var Q3 = Object.defineProperty;
var J3 = (e, t, n) => t in e ? Q3(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var pi = (e, t, n) => J3(e, typeof t != "symbol" ? t + "" : t, n);
import * as ue from "react";
import G, { useState as je, createContext as Le, useRef as ve, useLayoutEffect as y$, useEffect as De, useId as yy, useContext as Ce, useInsertionEffect as by, useMemo as Ee, useCallback as Ne, Children as X3, isValidElement as _y, Fragment as wy, createElement as e6, forwardRef as Jt, Component as Gd, version as t6, useReducer as b$, cloneElement as Kf, memo as Uf, PureComponent as _$, useImperativeHandle as n6 } from "react";
import r6, { flushSync as xy, createPortal as ga, unstable_batchedUpdates as i6 } from "react-dom";
import o6, { keyframes as a6 } from "styled-components";
import { toast as gr } from "react-toastify";
import { useMutation as Ey, useQuery as w$, QueryClientProvider as s6 } from "@tanstack/react-query";
import { useField as l6 } from "formik";
import { Link as es } from "react-router-dom";
import { Outlet as u6 } from "react-router";
import * as Qu from "@apollo/client";
import { gql as oi } from "@apollo/client";
import * as ph from "pdfjs-dist";
function Yd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $c = { exports: {} }, Dl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var D1;
function c6() {
  if (D1) return Dl;
  D1 = 1;
  var e = G, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, u) {
    var c, f = {}, d = null, p = null;
    u !== void 0 && (d = "" + u), l.key !== void 0 && (d = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (c in l) r.call(l, c) && !o.hasOwnProperty(c) && (f[c] = l[c]);
    if (s && s.defaultProps) for (c in l = s.defaultProps, l) f[c] === void 0 && (f[c] = l[c]);
    return { $$typeof: t, type: s, key: d, ref: p, props: f, _owner: i.current };
  }
  return Dl.Fragment = n, Dl.jsx = a, Dl.jsxs = a, Dl;
}
var Al = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var A1;
function f6() {
  return A1 || (A1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = G, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), h = Symbol.iterator, m = "@@iterator";
    function v(L) {
      if (L === null || typeof L != "object")
        return null;
      var ye = h && L[h] || L[m];
      return typeof ye == "function" ? ye : null;
    }
    var g = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(L) {
      {
        for (var ye = arguments.length, Pe = new Array(ye > 1 ? ye - 1 : 0), He = 1; He < ye; He++)
          Pe[He - 1] = arguments[He];
        E("error", L, Pe);
      }
    }
    function E(L, ye, Pe) {
      {
        var He = g.ReactDebugCurrentFrame, lt = He.getStackAddendum();
        lt !== "" && (ye += "%s", Pe = Pe.concat([lt]));
        var vt = Pe.map(function(et) {
          return String(et);
        });
        vt.unshift("Warning: " + ye), Function.prototype.apply.call(console[L], console, vt);
      }
    }
    var x = !1, S = !1, $ = !1, P = !1, y = !1, _;
    _ = Symbol.for("react.module.reference");
    function w(L) {
      return !!(typeof L == "string" || typeof L == "function" || L === r || L === o || y || L === i || L === u || L === c || P || L === p || x || S || $ || typeof L == "object" && L !== null && (L.$$typeof === d || L.$$typeof === f || L.$$typeof === a || L.$$typeof === s || L.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      L.$$typeof === _ || L.getModuleId !== void 0));
    }
    function A(L, ye, Pe) {
      var He = L.displayName;
      if (He)
        return He;
      var lt = ye.displayName || ye.name || "";
      return lt !== "" ? Pe + "(" + lt + ")" : Pe;
    }
    function k(L) {
      return L.displayName || "Context";
    }
    function N(L) {
      if (L == null)
        return null;
      if (typeof L.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof L == "function")
        return L.displayName || L.name || null;
      if (typeof L == "string")
        return L;
      switch (L) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case s:
            var ye = L;
            return k(ye) + ".Consumer";
          case a:
            var Pe = L;
            return k(Pe._context) + ".Provider";
          case l:
            return A(L, L.render, "ForwardRef");
          case f:
            var He = L.displayName || null;
            return He !== null ? He : N(L.type) || "Memo";
          case d: {
            var lt = L, vt = lt._payload, et = lt._init;
            try {
              return N(et(vt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var I = Object.assign, B = 0, q, ee, re, Z, T, F, M;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function te() {
      {
        if (B === 0) {
          q = console.log, ee = console.info, re = console.warn, Z = console.error, T = console.group, F = console.groupCollapsed, M = console.groupEnd;
          var L = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: L,
            log: L,
            warn: L,
            error: L,
            group: L,
            groupCollapsed: L,
            groupEnd: L
          });
        }
        B++;
      }
    }
    function se() {
      {
        if (B--, B === 0) {
          var L = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: I({}, L, {
              value: q
            }),
            info: I({}, L, {
              value: ee
            }),
            warn: I({}, L, {
              value: re
            }),
            error: I({}, L, {
              value: Z
            }),
            group: I({}, L, {
              value: T
            }),
            groupCollapsed: I({}, L, {
              value: F
            }),
            groupEnd: I({}, L, {
              value: M
            })
          });
        }
        B < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = g.ReactCurrentDispatcher, ge;
    function V(L, ye, Pe) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (lt) {
            var He = lt.stack.trim().match(/\n( *(at )?)/);
            ge = He && He[1] || "";
          }
        return `
` + ge + L;
      }
    }
    var O = !1, D;
    {
      var C = typeof WeakMap == "function" ? WeakMap : Map;
      D = new C();
    }
    function z(L, ye) {
      if (!L || O)
        return "";
      {
        var Pe = D.get(L);
        if (Pe !== void 0)
          return Pe;
      }
      var He;
      O = !0;
      var lt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var vt;
      vt = de.current, de.current = null, te();
      try {
        if (ye) {
          var et = function() {
            throw Error();
          };
          if (Object.defineProperty(et.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(et, []);
            } catch (Vn) {
              He = Vn;
            }
            Reflect.construct(L, [], et);
          } else {
            try {
              et.call();
            } catch (Vn) {
              He = Vn;
            }
            L.call(et.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Vn) {
            He = Vn;
          }
          L();
        }
      } catch (Vn) {
        if (Vn && He && typeof Vn.stack == "string") {
          for (var Ge = Vn.stack.split(`
`), On = He.stack.split(`
`), Ht = Ge.length - 1, tn = On.length - 1; Ht >= 1 && tn >= 0 && Ge[Ht] !== On[tn]; )
            tn--;
          for (; Ht >= 1 && tn >= 0; Ht--, tn--)
            if (Ge[Ht] !== On[tn]) {
              if (Ht !== 1 || tn !== 1)
                do
                  if (Ht--, tn--, tn < 0 || Ge[Ht] !== On[tn]) {
                    var mr = `
` + Ge[Ht].replace(" at new ", " at ");
                    return L.displayName && mr.includes("<anonymous>") && (mr = mr.replace("<anonymous>", L.displayName)), typeof L == "function" && D.set(L, mr), mr;
                  }
                while (Ht >= 1 && tn >= 0);
              break;
            }
        }
      } finally {
        O = !1, de.current = vt, se(), Error.prepareStackTrace = lt;
      }
      var Za = L ? L.displayName || L.name : "", Zo = Za ? V(Za) : "";
      return typeof L == "function" && D.set(L, Zo), Zo;
    }
    function H(L, ye, Pe) {
      return z(L, !1);
    }
    function X(L) {
      var ye = L.prototype;
      return !!(ye && ye.isReactComponent);
    }
    function fe(L, ye, Pe) {
      if (L == null)
        return "";
      if (typeof L == "function")
        return z(L, X(L));
      if (typeof L == "string")
        return V(L);
      switch (L) {
        case u:
          return V("Suspense");
        case c:
          return V("SuspenseList");
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case l:
            return H(L.render);
          case f:
            return fe(L.type, ye, Pe);
          case d: {
            var He = L, lt = He._payload, vt = He._init;
            try {
              return fe(vt(lt), ye, Pe);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, xe = {}, ne = g.ReactDebugCurrentFrame;
    function we(L) {
      if (L) {
        var ye = L._owner, Pe = fe(L.type, L._source, ye ? ye.type : null);
        ne.setExtraStackFrame(Pe);
      } else
        ne.setExtraStackFrame(null);
    }
    function ke(L, ye, Pe, He, lt) {
      {
        var vt = Function.call.bind(ce);
        for (var et in L)
          if (vt(L, et)) {
            var Ge = void 0;
            try {
              if (typeof L[et] != "function") {
                var On = Error((He || "React class") + ": " + Pe + " type `" + et + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof L[et] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw On.name = "Invariant Violation", On;
              }
              Ge = L[et](ye, et, He, Pe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ht) {
              Ge = Ht;
            }
            Ge && !(Ge instanceof Error) && (we(lt), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", He || "React class", Pe, et, typeof Ge), we(null)), Ge instanceof Error && !(Ge.message in xe) && (xe[Ge.message] = !0, we(lt), b("Failed %s type: %s", Pe, Ge.message), we(null));
          }
      }
    }
    var pe = Array.isArray;
    function j(L) {
      return pe(L);
    }
    function U(L) {
      {
        var ye = typeof Symbol == "function" && Symbol.toStringTag, Pe = ye && L[Symbol.toStringTag] || L.constructor.name || "Object";
        return Pe;
      }
    }
    function Y(L) {
      try {
        return Q(L), !1;
      } catch {
        return !0;
      }
    }
    function Q(L) {
      return "" + L;
    }
    function J(L) {
      if (Y(L))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(L)), Q(L);
    }
    var ae = g.ReactCurrentOwner, be = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ae, qe;
    function rt(L) {
      if (ce.call(L, "ref")) {
        var ye = Object.getOwnPropertyDescriptor(L, "ref").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return L.ref !== void 0;
    }
    function mt(L) {
      if (ce.call(L, "key")) {
        var ye = Object.getOwnPropertyDescriptor(L, "key").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return L.key !== void 0;
    }
    function _t(L, ye) {
      typeof L.ref == "string" && ae.current;
    }
    function ci(L, ye) {
      {
        var Pe = function() {
          Ae || (Ae = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        Pe.isReactWarning = !0, Object.defineProperty(L, "key", {
          get: Pe,
          configurable: !0
        });
      }
    }
    function fi(L, ye) {
      {
        var Pe = function() {
          qe || (qe = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        Pe.isReactWarning = !0, Object.defineProperty(L, "ref", {
          get: Pe,
          configurable: !0
        });
      }
    }
    var Ri = function(L, ye, Pe, He, lt, vt, et) {
      var Ge = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: L,
        key: ye,
        ref: Pe,
        props: et,
        // Record the component responsible for creating this element.
        _owner: vt
      };
      return Ge._store = {}, Object.defineProperty(Ge._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ge, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: He
      }), Object.defineProperty(Ge, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: lt
      }), Object.freeze && (Object.freeze(Ge.props), Object.freeze(Ge)), Ge;
    };
    function Wo(L, ye, Pe, He, lt) {
      {
        var vt, et = {}, Ge = null, On = null;
        Pe !== void 0 && (J(Pe), Ge = "" + Pe), mt(ye) && (J(ye.key), Ge = "" + ye.key), rt(ye) && (On = ye.ref, _t(ye, lt));
        for (vt in ye)
          ce.call(ye, vt) && !be.hasOwnProperty(vt) && (et[vt] = ye[vt]);
        if (L && L.defaultProps) {
          var Ht = L.defaultProps;
          for (vt in Ht)
            et[vt] === void 0 && (et[vt] = Ht[vt]);
        }
        if (Ge || On) {
          var tn = typeof L == "function" ? L.displayName || L.name || "Unknown" : L;
          Ge && ci(et, tn), On && fi(et, tn);
        }
        return Ri(L, Ge, On, lt, He, ae.current, et);
      }
    }
    var di = g.ReactCurrentOwner, no = g.ReactDebugCurrentFrame;
    function zr(L) {
      if (L) {
        var ye = L._owner, Pe = fe(L.type, L._source, ye ? ye.type : null);
        no.setExtraStackFrame(Pe);
      } else
        no.setExtraStackFrame(null);
    }
    var ch;
    ch = !1;
    function fh(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function S1() {
      {
        if (di.current) {
          var L = N(di.current.type);
          if (L)
            return `

Check the render method of \`` + L + "`.";
        }
        return "";
      }
    }
    function V3(L) {
      return "";
    }
    var $1 = {};
    function B3(L) {
      {
        var ye = S1();
        if (!ye) {
          var Pe = typeof L == "string" ? L : L.displayName || L.name;
          Pe && (ye = `

Check the top-level render call using <` + Pe + ">.");
        }
        return ye;
      }
    }
    function T1(L, ye) {
      {
        if (!L._store || L._store.validated || L.key != null)
          return;
        L._store.validated = !0;
        var Pe = B3(ye);
        if ($1[Pe])
          return;
        $1[Pe] = !0;
        var He = "";
        L && L._owner && L._owner !== di.current && (He = " It was passed a child from " + N(L._owner.type) + "."), zr(L), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Pe, He), zr(null);
      }
    }
    function O1(L, ye) {
      {
        if (typeof L != "object")
          return;
        if (j(L))
          for (var Pe = 0; Pe < L.length; Pe++) {
            var He = L[Pe];
            fh(He) && T1(He, ye);
          }
        else if (fh(L))
          L._store && (L._store.validated = !0);
        else if (L) {
          var lt = v(L);
          if (typeof lt == "function" && lt !== L.entries)
            for (var vt = lt.call(L), et; !(et = vt.next()).done; )
              fh(et.value) && T1(et.value, ye);
        }
      }
    }
    function K3(L) {
      {
        var ye = L.type;
        if (ye == null || typeof ye == "string")
          return;
        var Pe;
        if (typeof ye == "function")
          Pe = ye.propTypes;
        else if (typeof ye == "object" && (ye.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ye.$$typeof === f))
          Pe = ye.propTypes;
        else
          return;
        if (Pe) {
          var He = N(ye);
          ke(Pe, L.props, "prop", He, L);
        } else if (ye.PropTypes !== void 0 && !ch) {
          ch = !0;
          var lt = N(ye);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", lt || "Unknown");
        }
        typeof ye.getDefaultProps == "function" && !ye.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function U3(L) {
      {
        for (var ye = Object.keys(L.props), Pe = 0; Pe < ye.length; Pe++) {
          var He = ye[Pe];
          if (He !== "children" && He !== "key") {
            zr(L), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", He), zr(null);
            break;
          }
        }
        L.ref !== null && (zr(L), b("Invalid attribute `ref` supplied to `React.Fragment`."), zr(null));
      }
    }
    var k1 = {};
    function P1(L, ye, Pe, He, lt, vt) {
      {
        var et = w(L);
        if (!et) {
          var Ge = "";
          (L === void 0 || typeof L == "object" && L !== null && Object.keys(L).length === 0) && (Ge += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var On = V3();
          On ? Ge += On : Ge += S1();
          var Ht;
          L === null ? Ht = "null" : j(L) ? Ht = "array" : L !== void 0 && L.$$typeof === t ? (Ht = "<" + (N(L.type) || "Unknown") + " />", Ge = " Did you accidentally export a JSX literal instead of a component?") : Ht = typeof L, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ht, Ge);
        }
        var tn = Wo(L, ye, Pe, lt, vt);
        if (tn == null)
          return tn;
        if (et) {
          var mr = ye.children;
          if (mr !== void 0)
            if (He)
              if (j(mr)) {
                for (var Za = 0; Za < mr.length; Za++)
                  O1(mr[Za], L);
                Object.freeze && Object.freeze(mr);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              O1(mr, L);
        }
        if (ce.call(ye, "key")) {
          var Zo = N(L), Vn = Object.keys(ye).filter(function(Y3) {
            return Y3 !== "key";
          }), dh = Vn.length > 0 ? "{key: someKey, " + Vn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!k1[Zo + dh]) {
            var G3 = Vn.length > 0 ? "{" + Vn.join(": ..., ") + ": ...}" : "{}";
            b(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, dh, Zo, G3, Zo), k1[Zo + dh] = !0;
          }
        }
        return L === r ? U3(tn) : K3(tn), tn;
      }
    }
    function q3(L, ye, Pe) {
      return P1(L, ye, Pe, !0);
    }
    function H3(L, ye, Pe) {
      return P1(L, ye, Pe, !1);
    }
    var W3 = H3, Z3 = q3;
    Al.Fragment = r, Al.jsx = W3, Al.jsxs = Z3;
  })()), Al;
}
var C1;
function d6() {
  return C1 || (C1 = 1, process.env.NODE_ENV === "production" ? $c.exports = c6() : $c.exports = f6()), $c.exports;
}
var R = d6();
function p6() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = x$(t)) && (r && (r += " "), r += n);
  return r;
}
function x$(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = x$(e[r])) && (n && (n += " "), n += t);
  return n;
}
var Sy = "-";
function h6(e) {
  var t = v6(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, i = r === void 0 ? {} : r;
  function o(s) {
    var l = s.split(Sy);
    return l[0] === "" && l.length !== 1 && l.shift(), E$(l, t) || m6(s);
  }
  function a(s, l) {
    var u = n[s] || [];
    return l && i[s] ? [].concat(u, i[s]) : u;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: a
  };
}
function E$(e, t) {
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), i = r ? E$(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length !== 0) {
    var o = e.join(Sy);
    return t.validators.find(function(a) {
      var s = a.validator;
      return s(o);
    })?.classGroupId;
  }
}
var I1 = /^\[(.+)\]$/;
function m6(e) {
  if (I1.test(e)) {
    var t = I1.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function v6(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = y6(Object.entries(e.classGroups), n);
  return i.forEach(function(o) {
    var a = o[0], s = o[1];
    Ym(s, r, a, t);
  }), r;
}
function Ym(e, t, n, r) {
  e.forEach(function(i) {
    if (typeof i == "string") {
      var o = i === "" ? t : M1(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (g6(i)) {
        Ym(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(function(a) {
      var s = a[0], l = a[1];
      Ym(l, M1(t, s), n, r);
    });
  });
}
function M1(e, t) {
  var n = e;
  return t.split(Sy).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function g6(e) {
  return e.isThemeGetter;
}
function y6(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], i = n[1], o = i.map(function(a) {
      return typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(s) {
        var l = s[0], u = s[1];
        return [t + l, u];
      })) : a;
    });
    return [r, o];
  }) : e;
}
function b6(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(o, a) {
    n.set(o, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return i(a, s), s;
    },
    set: function(a, s) {
      n.has(a) ? n.set(a, s) : i(a, s);
    }
  };
}
var S$ = "!";
function _6(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], i = t.length;
  return function(a) {
    for (var s = [], l = 0, u = 0, c, f = 0; f < a.length; f++) {
      var d = a[f];
      if (l === 0) {
        if (d === r && (n || a.slice(f, f + i) === t)) {
          s.push(a.slice(u, f)), u = f + i;
          continue;
        }
        if (d === "/") {
          c = f;
          continue;
        }
      }
      d === "[" ? l++ : d === "]" && l--;
    }
    var p = s.length === 0 ? a : a.substring(u), h = p.startsWith(S$), m = h ? p.substring(1) : p, v = c && c > u ? c - u : void 0;
    return {
      modifiers: s,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: v
    };
  };
}
function w6(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var i = r[0] === "[";
    i ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function x6(e) {
  return {
    cache: b6(e.cacheSize),
    splitModifiers: _6(e),
    ...h6(e)
  };
}
var E6 = /\s+/;
function S6(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, i = t.getConflictingClassGroupIds, o = /* @__PURE__ */ new Set();
  return e.trim().split(E6).map(function(a) {
    var s = n(a), l = s.modifiers, u = s.hasImportantModifier, c = s.baseClassName, f = s.maybePostfixModifierPosition, d = r(f ? c.substring(0, f) : c), p = !!f;
    if (!d) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (d = r(c), !d)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      p = !1;
    }
    var h = w6(l).join(":"), m = u ? h + S$ : h;
    return {
      isTailwindClass: !0,
      modifierId: m,
      classGroupId: d,
      originalClassName: a,
      hasPostfixModifier: p
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var s = a.modifierId, l = a.classGroupId, u = a.hasPostfixModifier, c = s + l;
    return o.has(c) ? !1 : (o.add(c), i(l, u).forEach(function(f) {
      return o.add(s + f);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function $6() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, i, o, a = s;
  function s(u) {
    var c = t[0], f = t.slice(1), d = f.reduce(function(p, h) {
      return h(p);
    }, c());
    return r = x6(d), i = r.cache.get, o = r.cache.set, a = l, l(u);
  }
  function l(u) {
    var c = i(u);
    if (c)
      return c;
    var f = S6(u, r);
    return o(u, f), f;
  }
  return function() {
    return a(p6.apply(null, arguments));
  };
}
function $t(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var $$ = /^\[(?:([a-z-]+):)?(.+)\]$/i, T6 = /^\d+\/\d+$/, O6 = /* @__PURE__ */ new Set(["px", "full", "screen"]), k6 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, P6 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, D6 = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Lr(e) {
  return oa(e) || O6.has(e) || T6.test(e) || Qm(e);
}
function Qm(e) {
  return Ia(e, "length", N6);
}
function A6(e) {
  return Ia(e, "size", T$);
}
function C6(e) {
  return Ia(e, "position", T$);
}
function I6(e) {
  return Ia(e, "url", j6);
}
function Tc(e) {
  return Ia(e, "number", oa);
}
function oa(e) {
  return !Number.isNaN(Number(e));
}
function M6(e) {
  return e.endsWith("%") && oa(e.slice(0, -1));
}
function Cl(e) {
  return R1(e) || Ia(e, "number", R1);
}
function Ye(e) {
  return $$.test(e);
}
function Il() {
  return !0;
}
function ro(e) {
  return k6.test(e);
}
function R6(e) {
  return Ia(e, "", F6);
}
function Ia(e, t, n) {
  var r = $$.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function N6(e) {
  return P6.test(e);
}
function T$() {
  return !1;
}
function j6(e) {
  return e.startsWith("url(");
}
function R1(e) {
  return Number.isInteger(Number(e));
}
function F6(e) {
  return D6.test(e);
}
function z6() {
  var e = $t("colors"), t = $t("spacing"), n = $t("blur"), r = $t("brightness"), i = $t("borderColor"), o = $t("borderRadius"), a = $t("borderSpacing"), s = $t("borderWidth"), l = $t("contrast"), u = $t("grayscale"), c = $t("hueRotate"), f = $t("invert"), d = $t("gap"), p = $t("gradientColorStops"), h = $t("gradientColorStopPositions"), m = $t("inset"), v = $t("margin"), g = $t("opacity"), b = $t("padding"), E = $t("saturate"), x = $t("scale"), S = $t("sepia"), $ = $t("skew"), P = $t("space"), y = $t("translate"), _ = function() {
    return ["auto", "contain", "none"];
  }, w = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, A = function() {
    return ["auto", Ye, t];
  }, k = function() {
    return [Ye, t];
  }, N = function() {
    return ["", Lr];
  }, I = function() {
    return ["auto", oa, Ye];
  }, B = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, q = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, ee = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, re = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, Z = function() {
    return ["", "0", Ye];
  }, T = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, F = function() {
    return [oa, Tc];
  }, M = function() {
    return [oa, Ye];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Il],
      spacing: [Lr],
      blur: ["none", "", ro, Ye],
      brightness: F(),
      borderColor: [e],
      borderRadius: ["none", "", "full", ro, Ye],
      borderSpacing: k(),
      borderWidth: N(),
      contrast: F(),
      grayscale: Z(),
      hueRotate: M(),
      invert: Z(),
      gap: k(),
      gradientColorStops: [e],
      gradientColorStopPositions: [M6, Qm],
      inset: A(),
      margin: A(),
      opacity: F(),
      padding: k(),
      saturate: F(),
      scale: F(),
      sepia: Z(),
      skew: M(),
      space: k(),
      translate: k()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Ye]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ro]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": T()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": T()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(B(), [Ye])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: w()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": w()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": w()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: _()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": _()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": _()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Cl]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: A()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Ye]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Z()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Z()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Cl]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Il]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Cl]
        }, Ye]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": I()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": I()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Il]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Cl]
        }, Ye]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": I()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": I()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Ye]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Ye]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(re())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(re(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(re(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [b]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [b]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [b]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [b]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [b]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [b]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [b]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [b]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [b]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [v]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [v]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [v]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [v]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [v]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [v]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [v]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [v]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [v]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", Ye, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", Ye, Lr]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [ro]
        }, ro, Ye]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Ye, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", Ye, Lr]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Ye, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ro, Qm]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Tc]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Il]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Ye]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", oa, Tc]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Ye, Lr]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Ye]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Ye]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [g]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [g]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(q(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Lr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Ye, Lr]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Ye]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Ye]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [g]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(B(), [C6])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", A6]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, I6]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [g]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(q(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [g]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: q()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(q())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ye, Lr]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Lr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: N()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [g]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Lr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ro, R6]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Il]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [g]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": ee()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ee()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ro, Ye]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [E]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [g]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [E]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Ye]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: M()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Ye]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: M()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Ye]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Cl, Ye]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [y]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [y]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [$]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [$]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Ye]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Ye]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Ye]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Lr, Tc]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var Wn = /* @__PURE__ */ $6(z6);
function Pue(e) {
  const { className: t, children: n, ...r } = e;
  return /* @__PURE__ */ R.jsx("div", { className: Wn("p-8", t), ...r, children: /* @__PURE__ */ R.jsxs("div", { className: "border border-orange-2 p-4 bg-orange-100", children: [
    /* @__PURE__ */ R.jsx("h2", { className: "text-2xl mb-4", children: e.heading || "Note" }),
    n
  ] }) });
}
const Due = (e) => /* @__PURE__ */ R.jsx("div", { ...e });
function O$(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = O$(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function k$() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = O$(e)) && (r && (r += " "), r += t);
  return r;
}
const N1 = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, j1 = k$, Mr = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return j1(e, n?.class, n?.className);
  const { variants: i, defaultVariants: o } = t, a = Object.keys(i).map((u) => {
    const c = n?.[u], f = o?.[u];
    if (c === null) return null;
    const d = N1(c) || N1(f);
    return i[u][d];
  }), s = n && Object.entries(n).reduce((u, c) => {
    let [f, d] = c;
    return d === void 0 || (u[f] = d), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, c) => {
    let { class: f, className: d, ...p } = c;
    return Object.entries(p).every((h) => {
      let [m, v] = h;
      return Array.isArray(v) ? v.includes({
        ...o,
        ...s
      }[m]) : {
        ...o,
        ...s
      }[m] === v;
    }) ? [
      ...u,
      f,
      d
    ] : u;
  }, []);
  return j1(e, a, l, n?.class, n?.className);
}, L6 = Mr(
  [
    "z-0",
    "flex-grow-0",
    "px-4",
    "py-2",
    "text-sm",
    "text-white",
    "transition-all",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-opacity-75",
    "disabled:opacity-50",
    "disabled:cursor-default"
  ],
  {
    variants: {
      variant: {
        green: "bg-green-400 focus:ring-green-400 hover:bg-green-500 disabled:bg-green-400",
        blue: "bg-blue-400",
        red: "bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400",
        gray: "text-black bg-neutral-200 focus:ring-gray-200 hover:bg-neutral-300 disabled:bg-neutral-200",
        black: "bg-black focus:ring-neutral-800 hover:bg-neutral-800 disabled:bg-neutral-800"
      }
    }
  }
), $y = ({
  variant: e = "black",
  className: t,
  ...n
}) => /* @__PURE__ */ R.jsx(
  "button",
  {
    ...n,
    className: Wn(L6({ variant: e }), t)
  }
);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const V6 = {
  prefix: "fas",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"]
}, B6 = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, K6 = {
  prefix: "fas",
  iconName: "clipboard",
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, U6 = {
  prefix: "fas",
  iconName: "user-gear",
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
}, q6 = U6, P$ = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, H6 = {
  prefix: "fas",
  iconName: "x",
  icon: [384, 512, [120], "58", "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"]
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function W6(e, t, n) {
  return (t = G6(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function F1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? F1(Object(n), !0).forEach(function(r) {
      W6(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : F1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Z6(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function G6(e) {
  var t = Z6(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const z1 = () => {
};
let Ty = {}, D$ = {}, A$ = null, C$ = {
  mark: z1,
  measure: z1
};
try {
  typeof window < "u" && (Ty = window), typeof document < "u" && (D$ = document), typeof MutationObserver < "u" && (A$ = MutationObserver), typeof performance < "u" && (C$ = performance);
} catch {
}
const {
  userAgent: L1 = ""
} = Ty.navigator || {}, xo = Ty, Pt = D$, V1 = A$, Oc = C$;
xo.document;
const Xi = !!Pt.documentElement && !!Pt.head && typeof Pt.addEventListener == "function" && typeof Pt.createElement == "function", I$ = ~L1.indexOf("MSIE") || ~L1.indexOf("Trident/");
var Y6 = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, Q6 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, M$ = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, J6 = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, R$ = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], $n = "classic", Qd = "duotone", X6 = "sharp", eM = "sharp-duotone", N$ = [$n, Qd, X6, eM], tM = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, nM = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, rM = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), iM = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, oM = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], B1 = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, aM = ["kit"], sM = {
  kit: {
    "fa-kit": "fak"
  }
}, lM = ["fak", "fakd"], uM = {
  kit: {
    fak: "fa-kit"
  }
}, K1 = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, kc = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, cM = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], fM = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], dM = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, pM = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, hM = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, Jm = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, mM = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], Xm = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...cM, ...mM], vM = ["solid", "regular", "light", "thin", "duotone", "brands"], j$ = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], gM = j$.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), yM = [...Object.keys(hM), ...vM, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", kc.GROUP, kc.SWAP_OPACITY, kc.PRIMARY, kc.SECONDARY].concat(j$.map((e) => "".concat(e, "x"))).concat(gM.map((e) => "w-".concat(e))), bM = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const Ui = "___FONT_AWESOME___", ev = 16, F$ = "fa", z$ = "svg-inline--fa", ya = "data-fa-i2svg", tv = "data-fa-pseudo-element", _M = "data-fa-pseudo-element-pending", Oy = "data-prefix", ky = "data-icon", U1 = "fontawesome-i2svg", wM = "async", xM = ["HTML", "HEAD", "STYLE", "SCRIPT"], L$ = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function Ju(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[$n];
    }
  });
}
const V$ = _e({}, M$);
V$[$n] = _e(_e(_e(_e({}, {
  "fa-duotone": "duotone"
}), M$[$n]), B1.kit), B1["kit-duotone"]);
const EM = Ju(V$), nv = _e({}, iM);
nv[$n] = _e(_e(_e(_e({}, {
  duotone: "fad"
}), nv[$n]), K1.kit), K1["kit-duotone"]);
const q1 = Ju(nv), rv = _e({}, Jm);
rv[$n] = _e(_e({}, rv[$n]), uM.kit);
const Py = Ju(rv), iv = _e({}, pM);
iv[$n] = _e(_e({}, iv[$n]), sM.kit);
Ju(iv);
const SM = Y6, B$ = "fa-layers-text", $M = Q6, TM = _e({}, tM);
Ju(TM);
const OM = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], hh = J6, kM = [...aM, ...yM], iu = xo.FontAwesomeConfig || {};
function PM(e) {
  var t = Pt.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function DM(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
Pt && typeof Pt.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, r] = t;
  const i = DM(PM(n));
  i != null && (iu[r] = i);
});
const K$ = {
  styleDefault: "solid",
  familyDefault: $n,
  cssPrefix: F$,
  replacementClass: z$,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
iu.familyPrefix && (iu.cssPrefix = iu.familyPrefix);
const Cs = _e(_e({}, K$), iu);
Cs.autoReplaceSvg || (Cs.observeMutations = !1);
const Ve = {};
Object.keys(K$).forEach((e) => {
  Object.defineProperty(Ve, e, {
    enumerable: !0,
    set: function(t) {
      Cs[e] = t, ou.forEach((n) => n(Ve));
    },
    get: function() {
      return Cs[e];
    }
  });
});
Object.defineProperty(Ve, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    Cs.cssPrefix = e, ou.forEach((t) => t(Ve));
  },
  get: function() {
    return Cs.cssPrefix;
  }
});
xo.FontAwesomeConfig = Ve;
const ou = [];
function AM(e) {
  return ou.push(e), () => {
    ou.splice(ou.indexOf(e), 1);
  };
}
const io = ev, xi = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function CM(e) {
  if (!e || !Xi)
    return;
  const t = Pt.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = Pt.head.childNodes;
  let r = null;
  for (let i = n.length - 1; i > -1; i--) {
    const o = n[i], a = (o.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(a) > -1 && (r = o);
  }
  return Pt.head.insertBefore(t, r), e;
}
const IM = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function _u() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += IM[Math.random() * 62 | 0];
  return t;
}
function el(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function Dy(e) {
  return e.classList ? el(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function U$(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function MM(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(U$(e[n]), '" '), "").trim();
}
function Jd(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function Ay(e) {
  return e.size !== xi.size || e.x !== xi.x || e.y !== xi.y || e.rotate !== xi.rotate || e.flipX || e.flipY;
}
function RM(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: r
  } = e;
  const i = {
    transform: "translate(".concat(n / 2, " 256)")
  }, o = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), a = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), s = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(o, " ").concat(a, " ").concat(s)
  }, u = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: i,
    inner: l,
    path: u
  };
}
function NM(e) {
  let {
    transform: t,
    width: n = ev,
    height: r = ev,
    startCentered: i = !1
  } = e, o = "";
  return i && I$ ? o += "translate(".concat(t.x / io - n / 2, "em, ").concat(t.y / io - r / 2, "em) ") : i ? o += "translate(calc(-50% + ".concat(t.x / io, "em), calc(-50% + ").concat(t.y / io, "em)) ") : o += "translate(".concat(t.x / io, "em, ").concat(t.y / io, "em) "), o += "scale(".concat(t.size / io * (t.flipX ? -1 : 1), ", ").concat(t.size / io * (t.flipY ? -1 : 1), ") "), o += "rotate(".concat(t.rotate, "deg) "), o;
}
var jM = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function q$() {
  const e = F$, t = z$, n = Ve.cssPrefix, r = Ve.replacementClass;
  let i = jM;
  if (n !== e || r !== t) {
    const o = new RegExp("\\.".concat(e, "\\-"), "g"), a = new RegExp("\\--".concat(e, "\\-"), "g"), s = new RegExp("\\.".concat(t), "g");
    i = i.replace(o, ".".concat(n, "-")).replace(a, "--".concat(n, "-")).replace(s, ".".concat(r));
  }
  return i;
}
let H1 = !1;
function mh() {
  Ve.autoAddCss && !H1 && (CM(q$()), H1 = !0);
}
var FM = {
  mixout() {
    return {
      dom: {
        css: q$,
        insertCss: mh
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        mh();
      },
      beforeI2svg() {
        mh();
      }
    };
  }
};
const qi = xo || {};
qi[Ui] || (qi[Ui] = {});
qi[Ui].styles || (qi[Ui].styles = {});
qi[Ui].hooks || (qi[Ui].hooks = {});
qi[Ui].shims || (qi[Ui].shims = []);
var Ei = qi[Ui];
const H$ = [], W$ = function() {
  Pt.removeEventListener("DOMContentLoaded", W$), qf = 1, H$.map((e) => e());
};
let qf = !1;
Xi && (qf = (Pt.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Pt.readyState), qf || Pt.addEventListener("DOMContentLoaded", W$));
function zM(e) {
  Xi && (qf ? setTimeout(e, 0) : H$.push(e));
}
function Xu(e) {
  const {
    tag: t,
    attributes: n = {},
    children: r = []
  } = e;
  return typeof e == "string" ? U$(e) : "<".concat(t, " ").concat(MM(n), ">").concat(r.map(Xu).join(""), "</").concat(t, ">");
}
function W1(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var vh = function(t, n, r, i) {
  var o = Object.keys(t), a = o.length, s = n, l, u, c;
  for (r === void 0 ? (l = 1, c = t[o[0]]) : (l = 0, c = r); l < a; l++)
    u = o[l], c = s(c, t[u], u, t);
  return c;
};
function LM(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      const o = e.charCodeAt(n++);
      (o & 64512) == 56320 ? t.push(((i & 1023) << 10) + (o & 1023) + 65536) : (t.push(i), n--);
    } else
      t.push(i);
  }
  return t;
}
function ov(e) {
  const t = LM(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function VM(e, t) {
  const n = e.length;
  let r = e.charCodeAt(t), i;
  return r >= 55296 && r <= 56319 && n > t + 1 && (i = e.charCodeAt(t + 1), i >= 56320 && i <= 57343) ? (r - 55296) * 1024 + i - 56320 + 65536 : r;
}
function Z1(e) {
  return Object.keys(e).reduce((t, n) => {
    const r = e[n];
    return !!r.icon ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function av(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: r = !1
  } = n, i = Z1(t);
  typeof Ei.hooks.addPack == "function" && !r ? Ei.hooks.addPack(e, Z1(t)) : Ei.styles[e] = _e(_e({}, Ei.styles[e] || {}), i), e === "fas" && av("fa", t);
}
const {
  styles: wu,
  shims: BM
} = Ei, Z$ = Object.keys(Py), KM = Z$.reduce((e, t) => (e[t] = Object.keys(Py[t]), e), {});
let Cy = null, G$ = {}, Y$ = {}, Q$ = {}, J$ = {}, X$ = {};
function UM(e) {
  return ~kM.indexOf(e);
}
function qM(e, t) {
  const n = t.split("-"), r = n[0], i = n.slice(1).join("-");
  return r === e && i !== "" && !UM(i) ? i : null;
}
const eT = () => {
  const e = (r) => vh(wu, (i, o, a) => (i[a] = vh(o, r, {}), i), {});
  G$ = e((r, i, o) => (i[3] && (r[i[3]] = o), i[2] && i[2].filter((s) => typeof s == "number").forEach((s) => {
    r[s.toString(16)] = o;
  }), r)), Y$ = e((r, i, o) => (r[o] = o, i[2] && i[2].filter((s) => typeof s == "string").forEach((s) => {
    r[s] = o;
  }), r)), X$ = e((r, i, o) => {
    const a = i[2];
    return r[o] = o, a.forEach((s) => {
      r[s] = o;
    }), r;
  });
  const t = "far" in wu || Ve.autoFetchSvg, n = vh(BM, (r, i) => {
    const o = i[0];
    let a = i[1];
    const s = i[2];
    return a === "far" && !t && (a = "fas"), typeof o == "string" && (r.names[o] = {
      prefix: a,
      iconName: s
    }), typeof o == "number" && (r.unicodes[o.toString(16)] = {
      prefix: a,
      iconName: s
    }), r;
  }, {
    names: {},
    unicodes: {}
  });
  Q$ = n.names, J$ = n.unicodes, Cy = Xd(Ve.styleDefault, {
    family: Ve.familyDefault
  });
};
AM((e) => {
  Cy = Xd(e.styleDefault, {
    family: Ve.familyDefault
  });
});
eT();
function Iy(e, t) {
  return (G$[e] || {})[t];
}
function HM(e, t) {
  return (Y$[e] || {})[t];
}
function aa(e, t) {
  return (X$[e] || {})[t];
}
function tT(e) {
  return Q$[e] || {
    prefix: null,
    iconName: null
  };
}
function WM(e) {
  const t = J$[e], n = Iy("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Eo() {
  return Cy;
}
const nT = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function ZM(e) {
  let t = $n;
  const n = Z$.reduce((r, i) => (r[i] = "".concat(Ve.cssPrefix, "-").concat(i), r), {});
  return N$.forEach((r) => {
    (e.includes(n[r]) || e.some((i) => KM[r].includes(i))) && (t = r);
  }), t;
}
function Xd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = $n
  } = t, r = EM[n][e];
  if (n === Qd && !e)
    return "fad";
  const i = q1[n][e] || q1[n][r], o = e in Ei.styles ? e : null;
  return i || o || null;
}
function GM(e) {
  let t = [], n = null;
  return e.forEach((r) => {
    const i = qM(Ve.cssPrefix, r);
    i ? n = i : r && t.push(r);
  }), {
    iconName: n,
    rest: t
  };
}
function G1(e) {
  return e.sort().filter((t, n, r) => r.indexOf(t) === n);
}
function ep(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let r = null;
  const i = Xm.concat(fM), o = G1(e.filter((f) => i.includes(f))), a = G1(e.filter((f) => !Xm.includes(f))), s = o.filter((f) => (r = f, !R$.includes(f))), [l = null] = s, u = ZM(o), c = _e(_e({}, GM(a)), {}, {
    prefix: Xd(l, {
      family: u
    })
  });
  return _e(_e(_e({}, c), XM({
    values: e,
    family: u,
    styles: wu,
    config: Ve,
    canonical: c,
    givenPrefix: r
  })), YM(n, r, c));
}
function YM(e, t, n) {
  let {
    prefix: r,
    iconName: i
  } = n;
  if (e || !r || !i)
    return {
      prefix: r,
      iconName: i
    };
  const o = t === "fa" ? tT(i) : {}, a = aa(r, i);
  return i = o.iconName || a || i, r = o.prefix || r, r === "far" && !wu.far && wu.fas && !Ve.autoFetchSvg && (r = "fas"), {
    prefix: r,
    iconName: i
  };
}
const QM = N$.filter((e) => e !== $n || e !== Qd), JM = Object.keys(Jm).filter((e) => e !== $n).map((e) => Object.keys(Jm[e])).flat();
function XM(e) {
  const {
    values: t,
    family: n,
    canonical: r,
    givenPrefix: i = "",
    styles: o = {},
    config: a = {}
  } = e, s = n === Qd, l = t.includes("fa-duotone") || t.includes("fad"), u = a.familyDefault === "duotone", c = r.prefix === "fad" || r.prefix === "fa-duotone";
  if (!s && (l || u || c) && (r.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (r.prefix = "fab"), !r.prefix && QM.includes(n) && (Object.keys(o).find((d) => JM.includes(d)) || a.autoFetchSvg)) {
    const d = rM.get(n).defaultShortPrefixId;
    r.prefix = d, r.iconName = aa(r.prefix, r.iconName) || r.iconName;
  }
  return (r.prefix === "fa" || i === "fa") && (r.prefix = Eo() || "fas"), r;
}
class eR {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    const i = n.reduce(this._pullDefinitions, {});
    Object.keys(i).forEach((o) => {
      this.definitions[o] = _e(_e({}, this.definitions[o] || {}), i[o]), av(o, i[o]);
      const a = Py[$n][o];
      a && av(a, i[o]), eT();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const r = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(r).map((i) => {
      const {
        prefix: o,
        iconName: a,
        icon: s
      } = r[i], l = s[2];
      t[o] || (t[o] = {}), l.length > 0 && l.forEach((u) => {
        typeof u == "string" && (t[o][u] = s);
      }), t[o][a] = s;
    }), t;
  }
}
let Y1 = [], as = {};
const Es = {}, tR = Object.keys(Es);
function nR(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return Y1 = e, as = {}, Object.keys(Es).forEach((r) => {
    tR.indexOf(r) === -1 && delete Es[r];
  }), Y1.forEach((r) => {
    const i = r.mixout ? r.mixout() : {};
    if (Object.keys(i).forEach((o) => {
      typeof i[o] == "function" && (n[o] = i[o]), typeof i[o] == "object" && Object.keys(i[o]).forEach((a) => {
        n[o] || (n[o] = {}), n[o][a] = i[o][a];
      });
    }), r.hooks) {
      const o = r.hooks();
      Object.keys(o).forEach((a) => {
        as[a] || (as[a] = []), as[a].push(o[a]);
      });
    }
    r.provides && r.provides(Es);
  }), n;
}
function sv(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  return (as[e] || []).forEach((a) => {
    t = a.apply(null, [t, ...r]);
  }), t;
}
function ba(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  (as[e] || []).forEach((o) => {
    o.apply(null, n);
  });
}
function So() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return Es[e] ? Es[e].apply(null, t) : void 0;
}
function lv(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || Eo();
  if (t)
    return t = aa(n, t) || t, W1(rT.definitions, n, t) || W1(Ei.styles, n, t);
}
const rT = new eR(), rR = () => {
  Ve.autoReplaceSvg = !1, Ve.observeMutations = !1, ba("noAuto");
}, iR = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Xi ? (ba("beforeI2svg", e), So("pseudoElements2svg", e), So("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    Ve.autoReplaceSvg === !1 && (Ve.autoReplaceSvg = !0), Ve.observeMutations = !0, zM(() => {
      aR({
        autoReplaceSvgRoot: t
      }), ba("watch", e);
    });
  }
}, oR = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: aa(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = Xd(e[0]);
      return {
        prefix: n,
        iconName: aa(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(Ve.cssPrefix, "-")) > -1 || e.match(SM))) {
      const t = ep(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || Eo(),
        iconName: aa(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = Eo();
      return {
        prefix: t,
        iconName: aa(t, e) || e
      };
    }
  }
}, pr = {
  noAuto: rR,
  config: Ve,
  dom: iR,
  parse: oR,
  library: rT,
  findIconDefinition: lv,
  toHtml: Xu
}, aR = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = Pt
  } = e;
  (Object.keys(Ei.styles).length > 0 || Ve.autoFetchSvg) && Xi && Ve.autoReplaceSvg && pr.dom.i2svg({
    node: t
  });
};
function tp(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => Xu(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!Xi) return;
      const n = Pt.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function sR(e) {
  let {
    children: t,
    main: n,
    mask: r,
    attributes: i,
    styles: o,
    transform: a
  } = e;
  if (Ay(a) && n.found && !r.found) {
    const {
      width: s,
      height: l
    } = n, u = {
      x: s / l / 2,
      y: 0.5
    };
    i.style = Jd(_e(_e({}, o), {}, {
      "transform-origin": "".concat(u.x + a.x / 16, "em ").concat(u.y + a.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: i,
    children: t
  }];
}
function lR(e) {
  let {
    prefix: t,
    iconName: n,
    children: r,
    attributes: i,
    symbol: o
  } = e;
  const a = o === !0 ? "".concat(t, "-").concat(Ve.cssPrefix, "-").concat(n) : o;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _e(_e({}, i), {}, {
        id: a
      }),
      children: r
    }]
  }];
}
function My(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: r,
    iconName: i,
    transform: o,
    symbol: a,
    title: s,
    maskId: l,
    titleId: u,
    extra: c,
    watchable: f = !1
  } = e, {
    width: d,
    height: p
  } = n.found ? n : t, h = lM.includes(r), m = [Ve.replacementClass, i ? "".concat(Ve.cssPrefix, "-").concat(i) : ""].filter((S) => c.classes.indexOf(S) === -1).filter((S) => S !== "" || !!S).concat(c.classes).join(" ");
  let v = {
    children: [],
    attributes: _e(_e({}, c.attributes), {}, {
      "data-prefix": r,
      "data-icon": i,
      class: m,
      role: c.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(d, " ").concat(p)
    })
  };
  const g = h && !~c.classes.indexOf("fa-fw") ? {
    width: "".concat(d / p * 16 * 0.0625, "em")
  } : {};
  f && (v.attributes[ya] = ""), s && (v.children.push({
    tag: "title",
    attributes: {
      id: v.attributes["aria-labelledby"] || "title-".concat(u || _u())
    },
    children: [s]
  }), delete v.attributes.title);
  const b = _e(_e({}, v), {}, {
    prefix: r,
    iconName: i,
    main: t,
    mask: n,
    maskId: l,
    transform: o,
    symbol: a,
    styles: _e(_e({}, g), c.styles)
  }), {
    children: E,
    attributes: x
  } = n.found && t.found ? So("generateAbstractMask", b) || {
    children: [],
    attributes: {}
  } : So("generateAbstractIcon", b) || {
    children: [],
    attributes: {}
  };
  return b.children = E, b.attributes = x, a ? lR(b) : sR(b);
}
function Q1(e) {
  const {
    content: t,
    width: n,
    height: r,
    transform: i,
    title: o,
    extra: a,
    watchable: s = !1
  } = e, l = _e(_e(_e({}, a.attributes), o ? {
    title: o
  } : {}), {}, {
    class: a.classes.join(" ")
  });
  s && (l[ya] = "");
  const u = _e({}, a.styles);
  Ay(i) && (u.transform = NM({
    transform: i,
    startCentered: !0,
    width: n,
    height: r
  }), u["-webkit-transform"] = u.transform);
  const c = Jd(u);
  c.length > 0 && (l.style = c);
  const f = [];
  return f.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), o && f.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [o]
  }), f;
}
function uR(e) {
  const {
    content: t,
    title: n,
    extra: r
  } = e, i = _e(_e(_e({}, r.attributes), n ? {
    title: n
  } : {}), {}, {
    class: r.classes.join(" ")
  }), o = Jd(r.styles);
  o.length > 0 && (i.style = o);
  const a = [];
  return a.push({
    tag: "span",
    attributes: i,
    children: [t]
  }), n && a.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), a;
}
const {
  styles: gh
} = Ei;
function uv(e) {
  const t = e[0], n = e[1], [r] = e.slice(4);
  let i = null;
  return Array.isArray(r) ? i = {
    tag: "g",
    attributes: {
      class: "".concat(Ve.cssPrefix, "-").concat(hh.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(Ve.cssPrefix, "-").concat(hh.SECONDARY),
        fill: "currentColor",
        d: r[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(Ve.cssPrefix, "-").concat(hh.PRIMARY),
        fill: "currentColor",
        d: r[1]
      }
    }]
  } : i = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: r
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: i
  };
}
const cR = {
  found: !1,
  width: 512,
  height: 512
};
function fR(e, t) {
  !L$ && !Ve.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function cv(e, t) {
  let n = t;
  return t === "fa" && Ve.styleDefault !== null && (t = Eo()), new Promise((r, i) => {
    if (n === "fa") {
      const o = tT(e) || {};
      e = o.iconName || e, t = o.prefix || t;
    }
    if (e && t && gh[t] && gh[t][e]) {
      const o = gh[t][e];
      return r(uv(o));
    }
    fR(e, t), r(_e(_e({}, cR), {}, {
      icon: Ve.showMissingIcons && e ? So("missingIconAbstract") || {} : {}
    }));
  });
}
const J1 = () => {
}, fv = Ve.measurePerformance && Oc && Oc.mark && Oc.measure ? Oc : {
  mark: J1,
  measure: J1
}, ql = 'FA "6.7.2"', dR = (e) => (fv.mark("".concat(ql, " ").concat(e, " begins")), () => iT(e)), iT = (e) => {
  fv.mark("".concat(ql, " ").concat(e, " ends")), fv.measure("".concat(ql, " ").concat(e), "".concat(ql, " ").concat(e, " begins"), "".concat(ql, " ").concat(e, " ends"));
};
var Ry = {
  begin: dR,
  end: iT
};
const df = () => {
};
function X1(e) {
  return typeof (e.getAttribute ? e.getAttribute(ya) : null) == "string";
}
function pR(e) {
  const t = e.getAttribute ? e.getAttribute(Oy) : null, n = e.getAttribute ? e.getAttribute(ky) : null;
  return t && n;
}
function hR(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(Ve.replacementClass);
}
function mR() {
  return Ve.autoReplaceSvg === !0 ? pf.replace : pf[Ve.autoReplaceSvg] || pf.replace;
}
function vR(e) {
  return Pt.createElementNS("http://www.w3.org/2000/svg", e);
}
function gR(e) {
  return Pt.createElement(e);
}
function oT(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? vR : gR
  } = t;
  if (typeof e == "string")
    return Pt.createTextNode(e);
  const r = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(o) {
    r.setAttribute(o, e.attributes[o]);
  }), (e.children || []).forEach(function(o) {
    r.appendChild(oT(o, {
      ceFn: n
    }));
  }), r;
}
function yR(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const pf = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(oT(n), t);
      }), t.getAttribute(ya) === null && Ve.keepOriginalSource) {
        let n = Pt.createComment(yR(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~Dy(t).indexOf(Ve.replacementClass))
      return pf.replace(e);
    const r = new RegExp("".concat(Ve.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const o = n[0].attributes.class.split(" ").reduce((a, s) => (s === Ve.replacementClass || s.match(r) ? a.toSvg.push(s) : a.toNode.push(s), a), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = o.toSvg.join(" "), o.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", o.toNode.join(" "));
    }
    const i = n.map((o) => Xu(o)).join(`
`);
    t.setAttribute(ya, ""), t.innerHTML = i;
  }
};
function e_(e) {
  e();
}
function aT(e, t) {
  const n = typeof t == "function" ? t : df;
  if (e.length === 0)
    n();
  else {
    let r = e_;
    Ve.mutateApproach === wM && (r = xo.requestAnimationFrame || e_), r(() => {
      const i = mR(), o = Ry.begin("mutate");
      e.map(i), o(), n();
    });
  }
}
let Ny = !1;
function sT() {
  Ny = !0;
}
function dv() {
  Ny = !1;
}
let Hf = null;
function t_(e) {
  if (!V1 || !Ve.observeMutations)
    return;
  const {
    treeCallback: t = df,
    nodeCallback: n = df,
    pseudoElementsCallback: r = df,
    observeMutationsRoot: i = Pt
  } = e;
  Hf = new V1((o) => {
    if (Ny) return;
    const a = Eo();
    el(o).forEach((s) => {
      if (s.type === "childList" && s.addedNodes.length > 0 && !X1(s.addedNodes[0]) && (Ve.searchPseudoElements && r(s.target), t(s.target)), s.type === "attributes" && s.target.parentNode && Ve.searchPseudoElements && r(s.target.parentNode), s.type === "attributes" && X1(s.target) && ~OM.indexOf(s.attributeName))
        if (s.attributeName === "class" && pR(s.target)) {
          const {
            prefix: l,
            iconName: u
          } = ep(Dy(s.target));
          s.target.setAttribute(Oy, l || a), u && s.target.setAttribute(ky, u);
        } else hR(s.target) && n(s.target);
    });
  }), Xi && Hf.observe(i, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function bR() {
  Hf && Hf.disconnect();
}
function _R(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((r, i) => {
    const o = i.split(":"), a = o[0], s = o.slice(1);
    return a && s.length > 0 && (r[a] = s.join(":").trim()), r;
  }, {})), n;
}
function wR(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "";
  let i = ep(Dy(e));
  return i.prefix || (i.prefix = Eo()), t && n && (i.prefix = t, i.iconName = n), i.iconName && i.prefix || (i.prefix && r.length > 0 && (i.iconName = HM(i.prefix, e.innerText) || Iy(i.prefix, ov(e.innerText))), !i.iconName && Ve.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (i.iconName = e.firstChild.data)), i;
}
function xR(e) {
  const t = el(e.attributes).reduce((i, o) => (i.name !== "class" && i.name !== "style" && (i[o.name] = o.value), i), {}), n = e.getAttribute("title"), r = e.getAttribute("data-fa-title-id");
  return Ve.autoA11y && (n ? t["aria-labelledby"] = "".concat(Ve.replacementClass, "-title-").concat(r || _u()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function ER() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: xi,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function n_(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: r,
    rest: i
  } = wR(e), o = xR(e), a = sv("parseNodeAttributes", {}, e);
  let s = t.styleParser ? _R(e) : [];
  return _e({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: r,
    transform: xi,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: s,
      attributes: o
    }
  }, a);
}
const {
  styles: SR
} = Ei;
function lT(e) {
  const t = Ve.autoReplaceSvg === "nest" ? n_(e, {
    styleParser: !1
  }) : n_(e);
  return ~t.extra.classes.indexOf(B$) ? So("generateLayersText", e, t) : So("generateSvgReplacementMutation", e, t);
}
function $R() {
  return [...oM, ...Xm];
}
function r_(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Xi) return Promise.resolve();
  const n = Pt.documentElement.classList, r = (c) => n.add("".concat(U1, "-").concat(c)), i = (c) => n.remove("".concat(U1, "-").concat(c)), o = Ve.autoFetchSvg ? $R() : R$.concat(Object.keys(SR));
  o.includes("fa") || o.push("fa");
  const a = [".".concat(B$, ":not([").concat(ya, "])")].concat(o.map((c) => ".".concat(c, ":not([").concat(ya, "])"))).join(", ");
  if (a.length === 0)
    return Promise.resolve();
  let s = [];
  try {
    s = el(e.querySelectorAll(a));
  } catch {
  }
  if (s.length > 0)
    r("pending"), i("complete");
  else
    return Promise.resolve();
  const l = Ry.begin("onTree"), u = s.reduce((c, f) => {
    try {
      const d = lT(f);
      d && c.push(d);
    } catch (d) {
      L$ || d.name === "MissingIcon" && console.error(d);
    }
    return c;
  }, []);
  return new Promise((c, f) => {
    Promise.all(u).then((d) => {
      aT(d, () => {
        r("active"), r("complete"), i("pending"), typeof t == "function" && t(), l(), c();
      });
    }).catch((d) => {
      l(), f(d);
    });
  });
}
function TR(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  lT(e).then((n) => {
    n && aT([n], t);
  });
}
function OR(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = (t || {}).icon ? t : lv(t || {});
    let {
      mask: i
    } = n;
    return i && (i = (i || {}).icon ? i : lv(i || {})), e(r, _e(_e({}, n), {}, {
      mask: i
    }));
  };
}
const kR = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = xi,
    symbol: r = !1,
    mask: i = null,
    maskId: o = null,
    title: a = null,
    titleId: s = null,
    classes: l = [],
    attributes: u = {},
    styles: c = {}
  } = t;
  if (!e) return;
  const {
    prefix: f,
    iconName: d,
    icon: p
  } = e;
  return tp(_e({
    type: "icon"
  }, e), () => (ba("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), Ve.autoA11y && (a ? u["aria-labelledby"] = "".concat(Ve.replacementClass, "-title-").concat(s || _u()) : (u["aria-hidden"] = "true", u.focusable = "false")), My({
    icons: {
      main: uv(p),
      mask: i ? uv(i.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: f,
    iconName: d,
    transform: _e(_e({}, xi), n),
    symbol: r,
    title: a,
    maskId: o,
    titleId: s,
    extra: {
      attributes: u,
      styles: c,
      classes: l
    }
  })));
};
var PR = {
  mixout() {
    return {
      icon: OR(kR)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = r_, e.nodeCallback = TR, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = Pt,
        callback: r = () => {
        }
      } = t;
      return r_(n, r);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: r,
        title: i,
        titleId: o,
        prefix: a,
        transform: s,
        symbol: l,
        mask: u,
        maskId: c,
        extra: f
      } = n;
      return new Promise((d, p) => {
        Promise.all([cv(r, a), u.iconName ? cv(u.iconName, u.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((h) => {
          let [m, v] = h;
          d([t, My({
            icons: {
              main: m,
              mask: v
            },
            prefix: a,
            iconName: r,
            transform: s,
            symbol: l,
            maskId: c,
            title: i,
            titleId: o,
            extra: f,
            watchable: !0
          })]);
        }).catch(p);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: r,
        main: i,
        transform: o,
        styles: a
      } = t;
      const s = Jd(a);
      s.length > 0 && (r.style = s);
      let l;
      return Ay(o) && (l = So("generateAbstractTransformGrouping", {
        main: i,
        transform: o,
        containerWidth: i.width,
        iconWidth: i.width
      })), n.push(l || i.icon), {
        children: n,
        attributes: r
      };
    };
  }
}, DR = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return tp({
          type: "layer"
        }, () => {
          ba("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let r = [];
          return e((i) => {
            Array.isArray(i) ? i.map((o) => {
              r = r.concat(o.abstract);
            }) : r = r.concat(i.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(Ve.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: r
          }];
        });
      }
    };
  }
}, AR = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: r = [],
          attributes: i = {},
          styles: o = {}
        } = t;
        return tp({
          type: "counter",
          content: e
        }, () => (ba("beforeDOMElementCreation", {
          content: e,
          params: t
        }), uR({
          content: e.toString(),
          title: n,
          extra: {
            attributes: i,
            styles: o,
            classes: ["".concat(Ve.cssPrefix, "-layers-counter"), ...r]
          }
        })));
      }
    };
  }
}, CR = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = xi,
          title: r = null,
          classes: i = [],
          attributes: o = {},
          styles: a = {}
        } = t;
        return tp({
          type: "text",
          content: e
        }, () => (ba("beforeDOMElementCreation", {
          content: e,
          params: t
        }), Q1({
          content: e,
          transform: _e(_e({}, xi), n),
          title: r,
          extra: {
            attributes: o,
            styles: a,
            classes: ["".concat(Ve.cssPrefix, "-layers-text"), ...i]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: r,
        transform: i,
        extra: o
      } = n;
      let a = null, s = null;
      if (I$) {
        const l = parseInt(getComputedStyle(t).fontSize, 10), u = t.getBoundingClientRect();
        a = u.width / l, s = u.height / l;
      }
      return Ve.autoA11y && !r && (o.attributes["aria-hidden"] = "true"), Promise.resolve([t, Q1({
        content: t.innerHTML,
        width: a,
        height: s,
        transform: i,
        title: r,
        extra: o,
        watchable: !0
      })]);
    };
  }
};
const IR = new RegExp('"', "ug"), i_ = [1105920, 1112319], o_ = _e(_e(_e(_e({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), nM), bM), dM), pv = Object.keys(o_).reduce((e, t) => (e[t.toLowerCase()] = o_[t], e), {}), MR = Object.keys(pv).reduce((e, t) => {
  const n = pv[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function RR(e) {
  const t = e.replace(IR, ""), n = VM(t, 0), r = n >= i_[0] && n <= i_[1], i = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: ov(i ? t[0] : t),
    isSecondary: r || i
  };
}
function NR(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), r = parseInt(t), i = isNaN(r) ? "normal" : r;
  return (pv[n] || {})[i] || MR[n];
}
function a_(e, t) {
  const n = "".concat(_M).concat(t.replace(":", "-"));
  return new Promise((r, i) => {
    if (e.getAttribute(n) !== null)
      return r();
    const a = el(e.children).filter((d) => d.getAttribute(tv) === t)[0], s = xo.getComputedStyle(e, t), l = s.getPropertyValue("font-family"), u = l.match($M), c = s.getPropertyValue("font-weight"), f = s.getPropertyValue("content");
    if (a && !u)
      return e.removeChild(a), r();
    if (u && f !== "none" && f !== "") {
      const d = s.getPropertyValue("content");
      let p = NR(l, c);
      const {
        value: h,
        isSecondary: m
      } = RR(d), v = u[0].startsWith("FontAwesome");
      let g = Iy(p, h), b = g;
      if (v) {
        const E = WM(h);
        E.iconName && E.prefix && (g = E.iconName, p = E.prefix);
      }
      if (g && !m && (!a || a.getAttribute(Oy) !== p || a.getAttribute(ky) !== b)) {
        e.setAttribute(n, b), a && e.removeChild(a);
        const E = ER(), {
          extra: x
        } = E;
        x.attributes[tv] = t, cv(g, p).then((S) => {
          const $ = My(_e(_e({}, E), {}, {
            icons: {
              main: S,
              mask: nT()
            },
            prefix: p,
            iconName: b,
            extra: x,
            watchable: !0
          })), P = Pt.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(P, e.firstChild) : e.appendChild(P), P.outerHTML = $.map((y) => Xu(y)).join(`
`), e.removeAttribute(n), r();
        }).catch(i);
      } else
        r();
    } else
      r();
  });
}
function jR(e) {
  return Promise.all([a_(e, "::before"), a_(e, "::after")]);
}
function FR(e) {
  return e.parentNode !== document.head && !~xM.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(tv) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function s_(e) {
  if (Xi)
    return new Promise((t, n) => {
      const r = el(e.querySelectorAll("*")).filter(FR).map(jR), i = Ry.begin("searchPseudoElements");
      sT(), Promise.all(r).then(() => {
        i(), dv(), t();
      }).catch(() => {
        i(), dv(), n();
      });
    });
}
var zR = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = s_, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = Pt
      } = t;
      Ve.searchPseudoElements && s_(n);
    };
  }
};
let l_ = !1;
var LR = {
  mixout() {
    return {
      dom: {
        unwatch() {
          sT(), l_ = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        t_(sv("mutationObserverCallbacks", {}));
      },
      noAuto() {
        bR();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        l_ ? dv() : t_(sv("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const u_ = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, r) => {
    const i = r.toLowerCase().split("-"), o = i[0];
    let a = i.slice(1).join("-");
    if (o && a === "h")
      return n.flipX = !0, n;
    if (o && a === "v")
      return n.flipY = !0, n;
    if (a = parseFloat(a), isNaN(a))
      return n;
    switch (o) {
      case "grow":
        n.size = n.size + a;
        break;
      case "shrink":
        n.size = n.size - a;
        break;
      case "left":
        n.x = n.x - a;
        break;
      case "right":
        n.x = n.x + a;
        break;
      case "up":
        n.y = n.y - a;
        break;
      case "down":
        n.y = n.y + a;
        break;
      case "rotate":
        n.rotate = n.rotate + a;
        break;
    }
    return n;
  }, t);
};
var VR = {
  mixout() {
    return {
      parse: {
        transform: (e) => u_(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = u_(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: r,
        containerWidth: i,
        iconWidth: o
      } = t;
      const a = {
        transform: "translate(".concat(i / 2, " 256)")
      }, s = "translate(".concat(r.x * 32, ", ").concat(r.y * 32, ") "), l = "scale(".concat(r.size / 16 * (r.flipX ? -1 : 1), ", ").concat(r.size / 16 * (r.flipY ? -1 : 1), ") "), u = "rotate(".concat(r.rotate, " 0 0)"), c = {
        transform: "".concat(s, " ").concat(l, " ").concat(u)
      }, f = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, d = {
        outer: a,
        inner: c,
        path: f
      };
      return {
        tag: "g",
        attributes: _e({}, d.outer),
        children: [{
          tag: "g",
          attributes: _e({}, d.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: _e(_e({}, n.icon.attributes), d.path)
          }]
        }]
      };
    };
  }
};
const yh = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function c_(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function BR(e) {
  return e.tag === "g" ? e.children : [e];
}
var KR = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), r = n ? ep(n.split(" ").map((i) => i.trim())) : nT();
        return r.prefix || (r.prefix = Eo()), e.mask = r, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: r,
        main: i,
        mask: o,
        maskId: a,
        transform: s
      } = t;
      const {
        width: l,
        icon: u
      } = i, {
        width: c,
        icon: f
      } = o, d = RM({
        transform: s,
        containerWidth: c,
        iconWidth: l
      }), p = {
        tag: "rect",
        attributes: _e(_e({}, yh), {}, {
          fill: "white"
        })
      }, h = u.children ? {
        children: u.children.map(c_)
      } : {}, m = {
        tag: "g",
        attributes: _e({}, d.inner),
        children: [c_(_e({
          tag: u.tag,
          attributes: _e(_e({}, u.attributes), d.path)
        }, h))]
      }, v = {
        tag: "g",
        attributes: _e({}, d.outer),
        children: [m]
      }, g = "mask-".concat(a || _u()), b = "clip-".concat(a || _u()), E = {
        tag: "mask",
        attributes: _e(_e({}, yh), {}, {
          id: g,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, v]
      }, x = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: b
          },
          children: BR(f)
        }, E]
      };
      return n.push(x, {
        tag: "rect",
        attributes: _e({
          fill: "currentColor",
          "clip-path": "url(#".concat(b, ")"),
          mask: "url(#".concat(g, ")")
        }, yh)
      }), {
        children: n,
        attributes: r
      };
    };
  }
}, UR = {
  provides(e) {
    let t = !1;
    xo.matchMedia && (t = xo.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], r = {
        fill: "currentColor"
      }, i = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: _e(_e({}, r), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const o = _e(_e({}, i), {}, {
        attributeName: "opacity"
      }), a = {
        tag: "circle",
        attributes: _e(_e({}, r), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || a.children.push({
        tag: "animate",
        attributes: _e(_e({}, i), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: _e(_e({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(a), n.push({
        tag: "path",
        attributes: _e(_e({}, r), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: _e(_e({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || n.push({
        tag: "path",
        attributes: _e(_e({}, r), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: _e(_e({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, qR = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), r = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = r, e;
      }
    };
  }
}, HR = [FM, PR, DR, AR, CR, zR, LR, VR, KR, UR, qR];
nR(HR, {
  mixoutsTo: pr
});
pr.noAuto;
pr.config;
pr.library;
pr.dom;
const hv = pr.parse;
pr.findIconDefinition;
pr.toHtml;
const WR = pr.icon;
pr.layer;
pr.text;
pr.counter;
var Pc = { exports: {} }, Dc = { exports: {} }, ut = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f_;
function ZR() {
  if (f_) return ut;
  f_ = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function E(S) {
    if (typeof S == "object" && S !== null) {
      var $ = S.$$typeof;
      switch ($) {
        case t:
          switch (S = S.type, S) {
            case l:
            case u:
            case r:
            case o:
            case i:
            case f:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case s:
                case c:
                case h:
                case p:
                case a:
                  return S;
                default:
                  return $;
              }
          }
        case n:
          return $;
      }
    }
  }
  function x(S) {
    return E(S) === u;
  }
  return ut.AsyncMode = l, ut.ConcurrentMode = u, ut.ContextConsumer = s, ut.ContextProvider = a, ut.Element = t, ut.ForwardRef = c, ut.Fragment = r, ut.Lazy = h, ut.Memo = p, ut.Portal = n, ut.Profiler = o, ut.StrictMode = i, ut.Suspense = f, ut.isAsyncMode = function(S) {
    return x(S) || E(S) === l;
  }, ut.isConcurrentMode = x, ut.isContextConsumer = function(S) {
    return E(S) === s;
  }, ut.isContextProvider = function(S) {
    return E(S) === a;
  }, ut.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, ut.isForwardRef = function(S) {
    return E(S) === c;
  }, ut.isFragment = function(S) {
    return E(S) === r;
  }, ut.isLazy = function(S) {
    return E(S) === h;
  }, ut.isMemo = function(S) {
    return E(S) === p;
  }, ut.isPortal = function(S) {
    return E(S) === n;
  }, ut.isProfiler = function(S) {
    return E(S) === o;
  }, ut.isStrictMode = function(S) {
    return E(S) === i;
  }, ut.isSuspense = function(S) {
    return E(S) === f;
  }, ut.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === r || S === u || S === o || S === i || S === f || S === d || typeof S == "object" && S !== null && (S.$$typeof === h || S.$$typeof === p || S.$$typeof === a || S.$$typeof === s || S.$$typeof === c || S.$$typeof === v || S.$$typeof === g || S.$$typeof === b || S.$$typeof === m);
  }, ut.typeOf = E, ut;
}
var ct = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d_;
function GR() {
  return d_ || (d_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function E(z) {
      return typeof z == "string" || typeof z == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      z === r || z === u || z === o || z === i || z === f || z === d || typeof z == "object" && z !== null && (z.$$typeof === h || z.$$typeof === p || z.$$typeof === a || z.$$typeof === s || z.$$typeof === c || z.$$typeof === v || z.$$typeof === g || z.$$typeof === b || z.$$typeof === m);
    }
    function x(z) {
      if (typeof z == "object" && z !== null) {
        var H = z.$$typeof;
        switch (H) {
          case t:
            var X = z.type;
            switch (X) {
              case l:
              case u:
              case r:
              case o:
              case i:
              case f:
                return X;
              default:
                var fe = X && X.$$typeof;
                switch (fe) {
                  case s:
                  case c:
                  case h:
                  case p:
                  case a:
                    return fe;
                  default:
                    return H;
                }
            }
          case n:
            return H;
        }
      }
    }
    var S = l, $ = u, P = s, y = a, _ = t, w = c, A = r, k = h, N = p, I = n, B = o, q = i, ee = f, re = !1;
    function Z(z) {
      return re || (re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), T(z) || x(z) === l;
    }
    function T(z) {
      return x(z) === u;
    }
    function F(z) {
      return x(z) === s;
    }
    function M(z) {
      return x(z) === a;
    }
    function K(z) {
      return typeof z == "object" && z !== null && z.$$typeof === t;
    }
    function te(z) {
      return x(z) === c;
    }
    function se(z) {
      return x(z) === r;
    }
    function de(z) {
      return x(z) === h;
    }
    function ge(z) {
      return x(z) === p;
    }
    function V(z) {
      return x(z) === n;
    }
    function O(z) {
      return x(z) === o;
    }
    function D(z) {
      return x(z) === i;
    }
    function C(z) {
      return x(z) === f;
    }
    ct.AsyncMode = S, ct.ConcurrentMode = $, ct.ContextConsumer = P, ct.ContextProvider = y, ct.Element = _, ct.ForwardRef = w, ct.Fragment = A, ct.Lazy = k, ct.Memo = N, ct.Portal = I, ct.Profiler = B, ct.StrictMode = q, ct.Suspense = ee, ct.isAsyncMode = Z, ct.isConcurrentMode = T, ct.isContextConsumer = F, ct.isContextProvider = M, ct.isElement = K, ct.isForwardRef = te, ct.isFragment = se, ct.isLazy = de, ct.isMemo = ge, ct.isPortal = V, ct.isProfiler = O, ct.isStrictMode = D, ct.isSuspense = C, ct.isValidElementType = E, ct.typeOf = x;
  })()), ct;
}
var p_;
function uT() {
  return p_ || (p_ = 1, process.env.NODE_ENV === "production" ? Dc.exports = ZR() : Dc.exports = GR()), Dc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var bh, h_;
function YR() {
  if (h_) return bh;
  h_ = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(c) {
        return a[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return bh = i() ? Object.assign : function(o, a) {
    for (var s, l = r(o), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var f in s)
        t.call(s, f) && (l[f] = s[f]);
      if (e) {
        u = e(s);
        for (var d = 0; d < u.length; d++)
          n.call(s, u[d]) && (l[u[d]] = s[u[d]]);
      }
    }
    return l;
  }, bh;
}
var _h, m_;
function jy() {
  if (m_) return _h;
  m_ = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return _h = e, _h;
}
var wh, v_;
function cT() {
  return v_ || (v_ = 1, wh = Function.call.bind(Object.prototype.hasOwnProperty)), wh;
}
var xh, g_;
function QR() {
  if (g_) return xh;
  g_ = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ jy(), n = {}, r = /* @__PURE__ */ cT();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (r(o, c)) {
          var f;
          try {
            if (typeof o[c] != "function") {
              var d = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[c](a, c, l, s, null, t);
          } catch (h) {
            f = h;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var p = u ? u() : "";
            e(
              "Failed " + s + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, xh = i, xh;
}
var Eh, y_;
function JR() {
  if (y_) return Eh;
  y_ = 1;
  var e = uT(), t = YR(), n = /* @__PURE__ */ jy(), r = /* @__PURE__ */ cT(), i = /* @__PURE__ */ QR(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Eh = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(T) {
      var F = T && (u && T[u] || T[c]);
      if (typeof F == "function")
        return F;
    }
    var d = "<<anonymous>>", p = {
      array: g("array"),
      bigint: g("bigint"),
      bool: g("boolean"),
      func: g("function"),
      number: g("number"),
      object: g("object"),
      string: g("string"),
      symbol: g("symbol"),
      any: b(),
      arrayOf: E,
      element: x(),
      elementType: S(),
      instanceOf: $,
      node: w(),
      objectOf: y,
      oneOf: P,
      oneOfType: _,
      shape: k,
      exact: N
    };
    function h(T, F) {
      return T === F ? T !== 0 || 1 / T === 1 / F : T !== T && F !== F;
    }
    function m(T, F) {
      this.message = T, this.data = F && typeof F == "object" ? F : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function v(T) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, M = 0;
      function K(se, de, ge, V, O, D, C) {
        if (V = V || d, D = D || ge, C !== n) {
          if (l) {
            var z = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw z.name = "Invariant Violation", z;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var H = V + ":" + ge;
            !F[H] && // Avoid spamming the console because they are often not actionable except for lib authors
            M < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + D + "` prop on `" + V + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[H] = !0, M++);
          }
        }
        return de[ge] == null ? se ? de[ge] === null ? new m("The " + O + " `" + D + "` is marked as required " + ("in `" + V + "`, but its value is `null`.")) : new m("The " + O + " `" + D + "` is marked as required in " + ("`" + V + "`, but its value is `undefined`.")) : null : T(de, ge, V, O, D);
      }
      var te = K.bind(null, !1);
      return te.isRequired = K.bind(null, !0), te;
    }
    function g(T) {
      function F(M, K, te, se, de, ge) {
        var V = M[K], O = q(V);
        if (O !== T) {
          var D = ee(V);
          return new m(
            "Invalid " + se + " `" + de + "` of type " + ("`" + D + "` supplied to `" + te + "`, expected ") + ("`" + T + "`."),
            { expectedType: T }
          );
        }
        return null;
      }
      return v(F);
    }
    function b() {
      return v(a);
    }
    function E(T) {
      function F(M, K, te, se, de) {
        if (typeof T != "function")
          return new m("Property `" + de + "` of component `" + te + "` has invalid PropType notation inside arrayOf.");
        var ge = M[K];
        if (!Array.isArray(ge)) {
          var V = q(ge);
          return new m("Invalid " + se + " `" + de + "` of type " + ("`" + V + "` supplied to `" + te + "`, expected an array."));
        }
        for (var O = 0; O < ge.length; O++) {
          var D = T(ge, O, te, se, de + "[" + O + "]", n);
          if (D instanceof Error)
            return D;
        }
        return null;
      }
      return v(F);
    }
    function x() {
      function T(F, M, K, te, se) {
        var de = F[M];
        if (!s(de)) {
          var ge = q(de);
          return new m("Invalid " + te + " `" + se + "` of type " + ("`" + ge + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(T);
    }
    function S() {
      function T(F, M, K, te, se) {
        var de = F[M];
        if (!e.isValidElementType(de)) {
          var ge = q(de);
          return new m("Invalid " + te + " `" + se + "` of type " + ("`" + ge + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(T);
    }
    function $(T) {
      function F(M, K, te, se, de) {
        if (!(M[K] instanceof T)) {
          var ge = T.name || d, V = Z(M[K]);
          return new m("Invalid " + se + " `" + de + "` of type " + ("`" + V + "` supplied to `" + te + "`, expected ") + ("instance of `" + ge + "`."));
        }
        return null;
      }
      return v(F);
    }
    function P(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function F(M, K, te, se, de) {
        for (var ge = M[K], V = 0; V < T.length; V++)
          if (h(ge, T[V]))
            return null;
        var O = JSON.stringify(T, function(C, z) {
          var H = ee(z);
          return H === "symbol" ? String(z) : z;
        });
        return new m("Invalid " + se + " `" + de + "` of value `" + String(ge) + "` " + ("supplied to `" + te + "`, expected one of " + O + "."));
      }
      return v(F);
    }
    function y(T) {
      function F(M, K, te, se, de) {
        if (typeof T != "function")
          return new m("Property `" + de + "` of component `" + te + "` has invalid PropType notation inside objectOf.");
        var ge = M[K], V = q(ge);
        if (V !== "object")
          return new m("Invalid " + se + " `" + de + "` of type " + ("`" + V + "` supplied to `" + te + "`, expected an object."));
        for (var O in ge)
          if (r(ge, O)) {
            var D = T(ge, O, te, se, de + "." + O, n);
            if (D instanceof Error)
              return D;
          }
        return null;
      }
      return v(F);
    }
    function _(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var F = 0; F < T.length; F++) {
        var M = T[F];
        if (typeof M != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + re(M) + " at index " + F + "."
          ), a;
      }
      function K(te, se, de, ge, V) {
        for (var O = [], D = 0; D < T.length; D++) {
          var C = T[D], z = C(te, se, de, ge, V, n);
          if (z == null)
            return null;
          z.data && r(z.data, "expectedType") && O.push(z.data.expectedType);
        }
        var H = O.length > 0 ? ", expected one of type [" + O.join(", ") + "]" : "";
        return new m("Invalid " + ge + " `" + V + "` supplied to " + ("`" + de + "`" + H + "."));
      }
      return v(K);
    }
    function w() {
      function T(F, M, K, te, se) {
        return I(F[M]) ? null : new m("Invalid " + te + " `" + se + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return v(T);
    }
    function A(T, F, M, K, te) {
      return new m(
        (T || "React class") + ": " + F + " type `" + M + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + te + "`."
      );
    }
    function k(T) {
      function F(M, K, te, se, de) {
        var ge = M[K], V = q(ge);
        if (V !== "object")
          return new m("Invalid " + se + " `" + de + "` of type `" + V + "` " + ("supplied to `" + te + "`, expected `object`."));
        for (var O in T) {
          var D = T[O];
          if (typeof D != "function")
            return A(te, se, de, O, ee(D));
          var C = D(ge, O, te, se, de + "." + O, n);
          if (C)
            return C;
        }
        return null;
      }
      return v(F);
    }
    function N(T) {
      function F(M, K, te, se, de) {
        var ge = M[K], V = q(ge);
        if (V !== "object")
          return new m("Invalid " + se + " `" + de + "` of type `" + V + "` " + ("supplied to `" + te + "`, expected `object`."));
        var O = t({}, M[K], T);
        for (var D in O) {
          var C = T[D];
          if (r(T, D) && typeof C != "function")
            return A(te, se, de, D, ee(C));
          if (!C)
            return new m(
              "Invalid " + se + " `" + de + "` key `" + D + "` supplied to `" + te + "`.\nBad object: " + JSON.stringify(M[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(T), null, "  ")
            );
          var z = C(ge, D, te, se, de + "." + D, n);
          if (z)
            return z;
        }
        return null;
      }
      return v(F);
    }
    function I(T) {
      switch (typeof T) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !T;
        case "object":
          if (Array.isArray(T))
            return T.every(I);
          if (T === null || s(T))
            return !0;
          var F = f(T);
          if (F) {
            var M = F.call(T), K;
            if (F !== T.entries) {
              for (; !(K = M.next()).done; )
                if (!I(K.value))
                  return !1;
            } else
              for (; !(K = M.next()).done; ) {
                var te = K.value;
                if (te && !I(te[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function B(T, F) {
      return T === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function q(T) {
      var F = typeof T;
      return Array.isArray(T) ? "array" : T instanceof RegExp ? "object" : B(F, T) ? "symbol" : F;
    }
    function ee(T) {
      if (typeof T > "u" || T === null)
        return "" + T;
      var F = q(T);
      if (F === "object") {
        if (T instanceof Date)
          return "date";
        if (T instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function re(T) {
      var F = ee(T);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function Z(T) {
      return !T.constructor || !T.constructor.name ? d : T.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, Eh;
}
var Sh, b_;
function XR() {
  if (b_) return Sh;
  b_ = 1;
  var e = /* @__PURE__ */ jy();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Sh = function() {
    function r(a, s, l, u, c, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Sh;
}
var __;
function eN() {
  if (__) return Pc.exports;
  if (__ = 1, process.env.NODE_ENV !== "production") {
    var e = uT(), t = !0;
    Pc.exports = /* @__PURE__ */ JR()(e.isElement, t);
  } else
    Pc.exports = /* @__PURE__ */ XR()();
  return Pc.exports;
}
var tN = /* @__PURE__ */ eN();
const Re = /* @__PURE__ */ Yd(tN);
function w_(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w_(Object(n), !0).forEach(function(r) {
      ss(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : w_(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Wf(e) {
  "@babel/helpers - typeof";
  return Wf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wf(e);
}
function ss(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function nN(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function fT(e, t) {
  if (e == null) return {};
  var n = nN(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function mv(e) {
  return rN(e) || iN(e) || oN(e) || aN();
}
function rN(e) {
  if (Array.isArray(e)) return vv(e);
}
function iN(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function oN(e, t) {
  if (e) {
    if (typeof e == "string") return vv(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return vv(e, t);
  }
}
function vv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function aN() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sN(e) {
  var t, n = e.beat, r = e.fade, i = e.beatFade, o = e.bounce, a = e.shake, s = e.flash, l = e.spin, u = e.spinPulse, c = e.spinReverse, f = e.pulse, d = e.fixedWidth, p = e.inverse, h = e.border, m = e.listItem, v = e.flip, g = e.size, b = e.rotation, E = e.pull, x = (t = {
    "fa-beat": n,
    "fa-fade": r,
    "fa-beat-fade": i,
    "fa-bounce": o,
    "fa-shake": a,
    "fa-flash": s,
    "fa-spin": l,
    "fa-spin-reverse": c,
    "fa-spin-pulse": u,
    "fa-pulse": f,
    "fa-fw": d,
    "fa-inverse": p,
    "fa-border": h,
    "fa-li": m,
    "fa-flip": v === !0,
    "fa-flip-horizontal": v === "horizontal" || v === "both",
    "fa-flip-vertical": v === "vertical" || v === "both"
  }, ss(t, "fa-".concat(g), typeof g < "u" && g !== null), ss(t, "fa-rotate-".concat(b), typeof b < "u" && b !== null && b !== 0), ss(t, "fa-pull-".concat(E), typeof E < "u" && E !== null), ss(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(x).map(function(S) {
    return x[S] ? S : null;
  }).filter(function(S) {
    return S;
  });
}
function lN(e) {
  return e = e - 0, e === e;
}
function dT(e) {
  return lN(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, n) {
    return n ? n.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var uN = ["style"];
function cN(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function fN(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var r = n.indexOf(":"), i = dT(n.slice(0, r)), o = n.slice(r + 1).trim();
    return i.startsWith("webkit") ? t[cN(i)] = o : t[i] = o, t;
  }, {});
}
function pT(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var r = (t.children || []).map(function(l) {
    return pT(e, l);
  }), i = Object.keys(t.attributes || {}).reduce(function(l, u) {
    var c = t.attributes[u];
    switch (u) {
      case "class":
        l.attrs.className = c, delete t.attributes.class;
        break;
      case "style":
        l.attrs.style = fN(c);
        break;
      default:
        u.indexOf("aria-") === 0 || u.indexOf("data-") === 0 ? l.attrs[u.toLowerCase()] = c : l.attrs[dT(u)] = c;
    }
    return l;
  }, {
    attrs: {}
  }), o = n.style, a = o === void 0 ? {} : o, s = fT(n, uN);
  return i.attrs.style = mo(mo({}, i.attrs.style), a), e.apply(void 0, [t.tag, mo(mo({}, i.attrs), s)].concat(mv(r)));
}
var hT = !1;
try {
  hT = process.env.NODE_ENV === "production";
} catch {
}
function dN() {
  if (!hT && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function x_(e) {
  if (e && Wf(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (hv.icon)
    return hv.icon(e);
  if (e === null)
    return null;
  if (e && Wf(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function $h(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? ss({}, e, t) : {};
}
var pN = ["forwardedRef"];
function cr(e) {
  var t = e.forwardedRef, n = fT(e, pN), r = n.icon, i = n.mask, o = n.symbol, a = n.className, s = n.title, l = n.titleId, u = n.maskId, c = x_(r), f = $h("classes", [].concat(mv(sN(n)), mv(a.split(" ")))), d = $h("transform", typeof n.transform == "string" ? hv.transform(n.transform) : n.transform), p = $h("mask", x_(i)), h = WR(c, mo(mo(mo(mo({}, f), d), p), {}, {
    symbol: o,
    title: s,
    titleId: l,
    maskId: u
  }));
  if (!h)
    return dN("Could not find icon", c), null;
  var m = h.abstract, v = {
    ref: t
  };
  return Object.keys(n).forEach(function(g) {
    cr.defaultProps.hasOwnProperty(g) || (v[g] = n[g]);
  }), hN(m[0], v);
}
cr.displayName = "FontAwesomeIcon";
cr.propTypes = {
  beat: Re.bool,
  border: Re.bool,
  beatFade: Re.bool,
  bounce: Re.bool,
  className: Re.string,
  fade: Re.bool,
  flash: Re.bool,
  mask: Re.oneOfType([Re.object, Re.array, Re.string]),
  maskId: Re.string,
  fixedWidth: Re.bool,
  inverse: Re.bool,
  flip: Re.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: Re.oneOfType([Re.object, Re.array, Re.string]),
  listItem: Re.bool,
  pull: Re.oneOf(["right", "left"]),
  pulse: Re.bool,
  rotation: Re.oneOf([0, 90, 180, 270]),
  shake: Re.bool,
  size: Re.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: Re.bool,
  spinPulse: Re.bool,
  spinReverse: Re.bool,
  symbol: Re.oneOfType([Re.bool, Re.string]),
  title: Re.string,
  titleId: Re.string,
  transform: Re.oneOfType([Re.string, Re.object]),
  swapOpacity: Re.bool
};
cr.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var hN = pT.bind(null, G.createElement);
const mN = Mr(
  [
    "absolute",
    "p-1",
    "text-sm",
    "-translate-y-1/2",
    "top-1/2",
    "left-full",
    "text-neutral-800",
    "dark:text-neutral-100",
    "z-[9999]",
    "transition-opacity"
  ],
  {
    variants: {
      visible: {
        true: "opacity-100",
        false: "opacity-0"
      }
    }
  }
), vN = (e) => /* @__PURE__ */ R.jsx("p", { className: mN({ visible: e.visible }), children: "Copied!" }), Aue = ({
  text: e,
  onCopy: t,
  element: n,
  copyElement: r,
  disabled: i = !1,
  className: o = ""
}) => {
  const [a, s] = je(!1);
  return /* @__PURE__ */ R.jsxs(
    "button",
    {
      disabled: i,
      className: `${o} relative w-3 h-3`,
      onClick: () => {
        t?.(e), navigator.clipboard.writeText(e), s(!0), setTimeout(() => s(!1), 1500);
      },
      children: [
        n || /* @__PURE__ */ R.jsx(
          cr,
          {
            className: "w-full h-full p-1 cursor-pointer place-items-center aspect-square",
            icon: K6
          }
        ),
        /* @__PURE__ */ R.jsx(vN, { visible: a, children: r || "Copied!" })
      ]
    }
  );
}, xu = Le({});
function Fy(e) {
  const t = ve(null);
  return t.current === null && (t.current = e()), t.current;
}
const gN = typeof window < "u", np = gN ? y$ : De, rp = /* @__PURE__ */ Le(null);
function zy(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Zf(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const ki = (e, t, n) => n > t ? t : n < e ? e : n;
function gv(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let tl = () => {
}, Hi = () => {
};
typeof process < "u" && process.env?.NODE_ENV !== "production" && (tl = (e, t, n) => {
  !e && typeof console < "u" && console.warn(gv(t, n));
}, Hi = (e, t, n) => {
  if (!e)
    throw new Error(gv(t, n));
});
const $o = {}, mT = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), vT = (e) => typeof e == "object" && e !== null, gT = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function yT(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const kr = /* @__NO_SIDE_EFFECTS__ */ (e) => e, ec = (...e) => e.reduce((t, n) => (r) => n(t(r))), Eu = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r ? (n - e) / r : 1;
};
class Ly {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return zy(this.subscriptions, t), () => Zf(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let o = 0; o < i; o++) {
          const a = this.subscriptions[o];
          a && a(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const qn = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, Er = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, bT = /* @__NO_SIDE_EFFECTS__ */ (e, t) => t ? e * (1e3 / t) : 0, E_ = /* @__PURE__ */ new Set();
function Vy(e, t, n) {
  e || E_.has(t) || (console.warn(gv(t, n)), E_.add(t));
}
const _T = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, yN = 1e-7, bN = 12;
function _N(e, t, n, r, i) {
  let o, a, s = 0;
  do
    a = t + (n - t) / 2, o = _T(a, r, i) - e, o > 0 ? n = a : t = a;
  while (Math.abs(o) > yN && ++s < bN);
  return a;
}
// @__NO_SIDE_EFFECTS__
function tc(e, t, n, r) {
  if (e === t && n === r)
    return kr;
  const i = (o) => _N(o, 0, 1, e, n);
  return (o) => o === 0 || o === 1 ? o : _T(i(o), t, r);
}
const wT = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, xT = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => 1 - e(1 - t), ET = /* @__PURE__ */ tc(0.33, 1.53, 0.69, 0.99), By = /* @__PURE__ */ xT(ET), ST = /* @__PURE__ */ wT(By), $T = (e) => e >= 1 ? 1 : (e *= 2) < 1 ? 0.5 * By(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Ky = (e) => 1 - Math.sin(Math.acos(e)), TT = /* @__PURE__ */ xT(Ky), OT = /* @__PURE__ */ wT(Ky), wN = /* @__PURE__ */ tc(0.42, 0, 1, 1), xN = /* @__PURE__ */ tc(0, 0, 0.58, 1), kT = /* @__PURE__ */ tc(0.42, 0, 0.58, 1), EN = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] != "number", PT = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] == "number", S_ = {
  linear: kr,
  easeIn: wN,
  easeInOut: kT,
  easeOut: xN,
  circIn: Ky,
  circInOut: OT,
  circOut: TT,
  backIn: By,
  backInOut: ST,
  backOut: ET,
  anticipate: $T
}, SN = (e) => typeof e == "string", $_ = (e) => {
  if (/* @__PURE__ */ PT(e)) {
    Hi(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, r, i] = e;
    return /* @__PURE__ */ tc(t, n, r, i);
  } else if (SN(e))
    return Hi(S_[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), S_[e];
  return e;
}, Ac = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function $N(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function s(u) {
    o.has(u) && (l.schedule(u), e()), u(a);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, c = !1, f = !1) => {
      const p = f && r ? t : n;
      return c && o.add(u), p.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      n.delete(u), o.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (a = u, r) {
        i = !0;
        return;
      }
      r = !0;
      const c = t;
      t = n, n = c, t.forEach(s), t.clear(), r = !1, i && (i = !1, l.process(u));
    }
  };
  return l;
}
const TN = 40;
function DT(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => n = !0, a = Ac.reduce((E, x) => (E[x] = $N(o), E), {}), { setup: s, read: l, resolveKeyframes: u, preUpdate: c, update: f, preRender: d, render: p, postRender: h } = a, m = () => {
    const E = $o.useManualTiming, x = E ? i.timestamp : performance.now();
    n = !1, E || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(x - i.timestamp, TN), 1)), i.timestamp = x, i.isProcessing = !0, s.process(i), l.process(i), u.process(i), c.process(i), f.process(i), d.process(i), p.process(i), h.process(i), i.isProcessing = !1, n && t && (r = !1, e(m));
  }, v = () => {
    n = !0, r = !0, i.isProcessing || e(m);
  };
  return { schedule: Ac.reduce((E, x) => {
    const S = a[x];
    return E[x] = ($, P = !1, y = !1) => (n || v(), S.schedule($, P, y)), E;
  }, {}), cancel: (E) => {
    for (let x = 0; x < Ac.length; x++)
      a[Ac[x]].cancel(E);
  }, state: i, steps: a };
}
const { schedule: ht, cancel: To, state: vn, steps: Th } = /* @__PURE__ */ DT(typeof requestAnimationFrame < "u" ? requestAnimationFrame : kr, !0);
let hf;
function ON() {
  hf = void 0;
}
const Mn = {
  now: () => (hf === void 0 && Mn.set(vn.isProcessing || $o.useManualTiming ? vn.timestamp : performance.now()), hf),
  set: (e) => {
    hf = e, queueMicrotask(ON);
  }
}, AT = (e) => (t) => typeof t == "string" && t.startsWith(e), CT = /* @__PURE__ */ AT("--"), kN = /* @__PURE__ */ AT("var(--"), Uy = (e) => kN(e) ? PN.test(e.split("/*")[0].trim()) : !1, PN = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function T_(e) {
  return typeof e != "string" ? !1 : e.split("/*")[0].includes("var(--");
}
const nl = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Su = {
  ...nl,
  transform: (e) => ki(0, 1, e)
}, Cc = {
  ...nl,
  default: 1
}, au = (e) => Math.round(e * 1e5) / 1e5, qy = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function DN(e) {
  return e == null;
}
const AN = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Hy = (e, t) => (n) => !!(typeof n == "string" && AN.test(n) && n.startsWith(e) || t && !DN(n) && Object.prototype.hasOwnProperty.call(n, t)), IT = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, o, a, s] = r.match(qy);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, CN = (e) => ki(0, 255, e), Oh = {
  ...nl,
  transform: (e) => Math.round(CN(e))
}, sa = {
  test: /* @__PURE__ */ Hy("rgb", "red"),
  parse: /* @__PURE__ */ IT("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Oh.transform(e) + ", " + Oh.transform(t) + ", " + Oh.transform(n) + ", " + au(Su.transform(r)) + ")"
};
function IN(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const yv = {
  test: /* @__PURE__ */ Hy("#"),
  parse: IN,
  transform: sa.transform
}, nc = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Ni = /* @__PURE__ */ nc("deg"), $i = /* @__PURE__ */ nc("%"), Me = /* @__PURE__ */ nc("px"), MN = /* @__PURE__ */ nc("vh"), RN = /* @__PURE__ */ nc("vw"), O_ = {
  ...$i,
  parse: (e) => $i.parse(e) / 100,
  transform: (e) => $i.transform(e * 100)
}, ls = {
  test: /* @__PURE__ */ Hy("hsl", "hue"),
  parse: /* @__PURE__ */ IT("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + $i.transform(au(t)) + ", " + $i.transform(au(n)) + ", " + au(Su.transform(r)) + ")"
}, rn = {
  test: (e) => sa.test(e) || yv.test(e) || ls.test(e),
  parse: (e) => sa.test(e) ? sa.parse(e) : ls.test(e) ? ls.parse(e) : yv.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? sa.transform(e) : ls.transform(e),
  getAnimatableNone: (e) => {
    const t = rn.parse(e);
    return t.alpha = 0, rn.transform(t);
  }
}, NN = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function jN(e) {
  return isNaN(e) && typeof e == "string" && (e.match(qy)?.length || 0) + (e.match(NN)?.length || 0) > 0;
}
const MT = "number", RT = "color", FN = "var", zN = "var(", k_ = "${}", LN = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Is(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let o = 0;
  const s = t.replace(LN, (l) => (rn.test(l) ? (r.color.push(o), i.push(RT), n.push(rn.parse(l))) : l.startsWith(zN) ? (r.var.push(o), i.push(FN), n.push(l)) : (r.number.push(o), i.push(MT), n.push(parseFloat(l))), ++o, k_)).split(k_);
  return { values: n, split: s, indexes: r, types: i };
}
function VN(e) {
  return Is(e).values;
}
function NT({ split: e, types: t }) {
  const n = e.length;
  return (r) => {
    let i = "";
    for (let o = 0; o < n; o++)
      if (i += e[o], r[o] !== void 0) {
        const a = t[o];
        a === MT ? i += au(r[o]) : a === RT ? i += rn.transform(r[o]) : i += r[o];
      }
    return i;
  };
}
function BN(e) {
  return NT(Is(e));
}
const KN = (e) => typeof e == "number" ? 0 : rn.test(e) ? rn.getAnimatableNone(e) : e, UN = (e, t) => typeof e == "number" ? t?.trim().endsWith("/") ? e : 0 : KN(e);
function qN(e) {
  const t = Is(e);
  return NT(t)(t.values.map((r, i) => UN(r, t.split[i])));
}
const Jr = {
  test: jN,
  parse: VN,
  createTransformer: BN,
  getAnimatableNone: qN
};
function kh(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function HN({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, a = 0;
  if (!t)
    i = o = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    i = kh(l, s, e + 1 / 3), o = kh(l, s, e), a = kh(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
function Gf(e, t) {
  return (n) => n > 0 ? t : e;
}
const bt = (e, t, n) => e + (t - e) * n, Ph = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, WN = [yv, sa, ls], ZN = (e) => WN.find((t) => t.test(e));
function P_(e) {
  const t = ZN(e);
  if (tl(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === ls && (n = HN(n)), n;
}
const D_ = (e, t) => {
  const n = P_(e), r = P_(t);
  if (!n || !r)
    return Gf(e, t);
  const i = { ...n };
  return (o) => (i.red = Ph(n.red, r.red, o), i.green = Ph(n.green, r.green, o), i.blue = Ph(n.blue, r.blue, o), i.alpha = bt(n.alpha, r.alpha, o), sa.transform(i));
}, bv = /* @__PURE__ */ new Set(["none", "hidden"]);
function GN(e, t) {
  return bv.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function YN(e, t) {
  return (n) => bt(e, t, n);
}
function Wy(e) {
  return typeof e == "number" ? YN : typeof e == "string" ? Uy(e) ? Gf : rn.test(e) ? D_ : XN : Array.isArray(e) ? jT : typeof e == "object" ? rn.test(e) ? D_ : QN : Gf;
}
function jT(e, t) {
  const n = [...e], r = n.length, i = e.map((o, a) => Wy(o)(o, t[a]));
  return (o) => {
    for (let a = 0; a < r; a++)
      n[a] = i[a](o);
    return n;
  };
}
function QN(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = Wy(e[i])(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
}
function JN(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const o = t.types[i], a = e.indexes[o][r[o]], s = e.values[a] ?? 0;
    n[i] = s, r[o]++;
  }
  return n;
}
const XN = (e, t) => {
  const n = Jr.createTransformer(t), r = Is(e), i = Is(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? bv.has(e) && !i.values.length || bv.has(t) && !r.values.length ? GN(e, t) : ec(jT(JN(r, i), i.values), n) : (tl(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Gf(e, t));
};
function FT(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? bt(e, t, n) : Wy(e)(e, t);
}
const e5 = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => ht.update(t, n),
    stop: () => To(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => vn.isProcessing ? vn.timestamp : Mn.now()
  };
}, zT = (e, t, n = 10) => {
  let r = "";
  const i = Math.max(Math.round(t / n), 2);
  for (let o = 0; o < i; o++)
    r += Math.round(e(o / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, Yf = 2e4;
function Zy(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Yf; )
    t += n, r = e.next(t);
  return t >= Yf ? 1 / 0 : t;
}
function t5(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), i = Math.min(Zy(r), Yf);
  return {
    type: "keyframes",
    ease: (o) => r.next(i * o).value / t,
    duration: /* @__PURE__ */ Er(i)
  };
}
const Lt = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function _v(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const n5 = 12;
function r5(e, t, n) {
  let r = n;
  for (let i = 1; i < n5; i++)
    r = r - e(r) / t(r);
  return r;
}
const Dh = 1e-3;
function i5({ duration: e = Lt.duration, bounce: t = Lt.bounce, velocity: n = Lt.velocity, mass: r = Lt.mass }) {
  let i, o;
  tl(e <= /* @__PURE__ */ qn(Lt.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let a = 1 - t;
  a = ki(Lt.minDamping, Lt.maxDamping, a), e = ki(Lt.minDuration, Lt.maxDuration, /* @__PURE__ */ Er(e)), a < 1 ? (i = (u) => {
    const c = u * a, f = c * e, d = c - n, p = _v(u, a), h = Math.exp(-f);
    return Dh - d / p * h;
  }, o = (u) => {
    const f = u * a * e, d = f * n + n, p = Math.pow(a, 2) * Math.pow(u, 2) * e, h = Math.exp(-f), m = _v(Math.pow(u, 2), a);
    return (-i(u) + Dh > 0 ? -1 : 1) * ((d - p) * h) / m;
  }) : (i = (u) => {
    const c = Math.exp(-u * e), f = (u - n) * e + 1;
    return -Dh + c * f;
  }, o = (u) => {
    const c = Math.exp(-u * e), f = (n - u) * (e * e);
    return c * f;
  });
  const s = 5 / e, l = r5(i, o, s);
  if (e = /* @__PURE__ */ qn(e), isNaN(l))
    return {
      stiffness: Lt.stiffness,
      damping: Lt.damping,
      duration: e
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: a * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const o5 = ["duration", "bounce"], a5 = ["stiffness", "damping", "mass"];
function A_(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function s5(e) {
  let t = {
    velocity: Lt.velocity,
    stiffness: Lt.stiffness,
    damping: Lt.damping,
    mass: Lt.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!A_(e, a5) && A_(e, o5))
    if (t.velocity = 0, e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, o = 2 * ki(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(i);
      t = {
        ...t,
        mass: Lt.mass,
        stiffness: i,
        damping: o
      };
    } else {
      const n = i5({ ...e, velocity: 0 });
      t = {
        ...t,
        ...n,
        mass: Lt.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Qf(e = Lt.visualDuration, t = Lt.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: i } = n;
  const o = n.keyframes[0], a = n.keyframes[n.keyframes.length - 1], s = { done: !1, value: o }, { stiffness: l, damping: u, mass: c, duration: f, velocity: d, isResolvedFromDuration: p } = s5({
    ...n,
    velocity: -/* @__PURE__ */ Er(n.velocity || 0)
  }), h = d || 0, m = u / (2 * Math.sqrt(l * c)), v = a - o, g = /* @__PURE__ */ Er(Math.sqrt(l / c)), b = Math.abs(v) < 5;
  r || (r = b ? Lt.restSpeed.granular : Lt.restSpeed.default), i || (i = b ? Lt.restDelta.granular : Lt.restDelta.default);
  let E, x, S, $, P, y;
  if (m < 1)
    S = _v(g, m), $ = (h + m * g * v) / S, E = (w) => {
      const A = Math.exp(-m * g * w);
      return a - A * ($ * Math.sin(S * w) + v * Math.cos(S * w));
    }, P = m * g * $ + v * S, y = m * g * v - $ * S, x = (w) => Math.exp(-m * g * w) * (P * Math.sin(S * w) + y * Math.cos(S * w));
  else if (m === 1) {
    E = (A) => a - Math.exp(-g * A) * (v + (h + g * v) * A);
    const w = h + g * v;
    x = (A) => Math.exp(-g * A) * (g * w * A - h);
  } else {
    const w = g * Math.sqrt(m * m - 1);
    E = (I) => {
      const B = Math.exp(-m * g * I), q = Math.min(w * I, 300);
      return a - B * ((h + m * g * v) * Math.sinh(q) + w * v * Math.cosh(q)) / w;
    };
    const A = (h + m * g * v) / w, k = m * g * A - v * w, N = m * g * v - A * w;
    x = (I) => {
      const B = Math.exp(-m * g * I), q = Math.min(w * I, 300);
      return B * (k * Math.sinh(q) + N * Math.cosh(q));
    };
  }
  const _ = {
    calculatedDuration: p && f || null,
    velocity: (w) => /* @__PURE__ */ qn(x(w)),
    next: (w) => {
      if (!p && m < 1) {
        const k = Math.exp(-m * g * w), N = Math.sin(S * w), I = Math.cos(S * w), B = a - k * ($ * N + v * I), q = /* @__PURE__ */ qn(k * (P * N + y * I));
        return s.done = Math.abs(q) <= r && Math.abs(a - B) <= i, s.value = s.done ? a : B, s;
      }
      const A = E(w);
      if (p)
        s.done = w >= f;
      else {
        const k = /* @__PURE__ */ qn(x(w));
        s.done = Math.abs(k) <= r && Math.abs(a - A) <= i;
      }
      return s.value = s.done ? a : A, s;
    },
    toString: () => {
      const w = Math.min(Zy(_), Yf), A = zT((k) => _.next(w * k).value, w, 30);
      return w + "ms " + A;
    },
    toTransition: () => {
    }
  };
  return _;
}
Qf.applyToOptions = (e) => {
  const t = t5(e, 100, Qf);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ qn(t.duration), e.type = "keyframes", e;
};
const l5 = 5;
function LT(e, t, n) {
  const r = Math.max(t - l5, 0);
  return /* @__PURE__ */ bT(n - e(r), t - r);
}
function wv({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: o = 500, modifyTarget: a, min: s, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const f = e[0], d = {
    done: !1,
    value: f
  }, p = (y) => s !== void 0 && y < s || l !== void 0 && y > l, h = (y) => s === void 0 ? l : l === void 0 || Math.abs(s - y) < Math.abs(l - y) ? s : l;
  let m = n * t;
  const v = f + m, g = a === void 0 ? v : a(v);
  g !== v && (m = g - f);
  const b = (y) => -m * Math.exp(-y / r), E = (y) => g + b(y), x = (y) => {
    const _ = b(y), w = E(y);
    d.done = Math.abs(_) <= u, d.value = d.done ? g : w;
  };
  let S, $;
  const P = (y) => {
    p(d.value) && (S = y, $ = Qf({
      keyframes: [d.value, h(d.value)],
      velocity: LT(E, y, d.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: o,
      restDelta: u,
      restSpeed: c
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (y) => {
      let _ = !1;
      return !$ && S === void 0 && (_ = !0, x(y), P(y)), S !== void 0 && y >= S ? $.next(y - S) : (!_ && x(y), d);
    }
  };
}
function u5(e, t, n) {
  const r = [], i = n || $o.mix || FT, o = e.length - 1;
  for (let a = 0; a < o; a++) {
    let s = i(e[a], e[a + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[a] || kr : t;
      s = ec(l, s);
    }
    r.push(s);
  }
  return r;
}
function c5(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  if (Hi(o === t.length, "Both input and output ranges must be the same length", "range-length"), o === 1)
    return () => t[0];
  if (o === 2 && t[0] === t[1])
    return () => t[1];
  const a = e[0] === e[1];
  e[0] > e[o - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const s = u5(t, r, i), l = s.length, u = (c) => {
    if (a && c < e[0])
      return t[0];
    let f = 0;
    if (l > 1)
      for (; f < e.length - 2 && !(c < e[f + 1]); f++)
        ;
    const d = /* @__PURE__ */ Eu(e[f], e[f + 1], c);
    return s[f](d);
  };
  return n ? (c) => u(ki(e[0], e[o - 1], c)) : u;
}
function f5(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = /* @__PURE__ */ Eu(0, t, r);
    e.push(bt(n, 1, i));
  }
}
function d5(e) {
  const t = [0];
  return f5(t, e.length - 1), t;
}
function p5(e, t) {
  return e.map((n) => n * t);
}
function h5(e, t) {
  return e.map(() => t || kT).splice(0, e.length - 1);
}
function us({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = /* @__PURE__ */ EN(r) ? r.map($_) : $_(r), o = {
    done: !1,
    value: t[0]
  }, a = p5(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : d5(t),
    e
  ), s = c5(a, t, {
    ease: Array.isArray(i) ? i : h5(t, i)
  });
  return {
    calculatedDuration: e,
    next: (l) => (o.value = s(l), o.done = l >= e, o)
  };
}
const m5 = (e) => e !== null;
function ip(e, { repeat: t, repeatType: n = "loop" }, r, i = 1) {
  const o = e.filter(m5), s = i < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return !s || r === void 0 ? o[s] : r;
}
const v5 = {
  decay: wv,
  inertia: wv,
  tween: us,
  keyframes: us,
  spring: Qf
};
function VT(e) {
  typeof e.type == "string" && (e.type = v5[e.type]);
}
class Gy {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const g5 = (e) => e / 100;
class Jf extends Gy {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      const { motionValue: n } = this.options;
      n && n.updatedAt !== Mn.now() && this.tick(Mn.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    VT(t);
    const { type: n = us, repeat: r = 0, repeatDelay: i = 0, repeatType: o, velocity: a = 0 } = t;
    let { keyframes: s } = t;
    const l = n || us;
    process.env.NODE_ENV !== "production" && l !== us && Hi(s.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${s}`, "spring-two-frames"), l !== us && typeof s[0] != "number" && (this.mixKeyframes = ec(g5, FT(s[0], s[1])), s = [0, 100]);
    const u = l({ ...t, keyframes: s });
    o === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...s].reverse(),
      velocity: -a
    })), u.calculatedDuration === null && (u.calculatedDuration = Zy(u));
    const { calculatedDuration: c } = u;
    this.calculatedDuration = c, this.resolvedDuration = c + i, this.totalDuration = this.resolvedDuration * (r + 1) - i, this.generator = u;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: i, mixKeyframes: o, mirroredGenerator: a, resolvedDuration: s, calculatedDuration: l } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: u = 0, keyframes: c, repeat: f, repeatType: d, repeatDelay: p, type: h, onUpdate: m, finalKeyframe: v } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - i / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const g = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), b = this.playbackSpeed >= 0 ? g < 0 : g > i;
    this.currentTime = Math.max(g, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let E = this.currentTime, x = r;
    if (f) {
      const y = Math.min(this.currentTime, i) / s;
      let _ = Math.floor(y), w = y % 1;
      !w && y >= 1 && (w = 1), w === 1 && _--, _ = Math.min(_, f + 1), !!(_ % 2) && (d === "reverse" ? (w = 1 - w, p && (w -= p / s)) : d === "mirror" && (x = a)), E = ki(0, 1, w) * s;
    }
    let S;
    b ? (this.delayState.value = c[0], S = this.delayState) : S = x.next(E), o && !b && (S.value = o(S.value));
    let { done: $ } = S;
    !b && l !== null && ($ = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const P = this.holdTime === null && (this.state === "finished" || this.state === "running" && $);
    return P && h !== wv && (S.value = ip(c, this.options, v, this.speed)), m && m(S.value), P && this.finish(), S;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ Er(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Er(t);
  }
  get time() {
    return /* @__PURE__ */ Er(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ qn(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = t, this.tick(t));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const t = this.currentTime;
    if (t <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(t);
    const n = this.generator.next(t).value;
    return LT((r) => this.generator.next(r).value, t, n);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    n && this.driver && this.updateTime(Mn.now()), this.playbackSpeed = t, n && this.driver && (this.time = /* @__PURE__ */ Er(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: t = e5, startTime: n } = this.options;
    this.driver || (this.driver = t((i) => this.tick(i))), this.options.onPlay?.();
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Mn.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), t.observe(this);
  }
}
function y5(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const la = (e) => e * 180 / Math.PI, xv = (e) => {
  const t = la(Math.atan2(e[1], e[0]));
  return Ev(t);
}, b5 = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: xv,
  rotateZ: xv,
  skewX: (e) => la(Math.atan(e[1])),
  skewY: (e) => la(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, Ev = (e) => (e = e % 360, e < 0 && (e += 360), e), C_ = xv, I_ = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), M_ = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), _5 = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: I_,
  scaleY: M_,
  scale: (e) => (I_(e) + M_(e)) / 2,
  rotateX: (e) => Ev(la(Math.atan2(e[6], e[5]))),
  rotateY: (e) => Ev(la(Math.atan2(-e[2], e[0]))),
  rotateZ: C_,
  rotate: C_,
  skewX: (e) => la(Math.atan(e[4])),
  skewY: (e) => la(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function Sv(e) {
  return e.includes("scale") ? 1 : 0;
}
function $v(e, t) {
  if (!e || e === "none")
    return Sv(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (n)
    r = _5, i = n;
  else {
    const s = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = b5, i = s;
  }
  if (!i)
    return Sv(t);
  const o = r[t], a = i[1].split(",").map(x5);
  return typeof o == "function" ? o(a) : a[o];
}
const w5 = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return $v(n, t);
};
function x5(e) {
  return parseFloat(e.trim());
}
const rl = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], il = /* @__PURE__ */ new Set([...rl, "pathRotation"]), R_ = (e) => e === nl || e === Me, E5 = /* @__PURE__ */ new Set(["x", "y", "z"]), S5 = rl.filter((e) => !E5.has(e));
function $5(e) {
  const t = [];
  return S5.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const vo = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0", boxSizing: r }) => {
    const i = e.max - e.min;
    return r === "border-box" ? i : i - parseFloat(t) - parseFloat(n);
  },
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0", boxSizing: r }) => {
    const i = e.max - e.min;
    return r === "border-box" ? i : i - parseFloat(t) - parseFloat(n);
  },
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => $v(t, "x"),
  y: (e, { transform: t }) => $v(t, "y")
};
vo.translateX = vo.x;
vo.translateY = vo.y;
const da = /* @__PURE__ */ new Set();
let Tv = !1, Ov = !1, kv = !1;
function BT() {
  if (Ov) {
    const e = Array.from(da).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = $5(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([o, a]) => {
        r.getValue(o)?.set(a);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  Ov = !1, Tv = !1, da.forEach((e) => e.complete(kv)), da.clear();
}
function KT() {
  da.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (Ov = !0);
  });
}
function T5() {
  kv = !0, KT(), BT(), kv = !1;
}
class Yy {
  constructor(t, n, r, i, o, a = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = o, this.isAsync = a;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (da.add(this), Tv || (Tv = !0, ht.read(KT), ht.resolveKeyframes(BT))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    if (t[0] === null) {
      const o = i?.get(), a = t[t.length - 1];
      if (o !== void 0)
        t[0] = o;
      else if (r && n) {
        const s = r.readValue(n, a);
        s != null && (t[0] = s);
      }
      t[0] === void 0 && (t[0] = a), i && o === void 0 && i.set(t[0]);
    }
    y5(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), da.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (da.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const O5 = (e) => e.startsWith("--");
function UT(e, t, n) {
  O5(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const k5 = {};
function qT(e, t) {
  const n = /* @__PURE__ */ yT(e);
  return () => k5[t] ?? n();
}
const P5 = /* @__PURE__ */ qT(() => window.ScrollTimeline !== void 0, "scrollTimeline"), HT = /* @__PURE__ */ qT(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Hl = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, N_ = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Hl([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Hl([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Hl([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Hl([0.33, 1.53, 0.69, 0.99])
};
function WT(e, t) {
  if (e)
    return typeof e == "function" ? HT() ? zT(e, t) : "ease-out" : /* @__PURE__ */ PT(e) ? Hl(e) : Array.isArray(e) ? e.map((n) => WT(n, t) || N_.easeOut) : N_[e];
}
function D5(e, t, n, { delay: r = 0, duration: i = 300, repeat: o = 0, repeatType: a = "loop", ease: s = "easeOut", times: l } = {}, u = void 0) {
  const c = {
    [t]: n
  };
  l && (c.offset = l);
  const f = WT(s, i);
  Array.isArray(f) && (c.easing = f);
  const d = {
    delay: r,
    duration: i,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: o + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  };
  return u && (d.pseudoElement = u), e.animate(c, d);
}
function ZT(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function A5({ type: e, ...t }) {
  return ZT(e) && HT() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class GT extends Gy {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !t)
      return;
    const { element: n, name: r, keyframes: i, pseudoElement: o, allowFlatten: a = !1, finalKeyframe: s, onComplete: l } = t;
    this.isPseudoElement = !!o, this.allowFlatten = a, this.options = t, Hi(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = A5(t);
    this.animation = D5(n, r, i, u, o), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !o) {
        const c = ip(i, this.options, s, this.speed);
        this.updateMotionValue && this.updateMotionValue(c), UT(n, r, c), this.animation.cancel();
      }
      l?.(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    const t = this.options?.element;
    !this.isPseudoElement && t?.isConnected && this.animation.commitStyles?.();
  }
  get duration() {
    const t = this.animation.effect?.getComputedTiming?.().duration || 0;
    return /* @__PURE__ */ Er(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Er(t);
  }
  get time() {
    return /* @__PURE__ */ Er(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    const n = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ qn(t), n && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(t) {
    this.manualStartTime = this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, rangeStart: n, rangeEnd: r, observe: i }) {
    return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, t && P5() ? (this.animation.timeline = t, n && (this.animation.rangeStart = n), r && (this.animation.rangeEnd = r), kr) : i(this);
  }
}
const YT = {
  anticipate: $T,
  backInOut: ST,
  circInOut: OT
};
function C5(e) {
  return e in YT;
}
function I5(e) {
  typeof e.ease == "string" && C5(e.ease) && (e.ease = YT[e.ease]);
}
const Ah = 10;
class M5 extends GT {
  constructor(t) {
    I5(t), VT(t), super(t), t.startTime !== void 0 && t.autoplay !== !1 && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: i, element: o, ...a } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const s = new Jf({
      ...a,
      autoplay: !1
    }), l = Math.max(Ah, Mn.now() - this.startTime), u = ki(0, Ah, l - Ah), c = s.sample(l).value, { name: f } = this.options;
    o && f && UT(o, f, c), n.setWithVelocity(s.sample(Math.max(0, l - u)).value, c, u), s.stop();
  }
}
const j_ = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(Jr.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function R5(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function N5(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const o = e[e.length - 1], a = j_(i, t), s = j_(o, t);
  return tl(a === s, `You are trying to animate ${t} from "${i}" to "${o}". "${a ? o : i}" is not an animatable value.`, "value-not-animatable"), !a || !s ? !1 : R5(e) || (n === "spring" || ZT(n)) && r;
}
function Pv(e) {
  e.duration = 0, e.type = "keyframes";
}
const QT = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), j5 = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function F5(e) {
  for (let t = 0; t < e.length; t++)
    if (typeof e[t] == "string" && j5.test(e[t]))
      return !0;
  return !1;
}
const z5 = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), L5 = /* @__PURE__ */ yT(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function V5(e) {
  const { motionValue: t, name: n, repeatDelay: r, repeatType: i, damping: o, type: a, keyframes: s } = e;
  if (!(t?.owner?.current instanceof HTMLElement))
    return !1;
  const { onUpdate: u, transformTemplate: c } = t.owner.getProps();
  return L5() && n && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (QT.has(n) || z5.has(n) && F5(s)) && (n !== "transform" || !c) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !u && !r && i !== "mirror" && o !== 0 && a !== "inertia";
}
const B5 = 40;
class K5 extends Gy {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: a = "loop", keyframes: s, name: l, motionValue: u, element: c, ...f }) {
    super(), this.stop = () => {
      this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
    }, this.createdAt = Mn.now();
    const d = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: o,
      repeatType: a,
      name: l,
      motionValue: u,
      element: c,
      ...f
    }, p = c?.KeyframeResolver || Yy;
    this.keyframeResolver = new p(s, (h, m, v) => this.onKeyframesResolved(h, m, d, !v), l, u, c), this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, i) {
    this.keyframeResolver = void 0;
    const { name: o, type: a, velocity: s, delay: l, isHandoff: u, onUpdate: c } = r;
    this.resolvedAt = Mn.now();
    let f = !0;
    N5(t, o, a, s) || (f = !1, ($o.instantAnimations || !l) && c?.(ip(t, r, n)), t[0] = t[t.length - 1], Pv(r), r.repeat = 0);
    const p = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > B5 ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, h = f && !u && V5(p), m = p.motionValue?.owner?.current;
    let v;
    if (h)
      try {
        v = new M5({
          ...p,
          element: m
        });
      } catch {
        v = new Jf(p);
      }
    else
      v = new Jf(p);
    v.finished.then(() => {
      this.notifyFinished();
    }).catch(kr), this.pendingTimeline && (this.stopTimeline = v.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = v;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    return this._animation || (this.keyframeResolver?.resume(), T5()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
function JT(e, t, n, r = 0, i = 1) {
  const o = Array.from(e).sort((u, c) => u.sortNodePosition(c)).indexOf(t), a = e.size, s = (a - 1) * r;
  return typeof n == "function" ? n(o, a) : i === 1 ? o * r : s - o * r;
}
const F_ = 30, U5 = (e) => !isNaN(parseFloat(e));
class q5 {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      const i = Mn.now();
      if (this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Mn.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = U5(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Vy(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Ly());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), ht.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = Mn.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > F_)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, F_);
    return /* @__PURE__ */ bT(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Ms(e, t) {
  return new q5(e, t);
}
function XT(e, t) {
  if (e?.inherit && t) {
    const { inherit: n, ...r } = e;
    return { ...t, ...r };
  }
  return e;
}
function Qy(e, t) {
  const n = e?.[t] ?? e?.default ?? e;
  return n !== e ? XT(n, e) : n;
}
const H5 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, W5 = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Z5 = {
  type: "keyframes",
  duration: 0.8
}, G5 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Y5 = (e, { keyframes: t }) => t.length > 2 ? Z5 : il.has(e) ? e.startsWith("scale") ? W5(t[1]) : H5 : G5, Q5 = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function J5(e) {
  for (const t in e)
    if (!Q5.has(t))
      return !0;
  return !1;
}
const Jy = (e, t, n, r = {}, i, o) => (a) => {
  const s = Qy(r, e) || {}, l = s.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - /* @__PURE__ */ qn(l);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...s,
    delay: -u,
    onUpdate: (d) => {
      t.set(d), s.onUpdate && s.onUpdate(d);
    },
    onComplete: () => {
      a(), s.onComplete && s.onComplete();
    },
    name: e,
    motionValue: t,
    element: o ? void 0 : i
  };
  J5(s) || Object.assign(c, Y5(e, c)), c.duration && (c.duration = /* @__PURE__ */ qn(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ qn(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let f = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (Pv(c), c.delay === 0 && (f = !0)), ($o.instantAnimations || $o.skipAnimations || i?.shouldSkipAnimations || s.skipAnimations) && (f = !0, Pv(c), c.delay = 0), c.allowFlatten = !s.type && !s.ease, f && !o && t.get() !== void 0) {
    const d = ip(c.keyframes, s);
    if (d !== void 0) {
      ht.update(() => {
        c.onUpdate(d), c.onComplete();
      });
      return;
    }
  }
  return s.isSync ? new Jf(c) : new K5(c);
}, X5 = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function ej(e) {
  const t = X5.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
const tj = 4;
function eO(e, t, n = 1) {
  Hi(n <= tj, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, i] = ej(e);
  if (!r)
    return;
  const o = window.getComputedStyle(t).getPropertyValue(r);
  if (o) {
    const a = o.trim();
    return mT(a) ? parseFloat(a) : a;
  }
  return Uy(i) ? eO(i, t, n + 1) : i;
}
function z_(e) {
  const t = [{}, {}];
  return e?.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function Xy(e, t, n, r) {
  if (typeof t == "function") {
    const [i, o] = z_(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, o] = z_(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  return t;
}
function pa(e, t, n) {
  const r = e.getProps();
  return Xy(r, t, n !== void 0 ? n : r.custom, e);
}
const tO = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...rl
]), Dv = (e) => Array.isArray(e);
function nj(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Ms(n));
}
function rj(e) {
  return Dv(e) ? e[e.length - 1] || 0 : e;
}
function ij(e, t) {
  const n = pa(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...o } = n || {};
  o = { ...o, ...r };
  for (const a in o) {
    const s = rj(o[a]);
    nj(e, a, s);
  }
}
const gn = (e) => !!(e && e.getVelocity);
function oj(e) {
  return !!(gn(e) && e.add);
}
function Av(e, t) {
  const n = e.getValue("willChange");
  if (oj(n))
    return n.add(t);
  if (!n && $o.WillChange) {
    const r = new $o.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function eb(e) {
  return e.replace(/([A-Z])/g, (t) => `-${t.toLowerCase()}`);
}
const aj = "framerAppearId", nO = "data-" + eb(aj);
function rO(e) {
  return e.props[nO];
}
function sj({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function iO(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  let { transition: o, transitionEnd: a, ...s } = t;
  const l = e.getDefaultTransition();
  o = o ? XT(o, l) : l;
  const u = o?.reduceMotion, c = o?.skipAnimations;
  r && (o = r);
  const f = [], d = i && e.animationState && e.animationState.getState()[i], p = o?.path;
  p && p.animateVisualElement(e, s, o, n, f);
  for (const h in s) {
    const m = e.getValue(h, e.latestValues[h] ?? null), v = s[h];
    if (v === void 0 || d && sj(d, h))
      continue;
    const g = {
      delay: n,
      ...Qy(o || {}, h)
    };
    c && (g.skipAnimations = !0);
    const b = m.get();
    if (b !== void 0 && !m.isAnimating() && !Array.isArray(v) && v === b && !g.velocity) {
      ht.update(() => m.set(v));
      continue;
    }
    let E = !1;
    if (window.MotionHandoffAnimation) {
      const $ = rO(e);
      if ($) {
        const P = window.MotionHandoffAnimation($, h, ht);
        P !== null && (g.startTime = P, E = !0);
      }
    }
    Av(e, h);
    const x = u ?? e.shouldReduceMotion;
    m.start(Jy(h, m, v, x && tO.has(h) ? { type: !1 } : g, e, E));
    const S = m.animation;
    S && f.push(S);
  }
  if (a) {
    const h = () => ht.update(() => {
      a && ij(e, a);
    });
    f.length ? Promise.all(f).then(h) : h();
  }
  return f;
}
function Cv(e, t, n = {}) {
  const r = pa(e, t, n.type === "exit" ? e.presenceContext?.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (i = n.transitionOverride);
  const o = r ? () => Promise.all(iO(e, r, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (l = 0) => {
    const { delayChildren: u = 0, staggerChildren: c, staggerDirection: f } = i;
    return lj(e, t, l, u, c, f, n);
  } : () => Promise.resolve(), { when: s } = i;
  if (s) {
    const [l, u] = s === "beforeChildren" ? [o, a] : [a, o];
    return l().then(() => u());
  } else
    return Promise.all([o(), a(n.delay)]);
}
function lj(e, t, n = 0, r = 0, i = 0, o = 1, a) {
  const s = [];
  for (const l of e.variantChildren)
    l.notify("AnimationStart", t), s.push(Cv(l, t, {
      ...a,
      delay: n + (typeof r == "function" ? 0 : r) + JT(e.variantChildren, l, r, i, o)
    }).then(() => l.notify("AnimationComplete", t)));
  return Promise.all(s);
}
function uj(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((o) => Cv(e, o, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = Cv(e, t, n);
  else {
    const i = typeof t == "function" ? pa(e, t, n.custom) : t;
    r = Promise.all(iO(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const cj = {
  test: (e) => e === "auto",
  parse: (e) => e
}, oO = (e) => (t) => t.test(e), aO = [nl, Me, $i, Ni, RN, MN, cj], L_ = (e) => aO.find(oO(e));
function fj(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || gT(e) : !0;
}
const dj = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function pj(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(qy) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = dj.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const hj = /\b([a-z-]*)\(.*?\)/gu, Iv = {
  ...Jr,
  getAnimatableNone: (e) => {
    const t = e.match(hj);
    return t ? t.map(pj).join(" ") : e;
  }
}, Mv = {
  ...Jr,
  getAnimatableNone: (e) => {
    const t = Jr.parse(e);
    return Jr.createTransformer(e)(t.map((r) => typeof r == "number" ? 0 : typeof r == "object" ? { ...r, alpha: 1 } : r));
  }
}, V_ = {
  ...nl,
  transform: Math.round
}, mj = {
  rotate: Ni,
  /**
   * Internal channel for `transition.path` orientToPath. Composed onto
   * `rotate` at the transform-build sites so the user's `rotate` is
   * never read or overwritten. Not part of `transformPropOrder`.
   */
  pathRotation: Ni,
  rotateX: Ni,
  rotateY: Ni,
  rotateZ: Ni,
  scale: Cc,
  scaleX: Cc,
  scaleY: Cc,
  scaleZ: Cc,
  skew: Ni,
  skewX: Ni,
  skewY: Ni,
  distance: Me,
  translateX: Me,
  translateY: Me,
  translateZ: Me,
  x: Me,
  y: Me,
  z: Me,
  perspective: Me,
  transformPerspective: Me,
  opacity: Su,
  originX: O_,
  originY: O_,
  originZ: Me
}, Xf = {
  // Border props
  borderWidth: Me,
  borderTopWidth: Me,
  borderRightWidth: Me,
  borderBottomWidth: Me,
  borderLeftWidth: Me,
  borderRadius: Me,
  borderTopLeftRadius: Me,
  borderTopRightRadius: Me,
  borderBottomRightRadius: Me,
  borderBottomLeftRadius: Me,
  // Positioning props
  width: Me,
  maxWidth: Me,
  height: Me,
  maxHeight: Me,
  top: Me,
  right: Me,
  bottom: Me,
  left: Me,
  inset: Me,
  insetBlock: Me,
  insetBlockStart: Me,
  insetBlockEnd: Me,
  insetInline: Me,
  insetInlineStart: Me,
  insetInlineEnd: Me,
  // Spacing props
  padding: Me,
  paddingTop: Me,
  paddingRight: Me,
  paddingBottom: Me,
  paddingLeft: Me,
  paddingBlock: Me,
  paddingBlockStart: Me,
  paddingBlockEnd: Me,
  paddingInline: Me,
  paddingInlineStart: Me,
  paddingInlineEnd: Me,
  margin: Me,
  marginTop: Me,
  marginRight: Me,
  marginBottom: Me,
  marginLeft: Me,
  marginBlock: Me,
  marginBlockStart: Me,
  marginBlockEnd: Me,
  marginInline: Me,
  marginInlineStart: Me,
  marginInlineEnd: Me,
  // Typography
  fontSize: Me,
  // Misc
  backgroundPositionX: Me,
  backgroundPositionY: Me,
  ...mj,
  zIndex: V_,
  // SVG
  fillOpacity: Su,
  strokeOpacity: Su,
  numOctaves: V_
}, vj = {
  ...Xf,
  // Color props
  color: rn,
  backgroundColor: rn,
  outlineColor: rn,
  fill: rn,
  stroke: rn,
  // Border props
  borderColor: rn,
  borderTopColor: rn,
  borderRightColor: rn,
  borderBottomColor: rn,
  borderLeftColor: rn,
  filter: Iv,
  WebkitFilter: Iv,
  mask: Mv,
  WebkitMask: Mv
}, sO = (e) => vj[e], gj = /* @__PURE__ */ new Set([Iv, Mv]);
function lO(e, t) {
  let n = sO(e);
  return gj.has(n) || (n = Jr), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const yj = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function bj(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const o = e[r];
    typeof o == "string" && !yj.has(o) && Is(o).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const o of t)
      e[o] = lO(n, i);
}
class _j extends Yy {
  constructor(t, n, r, i, o) {
    super(t, n, r, i, o, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let c = 0; c < t.length; c++) {
      let f = t[c];
      if (typeof f == "string" && (f = f.trim(), Uy(f))) {
        const d = eO(f, n.current);
        d !== void 0 && (t[c] = d), c === t.length - 1 && (this.finalKeyframe = f);
      }
    }
    if (this.resolveNoneKeyframes(), !tO.has(r) || t.length !== 2)
      return;
    const [i, o] = t, a = L_(i), s = L_(o), l = T_(i), u = T_(o);
    if (l !== u && vo[r]) {
      this.needsMeasurement = !0;
      return;
    }
    if (a !== s)
      if (R_(a) && R_(s))
        for (let c = 0; c < t.length; c++) {
          const f = t[c];
          typeof f == "string" && (t[c] = parseFloat(f));
        }
      else vo[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      (t[i] === null || fj(t[i])) && r.push(i);
    r.length && bj(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = vo[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const i = t.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const o = r.length - 1, a = r[o];
    r[o] = vo[n](t.measureViewportBox(), window.getComputedStyle(t.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), this.removedTransforms?.length && this.removedTransforms.forEach(([s, l]) => {
      t.getValue(s).set(l);
    }), this.resolveNoneKeyframes();
  }
}
function uO(e, t, n) {
  if (e == null)
    return [];
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const i = n?.[e] ?? r.querySelectorAll(e);
    return i ? Array.from(i) : [];
  }
  return Array.from(e).filter((r) => r != null);
}
const Rv = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function mf(e) {
  return vT(e) && "offsetHeight" in e && !("ownerSVGElement" in e);
}
const { schedule: tb } = /* @__PURE__ */ DT(queueMicrotask, !1), Ur = {
  x: !1,
  y: !1
};
function cO() {
  return Ur.x || Ur.y;
}
function wj(e) {
  return e === "x" || e === "y" ? Ur[e] ? null : (Ur[e] = !0, () => {
    Ur[e] = !1;
  }) : Ur.x || Ur.y ? null : (Ur.x = Ur.y = !0, () => {
    Ur.x = Ur.y = !1;
  });
}
function fO(e, t) {
  const n = uO(e), r = new AbortController(), i = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function xj(e) {
  return !(e.pointerType === "touch" || cO());
}
function Ej(e, t, n = {}) {
  const [r, i, o] = fO(e, n);
  return r.forEach((a) => {
    let s = !1, l = !1, u;
    const c = () => {
      a.removeEventListener("pointerleave", h);
    }, f = (v) => {
      u && (u(v), u = void 0), c();
    }, d = (v) => {
      s = !1, window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", d), l && (l = !1, f(v));
    }, p = () => {
      s = !0, window.addEventListener("pointerup", d, i), window.addEventListener("pointercancel", d, i);
    }, h = (v) => {
      if (v.pointerType !== "touch") {
        if (s) {
          l = !0;
          return;
        }
        f(v);
      }
    }, m = (v) => {
      if (!xj(v))
        return;
      l = !1;
      const g = t(a, v);
      typeof g == "function" && (u = g, a.addEventListener("pointerleave", h, i));
    };
    a.addEventListener("pointerenter", m, i), a.addEventListener("pointerdown", p, i);
  }), o;
}
const dO = (e, t) => t ? e === t ? !0 : dO(e, t.parentElement) : !1, nb = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, Sj = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function $j(e) {
  return Sj.has(e.tagName) || e.isContentEditable === !0;
}
const Tj = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function Oj(e) {
  return Tj.has(e.tagName) || e.isContentEditable === !0;
}
const vf = /* @__PURE__ */ new WeakSet();
function B_(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function Ch(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const kj = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = B_(() => {
    if (vf.has(n))
      return;
    Ch(n, "down");
    const i = B_(() => {
      Ch(n, "up");
    }), o = () => Ch(n, "cancel");
    n.addEventListener("keyup", i, t), n.addEventListener("blur", o, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function K_(e) {
  return nb(e) && !cO();
}
const U_ = /* @__PURE__ */ new WeakSet();
function Pj(e, t, n = {}) {
  const [r, i, o] = fO(e, n), a = (s) => {
    const l = s.currentTarget;
    if (!K_(s) || U_.has(s))
      return;
    vf.add(l), n.stopPropagation && U_.add(s);
    const u = t(l, s), c = { ...i, capture: !0 }, f = (h, m) => {
      window.removeEventListener("pointerup", d, c), window.removeEventListener("pointercancel", p, c), vf.has(l) && vf.delete(l), K_(h) && typeof u == "function" && u(h, { success: m });
    }, d = (h) => {
      f(h, l === window || l === document || n.useGlobalTarget || dO(l, h.target));
    }, p = (h) => {
      f(h, !1);
    };
    window.addEventListener("pointerup", d, c), window.addEventListener("pointercancel", p, c);
  };
  return r.forEach((s) => {
    (n.useGlobalTarget ? window : s).addEventListener("pointerdown", a, i), mf(s) && (s.addEventListener("focus", (u) => kj(u, i)), !$j(s) && !s.hasAttribute("tabindex") && (s.tabIndex = 0));
  }), o;
}
function rb(e) {
  return vT(e) && "ownerSVGElement" in e;
}
const gf = /* @__PURE__ */ new WeakMap();
let yf;
const pO = (e, t, n) => (r, i) => i && i[0] ? i[0][e + "Size"] : rb(r) && "getBBox" in r ? r.getBBox()[t] : r[n], Dj = /* @__PURE__ */ pO("inline", "width", "offsetWidth"), Aj = /* @__PURE__ */ pO("block", "height", "offsetHeight");
function Cj({ target: e, borderBoxSize: t }) {
  gf.get(e)?.forEach((n) => {
    n(e, {
      get width() {
        return Dj(e, t);
      },
      get height() {
        return Aj(e, t);
      }
    });
  });
}
function Ij(e) {
  e.forEach(Cj);
}
function Mj() {
  typeof ResizeObserver > "u" || (yf = new ResizeObserver(Ij));
}
function Rj(e, t) {
  yf || Mj();
  const n = uO(e);
  return n.forEach((r) => {
    let i = gf.get(r);
    i || (i = /* @__PURE__ */ new Set(), gf.set(r, i)), i.add(t), yf?.observe(r);
  }), () => {
    n.forEach((r) => {
      const i = gf.get(r);
      i?.delete(t), i?.size || yf?.unobserve(r);
    });
  };
}
const bf = /* @__PURE__ */ new Set();
let cs;
function Nj() {
  cs = () => {
    const e = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    bf.forEach((t) => t(e));
  }, window.addEventListener("resize", cs);
}
function jj(e) {
  return bf.add(e), cs || Nj(), () => {
    bf.delete(e), !bf.size && typeof cs == "function" && (window.removeEventListener("resize", cs), cs = void 0);
  };
}
function q_(e, t) {
  return typeof e == "function" ? jj(e) : Rj(e, t);
}
function Fj(e) {
  return rb(e) && e.tagName === "svg";
}
const zj = [...aO, rn, Jr], Lj = (e) => zj.find(oO(e)), H_ = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), fs = () => ({
  x: H_(),
  y: H_()
}), W_ = () => ({ min: 0, max: 0 }), ln = () => ({
  x: W_(),
  y: W_()
}), Vj = /* @__PURE__ */ new WeakMap();
function op(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function $u(e) {
  return typeof e == "string" || Array.isArray(e);
}
const ib = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], ob = ["initial", ...ib];
function ap(e) {
  return op(e.animate) || ob.some((t) => $u(e[t]));
}
function hO(e) {
  return !!(ap(e) || e.variants);
}
function Bj(e, t, n) {
  for (const r in t) {
    const i = t[r], o = n[r];
    if (gn(i))
      e.addValue(r, i);
    else if (gn(o))
      e.addValue(r, Ms(i, { owner: e }));
    else if (o !== i)
      if (e.hasValue(r)) {
        const a = e.getValue(r);
        a.liveStyle === !0 ? a.jump(i) : a.hasAnimated || a.set(i);
      } else {
        const a = e.getStaticValue(r);
        e.addValue(r, Ms(a !== void 0 ? a : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Nv = { current: null }, mO = { current: !1 }, Kj = typeof window < "u";
function Uj() {
  if (mO.current = !0, !!Kj)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Nv.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      Nv.current = !1;
}
const Z_ = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let ed = {};
function vO(e) {
  ed = e;
}
function qj() {
  return ed;
}
class Hj {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, skipAnimations: o, blockInitialAnimation: a, visualState: s }, l = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Yy, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = Mn.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, ht.render(this.render, !1, !0));
    };
    const { latestValues: u, renderState: c } = s;
    this.latestValues = u, this.baseTarget = { ...u }, this.initialValues = n.initial ? { ...u } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.skipAnimationsConfig = o, this.options = l, this.blockInitialAnimation = !!a, this.isControllingVariants = ap(n), this.isVariantNode = hO(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: f, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const p in d) {
      const h = d[p];
      u[p] !== void 0 && gn(h) && h.set(u[p]);
    }
  }
  mount(t) {
    if (this.hasBeenMounted)
      for (const n in this.initialValues)
        this.values.get(n)?.jump(this.initialValues[n]), this.latestValues[n] = this.initialValues[n];
    this.current = t, Vj.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (mO.current || Uj(), this.shouldReduceMotion = Nv.current), process.env.NODE_ENV !== "production" && Vy(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, this.parent?.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    this.projection && this.projection.unmount(), To(this.notifyUpdate), To(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    if (this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)(), n.accelerate && QT.has(t) && this.current instanceof HTMLElement) {
      const { factory: a, keyframes: s, times: l, ease: u, duration: c } = n.accelerate, f = new GT({
        element: this.current,
        name: t,
        keyframes: s,
        times: l,
        ease: u,
        duration: /* @__PURE__ */ qn(c)
      }), d = a(f);
      this.valueSubscriptions.set(t, () => {
        d(), f.cancel();
      });
      return;
    }
    const r = il.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && ht.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let o;
    typeof window < "u" && window.MotionCheckAppearSync && (o = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      i(), o && o();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in ed) {
      const n = ed[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const o = this.features[t];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ln();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Z_.length; r++) {
      const i = Z_[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const o = "on" + i, a = t[o];
      a && (this.propEventSubscriptions[i] = this.on(i, a));
    }
    this.prevMotionValues = Bj(this, this.scrapeMotionValuesFromProps(t, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Ms(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (mT(r) || gT(r)) ? r = parseFloat(r) : !Lj(r) && Jr.test(n) && (r = lO(t, n)), this.setBaseTarget(t, gn(r) ? r.get() : r)), gn(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const o = Xy(this.props, n, this.presenceContext?.custom);
      o && (r = o[t]);
    }
    if (n && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !gn(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Ly()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    tb.render(this.render);
  }
}
class gO extends Hj {
  constructor() {
    super(...arguments), this.KeyframeResolver = _j;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    const r = t.style;
    return r ? r[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    gn(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class jo {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function yO({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function Wj({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function Zj(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Ih(e) {
  return e === void 0 || e === 1;
}
function jv({ scale: e, scaleX: t, scaleY: n }) {
  return !Ih(e) || !Ih(t) || !Ih(n);
}
function Jo(e) {
  return jv(e) || bO(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function bO(e) {
  return G_(e.x) || G_(e.y);
}
function G_(e) {
  return e && e !== "0%";
}
function td(e, t, n) {
  const r = e - n, i = t * r;
  return n + i;
}
function Y_(e, t, n, r, i) {
  return i !== void 0 && (e = td(e, i, r)), td(e, n, r) + t;
}
function Fv(e, t = 0, n = 1, r, i) {
  e.min = Y_(e.min, t, n, r, i), e.max = Y_(e.max, t, n, r, i);
}
function _O(e, { x: t, y: n }) {
  Fv(e.x, t.translate, t.scale, t.originPoint), Fv(e.y, n.translate, n.scale, n.originPoint);
}
const Q_ = 0.999999999999, J_ = 1.0000000000001;
function Gj(e, t, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  t.x = t.y = 1;
  let o, a;
  for (let s = 0; s < i; s++) {
    o = n[s], a = o.projectionDelta;
    const { visualElement: l } = o.options;
    l && l.props.style && l.props.style.display === "contents" || (r && o.options.layoutScroll && o.scroll && o !== o.root && (bi(e.x, -o.scroll.offset.x), bi(e.y, -o.scroll.offset.y)), a && (t.x *= a.x.scale, t.y *= a.y.scale, _O(e, a)), r && Jo(o.latestValues) && _f(e, o.latestValues, o.layout?.layoutBox));
  }
  t.x < J_ && t.x > Q_ && (t.x = 1), t.y < J_ && t.y > Q_ && (t.y = 1);
}
function bi(e, t) {
  e.min += t, e.max += t;
}
function X_(e, t, n, r, i = 0.5) {
  const o = bt(e.min, e.max, i);
  Fv(e, t, n, o, r);
}
function ew(e, t) {
  return typeof e == "string" ? parseFloat(e) / 100 * (t.max - t.min) : e;
}
function _f(e, t, n) {
  const r = n ?? e;
  X_(e.x, ew(t.x, r.x), t.scaleX, t.scale, t.originX), X_(e.y, ew(t.y, r.y), t.scaleY, t.scale, t.originY);
}
function wO(e, t) {
  return yO(Zj(e.getBoundingClientRect(), t));
}
function Yj(e, t, n) {
  const r = wO(e, n), { scroll: i } = t;
  return i && (bi(r.x, i.offset.x), bi(r.y, i.offset.y)), r;
}
const Qj = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, Jj = rl.length;
function Xj(e, t, n) {
  let r = "", i = !0;
  for (let a = 0; a < Jj; a++) {
    const s = rl[a], l = e[s];
    if (l === void 0)
      continue;
    let u = !0;
    if (typeof l == "number")
      u = l === (s.startsWith("scale") ? 1 : 0);
    else {
      const c = parseFloat(l);
      u = s.startsWith("scale") ? c === 1 : c === 0;
    }
    if (!u || n) {
      const c = Rv(l, Xf[s]);
      if (!u) {
        i = !1;
        const f = Qj[s] || s;
        r += `${f}(${c}) `;
      }
      n && (t[s] = c);
    }
  }
  const o = e.pathRotation;
  return o && (i = !1, r += `rotate(${Rv(o, Xf.pathRotation)}) `), r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function ab(e, t, n) {
  const { style: r, vars: i, transformOrigin: o } = e;
  let a = !1, s = !1;
  for (const l in t) {
    const u = t[l];
    if (il.has(l)) {
      a = !0;
      continue;
    } else if (CT(l)) {
      i[l] = u;
      continue;
    } else {
      const c = Rv(u, Xf[l]);
      l.startsWith("origin") ? (s = !0, o[l] = c) : r[l] = c;
    }
  }
  if (t.transform || (a || n ? r.transform = Xj(t, e.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = o;
    r.transformOrigin = `${l} ${u} ${c}`;
  }
}
function xO(e, { style: t, vars: n }, r, i) {
  const o = e.style;
  let a;
  for (a in t)
    o[a] = t[a];
  i?.applyProjectionStyles(o, r);
  for (a in n)
    o.setProperty(a, n[a]);
}
function tw(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Ml = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Me.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = tw(e, t.target.x), r = tw(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, e8 = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, i = Jr.parse(e);
    if (i.length > 5)
      return r;
    const o = Jr.createTransformer(e), a = typeof i[0] != "number" ? 1 : 0, s = n.x.scale * t.x, l = n.y.scale * t.y;
    i[0 + a] /= s, i[1 + a] /= l;
    const u = bt(s, l, 0.5);
    return typeof i[2 + a] == "number" && (i[2 + a] /= u), typeof i[3 + a] == "number" && (i[3 + a] /= u), o(i);
  }
}, zv = {
  borderRadius: {
    ...Ml,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Ml,
  borderTopRightRadius: Ml,
  borderBottomLeftRadius: Ml,
  borderBottomRightRadius: Ml,
  boxShadow: e8
};
function EO(e, { layout: t, layoutId: n }) {
  return il.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!zv[e] || e === "opacity");
}
function sb(e, t, n) {
  const r = e.style, i = t?.style, o = {};
  if (!r)
    return o;
  for (const a in r)
    (gn(r[a]) || i && gn(i[a]) || EO(a, e) || n?.getValue(a)?.liveStyle !== void 0) && (o[a] = r[a]);
  return o;
}
function t8(e) {
  return window.getComputedStyle(e);
}
class n8 extends gO {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = xO;
  }
  readValueFromInstance(t, n) {
    if (il.has(n))
      return this.projection?.isProjecting ? Sv(n) : w5(t, n);
    {
      const r = t8(t), i = (CT(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return wO(t, n);
  }
  build(t, n, r) {
    ab(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return sb(t, n, r);
  }
}
const r8 = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, i8 = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function o8(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const o = i ? r8 : i8;
  e[o.offset] = `${-r}`, e[o.array] = `${t} ${n}`;
}
const a8 = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function SO(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: i,
  pathSpacing: o = 1,
  pathOffset: a = 0,
  // This is object creation, which we try to avoid per-frame.
  ...s
}, l, u, c) {
  if (ab(e, s, u), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: f, style: d } = e;
  f.transform && (d.transform = f.transform, delete f.transform), (d.transform || f.transformOrigin) && (d.transformOrigin = f.transformOrigin ?? "50% 50%", delete f.transformOrigin), d.transform && (d.transformBox = c?.transformBox ?? "fill-box", delete f.transformBox);
  for (const p of a8)
    f[p] !== void 0 && (d[p] = f[p], delete f[p]);
  t !== void 0 && (f.x = t), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), i !== void 0 && o8(f, i, o, a, !1);
}
const $O = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), TO = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function s8(e, t, n, r) {
  xO(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute($O.has(i) ? i : eb(i), t.attrs[i]);
}
function OO(e, t, n) {
  const r = sb(e, t, n);
  for (const i in e)
    if (gn(e[i]) || gn(t[i])) {
      const o = rl.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[o] = e[i];
    }
  return r;
}
class l8 extends gO {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ln;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (il.has(n)) {
      const r = sO(n);
      return r && r.default || 0;
    }
    return n = $O.has(n) ? n : eb(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return OO(t, n, r);
  }
  build(t, n, r) {
    SO(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, i) {
    s8(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = TO(t.tagName), super.mount(t);
  }
}
const u8 = ob.length;
function kO(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? kO(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < u8; n++) {
    const r = ob[n], i = e.props[r];
    ($u(i) || i === !1) && (t[r] = i);
  }
  return t;
}
function PO(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const c8 = [...ib].reverse(), f8 = ib.length;
function d8(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => uj(e, n, r)));
}
function p8(e) {
  let t = d8(e), n = nw(), r = !0, i = !1;
  const o = (u) => (c, f) => {
    const d = pa(e, f, u === "exit" ? e.presenceContext?.custom : void 0);
    if (d) {
      const { transition: p, transitionEnd: h, ...m } = d;
      c = { ...c, ...m, ...h };
    }
    return c;
  };
  function a(u) {
    t = u(e);
  }
  function s(u) {
    const { props: c } = e, f = kO(e.parent) || {}, d = [], p = /* @__PURE__ */ new Set();
    let h = {}, m = 1 / 0;
    for (let g = 0; g < f8; g++) {
      const b = c8[g], E = n[b], x = c[b] !== void 0 ? c[b] : f[b], S = $u(x), $ = b === u ? E.isActive : null;
      $ === !1 && (m = g);
      let P = x === f[b] && x !== c[b] && S;
      if (P && (r || i) && e.manuallyAnimateOnMount && (P = !1), E.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !E.isActive && $ === null || // If we didn't and don't have any defined prop for this animation type
      !x && !E.prevProp || // Or if the prop doesn't define an animation
      op(x) || typeof x == "boolean")
        continue;
      if (b === "exit" && E.isActive && $ !== !0) {
        E.prevResolvedValues && (h = {
          ...h,
          ...E.prevResolvedValues
        });
        continue;
      }
      const y = h8(E.prevProp, x);
      let _ = y || // If we're making this variant active, we want to always make it active
      b === u && E.isActive && !P && S || // If we removed a higher-priority variant (i is in reverse order)
      g > m && S, w = !1;
      const A = Array.isArray(x) ? x : [x];
      let k = A.reduce(o(b), {});
      $ === !1 && (k = {});
      const { prevResolvedValues: N = {} } = E, I = {
        ...N,
        ...k
      }, B = (re) => {
        _ = !0, p.has(re) && (w = !0, p.delete(re)), E.needsAnimating[re] = !0;
        const Z = e.getValue(re);
        Z && (Z.liveStyle = !1);
      };
      for (const re in I) {
        const Z = k[re], T = N[re];
        if (h.hasOwnProperty(re))
          continue;
        let F = !1;
        Dv(Z) && Dv(T) ? F = !PO(Z, T) || y : F = Z !== T, F ? Z != null ? B(re) : p.add(re) : Z !== void 0 && p.has(re) ? B(re) : E.protectedKeys[re] = !0;
      }
      E.prevProp = x, E.prevResolvedValues = k, E.isActive && (h = { ...h, ...k }), (r || i) && e.blockInitialAnimation && (_ = !1);
      const q = P && y;
      _ && (!q || w) && d.push(...A.map((re) => {
        const Z = { type: b };
        if (typeof re == "string" && (r || i) && !q && e.manuallyAnimateOnMount && e.parent) {
          const { parent: T } = e, F = pa(T, re);
          if (T.enteringChildren && F) {
            const { delayChildren: M } = F.transition || {};
            Z.delay = JT(T.enteringChildren, e, M);
          }
        }
        return {
          animation: re,
          options: Z
        };
      }));
    }
    if (p.size) {
      const g = {};
      if (typeof c.initial != "boolean") {
        const b = pa(e, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        b && b.transition && (g.transition = b.transition);
      }
      p.forEach((b) => {
        const E = e.getBaseTarget(b), x = e.getValue(b);
        x && (x.liveStyle = !0), g[b] = E ?? null;
      }), d.push({ animation: g });
    }
    let v = !!d.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (v = !1), r = !1, i = !1, v ? t(d) : Promise.resolve();
  }
  function l(u, c) {
    if (n[u].isActive === c)
      return Promise.resolve();
    e.variantChildren?.forEach((d) => d.animationState?.setActive(u, c)), n[u].isActive = c;
    const f = s(u);
    for (const d in n)
      n[d].protectedKeys = {};
    return f;
  }
  return {
    animateChanges: s,
    setActive: l,
    setAnimateFunction: a,
    getState: () => n,
    reset: () => {
      n = nw(), i = !0;
    }
  };
}
function h8(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !PO(t, e) : !1;
}
function Go(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function nw() {
  return {
    animate: Go(!0),
    whileInView: Go(),
    whileHover: Go(),
    whileTap: Go(),
    whileDrag: Go(),
    whileFocus: Go(),
    exit: Go()
  };
}
function Lv(e, t) {
  e.min = t.min, e.max = t.max;
}
function Vr(e, t) {
  Lv(e.x, t.x), Lv(e.y, t.y);
}
function rw(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
const DO = 1e-4, m8 = 1 - DO, v8 = 1 + DO, AO = 0.01, g8 = 0 - AO, y8 = 0 + AO;
function Rn(e) {
  return e.max - e.min;
}
function b8(e, t, n) {
  return Math.abs(e - t) <= n;
}
function iw(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = bt(t.min, t.max, e.origin), e.scale = Rn(n) / Rn(t), e.translate = bt(n.min, n.max, e.origin) - e.originPoint, (e.scale >= m8 && e.scale <= v8 || isNaN(e.scale)) && (e.scale = 1), (e.translate >= g8 && e.translate <= y8 || isNaN(e.translate)) && (e.translate = 0);
}
function su(e, t, n, r) {
  iw(e.x, t.x, n.x, r ? r.originX : void 0), iw(e.y, t.y, n.y, r ? r.originY : void 0);
}
function ow(e, t, n, r = 0) {
  const i = r ? bt(n.min, n.max, r) : n.min;
  e.min = i + t.min, e.max = e.min + Rn(t);
}
function _8(e, t, n, r) {
  ow(e.x, t.x, n.x, r?.x), ow(e.y, t.y, n.y, r?.y);
}
function aw(e, t, n, r = 0) {
  const i = r ? bt(n.min, n.max, r) : n.min;
  e.min = t.min - i, e.max = e.min + Rn(t);
}
function nd(e, t, n, r) {
  aw(e.x, t.x, n.x, r?.x), aw(e.y, t.y, n.y, r?.y);
}
function sw(e, t, n, r, i) {
  return e -= t, e = td(e, 1 / n, r), i !== void 0 && (e = td(e, 1 / i, r)), e;
}
function w8(e, t = 0, n = 1, r = 0.5, i, o = e, a = e) {
  if ($i.test(t) && (t = parseFloat(t), t = bt(a.min, a.max, t / 100) - a.min), typeof t != "number")
    return;
  let s = bt(o.min, o.max, r);
  e === o && (s -= t), e.min = sw(e.min, t, n, s, i), e.max = sw(e.max, t, n, s, i);
}
function lw(e, t, [n, r, i], o, a) {
  w8(e, t[n], t[r], t[i], t.scale, o, a);
}
const x8 = ["x", "scaleX", "originX"], E8 = ["y", "scaleY", "originY"];
function uw(e, t, n, r) {
  lw(e.x, t, x8, n ? n.x : void 0, r ? r.x : void 0), lw(e.y, t, E8, n ? n.y : void 0, r ? r.y : void 0);
}
function cw(e) {
  return e.translate === 0 && e.scale === 1;
}
function CO(e) {
  return cw(e.x) && cw(e.y);
}
function fw(e, t) {
  return e.min === t.min && e.max === t.max;
}
function S8(e, t) {
  return fw(e.x, t.x) && fw(e.y, t.y);
}
function dw(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function IO(e, t) {
  return dw(e.x, t.x) && dw(e.y, t.y);
}
function pw(e) {
  return Rn(e.x) / Rn(e.y);
}
function hw(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
function gi(e) {
  return [e("x"), e("y")];
}
function $8(e, t, n) {
  let r = "";
  const i = e.x.translate / t.x, o = e.y.translate / t.y, a = n?.z || 0;
  if ((i || o || a) && (r = `translate3d(${i}px, ${o}px, ${a}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: u, rotate: c, pathRotation: f, rotateX: d, rotateY: p, skewX: h, skewY: m } = n;
    u && (r = `perspective(${u}px) ${r}`), c && (r += `rotate(${c}deg) `), f && (r += `rotate(${f}deg) `), d && (r += `rotateX(${d}deg) `), p && (r += `rotateY(${p}deg) `), h && (r += `skewX(${h}deg) `), m && (r += `skewY(${m}deg) `);
  }
  const s = e.x.scale * t.x, l = e.y.scale * t.y;
  return (s !== 1 || l !== 1) && (r += `scale(${s}, ${l})`), r || "none";
}
const MO = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomLeftRadius",
  "borderBottomRightRadius"
], T8 = MO.length, mw = (e) => typeof e == "string" ? parseFloat(e) : e, vw = (e) => typeof e == "number" || Me.test(e);
function O8(e, t, n, r, i, o) {
  i ? (e.opacity = bt(0, n.opacity ?? 1, k8(r)), e.opacityExit = bt(t.opacity ?? 1, 0, P8(r))) : o && (e.opacity = bt(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let a = 0; a < T8; a++) {
    const s = MO[a];
    let l = gw(t, s), u = gw(n, s);
    if (l === void 0 && u === void 0)
      continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || vw(l) === vw(u) ? (e[s] = Math.max(bt(mw(l), mw(u), r), 0), ($i.test(u) || $i.test(l)) && (e[s] += "%")) : e[s] = u;
  }
  (t.rotate || n.rotate) && (e.rotate = bt(t.rotate || 0, n.rotate || 0, r));
}
function gw(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const k8 = /* @__PURE__ */ RO(0, 0.5, TT), P8 = /* @__PURE__ */ RO(0.5, 0.95, kr);
function RO(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ Eu(e, t, r));
}
function D8(e, t, n) {
  const r = gn(e) ? e : Ms(e);
  return r.start(Jy("", r, t, n)), r.animation;
}
function Tu(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r);
}
const A8 = (e, t) => e.depth - t.depth;
class C8 {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    zy(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Zf(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(A8), this.isDirty = !1, this.children.forEach(t);
  }
}
function I8(e, t) {
  const n = Mn.now(), r = ({ timestamp: i }) => {
    const o = i - n;
    o >= t && (To(r), e(o - t));
  };
  return ht.setup(r, !0), () => To(r);
}
function wf(e) {
  return gn(e) ? e.get() : e;
}
class M8 {
  constructor() {
    this.members = [];
  }
  add(t) {
    zy(this.members, t);
    for (let n = this.members.length - 1; n >= 0; n--) {
      const r = this.members[n];
      if (r === t || r === this.lead || r === this.prevLead)
        continue;
      const i = r.instance;
      (!i || i.isConnected === !1) && !r.snapshot && (Zf(this.members, r), r.unmount());
    }
    t.scheduleRender();
  }
  remove(t) {
    if (Zf(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    for (let n = this.members.indexOf(t) - 1; n >= 0; n--) {
      const r = this.members[n];
      if (r.isPresent !== !1 && r.instance?.isConnected !== !1)
        return this.promote(r), !0;
    }
    return !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.updateSnapshot(), t.scheduleRender();
      const { layoutDependency: i } = r.options, { layoutDependency: o } = t.options;
      (i === void 0 || i !== o) && (t.resumeFrom = r, n && (r.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root?.isUpdating && (t.isLayoutDirty = !0)), t.options.crossfade === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      t.options.onExitComplete?.(), t.resumingFrom?.options.onExitComplete?.();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => t.instance && t.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    this.lead?.snapshot && (this.lead.snapshot = void 0);
  }
}
const xf = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, Mh = ["", "X", "Y", "Z"], R8 = 1e3;
let N8 = 0;
function Rh(e, t, n, r) {
  const { latestValues: i } = t;
  i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function NO(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = rO(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: o } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", ht, !(i || o));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && NO(r);
}
function jO({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(a = {}, s = t?.()) {
      this.id = N8++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(z8), this.nodes.forEach(q8), this.nodes.forEach(H8), this.nodes.forEach(L8);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = s ? s.root || s : this, this.path = s ? [...s.path, s] : [], this.parent = s, this.depth = s ? s.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new C8());
    }
    addEventListener(a, s) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new Ly()), this.eventHandlers.get(a).add(s);
    }
    notifyListeners(a, ...s) {
      const l = this.eventHandlers.get(a);
      l && l.notify(...s);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a) {
      if (this.instance)
        return;
      this.isSVG = rb(a) && !Fj(a), this.instance = a;
      const { layoutId: s, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || s) && (this.isLayoutDirty = !0), e) {
        let c, f = 0;
        const d = () => this.root.updateBlockedByResize = !1;
        ht.read(() => {
          f = window.innerWidth;
        }), e(a, () => {
          const p = window.innerWidth;
          p !== f && (f = p, this.root.updateBlockedByResize = !0, c && c(), c = I8(d, 250), xf.hasAnimatedSinceResize && (xf.hasAnimatedSinceResize = !1, this.nodes.forEach(_w)));
        });
      }
      s && this.root.registerSharedNode(s, this), this.options.animate !== !1 && u && (s || l) && this.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: f, hasRelativeLayoutChanged: d, layout: p }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const h = this.options.transition || u.getDefaultTransition() || Q8, { onLayoutAnimationStart: m, onLayoutAnimationComplete: v } = u.getProps(), g = !this.targetLayout || !IO(this.targetLayout, p), b = !f && d;
        if (this.options.layoutRoot || this.resumeFrom || b || f && (g || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const E = {
            ...Qy(h, "layout"),
            onPlay: m,
            onComplete: v
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (E.delay = 0, E.type = !1), this.startAnimation(E), this.setAnimationOrigin(c, b, E.path);
        } else
          f || _w(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = p;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), To(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(W8), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && NO(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c];
        f.shouldResetTransform = !0, (typeof f.latestValues.x == "string" || typeof f.latestValues.y == "string") && (f.isLayoutDirty = !0), f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: s, layout: l } = this.options;
      if (s === void 0 && !l)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const l = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), l && this.nodes.forEach(B8), this.nodes.forEach(yw);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(bw);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(K8), this.nodes.forEach(U8), this.nodes.forEach(j8), this.nodes.forEach(F8)) : this.nodes.forEach(bw), this.clearAllSnapshots();
      const s = Mn.now();
      vn.delta = ki(0, 1e3 / 60, s - vn.timestamp), vn.timestamp = s, vn.isProcessing = !0, Th.update.process(vn), Th.preRender.process(vn), Th.render.process(vn), vn.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, tb.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(V8), this.sharedNodes.forEach(Z8);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, ht.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      ht.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Rn(this.snapshot.measuredBox.x) && !Rn(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = ln()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (s = !1), s && this.instance) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: a,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, s = this.projectionDelta && !CO(this.projectionDelta), l = this.getTransformTemplate(), u = l ? l(this.latestValues, "") : void 0, c = u !== this.prevTransformTemplateValue;
      a && this.instance && (s || Jo(this.latestValues) || c) && (i(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const s = this.measurePageBox();
      let l = this.removeElementScroll(s);
      return a && (l = this.removeTransform(l)), J8(l), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: a } = this.options;
      if (!a)
        return ln();
      const s = a.measureViewportBox();
      if (!(this.scroll?.wasRoot || this.path.some(X8))) {
        const { scroll: u } = this.root;
        u && (bi(s.x, u.offset.x), bi(s.y, u.offset.y));
      }
      return s;
    }
    removeElementScroll(a) {
      const s = ln();
      if (Vr(s, a), this.scroll?.wasRoot)
        return s;
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l], { scroll: c, options: f } = u;
        u !== this.root && c && f.layoutScroll && (c.wasRoot && Vr(s, a), bi(s.x, c.offset.x), bi(s.y, c.offset.y));
      }
      return s;
    }
    applyTransform(a, s = !1, l) {
      const u = l || ln();
      Vr(u, a);
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c];
        !s && f.options.layoutScroll && f.scroll && f !== f.root && (bi(u.x, -f.scroll.offset.x), bi(u.y, -f.scroll.offset.y)), Jo(f.latestValues) && _f(u, f.latestValues, f.layout?.layoutBox);
      }
      return Jo(this.latestValues) && _f(u, this.latestValues, this.layout?.layoutBox), u;
    }
    removeTransform(a) {
      const s = ln();
      Vr(s, a);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        if (!Jo(u.latestValues))
          continue;
        let c;
        u.instance && (jv(u.latestValues) && u.updateSnapshot(), c = ln(), Vr(c, u.measurePageBox())), uw(s, u.latestValues, u.snapshot?.layoutBox, c);
      }
      return Jo(this.latestValues) && uw(s, this.latestValues), s;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== vn.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      const s = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = s.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = s.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = s.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== s;
      if (!(a || l && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: f } = this.options;
      if (!this.layout || !(c || f))
        return;
      this.resolvedRelativeTargetAt = vn.timestamp;
      const d = this.getClosestProjectingParent();
      d && this.linkedParentVersion !== d.layoutVersion && !d.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && d && d.layout ? this.createRelativeTarget(d, this.layout.layoutBox, d.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = ln(), this.targetWithTransforms = ln()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), _8(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : Vr(this.target, this.layout.layoutBox), _O(this.target, this.targetDelta)) : Vr(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && d && !!d.resumingFrom == !!this.resumingFrom && !d.options.layoutScroll && d.target && this.animationProgress !== 1 ? this.createRelativeTarget(d, this.target, d.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || jv(this.parent.latestValues) || bO(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(a, s, l) {
      this.relativeParent = a, this.linkedParentVersion = a.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ln(), this.relativeTargetOrigin = ln(), nd(this.relativeTargetOrigin, s, l, this.options.layoutAnchor || void 0), Vr(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      const a = this.getLead(), s = !!this.resumingFrom || this !== a;
      let l = !0;
      if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (l = !1), s && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === vn.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: c } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || c))
        return;
      Vr(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, d = this.treeScale.y;
      Gj(this.layoutCorrected, this.treeScale, this.path, s), a.layout && !a.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (a.target = a.layout.layoutBox, a.targetWithTransforms = ln());
      const { target: p } = a;
      if (!p) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (rw(this.prevProjectionDelta.x, this.projectionDelta.x), rw(this.prevProjectionDelta.y, this.projectionDelta.y)), su(this.projectionDelta, this.layoutCorrected, p, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== d || !hw(this.projectionDelta.x, this.prevProjectionDelta.x) || !hw(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", p));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      if (this.options.visualElement?.scheduleRender(), a) {
        const s = this.getStack();
        s && s.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = fs(), this.projectionDelta = fs(), this.projectionDeltaWithTransform = fs();
    }
    setAnimationOrigin(a, s = !1, l) {
      const u = this.snapshot, c = u ? u.latestValues : {}, f = { ...this.latestValues }, d = fs();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const p = ln(), h = u ? u.source : void 0, m = this.layout ? this.layout.source : void 0, v = h !== m, g = this.getStack(), b = !g || g.members.length <= 1, E = !!(v && !b && this.options.crossfade === !0 && !this.path.some(Y8));
      this.animationProgress = 0;
      let x;
      const S = l?.interpolateProjection(a);
      this.mixTargetDelta = ($) => {
        const P = $ / 1e3, y = S?.(P);
        y ? (d.x.translate = y.x, d.x.scale = bt(a.x.scale, 1, P), d.x.origin = a.x.origin, d.x.originPoint = a.x.originPoint, d.y.translate = y.y, d.y.scale = bt(a.y.scale, 1, P), d.y.origin = a.y.origin, d.y.originPoint = a.y.originPoint) : (ww(d.x, a.x, P), ww(d.y, a.y, P)), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (nd(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), G8(this.relativeTarget, this.relativeTargetOrigin, p, P), x && S8(this.relativeTarget, x) && (this.isProjectionDirty = !1), x || (x = ln()), Vr(x, this.relativeTarget)), v && (this.animationValues = f, O8(f, c, this.latestValues, P, E, b)), y && y.rotate !== void 0 && (this.animationValues || (this.animationValues = f), this.animationValues.pathRotation = y.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = P;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation && (To(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ht.update(() => {
        xf.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Ms(0)), this.motionValue.jump(0, !1), this.currentAnimation = D8(this.motionValue, [0, 1e3], {
          ...a,
          velocity: 0,
          isSync: !0,
          onUpdate: (s) => {
            this.mixTargetDelta(s), a.onUpdate && a.onUpdate(s);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(R8), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: s, target: l, layout: u, latestValues: c } = a;
      if (!(!s || !l || !u)) {
        if (this !== a && this.layout && u && FO(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || ln();
          const f = Rn(this.layout.layoutBox.x);
          l.x.min = a.target.x.min, l.x.max = l.x.min + f;
          const d = Rn(this.layout.layoutBox.y);
          l.y.min = a.target.y.min, l.y.max = l.y.min + d;
        }
        Vr(s, l), _f(s, c), su(this.projectionDeltaWithTransform, this.layoutCorrected, s, c);
      }
    }
    registerSharedNode(a, s) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new M8()), this.sharedNodes.get(a).add(s);
      const u = s.options.initialPromotionConfig;
      s.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      const { layoutId: a } = this.options;
      return a ? this.getStack()?.lead || this : this;
    }
    getPrevLead() {
      const { layoutId: a } = this.options;
      return a ? this.getStack()?.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: s, preserveFollowOpacity: l } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), a && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let s = !1;
      const { latestValues: l } = a;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (s = !0), !s)
        return;
      const u = {};
      l.z && Rh("z", a, u, this.animationValues);
      for (let c = 0; c < Mh.length; c++)
        Rh(`rotate${Mh[c]}`, a, u, this.animationValues), Rh(`skew${Mh[c]}`, a, u, this.animationValues);
      a.render();
      for (const c in u)
        a.setStaticValue(c, u[c]), this.animationValues && (this.animationValues[c] = u[c]);
      a.scheduleRender();
    }
    applyProjectionStyles(a, s) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        a.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, a.visibility = "", a.opacity = "", a.pointerEvents = wf(s?.pointerEvents) || "", a.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (a.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, a.pointerEvents = wf(s?.pointerEvents) || ""), this.hasProjected && !Jo(this.latestValues) && (a.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      a.visibility = "";
      const c = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let f = $8(this.projectionDeltaWithTransform, this.treeScale, c);
      l && (f = l(c, f)), a.transform = f;
      const { x: d, y: p } = this.projectionDelta;
      a.transformOrigin = `${d.origin * 100}% ${p.origin * 100}% 0`, u.animationValues ? a.opacity = u === this ? c.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : a.opacity = u === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const h in zv) {
        if (c[h] === void 0)
          continue;
        const { correct: m, applyTo: v, isCSSVariable: g } = zv[h], b = f === "none" ? c[h] : m(c[h], u);
        if (v) {
          const E = v.length;
          for (let x = 0; x < E; x++)
            a[v[x]] = b;
        } else
          g ? this.options.visualElement.renderState.vars[h] = b : a[h] = b;
      }
      this.options.layoutId && (a.pointerEvents = u === this ? wf(s?.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => a.currentAnimation?.stop()), this.root.nodes.forEach(yw), this.root.sharedNodes.clear();
    }
  };
}
function j8(e) {
  e.updateLayout();
}
function F8(e) {
  const t = e.resumeFrom?.snapshot || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: n, measuredBox: r } = e.layout, { animationType: i } = e.options, o = t.source !== e.layout.source;
    if (i === "size")
      gi((c) => {
        const f = o ? t.measuredBox[c] : t.layoutBox[c], d = Rn(f);
        f.min = n[c].min, f.max = f.min + d;
      });
    else if (i === "x" || i === "y") {
      const c = i === "x" ? "y" : "x";
      Lv(o ? t.measuredBox[c] : t.layoutBox[c], n[c]);
    } else FO(i, t.layoutBox, n) && gi((c) => {
      const f = o ? t.measuredBox[c] : t.layoutBox[c], d = Rn(n[c]);
      f.max = f.min + d, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[c].max = e.relativeTarget[c].min + d);
    });
    const a = fs();
    su(a, n, t.layoutBox);
    const s = fs();
    o ? su(s, e.applyTransform(r, !0), t.measuredBox) : su(s, n, t.layoutBox);
    const l = !CO(a);
    let u = !1;
    if (!e.resumeFrom) {
      const c = e.getClosestProjectingParent();
      if (c && !c.resumeFrom) {
        const { snapshot: f, layout: d } = c;
        if (f && d) {
          const p = e.options.layoutAnchor || void 0, h = ln();
          nd(h, t.layoutBox, f.layoutBox, p);
          const m = ln();
          nd(m, n, d.layoutBox, p), IO(h, m) || (u = !0), c.options.layoutRoot && (e.relativeTarget = m, e.relativeTargetOrigin = h, e.relativeParent = c);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: n,
      snapshot: t,
      delta: s,
      layoutDelta: a,
      hasLayoutChanged: l,
      hasRelativeLayoutChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: n } = e.options;
    n && n();
  }
  e.options.transition = void 0;
}
function z8(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function L8(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function V8(e) {
  e.clearSnapshot();
}
function yw(e) {
  e.clearMeasurements();
}
function B8(e) {
  e.isLayoutDirty = !0, e.updateLayout();
}
function bw(e) {
  e.isLayoutDirty = !1;
}
function K8(e) {
  e.isAnimationBlocked && e.layout && !e.isLayoutDirty && (e.snapshot = e.layout, e.isLayoutDirty = !0);
}
function U8(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function _w(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function q8(e) {
  e.resolveTargetDelta();
}
function H8(e) {
  e.calcProjection();
}
function W8(e) {
  e.resetSkewAndRotation();
}
function Z8(e) {
  e.removeLeadSnapshot();
}
function ww(e, t, n) {
  e.translate = bt(t.translate, 0, n), e.scale = bt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function xw(e, t, n, r) {
  e.min = bt(t.min, n.min, r), e.max = bt(t.max, n.max, r);
}
function G8(e, t, n, r) {
  xw(e.x, t.x, n.x, r), xw(e.y, t.y, n.y, r);
}
function Y8(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const Q8 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Ew = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Sw = Ew("applewebkit/") && !Ew("chrome/") ? Math.round : kr;
function $w(e) {
  e.min = Sw(e.min), e.max = Sw(e.max);
}
function J8(e) {
  $w(e.x), $w(e.y);
}
function FO(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !b8(pw(t), pw(n), 0.2);
}
function X8(e) {
  return e !== e.root && e.scroll?.wasRoot;
}
const eF = jO({
  attachResizeListener: (e, t) => Tu(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
    y: document.documentElement.scrollTop || document.body?.scrollTop || 0
  }),
  checkIsScrollRoot: () => !0
}), tF = (e) => !e.isLayoutDirty && e.willUpdate(!1);
function Tw() {
  const e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new WeakMap(), n = () => e.forEach(tF);
  return {
    add: (r) => {
      e.add(r), t.set(r, r.addEventListener("willUpdate", n));
    },
    remove: (r) => {
      e.delete(r);
      const i = t.get(r);
      i && (i(), t.delete(r)), n();
    },
    dirty: n
  };
}
const Nh = {
  current: void 0
}, zO = jO({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Nh.current) {
      const e = new eF({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Nh.current = e;
    }
    return Nh.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), lb = Le({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function Ow(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function nF(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = Ow(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : Ow(e[i], null);
        }
      };
  };
}
function rF(...e) {
  return ue.useCallback(nF(...e), e);
}
class iF extends ue.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (mf(n) && t.isPresent && !this.props.isPresent && this.props.pop !== !1) {
      const r = n.offsetParent, i = mf(r) && r.offsetWidth || 0, o = mf(r) && r.offsetHeight || 0, a = getComputedStyle(n), s = this.props.sizeRef.current;
      s.height = parseFloat(a.height), s.width = parseFloat(a.width), s.top = n.offsetTop, s.left = n.offsetLeft, s.right = i - s.width - s.left, s.bottom = o - s.height - s.top, s.direction = a.direction;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function oF({ children: e, isPresent: t, anchorX: n, anchorY: r, root: i, pop: o }) {
  const a = yy(), s = ve(null), l = ve({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    direction: "ltr"
  }), { nonce: u } = Ce(lb), c = e.props?.ref ?? e?.ref, f = rF(s, c);
  return by(() => {
    const { width: d, height: p, top: h, left: m, right: v, bottom: g, direction: b } = l.current;
    if (t || o === !1 || !s.current || !d || !p)
      return;
    const E = b === "rtl", x = n === "left" ? E ? `right: ${v}` : `left: ${m}` : E ? `left: ${m}` : `right: ${v}`, S = r === "bottom" ? `bottom: ${g}` : `top: ${h}`;
    s.current.dataset.motionPopId = a;
    const $ = document.createElement("style");
    u && ($.nonce = u);
    const P = i ?? document.head;
    return P.appendChild($), $.sheet && $.sheet.insertRule(`
          [data-motion-pop-id="${a}"] {
            position: absolute !important;
            width: ${d}px !important;
            height: ${p}px !important;
            ${x}px !important;
            ${S}px !important;
          }
        `), () => {
      s.current?.removeAttribute("data-motion-pop-id"), P.contains($) && P.removeChild($);
    };
  }, [t]), R.jsx(iF, { isPresent: t, childRef: s, sizeRef: l, pop: o, children: o === !1 ? e : ue.cloneElement(e, { ref: f }) });
}
const aF = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: o, mode: a, anchorX: s, anchorY: l, root: u }) => {
  const c = Fy(sF), f = yy(), d = ve(n), p = ve(r);
  np(() => {
    d.current = n, p.current = r;
  });
  let h = !0, m = Ee(() => (h = !1, {
    id: f,
    initial: t,
    isPresent: n,
    custom: i,
    onExitComplete: (v) => {
      c.set(v, !0);
      for (const g of c.values())
        if (!g)
          return;
      r && r();
    },
    register: (v) => (c.set(v, !1), () => {
      c.delete(v), !d.current && !c.size && p.current?.();
    })
  }), [n, c, r]);
  return o && h && (m = { ...m }), Ee(() => {
    c.forEach((v, g) => c.set(g, !1));
  }, [n]), ue.useEffect(() => {
    !n && !c.size && r && r();
  }, [n]), e = R.jsx(oF, { pop: a === "popLayout", isPresent: n, anchorX: s, anchorY: l, root: u, children: e }), R.jsx(rp.Provider, { value: m, children: e });
};
function sF() {
  return /* @__PURE__ */ new Map();
}
function LO(e = !0) {
  const t = Ce(rp);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: i } = t, o = yy();
  De(() => {
    if (e)
      return i(o);
  }, [e]);
  const a = Ne(() => e && r && r(o), [o, r, e]);
  return !n && r ? [!1, a] : [!0];
}
const Ic = (e) => e.key || "";
function kw(e) {
  const t = [];
  return X3.forEach(e, (n) => {
    _y(n) && t.push(n);
  }), t;
}
const Vv = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, presenceAffectsLayout: i = !0, mode: o = "sync", propagate: a = !1, anchorX: s = "left", anchorY: l = "top", root: u }) => {
  const [c, f] = LO(a), d = Ee(() => kw(e), [e]), p = a && !c ? [] : d.map(Ic), h = ve(!0), m = ve(d), v = Fy(() => /* @__PURE__ */ new Map()), g = ve(/* @__PURE__ */ new Set()), [b, E] = je(d), [x, S] = je(d);
  np(() => {
    h.current = !1, m.current = d;
    for (let y = 0; y < x.length; y++) {
      const _ = Ic(x[y]);
      p.includes(_) ? (v.delete(_), g.current.delete(_)) : v.get(_) !== !0 && v.set(_, !1);
    }
  }, [x, p.length, p.join("-")]);
  const $ = [];
  if (d !== b) {
    let y = [...d];
    for (let _ = 0; _ < x.length; _++) {
      const w = x[_], A = Ic(w);
      p.includes(A) || (y.splice(_, 0, w), $.push(w));
    }
    return o === "wait" && $.length && (y = $), S(kw(y)), E(d), null;
  }
  process.env.NODE_ENV !== "production" && o === "wait" && x.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: P } = Ce(xu);
  return R.jsx(R.Fragment, { children: x.map((y) => {
    const _ = Ic(y), w = a && !c ? !1 : d === x || p.includes(_), A = () => {
      if (g.current.has(_))
        return;
      if (v.has(_))
        g.current.add(_), v.set(_, !0);
      else
        return;
      let k = !0;
      v.forEach((N) => {
        N || (k = !1);
      }), k && (P?.(), S(m.current), a && f?.(), r && r());
    };
    return R.jsx(aF, { isPresent: w, initial: !h.current || n ? void 0 : !1, custom: t, presenceAffectsLayout: i, mode: o, root: u, onExitComplete: w ? void 0 : A, anchorX: s, anchorY: l, children: y }, _);
  }) });
}, lF = Le(null);
function uF() {
  const e = ve(!1);
  return np(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function cF() {
  const e = uF(), [t, n] = je(0), r = Ne(() => {
    e.current && n(t + 1);
  }, [t]);
  return [Ne(() => ht.postRender(r), [r]), t];
}
const VO = (e) => e === !0, fF = (e) => VO(e === !0) || e === "id", dF = ({ children: e, id: t, inherit: n = !0 }) => {
  const r = Ce(xu), i = Ce(lF), [o, a] = cF(), s = ve(null), l = r.id || i;
  s.current === null && (fF(n) && l && (t = t ? l + "-" + t : l), s.current = {
    id: t,
    group: VO(n) && r.group || Tw()
  });
  const u = Ee(() => ({ ...s.current, forceRender: o }), [a]);
  return R.jsx(xu.Provider, { value: u, children: e });
}, BO = Le({ strict: !1 }), Pw = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let Dw = !1;
function pF() {
  if (Dw)
    return;
  const e = {};
  for (const t in Pw)
    e[t] = {
      isEnabled: (n) => Pw[t].some((r) => !!n[r])
    };
  vO(e), Dw = !0;
}
function KO() {
  return pF(), qj();
}
function hF(e) {
  const t = KO();
  for (const n in e)
    t[n] = {
      ...t[n],
      ...e[n]
    };
  vO(t);
}
const mF = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function rd(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || mF.has(e);
}
let UO = (e) => !rd(e);
function vF(e) {
  typeof e == "function" && (UO = (t) => t.startsWith("on") ? !rd(t) : e(t));
}
try {
  vF(require("@emotion/is-prop-valid").default);
} catch {
}
function gF(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || gn(e[i]) || (UO(i) || n === !0 && rd(i) || !t && !rd(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
const sp = /* @__PURE__ */ Le({});
function yF(e, t) {
  if (ap(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || $u(n) ? n : void 0,
      animate: $u(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function bF(e) {
  const { initial: t, animate: n } = yF(e, Ce(sp));
  return Ee(() => ({ initial: t, animate: n }), [Aw(t), Aw(n)]);
}
function Aw(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const ub = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function qO(e, t, n) {
  for (const r in t)
    !gn(t[r]) && !EO(r, n) && (e[r] = t[r]);
}
function _F({ transformTemplate: e }, t) {
  return Ee(() => {
    const n = ub();
    return ab(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function wF(e, t) {
  const n = e.style || {}, r = {};
  return qO(r, n, e), Object.assign(r, _F(e, t)), r;
}
function xF(e, t) {
  const n = {}, r = wF(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const HO = () => ({
  ...ub(),
  attrs: {}
});
function EF(e, t, n, r) {
  const i = Ee(() => {
    const o = HO();
    return SO(o, t, TO(r), e.transformTemplate, e.style), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [t]);
  if (e.style) {
    const o = {};
    qO(o, e.style, e), i.style = { ...o, ...i.style };
  }
  return i;
}
const SF = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function cb(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(SF.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function $F(e, t, n, { latestValues: r }, i, o = !1, a) {
  const l = (a ?? cb(e) ? EF : xF)(t, r, i, e), u = gF(t, typeof e == "string", o), c = e !== wy ? { ...u, ...l, ref: n } : {}, { children: f } = t, d = Ee(() => gn(f) ? f.get() : f, [f]);
  return e6(e, {
    ...c,
    children: d
  });
}
function TF({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, i) {
  return {
    latestValues: OF(n, r, i, e),
    renderState: t()
  };
}
function OF(e, t, n, r) {
  const i = {}, o = r(e, {});
  for (const d in o)
    i[d] = wf(o[d]);
  let { initial: a, animate: s } = e;
  const l = ap(e), u = hO(e);
  t && u && !l && e.inherit !== !1 && (a === void 0 && (a = t.initial), s === void 0 && (s = t.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || a === !1;
  const f = c ? s : a;
  if (f && typeof f != "boolean" && !op(f)) {
    const d = Array.isArray(f) ? f : [f];
    for (let p = 0; p < d.length; p++) {
      const h = Xy(e, d[p]);
      if (h) {
        const { transitionEnd: m, transition: v, ...g } = h;
        for (const b in g) {
          let E = g[b];
          if (Array.isArray(E)) {
            const x = c ? E.length - 1 : 0;
            E = E[x];
          }
          E !== null && (i[b] = E);
        }
        for (const b in m)
          i[b] = m[b];
      }
    }
  }
  return i;
}
const WO = (e) => (t, n) => {
  const r = Ce(sp), i = Ce(rp), o = () => TF(e, t, r, i);
  return n ? o() : Fy(o);
}, kF = /* @__PURE__ */ WO({
  scrapeMotionValuesFromProps: sb,
  createRenderState: ub
}), PF = /* @__PURE__ */ WO({
  scrapeMotionValuesFromProps: OO,
  createRenderState: HO
}), DF = Symbol.for("motionComponentSymbol");
function AF(e, t, n) {
  const r = ve(n);
  by(() => {
    r.current = n;
  });
  const i = ve(null);
  return Ne((o) => {
    o && e.onMount?.(o), t && (o ? t.mount(o) : t.unmount());
    const a = r.current;
    if (typeof a == "function")
      if (o) {
        const s = a(o);
        typeof s == "function" && (i.current = s);
      } else i.current ? (i.current(), i.current = null) : a(o);
    else a && (a.current = o);
  }, [t]);
}
const ZO = Le({});
function ts(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function CF(e, t, n, r, i, o) {
  const { visualElement: a } = Ce(sp), s = Ce(BO), l = Ce(rp), u = Ce(lb), c = u.reducedMotion, f = u.skipAnimations, d = ve(null), p = ve(!1);
  r = r || s.renderer, !d.current && r && (d.current = r(e, {
    visualState: t,
    parent: a,
    props: n,
    presenceContext: l,
    blockInitialAnimation: l ? l.initial === !1 : !1,
    reducedMotionConfig: c,
    skipAnimations: f,
    isSVG: o
  }), p.current && d.current && (d.current.manuallyAnimateOnMount = !0));
  const h = d.current, m = Ce(ZO);
  h && !h.projection && i && (h.type === "html" || h.type === "svg") && IF(d.current, n, i, m);
  const v = ve(!1);
  by(() => {
    h && v.current && h.update(n, l);
  });
  const g = n[nO], b = ve(!!g && typeof window < "u" && !window.MotionHandoffIsComplete?.(g) && window.MotionHasOptimisedAnimation?.(g));
  return np(() => {
    p.current = !0, h && (v.current = !0, window.MotionIsMounted = !0, h.updateFeatures(), h.scheduleRenderMicrotask(), b.current && h.animationState && h.animationState.animateChanges());
  }), De(() => {
    h && (!b.current && h.animationState && h.animationState.animateChanges(), b.current && (queueMicrotask(() => {
      window.MotionHandoffMarkAsComplete?.(g);
    }), b.current = !1), h.enteringChildren = void 0);
  }), h;
}
function IF(e, t, n, r) {
  const { layoutId: i, layout: o, drag: a, dragConstraints: s, layoutScroll: l, layoutRoot: u, layoutAnchor: c, layoutCrossfade: f } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : GO(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!a || s && ts(s),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: r,
    crossfade: f,
    layoutScroll: l,
    layoutRoot: u,
    layoutAnchor: c
  });
}
function GO(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : GO(e.parent);
}
function jh(e, { forwardMotionProps: t = !1, type: n } = {}, r, i) {
  r && hF(r);
  const o = n ? n === "svg" : cb(e), a = o ? PF : kF;
  function s(u, c) {
    let f;
    const d = {
      ...Ce(lb),
      ...u,
      layoutId: MF(u)
    }, { isStatic: p } = d, h = bF(u), m = a(u, p);
    if (!p && typeof window < "u") {
      RF(d, r);
      const v = NF(d);
      f = v.MeasureLayout, h.visualElement = CF(e, m, d, i, v.ProjectionNode, o);
    }
    return R.jsxs(sp.Provider, { value: h, children: [f && h.visualElement ? R.jsx(f, { visualElement: h.visualElement, ...d }) : null, $F(e, u, AF(m, h.visualElement, c), m, p, t, o)] });
  }
  s.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const l = Jt(s);
  return l[DF] = e, l;
}
function MF({ layoutId: e }) {
  const t = Ce(xu).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function RF(e, t) {
  const n = Ce(BO).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? tl(!1, r, "lazy-strict-mode") : Hi(!1, r, "lazy-strict-mode");
  }
}
function NF(e) {
  const t = KO(), { drag: n, layout: r } = t;
  if (!n && !r)
    return {};
  const i = { ...n, ...r };
  return {
    MeasureLayout: n?.isEnabled(e) || r?.isEnabled(e) ? i.MeasureLayout : void 0,
    ProjectionNode: i.ProjectionNode
  };
}
function jF(e, t) {
  if (typeof Proxy > "u")
    return jh;
  const n = /* @__PURE__ */ new Map(), r = (o, a) => jh(o, a, e, t), i = (o, a) => (process.env.NODE_ENV !== "production" && Vy(!1, "motion() is deprecated. Use motion.create() instead."), r(o, a));
  return new Proxy(i, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (o, a) => a === "create" ? r : (n.has(a) || n.set(a, jh(a, void 0, e, t)), n.get(a))
  });
}
const FF = (e, t) => t.isSVG ?? cb(e) ? new l8(t) : new n8(t, {
  allowProjection: e !== wy
});
class zF extends jo {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = p8(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    op(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    this.node.animationState.reset(), this.unmountControls?.();
  }
}
let LF = 0;
class VF extends jo {
  constructor() {
    super(...arguments), this.id = LF++, this.isExitComplete = !1;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    if (t && r === !1) {
      if (this.isExitComplete) {
        const { initial: o, custom: a } = this.node.getProps();
        if (typeof o == "string" || typeof o == "object" && o !== null && !Array.isArray(o)) {
          const s = pa(this.node, o, a);
          if (s) {
            const { transition: l, transitionEnd: u, ...c } = s;
            for (const f in c)
              this.node.getValue(f)?.jump(c[f]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else
        this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => {
      this.isExitComplete = !0, n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const BF = {
  animation: {
    Feature: zF
  },
  exit: {
    Feature: VF
  }
};
function rc(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const KF = (e) => (t) => nb(t) && e(t, rc(t));
function lu(e, t, n, r) {
  return Tu(e, t, KF(n), r);
}
const YO = ({ current: e }) => e ? e.ownerDocument.defaultView : null, Cw = (e, t) => Math.abs(e - t);
function UF(e, t) {
  const n = Cw(e.x, t.x), r = Cw(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
const Iw = /* @__PURE__ */ new Set(["auto", "scroll"]);
class QO {
  constructor(t, n, { transformPagePoint: r, contextWindow: i = window, dragSnapToOrigin: o = !1, distanceThreshold: a = 3, element: s } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (h) => {
      this.handleScroll(h.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = Mc(this.lastRawMoveEventInfo, this.transformPagePoint));
      const h = Fh(this.lastMoveEventInfo, this.history), m = this.startEvent !== null, v = UF(h.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!m && !v)
        return;
      const { point: g } = h, { timestamp: b } = vn;
      this.history.push({ ...g, timestamp: b });
      const { onStart: E, onMove: x } = this.handlers;
      m || (E && E(this.lastMoveEvent, h), this.startEvent = this.lastMoveEvent), x && x(this.lastMoveEvent, h);
    }, this.handlePointerMove = (h, m) => {
      this.lastMoveEvent = h, this.lastRawMoveEventInfo = m, this.lastMoveEventInfo = Mc(m, this.transformPagePoint), ht.update(this.updatePoint, !0);
    }, this.handlePointerUp = (h, m) => {
      this.end();
      const { onEnd: v, onSessionEnd: g, resumeAnimation: b } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && b && b(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const E = Fh(h.type === "pointercancel" ? this.lastMoveEventInfo : Mc(m, this.transformPagePoint), this.history);
      this.startEvent && v && v(h, E), g && g(h, E);
    }, !nb(t))
      return;
    this.dragSnapToOrigin = o, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = a, this.contextWindow = i || window;
    const l = rc(t), u = Mc(l, this.transformPagePoint), { point: c } = u, { timestamp: f } = vn;
    this.history = [{ ...c, timestamp: f }];
    const { onSessionStart: d } = n;
    d && d(t, Fh(u, this.history));
    const p = { passive: !0, capture: !0 };
    this.removeListeners = ec(lu(this.contextWindow, "pointermove", this.handlePointerMove, p), lu(this.contextWindow, "pointerup", this.handlePointerUp, p), lu(this.contextWindow, "pointercancel", this.handlePointerUp, p)), s && this.startScrollTracking(s);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(t) {
    let n = t.parentElement;
    for (; n; ) {
      const r = getComputedStyle(n);
      (Iw.has(r.overflowX) || Iw.has(r.overflowY)) && this.scrollPositions.set(n, {
        x: n.scrollLeft,
        y: n.scrollTop
      }), n = n.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(t) {
    const n = this.scrollPositions.get(t);
    if (!n)
      return;
    const r = t === window, i = r ? { x: window.scrollX, y: window.scrollY } : {
      x: t.scrollLeft,
      y: t.scrollTop
    }, o = { x: i.x - n.x, y: i.y - n.y };
    o.x === 0 && o.y === 0 || (r ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += o.x, this.lastMoveEventInfo.point.y += o.y) : this.history.length > 0 && (this.history[0].x -= o.x, this.history[0].y -= o.y), this.scrollPositions.set(t, i), ht.update(this.updatePoint, !0));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), To(this.updatePoint);
  }
}
function Mc(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Mw(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Fh({ point: e }, t) {
  return {
    point: e,
    delta: Mw(e, JO(t)),
    offset: Mw(e, qF(t)),
    velocity: HF(t, 0.1)
  };
}
function qF(e) {
  return e[0];
}
function JO(e) {
  return e[e.length - 1];
}
function HF(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const i = JO(e);
  for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ qn(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  r === e[0] && e.length > 2 && i.timestamp - r.timestamp > /* @__PURE__ */ qn(t) * 2 && (r = e[1]);
  const o = /* @__PURE__ */ Er(i.timestamp - r.timestamp);
  if (o === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function WF(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? bt(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? bt(n, e, r.max) : Math.min(e, n)), e;
}
function Rw(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function ZF(e, { top: t, left: n, bottom: r, right: i }) {
  return {
    x: Rw(e.x, n, i),
    y: Rw(e.y, t, r)
  };
}
function Nw(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function GF(e, t) {
  return {
    x: Nw(e.x, t.x),
    y: Nw(e.y, t.y)
  };
}
function YF(e, t) {
  let n = 0.5;
  const r = Rn(e), i = Rn(t);
  return i > r ? n = /* @__PURE__ */ Eu(t.min, t.max - r, e.min) : r > i && (n = /* @__PURE__ */ Eu(e.min, e.max - i, t.min)), ki(0, 1, n);
}
function QF(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Bv = 0.35;
function JF(e = Bv) {
  return e === !1 ? e = 0 : e === !0 && (e = Bv), {
    x: jw(e, "left", "right"),
    y: jw(e, "top", "bottom")
  };
}
function jw(e, t, n) {
  return {
    min: Fw(e, t),
    max: Fw(e, n)
  };
}
function Fw(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const XF = /* @__PURE__ */ new WeakMap();
class ez {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ln(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const o = (f) => {
      n && this.snapToCursor(rc(f).point), this.stopAnimation();
    }, a = (f, d) => {
      const { drag: p, dragPropagation: h, onDragStart: m } = this.getProps();
      if (p && !h && (this.openDragLock && this.openDragLock(), this.openDragLock = wj(p), !this.openDragLock))
        return;
      this.latestPointerEvent = f, this.latestPanInfo = d, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), gi((g) => {
        let b = this.getAxisMotionValue(g).get() || 0;
        if ($i.test(b)) {
          const { projection: E } = this.visualElement;
          if (E && E.layout) {
            const x = E.layout.layoutBox[g];
            x && (b = Rn(x) * (parseFloat(b) / 100));
          }
        }
        this.originPoint[g] = b;
      }), m && ht.update(() => m(f, d), !1, !0), Av(this.visualElement, "transform");
      const { animationState: v } = this.visualElement;
      v && v.setActive("whileDrag", !0);
    }, s = (f, d) => {
      this.latestPointerEvent = f, this.latestPanInfo = d;
      const { dragPropagation: p, dragDirectionLock: h, onDirectionLock: m, onDrag: v } = this.getProps();
      if (!p && !this.openDragLock)
        return;
      const { offset: g } = d;
      if (h && this.currentDirection === null) {
        this.currentDirection = nz(g), this.currentDirection !== null && m && m(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, g), this.updateAxis("y", d.point, g), this.visualElement.render(), v && ht.update(() => v(f, d), !1, !0);
    }, l = (f, d) => {
      this.latestPointerEvent = f, this.latestPanInfo = d, this.stop(f, d), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => {
      const { dragSnapToOrigin: f } = this.getProps();
      (f || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new QO(t, {
      onSessionStart: o,
      onStart: a,
      onMove: s,
      onSessionEnd: l,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      distanceThreshold: r,
      contextWindow: YO(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, i = n || this.latestPanInfo, o = this.isDragging;
    if (this.cancel(), !o || !i || !r)
      return;
    const { velocity: a } = i;
    this.startAnimation(a);
    const { onDragEnd: s } = this.getProps();
    s && ht.postRender(() => s(r, i));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(t, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !Rc(t, i, this.currentDirection))
      return;
    const o = this.getAxisMotionValue(t);
    let a = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (a = WF(a, this.constraints[t], this.elastic[t])), o.set(a);
  }
  resolveConstraints() {
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, i = this.constraints;
    t && ts(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = ZF(r.layoutBox, t) : this.constraints = !1, this.elastic = JF(n), i !== this.constraints && !ts(t) && r && this.constraints && !this.hasMutatedConstraints && gi((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = QF(r.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !ts(t))
      return !1;
    const r = t.current;
    Hi(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    i.root && (i.root.scroll = void 0, i.root.updateScroll());
    const o = Yj(r, i.root, this.visualElement.getTransformPagePoint());
    let a = GF(i.layout.layoutBox, o);
    if (n) {
      const s = n(Wj(a));
      this.hasMutatedConstraints = !!s, s && (a = yO(s));
    }
    return a;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: o, dragSnapToOrigin: a, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, u = gi((c) => {
      if (!Rc(c, n, this.currentDirection))
        return;
      let f = l && l[c] || {};
      (a === !0 || a === c) && (f = { min: 0, max: 0 });
      const d = i ? 200 : 1e6, p = i ? 40 : 1e7, h = {
        type: "inertia",
        velocity: r ? t[c] : 0,
        bounceStiffness: d,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...o,
        ...f
      };
      return this.startAxisValueAnimation(c, h);
    });
    return Promise.all(u).then(s);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return Av(this.visualElement, t), r.start(Jy(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    gi((t) => this.getAxisMotionValue(t).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, i = this.visualElement.getProps()[n];
    return i || this.visualElement.getValue(t, this.visualElement.latestValues[t] ?? 0);
  }
  snapToCursor(t) {
    gi((n) => {
      const { drag: r } = this.getProps();
      if (!Rc(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, o = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: a, max: s } = i.layout.layoutBox[n], l = o.get() || 0;
        o.set(t[n] - bt(a, s, 0.5) + l);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!ts(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    gi((a) => {
      const s = this.getAxisMotionValue(a);
      if (s && this.constraints !== !1) {
        const l = s.get();
        i[a] = YF({ min: l, max: l }, this.constraints[a]);
      }
    });
    const { transformTemplate: o } = this.visualElement.getProps();
    this.visualElement.current.style.transform = o ? o({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.constraints = !1, this.resolveConstraints(), gi((a) => {
      if (!Rc(a, t, null))
        return;
      const s = this.getAxisMotionValue(a), { min: l, max: u } = this.constraints[a];
      s.set(bt(l, u, i[a]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    XF.set(this.visualElement, this);
    const t = this.visualElement.current, n = lu(t, "pointerdown", (u) => {
      const { drag: c, dragListener: f = !0 } = this.getProps(), d = u.target, p = d !== t && Oj(d);
      c && f && !p && this.start(u);
    });
    let r;
    const i = () => {
      const { dragConstraints: u } = this.getProps();
      ts(u) && u.current && (this.constraints = this.resolveRefConstraints(), r || (r = tz(t, u.current, () => this.scalePositionWithinConstraints())));
    }, { projection: o } = this.visualElement, a = o.addEventListener("measure", i);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), ht.read(i);
    const s = Tu(window, "resize", () => this.scalePositionWithinConstraints()), l = o.addEventListener("didUpdate", (({ delta: u, hasLayoutChanged: c }) => {
      this.isDragging && c && (gi((f) => {
        const d = this.getAxisMotionValue(f);
        d && (this.originPoint[f] += u[f].translate, d.set(d.get() + u[f].translate));
      }), this.visualElement.render());
    }));
    return () => {
      s(), n(), a(), l && l(), r && r();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: o = !1, dragElastic: a = Bv, dragMomentum: s = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: o,
      dragElastic: a,
      dragMomentum: s
    };
  }
}
function zw(e) {
  let t = !0;
  return () => {
    if (t) {
      t = !1;
      return;
    }
    e();
  };
}
function tz(e, t, n) {
  const r = q_(e, zw(n)), i = q_(t, zw(n));
  return () => {
    r(), i();
  };
}
function Rc(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function nz(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class rz extends jo {
  constructor(t) {
    super(t), this.removeGroupControls = kr, this.removeListeners = kr, this.controls = new ez(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || kr;
  }
  update() {
    const { dragControls: t } = this.node.getProps(), { dragControls: n } = this.node.prevProps || {};
    t !== n && (this.removeGroupControls(), t && (this.removeGroupControls = t.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const zh = (e) => (t, n) => {
  e && ht.update(() => e(t, n), !1, !0);
};
class iz extends jo {
  constructor() {
    super(...arguments), this.removePointerDownListener = kr;
  }
  onPointerDown(t) {
    this.session = new QO(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: YO(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: zh(t),
      onStart: zh(n),
      onMove: zh(r),
      onEnd: (o, a) => {
        delete this.session, i && ht.postRender(() => i(o, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = lu(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let Lh = !1;
class oz extends Gd {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: o } = t;
    o && (n.group && n.group.add(o), r && r.register && i && r.register(o), Lh && o.root.didUpdate(), o.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), o.setOptions({
      ...o.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), xf.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: o } = this.props, { projection: a } = r;
    return a && (a.isPresent = o, t.layoutDependency !== n && a.setOptions({
      ...a.options,
      layoutDependency: n
    }), Lh = !0, i || t.layoutDependency !== n || n === void 0 || t.isPresent !== o ? a.willUpdate() : this.safeToRemove(), t.isPresent !== o && (o ? a.promote() : a.relegate() || ht.postRender(() => {
      const s = a.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { visualElement: t, layoutAnchor: n } = this.props, { projection: r } = t;
    r && (r.options.layoutAnchor = n, r.root.didUpdate(), tb.postRender(() => {
      !r.currentAnimation && r.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = t;
    Lh = !0, i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function XO(e) {
  const [t, n] = LO(), r = Ce(xu);
  return R.jsx(oz, { ...e, layoutGroup: r, switchLayoutGroup: Ce(ZO), isPresent: t, safeToRemove: n });
}
const az = {
  pan: {
    Feature: iz
  },
  drag: {
    Feature: rz,
    ProjectionNode: zO,
    MeasureLayout: XO
  }
};
function Lw(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, o = r[i];
  o && ht.postRender(() => o(t, rc(t)));
}
class sz extends jo {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = Ej(t, (n, r) => (Lw(this.node, r, "Start"), (i) => Lw(this.node, i, "End"))));
  }
  unmount() {
  }
}
class lz extends jo {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = ec(Tu(this.node.current, "focus", () => this.onFocus()), Tu(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Vw(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), o = r[i];
  o && ht.postRender(() => o(t, rc(t)));
}
class uz extends jo {
  mount() {
    const { current: t } = this.node;
    if (!t)
      return;
    const { globalTapTarget: n, propagate: r } = this.node.props;
    this.unmount = Pj(t, (i, o) => (Vw(this.node, o, "Start"), (a, { success: s }) => Vw(this.node, a, s ? "End" : "Cancel")), {
      useGlobalTarget: n,
      stopPropagation: r?.tap === !1
    });
  }
  unmount() {
  }
}
const Kv = /* @__PURE__ */ new WeakMap(), Vh = /* @__PURE__ */ new WeakMap(), cz = (e) => {
  const t = Kv.get(e.target);
  t && t(e);
}, fz = (e) => {
  e.forEach(cz);
};
function dz({ root: e, ...t }) {
  const n = e || document;
  Vh.has(n) || Vh.set(n, {});
  const r = Vh.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(fz, { root: e, ...t })), r[i];
}
function pz(e, t, n) {
  const r = dz(t);
  return Kv.set(e, n), r.observe(e), () => {
    Kv.delete(e), r.unobserve(e);
  };
}
const hz = {
  some: 0,
  all: 1
};
class mz extends jo {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.stopObserver?.();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: o } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : hz[i]
    }, s = (l) => {
      const { isIntersecting: u } = l;
      if (this.isInView === u || (this.isInView = u, o && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: c, onViewportLeave: f } = this.node.getProps(), d = u ? c : f;
      d && d(l);
    };
    this.stopObserver = pz(this.node.current, a, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(vz(t, n)) && this.startObserver();
  }
  unmount() {
    this.stopObserver?.(), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function vz({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const gz = {
  inView: {
    Feature: mz
  },
  tap: {
    Feature: uz
  },
  focus: {
    Feature: lz
  },
  hover: {
    Feature: sz
  }
}, yz = {
  layout: {
    ProjectionNode: zO,
    MeasureLayout: XO
  }
}, bz = {
  ...BF,
  ...gz,
  ...az,
  ...yz
}, _z = /* @__PURE__ */ jF(bz, FF), Nn = _z, Bh = [
  "Really?",
  "Sure?",
  "Certain?",
  "Positive?",
  "Confident?",
  "Right?",
  "Accurate?",
  "Correct?",
  "Definite?",
  "Absolutely?"
], wz = {
  y: "-200%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, xz = {
  y: "-50%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, Ez = Mr(
  [
    "relative",
    "cursor-pointer",
    "focus:ring-white",
    "hover:bg-red-500",
    "disabled:bg-red-400",
    "z-0",
    "px-4",
    "py-2",
    "text-sm",
    "text-white",
    "transition-all",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-opacity-75",
    "disabled:opacity-50",
    "disabled:cursor-default"
  ],
  {
    variants: {
      showConfirm: {
        true: ["bg-red-600"],
        false: ["bg-black"]
      }
    }
  }
), Iue = ({
  onDelete: e,
  numberOfQuestions: t = 1,
  className: n = ""
}) => {
  let r = t;
  t > Bh.length && (r = Bh.length), t < 1 && (r = 1);
  const [i, o] = je(!1), [a, s] = je(0);
  return /* @__PURE__ */ R.jsxs(
    Nn.button,
    {
      layout: !0,
      className: Wn(Ez({ showConfirm: i }), n),
      children: [
        /* @__PURE__ */ R.jsx("p", { className: "opacity-0", children: "Delete" }),
        /* @__PURE__ */ R.jsx(Vv, { children: /* @__PURE__ */ R.jsx(
          Nn.p,
          {
            className: "absolute text-white",
            onClick: () => o(!0),
            exit: wz,
            initial: xz,
            children: !i && "Delete"
          }
        ) }),
        /* @__PURE__ */ R.jsx(Vv, { children: i && /* @__PURE__ */ R.jsx(
          Nn.p,
          {
            className: "absolute text-white",
            onClick: () => {
              a < r - 1 ? s((l) => l + 1) : e();
            },
            initial: { y: "200%", top: "50%", left: "50%", x: "-50%" },
            animate: { y: "-50%", top: "50%", left: "50%", x: "-50%" },
            children: Bh[a]
          }
        ) })
      ]
    }
  );
}, Mue = () => /* @__PURE__ */ R.jsx("hr", { className: "w-full h-px border-t-neutral-600" }), Sz = Mr(
  [
    "w-48",
    "h-screen",
    "fixed",
    "top-0",
    "left-[100vw]",
    "bg-white",
    "transition-transform"
  ],
  {
    variants: {
      visible: {
        true: "-translate-x-full",
        false: ""
      }
    }
  }
), Rue = ({
  visible: e,
  children: t,
  onClose: n
}) => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
  e && /* @__PURE__ */ R.jsx(
    "div",
    {
      className: "fixed top-0 left-0 w-screen h-screen bg-black opacity-50",
      onClick: () => n()
    }
  ),
  /* @__PURE__ */ R.jsx("div", { className: Sz({ visible: e }), children: t })
] }), kn = 16, Uv = ({
  sideBarVisible: e,
  onClick: t,
  className: n = ""
}) => /* @__PURE__ */ R.jsxs(
  Nn.svg,
  {
    className: `my-auto cursor-pointer ${n}`,
    width: kn,
    height: kn,
    viewBox: `0 0 ${kn} ${kn}`,
    animate: e ? "open" : "closed",
    onClick: () => t(),
    children: [
      /* @__PURE__ */ R.jsx(
        Nn.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 1 L ${kn} 1` },
            open: { d: `M ${kn} 0 L 0 ${kn}` }
          }
        }
      ),
      /* @__PURE__ */ R.jsx(
        Nn.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          d: `M 0 ${kn / 2} L ${kn} ${kn / 2}`,
          variants: {
            closed: { opacity: 1 },
            open: { opacity: 0 }
          },
          transition: { duration: 0.1 }
        }
      ),
      /* @__PURE__ */ R.jsx(
        Nn.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 ${kn - 1} L ${kn} ${kn - 1}` },
            open: { d: `M 0 0 L ${kn} ${kn}` }
          }
        }
      )
    ]
  }
);
Le(null);
Le(null);
Le(null);
Le(null);
Le(null);
Le({});
const qv = Le(null), $z = Le(null), ot = typeof document < "u" ? G.useLayoutEffect : () => {
};
function Tz(e) {
  let [t, n] = je(e), r = ve(t), i = ve(null), o = ve(() => {
    if (!i.current) return;
    let s = i.current.next();
    if (s.done) {
      i.current = null;
      return;
    }
    r.current === s.value ? o.current() : n(s.value);
  });
  ot(() => {
    r.current = t, i.current && o.current();
  });
  let a = Ne((s) => {
    i.current = s(r.current), o.current();
  }, [
    o
  ]);
  return [
    t,
    a
  ];
}
const id = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, ek = /* @__PURE__ */ G.createContext(id), Oz = /* @__PURE__ */ G.createContext(!1);
let kz = !!(typeof window < "u" && window.document && window.document.createElement), Kh = /* @__PURE__ */ new WeakMap();
function Pz(e = !1) {
  let t = Ce(ek), n = ve(null);
  if (n.current === null && !e) {
    var r, i;
    let o = (i = G.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || i === void 0 || (r = i.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (o) {
      let a = Kh.get(o);
      a == null ? Kh.set(o, {
        id: t.current,
        state: o.memoizedState
      }) : o.memoizedState !== a.state && (t.current = a.id, Kh.delete(o));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function Dz(e) {
  let t = Ce(ek);
  t === id && !kz && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Pz(!!e), r = t === id && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function Az(e) {
  let t = G.useId(), [n] = je(ic()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${id.prefix}`;
  return e || `${r}-${t}`;
}
const Cz = typeof G.useId == "function" ? Az : Dz;
function Iz() {
  return !1;
}
function Mz() {
  return !0;
}
function Rz(e) {
  return () => {
  };
}
function ic() {
  return typeof G.useSyncExternalStore == "function" ? G.useSyncExternalStore(Rz, Iz, Mz) : Ce(Oz);
}
let Nz = !!(typeof window < "u" && window.document && window.document.createElement), Ss = /* @__PURE__ */ new Map(), Wl;
typeof FinalizationRegistry < "u" && (Wl = new FinalizationRegistry((e) => {
  Ss.delete(e);
}));
function Zn(e) {
  let [t, n] = je(e), r = ve(null), i = Cz(t), o = ve(null);
  if (Wl && Wl.register(o, i), Nz) {
    const a = Ss.get(i);
    a && !a.includes(r) ? a.push(r) : Ss.set(i, [
      r
    ]);
  }
  return ot(() => {
    let a = i;
    return () => {
      Wl && Wl.unregister(o), Ss.delete(a);
    };
  }, [
    i
  ]), De(() => {
    let a = r.current;
    return a && n(a), () => {
      a && (r.current = null);
    };
  }), i;
}
function jz(e, t) {
  if (e === t) return e;
  let n = Ss.get(e);
  if (n)
    return n.forEach((i) => i.current = t), t;
  let r = Ss.get(t);
  return r ? (r.forEach((i) => i.current = e), e) : t;
}
function ha(e = []) {
  let t = Zn(), [n, r] = Tz(t), i = Ne(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return ot(i, [
    t,
    i,
    ...e
  ]), n;
}
function Ma(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const Qe = (e) => {
  var t;
  return (t = e?.ownerDocument) !== null && t !== void 0 ? t : document;
}, Sn = (e) => e && "window" in e && e.window === e ? e : Qe(e).defaultView || window;
function Fz(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function zz(e) {
  return Fz(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let Lz = !1;
function ji() {
  return Lz;
}
function We(e, t) {
  if (!ji()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : zz(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const Rt = (e = document) => {
  var t;
  if (!ji()) return e.activeElement;
  let n = e.activeElement;
  for (; n && "shadowRoot" in n && (!((t = n.shadowRoot) === null || t === void 0) && t.activeElement); ) n = n.shadowRoot.activeElement;
  return n;
};
function Te(e) {
  if (ji() && e.target instanceof Element && e.target.shadowRoot) {
    var t, n;
    if ("composedPath" in e) return (t = e.composedPath()[0]) !== null && t !== void 0 ? t : null;
    if ("composedPath" in e.nativeEvent) return (n = e.nativeEvent.composedPath()[0]) !== null && n !== void 0 ? n : null;
  }
  return e.target;
}
function od(e) {
  if (!e) return !1;
  let t = e.getRootNode(), n = Sn(e);
  if (!(t instanceof n.Document || t instanceof n.ShadowRoot)) return !1;
  let r = t.activeElement;
  return r != null && e.contains(r);
}
class Vz {
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(t) {
    if (!We(this.root, t)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const n = [];
    let r = t, i = t;
    for (this._currentNode = t; r && r !== this.root; ) if (r.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const a = r, s = this._doc.createTreeWalker(a, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      n.push(s), s.currentNode = i, this._currentSetFor.add(s), r = i = a.host;
    } else r = r.parentNode;
    const o = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    n.push(o), o.currentNode = i, this._currentSetFor.add(o), this._walkerStack = n;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let t = this.currentNode, n = this.nextNode();
    return We(t, n) ? (n && (this.currentNode = n), n) : (this.currentNode = t, null);
  }
  lastChild() {
    let n = this._walkerStack[0].lastChild();
    return n && (this.currentNode = n), n;
  }
  nextNode() {
    const t = this._walkerStack[0].nextNode();
    if (t) {
      if (t.shadowRoot) {
        var n;
        let i;
        if (typeof this.filter == "function" ? i = this.filter(t) : !((n = this.filter) === null || n === void 0) && n.acceptNode && (i = this.filter.acceptNode(t)), i === NodeFilter.FILTER_ACCEPT)
          return this.currentNode = t, t;
        let o = this.nextNode();
        return o && (this.currentNode = o), o;
      }
      return t && (this.currentNode = t), t;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let r = this.nextNode();
      return r && (this.currentNode = r), r;
    } else return null;
  }
  previousNode() {
    const t = this._walkerStack[0];
    if (t.currentNode === t.root) {
      if (this._currentSetFor.has(t))
        if (this._currentSetFor.delete(t), this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let i = this.previousNode();
          return i && (this.currentNode = i), i;
        } else return null;
      return null;
    }
    const n = t.previousNode();
    if (n) {
      if (n.shadowRoot) {
        var r;
        let o;
        if (typeof this.filter == "function" ? o = this.filter(n) : !((r = this.filter) === null || r === void 0) && r.acceptNode && (o = this.filter.acceptNode(n)), o === NodeFilter.FILTER_ACCEPT)
          return n && (this.currentNode = n), n;
        let a = this.lastChild();
        return a && (this.currentNode = a), a;
      }
      return n && (this.currentNode = n), n;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let i = this.previousNode();
      return i && (this.currentNode = i), i;
    } else return null;
  }
  /**
   * @deprecated
   */
  nextSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  previousSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  parentNode() {
    return null;
  }
  constructor(t, n, r, i) {
    this._walkerStack = [], this._currentSetFor = /* @__PURE__ */ new Set(), this._acceptNode = (a) => {
      if (a.nodeType === Node.ELEMENT_NODE) {
        const l = a.shadowRoot;
        if (l) {
          const u = this._doc.createTreeWalker(l, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          return this._walkerStack.unshift(u), NodeFilter.FILTER_ACCEPT;
        } else {
          var s;
          if (typeof this.filter == "function") return this.filter(a);
          if (!((s = this.filter) === null || s === void 0) && s.acceptNode) return this.filter.acceptNode(a);
          if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    }, this._doc = t, this.root = n, this.filter = i ?? null, this.whatToShow = r ?? NodeFilter.SHOW_ALL, this._currentNode = n, this._walkerStack.unshift(t.createTreeWalker(n, r, this._acceptNode));
    const o = n.shadowRoot;
    if (o) {
      const a = this._doc.createTreeWalker(o, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(a);
    }
  }
}
function tk(e, t, n, r) {
  return ji() ? new Vz(e, t, n, r) : e.createTreeWalker(t, n, r);
}
function fb(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = Bw(i, t);
      return n || (n = typeof o == "function"), o;
    });
    if (n) return () => {
      r.forEach((i, o) => {
        typeof i == "function" ? i() : Bw(e[o], null);
      });
    };
  };
}
function Bw(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
function nt(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let i in r) {
      let o = t[i], a = r[i];
      typeof o == "function" && typeof a == "function" && // This is a lot faster than a regex.
      i[0] === "o" && i[1] === "n" && i.charCodeAt(2) >= /* 'A' */
      65 && i.charCodeAt(2) <= /* 'Z' */
      90 ? t[i] = Ma(o, a) : (i === "className" || i === "UNSAFE_className") && typeof o == "string" && typeof a == "string" ? t[i] = k$(o, a) : i === "id" && o && a ? t.id = jz(o, a) : i === "ref" && o && a ? t.ref = fb(o, a) : t[i] = a !== void 0 ? a : o;
    }
  }
  return t;
}
const Bz = /* @__PURE__ */ new Set([
  "id"
]), Kz = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), Uz = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), qz = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]), Kw = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]), Hz = /^(data-.*)$/;
function xn(e, t = {}) {
  let { labelable: n, isLink: r, global: i, events: o = i, propNames: a } = t, s = {};
  for (const l in e) Object.prototype.hasOwnProperty.call(e, l) && (Bz.has(l) || n && Kz.has(l) || r && Uz.has(l) || i && qz.has(l) || o && (Kw.has(l) || l.endsWith("Capture") && Kw.has(l.slice(0, -7))) || a?.has(l) || Hz.test(l)) && (s[l] = e[l]);
  return s;
}
function ni(e) {
  if (Wz()) e.focus({
    preventScroll: !0
  });
  else {
    let t = Zz(e);
    e.focus(), Gz(t);
  }
}
let Nc = null;
function Wz() {
  if (Nc == null) {
    Nc = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Nc = !0, !0;
        }
      });
    } catch {
    }
  }
  return Nc;
}
function Zz(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function Gz(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function lp(e) {
  var t;
  if (typeof window > "u" || window.navigator == null) return !1;
  let n = (t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands;
  return Array.isArray(n) && n.some((r) => e.test(r.brand)) || e.test(window.navigator.userAgent);
}
function db(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function eo(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const Oo = eo(function() {
  return db(/^Mac/i);
}), Yz = eo(function() {
  return db(/^iPhone/i);
}), nk = eo(function() {
  return db(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Oo() && navigator.maxTouchPoints > 1;
}), oc = eo(function() {
  return Yz() || nk();
}), Qz = eo(function() {
  return Oo() || oc();
}), pb = eo(function() {
  return lp(/AppleWebKit/i) && !hb();
}), hb = eo(function() {
  return lp(/Chrome/i);
}), mb = eo(function() {
  return lp(/Android/i);
}), Jz = eo(function() {
  return lp(/Firefox/i);
}), Xz = /* @__PURE__ */ Le({
  isNative: !0,
  open: nL,
  useHref: (e) => e
});
function up() {
  return Ce(Xz);
}
function eL(e, t) {
  let n = e.getAttribute("target");
  return (!n || n === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function Wi(e, t, n = !0) {
  var r, i;
  let { metaKey: o, ctrlKey: a, altKey: s, shiftKey: l } = t;
  Jz() && (!((i = window.event) === null || i === void 0 || (r = i.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && (Oo() ? o = !0 : a = !0);
  let u = pb() && Oo() && !nk() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: o,
    ctrlKey: a,
    altKey: s,
    shiftKey: l
  }) : new MouseEvent("click", {
    metaKey: o,
    ctrlKey: a,
    altKey: s,
    shiftKey: l,
    detail: 1,
    bubbles: !0,
    cancelable: !0
  });
  Wi.isOpening = n, ni(e), e.dispatchEvent(u), Wi.isOpening = !1;
}
Wi.isOpening = !1;
function tL(e, t) {
  if (e instanceof HTMLAnchorElement) t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function nL(e, t) {
  tL(e, (n) => Wi(n, t));
}
function rk(e) {
  let t = up();
  var n;
  const r = t.useHref((n = e?.href) !== null && n !== void 0 ? n : "");
  return {
    href: e?.href ? r : void 0,
    target: e?.target,
    rel: e?.rel,
    download: e?.download,
    ping: e?.ping,
    referrerPolicy: e?.referrerPolicy
  };
}
function rL(e, t, n, r) {
  !t.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
  !e.isDefaultPrevented() && eL(e.currentTarget, e) && n && (e.preventDefault(), t.open(e.currentTarget, e, n, r));
}
let po = /* @__PURE__ */ new Map(), Hv = /* @__PURE__ */ new Set();
function Uw() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    let i = Te(r);
    if (!e(r) || !i) return;
    let o = po.get(i);
    o || (o = /* @__PURE__ */ new Set(), po.set(i, o), i.addEventListener("transitioncancel", n, {
      once: !0
    })), o.add(r.propertyName);
  }, n = (r) => {
    let i = Te(r);
    if (!e(r) || !i) return;
    let o = po.get(i);
    if (o && (o.delete(r.propertyName), o.size === 0 && (i.removeEventListener("transitioncancel", n), po.delete(i)), po.size === 0)) {
      for (let a of Hv) a();
      Hv.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? Uw() : document.addEventListener("DOMContentLoaded", Uw));
function iL() {
  for (const [e] of po)
    "isConnected" in e && !e.isConnected && po.delete(e);
}
function ik(e) {
  requestAnimationFrame(() => {
    iL(), po.size === 0 ? e() : Hv.add(e);
  });
}
function cp() {
  let e = ve(/* @__PURE__ */ new Map()), t = Ne((i, o, a, s) => {
    let l = s?.once ? (...u) => {
      e.current.delete(a), a(...u);
    } : a;
    e.current.set(a, {
      type: o,
      eventTarget: i,
      fn: l,
      options: s
    }), i.addEventListener(o, l, s);
  }, []), n = Ne((i, o, a, s) => {
    var l;
    let u = ((l = e.current.get(a)) === null || l === void 0 ? void 0 : l.fn) || a;
    i.removeEventListener(o, u, s), e.current.delete(a);
  }, []), r = Ne(() => {
    e.current.forEach((i, o) => {
      n(i.eventTarget, i.type, o, i.options);
    });
  }, [
    n
  ]);
  return De(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function ok(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": i } = e;
  return n = Zn(n), i && r ? i = [
    .../* @__PURE__ */ new Set([
      n,
      ...i.trim().split(/\s+/)
    ])
  ].join(" ") : i && (i = i.trim().split(/\s+/).join(" ")), !r && !i && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": i
  };
}
function ol(e) {
  const t = ve(null), n = ve(void 0), r = Ne((i) => {
    if (typeof e == "function") {
      const o = e, a = o(i);
      return () => {
        typeof a == "function" ? a() : o(null);
      };
    } else if (e)
      return e.current = i, () => {
        e.current = null;
      };
  }, [
    e
  ]);
  return Ee(() => ({
    get current() {
      return t.current;
    },
    set current(i) {
      t.current = i, n.current && (n.current(), n.current = void 0), i != null && (n.current = r(i));
    }
  }), [
    r
  ]);
}
var Uh;
const oL = (Uh = G.useInsertionEffect) !== null && Uh !== void 0 ? Uh : ot;
function or(e) {
  const t = ve(null);
  return oL(() => {
    t.current = e;
  }, [
    e
  ]), Ne((...n) => {
    const r = t.current;
    return r?.(...n);
  }, []);
}
function qw(e, t) {
  const n = ve(!0), r = ve(null);
  ot(() => (n.current = !0, () => {
    n.current = !1;
  }), []), ot(() => {
    n.current ? n.current = !1 : (!r.current || t.some((i, o) => !Object.is(i, r[o]))) && e(), r.current = t;
  }, t);
}
function aL() {
  return typeof window.ResizeObserver < "u";
}
function ad(e) {
  const { ref: t, box: n, onResize: r } = e;
  let i = or(r);
  De(() => {
    let o = t?.current;
    if (o)
      if (aL()) {
        const a = new window.ResizeObserver((s) => {
          s.length && i();
        });
        return a.observe(o, {
          box: n
        }), () => {
          o && a.unobserve(o);
        };
      } else
        return window.addEventListener("resize", i, !1), () => {
          window.removeEventListener("resize", i, !1);
        };
  }, [
    t,
    n
  ]);
}
function vb(e, t) {
  ot(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function Rs(e, t) {
  if (!e) return !1;
  let n = window.getComputedStyle(e), r = document.scrollingElement || document.documentElement, i = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return e === r && n.overflow !== "hidden" && (i = !0), i && t && (i = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), i;
}
function gb(e, t) {
  let n = e;
  for (Rs(n, t) && (n = n.parentElement); n && !Rs(n, t); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function Hw(e, t) {
  let n = [], r = document.scrollingElement || document.documentElement;
  do
    Rs(e, t) && n.push(e), e = e.parentElement;
  while (e && e !== r);
  return n;
}
function ns(e) {
  return Oo() ? e.metaKey : e.ctrlKey;
}
const sL = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function qh(e) {
  return e instanceof HTMLInputElement && !sL.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
let lL = 0;
const Hh = /* @__PURE__ */ new Map();
function uL(e) {
  let [t, n] = je();
  return ot(() => {
    if (!e) return;
    let r = Hh.get(e);
    if (r)
      n(r.element.id);
    else {
      let i = `react-aria-description-${lL++}`;
      n(i);
      let o = document.createElement("div");
      o.id = i, o.style.display = "none", o.textContent = e, document.body.appendChild(o), r = {
        refCount: 0,
        element: o
      }, Hh.set(e, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), Hh.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
function jc(e, t, n, r) {
  let i = or(n), o = n == null;
  De(() => {
    if (o || !e.current) return;
    let a = e.current;
    return a.addEventListener(t, i, r), () => {
      a.removeEventListener(t, i, r);
    };
  }, [
    e,
    t,
    r,
    o
  ]);
}
function Wv(e, t, n = {}) {
  let { block: r = "nearest", inline: i = "nearest" } = n;
  if (e === t) return;
  let o = e.scrollTop, a = e.scrollLeft, s = t.getBoundingClientRect(), l = e.getBoundingClientRect(), u = window.getComputedStyle(t), c = window.getComputedStyle(e), f = document.scrollingElement || document.documentElement, d = e === f ? 0 : l.top, p = e === f ? e.clientHeight : l.bottom, h = e === f ? 0 : l.left, m = e === f ? e.clientWidth : l.right, v = parseInt(u.scrollMarginTop, 10) || 0, g = parseInt(u.scrollMarginBottom, 10) || 0, b = parseInt(u.scrollMarginLeft, 10) || 0, E = parseInt(u.scrollMarginRight, 10) || 0, x = parseInt(c.scrollPaddingTop, 10) || 0, S = parseInt(c.scrollPaddingBottom, 10) || 0, $ = parseInt(c.scrollPaddingLeft, 10) || 0, P = parseInt(c.scrollPaddingRight, 10) || 0, y = parseInt(c.borderTopWidth, 10) || 0, _ = parseInt(c.borderBottomWidth, 10) || 0, w = parseInt(c.borderLeftWidth, 10) || 0, A = parseInt(c.borderRightWidth, 10) || 0, k = s.top - v, N = s.bottom + g, I = s.left - b, B = s.right + E, q = e === f ? 0 : w + A, ee = e === f ? 0 : y + _, re = e.offsetWidth - e.clientWidth - q, Z = e.offsetHeight - e.clientHeight - ee, T = d + y + x, F = p - _ - S - Z, M = h + w + $, K = m - A - P;
  c.direction === "rtl" && !oc() ? M += re : K -= re;
  let te = k < T || N > F, se = I < M || B > K;
  if (te && r === "start") o += k - T;
  else if (te && r === "center") o += (k + N) / 2 - (T + F) / 2;
  else if (te && r === "end") o += N - F;
  else if (te && r === "nearest") {
    let de = k - T, ge = N - F;
    o += Math.abs(de) <= Math.abs(ge) ? de : ge;
  }
  if (se && i === "start") a += I - M;
  else if (se && i === "center") a += (I + B) / 2 - (M + K) / 2;
  else if (se && i === "end") a += B - K;
  else if (se && i === "nearest") {
    let de = I - M, ge = B - K;
    a += Math.abs(de) <= Math.abs(ge) ? de : ge;
  }
  if (process.env.NODE_ENV === "test") {
    e.scrollLeft = a, e.scrollTop = o;
    return;
  }
  e.scrollTo({
    left: a,
    top: o
  });
}
function Ww(e, t = {}) {
  let { containingElement: n } = t;
  if (e && e.isConnected) {
    let a = document.scrollingElement || document.documentElement;
    if (!(window.getComputedStyle(a).overflow === "hidden") && !hb()) {
      var r;
      let { left: l, top: u } = e.getBoundingClientRect();
      e == null || (r = e.scrollIntoView) === null || r === void 0 || r.call(e, {
        block: "nearest"
      });
      let { left: c, top: f } = e.getBoundingClientRect();
      if (Math.abs(l - c) > 1 || Math.abs(u - f) > 1) {
        var i, o;
        n == null || (i = n.scrollIntoView) === null || i === void 0 || i.call(n, {
          block: "center",
          inline: "center"
        }), (o = e.scrollIntoView) === null || o === void 0 || o.call(e, {
          block: "nearest"
        });
      }
    } else {
      let { left: l, top: u } = e.getBoundingClientRect(), c = Hw(e, !0);
      for (let p of c) Wv(p, e);
      let { left: f, top: d } = e.getBoundingClientRect();
      if (Math.abs(l - f) > 1 || Math.abs(u - d) > 1) {
        c = n ? Hw(n, !0) : [];
        for (let p of c) Wv(p, n, {
          block: "center",
          inline: "center"
        });
      }
    }
  }
}
function Zv(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : mb() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function cL(e) {
  return !mb() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function fL(e, t, n) {
  let r = or(() => {
    n && n(t);
  });
  De(() => {
    var i;
    let o = e == null || (i = e.current) === null || i === void 0 ? void 0 : i.form;
    return o?.addEventListener("reset", r), () => {
      o?.removeEventListener("reset", r);
    };
  }, [
    e
  ]);
}
function dL(e, t) {
  let { collection: n, onLoadMore: r, scrollOffset: i = 1 } = e, o = ve(null), a = or((s) => {
    for (let l of s)
      l.isIntersecting && r && r();
  });
  ot(() => (t.current && (o.current = new IntersectionObserver(a, {
    root: gb(t?.current),
    rootMargin: `0px ${100 * i}% ${100 * i}% ${100 * i}%`
  }), o.current.observe(t.current)), () => {
    o.current && o.current.disconnect();
  }), [
    n,
    t,
    i
  ]);
}
function pL(e) {
  const t = t6.split(".");
  return parseInt(t[0], 10) >= 19 ? e : e ? "true" : void 0;
}
const hL = "react-aria-clear-focus", mL = "react-aria-focus";
function vL(e, t = !0) {
  let [n, r] = je(!0), i = n && t;
  return ot(() => {
    if (i && e.current && "getAnimations" in e.current)
      for (let o of e.current.getAnimations()) o instanceof CSSTransition && o.cancel();
  }, [
    e,
    i
  ]), ak(e, i, Ne(() => r(!1), [])), i;
}
function gL(e, t) {
  let [n, r] = je(t ? "open" : "closed");
  switch (n) {
    case "open":
      t || r("exiting");
      break;
    case "closed":
    case "exiting":
      t && r("open");
      break;
  }
  let i = n === "exiting";
  return ak(e, i, Ne(() => {
    r((o) => o === "exiting" ? "closed" : o);
  }, [])), i;
}
function ak(e, t, n) {
  ot(() => {
    if (t && e.current) {
      if (!("getAnimations" in e.current)) {
        n();
        return;
      }
      let r = e.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let i = !1;
      return Promise.all(r.map((o) => o.finished)).then(() => {
        i || xy(() => {
          n();
        });
      }).catch(() => {
      }), () => {
        i = !0;
      };
    }
  }, [
    e,
    t,
    n
  ]);
}
const yL = typeof Element < "u" && "checkVisibility" in Element.prototype;
function bL(e) {
  const t = Sn(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement)) return !1;
  let { display: n, visibility: r } = e.style, i = n !== "none" && r !== "hidden" && r !== "collapse";
  if (i) {
    const { getComputedStyle: o } = e.ownerDocument.defaultView;
    let { display: a, visibility: s } = o(e);
    i = a !== "none" && s !== "hidden" && s !== "collapse";
  }
  return i;
}
function _L(e, t) {
  return !e.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !e.hasAttribute("data-react-aria-prevent-focus") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function yb(e, t) {
  return yL ? e.checkVisibility({
    visibilityProperty: !0
  }) && !e.closest("[data-react-aria-prevent-focus]") : e.nodeName !== "#comment" && bL(e) && _L(e, t) && (!e.parentElement || yb(e.parentElement, e));
}
const bb = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])',
  "permission"
], wL = bb.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
bb.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const xL = bb.join(':not([hidden]):not([tabindex="-1"]),');
function sk(e) {
  return e.matches(wL) && yb(e) && !uk(e);
}
function lk(e) {
  return e.matches(xL) && yb(e) && !uk(e);
}
function uk(e) {
  let t = e;
  for (; t != null; ) {
    if (t instanceof t.ownerDocument.defaultView.HTMLElement && t.inert) return !0;
    t = t.parentElement;
  }
  return !1;
}
var Wh;
const EL = typeof document < "u" ? (Wh = G.useInsertionEffect) !== null && Wh !== void 0 ? Wh : G.useLayoutEffect : () => {
};
function fp(e, t, n) {
  let [r, i] = je(e || t), o = ve(r), a = ve(e !== void 0), s = e !== void 0;
  De(() => {
    let f = a.current;
    f !== s && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}.`), a.current = s;
  }, [
    s
  ]);
  let l = s ? e : r;
  EL(() => {
    o.current = l;
  });
  let [, u] = b$(() => ({}), {}), c = Ne((f, ...d) => {
    let p = typeof f == "function" ? f(o.current) : f;
    Object.is(o.current, p) || (o.current = p, i(p), u(), n?.(p, ...d));
  }, [
    n
  ]);
  return [
    l,
    c
  ];
}
function Gv(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
const _b = Symbol("default");
function Ra({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ G.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function Rr(e) {
  let { className: t, style: n, children: r, defaultClassName: i, defaultChildren: o, defaultStyle: a, values: s, render: l } = e;
  return Ee(() => {
    let u, c, f;
    return typeof t == "function" ? u = t({
      ...s,
      defaultClassName: i
    }) : u = t, typeof n == "function" ? c = n({
      ...s,
      defaultStyle: a || {}
    }) : c = n, typeof r == "function" ? f = r({
      ...s,
      defaultChildren: o
    }) : r == null ? f = o : f = r, {
      className: u ?? i,
      style: c || a ? {
        ...a,
        ...c
      } : void 0,
      children: f ?? o,
      "data-rac": "",
      render: l ? (d) => l(d, s) : void 0
    };
  }, [
    t,
    n,
    r,
    i,
    o,
    a,
    s,
    l
  ]);
}
function dp(e, t) {
  let n = Ce(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || _b;
    if (!n.slots[r]) {
      let i = new Intl.ListFormat().format(Object.keys(n.slots).map((a) => `"${a}"`)), o = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${o} Valid slot names are ${i}.`);
    }
    return n.slots[r];
  }
  return n;
}
function Ai(e, t, n) {
  let r = dp(n, e.slot) || {}, { ref: i, ...o } = r, a = ol(Ee(() => fb(t, i), [
    t,
    i
  ])), s = nt(o, e);
  return "style" in o && o.style && "style" in e && e.style && (typeof o.style == "function" || typeof e.style == "function" ? s.style = (l) => {
    let u = typeof o.style == "function" ? o.style(l) : o.style, c = {
      ...l.defaultStyle,
      ...u
    }, f = typeof e.style == "function" ? e.style({
      ...l,
      defaultStyle: c
    }) : e.style;
    return {
      ...c,
      ...f
    };
  } : s.style = {
    ...o.style,
    ...e.style
  }), [
    s,
    a
  ];
}
function wb(e = !0) {
  let [t, n] = je(e), r = ve(!1), i = Ne((o) => {
    r.current = !0, n(!!o);
  }, []);
  return ot(() => {
    r.current || n(!1);
  }, []), [
    i,
    t
  ];
}
function SL(e) {
  const t = /^(data-.*)$/;
  let n = {};
  for (const r in e) t.test(r) || (n[r] = e[r]);
  return n;
}
function $L(e, t, n) {
  let { render: r, ...i } = t, o = ve(null), a = Ee(() => fb(n, o), [
    n,
    o
  ]);
  ot(() => {
    process.env.NODE_ENV !== "production" && r && (o.current ? o.current.localName !== e && console.warn(`Unexpected DOM element returned by custom \`render\` function. Expected <${e}>, got <${o.current.localName}>. This may break the component behavior and accessibility.`) : console.warn("Ref was not connected to DOM element returned by custom `render` function. Did you forget to pass through or merge the `ref`?"));
  }, [
    e,
    r
  ]);
  let s = {
    ...i,
    ref: a
  };
  return r ? r(s, void 0) : /* @__PURE__ */ G.createElement(e, s);
}
const Zw = {}, Fn = new Proxy({}, {
  get(e, t) {
    if (typeof t != "string") return;
    let n = Zw[t];
    return n || (n = /* @__PURE__ */ Jt($L.bind(null, t)), Zw[t] = n), n;
  }
}), ck = 7e3;
let hi = null;
function Gw(e, t = "assertive", n = ck) {
  hi ? hi.announce(e, t, n) : (hi = new TL(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? hi.announce(e, t, n) : setTimeout(() => {
    hi?.isAttached() && hi?.announce(e, t, n);
  }, 100));
}
class TL {
  isAttached() {
    var t;
    return (t = this.node) === null || t === void 0 ? void 0 : t.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = ck) {
    var i, o;
    if (!this.node) return;
    let a = document.createElement("div");
    typeof t == "object" ? (a.setAttribute("role", "img"), a.setAttribute("aria-labelledby", t["aria-labelledby"])) : a.textContent = t, n === "assertive" ? (i = this.assertiveLog) === null || i === void 0 || i.appendChild(a) : (o = this.politeLog) === null || o === void 0 || o.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
const yr = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, sd = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, OL = {
  top: "left",
  left: "top"
}, Yv = {
  top: "height",
  left: "width"
}, fk = {
  width: "totalWidth",
  height: "totalHeight"
}, Fc = {};
let kL = () => typeof document < "u" ? window.visualViewport : null;
function Yw(e, t) {
  let n = 0, r = 0, i = 0, o = 0, a = 0, s = 0, l = {};
  var u;
  let c = ((u = t?.scale) !== null && u !== void 0 ? u : 1) > 1;
  if (e.tagName === "BODY" || e.tagName === "HTML") {
    let m = document.documentElement;
    i = m.clientWidth, o = m.clientHeight;
    var f;
    n = (f = t?.width) !== null && f !== void 0 ? f : i;
    var d;
    r = (d = t?.height) !== null && d !== void 0 ? d : o, l.top = m.scrollTop || e.scrollTop, l.left = m.scrollLeft || e.scrollLeft, t && (a = t.offsetTop, s = t.offsetLeft);
  } else
    ({ width: n, height: r, top: a, left: s } = Ou(e, !1)), l.top = e.scrollTop, l.left = e.scrollLeft, i = n, o = r;
  if (pb() && (e.tagName === "BODY" || e.tagName === "HTML") && c) {
    l.top = 0, l.left = 0;
    var p;
    a = (p = t?.pageTop) !== null && p !== void 0 ? p : 0;
    var h;
    s = (h = t?.pageLeft) !== null && h !== void 0 ? h : 0;
  }
  return {
    width: n,
    height: r,
    totalWidth: i,
    totalHeight: o,
    scroll: l,
    top: a,
    left: s
  };
}
function PL(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function Qw(e, t, n, r, i, o, a) {
  var s;
  let l = (s = i.scroll[e]) !== null && s !== void 0 ? s : 0, u = r[Yv[e]], c = a[e] + r.scroll[yr[e]] + o, f = a[e] + r.scroll[yr[e]] + u - o, d = t - l + r.scroll[yr[e]] + a[e] - r[yr[e]], p = t - l + n + r.scroll[yr[e]] + a[e] - r[yr[e]];
  return d < c ? c - d : p > f ? Math.max(f - p, c - d) : 0;
}
function DL(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function Jw(e) {
  if (Fc[e]) return Fc[e];
  let [t, n] = e.split(" "), r = yr[t] || "right", i = OL[r];
  yr[n] || (n = "center");
  let o = Yv[r], a = Yv[i];
  return Fc[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: i,
    size: o,
    crossSize: a
  }, Fc[e];
}
function Zh(e, t, n, r, i, o, a, s, l, u, c) {
  let { placement: f, crossPlacement: d, axis: p, crossAxis: h, size: m, crossSize: v } = r, g = {};
  var b;
  g[h] = (b = e[h]) !== null && b !== void 0 ? b : 0;
  var E, x, S, $;
  d === "center" ? g[h] += (((E = e[v]) !== null && E !== void 0 ? E : 0) - ((x = n[v]) !== null && x !== void 0 ? x : 0)) / 2 : d !== h && (g[h] += ((S = e[v]) !== null && S !== void 0 ? S : 0) - (($ = n[v]) !== null && $ !== void 0 ? $ : 0)), g[h] += o;
  const P = e[h] - n[v] + l + u, y = e[h] + e[v] - l - u;
  if (g[h] = Gv(g[h], P, y), f === p) {
    let _ = s ? c[m] : c[fk[m]];
    g[sd[p]] = Math.floor(_ - e[p] + i);
  } else g[p] = Math.floor(e[p] + e[m] + i);
  return g;
}
function AL(e, t, n, r, i, o, a, s, l, u, c) {
  var f, d;
  let p = (e.top != null ? e.top : l[fk.height] - ((f = e.bottom) !== null && f !== void 0 ? f : 0) - a) - ((d = l.scroll.top) !== null && d !== void 0 ? d : 0), h = u ? n.top : 0;
  var m, v, g;
  let b = {
    // This should be boundary top in container coord system vs viewport top in container coord system
    // For the viewport top, there are several cases
    // 1. pinchzoom case where we want the viewports offset top as top here
    // 2. case where container is offset from the boundary and is contained by the boundary. In this case the top we want here is NOT 0, we want to take boundary's top even though is is a negative number OR the visual viewport, whichever is more restrictive
    top: Math.max(t.top + h, ((m = c?.offsetTop) !== null && m !== void 0 ? m : t.top) + h),
    bottom: Math.min(t.top + t.height + h, ((v = c?.offsetTop) !== null && v !== void 0 ? v : 0) + ((g = c?.height) !== null && g !== void 0 ? g : 0))
  };
  var E, x, S, $;
  return s !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, b.bottom - p - (((E = i.top) !== null && E !== void 0 ? E : 0) + ((x = i.bottom) !== null && x !== void 0 ? x : 0) + o))
  ) : Math.max(0, p + a - b.top - (((S = i.top) !== null && S !== void 0 ? S : 0) + (($ = i.bottom) !== null && $ !== void 0 ? $ : 0) + o));
}
function Xw(e, t, n, r, i, o, a, s) {
  let { placement: l, axis: u, size: c } = o;
  var f, d;
  if (l === u) return Math.max(0, n[u] - ((f = a.scroll[u]) !== null && f !== void 0 ? f : 0) - (e[u] + (s ? t[u] : 0)) - ((d = r[u]) !== null && d !== void 0 ? d : 0) - r[sd[u]] - i);
  var p, h;
  return Math.max(0, e[c] + e[u] + (s ? t[u] : 0) - n[u] - n[c] + ((p = a.scroll[u]) !== null && p !== void 0 ? p : 0) - ((h = r[u]) !== null && h !== void 0 ? h : 0) - r[sd[u]] - i);
}
function CL(e, t, n, r, i, o, a, s, l, u, c, f, d, p, h, m, v, g) {
  let b = Jw(e), { size: E, crossAxis: x, crossSize: S, placement: $, crossPlacement: P } = b, y = Zh(t, s, n, b, c, f, u, d, h, m, l), _ = c, w = Xw(s, u, t, i, o + c, b, l, v);
  if (a && n[E] > w) {
    let O = Jw(`${sd[$]} ${P}`), D = Zh(t, s, n, O, c, f, u, d, h, m, l);
    Xw(s, u, t, i, o + c, O, l, v) > w && (b = O, y = D, _ = c);
  }
  let A = "bottom";
  b.axis === "top" ? b.placement === "top" ? A = "top" : b.placement === "bottom" && (A = "bottom") : b.crossAxis === "top" && (b.crossPlacement === "top" ? A = "bottom" : b.crossPlacement === "bottom" && (A = "top"));
  let k = Qw(x, y[x], n[S], s, l, o, u);
  y[x] += k;
  let N = AL(y, s, u, d, i, o, n.height, A, l, v, g);
  p && p < N && (N = p), n.height = Math.min(n.height, N), y = Zh(t, s, n, b, _, f, u, d, h, m, l), k = Qw(x, y[x], n[S], s, l, o, u), y[x] += k;
  let I = {}, B = t[x] - y[x] - i[yr[x]], q = B + 0.5 * t[S];
  const ee = h / 2 + m;
  var re, Z, T, F;
  const M = yr[x] === "left" ? ((re = i.left) !== null && re !== void 0 ? re : 0) + ((Z = i.right) !== null && Z !== void 0 ? Z : 0) : ((T = i.top) !== null && T !== void 0 ? T : 0) + ((F = i.bottom) !== null && F !== void 0 ? F : 0), K = n[S] - M - h / 2 - m, te = t[x] + h / 2 - (y[x] + i[yr[x]]), se = t[x] + t[S] - h / 2 - (y[x] + i[yr[x]]), de = Gv(q, te, se);
  I[x] = Gv(de, ee, K), { placement: $, crossPlacement: P } = b, h ? B = I[x] : P === "right" ? B += t[S] : P === "center" && (B += t[S] / 2);
  let ge = $ === "left" || $ === "top" ? n[E] : 0, V = {
    x: $ === "top" || $ === "bottom" ? B : ge,
    y: $ === "left" || $ === "right" ? B : ge
  };
  return {
    position: y,
    maxHeight: N,
    arrowOffsetLeft: I.left,
    arrowOffsetTop: I.top,
    placement: $,
    triggerAnchorPoint: V
  };
}
function IL(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: i, padding: o, shouldFlip: a, boundaryElement: s, offset: l, crossOffset: u, maxHeight: c, arrowSize: f = 0, arrowBoundaryOffset: d = 0 } = e, p = kL(), h = r instanceof HTMLElement ? ML(r) : document.documentElement, m = h === document.documentElement;
  const v = window.getComputedStyle(h).position;
  let g = !!v && v !== "static", b = m ? Ou(n, !1) : ex(n, h, !1);
  if (!m) {
    let { marginTop: I, marginLeft: B } = window.getComputedStyle(n);
    b.top += parseInt(I, 10) || 0, b.left += parseInt(B, 10) || 0;
  }
  let E = Ou(r, !0), x = DL(r);
  var S, $;
  E.width += ((S = x.left) !== null && S !== void 0 ? S : 0) + (($ = x.right) !== null && $ !== void 0 ? $ : 0);
  var P, y;
  E.height += ((P = x.top) !== null && P !== void 0 ? P : 0) + ((y = x.bottom) !== null && y !== void 0 ? y : 0);
  let _ = PL(i), w = Yw(s, p), A = Yw(h, p), k;
  if ((s.tagName === "BODY" || s.tagName === "HTML") && !m) {
    let I = pp(h, !1);
    k = {
      top: -(I.top - w.top),
      left: -(I.left - w.left),
      width: 0,
      height: 0
    };
  } else (s.tagName === "BODY" || s.tagName === "HTML") && m ? k = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  } : k = ex(s, h, !1);
  let N = We(s, h);
  return CL(t, b, E, _, x, o, a, w, A, k, l, u, g, c, f, d, N, p);
}
function pp(e, t) {
  let { top: n, left: r, width: i, height: o } = e.getBoundingClientRect();
  return t && e instanceof e.ownerDocument.defaultView.HTMLElement && (i = e.offsetWidth, o = e.offsetHeight), {
    top: n,
    left: r,
    width: i,
    height: o
  };
}
function Ou(e, t) {
  let { top: n, left: r, width: i, height: o } = pp(e, t), { scrollTop: a, scrollLeft: s, clientTop: l, clientLeft: u } = document.documentElement;
  return {
    top: n + a - l,
    left: r + s - u,
    width: i,
    height: o
  };
}
function ex(e, t, n) {
  let r = window.getComputedStyle(e), i;
  if (r.position === "fixed") i = pp(e, n);
  else {
    i = Ou(e, n);
    let o = Ou(t, n), a = window.getComputedStyle(t);
    o.top += (parseInt(a.borderTopWidth, 10) || 0) - t.scrollTop, o.left += (parseInt(a.borderLeftWidth, 10) || 0) - t.scrollLeft, i.top -= o.top, i.left -= o.left;
  }
  return i.top -= parseInt(r.marginTop, 10) || 0, i.left -= parseInt(r.marginLeft, 10) || 0, i;
}
function ML(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !tx(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !tx(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function tx(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || "backdropFilter" in t && t.backdropFilter !== "none" || "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const dk = /* @__PURE__ */ new WeakMap();
function RL(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  De(() => {
    if (!n || r === null) return;
    let i = (o) => {
      let a = Te(o);
      if (!t.current || a instanceof Node && !We(a, t.current) || a instanceof HTMLInputElement || a instanceof HTMLTextAreaElement) return;
      let s = r || dk.get(t.current);
      s && s();
    };
    return window.addEventListener("scroll", i, !0), () => {
      window.removeEventListener("scroll", i, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
const NL = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), jL = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function FL(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return NL.has(n.script);
  }
  let t = e.split("-")[0];
  return jL.has(t);
}
const pk = Symbol.for("react-aria.i18n.locale");
function hk() {
  let e = typeof window < "u" && window[pk] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: FL(e) ? "rtl" : "ltr"
  };
}
let Qv = hk(), Zl = /* @__PURE__ */ new Set();
function nx() {
  Qv = hk();
  for (let e of Zl) e(Qv);
}
function zL() {
  let e = ic(), [t, n] = je(Qv);
  return De(() => (Zl.size === 0 && window.addEventListener("languagechange", nx), Zl.add(n), () => {
    Zl.delete(n), Zl.size === 0 && window.removeEventListener("languagechange", nx);
  }), []), e ? {
    locale: typeof window < "u" && window[pk] || "en-US",
    direction: "ltr"
  } : t;
}
const LL = /* @__PURE__ */ G.createContext(null);
function al() {
  let e = zL();
  return Ce(LL) || e;
}
function Na(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (f) {
        a(f);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (f) {
        a(f);
      }
    }
    function u(c) {
      c.done ? o(c.value) : i(c.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
const VL = Symbol.for("react-aria.i18n.locale"), BL = Symbol.for("react-aria.i18n.strings");
let Ga;
class hp {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, n) {
    let i = this.getStringsForLocale(n)[t];
    if (!i) throw new Error(`Could not find intl message ${t} in ${n} locale`);
    return i;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let n = this.strings[t];
    return n || (n = KL(t, this.strings, this.defaultLocale), this.strings[t] = n), n;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u") return null;
    let n = window[VL];
    if (Ga === void 0) {
      let i = window[BL];
      if (!i) return null;
      Ga = {};
      for (let o in i) Ga[o] = new hp({
        [n]: i[o]
      }, n);
    }
    let r = Ga?.[t];
    if (!r) throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
  constructor(t, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(t).filter(([, r]) => r)), this.defaultLocale = n;
  }
}
function KL(e, t, n = "en-US") {
  if (t[e]) return t[e];
  let r = UL(e);
  if (t[r]) return t[r];
  for (let i in t)
    if (i.startsWith(r + "-")) return t[i];
  return t[n];
}
function UL(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const rx = /* @__PURE__ */ new Map(), ix = /* @__PURE__ */ new Map();
class qL {
  /** Formats a localized string for the given key with the provided variables. */
  format(t, n) {
    let r = this.strings.getStringForLocale(t, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(t, n, r = "cardinal") {
    let i = n["=" + t];
    if (i) return typeof i == "function" ? i() : i;
    let o = this.locale + ":" + r, a = rx.get(o);
    a || (a = new Intl.PluralRules(this.locale, {
      type: r
    }), rx.set(o, a));
    let s = a.select(t);
    return i = n[s] || n.other, typeof i == "function" ? i() : i;
  }
  number(t) {
    let n = ix.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), ix.set(this.locale, n)), n.format(t);
  }
  select(t, n) {
    let r = t[n] || t.other;
    return typeof r == "function" ? r() : r;
  }
  constructor(t, n) {
    this.locale = t, this.strings = n;
  }
}
const ox = /* @__PURE__ */ new WeakMap();
function HL(e) {
  let t = ox.get(e);
  return t || (t = new hp(e), ox.set(e, t)), t;
}
function WL(e, t) {
  return t && hp.getGlobalDictionaryForPackage(t) || HL(e);
}
function mk(e, t) {
  let { locale: n } = al(), r = WL(e, t);
  return Ee(() => new qL(n, r), [
    n,
    r
  ]);
}
function ZL(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function GL(e, t, n) {
  ZL(e, t), t.set(e, n);
}
let Gh = /* @__PURE__ */ new Map();
function xb(e) {
  let { locale: t } = al(), n = t + (e ? Object.entries(e).sort((i, o) => i[0] < o[0] ? -1 : 1).join() : "");
  if (Gh.has(n)) return Gh.get(n);
  let r = new Intl.Collator(t, e);
  return Gh.set(n, r), r;
}
let Wt = typeof document < "u" ? window.visualViewport : null;
function YL(e) {
  let { direction: t } = al(), { arrowSize: n, targetRef: r, overlayRef: i, arrowRef: o, scrollRef: a = i, placement: s = "bottom", containerPadding: l = 12, shouldFlip: u = !0, boundaryElement: c = typeof document < "u" ? document.body : null, offset: f = 0, crossOffset: d = 0, shouldUpdatePosition: p = !0, isOpen: h = !0, onClose: m, maxHeight: v, arrowBoundaryOffset: g = 0 } = e, [b, E] = je(null), x = [
    p,
    s,
    i.current,
    r.current,
    o?.current,
    a.current,
    l,
    u,
    c,
    f,
    d,
    h,
    t,
    v,
    g,
    n
  ], S = ve(Wt?.scale);
  De(() => {
    h && (S.current = Wt?.scale);
  }, [
    h
  ]);
  let $ = Ne(() => {
    if (p === !1 || !h || !i.current || !r.current || !c || Wt?.scale !== S.current) return;
    let k = null;
    if (a.current && od(a.current)) {
      var N;
      let F = (N = Rt()) === null || N === void 0 ? void 0 : N.getBoundingClientRect(), M = a.current.getBoundingClientRect();
      var I;
      if (k = {
        type: "top",
        offset: ((I = F?.top) !== null && I !== void 0 ? I : 0) - M.top
      }, k.offset > M.height / 2) {
        k.type = "bottom";
        var B;
        k.offset = ((B = F?.bottom) !== null && B !== void 0 ? B : 0) - M.bottom;
      }
    }
    let q = i.current;
    if (!v && i.current) {
      var ee;
      q.style.top = "0px", q.style.bottom = "";
      var re;
      q.style.maxHeight = ((re = (ee = window.visualViewport) === null || ee === void 0 ? void 0 : ee.height) !== null && re !== void 0 ? re : window.innerHeight) + "px";
    }
    let Z = IL({
      placement: JL(s, t),
      overlayNode: i.current,
      targetNode: r.current,
      scrollNode: a.current || i.current,
      padding: l,
      shouldFlip: u,
      boundaryElement: c,
      offset: f,
      crossOffset: d,
      maxHeight: v,
      arrowSize: n ?? (o?.current ? pp(o.current, !0).width : 0),
      arrowBoundaryOffset: g
    });
    if (!Z.position) return;
    q.style.top = "", q.style.bottom = "", q.style.left = "", q.style.right = "", Object.keys(Z.position).forEach((F) => q.style[F] = Z.position[F] + "px"), q.style.maxHeight = Z.maxHeight != null ? Z.maxHeight + "px" : "";
    let T = Rt();
    if (k && T && a.current) {
      let F = T.getBoundingClientRect(), M = a.current.getBoundingClientRect(), K = F[k.type] - M[k.type];
      a.current.scrollTop += K - k.offset;
    }
    E(Z);
  }, x);
  ot($, x), QL($), ad({
    ref: i,
    onResize: $
  }), ad({
    ref: r,
    onResize: $
  });
  let P = ve(!1);
  ot(() => {
    let k, N = () => {
      P.current = !0, clearTimeout(k), k = setTimeout(() => {
        P.current = !1;
      }, 500), $();
    }, I = () => {
      P.current && N();
    };
    return Wt?.addEventListener("resize", N), Wt?.addEventListener("scroll", I), () => {
      Wt?.removeEventListener("resize", N), Wt?.removeEventListener("scroll", I);
    };
  }, [
    $
  ]);
  let y = Ne(() => {
    P.current || m?.();
  }, [
    m,
    P
  ]);
  RL({
    triggerRef: r,
    isOpen: h,
    onClose: m && y
  });
  var _, w, A;
  return {
    overlayProps: {
      style: {
        position: b ? "absolute" : "fixed",
        top: b ? void 0 : 0,
        left: b ? void 0 : 0,
        zIndex: 1e5,
        ...b?.position,
        maxHeight: (_ = b?.maxHeight) !== null && _ !== void 0 ? _ : "100vh"
      }
    },
    placement: (w = b?.placement) !== null && w !== void 0 ? w : null,
    triggerAnchorPoint: (A = b?.triggerAnchorPoint) !== null && A !== void 0 ? A : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: b?.arrowOffsetLeft,
        top: b?.arrowOffsetTop
      }
    },
    updatePosition: $
  };
}
function QL(e) {
  ot(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function JL(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
function Eb(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function vk(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function gk(e) {
  let t = ve({
    isFocused: !1,
    observer: null
  });
  return ot(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []), Ne((n) => {
    let r = Te(n);
    if (r instanceof HTMLButtonElement || r instanceof HTMLInputElement || r instanceof HTMLTextAreaElement || r instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let i = r, o = (a) => {
        if (t.current.isFocused = !1, i.disabled) {
          let s = Eb(a);
          e?.(s);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      i.addEventListener("focusout", o, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && i.disabled) {
          var a;
          (a = t.current.observer) === null || a === void 0 || a.disconnect();
          let s = i === Rt() ? null : Rt();
          i.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), i.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(i, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    e
  ]);
}
let ld = !1;
function ax(e) {
  for (; e && !sk(e); ) e = e.parentElement;
  let t = Sn(e), n = t.document.activeElement;
  if (!n || n === e) return;
  ld = !0;
  let r = !1, i = (c) => {
    (Te(c) === n || r) && c.stopImmediatePropagation();
  }, o = (c) => {
    (Te(c) === n || r) && (c.stopImmediatePropagation(), !e && !r && (r = !0, ni(n), l()));
  }, a = (c) => {
    (Te(c) === e || r) && c.stopImmediatePropagation();
  }, s = (c) => {
    (Te(c) === e || r) && (c.stopImmediatePropagation(), r || (r = !0, ni(n), l()));
  };
  t.addEventListener("blur", i, !0), t.addEventListener("focusout", o, !0), t.addEventListener("focusin", s, !0), t.addEventListener("focus", a, !0);
  let l = () => {
    cancelAnimationFrame(u), t.removeEventListener("blur", i, !0), t.removeEventListener("focusout", o, !0), t.removeEventListener("focusin", s, !0), t.removeEventListener("focus", a, !0), ld = !1, r = !1;
  }, u = requestAnimationFrame(l);
  return l;
}
let ds = "default", Jv = "", Ef = /* @__PURE__ */ new WeakMap();
function sx(e) {
  if (oc()) {
    if (ds === "default") {
      const t = Qe(e);
      Jv = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    ds = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    Ef.set(e, e.style[t]), e.style[t] = "none";
  }
}
function Yh(e) {
  if (oc()) {
    if (ds !== "disabled") return;
    ds = "restoring", setTimeout(() => {
      ik(() => {
        if (ds === "restoring") {
          const t = Qe(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = Jv || ""), Jv = "", ds = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Ef.has(e)) {
    let t = Ef.get(e), n = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[n] === "none" && (e.style[n] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Ef.delete(e);
  }
}
const ku = G.createContext({
  register: () => {
  }
});
ku.displayName = "PressResponderContext";
function XL(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function yk(e, t, n) {
  if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return t.get(e);
}
function e9(e, t) {
  var n = yk(e, t, "get");
  return XL(e, n);
}
function t9(e, t, n) {
  if (t.set) t.set.call(e, n);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = n;
  }
}
function lx(e, t, n) {
  var r = yk(e, t, "set");
  return t9(e, r, n), n;
}
function n9(e) {
  let t = Ce(ku);
  if (t) {
    let { register: n, ref: r, ...i } = t;
    e = nt(i, e), n();
  }
  return vb(t, e.ref), e;
}
var zc = /* @__PURE__ */ new WeakMap();
class Lc {
  continuePropagation() {
    lx(this, zc, !1);
  }
  get shouldStopPropagation() {
    return e9(this, zc);
  }
  constructor(t, n, r, i) {
    GL(this, zc, {
      writable: !0,
      value: void 0
    }), lx(this, zc, !0);
    var o;
    let a = (o = i?.target) !== null && o !== void 0 ? o : r.currentTarget;
    const s = a?.getBoundingClientRect();
    let l, u = 0, c, f = null;
    r.clientX != null && r.clientY != null && (c = r.clientX, f = r.clientY), s && (c != null && f != null ? (l = c - s.left, u = f - s.top) : (l = s.width / 2, u = s.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = l, this.y = u, this.key = r.key;
  }
}
const ux = Symbol("linkClicked"), cx = "react-aria-pressable-style", fx = "data-react-aria-pressable";
function mp(e) {
  let { onPress: t, onPressChange: n, onPressStart: r, onPressEnd: i, onPressUp: o, onClick: a, isDisabled: s, isPressed: l, preventFocusOnPress: u, shouldCancelOnPointerExit: c, allowTextSelectionOnPress: f, ref: d, ...p } = n9(e), [h, m] = je(!1), v = ve({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: g, removeAllGlobalListeners: b, removeGlobalListener: E } = cp(), x = Ne((T, F) => {
    let M = v.current;
    if (s || M.didFirePressStart) return !1;
    let K = !0;
    if (M.isTriggeringEvent = !0, r) {
      let te = new Lc("pressstart", F, T);
      r(te), K = te.shouldStopPropagation;
    }
    return n && n(!0), M.isTriggeringEvent = !1, M.didFirePressStart = !0, m(!0), K;
  }, [
    s,
    r,
    n
  ]), S = Ne((T, F, M = !0) => {
    let K = v.current;
    if (!K.didFirePressStart) return !1;
    K.didFirePressStart = !1, K.isTriggeringEvent = !0;
    let te = !0;
    if (i) {
      let se = new Lc("pressend", F, T);
      i(se), te = se.shouldStopPropagation;
    }
    if (n && n(!1), m(!1), t && M && !s) {
      let se = new Lc("press", F, T);
      t(se), te && (te = se.shouldStopPropagation);
    }
    return K.isTriggeringEvent = !1, te;
  }, [
    s,
    i,
    n,
    t
  ]), $ = or(S), P = Ne((T, F) => {
    let M = v.current;
    if (s) return !1;
    if (o) {
      M.isTriggeringEvent = !0;
      let K = new Lc("pressup", F, T);
      return o(K), M.isTriggeringEvent = !1, K.shouldStopPropagation;
    }
    return !0;
  }, [
    s,
    o
  ]), y = or(P), _ = Ne((T) => {
    let F = v.current;
    if (F.isPressed && F.target) {
      F.didFirePressStart && F.pointerType != null && S(Yo(F.target, T), F.pointerType, !1), F.isPressed = !1, re(null), F.isOverTarget = !1, F.activePointerId = null, F.pointerType = null, b(), f || Yh(F.target);
      for (let M of F.disposables) M();
      F.disposables = [];
    }
  }, [
    f,
    b,
    S
  ]), w = or(_), A = Ne((T) => {
    c && _(T);
  }, [
    c,
    _
  ]), k = Ne((T) => {
    s || a?.(T);
  }, [
    s,
    a
  ]), N = Ne((T, F) => {
    if (!s && a) {
      let M = new MouseEvent("click", T);
      vk(M, F), a(Eb(M));
    }
  }, [
    s,
    a
  ]), I = or(N), [B, q] = je(!1);
  ot(() => {
    let T = v.current;
    if (B) {
      let F = (se) => {
        var de;
        if (T.isPressed && T.target && Qh(se, T.target)) {
          var ge;
          hx(Te(se), se.key) && se.preventDefault();
          let O = Te(se), D = We(T.target, O);
          $(Yo(T.target, se), "keyboard", D), D && I(se, T.target), b(), se.key !== "Enter" && Sb(T.target) && We(T.target, O) && !se[ux] && (se[ux] = !0, Wi(T.target, se, !1)), T.isPressed = !1, q(!1), (ge = T.metaKeyEvents) === null || ge === void 0 || ge.delete(se.key);
        } else if (se.key === "Meta" && (!((de = T.metaKeyEvents) === null || de === void 0) && de.size)) {
          var V;
          let O = T.metaKeyEvents;
          T.metaKeyEvents = void 0;
          for (let D of O.values()) (V = T.target) === null || V === void 0 || V.dispatchEvent(new KeyboardEvent("keyup", D));
        }
      }, M = T.target, te = Ma((se) => {
        M && Qh(se, M) && !se.repeat && We(M, Te(se)) && T.target && y(Yo(T.target, se), "keyboard");
      }, F);
      return g(Qe(T.target), "keyup", te, !0), () => {
        E(Qe(T.target), "keyup", te, !0);
      };
    }
  }, [
    B,
    g,
    b,
    E
  ]);
  let [ee, re] = je(null);
  ot(() => {
    let T = v.current;
    if (ee === "pointer") {
      let F = (K) => {
        if (K.pointerId === T.activePointerId && T.isPressed && K.button === 0 && T.target) {
          if (We(T.target, Te(K)) && T.pointerType != null) {
            let te = !1, se = setTimeout(() => {
              T.isPressed && T.target instanceof HTMLElement && (te ? w(K) : (ni(T.target), T.target.click()));
            }, 80);
            K.currentTarget && g(K.currentTarget, "click", () => te = !0, !0), T.disposables.push(() => clearTimeout(se));
          } else w(K);
          T.isOverTarget = !1;
        }
      }, M = (K) => {
        w(K);
      };
      return g(Qe(T.target), "pointerup", F, !1), g(Qe(T.target), "pointercancel", M, !1), () => {
        E(Qe(T.target), "pointerup", F, !1), E(Qe(T.target), "pointercancel", M, !1);
      };
    } else if (ee === "mouse" && process.env.NODE_ENV === "test") {
      let F = (M) => {
        if (M.button === 0) {
          if (T.ignoreEmulatedMouseEvents) {
            T.ignoreEmulatedMouseEvents = !1;
            return;
          }
          T.target && We(T.target, M.target) && T.pointerType != null || w(M), T.isOverTarget = !1;
        }
      };
      return g(Qe(T.target), "mouseup", F, !1), () => {
        E(Qe(T.target), "mouseup", F, !1);
      };
    } else if (ee === "touch" && process.env.NODE_ENV === "test") {
      let F = (M) => {
        T.isPressed && We(Te(M), T.target) && w({
          currentTarget: T.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      return g(Sn(T.target), "scroll", F, !0), () => {
        E(Sn(T.target), "scroll", F, !0);
      };
    }
  }, [
    ee,
    g,
    E
  ]);
  let Z = Ee(() => {
    let T = v.current, F = {
      onKeyDown(M) {
        if (Qh(M.nativeEvent, M.currentTarget) && We(M.currentTarget, Te(M))) {
          var K;
          hx(Te(M), M.key) && M.preventDefault();
          let te = !0;
          !T.isPressed && !M.repeat && (T.target = M.currentTarget, T.isPressed = !0, q(!0), T.pointerType = "keyboard", te = x(M, "keyboard")), te && M.stopPropagation(), M.metaKey && Oo() && ((K = T.metaKeyEvents) === null || K === void 0 || K.set(M.key, M.nativeEvent));
        } else M.key === "Meta" && (T.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(M) {
        if (!(M && !We(M.currentTarget, Te(M))) && M && M.button === 0 && !T.isTriggeringEvent && !Wi.isOpening) {
          let K = !0;
          if (s && M.preventDefault(), !T.ignoreEmulatedMouseEvents && !T.isPressed && (T.pointerType === "virtual" || Zv(M.nativeEvent))) {
            let te = x(M, "virtual"), se = P(M, "virtual"), de = S(M, "virtual");
            k(M), K = te && se && de;
          } else if (T.isPressed && T.pointerType !== "keyboard") {
            let te = T.pointerType || M.nativeEvent.pointerType || "virtual", se = P(Yo(M.currentTarget, M), te), de = S(Yo(M.currentTarget, M), te, !0);
            K = se && de, T.isOverTarget = !1, k(M), _(M);
          }
          T.ignoreEmulatedMouseEvents = !1, K && M.stopPropagation();
        }
      }
    };
    return typeof PointerEvent < "u" ? (F.onPointerDown = (M) => {
      if (M.button !== 0 || !We(M.currentTarget, Te(M))) return;
      if (cL(M.nativeEvent)) {
        T.pointerType = "virtual";
        return;
      }
      T.pointerType = M.pointerType;
      let K = !0;
      if (!T.isPressed) {
        T.isPressed = !0, re("pointer"), T.isOverTarget = !0, T.activePointerId = M.pointerId, T.target = M.currentTarget, f || sx(T.target), K = x(M, T.pointerType);
        let te = Te(M);
        "releasePointerCapture" in te && ("hasPointerCapture" in te ? te.hasPointerCapture(M.pointerId) && te.releasePointerCapture(M.pointerId) : te.releasePointerCapture(M.pointerId));
      }
      K && M.stopPropagation();
    }, F.onMouseDown = (M) => {
      if (We(M.currentTarget, Te(M)) && M.button === 0) {
        if (u) {
          let K = ax(M.target);
          K && T.disposables.push(K);
        }
        M.stopPropagation();
      }
    }, F.onPointerUp = (M) => {
      !We(M.currentTarget, Te(M)) || T.pointerType === "virtual" || M.button === 0 && !T.isPressed && P(M, T.pointerType || M.pointerType);
    }, F.onPointerEnter = (M) => {
      M.pointerId === T.activePointerId && T.target && !T.isOverTarget && T.pointerType != null && (T.isOverTarget = !0, x(Yo(T.target, M), T.pointerType));
    }, F.onPointerLeave = (M) => {
      M.pointerId === T.activePointerId && T.target && T.isOverTarget && T.pointerType != null && (T.isOverTarget = !1, S(Yo(T.target, M), T.pointerType, !1), A(M));
    }, F.onDragStart = (M) => {
      We(M.currentTarget, Te(M)) && _(M);
    }) : process.env.NODE_ENV === "test" && (F.onMouseDown = (M) => {
      if (M.button !== 0 || !We(M.currentTarget, Te(M))) return;
      if (T.ignoreEmulatedMouseEvents) {
        M.stopPropagation();
        return;
      }
      if (T.isPressed = !0, re("mouse"), T.isOverTarget = !0, T.target = M.currentTarget, T.pointerType = Zv(M.nativeEvent) ? "virtual" : "mouse", xy(() => x(M, T.pointerType)) && M.stopPropagation(), u) {
        let te = ax(M.target);
        te && T.disposables.push(te);
      }
    }, F.onMouseEnter = (M) => {
      if (!We(M.currentTarget, Te(M))) return;
      let K = !0;
      T.isPressed && !T.ignoreEmulatedMouseEvents && T.pointerType != null && (T.isOverTarget = !0, K = x(M, T.pointerType)), K && M.stopPropagation();
    }, F.onMouseLeave = (M) => {
      if (!We(M.currentTarget, Te(M))) return;
      let K = !0;
      T.isPressed && !T.ignoreEmulatedMouseEvents && T.pointerType != null && (T.isOverTarget = !1, K = S(M, T.pointerType, !1), A(M)), K && M.stopPropagation();
    }, F.onMouseUp = (M) => {
      We(M.currentTarget, Te(M)) && !T.ignoreEmulatedMouseEvents && M.button === 0 && !T.isPressed && P(M, T.pointerType || "mouse");
    }, F.onTouchStart = (M) => {
      if (!We(M.currentTarget, Te(M))) return;
      let K = r9(M.nativeEvent);
      if (!K) return;
      T.activePointerId = K.identifier, T.ignoreEmulatedMouseEvents = !0, T.isOverTarget = !0, T.isPressed = !0, re("touch"), T.target = M.currentTarget, T.pointerType = "touch", f || sx(T.target), x(oo(T.target, M), T.pointerType) && M.stopPropagation();
    }, F.onTouchMove = (M) => {
      if (!We(M.currentTarget, Te(M))) return;
      if (!T.isPressed) {
        M.stopPropagation();
        return;
      }
      let K = dx(M.nativeEvent, T.activePointerId), te = !0;
      K && px(K, M.currentTarget) ? !T.isOverTarget && T.pointerType != null && (T.isOverTarget = !0, te = x(oo(T.target, M), T.pointerType)) : T.isOverTarget && T.pointerType != null && (T.isOverTarget = !1, te = S(oo(T.target, M), T.pointerType, !1), A(oo(T.target, M))), te && M.stopPropagation();
    }, F.onTouchEnd = (M) => {
      if (!We(M.currentTarget, Te(M))) return;
      if (!T.isPressed) {
        M.stopPropagation();
        return;
      }
      let K = dx(M.nativeEvent, T.activePointerId), te = !0;
      K && px(K, M.currentTarget) && T.pointerType != null ? (P(oo(T.target, M), T.pointerType), te = S(oo(T.target, M), T.pointerType), N(M.nativeEvent, T.target)) : T.isOverTarget && T.pointerType != null && (te = S(oo(T.target, M), T.pointerType, !1)), te && M.stopPropagation(), T.isPressed = !1, re(null), T.activePointerId = null, T.isOverTarget = !1, T.ignoreEmulatedMouseEvents = !0, T.target && !f && Yh(T.target), b();
    }, F.onTouchCancel = (M) => {
      We(M.currentTarget, Te(M)) && (M.stopPropagation(), T.isPressed && _(oo(T.target, M)));
    }, F.onDragStart = (M) => {
      We(M.currentTarget, Te(M)) && _(M);
    }), F;
  }, [
    s,
    u,
    b,
    f,
    _,
    A,
    S,
    x,
    P,
    k,
    N
  ]);
  return De(() => {
    if (!d || process.env.NODE_ENV === "test") return;
    const T = Qe(d.current);
    if (!T || !T.head || T.getElementById(cx)) return;
    const F = T.createElement("style");
    F.id = cx, F.textContent = `
@layer {
  [${fx}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), T.head.prepend(F);
  }, [
    d
  ]), De(() => {
    let T = v.current;
    return () => {
      var F;
      f || Yh((F = T.target) !== null && F !== void 0 ? F : void 0);
      for (let M of T.disposables) M();
      T.disposables = [];
    };
  }, [
    f
  ]), {
    isPressed: l || h,
    pressProps: nt(p, Z, {
      [fx]: !0
    })
  };
}
function Sb(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function Qh(e, t) {
  const { key: n, code: r } = e, i = t, o = i.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(i instanceof Sn(i).HTMLInputElement && !bk(i, n) || i instanceof Sn(i).HTMLTextAreaElement || i.isContentEditable) && // Links should only trigger with Enter key
  !((o === "link" || !o && Sb(i)) && n !== "Enter");
}
function r9(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function dx(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const i = n[r];
    if (i.identifier === t) return i;
  }
  return null;
}
function oo(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function Yo(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r,
    key: t.key
  };
}
function i9(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function o9(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function px(e, t) {
  let n = t.getBoundingClientRect(), r = i9(e);
  return o9(n, r);
}
function a9(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Sb(e);
}
function hx(e, t) {
  return e instanceof HTMLInputElement ? !bk(e, t) : a9(e);
}
const s9 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function bk(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : s9.has(e.type);
}
let ja = null;
const Xv = /* @__PURE__ */ new Set();
let uu = /* @__PURE__ */ new Map(), _a = !1, eg = !1;
const l9 = {
  Tab: !0,
  Escape: !0
};
function vp(e, t) {
  for (let n of Xv) n(e, t);
}
function u9(e) {
  return !(e.metaKey || !Oo() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function ud(e) {
  _a = !0, !Wi.isOpening && u9(e) && (ja = "keyboard", vp("keyboard", e));
}
function br(e) {
  ja = "pointer", "pointerType" in e && e.pointerType, (e.type === "mousedown" || e.type === "pointerdown") && (_a = !0, vp("pointer", e));
}
function _k(e) {
  !Wi.isOpening && Zv(e) && (_a = !0, ja = "virtual");
}
function wk(e) {
  Te(e) === window || Te(e) === document || ld || !e.isTrusted || (!_a && !eg && (ja = "virtual", vp("virtual", e)), _a = !1, eg = !1);
}
function xk() {
  ld || (_a = !1, eg = !0);
}
function tg(e) {
  if (typeof window > "u" || typeof document > "u" || uu.get(Sn(e))) return;
  const t = Sn(e), n = Qe(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    _a = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", ud, !0), n.addEventListener("keyup", ud, !0), n.addEventListener("click", _k, !0), t.addEventListener("focus", wk, !0), t.addEventListener("blur", xk, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", br, !0), n.addEventListener("pointermove", br, !0), n.addEventListener("pointerup", br, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", br, !0), n.addEventListener("mousemove", br, !0), n.addEventListener("mouseup", br, !0)), t.addEventListener("beforeunload", () => {
    Ek(e);
  }, {
    once: !0
  }), uu.set(t, {
    focus: r
  });
}
const Ek = (e, t) => {
  const n = Sn(e), r = Qe(e);
  t && r.removeEventListener("DOMContentLoaded", t), uu.has(n) && (n.HTMLElement.prototype.focus = uu.get(n).focus, r.removeEventListener("keydown", ud, !0), r.removeEventListener("keyup", ud, !0), r.removeEventListener("click", _k, !0), n.removeEventListener("focus", wk, !0), n.removeEventListener("blur", xk, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", br, !0), r.removeEventListener("pointermove", br, !0), r.removeEventListener("pointerup", br, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", br, !0), r.removeEventListener("mousemove", br, !0), r.removeEventListener("mouseup", br, !0)), uu.delete(n));
};
function c9(e) {
  const t = Qe(e);
  let n;
  return t.readyState !== "loading" ? tg(e) : (n = () => {
    tg(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => Ek(e, n);
}
typeof document < "u" && c9();
function wa() {
  return ja !== "pointer";
}
function Pu() {
  return ja;
}
function cd(e) {
  ja = e, vp(e, null);
}
const f9 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function d9(e, t, n) {
  let r = Qe(n ? Te(n) : void 0), i = n ? Te(n) : void 0;
  const o = typeof window < "u" ? Sn(i).HTMLInputElement : HTMLInputElement, a = typeof window < "u" ? Sn(i).HTMLTextAreaElement : HTMLTextAreaElement, s = typeof window < "u" ? Sn(i).HTMLElement : HTMLElement, l = typeof window < "u" ? Sn(i).KeyboardEvent : KeyboardEvent;
  let u = Rt(r);
  return e = e || u instanceof o && !f9.has(u.type) || u instanceof a || u instanceof s && u.isContentEditable, !(e && t === "keyboard" && n instanceof l && !l9[n.key]);
}
function p9(e, t, n) {
  tg(), De(() => {
    if (n?.enabled === !1) return;
    let r = (i, o) => {
      d9(!!n?.isTextInput, i, o) && e(wa());
    };
    return Xv.add(r), () => {
      Xv.delete(r);
    };
  }, t);
}
function Ns(e) {
  if (!e.isConnected) return;
  const t = Qe(e);
  if (Pu() === "virtual") {
    let n = Rt(t);
    ik(() => {
      const r = Rt(t);
      (r === n || r === t.body) && e.isConnected && ni(e);
    });
  } else ni(e);
}
function $b(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: i } = e;
  const o = Ne((l) => {
    if (Te(l) === l.currentTarget)
      return r && r(l), i && i(!1), !0;
  }, [
    r,
    i
  ]), a = gk(o), s = Ne((l) => {
    let u = Te(l);
    const c = Qe(u), f = c ? Rt(c) : Rt();
    u === l.currentTarget && u === f && (n && n(l), i && i(!0), a(l));
  }, [
    i,
    n,
    a
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || i || r) ? s : void 0,
      onBlur: !t && (r || i) ? o : void 0
    }
  };
}
function mx(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1;
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function Tb(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: mx(e.onKeyDown),
      onKeyUp: mx(e.onKeyUp)
    }
  };
}
let ng = /* @__PURE__ */ G.createContext(null);
function h9(e) {
  let t = Ce(ng) || {};
  vb(t, e);
  let { ref: n, ...r } = t;
  return r;
}
function Sk(e, t) {
  let { focusProps: n } = $b(e), { keyboardProps: r } = Tb(e), i = nt(n, r), o = h9(t), a = e.isDisabled ? {} : o, s = ve(e.autoFocus);
  De(() => {
    s.current && t.current && Ns(t.current), s.current = !1;
  }, [
    t
  ]);
  let l = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (l = void 0), {
    focusableProps: nt({
      ...i,
      tabIndex: l
    }, a)
  };
}
const $k = /* @__PURE__ */ G.forwardRef(({ children: e, ...t }, n) => {
  let r = ve(!1), i = Ce(ku), o = nt(i || {}, {
    ...t,
    register() {
      r.current = !0, i && i.register();
    }
  });
  return o.ref = ol(n || i?.ref), vb(i, o.ref), De(() => {
    r.current || (process.env.NODE_ENV !== "production" && console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), r.current = !0);
  }, []), /* @__PURE__ */ G.createElement(ku.Provider, {
    value: o
  }, e);
});
function m9({ children: e }) {
  let t = Ee(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ G.createElement(ku.Provider, {
    value: t
  }, e);
}
function gp(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: i } = e, o = ve({
    isFocusWithin: !1
  }), { addGlobalListener: a, removeAllGlobalListeners: s } = cp(), l = Ne((f) => {
    We(f.currentTarget, Te(f)) && o.current.isFocusWithin && !We(f.currentTarget, f.relatedTarget) && (o.current.isFocusWithin = !1, s(), n && n(f), i && i(!1));
  }, [
    n,
    i,
    o,
    s
  ]), u = gk(l), c = Ne((f) => {
    if (!We(f.currentTarget, Te(f))) return;
    let d = Te(f);
    const p = Qe(d), h = Rt(p);
    if (!o.current.isFocusWithin && h === d) {
      r && r(f), i && i(!0), o.current.isFocusWithin = !0, u(f);
      let m = f.currentTarget;
      a(p, "focus", (v) => {
        let g = Te(v);
        if (o.current.isFocusWithin && !We(m, g)) {
          let b = new p.defaultView.FocusEvent("blur", {
            relatedTarget: g
          });
          vk(b, m);
          let E = Eb(b);
          l(E);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    i,
    u,
    a,
    l
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: c,
      onBlur: l
    }
  };
}
let fd = !1, Vc = 0;
function rg() {
  fd = !0, setTimeout(() => {
    fd = !1;
  }, 50);
}
function vx(e) {
  e.pointerType === "touch" && rg();
}
function v9() {
  if (!(typeof document > "u"))
    return Vc === 0 && (typeof PointerEvent < "u" ? document.addEventListener("pointerup", vx) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", rg)), Vc++, () => {
      Vc--, !(Vc > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", vx) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", rg));
    };
}
function sl(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: i } = e, [o, a] = je(!1), s = ve({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  De(v9, []);
  let { addGlobalListener: l, removeAllGlobalListeners: u } = cp(), { hoverProps: c, triggerHoverEnd: f } = Ee(() => {
    let d = (m, v) => {
      if (s.pointerType = v, i || v === "touch" || s.isHovered || !We(m.currentTarget, Te(m))) return;
      s.isHovered = !0;
      let g = m.currentTarget;
      s.target = g, l(Qe(Te(m)), "pointerover", (b) => {
        s.isHovered && s.target && !We(s.target, Te(b)) && p(b, b.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: g,
        pointerType: v
      }), n && n(!0), a(!0);
    }, p = (m, v) => {
      let g = s.target;
      s.pointerType = "", s.target = null, !(v === "touch" || !s.isHovered || !g) && (s.isHovered = !1, u(), r && r({
        type: "hoverend",
        target: g,
        pointerType: v
      }), n && n(!1), a(!1));
    }, h = {};
    return typeof PointerEvent < "u" ? (h.onPointerEnter = (m) => {
      fd && m.pointerType === "mouse" || d(m, m.pointerType);
    }, h.onPointerLeave = (m) => {
      !i && We(m.currentTarget, Te(m)) && p(m, m.pointerType);
    }) : process.env.NODE_ENV === "test" && (h.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, h.onMouseEnter = (m) => {
      !s.ignoreEmulatedMouseEvents && !fd && d(m, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, h.onMouseLeave = (m) => {
      !i && We(m.currentTarget, Te(m)) && p(m, "mouse");
    }), {
      hoverProps: h,
      triggerHoverEnd: p
    };
  }, [
    t,
    n,
    r,
    i,
    s,
    l,
    u
  ]);
  return De(() => {
    i && f({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    i
  ]), {
    hoverProps: c,
    isHovered: o
  };
}
function g9(e) {
  let { ref: t, onInteractOutside: n, isDisabled: r, onInteractOutsideStart: i } = e, o = ve({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), a = or((l) => {
    n && Bc(l, t) && (i && i(l), o.current.isPointerDown = !0);
  }), s = or((l) => {
    n && n(l);
  });
  De(() => {
    let l = o.current;
    if (r) return;
    const u = t.current, c = Qe(u);
    if (typeof PointerEvent < "u") {
      let f = (d) => {
        l.isPointerDown && Bc(d, t) && s(d), l.isPointerDown = !1;
      };
      return c.addEventListener("pointerdown", a, !0), c.addEventListener("click", f, !0), () => {
        c.removeEventListener("pointerdown", a, !0), c.removeEventListener("click", f, !0);
      };
    } else if (process.env.NODE_ENV === "test") {
      let f = (p) => {
        l.ignoreEmulatedMouseEvents ? l.ignoreEmulatedMouseEvents = !1 : l.isPointerDown && Bc(p, t) && s(p), l.isPointerDown = !1;
      }, d = (p) => {
        l.ignoreEmulatedMouseEvents = !0, l.isPointerDown && Bc(p, t) && s(p), l.isPointerDown = !1;
      };
      return c.addEventListener("mousedown", a, !0), c.addEventListener("mouseup", f, !0), c.addEventListener("touchstart", a, !0), c.addEventListener("touchend", d, !0), () => {
        c.removeEventListener("mousedown", a, !0), c.removeEventListener("mouseup", f, !0), c.removeEventListener("touchstart", a, !0), c.removeEventListener("touchend", d, !0);
      };
    }
  }, [
    t,
    r
  ]);
}
function Bc(e, t) {
  if (e.button > 0) return !1;
  let n = Te(e);
  if (n) {
    const r = n.ownerDocument;
    if (!r || !We(r.documentElement, n) || n.closest("[data-react-aria-top-layer]")) return !1;
  }
  return t.current ? !e.composedPath().includes(t.current) : !1;
}
const y9 = 500;
function Tk(e) {
  let { isDisabled: t, onLongPressStart: n, onLongPressEnd: r, onLongPress: i, threshold: o = y9, accessibilityDescription: a } = e;
  const s = ve(void 0);
  let { addGlobalListener: l, removeGlobalListener: u } = cp(), { pressProps: c } = mp({
    isDisabled: t,
    onPressStart(d) {
      if (d.continuePropagation(), (d.pointerType === "mouse" || d.pointerType === "touch") && (n && n({
        ...d,
        type: "longpressstart"
      }), s.current = setTimeout(() => {
        d.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), Qe(d.target).activeElement !== d.target && ni(d.target), i && i({
          ...d,
          type: "longpress"
        }), s.current = void 0;
      }, o), d.pointerType === "touch")) {
        let p = (h) => {
          h.preventDefault();
        };
        l(d.target, "contextmenu", p, {
          once: !0
        }), l(window, "pointerup", () => {
          setTimeout(() => {
            u(d.target, "contextmenu", p);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(d) {
      s.current && clearTimeout(s.current), r && (d.pointerType === "mouse" || d.pointerType === "touch") && r({
        ...d,
        type: "longpressend"
      });
    }
  }), f = uL(i && !t ? a : void 0);
  return {
    longPressProps: nt(c, f)
  };
}
const gx = /* @__PURE__ */ G.createContext(null), ig = "react-aria-focus-scope-restore";
let xt = null;
function Ob(e) {
  let { children: t, contain: n, restoreFocus: r, autoFocus: i } = e, o = ve(null), a = ve(null), s = ve([]), { parentNode: l } = Ce(gx) || {}, u = Ee(() => new ag({
    scopeRef: s
  }), [
    s
  ]);
  ot(() => {
    let d = l || on.root;
    if (on.getTreeNode(d.scopeRef) && xt && !dd(xt, d.scopeRef)) {
      let p = on.getTreeNode(xt);
      p && (d = p);
    }
    d.addChild(u), on.addNode(u);
  }, [
    u,
    l
  ]), ot(() => {
    let d = on.getTreeNode(s);
    d && (d.contain = !!n);
  }, [
    n
  ]), ot(() => {
    var d;
    let p = (d = o.current) === null || d === void 0 ? void 0 : d.nextSibling, h = [], m = (v) => v.stopPropagation();
    for (; p && p !== a.current; )
      h.push(p), p.addEventListener(ig, m), p = p.nextSibling;
    return s.current = h, () => {
      for (let v of h) v.removeEventListener(ig, m);
    };
  }, [
    t
  ]), $9(s, r, n), x9(s, n), T9(s, r, n), S9(s, i), De(() => {
    const d = Rt(Qe(s.current ? s.current[0] : void 0));
    let p = null;
    if (Ar(d, s.current)) {
      for (let h of on.traverse()) h.scopeRef && Ar(d, h.scopeRef.current) && (p = h);
      p === on.getTreeNode(s) && (xt = p.scopeRef);
    }
  }, [
    s
  ]), ot(() => () => {
    var d, p, h;
    let m = (h = (p = on.getTreeNode(s)) === null || p === void 0 || (d = p.parent) === null || d === void 0 ? void 0 : d.scopeRef) !== null && h !== void 0 ? h : null;
    (s === xt || dd(s, xt)) && (!m || on.getTreeNode(m)) && (xt = m), on.removeTreeNode(s);
  }, [
    s
  ]);
  let c = Ee(() => b9(s), []), f = Ee(() => ({
    focusManager: c,
    parentNode: u
  }), [
    u,
    c
  ]);
  return /* @__PURE__ */ G.createElement(gx.Provider, {
    value: f
  }, /* @__PURE__ */ G.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: o
  }), t, /* @__PURE__ */ G.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: a
  }));
}
function b9(e) {
  return {
    focusNext(t = {}) {
      let n = e.current, { from: r, tabbable: i, wrap: o, accept: a } = t;
      var s;
      let l = r || Rt(Qe((s = n[0]) !== null && s !== void 0 ? s : void 0)), u = n[0].previousElementSibling, c = ua(n), f = Vi(c, {
        tabbable: i,
        accept: a
      }, n);
      f.currentNode = Ar(l, n) ? l : u;
      let d = f.nextNode();
      return !d && o && (f.currentNode = u, d = f.nextNode()), d && Li(d, !0), d;
    },
    focusPrevious(t = {}) {
      let n = e.current, { from: r, tabbable: i, wrap: o, accept: a } = t;
      var s;
      let l = r || Rt(Qe((s = n[0]) !== null && s !== void 0 ? s : void 0)), u = n[n.length - 1].nextElementSibling, c = ua(n), f = Vi(c, {
        tabbable: i,
        accept: a
      }, n);
      f.currentNode = Ar(l, n) ? l : u;
      let d = f.previousNode();
      return !d && o && (f.currentNode = u, d = f.previousNode()), d && Li(d, !0), d;
    },
    focusFirst(t = {}) {
      let n = e.current, { tabbable: r, accept: i } = t, o = ua(n), a = Vi(o, {
        tabbable: r,
        accept: i
      }, n);
      a.currentNode = n[0].previousElementSibling;
      let s = a.nextNode();
      return s && Li(s, !0), s;
    },
    focusLast(t = {}) {
      let n = e.current, { tabbable: r, accept: i } = t, o = ua(n), a = Vi(o, {
        tabbable: r,
        accept: i
      }, n);
      a.currentNode = n[n.length - 1].nextElementSibling;
      let s = a.previousNode();
      return s && Li(s, !0), s;
    }
  };
}
function ua(e) {
  return e[0].parentElement;
}
function Gl(e) {
  let t = on.getTreeNode(xt);
  for (; t && t.scopeRef !== e; ) {
    if (t.contain) return !1;
    t = t.parent;
  }
  return !0;
}
function _9(e) {
  if (!e.form)
    return Array.from(Qe(e).querySelectorAll(`input[type="radio"][name="${CSS.escape(e.name)}"]`)).filter((r) => !r.form);
  const t = e.form.elements.namedItem(e.name);
  let n = Sn(e);
  return t instanceof n.RadioNodeList ? Array.from(t).filter((r) => r instanceof n.HTMLInputElement) : t instanceof n.HTMLInputElement ? [
    t
  ] : [];
}
function w9(e) {
  if (e.checked) return !0;
  const t = _9(e);
  return t.length > 0 && !t.some((n) => n.checked);
}
function x9(e, t) {
  let n = ve(void 0), r = ve(void 0);
  ot(() => {
    let i = e.current;
    if (!t) {
      r.current && (cancelAnimationFrame(r.current), r.current = void 0);
      return;
    }
    const o = Qe(i ? i[0] : void 0);
    let a = (u) => {
      if (u.key !== "Tab" || u.altKey || u.ctrlKey || u.metaKey || !Gl(e) || u.isComposing) return;
      let c = Rt(o), f = e.current;
      if (!f || !Ar(c, f)) return;
      let d = ua(f), p = Vi(d, {
        tabbable: !0
      }, f);
      if (!c) return;
      p.currentNode = c;
      let h = u.shiftKey ? p.previousNode() : p.nextNode();
      h || (p.currentNode = u.shiftKey ? f[f.length - 1].nextElementSibling : f[0].previousElementSibling, h = u.shiftKey ? p.previousNode() : p.nextNode()), u.preventDefault(), h && Li(h, !0);
    }, s = (u) => {
      (!xt || dd(xt, e)) && Ar(Te(u), e.current) ? (xt = e, n.current = Te(u)) : Gl(e) && !go(Te(u), e) ? n.current ? n.current.focus() : xt && xt.current && og(xt.current) : Gl(e) && (n.current = Te(u));
    }, l = (u) => {
      r.current && cancelAnimationFrame(r.current), r.current = requestAnimationFrame(() => {
        let c = Pu(), f = (c === "virtual" || c === null) && mb() && hb(), d = Rt(o);
        if (!f && d && Gl(e) && !go(d, e)) {
          xt = e;
          let h = Te(u);
          if (h && h.isConnected) {
            var p;
            n.current = h, (p = n.current) === null || p === void 0 || p.focus();
          } else xt.current && og(xt.current);
        }
      });
    };
    return o.addEventListener("keydown", a, !1), o.addEventListener("focusin", s, !1), i?.forEach((u) => u.addEventListener("focusin", s, !1)), i?.forEach((u) => u.addEventListener("focusout", l, !1)), () => {
      o.removeEventListener("keydown", a, !1), o.removeEventListener("focusin", s, !1), i?.forEach((u) => u.removeEventListener("focusin", s, !1)), i?.forEach((u) => u.removeEventListener("focusout", l, !1));
    };
  }, [
    e,
    t
  ]), ot(() => () => {
    r.current && cancelAnimationFrame(r.current);
  }, [
    r
  ]);
}
function Ok(e) {
  return go(e);
}
function Ar(e, t) {
  return !e || !t ? !1 : t.some((n) => We(n, e));
}
function go(e, t = null) {
  if (e instanceof Element && e.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: n } of on.traverse(on.getTreeNode(t)))
    if (n && Ar(e, n.current)) return !0;
  return !1;
}
function E9(e) {
  return go(e, xt);
}
function dd(e, t) {
  var n;
  let r = (n = on.getTreeNode(t)) === null || n === void 0 ? void 0 : n.parent;
  for (; r; ) {
    if (r.scopeRef === e) return !0;
    r = r.parent;
  }
  return !1;
}
function Li(e, t = !1) {
  if (e != null && !t) try {
    Ns(e);
  } catch {
  }
  else if (e != null) try {
    e.focus();
  } catch {
  }
}
function kk(e, t = !0) {
  let n = e[0].previousElementSibling, r = ua(e), i = Vi(r, {
    tabbable: t
  }, e);
  i.currentNode = n;
  let o = i.nextNode();
  return t && !o && (r = ua(e), i = Vi(r, {
    tabbable: !1
  }, e), i.currentNode = n, o = i.nextNode()), o;
}
function og(e, t = !0) {
  Li(kk(e, t));
}
function S9(e, t) {
  const n = G.useRef(t);
  De(() => {
    if (n.current) {
      xt = e;
      const r = Qe(e.current ? e.current[0] : void 0);
      !Ar(Rt(r), xt.current) && e.current && og(e.current);
    }
    n.current = !1;
  }, [
    e
  ]);
}
function $9(e, t, n) {
  ot(() => {
    if (t || n) return;
    let r = e.current;
    const i = Qe(r ? r[0] : void 0);
    let o = (a) => {
      let s = Te(a);
      Ar(s, e.current) ? xt = e : Ok(s) || (xt = null);
    };
    return i.addEventListener("focusin", o, !1), r?.forEach((a) => a.addEventListener("focusin", o, !1)), () => {
      i.removeEventListener("focusin", o, !1), r?.forEach((a) => a.removeEventListener("focusin", o, !1));
    };
  }, [
    e,
    t,
    n
  ]);
}
function yx(e) {
  let t = on.getTreeNode(xt);
  for (; t && t.scopeRef !== e; ) {
    if (t.nodeToRestore) return !1;
    t = t.parent;
  }
  return t?.scopeRef === e;
}
function T9(e, t, n) {
  const r = ve(typeof document < "u" ? Rt(Qe(e.current ? e.current[0] : void 0)) : null);
  ot(() => {
    let i = e.current;
    const o = Qe(i ? i[0] : void 0);
    if (!t || n) return;
    let a = () => {
      (!xt || dd(xt, e)) && Ar(Rt(o), e.current) && (xt = e);
    };
    return o.addEventListener("focusin", a, !1), i?.forEach((s) => s.addEventListener("focusin", a, !1)), () => {
      o.removeEventListener("focusin", a, !1), i?.forEach((s) => s.removeEventListener("focusin", a, !1));
    };
  }, [
    e,
    n
  ]), ot(() => {
    const i = Qe(e.current ? e.current[0] : void 0);
    if (!t) return;
    let o = (a) => {
      if (a.key !== "Tab" || a.altKey || a.ctrlKey || a.metaKey || !Gl(e) || a.isComposing) return;
      let s = i.activeElement;
      if (!go(s, e) || !yx(e)) return;
      let l = on.getTreeNode(e);
      if (!l) return;
      let u = l.nodeToRestore, c = Vi(i.body, {
        tabbable: !0
      });
      c.currentNode = s;
      let f = a.shiftKey ? c.previousNode() : c.nextNode();
      if ((!u || !u.isConnected || u === i.body) && (u = void 0, l.nodeToRestore = void 0), (!f || !go(f, e)) && u) {
        c.currentNode = u;
        do
          f = a.shiftKey ? c.previousNode() : c.nextNode();
        while (go(f, e));
        a.preventDefault(), a.stopPropagation(), f ? Li(f, !0) : Ok(u) ? Li(u, !0) : s.blur();
      }
    };
    return n || i.addEventListener("keydown", o, !0), () => {
      n || i.removeEventListener("keydown", o, !0);
    };
  }, [
    e,
    t,
    n
  ]), ot(() => {
    const i = Qe(e.current ? e.current[0] : void 0);
    if (!t) return;
    let o = on.getTreeNode(e);
    if (o) {
      var a;
      return o.nodeToRestore = (a = r.current) !== null && a !== void 0 ? a : void 0, () => {
        let s = on.getTreeNode(e);
        if (!s) return;
        let l = s.nodeToRestore, u = Rt(i);
        if (t && l && (u && go(u, e) || u === i.body && yx(e))) {
          let c = on.clone();
          requestAnimationFrame(() => {
            if (i.activeElement === i.body) {
              let f = c.getTreeNode(e);
              for (; f; ) {
                if (f.nodeToRestore && f.nodeToRestore.isConnected) {
                  bx(f.nodeToRestore);
                  return;
                }
                f = f.parent;
              }
              for (f = c.getTreeNode(e); f; ) {
                if (f.scopeRef && f.scopeRef.current && on.getTreeNode(f.scopeRef)) {
                  let d = kk(f.scopeRef.current, !0);
                  bx(d);
                  return;
                }
                f = f.parent;
              }
            }
          });
        }
      };
    }
  }, [
    e,
    t
  ]);
}
function bx(e) {
  e.dispatchEvent(new CustomEvent(ig, {
    bubbles: !0,
    cancelable: !0
  })) && Li(e);
}
function Vi(e, t, n) {
  let r = t?.tabbable ? lk : sk, i = e?.nodeType === Node.ELEMENT_NODE ? e : null, o = Qe(i), a = tk(o, e || o, NodeFilter.SHOW_ELEMENT, {
    acceptNode(s) {
      return We(t?.from, s) || t?.tabbable && s.tagName === "INPUT" && s.getAttribute("type") === "radio" && (!w9(s) || a.currentNode.tagName === "INPUT" && a.currentNode.type === "radio" && a.currentNode.name === s.name) ? NodeFilter.FILTER_REJECT : r(s) && (!n || Ar(s, n)) && (!t?.accept || t.accept(s)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t?.from && (a.currentNode = t.from), a;
}
class kb {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let i = this.fastMap.get(n ?? null);
    if (!i) return;
    let o = new ag({
      scopeRef: t
    });
    i.addChild(o), o.parent = i, this.fastMap.set(t, o), r && (o.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null) return;
    let n = this.fastMap.get(t);
    if (!n) return;
    let r = n.parent;
    for (let o of this.traverse()) o !== n && n.nodeToRestore && o.nodeToRestore && n.scopeRef && n.scopeRef.current && Ar(o.nodeToRestore, n.scopeRef.current) && (o.nodeToRestore = n.nodeToRestore);
    let i = n.children;
    r && (r.removeChild(n), i.size > 0 && i.forEach((o) => r && r.addChild(o))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0) for (let n of t.children) yield* this.traverse(n);
  }
  clone() {
    var t;
    let n = new kb();
    var r;
    for (let i of this.traverse()) n.addTreeNode(i.scopeRef, (r = (t = i.parent) === null || t === void 0 ? void 0 : t.scopeRef) !== null && r !== void 0 ? r : null, i.nodeToRestore);
    return n;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new ag({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class ag {
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
}
let on = new kb();
function yp(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, i = ve({
    isFocused: !1,
    isFocusVisible: t || wa()
  }), [o, a] = je(!1), [s, l] = je(() => i.current.isFocused && i.current.isFocusVisible), u = Ne(() => l(i.current.isFocused && i.current.isFocusVisible), []), c = Ne((p) => {
    i.current.isFocused = p, i.current.isFocusVisible = wa(), a(p), u();
  }, [
    u
  ]);
  p9((p) => {
    i.current.isFocusVisible = p, u();
  }, [
    n,
    o
  ], {
    enabled: o,
    isTextInput: n
  });
  let { focusProps: f } = $b({
    isDisabled: r,
    onFocusChange: c
  }), { focusWithinProps: d } = gp({
    isDisabled: !r,
    onFocusWithinChange: c
  });
  return {
    isFocused: o,
    isFocusVisible: s,
    focusProps: r ? d : f
  };
}
function Pk(e) {
  let t = k9(Qe(e));
  t !== e && (t && O9(t, e), e && Dk(e, t));
}
function O9(e, t) {
  e.dispatchEvent(new FocusEvent("blur", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusout", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function Dk(e, t) {
  e.dispatchEvent(new FocusEvent("focus", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusin", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function k9(e) {
  let t = Rt(e), n = t?.getAttribute("aria-activedescendant");
  return n && e.getElementById(n) || t;
}
const mi = [];
function P9(e, t) {
  let { onClose: n, shouldCloseOnBlur: r, isOpen: i, isDismissable: o = !1, isKeyboardDismissDisabled: a = !1, shouldCloseOnInteractOutside: s } = e, l = ve(void 0);
  De(() => {
    if (i && !mi.includes(t))
      return mi.push(t), () => {
        let m = mi.indexOf(t);
        m >= 0 && mi.splice(m, 1);
      };
  }, [
    i,
    t
  ]);
  let u = () => {
    mi[mi.length - 1] === t && n && n();
  }, c = (m) => {
    const v = mi[mi.length - 1];
    l.current = v, (!s || s(Te(m))) && v === t && (m.stopPropagation(), m.preventDefault());
  }, f = (m) => {
    (!s || s(Te(m))) && (mi[mi.length - 1] === t && (m.stopPropagation(), m.preventDefault()), l.current === t && u()), l.current = void 0;
  }, d = (m) => {
    m.key === "Escape" && !a && !m.nativeEvent.isComposing && (m.stopPropagation(), m.preventDefault(), u());
  };
  g9({
    ref: t,
    onInteractOutside: o && i ? f : void 0,
    onInteractOutsideStart: c
  });
  let { focusWithinProps: p } = gp({
    isDisabled: !r,
    onBlurWithin: (m) => {
      !m.relatedTarget || E9(m.relatedTarget) || (!s || s(m.relatedTarget)) && n?.();
    }
  }), h = (m) => {
    Te(m) === m.currentTarget && m.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown: d,
      ...p
    },
    underlayProps: {
      onPointerDown: h
    }
  };
}
function D9(e, t, n) {
  let { type: r } = e, { isOpen: i } = t;
  De(() => {
    n && n.current && dk.set(n.current, t.close);
  });
  let o;
  r === "menu" ? o = !0 : r === "listbox" && (o = "listbox");
  let a = Zn();
  return {
    triggerProps: {
      "aria-haspopup": o,
      "aria-expanded": i,
      "aria-controls": i ? a : void 0,
      onPress: t.toggle
    },
    overlayProps: {
      id: a
    }
  };
}
const cu = typeof document < "u" && window.visualViewport;
let Kc = 0, Jh;
function A9(e = {}) {
  let { isDisabled: t } = e;
  ot(() => {
    if (!t)
      return Kc++, Kc === 1 && (oc() ? Jh = I9() : Jh = C9()), () => {
        Kc--, Kc === 0 && Jh();
      };
  }, [
    t
  ]);
}
function C9() {
  let e = window.innerWidth - document.documentElement.clientWidth;
  return Ma(e > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
  ("scrollbarGutter" in document.documentElement.style ? Sf(document.documentElement, "scrollbarGutter", "stable") : Sf(document.documentElement, "paddingRight", `${e}px`)), Sf(document.documentElement, "overflow", "hidden"));
}
function I9() {
  let e = Sf(document.documentElement, "overflow", "hidden"), t, n = !1, r = (u) => {
    let c = Te(u);
    t = Rs(c) ? c : gb(c, !0), n = !1;
    let f = c.ownerDocument.defaultView.getSelection();
    f && !f.isCollapsed && f.containsNode(c, !0) && (n = !0), u.composedPath().some((d) => d instanceof HTMLInputElement && d.type === "range") && (n = !0), "selectionStart" in c && "selectionEnd" in c && c.selectionStart < c.selectionEnd && c.ownerDocument.activeElement === c && (n = !0);
  }, i = document.createElement("style");
  i.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim(), document.head.prepend(i);
  let o = (u) => {
    if (!(u.touches.length === 2 || n)) {
      if (!t || t === document.documentElement || t === document.body) {
        u.preventDefault();
        return;
      }
      t.scrollHeight === t.clientHeight && t.scrollWidth === t.clientWidth && u.preventDefault();
    }
  }, a = (u) => {
    let c = Te(u), f = u.relatedTarget;
    if (f && qh(f))
      f.focus({
        preventScroll: !0
      }), _x(f, qh(c));
    else if (!f) {
      var d;
      let p = (d = c.parentElement) === null || d === void 0 ? void 0 : d.closest("[tabindex]");
      p?.focus({
        preventScroll: !0
      });
    }
  }, s = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function(u) {
    let c = Rt(), f = c != null && qh(c);
    s.call(this, {
      ...u,
      preventScroll: !0
    }), (!u || !u.preventScroll) && _x(this, f);
  };
  let l = Ma(Xh(document, "touchstart", r, {
    passive: !1,
    capture: !0
  }), Xh(document, "touchmove", o, {
    passive: !1,
    capture: !0
  }), Xh(document, "blur", a, !0));
  return () => {
    e(), l(), i.remove(), HTMLElement.prototype.focus = s;
  };
}
function Sf(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Xh(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function _x(e, t) {
  t || !cu ? wx(e) : cu.addEventListener("resize", () => wx(e), {
    once: !0
  });
}
function wx(e) {
  let t = document.scrollingElement || document.documentElement, n = e;
  for (; n && n !== t; ) {
    let r = gb(n);
    if (r !== document.documentElement && r !== document.body && r !== n) {
      let i = r.getBoundingClientRect(), o = n.getBoundingClientRect();
      if (o.top < i.top || o.bottom > i.top + n.clientHeight) {
        let a = i.bottom;
        cu && (a = Math.min(a, cu.offsetTop + cu.height));
        let s = o.top - i.top - ((a - i.top) / 2 - o.height / 2);
        r.scrollTo({
          // Clamp to the valid range to prevent over-scrolling.
          top: Math.max(0, Math.min(r.scrollHeight - r.clientHeight, r.scrollTop + s)),
          behavior: "smooth"
        });
      }
    }
    n = r.parentElement;
  }
}
const M9 = /* @__PURE__ */ Le({});
function R9() {
  var e;
  return (e = Ce(M9)) !== null && e !== void 0 ? e : {};
}
var Ak = {};
Ak = {
  dismiss: "تجاهل"
};
var Ck = {};
Ck = {
  dismiss: "Отхвърляне"
};
var Ik = {};
Ik = {
  dismiss: "Odstranit"
};
var Mk = {};
Mk = {
  dismiss: "Luk"
};
var Rk = {};
Rk = {
  dismiss: "Schließen"
};
var Nk = {};
Nk = {
  dismiss: "Απόρριψη"
};
var jk = {};
jk = {
  dismiss: "Dismiss"
};
var Fk = {};
Fk = {
  dismiss: "Descartar"
};
var zk = {};
zk = {
  dismiss: "Lõpeta"
};
var Lk = {};
Lk = {
  dismiss: "Hylkää"
};
var Vk = {};
Vk = {
  dismiss: "Rejeter"
};
var Bk = {};
Bk = {
  dismiss: "התעלם"
};
var Kk = {};
Kk = {
  dismiss: "Odbaci"
};
var Uk = {};
Uk = {
  dismiss: "Elutasítás"
};
var qk = {};
qk = {
  dismiss: "Ignora"
};
var Hk = {};
Hk = {
  dismiss: "閉じる"
};
var Wk = {};
Wk = {
  dismiss: "무시"
};
var Zk = {};
Zk = {
  dismiss: "Atmesti"
};
var Gk = {};
Gk = {
  dismiss: "Nerādīt"
};
var Yk = {};
Yk = {
  dismiss: "Lukk"
};
var Qk = {};
Qk = {
  dismiss: "Negeren"
};
var Jk = {};
Jk = {
  dismiss: "Zignoruj"
};
var Xk = {};
Xk = {
  dismiss: "Descartar"
};
var eP = {};
eP = {
  dismiss: "Dispensar"
};
var tP = {};
tP = {
  dismiss: "Revocare"
};
var nP = {};
nP = {
  dismiss: "Пропустить"
};
var rP = {};
rP = {
  dismiss: "Zrušiť"
};
var iP = {};
iP = {
  dismiss: "Opusti"
};
var oP = {};
oP = {
  dismiss: "Odbaci"
};
var aP = {};
aP = {
  dismiss: "Avvisa"
};
var sP = {};
sP = {
  dismiss: "Kapat"
};
var lP = {};
lP = {
  dismiss: "Скасувати"
};
var uP = {};
uP = {
  dismiss: "取消"
};
var cP = {};
cP = {
  dismiss: "關閉"
};
var fP = {};
fP = {
  "ar-AE": Ak,
  "bg-BG": Ck,
  "cs-CZ": Ik,
  "da-DK": Mk,
  "de-DE": Rk,
  "el-GR": Nk,
  "en-US": jk,
  "es-ES": Fk,
  "et-EE": zk,
  "fi-FI": Lk,
  "fr-FR": Vk,
  "he-IL": Bk,
  "hr-HR": Kk,
  "hu-HU": Uk,
  "it-IT": qk,
  "ja-JP": Hk,
  "ko-KR": Wk,
  "lt-LT": Zk,
  "lv-LV": Gk,
  "nb-NO": Yk,
  "nl-NL": Qk,
  "pl-PL": Jk,
  "pt-BR": Xk,
  "pt-PT": eP,
  "ro-RO": tP,
  "ru-RU": nP,
  "sk-SK": rP,
  "sl-SI": iP,
  "sr-SP": oP,
  "sv-SE": aP,
  "tr-TR": sP,
  "uk-UA": lP,
  "zh-CN": uP,
  "zh-TW": cP
};
const xx = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function dP(e = {}) {
  let { style: t, isFocusable: n } = e, [r, i] = je(!1), { focusWithinProps: o } = gp({
    isDisabled: !n,
    onFocusWithinChange: (s) => i(s)
  }), a = Ee(() => r ? t : t ? {
    ...xx,
    ...t
  } : xx, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...o,
      style: a
    }
  };
}
function N9(e) {
  let { children: t, elementType: n = "div", isFocusable: r, style: i, ...o } = e, { visuallyHiddenProps: a } = dP(e);
  return /* @__PURE__ */ G.createElement(n, nt(o, a), t);
}
function j9(e) {
  return e && e.__esModule ? e.default : e;
}
function Ex(e) {
  let { onDismiss: t, ...n } = e, r = mk(j9(fP), "@react-aria/overlays"), i = ok(n, r.format("dismiss")), o = () => {
    t && t();
  };
  return /* @__PURE__ */ G.createElement(N9, null, /* @__PURE__ */ G.createElement("button", {
    ...i,
    tabIndex: -1,
    onClick: o,
    style: {
      width: 1,
      height: 1
    }
  }));
}
const F9 = typeof HTMLElement < "u" && "inert" in HTMLElement.prototype;
let Rl = /* @__PURE__ */ new WeakMap(), Bn = [];
function z9(e, t) {
  let n = Sn(e?.[0]), r = t instanceof n.Element ? {
    root: t
  } : t;
  var i;
  let o = (i = r?.root) !== null && i !== void 0 ? i : document.body, a = r?.shouldUseInert && F9, s = new Set(e), l = /* @__PURE__ */ new Set(), u = (g) => a && g instanceof n.HTMLElement ? g.inert : g.getAttribute("aria-hidden") === "true", c = (g, b) => {
    a && g instanceof n.HTMLElement ? g.inert = b : b ? g.setAttribute("aria-hidden", "true") : (g.removeAttribute("aria-hidden"), g instanceof n.HTMLElement && (g.inert = !1));
  }, f = /* @__PURE__ */ new Set();
  if (ji())
    for (let g of e) {
      let b = g;
      for (; b && b !== o; ) {
        let E = b.getRootNode();
        "shadowRoot" in E && f.add(E.shadowRoot), b = E.parentNode;
      }
    }
  let d = (g) => {
    for (let S of g.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) s.add(S);
    let b = (S) => {
      if (l.has(S) || s.has(S) || S.parentElement && l.has(S.parentElement) && S.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let $ of s)
        if (We(S, $)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, E = tk(Qe(g), g, NodeFilter.SHOW_ELEMENT, {
      acceptNode: b
    }), x = b(g);
    if (x === NodeFilter.FILTER_ACCEPT && p(g), x !== NodeFilter.FILTER_REJECT) {
      let S = E.nextNode();
      for (; S != null; )
        p(S), S = E.nextNode();
    }
  }, p = (g) => {
    var b;
    let E = (b = Rl.get(g)) !== null && b !== void 0 ? b : 0;
    u(g) && E === 0 || (E === 0 && c(g, !0), l.add(g), Rl.set(g, E + 1));
  };
  Bn.length && Bn[Bn.length - 1].disconnect(), d(o);
  let h = new MutationObserver((g) => {
    for (let b of g)
      if (b.type === "childList") {
        if (b.target.isConnected && ![
          ...s,
          ...l
        ].some((E) => We(E, b.target))) for (let E of b.addedNodes)
          (E instanceof HTMLElement || E instanceof SVGElement) && (E.dataset.liveAnnouncer === "true" || E.dataset.reactAriaTopLayer === "true") ? s.add(E) : E instanceof Element && d(E);
        if (ji()) {
          for (let E of f) if (!E.isConnected) {
            h.disconnect();
            break;
          }
        }
      }
  });
  h.observe(o, {
    childList: !0,
    subtree: !0
  });
  let m = /* @__PURE__ */ new Set();
  if (ji()) for (let g of f) {
    let b = new MutationObserver((E) => {
      for (let x of E)
        if (x.type === "childList") {
          if (x.target.isConnected && ![
            ...s,
            ...l
          ].some((S) => We(S, x.target))) for (let S of x.addedNodes)
            (S instanceof HTMLElement || S instanceof SVGElement) && (S.dataset.liveAnnouncer === "true" || S.dataset.reactAriaTopLayer === "true") ? s.add(S) : S instanceof Element && d(S);
          if (ji()) {
            for (let S of f) if (!S.isConnected) {
              h.disconnect();
              break;
            }
          }
        }
    });
    b.observe(g, {
      childList: !0,
      subtree: !0
    }), m.add(b);
  }
  let v = {
    visibleNodes: s,
    hiddenNodes: l,
    observe() {
      h.observe(o, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      h.disconnect();
    }
  };
  return Bn.push(v), () => {
    if (h.disconnect(), ji()) for (let g of m) g.disconnect();
    for (let g of l) {
      let b = Rl.get(g);
      b != null && (b === 1 ? (c(g, !1), Rl.delete(g)) : Rl.set(g, b - 1));
    }
    v === Bn[Bn.length - 1] ? (Bn.pop(), Bn.length && Bn[Bn.length - 1].observe()) : Bn.splice(Bn.indexOf(v), 1);
  };
}
function L9(e) {
  let t = Bn[Bn.length - 1];
  if (t && !t.visibleNodes.has(e))
    return t.visibleNodes.add(e), () => {
      t.visibleNodes.delete(e);
    };
}
function V9(e, t) {
  let { triggerRef: n, popoverRef: r, groupRef: i, isNonModal: o, isKeyboardDismissDisabled: a, shouldCloseOnInteractOutside: s, ...l } = e, u = l.trigger === "SubmenuTrigger", { overlayProps: c, underlayProps: f } = P9({
    isOpen: t.isOpen,
    onClose: t.close,
    shouldCloseOnBlur: !0,
    isDismissable: !o || u,
    isKeyboardDismissDisabled: a,
    shouldCloseOnInteractOutside: s
  }, i ?? r), { overlayProps: d, arrowProps: p, placement: h, triggerAnchorPoint: m } = YL({
    ...l,
    targetRef: n,
    overlayRef: r,
    isOpen: t.isOpen,
    onClose: o && !u ? t.close : null
  });
  return A9({
    isDisabled: o || !t.isOpen
  }), De(() => {
    if (t.isOpen && r.current) {
      var v, g;
      return o ? L9((v = i?.current) !== null && v !== void 0 ? v : r.current) : z9([
        (g = i?.current) !== null && g !== void 0 ? g : r.current
      ], {
        shouldUseInert: !0
      });
    }
  }, [
    o,
    t.isOpen,
    r,
    i
  ]), {
    popoverProps: nt(c, d),
    arrowProps: p,
    underlayProps: f,
    placement: h,
    triggerAnchorPoint: m
  };
}
const B9 = /* @__PURE__ */ G.createContext(null);
function Sx(e) {
  let t = ic(), { portalContainer: n = t ? null : document.body, isExiting: r } = e, [i, o] = je(!1), a = Ee(() => ({
    contain: i,
    setContain: o
  }), [
    i,
    o
  ]), { getContainer: s } = R9();
  if (!e.portalContainer && s && (n = s()), !n) return null;
  let l = e.children;
  return e.disableFocusManagement || (l = /* @__PURE__ */ G.createElement(Ob, {
    restoreFocus: !0,
    contain: (e.shouldContainFocus || i) && !r
  }, l)), l = /* @__PURE__ */ G.createElement(B9.Provider, {
    value: a
  }, /* @__PURE__ */ G.createElement(m9, null, l)), /* @__PURE__ */ r6.createPortal(l, n);
}
const Pb = /* @__PURE__ */ new WeakMap();
function K9(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function U9(e, t) {
  let n = Pb.get(e);
  if (!n) throw new Error("Unknown list");
  return `${n.id}-option-${K9(t)}`;
}
function pP(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": i, labelElementType: o = "label" } = e;
  t = Zn(t);
  let a = Zn(), s = {};
  n ? (r = r ? `${a} ${r}` : a, s = {
    id: a,
    htmlFor: o === "label" ? t : void 0
  }) : !r && !i && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let l = ok({
    id: t,
    "aria-label": i,
    "aria-labelledby": r
  });
  return {
    labelProps: s,
    fieldProps: l
  };
}
function q9(e) {
  let { description: t, errorMessage: n, isInvalid: r, validationState: i } = e, { labelProps: o, fieldProps: a } = pP(e), s = ha([
    !!t,
    !!n,
    r,
    i
  ]), l = ha([
    !!t,
    !!n,
    r,
    i
  ]);
  return a = nt(a, {
    "aria-describedby": [
      s,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      l,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: o,
    fieldProps: a,
    descriptionProps: {
      id: s
    },
    errorMessageProps: {
      id: l
    }
  };
}
function sg(e) {
  return Qz() ? e.altKey : e.ctrlKey;
}
function $f(e, t) {
  var n, r;
  let i = `[data-key="${CSS.escape(String(t))}"]`, o = (n = e.current) === null || n === void 0 ? void 0 : n.dataset.collection;
  return o && (i = `[data-collection="${CSS.escape(o)}"]${i}`), (r = e.current) === null || r === void 0 ? void 0 : r.querySelector(i);
}
const hP = /* @__PURE__ */ new WeakMap();
function H9(e) {
  let t = Zn();
  return hP.set(e, t), t;
}
function W9(e) {
  return hP.get(e);
}
const Z9 = 1e3;
function mP(e) {
  let { keyboardDelegate: t, selectionManager: n, onTypeSelect: r } = e, i = ve({
    search: "",
    timeout: void 0
  }).current, o = (a) => {
    let s = G9(a.key);
    if (!(!s || a.ctrlKey || a.metaKey || !We(a.currentTarget, Te(a)) || i.search.length === 0 && s === " ")) {
      if (s === " " && i.search.trim().length > 0 && (a.preventDefault(), "continuePropagation" in a || a.stopPropagation()), i.search += s, t.getKeyForSearch != null) {
        let l = t.getKeyForSearch(i.search, n.focusedKey);
        l == null && (l = t.getKeyForSearch(i.search)), l != null && (n.setFocusedKey(l), r && r(l));
      }
      clearTimeout(i.timeout), i.timeout = setTimeout(() => {
        i.search = "";
      }, Z9);
    }
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: t.getKeyForSearch ? o : void 0
    }
  };
}
function G9(e) {
  return e.length === 1 || !/^[A-Z]/i.test(e) ? e : "";
}
function Y9(e) {
  let { selectionManager: t, keyboardDelegate: n, ref: r, autoFocus: i = !1, shouldFocusWrap: o = !1, disallowEmptySelection: a = !1, disallowSelectAll: s = !1, escapeKeyBehavior: l = "clearSelection", selectOnFocus: u = t.selectionBehavior === "replace", disallowTypeAhead: c = !1, shouldUseVirtualFocus: f, allowsTabNavigation: d = !1, scrollRef: p = r, linkBehavior: h = "action" } = e, { direction: m } = al(), v = up(), g = (I) => {
    if (I.altKey && I.key === "Tab" && I.preventDefault(), !r.current || !We(r.current, Te(I))) return;
    const B = (V, O) => {
      if (V != null) {
        if (t.isLink(V) && h === "selection" && u && !sg(I)) {
          xy(() => {
            t.setFocusedKey(V, O);
          });
          let D = $f(r, V), C = t.getItemProps(V);
          D && v.open(D, I, C.href, C.routerOptions);
          return;
        }
        if (t.setFocusedKey(V, O), t.isLink(V) && h === "override") return;
        I.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(V) : u && !sg(I) && t.replaceSelection(V);
      }
    };
    switch (I.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          var q, ee, re;
          let V = t.focusedKey != null ? (q = n.getKeyBelow) === null || q === void 0 ? void 0 : q.call(n, t.focusedKey) : (ee = n.getFirstKey) === null || ee === void 0 ? void 0 : ee.call(n);
          V == null && o && (V = (re = n.getFirstKey) === null || re === void 0 ? void 0 : re.call(n, t.focusedKey)), V != null && (I.preventDefault(), B(V));
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          var Z, T, F;
          let V = t.focusedKey != null ? (Z = n.getKeyAbove) === null || Z === void 0 ? void 0 : Z.call(n, t.focusedKey) : (T = n.getLastKey) === null || T === void 0 ? void 0 : T.call(n);
          V == null && o && (V = (F = n.getLastKey) === null || F === void 0 ? void 0 : F.call(n, t.focusedKey)), V != null && (I.preventDefault(), B(V));
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          var M, K, te;
          let V = t.focusedKey != null ? (M = n.getKeyLeftOf) === null || M === void 0 ? void 0 : M.call(n, t.focusedKey) : null;
          V == null && o && (V = m === "rtl" ? (K = n.getFirstKey) === null || K === void 0 ? void 0 : K.call(n, t.focusedKey) : (te = n.getLastKey) === null || te === void 0 ? void 0 : te.call(n, t.focusedKey)), V != null && (I.preventDefault(), B(V, m === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          var se, de, ge;
          let V = t.focusedKey != null ? (se = n.getKeyRightOf) === null || se === void 0 ? void 0 : se.call(n, t.focusedKey) : null;
          V == null && o && (V = m === "rtl" ? (de = n.getLastKey) === null || de === void 0 ? void 0 : de.call(n, t.focusedKey) : (ge = n.getFirstKey) === null || ge === void 0 ? void 0 : ge.call(n, t.focusedKey)), V != null && (I.preventDefault(), B(V, m === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          if (t.focusedKey === null && I.shiftKey) return;
          I.preventDefault();
          let V = n.getFirstKey(t.focusedKey, ns(I));
          t.setFocusedKey(V), V != null && (ns(I) && I.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(V) : u && t.replaceSelection(V));
        }
        break;
      case "End":
        if (n.getLastKey) {
          if (t.focusedKey === null && I.shiftKey) return;
          I.preventDefault();
          let V = n.getLastKey(t.focusedKey, ns(I));
          t.setFocusedKey(V), V != null && (ns(I) && I.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(V) : u && t.replaceSelection(V));
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow && t.focusedKey != null) {
          let V = n.getKeyPageBelow(t.focusedKey);
          V != null && (I.preventDefault(), B(V));
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove && t.focusedKey != null) {
          let V = n.getKeyPageAbove(t.focusedKey);
          V != null && (I.preventDefault(), B(V));
        }
        break;
      case "a":
        ns(I) && t.selectionMode === "multiple" && s !== !0 && (I.preventDefault(), t.selectAll());
        break;
      case "Escape":
        l === "clearSelection" && !a && t.selectedKeys.size !== 0 && (I.stopPropagation(), I.preventDefault(), t.clearSelection());
        break;
      case "Tab":
        if (!d) {
          if (I.shiftKey) r.current.focus();
          else {
            let V = Vi(r.current, {
              tabbable: !0
            }), O, D;
            do
              D = V.lastChild(), D && (O = D);
            while (D);
            let C = Rt();
            O && (!od(O) || C && !lk(C)) && ni(O);
          }
          break;
        }
    }
  }, b = ve({
    top: 0,
    left: 0
  });
  jc(p, "scroll", () => {
    var I, B, q, ee;
    b.current = {
      top: (q = (I = p.current) === null || I === void 0 ? void 0 : I.scrollTop) !== null && q !== void 0 ? q : 0,
      left: (ee = (B = p.current) === null || B === void 0 ? void 0 : B.scrollLeft) !== null && ee !== void 0 ? ee : 0
    };
  });
  let E = (I) => {
    if (t.isFocused) {
      We(I.currentTarget, Te(I)) || t.setFocused(!1);
      return;
    }
    if (We(I.currentTarget, Te(I))) {
      if (t.setFocused(!0), t.focusedKey == null) {
        var B, q;
        let Z = (F) => {
          F != null && (t.setFocusedKey(F), u && !t.isSelected(F) && t.replaceSelection(F));
        }, T = I.relatedTarget;
        var ee, re;
        T && I.currentTarget.compareDocumentPosition(T) & Node.DOCUMENT_POSITION_FOLLOWING ? Z((ee = t.lastSelectedKey) !== null && ee !== void 0 ? ee : (B = n.getLastKey) === null || B === void 0 ? void 0 : B.call(n)) : Z((re = t.firstSelectedKey) !== null && re !== void 0 ? re : (q = n.getFirstKey) === null || q === void 0 ? void 0 : q.call(n));
      } else p.current && (p.current.scrollTop = b.current.top, p.current.scrollLeft = b.current.left);
      if (t.focusedKey != null && p.current) {
        let Z = $f(r, t.focusedKey);
        Z instanceof HTMLElement && (!od(Z) && !f && ni(Z), Pu() === "keyboard" && Ww(Z, {
          containingElement: r.current
        }));
      }
    }
  }, x = (I) => {
    We(I.currentTarget, I.relatedTarget) || t.setFocused(!1);
  }, S = ve(!1);
  jc(r, mL, f ? (I) => {
    let { detail: B } = I;
    I.stopPropagation(), t.setFocused(!0), B?.focusStrategy === "first" && (S.current = !0);
  } : void 0), qw(() => {
    if (S.current) {
      var I, B;
      let q = (B = (I = n.getFirstKey) === null || I === void 0 ? void 0 : I.call(n)) !== null && B !== void 0 ? B : null;
      if (q == null) {
        let ee = Rt();
        Pk(r.current), Dk(ee, null), t.collection.size > 0 && (S.current = !1);
      } else
        t.setFocusedKey(q), S.current = !1;
    }
  }, [
    t.collection
  ]), qw(() => {
    t.collection.size > 0 && (S.current = !1);
  }, [
    t.focusedKey
  ]), jc(r, hL, f ? (I) => {
    var B;
    I.stopPropagation(), t.setFocused(!1), !((B = I.detail) === null || B === void 0) && B.clearFocusKey && t.setFocusedKey(null);
  } : void 0);
  const $ = ve(i), P = ve(!1);
  De(() => {
    if ($.current) {
      var I, B;
      let re = null;
      var q;
      i === "first" && (re = (q = (I = n.getFirstKey) === null || I === void 0 ? void 0 : I.call(n)) !== null && q !== void 0 ? q : null);
      var ee;
      i === "last" && (re = (ee = (B = n.getLastKey) === null || B === void 0 ? void 0 : B.call(n)) !== null && ee !== void 0 ? ee : null);
      let Z = t.selectedKeys;
      if (Z.size) {
        for (let T of Z) if (t.canSelectItem(T)) {
          re = T;
          break;
        }
      }
      t.setFocused(!0), t.setFocusedKey(re), re == null && !f && r.current && Ns(r.current), t.collection.size > 0 && ($.current = !1, P.current = !0);
    }
  });
  let y = ve(t.focusedKey), _ = ve(null);
  De(() => {
    if (t.isFocused && t.focusedKey != null && (t.focusedKey !== y.current || P.current) && p.current && r.current) {
      let I = Pu(), B = $f(r, t.focusedKey);
      if (!(B instanceof HTMLElement))
        return;
      (I === "keyboard" || P.current) && (_.current && cancelAnimationFrame(_.current), _.current = requestAnimationFrame(() => {
        p.current && (Wv(p.current, B), I !== "virtual" && Ww(B, {
          containingElement: r.current
        }));
      }));
    }
    !f && t.isFocused && t.focusedKey == null && y.current != null && r.current && Ns(r.current), y.current = t.focusedKey, P.current = !1;
  }), De(() => () => {
    _.current && cancelAnimationFrame(_.current);
  }, []), jc(r, "react-aria-focus-scope-restore", (I) => {
    I.preventDefault(), t.setFocused(!0);
  });
  let w = {
    onKeyDown: g,
    onFocus: E,
    onBlur: x,
    onMouseDown(I) {
      p.current === Te(I) && I.preventDefault();
    }
  }, { typeSelectProps: A } = mP({
    keyboardDelegate: n,
    selectionManager: t
  });
  c || (w = nt(A, w));
  let k;
  f || (k = t.focusedKey == null ? 0 : -1);
  let N = H9(t.collection);
  return {
    collectionProps: nt(w, {
      tabIndex: k,
      "data-collection": N
    })
  };
}
function vP(e) {
  let { id: t, selectionManager: n, key: r, ref: i, shouldSelectOnPressUp: o, shouldUseVirtualFocus: a, focus: s, isDisabled: l, onAction: u, allowsDifferentPressOrigin: c, linkBehavior: f = "action" } = e, d = up();
  t = Zn(t);
  let p = (T) => {
    if (T.pointerType === "keyboard" && sg(T)) n.toggleSelection(r);
    else {
      if (n.selectionMode === "none") return;
      if (n.isLink(r)) {
        if (f === "selection" && i.current) {
          let F = n.getItemProps(r);
          d.open(i.current, T, F.href, F.routerOptions), n.setSelectedKeys(n.selectedKeys);
          return;
        } else if (f === "override" || f === "none") return;
      }
      n.selectionMode === "single" ? n.isSelected(r) && !n.disallowEmptySelection ? n.toggleSelection(r) : n.replaceSelection(r) : T && T.shiftKey ? n.extendSelection(r) : n.selectionBehavior === "toggle" || T && (ns(T) || T.pointerType === "touch" || T.pointerType === "virtual") ? n.toggleSelection(r) : n.replaceSelection(r);
    }
  };
  De(() => {
    r === n.focusedKey && n.isFocused && (a ? Pk(i.current) : s ? s() : Rt() !== i.current && i.current && Ns(i.current));
  }, [
    i,
    r,
    n.focusedKey,
    n.childFocusStrategy,
    n.isFocused,
    a
  ]), l = l || n.isDisabled(r);
  let h = {};
  !a && !l ? h = {
    tabIndex: r === n.focusedKey ? 0 : -1,
    onFocus(T) {
      Te(T) === i.current && n.setFocusedKey(r);
    }
  } : l && (h.onMouseDown = (T) => {
    T.preventDefault();
  }), De(() => {
    l && n.focusedKey === r && n.setFocusedKey(null);
  }, [
    n,
    l,
    r
  ]);
  let m = n.isLink(r) && f === "override", v = u && e.UNSTABLE_itemBehavior === "action", g = n.isLink(r) && f !== "selection" && f !== "none", b = !l && n.canSelectItem(r) && !m && !v, E = (u || g) && !l, x = E && (n.selectionBehavior === "replace" ? !b : !b || n.isEmpty), S = E && b && n.selectionBehavior === "replace", $ = x || S, P = ve(null), y = $ && b, _ = ve(!1), w = ve(!1), A = n.getItemProps(r), k = (T) => {
    if (u) {
      var F;
      u(), (F = i.current) === null || F === void 0 || F.dispatchEvent(new CustomEvent("react-aria-item-action", {
        bubbles: !0
      }));
    }
    g && i.current && d.open(i.current, T, A.href, A.routerOptions);
  }, N = {
    ref: i
  };
  if (o ? (N.onPressStart = (T) => {
    P.current = T.pointerType, _.current = y, T.pointerType === "keyboard" && (!$ || Tx(T.key)) && p(T);
  }, c ? (N.onPressUp = x ? void 0 : (T) => {
    T.pointerType === "mouse" && b && p(T);
  }, N.onPress = x ? k : (T) => {
    T.pointerType !== "keyboard" && T.pointerType !== "mouse" && b && p(T);
  }) : N.onPress = (T) => {
    if (x || S && T.pointerType !== "mouse") {
      if (T.pointerType === "keyboard" && !$x(T.key)) return;
      k(T);
    } else T.pointerType !== "keyboard" && b && p(T);
  }) : (N.onPressStart = (T) => {
    P.current = T.pointerType, _.current = y, w.current = x, b && (T.pointerType === "mouse" && !x || T.pointerType === "keyboard" && (!E || Tx(T.key))) && p(T);
  }, N.onPress = (T) => {
    (T.pointerType === "touch" || T.pointerType === "pen" || T.pointerType === "virtual" || T.pointerType === "keyboard" && $ && $x(T.key) || T.pointerType === "mouse" && w.current) && ($ ? k(T) : b && p(T));
  }), h["data-collection"] = W9(n.collection), h["data-key"] = r, N.preventFocusOnPress = a, a && (N = nt(N, {
    onPressStart(T) {
      T.pointerType !== "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    },
    onPress(T) {
      T.pointerType === "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    }
  })), A)
    for (let T of [
      "onPressStart",
      "onPressEnd",
      "onPressChange",
      "onPress",
      "onPressUp",
      "onClick"
    ]) A[T] && (N[T] = Ma(N[T], A[T]));
  let { pressProps: I, isPressed: B } = mp(N), q = S ? (T) => {
    P.current === "mouse" && (T.stopPropagation(), T.preventDefault(), k(T));
  } : void 0, { longPressProps: ee } = Tk({
    isDisabled: !y,
    onLongPress(T) {
      T.pointerType === "touch" && (p(T), n.setSelectionBehavior("toggle"));
    }
  }), re = (T) => {
    P.current === "touch" && _.current && T.preventDefault();
  }, Z = f !== "none" && n.isLink(r) ? (T) => {
    Wi.isOpening || T.preventDefault();
  } : void 0;
  return {
    itemProps: nt(
      h,
      b || x || a && !l ? I : {},
      y ? ee : {},
      {
        onDoubleClick: q,
        onDragStartCapture: re,
        onClick: Z,
        id: t
      },
      // Prevent DOM focus from moving on mouse down when using virtual focus
      a ? {
        onMouseDown: (T) => T.preventDefault()
      } : void 0
    ),
    isPressed: B,
    isSelected: n.isSelected(r),
    isFocused: n.isFocused && n.focusedKey === r,
    isDisabled: l,
    allowsSelection: b,
    hasAction: $
  };
}
function $x(e) {
  return e === "Enter";
}
function Tx(e) {
  return e === " ";
}
class Ox {
  getItemRect(t) {
    let n = this.ref.current;
    if (!n) return null;
    let r = t != null ? $f(this.ref, t) : null;
    if (!r) return null;
    let i = n.getBoundingClientRect(), o = r.getBoundingClientRect();
    return {
      x: o.left - i.left - n.clientLeft + n.scrollLeft,
      y: o.top - i.top - n.clientTop + n.scrollTop,
      width: o.width,
      height: o.height
    };
  }
  getContentSize() {
    let t = this.ref.current;
    var n, r;
    return {
      width: (n = t?.scrollWidth) !== null && n !== void 0 ? n : 0,
      height: (r = t?.scrollHeight) !== null && r !== void 0 ? r : 0
    };
  }
  getVisibleRect() {
    let t = this.ref.current;
    var n, r, i, o;
    return {
      x: (n = t?.scrollLeft) !== null && n !== void 0 ? n : 0,
      y: (r = t?.scrollTop) !== null && r !== void 0 ? r : 0,
      width: (i = t?.clientWidth) !== null && i !== void 0 ? i : 0,
      height: (o = t?.clientHeight) !== null && o !== void 0 ? o : 0
    };
  }
  constructor(t) {
    this.ref = t;
  }
}
class Db {
  isDisabled(t) {
    var n;
    return this.disabledBehavior === "all" && (((n = t.props) === null || n === void 0 ? void 0 : n.isDisabled) || this.disabledKeys.has(t.key));
  }
  findNextNonDisabled(t, n) {
    let r = t;
    for (; r != null; ) {
      let i = this.collection.getItem(r);
      if (i?.type === "item" && !this.isDisabled(i)) return r;
      r = n(r);
    }
    return null;
  }
  getNextKey(t) {
    let n = t;
    return n = this.collection.getKeyAfter(n), this.findNextNonDisabled(n, (r) => this.collection.getKeyAfter(r));
  }
  getPreviousKey(t) {
    let n = t;
    return n = this.collection.getKeyBefore(n), this.findNextNonDisabled(n, (r) => this.collection.getKeyBefore(r));
  }
  findKey(t, n, r) {
    let i = t, o = this.layoutDelegate.getItemRect(i);
    if (!o || i == null) return null;
    let a = o;
    do {
      if (i = n(i), i == null) break;
      o = this.layoutDelegate.getItemRect(i);
    } while (o && r(a, o) && i != null);
    return i;
  }
  isSameRow(t, n) {
    return t.y === n.y || t.x !== n.x;
  }
  isSameColumn(t, n) {
    return t.x === n.x || t.y !== n.y;
  }
  getKeyBelow(t) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (n) => this.getNextKey(n), this.isSameRow) : this.getNextKey(t);
  }
  getKeyAbove(t) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (n) => this.getPreviousKey(n), this.isSameRow) : this.getPreviousKey(t);
  }
  getNextColumn(t, n) {
    return n ? this.getPreviousKey(t) : this.getNextKey(t);
  }
  getKeyRightOf(t) {
    let n = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[n] ? (t = this.layoutDelegate[n](t), this.findNextNonDisabled(t, (r) => this.layoutDelegate[n](r))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "rtl") : this.findKey(t, (r) => this.getNextColumn(r, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "rtl") : null;
  }
  getKeyLeftOf(t) {
    let n = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[n] ? (t = this.layoutDelegate[n](t), this.findNextNonDisabled(t, (r) => this.layoutDelegate[n](r))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "ltr") : this.findKey(t, (r) => this.getNextColumn(r, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyAfter(n));
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyBefore(n));
  }
  getKeyPageAbove(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    if (n && !Rs(n)) return this.getFirstKey();
    let i = t;
    if (this.orientation === "horizontal") {
      let o = Math.max(0, r.x + r.width - this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x > o && i != null; )
        i = this.getKeyAbove(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    } else {
      let o = Math.max(0, r.y + r.height - this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y > o && i != null; )
        i = this.getKeyAbove(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    }
    return i ?? this.getFirstKey();
  }
  getKeyPageBelow(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    if (n && !Rs(n)) return this.getLastKey();
    let i = t;
    if (this.orientation === "horizontal") {
      let o = Math.min(this.layoutDelegate.getContentSize().width, r.y - r.width + this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x < o && i != null; )
        i = this.getKeyBelow(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    } else {
      let o = Math.min(this.layoutDelegate.getContentSize().height, r.y - r.height + this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y < o && i != null; )
        i = this.getKeyBelow(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    }
    return i ?? this.getLastKey();
  }
  getKeyForSearch(t, n) {
    if (!this.collator) return null;
    let r = this.collection, i = n || this.getFirstKey();
    for (; i != null; ) {
      let o = r.getItem(i);
      if (!o) return null;
      let a = o.textValue.slice(0, t.length);
      if (o.textValue && this.collator.compare(a, t) === 0) return i;
      i = this.getNextKey(i);
    }
    return null;
  }
  constructor(...t) {
    if (t.length === 1) {
      let n = t[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = n.disabledBehavior || "all", this.orientation = n.orientation || "vertical", this.direction = n.direction, this.layout = n.layout || "stack", this.layoutDelegate = n.layoutDelegate || new Ox(n.ref);
    } else
      this.collection = t[0], this.disabledKeys = t[1], this.ref = t[2], this.collator = t[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new Ox(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
function gP(e) {
  let { selectionManager: t, collection: n, disabledKeys: r, ref: i, keyboardDelegate: o, layoutDelegate: a } = e, s = xb({
    usage: "search",
    sensitivity: "base"
  }), l = t.disabledBehavior, u = Ee(() => o || new Db({
    collection: n,
    disabledKeys: r,
    disabledBehavior: l,
    ref: i,
    collator: s,
    layoutDelegate: a
  }), [
    o,
    a,
    n,
    r,
    i,
    s,
    l
  ]), { collectionProps: c } = Y9({
    ...e,
    ref: i,
    selectionManager: t,
    keyboardDelegate: u
  });
  return {
    listProps: c
  };
}
function Q9(e, t, n) {
  let r = xn(e, {
    labelable: !0
  }), i = e.selectionBehavior || "toggle", o = e.linkBehavior || (i === "replace" ? "action" : "override");
  i === "toggle" && o === "action" && (o = "override");
  let { listProps: a } = gP({
    ...e,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    linkBehavior: o
  }), { focusWithinProps: s } = gp({
    onFocusWithin: e.onFocus,
    onBlurWithin: e.onBlur,
    onFocusWithinChange: e.onFocusChange
  }), l = Zn(e.id);
  Pb.set(t, {
    id: l,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp,
    shouldFocusOnHover: e.shouldFocusOnHover,
    isVirtualized: e.isVirtualized,
    onAction: e.onAction,
    linkBehavior: o,
    // @ts-ignore
    UNSTABLE_itemBehavior: e.UNSTABLE_itemBehavior
  });
  let { labelProps: u, fieldProps: c } = pP({
    ...e,
    id: l,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: u,
    listBoxProps: nt(r, s, t.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      ...nt(c, a)
    })
  };
}
class J9 {
  build(t, n) {
    return this.context = n, kx(() => this.iterateCollection(t));
  }
  *iterateCollection(t) {
    let { children: n, items: r } = t;
    if (G.isValidElement(n) && n.type === G.Fragment) yield* this.iterateCollection({
      children: n.props.children,
      items: r
    });
    else if (typeof n == "function") {
      if (!r) throw new Error("props.children was a function but props.items is missing");
      let i = 0;
      for (let o of r)
        yield* this.getFullNode({
          value: o,
          index: i
        }, {
          renderer: n
        }), i++;
    } else {
      let i = [];
      G.Children.forEach(n, (a) => {
        a && i.push(a);
      });
      let o = 0;
      for (let a of i) {
        let s = this.getFullNode({
          element: a,
          index: o
        }, {});
        for (let l of s)
          o++, yield l;
      }
    }
  }
  getKey(t, n, r, i) {
    if (t.key != null) return t.key;
    if (n.type === "cell" && n.key != null) return `${i}${n.key}`;
    let o = n.value;
    if (o != null) {
      var a;
      let s = (a = o.key) !== null && a !== void 0 ? a : o.id;
      if (s == null) throw new Error("No key found for item");
      return s;
    }
    return i ? `${i}.${n.index}` : `$.${n.index}`;
  }
  getChildState(t, n) {
    return {
      renderer: n.renderer || t.renderer
    };
  }
  *getFullNode(t, n, r, i) {
    if (G.isValidElement(t.element) && t.element.type === G.Fragment) {
      let v = [];
      G.Children.forEach(t.element.props.children, (b) => {
        v.push(b);
      });
      var o;
      let g = (o = t.index) !== null && o !== void 0 ? o : 0;
      for (const b of v) yield* this.getFullNode({
        element: b,
        index: g++
      }, n, r, i);
      return;
    }
    let a = t.element;
    if (!a && t.value && n && n.renderer) {
      let v = this.cache.get(t.value);
      if (v && (!v.shouldInvalidate || !v.shouldInvalidate(this.context))) {
        v.index = t.index, v.parentKey = i ? i.key : null, yield v;
        return;
      }
      a = n.renderer(t.value);
    }
    if (G.isValidElement(a)) {
      let v = a.type;
      if (typeof v != "function" && typeof v.getCollectionNode != "function") {
        let x = a.type;
        throw new Error(`Unknown element <${x}> in collection.`);
      }
      let g = v.getCollectionNode(a.props, this.context);
      var s;
      let b = (s = t.index) !== null && s !== void 0 ? s : 0, E = g.next();
      for (; !E.done && E.value; ) {
        let x = E.value;
        t.index = b;
        var l;
        let S = (l = x.key) !== null && l !== void 0 ? l : null;
        S == null && (S = x.element ? null : this.getKey(a, t, n, r));
        let P = [
          ...this.getFullNode({
            ...x,
            key: S,
            index: b,
            wrapper: X9(t.wrapper, x.wrapper)
          }, this.getChildState(n, x), r ? `${r}${a.key}` : a.key, i)
        ];
        for (let y of P) {
          var u, c;
          y.value = (c = (u = x.value) !== null && u !== void 0 ? u : t.value) !== null && c !== void 0 ? c : null, y.value && this.cache.set(y.value, y);
          var f;
          if (t.type && y.type !== t.type) throw new Error(`Unsupported type <${em(y.type)}> in <${em((f = i?.type) !== null && f !== void 0 ? f : "unknown parent type")}>. Only <${em(t.type)}> is supported.`);
          b++, yield y;
        }
        E = g.next(P);
      }
      return;
    }
    if (t.key == null || t.type == null) return;
    let d = this;
    var p, h;
    let m = {
      type: t.type,
      props: t.props,
      key: t.key,
      parentKey: i ? i.key : null,
      value: (p = t.value) !== null && p !== void 0 ? p : null,
      level: i ? i.level + 1 : 0,
      index: t.index,
      rendered: t.rendered,
      textValue: (h = t.textValue) !== null && h !== void 0 ? h : "",
      "aria-label": t["aria-label"],
      wrapper: t.wrapper,
      shouldInvalidate: t.shouldInvalidate,
      hasChildNodes: t.hasChildNodes || !1,
      childNodes: kx(function* () {
        if (!t.hasChildNodes || !t.childNodes) return;
        let v = 0;
        for (let g of t.childNodes()) {
          g.key != null && (g.key = `${m.key}${g.key}`);
          let b = d.getFullNode({
            ...g,
            index: v
          }, d.getChildState(n, g), m.key, m);
          for (let E of b)
            v++, yield E;
        }
      })
    };
    yield m;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function kx(e) {
  let t = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let r of t) yield r;
      n || (n = e());
      for (let r of n)
        t.push(r), yield r;
    }
  };
}
function X9(e, t) {
  if (e && t) return (n) => e(t(n));
  if (e) return e;
  if (t) return t;
}
function em(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function yP(e, t, n) {
  let r = Ee(() => new J9(), []), { children: i, items: o, collection: a } = e;
  return Ee(() => {
    if (a) return a;
    let l = r.build({
      children: i,
      items: o
    }, n);
    return t(l);
  }, [
    r,
    i,
    o,
    a,
    n,
    t
  ]);
}
function bP(e, t) {
  return typeof t.getChildren == "function" ? t.getChildren(e.key) : e.childNodes;
}
function e7(e) {
  return t7(e);
}
function t7(e, t) {
  for (let n of e)
    return n;
}
function tm(e, t, n) {
  if (t.parentKey === n.parentKey) return t.index - n.index;
  let r = [
    ...Px(e, t),
    t
  ], i = [
    ...Px(e, n),
    n
  ], o = r.slice(0, i.length).findIndex((a, s) => a !== i[s]);
  return o !== -1 ? (t = r[o], n = i[o], t.index - n.index) : r.findIndex((a) => a === n) >= 0 ? 1 : (i.findIndex((a) => a === t) >= 0, -1);
}
function Px(e, t) {
  let n = [], r = t;
  for (; r?.parentKey != null; )
    r = e.getItem(r.parentKey), r && n.unshift(r);
  return n;
}
const Dx = /* @__PURE__ */ new WeakMap();
function _P(e) {
  let t = Dx.get(e);
  if (t != null) return t;
  let n = 0, r = (i) => {
    for (let o of i)
      o.type === "section" ? r(bP(o, e)) : o.type === "item" && n++;
  };
  return r(e), Dx.set(e, n), n;
}
function n7(e, t, n) {
  var r, i;
  let { key: o } = e, a = Pb.get(t);
  var s;
  let l = (s = e.isDisabled) !== null && s !== void 0 ? s : t.selectionManager.isDisabled(o);
  var u;
  let c = (u = e.isSelected) !== null && u !== void 0 ? u : t.selectionManager.isSelected(o);
  var f;
  let d = (f = e.shouldSelectOnPressUp) !== null && f !== void 0 ? f : a?.shouldSelectOnPressUp;
  var p;
  let h = (p = e.shouldFocusOnHover) !== null && p !== void 0 ? p : a?.shouldFocusOnHover;
  var m;
  let v = (m = e.shouldUseVirtualFocus) !== null && m !== void 0 ? m : a?.shouldUseVirtualFocus;
  var g;
  let b = (g = e.isVirtualized) !== null && g !== void 0 ? g : a?.isVirtualized, E = ha(), x = ha(), S = {
    role: "option",
    "aria-disabled": l || void 0,
    "aria-selected": t.selectionManager.selectionMode !== "none" ? c : void 0
  };
  Oo() && pb() || (S["aria-label"] = e["aria-label"], S["aria-labelledby"] = E, S["aria-describedby"] = x);
  let $ = t.collection.getItem(o);
  if (b) {
    let ee = Number($?.index);
    S["aria-posinset"] = Number.isNaN(ee) ? void 0 : ee + 1, S["aria-setsize"] = _P(t.collection);
  }
  let P = a?.onAction ? () => {
    var ee;
    return a == null || (ee = a.onAction) === null || ee === void 0 ? void 0 : ee.call(a, o);
  } : void 0, y = U9(t, o), { itemProps: _, isPressed: w, isFocused: A, hasAction: k, allowsSelection: N } = vP({
    selectionManager: t.selectionManager,
    key: o,
    ref: n,
    shouldSelectOnPressUp: d,
    allowsDifferentPressOrigin: d && h,
    isVirtualized: b,
    shouldUseVirtualFocus: v,
    isDisabled: l,
    onAction: P || !($ == null || (r = $.props) === null || r === void 0) && r.onAction ? Ma($ == null || (i = $.props) === null || i === void 0 ? void 0 : i.onAction, P) : void 0,
    linkBehavior: a?.linkBehavior,
    // @ts-ignore
    UNSTABLE_itemBehavior: a?.UNSTABLE_itemBehavior,
    id: y
  }), { hoverProps: I } = sl({
    isDisabled: l || !h,
    onHoverStart() {
      wa() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(o));
    }
  }), B = xn($?.props);
  delete B.id;
  let q = rk($?.props);
  return {
    optionProps: {
      ...S,
      ...nt(B, _, I, q),
      id: y
    },
    labelProps: {
      id: E
    },
    descriptionProps: {
      id: x
    },
    isFocused: A,
    isFocusVisible: A && t.selectionManager.isFocused && wa(),
    isSelected: c,
    isDisabled: l,
    isPressed: w,
    allowsSelection: N,
    hasAction: k
  };
}
function r7(e) {
  let { heading: t, "aria-label": n } = e, r = Zn();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Technically, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: r,
      role: "presentation",
      onMouseDown: (i) => {
        i.preventDefault();
      }
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
const wP = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, xP = {
  ...wP,
  customError: !0,
  valid: !1
}, Nl = {
  isInvalid: !1,
  validationDetails: wP,
  validationErrors: []
}, i7 = Le({}), Ax = "__formValidationState" + Date.now();
function o7(e) {
  if (e[Ax]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: i, commitValidation: o } = e[Ax];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: i,
      commitValidation: o
    };
  }
  return a7(e);
}
function a7(e) {
  let { isInvalid: t, validationState: n, name: r, value: i, builtinValidation: o, validate: a, validationBehavior: s = "aria" } = e;
  n && (t || (t = n === "invalid"));
  let l = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: xP
  } : null, u = Ee(() => {
    if (!a || i == null) return null;
    let w = s7(a, i);
    return Cx(w);
  }, [
    a,
    i
  ]);
  o?.validationDetails.valid && (o = void 0);
  let c = Ce(i7), f = Ee(() => r ? Array.isArray(r) ? r.flatMap((w) => lg(c[w])) : lg(c[r]) : [], [
    c,
    r
  ]), [d, p] = je(c), [h, m] = je(!1);
  c !== d && (p(c), m(!1));
  let v = Ee(() => Cx(h ? [] : f), [
    h,
    f
  ]), g = ve(Nl), [b, E] = je(Nl), x = ve(Nl), S = () => {
    if (!$) return;
    P(!1);
    let w = u || o || g.current;
    nm(w, x.current) || (x.current = w, E(w));
  }, [$, P] = je(!1);
  return De(S), {
    realtimeValidation: l || v || u || o || Nl,
    displayValidation: s === "native" ? l || v || b : l || v || u || o || b,
    updateValidation(w) {
      s === "aria" && !nm(b, w) ? E(w) : g.current = w;
    },
    resetValidation() {
      let w = Nl;
      nm(w, x.current) || (x.current = w, E(w)), s === "native" && P(!1), m(!0);
    },
    commitValidation() {
      s === "native" && P(!0), m(!0);
    }
  };
}
function lg(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function s7(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean") return lg(n);
  }
  return [];
}
function Cx(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: xP
  } : null;
}
function nm(e, t) {
  return e === t ? !0 : !!e && !!t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
var EP = {};
EP = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var SP = {};
SP = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var $P = {};
$P = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var TP = {};
TP = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var OP = {};
OP = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var kP = {};
kP = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var PP = {};
PP = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var DP = {};
DP = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var AP = {};
AP = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var CP = {};
CP = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var IP = {};
IP = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var MP = {};
MP = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var RP = {};
RP = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var NP = {};
NP = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var jP = {};
jP = {
  longPressMessage: "Premi a lungo o premi Alt + Freccia giù per aprire il menu"
};
var FP = {};
FP = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var zP = {};
zP = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var LP = {};
LP = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var VP = {};
VP = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var BP = {};
BP = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var KP = {};
KP = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var UP = {};
UP = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var qP = {};
qP = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var HP = {};
HP = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var WP = {};
WP = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var ZP = {};
ZP = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var GP = {};
GP = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var YP = {};
YP = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var QP = {};
QP = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var JP = {};
JP = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var XP = {};
XP = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var eD = {};
eD = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var tD = {};
tD = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var nD = {};
nD = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var rD = {};
rD = {
  "ar-AE": EP,
  "bg-BG": SP,
  "cs-CZ": $P,
  "da-DK": TP,
  "de-DE": OP,
  "el-GR": kP,
  "en-US": PP,
  "es-ES": DP,
  "et-EE": AP,
  "fi-FI": CP,
  "fr-FR": IP,
  "he-IL": MP,
  "hr-HR": RP,
  "hu-HU": NP,
  "it-IT": jP,
  "ja-JP": FP,
  "ko-KR": zP,
  "lt-LT": LP,
  "lv-LV": VP,
  "nb-NO": BP,
  "nl-NL": KP,
  "pl-PL": UP,
  "pt-BR": qP,
  "pt-PT": HP,
  "ro-RO": WP,
  "ru-RU": ZP,
  "sk-SK": GP,
  "sl-SI": YP,
  "sr-SP": QP,
  "sv-SE": JP,
  "tr-TR": XP,
  "uk-UA": eD,
  "zh-CN": tD,
  "zh-TW": nD
};
function l7(e) {
  return e && e.__esModule ? e.default : e;
}
function iD(e, t, n) {
  let { type: r = "menu", isDisabled: i, trigger: o = "press" } = e, a = Zn(), { triggerProps: s, overlayProps: l } = D9({
    type: r
  }, t, n), u = (p) => {
    if (!i && !(o === "longPress" && !p.altKey) && n && n.current)
      switch (p.key) {
        case "Enter":
        case " ":
          if (o === "longPress" || p.isDefaultPrevented()) return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in p || p.stopPropagation(), p.preventDefault(), t.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in p || p.stopPropagation(), p.preventDefault(), t.toggle("last");
          break;
        default:
          "continuePropagation" in p && p.continuePropagation();
      }
  }, c = mk(l7(rD), "@react-aria/menu"), { longPressProps: f } = Tk({
    isDisabled: i || o !== "longPress",
    accessibilityDescription: c.format("longPressMessage"),
    onLongPressStart() {
      t.close();
    },
    onLongPress() {
      t.open("first");
    }
  }), d = {
    preventFocusOnPress: !0,
    onPressStart(p) {
      p.pointerType !== "touch" && p.pointerType !== "keyboard" && !i && (ni(p.target), t.open(p.pointerType === "virtual" ? "first" : null));
    },
    onPress(p) {
      p.pointerType === "touch" && !i && (ni(p.target), t.toggle());
    }
  };
  return delete s.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...s,
      ...o === "press" ? d : f,
      id: a,
      onKeyDown: u
    },
    menuProps: {
      ...l,
      "aria-labelledby": a,
      autoFocus: t.focusStrategy || !0,
      onClose: t.close
    }
  };
}
const oD = /* @__PURE__ */ new WeakMap();
function u7(e, t, n) {
  let { shouldFocusWrap: r = !0, onKeyDown: i, onKeyUp: o, ...a } = e;
  !e["aria-label"] && !e["aria-labelledby"] && process.env.NODE_ENV !== "production" && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let s = xn(e, {
    labelable: !0
  }), { listProps: l } = gP({
    ...a,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    shouldFocusWrap: r,
    linkBehavior: "override"
  });
  return oD.set(t, {
    onClose: e.onClose,
    onAction: e.onAction,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus
  }), {
    menuProps: nt(s, {
      onKeyDown: i,
      onKeyUp: o
    }, {
      role: "menu",
      ...l,
      onKeyDown: (u) => {
        var c;
        (u.key !== "Escape" || e.shouldUseVirtualFocus) && ((c = l.onKeyDown) === null || c === void 0 || c.call(l, u));
      }
    })
  };
}
function c7(e, t, n) {
  let { id: r, key: i, closeOnSelect: o, shouldCloseOnSelect: a, isVirtualized: s, "aria-haspopup": l, onPressStart: u, onPressUp: c, onPress: f, onPressChange: d, onPressEnd: p, onClick: h, onHoverStart: m, onHoverChange: v, onHoverEnd: g, onKeyDown: b, onKeyUp: E, onFocus: x, onFocusChange: S, onBlur: $, selectionManager: P = t.selectionManager } = e, y = !!l, _ = y && e["aria-expanded"] === "true";
  var w;
  let A = (w = e.isDisabled) !== null && w !== void 0 ? w : P.isDisabled(i);
  var k;
  let N = (k = e.isSelected) !== null && k !== void 0 ? k : P.isSelected(i), I = oD.get(t), B = t.collection.getItem(i), q = e.onClose || I.onClose, ee = up(), re = () => {
    var ne;
    if (!y && (!(B == null || (ne = B.props) === null || ne === void 0) && ne.onAction ? B.props.onAction() : e.onAction && e.onAction(i), I.onAction)) {
      let we = I.onAction;
      we(i);
    }
  }, Z = "menuitem";
  y || (P.selectionMode === "single" ? Z = "menuitemradio" : P.selectionMode === "multiple" && (Z = "menuitemcheckbox"));
  let T = ha(), F = ha(), M = ha(), K = {
    id: r,
    "aria-disabled": A || void 0,
    role: Z,
    "aria-label": e["aria-label"],
    "aria-labelledby": T,
    "aria-describedby": [
      e["aria-describedby"],
      F,
      M
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": e["aria-controls"],
    "aria-haspopup": l,
    "aria-expanded": e["aria-expanded"]
  };
  if (P.selectionMode !== "none" && !y && (K["aria-checked"] = N), s) {
    let ne = Number(B?.index);
    K["aria-posinset"] = Number.isNaN(ne) ? void 0 : ne + 1, K["aria-setsize"] = _P(t.collection);
  }
  let te = ve(!1), se = (ne) => {
    d?.(ne), te.current = ne;
  }, de = ve(null), ge = (ne) => {
    ne.pointerType !== "keyboard" && (de.current = {
      pointerType: ne.pointerType
    }), ne.pointerType === "mouse" && (te.current || ne.target.click()), c?.(ne);
  }, V = (ne) => {
    var we, ke;
    h?.(ne), re(), rL(ne, ee, B.props.href, B?.props.routerOptions);
    let pe = ((we = de.current) === null || we === void 0 ? void 0 : we.pointerType) === "keyboard" ? ((ke = de.current) === null || ke === void 0 ? void 0 : ke.key) === "Enter" || P.selectionMode === "none" || P.isLink(i) : P.selectionMode !== "multiple" || P.isLink(i);
    var j;
    pe = (j = a ?? o) !== null && j !== void 0 ? j : pe, q && !y && pe && q(), de.current = null;
  }, { itemProps: O, isFocused: D } = vP({
    id: r,
    selectionManager: P,
    key: i,
    ref: n,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: I.shouldUseVirtualFocus
  }), { pressProps: C, isPressed: z } = mp({
    onPressStart: u,
    onPress: f,
    onPressUp: ge,
    onPressChange: se,
    onPressEnd: p,
    isDisabled: A
  }), { hoverProps: H } = sl({
    isDisabled: A,
    onHoverStart(ne) {
      !wa() && !(_ && l) && (P.setFocused(!0), P.setFocusedKey(i)), m?.(ne);
    },
    onHoverChange: v,
    onHoverEnd: g
  }), { keyboardProps: X } = Tb({
    onKeyDown: (ne) => {
      if (ne.repeat) {
        ne.continuePropagation();
        return;
      }
      switch (ne.key) {
        case " ":
          de.current = {
            pointerType: "keyboard",
            key: " "
          }, Te(ne).click(), cd("keyboard");
          break;
        case "Enter":
          de.current = {
            pointerType: "keyboard",
            key: "Enter"
          }, Te(ne).tagName !== "A" && Te(ne).click(), cd("keyboard");
          break;
        default:
          y || ne.continuePropagation(), b?.(ne);
          break;
      }
    },
    onKeyUp: E
  }), { focusableProps: fe } = Sk({
    onBlur: $,
    onFocus: x,
    onFocusChange: S
  }, n), ce = xn(B?.props);
  delete ce.id;
  let xe = rk(B?.props);
  return {
    menuItemProps: {
      ...K,
      ...nt(
        ce,
        xe,
        y ? {
          onFocus: O.onFocus,
          "data-collection": O["data-collection"],
          "data-key": O["data-key"]
        } : O,
        C,
        H,
        X,
        fe,
        // Prevent DOM focus from moving on mouse down when using virtual focus or this is a submenu/subdialog trigger.
        I.shouldUseVirtualFocus || y ? {
          onMouseDown: (ne) => ne.preventDefault()
        } : void 0,
        A ? void 0 : {
          onClick: V
        }
      ),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: O.tabIndex != null && _ && !I.shouldUseVirtualFocus ? -1 : O.tabIndex
    },
    labelProps: {
      id: T
    },
    descriptionProps: {
      id: F
    },
    keyboardShortcutProps: {
      id: M
    },
    isFocused: D,
    isFocusVisible: D && P.isFocused && wa() && !_,
    isSelected: N,
    isPressed: z,
    isDisabled: A
  };
}
function f7(e) {
  let { heading: t, "aria-label": n } = e, r = Zn();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: r,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
function d7(e, t, n) {
  let { validationBehavior: r, focus: i } = e;
  ot(() => {
    if (r === "native" && n?.current && !n.current.disabled) {
      let u = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(u), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(h7(n.current));
    }
  });
  let o = ve(!1), a = or(() => {
    o.current || t.resetValidation();
  }), s = or((u) => {
    var c;
    t.displayValidation.isInvalid || t.commitValidation();
    let f = n == null || (c = n.current) === null || c === void 0 ? void 0 : c.form;
    if (!u.defaultPrevented && n && f && m7(f) === n.current) {
      var d;
      i ? i() : (d = n.current) === null || d === void 0 || d.focus(), cd("keyboard");
    }
    u.preventDefault();
  }), l = or(() => {
    t.commitValidation();
  });
  De(() => {
    let u = n?.current;
    if (!u) return;
    let c = u.form, f = c?.reset;
    return c && (c.reset = () => {
      o.current = !window.event || window.event.type === "message" && Te(window.event) instanceof MessagePort, f?.call(c), o.current = !1;
    }), u.addEventListener("invalid", s), u.addEventListener("change", l), c?.addEventListener("reset", a), () => {
      u.removeEventListener("invalid", s), u.removeEventListener("change", l), c?.removeEventListener("reset", a), c && (c.reset = f);
    };
  }, [
    n,
    r
  ]);
}
function p7(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function h7(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: p7(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function m7(e) {
  for (let n = 0; n < e.elements.length; n++) {
    var t;
    let r = e.elements[n];
    if (((t = r.validity) === null || t === void 0 ? void 0 : t.valid) === !1) return r;
  }
  return null;
}
class ll {
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let t = new this.constructor(this.key);
    return t.value = this.value, t.level = this.level, t.hasChildNodes = this.hasChildNodes, t.rendered = this.rendered, t.textValue = this.textValue, t["aria-label"] = this["aria-label"], t.index = this.index, t.parentKey = this.parentKey, t.prevKey = this.prevKey, t.nextKey = this.nextKey, t.firstChildKey = this.firstChildKey, t.lastChildKey = this.lastChildKey, t.props = this.props, t.render = this.render, t.colSpan = this.colSpan, t.colIndex = this.colIndex, t;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  filter(t, n, r) {
    let i = this.clone();
    return n.addDescendants(i, t), i;
  }
  constructor(t) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.colSpan = null, this.colIndex = null, this.type = this.constructor.type, this.key = t;
  }
}
class aD extends ll {
  filter(t, n, r) {
    let [i, o] = lD(t, n, this.firstChildKey, r), a = this.clone();
    return a.firstChildKey = i, a.lastChildKey = o, a;
  }
}
class v7 extends ll {
}
v7.type = "header";
class sD extends ll {
}
sD.type = "loader";
class Ab extends aD {
  filter(t, n, r) {
    if (r(this.textValue, this)) {
      let i = this.clone();
      return n.addDescendants(i, t), i;
    }
    return null;
  }
}
Ab.type = "item";
class g7 extends aD {
  filter(t, n, r) {
    let i = super.filter(t, n, r);
    if (i && i.lastChildKey !== null) {
      let o = t.getItem(i.lastChildKey);
      if (o && o.type !== "header") return i;
    }
    return null;
  }
}
g7.type = "section";
class y7 {
  get size() {
    return this.itemCount;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let t = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; t; )
      yield t, t = t.nextKey != null ? this.keyMap.get(t.nextKey) : void 0;
  }
  getChildren(t) {
    let n = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let r = n.get(t), i = r?.firstChildKey != null ? n.get(r.firstChildKey) : null;
        for (; i; )
          yield i, i = i.nextKey != null ? n.get(i.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.prevKey != null) {
      for (n = this.keyMap.get(n.prevKey); n && n.type !== "item" && n.lastChildKey != null; ) n = this.keyMap.get(n.lastChildKey);
      var r;
      return (r = n?.key) !== null && r !== void 0 ? r : null;
    }
    return n.parentKey;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.type !== "item" && n.firstChildKey != null) return n.firstChildKey;
    for (; n; ) {
      if (n.nextKey != null) return n.nextKey;
      if (n.parentKey != null) n = this.keyMap.get(n.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let t = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; t?.lastChildKey != null; ) t = this.keyMap.get(t.lastChildKey);
    var n;
    return (n = t?.key) !== null && n !== void 0 ? n : null;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let t = this.constructor, n = new t();
    return n.keyMap = new Map(this.keyMap), n.firstKey = this.firstKey, n.lastKey = this.lastKey, n.itemCount = this.itemCount, n;
  }
  addNode(t) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    t.type === "item" && this.keyMap.get(t.key) == null && this.itemCount++, this.keyMap.set(t.key, t);
  }
  // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
  addDescendants(t, n) {
    this.addNode(t);
    let r = n.getChildren(t.key);
    for (let i of r) this.addDescendants(i, n);
  }
  removeNode(t) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    let n = this.keyMap.get(t);
    n != null && n.type === "item" && this.itemCount--, this.keyMap.delete(t);
  }
  commit(t, n, r = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = t, this.lastKey = n, this.frozen = !r;
  }
  filter(t) {
    let n = new this.constructor(), [r, i] = lD(this, n, this.firstKey, t);
    return n?.commit(r, i), n;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1, this.itemCount = 0;
  }
}
function lD(e, t, n, r) {
  if (n == null) return [
    null,
    null
  ];
  let i = null, o = null, a = e.getItem(n);
  for (; a != null; ) {
    let u = a.filter(e, t, r);
    u != null && (u.nextKey = null, o && (u.prevKey = o.key, o.nextKey = u.key), i == null && (i = u), t.addNode(u), o = u), a = a.nextKey ? e.getItem(a.nextKey) : null;
  }
  if (o && o.type === "separator") {
    let u = o.prevKey;
    t.removeNode(o.key), u ? (o = t.getItem(u), o.nextKey = null) : o = null;
  }
  var s, l;
  return [
    (s = i?.key) !== null && s !== void 0 ? s : null,
    (l = o?.key) !== null && l !== void 0 ? l : null
  ];
}
class uD {
  *[Symbol.iterator]() {
    let t = this.firstChild;
    for (; t; )
      yield t, t = t.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(t) {
    this._firstChild = t, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(t) {
    this._lastChild = t, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(t) {
    this._previousSibling = t, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(t) {
    this._nextSibling = t, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(t) {
    this._parentNode = t, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    var t;
    return ((t = this.parentNode) === null || t === void 0 ? void 0 : t.isConnected) || !1;
  }
  invalidateChildIndices(t) {
    (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || t.index < this._minInvalidChildIndex.index) && (this._minInvalidChildIndex = t, this.ownerDocument.markDirty(this));
  }
  updateChildIndices() {
    let t = this._minInvalidChildIndex;
    for (; t; )
      t.index = t.previousSibling ? t.previousSibling.index + 1 : 0, t = t.nextSibling;
    this._minInvalidChildIndex = null;
  }
  appendChild(t) {
    t.parentNode && t.parentNode.removeChild(t), this.firstChild == null && (this.firstChild = t), this.lastChild ? (this.lastChild.nextSibling = t, t.index = this.lastChild.index + 1, t.previousSibling = this.lastChild) : (t.previousSibling = null, t.index = 0), t.parentNode = this, t.nextSibling = null, this.lastChild = t, this.ownerDocument.markDirty(this), this.isConnected && this.ownerDocument.queueUpdate();
  }
  insertBefore(t, n) {
    if (n == null) return this.appendChild(t);
    t.parentNode && t.parentNode.removeChild(t), t.nextSibling = n, t.previousSibling = n.previousSibling, t.index = n.index - 1, this.firstChild === n ? this.firstChild = t : n.previousSibling && (n.previousSibling.nextSibling = t), n.previousSibling = t, t.parentNode = n.parentNode, this.invalidateChildIndices(t), this.isConnected && this.ownerDocument.queueUpdate();
  }
  removeChild(t) {
    t.parentNode === this && (this._minInvalidChildIndex === t && (this._minInvalidChildIndex = null), t.nextSibling && (this.invalidateChildIndices(t.nextSibling), t.nextSibling.previousSibling = t.previousSibling), t.previousSibling && (t.previousSibling.nextSibling = t.nextSibling), this.firstChild === t && (this.firstChild = t.nextSibling), this.lastChild === t && (this.lastChild = t.previousSibling), t.parentNode = null, t.nextSibling = null, t.previousSibling = null, t.index = 0, this.ownerDocument.markDirty(t), this.isConnected && this.ownerDocument.queueUpdate());
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  get previousVisibleSibling() {
    let t = this.previousSibling;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
  get nextVisibleSibling() {
    let t = this.nextSibling;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get firstVisibleChild() {
    let t = this.firstChild;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get lastVisibleChild() {
    let t = this.lastChild;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
  constructor(t) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this._minInvalidChildIndex = null, this.ownerDocument = t;
  }
}
class $s extends uD {
  get index() {
    return this._index;
  }
  set index(t) {
    this._index = t, this.ownerDocument.markDirty(this);
  }
  get level() {
    var t;
    return this.parentNode instanceof $s ? this.parentNode.level + (((t = this.parentNode.node) === null || t === void 0 ? void 0 : t.type) === "item" ? 1 : 0) : 0;
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode() {
    return this.node == null ? null : (this.isMutated || (this.node = this.node.clone(), this.isMutated = !0), this.ownerDocument.markDirty(this), this.node);
  }
  updateNode() {
    var t, n, r, i, o, a, s, l;
    let u = this.nextVisibleSibling, c = this.getMutableNode();
    if (c != null) {
      c.index = this.index, c.level = this.level;
      var f;
      c.parentKey = this.parentNode instanceof $s && (f = (t = this.parentNode.node) === null || t === void 0 ? void 0 : t.key) !== null && f !== void 0 ? f : null;
      var d;
      c.prevKey = (d = (r = this.previousVisibleSibling) === null || r === void 0 || (n = r.node) === null || n === void 0 ? void 0 : n.key) !== null && d !== void 0 ? d : null;
      var p;
      c.nextKey = (p = u == null || (i = u.node) === null || i === void 0 ? void 0 : i.key) !== null && p !== void 0 ? p : null, c.hasChildNodes = !!this.firstChild;
      var h;
      c.firstChildKey = (h = (a = this.firstVisibleChild) === null || a === void 0 || (o = a.node) === null || o === void 0 ? void 0 : o.key) !== null && h !== void 0 ? h : null;
      var m;
      if (c.lastChildKey = (m = (l = this.lastVisibleChild) === null || l === void 0 || (s = l.node) === null || s === void 0 ? void 0 : s.key) !== null && m !== void 0 ? m : null, (c.colSpan != null || c.colIndex != null) && u) {
        var v, g;
        let b = ((v = c.colIndex) !== null && v !== void 0 ? v : c.index) + ((g = c.colSpan) !== null && g !== void 0 ? g : 1);
        if (u.node != null && b !== u.node.colIndex) {
          let E = u.getMutableNode();
          E.colIndex = b;
        }
      }
    }
  }
  setProps(t, n, r, i, o) {
    let a, { value: s, textValue: l, id: u, ...c } = t;
    if (this.node == null ? (a = new r(u ?? `react-aria-${++this.ownerDocument.nodeId}`), this.node = a) : a = this.getMutableNode(), c.ref = n, a.props = c, a.rendered = i, a.render = o, a.value = s, t["aria-label"] && (a["aria-label"] = t["aria-label"]), a.textValue = l || (typeof c.children == "string" ? c.children : "") || t["aria-label"] || "", u != null && u !== a.key) throw new Error("Cannot change the id of an item");
    c.colSpan != null && (a.colSpan = c.colSpan), this.isConnected && this.ownerDocument.queueUpdate();
  }
  get style() {
    let t = this;
    return {
      get display() {
        return t.isHidden ? "none" : "";
      },
      set display(n) {
        let r = n === "none";
        if (t.isHidden !== r) {
          var i, o;
          (((i = t.parentNode) === null || i === void 0 ? void 0 : i.firstVisibleChild) === t || ((o = t.parentNode) === null || o === void 0 ? void 0 : o.lastVisibleChild) === t) && t.ownerDocument.markDirty(t.parentNode);
          let a = t.previousVisibleSibling, s = t.nextVisibleSibling;
          a && t.ownerDocument.markDirty(a), s && t.ownerDocument.markDirty(s), t.isHidden = r, t.ownerDocument.markDirty(t);
        }
      }
    };
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
  constructor(t, n) {
    super(n), this.nodeType = 8, this.isMutated = !0, this._index = 0, this.isHidden = !1, this.node = null;
  }
}
class b7 extends uD {
  get isConnected() {
    return !0;
  }
  createElement(t) {
    return new $s(t, this);
  }
  getMutableCollection() {
    return this.nextCollection || (this.nextCollection = this.collection.clone()), this.nextCollection;
  }
  markDirty(t) {
    this.dirtyNodes.add(t);
  }
  addNode(t) {
    if (t.isHidden || t.node == null) return;
    let n = this.getMutableCollection();
    if (!n.getItem(t.node.key)) for (let r of t) this.addNode(r);
    n.addNode(t.node);
  }
  removeNode(t) {
    for (let n of t) this.removeNode(n);
    t.node && this.getMutableCollection().removeNode(t.node.key);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.inSubscription ? this.collection : (this.queuedRender = !1, this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let s of this.dirtyNodes) s instanceof $s && (!s.isConnected || s.isHidden) ? this.removeNode(s) : s.updateChildIndices();
    for (let s of this.dirtyNodes) s instanceof $s ? (s.isConnected && !s.isHidden && (s.updateNode(), this.addNode(s)), s.node && this.dirtyNodes.delete(s), s.isMutated = !1) : this.dirtyNodes.delete(s);
    if (this.nextCollection) {
      var t, n, r, i, o, a;
      this.nextCollection.commit((o = (n = this.firstVisibleChild) === null || n === void 0 || (t = n.node) === null || t === void 0 ? void 0 : t.key) !== null && o !== void 0 ? o : null, (a = (i = this.lastVisibleChild) === null || i === void 0 || (r = i.node) === null || r === void 0 ? void 0 : r.key) !== null && a !== void 0 ? a : null, this.isSSR), this.isSSR || (this.collection = this.nextCollection, this.nextCollection = null);
    }
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.queuedRender)) {
      this.queuedRender = !0, this.inSubscription = !0, this.isSSR || (this.collection = this.collection.clone());
      for (let t of this.subscriptions) t();
      this.inSubscription = !1;
    }
  }
  subscribe(t) {
    return this.subscriptions.add(t), () => this.subscriptions.delete(t);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
  constructor(t) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.nextCollection = null, this.subscriptions = /* @__PURE__ */ new Set(), this.queuedRender = !1, this.inSubscription = !1, this.collection = t, this.nextCollection = t;
  }
}
function cD(e) {
  let { children: t, items: n, idScope: r, addIdAndValue: i, dependencies: o = [] } = e, a = Ee(() => /* @__PURE__ */ new WeakMap(), o);
  return Ee(() => {
    if (n && typeof t == "function") {
      let u = [];
      for (let c of n) {
        let f = a.get(c);
        if (!f) {
          f = t(c);
          var s, l;
          let d = (l = (s = f.props.id) !== null && s !== void 0 ? s : c.key) !== null && l !== void 0 ? l : c.id;
          if (d == null) throw new Error("Could not determine key for item");
          r != null && (d = r + ":" + d), f = Kf(f, i ? {
            key: d,
            id: d,
            value: c
          } : {
            key: d
          }), a.set(c, f);
        }
        u.push(f);
      }
      return u;
    } else if (typeof t != "function") return t;
  }, [
    t,
    n,
    a,
    r,
    i
  ]);
}
typeof HTMLTemplateElement < "u" && (Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
  configurable: !0,
  enumerable: !0,
  get: function() {
    return this.content.firstChild;
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "appendChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.appendChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "removeChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.removeChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "insertBefore", {
  configurable: !0,
  enumerable: !0,
  value: function(e, t) {
    return this.content.insertBefore(e, t);
  }
}));
const pd = /* @__PURE__ */ Le(!1);
function _7(e) {
  if (Ce(pd))
    return /* @__PURE__ */ G.createElement(G.Fragment, null, e.children);
  let n = /* @__PURE__ */ G.createElement(pd.Provider, {
    value: !0
  }, e.children);
  return /* @__PURE__ */ G.createElement("template", null, n);
}
function Cb(e) {
  let t = (n, r) => Ce(pd) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, Jt(t);
}
function w7() {
  return Ce(pd);
}
var Uc = { exports: {} }, rm = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ix;
function x7() {
  if (Ix) return rm;
  Ix = 1;
  var e = G;
  function t(f, d) {
    return f === d && (f !== 0 || 1 / f === 1 / d) || f !== f && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, a = e.useDebugValue;
  function s(f, d) {
    var p = d(), h = r({ inst: { value: p, getSnapshot: d } }), m = h[0].inst, v = h[1];
    return o(
      function() {
        m.value = p, m.getSnapshot = d, l(m) && v({ inst: m });
      },
      [f, p, d]
    ), i(
      function() {
        return l(m) && v({ inst: m }), f(function() {
          l(m) && v({ inst: m });
        });
      },
      [f]
    ), a(p), p;
  }
  function l(f) {
    var d = f.getSnapshot;
    f = f.value;
    try {
      var p = d();
      return !n(f, p);
    } catch {
      return !0;
    }
  }
  function u(f, d) {
    return d();
  }
  var c = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : s;
  return rm.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : c, rm;
}
var im = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mx;
function E7() {
  return Mx || (Mx = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(p, h) {
      return p === h && (p !== 0 || 1 / p === 1 / h) || p !== p && h !== h;
    }
    function t(p, h) {
      c || i.startTransition === void 0 || (c = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var m = h();
      if (!f) {
        var v = h();
        o(m, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      v = a({
        inst: { value: m, getSnapshot: h }
      });
      var g = v[0].inst, b = v[1];
      return l(
        function() {
          g.value = m, g.getSnapshot = h, n(g) && b({ inst: g });
        },
        [p, m, h]
      ), s(
        function() {
          return n(g) && b({ inst: g }), p(function() {
            n(g) && b({ inst: g });
          });
        },
        [p]
      ), u(m), m;
    }
    function n(p) {
      var h = p.getSnapshot;
      p = p.value;
      try {
        var m = h();
        return !o(p, m);
      } catch {
        return !0;
      }
    }
    function r(p, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = G, o = typeof Object.is == "function" ? Object.is : e, a = i.useState, s = i.useEffect, l = i.useLayoutEffect, u = i.useDebugValue, c = !1, f = !1, d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    im.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : d, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), im;
}
var Rx;
function S7() {
  return Rx || (Rx = 1, process.env.NODE_ENV === "production" ? Uc.exports = x7() : Uc.exports = E7()), Uc.exports;
}
var fD = S7();
const dD = /* @__PURE__ */ Le(!1), Du = /* @__PURE__ */ Le(null);
function Ib(e) {
  if (Ce(Du))
    return e.content;
  let { collection: n, document: r } = k7(e.createCollection);
  return /* @__PURE__ */ G.createElement(G.Fragment, null, /* @__PURE__ */ G.createElement(_7, null, /* @__PURE__ */ G.createElement(Du.Provider, {
    value: r
  }, e.content)), /* @__PURE__ */ G.createElement($7, {
    render: e.children,
    collection: n
  }));
}
function $7({ collection: e, render: t }) {
  return t(e);
}
function T7(e, t, n) {
  let r = ic(), i = ve(r);
  i.current = r;
  let o = Ne(() => i.current ? n() : t(), [
    t,
    n
  ]);
  return fD.useSyncExternalStore(e, o);
}
const O7 = typeof G.useSyncExternalStore == "function" ? G.useSyncExternalStore : T7;
function k7(e) {
  let [t] = je(() => new b7(e?.() || new y7())), n = Ne((a) => t.subscribe(a), [
    t
  ]), r = Ne(() => {
    let a = t.getCollection();
    return t.isSSR && t.resetAfterSSR(), a;
  }, [
    t
  ]), i = Ne(() => (t.isSSR = !0, t.getCollection()), [
    t
  ]);
  return {
    collection: O7(n, r, i),
    document: t
  };
}
const ug = /* @__PURE__ */ Le(null);
function P7(e) {
  var t;
  return t = class extends ll {
  }, t.type = e, t;
}
function D7(e, t, n, r, i, o) {
  typeof e == "string" && (e = P7(e));
  let a = Ne((l) => {
    l?.setProps(t, n, e, r, o);
  }, [
    t,
    n,
    r,
    o,
    e
  ]), s = Ce(ug);
  if (s) {
    let l = s.ownerDocument.nodesByProps.get(t);
    return l || (l = s.ownerDocument.createElement(e.type), l.setProps(t, n, e, r, o), s.appendChild(l), s.ownerDocument.updateCollection(), s.ownerDocument.nodesByProps.set(t, l)), i ? /* @__PURE__ */ G.createElement(ug.Provider, {
      value: l
    }, i) : null;
  }
  return /* @__PURE__ */ G.createElement(e.type, {
    ref: a
  }, i);
}
function Mb(e, t) {
  let n = ({ node: i }) => t(i.props, i.props.ref, i), r = Jt((i, o) => {
    let a = Ce(ng);
    if (!Ce(dD)) {
      if (t.length >= 3) throw new Error(t.name + " cannot be rendered outside a collection.");
      return t(i, o);
    }
    return D7(e, i, o, "children" in i ? i.children : null, null, (l) => (
      // Forward FocusableContext to real DOM tree so tooltips work.
      /* @__PURE__ */ G.createElement(ng.Provider, {
        value: a
      }, /* @__PURE__ */ G.createElement(n, {
        node: l
      }))
    ));
  });
  return r.displayName = t.name, r;
}
function A7(e) {
  return cD({
    ...e,
    addIdAndValue: !0
  });
}
const Nx = /* @__PURE__ */ Le(null);
function pD(e) {
  let t = Ce(Nx), n = (t?.dependencies || []).concat(e.dependencies);
  var r;
  let i = (r = e.idScope) !== null && r !== void 0 ? r : t?.idScope, o = A7({
    ...e,
    idScope: i,
    dependencies: n
  });
  return Ce(Du) && (o = /* @__PURE__ */ G.createElement(C7, null, o)), t = Ee(() => ({
    dependencies: n,
    idScope: i
  }), [
    i,
    ...n
  ]), /* @__PURE__ */ G.createElement(Nx.Provider, {
    value: t
  }, o);
}
function C7({ children: e }) {
  let t = Ce(Du), n = Ee(() => /* @__PURE__ */ G.createElement(Du.Provider, {
    value: null
  }, /* @__PURE__ */ G.createElement(dD.Provider, {
    value: !0
  }, e)), [
    e
  ]);
  return ic() ? /* @__PURE__ */ G.createElement(ug.Provider, {
    value: t
  }, n) : /* @__PURE__ */ ga(n, t);
}
const hD = /* @__PURE__ */ Le(null), I7 = {
  CollectionRoot({ collection: e, renderDropIndicator: t }) {
    return jx(e, null, t);
  },
  CollectionBranch({ collection: e, parent: t, renderDropIndicator: n }) {
    return jx(e, t, n);
  }
};
function jx(e, t, n) {
  return cD({
    items: t ? e.getChildren(t.key) : e,
    dependencies: [
      n
    ],
    children(r) {
      if (r.type === "content") return /* @__PURE__ */ G.createElement(G.Fragment, null);
      let i = r.render(r);
      return !n || r.type !== "item" ? i : /* @__PURE__ */ G.createElement(G.Fragment, null, n({
        type: "item",
        key: r.key,
        dropPosition: "before"
      }), i, M7(e, r, n));
    }
  });
}
function M7(e, t, n) {
  let r = t.key, i = e.getKeyAfter(r), o = i != null ? e.getItem(i) : null;
  for (; o != null && o.type !== "item"; )
    i = e.getKeyAfter(o.key), o = i != null ? e.getItem(i) : null;
  let a = t.nextKey != null ? e.getItem(t.nextKey) : null;
  for (; a != null && a.type !== "item"; ) a = a.nextKey != null ? e.getItem(a.nextKey) : null;
  let s = [];
  if (a == null) {
    let l = t;
    for (; l?.type === "item" && (!o || l.parentKey !== o.parentKey && o.level < l.level); ) {
      let u = n({
        type: "item",
        key: l.key,
        dropPosition: "after"
      });
      /* @__PURE__ */ _y(u) && s.push(/* @__PURE__ */ Kf(u, {
        key: `${l.key}-after`
      })), l = l.parentKey != null ? e.getItem(l.parentKey) : null;
    }
  }
  return s;
}
const ul = /* @__PURE__ */ Le(I7);
function R7(e) {
  return Ee(() => e != null ? /* @__PURE__ */ new Set([
    e
  ]) : null, [
    e
  ]);
}
function N7(e, t) {
  let { elementType: n = "button", isDisabled: r, onPress: i, onPressStart: o, onPressEnd: a, onPressUp: s, onPressChange: l, preventFocusOnPress: u, allowFocusWhenDisabled: c, onClick: f, href: d, target: p, rel: h, type: m = "button" } = e, v;
  n === "button" ? v = {
    type: m,
    disabled: r,
    form: e.form,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formMethod: e.formMethod,
    formNoValidate: e.formNoValidate,
    formTarget: e.formTarget,
    name: e.name,
    value: e.value
  } : v = {
    role: "button",
    href: n === "a" && !r ? d : void 0,
    target: n === "a" ? p : void 0,
    type: n === "input" ? m : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? h : void 0
  };
  let { pressProps: g, isPressed: b } = mp({
    onPressStart: o,
    onPressEnd: a,
    onPressChange: l,
    onPress: i,
    onPressUp: s,
    onClick: f,
    isDisabled: r,
    preventFocusOnPress: u,
    ref: t
  }), { focusableProps: E } = Sk(e, t);
  c && (E.tabIndex = r ? -1 : E.tabIndex);
  let x = nt(E, g, xn(e, {
    labelable: !0
  }));
  return {
    isPressed: b,
    buttonProps: nt(v, x, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"],
      "aria-disabled": e["aria-disabled"]
    })
  };
}
const Rb = /* @__PURE__ */ new WeakMap();
function j7(e, t, n) {
  let { keyboardDelegate: r, isDisabled: i, isRequired: o, name: a, form: s, validationBehavior: l = "aria" } = e, u = xb({
    usage: "search",
    sensitivity: "base"
  }), c = Ee(() => r || new Db(t.collection, t.disabledKeys, n, u), [
    r,
    t.collection,
    t.disabledKeys,
    u,
    n
  ]), { menuTriggerProps: f, menuProps: d } = iD({
    isDisabled: i,
    type: "listbox"
  }, t, n), p = (_) => {
    if (t.selectionManager.selectionMode !== "multiple")
      switch (_.key) {
        case "ArrowLeft": {
          var w, A;
          _.preventDefault();
          let I = t.selectedKey != null ? (w = c.getKeyAbove) === null || w === void 0 ? void 0 : w.call(c, t.selectedKey) : (A = c.getFirstKey) === null || A === void 0 ? void 0 : A.call(c);
          I && t.setSelectedKey(I);
          break;
        }
        case "ArrowRight": {
          var k, N;
          _.preventDefault();
          let I = t.selectedKey != null ? (k = c.getKeyBelow) === null || k === void 0 ? void 0 : k.call(c, t.selectedKey) : (N = c.getFirstKey) === null || N === void 0 ? void 0 : N.call(c);
          I && t.setSelectedKey(I);
          break;
        }
      }
  }, { typeSelectProps: h } = mP({
    keyboardDelegate: c,
    selectionManager: t.selectionManager,
    onTypeSelect(_) {
      t.setSelectedKey(_);
    }
  }), { isInvalid: m, validationErrors: v, validationDetails: g } = t.displayValidation, { labelProps: b, fieldProps: E, descriptionProps: x, errorMessageProps: S } = q9({
    ...e,
    labelElementType: "span",
    isInvalid: m,
    errorMessage: e.errorMessage || v
  });
  h.onKeyDown = h.onKeyDownCapture, delete h.onKeyDownCapture, t.selectionManager.selectionMode === "multiple" && (h = {});
  let $ = xn(e, {
    labelable: !0
  }), P = nt(h, f, E), y = Zn();
  return Rb.set(t, {
    isDisabled: i,
    isRequired: o,
    name: a,
    form: s,
    validationBehavior: l
  }), {
    labelProps: {
      ...b,
      onClick: () => {
        if (!e.isDisabled) {
          var _;
          (_ = n.current) === null || _ === void 0 || _.focus(), cd("keyboard");
        }
      }
    },
    triggerProps: nt($, {
      ...P,
      isDisabled: i,
      onKeyDown: Ma(P.onKeyDown, p, e.onKeyDown),
      onKeyUp: e.onKeyUp,
      "aria-labelledby": [
        y,
        P["aria-labelledby"],
        P["aria-label"] && !P["aria-labelledby"] ? P.id : null
      ].filter(Boolean).join(" "),
      onFocus(_) {
        t.isFocused || (e.onFocus && e.onFocus(_), e.onFocusChange && e.onFocusChange(!0), t.setFocused(!0));
      },
      onBlur(_) {
        t.isOpen || (e.onBlur && e.onBlur(_), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      }
    }),
    valueProps: {
      id: y
    },
    menuProps: {
      ...d,
      autoFocus: t.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (_) => {
        We(_.currentTarget, _.relatedTarget) || (e.onBlur && e.onBlur(_), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      },
      "aria-labelledby": [
        E["aria-labelledby"],
        P["aria-label"] && !E["aria-labelledby"] ? P.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: x,
    errorMessageProps: S,
    isInvalid: m,
    validationErrors: v,
    validationDetails: g,
    hiddenSelectProps: {
      isDisabled: i,
      name: a,
      label: e.label,
      state: t,
      triggerRef: n,
      form: s
    }
  };
}
function F7(e, t, n) {
  let r = Rb.get(t) || {}, { autoComplete: i, name: o = r.name, form: a = r.form, isDisabled: s = r.isDisabled } = e, { validationBehavior: l, isRequired: u } = r, { visuallyHiddenProps: c } = dP({
    style: {
      // Prevent page scrolling.
      position: "fixed",
      top: 0,
      left: 0
    }
  });
  fL(e.selectRef, t.defaultValue, t.setValue), d7({
    validationBehavior: l,
    focus: () => {
      var h;
      return (h = n.current) === null || h === void 0 ? void 0 : h.focus();
    }
  }, t, e.selectRef);
  let f = t.setValue, d = Ne((h) => {
    let m = Te(h);
    m.multiple ? f(Array.from(m.selectedOptions, (v) => v.value)) : f(h.currentTarget.value);
  }, [
    f
  ]);
  var p;
  return {
    containerProps: {
      ...c,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: i,
      disabled: s,
      multiple: t.selectionManager.selectionMode === "multiple",
      required: l === "native" && u,
      name: o,
      form: a,
      value: (p = t.value) !== null && p !== void 0 ? p : "",
      onChange: d,
      onInput: d
    }
  };
}
function z7(e) {
  let { state: t, triggerRef: n, label: r, name: i, form: o, isDisabled: a } = e, s = ve(null), l = ve(null), { containerProps: u, selectProps: c } = F7({
    ...e,
    selectRef: t.collection.size <= 300 ? s : l
  }, t, n), f = Array.isArray(t.value) ? t.value : [
    t.value
  ];
  if (t.collection.size <= 300) return /* @__PURE__ */ G.createElement("div", {
    ...u,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ G.createElement("label", null, r, /* @__PURE__ */ G.createElement("select", {
    ...c,
    ref: s
  }, /* @__PURE__ */ G.createElement("option", null), [
    ...t.collection.getKeys()
  ].map((d) => {
    let p = t.collection.getItem(d);
    if (p && p.type === "item") return /* @__PURE__ */ G.createElement("option", {
      key: p.key,
      value: p.key
    }, p.textValue);
  }), t.collection.size === 0 && i && f.map((d, p) => /* @__PURE__ */ G.createElement("option", {
    key: p,
    value: d ?? ""
  })))));
  if (i) {
    let d = Rb.get(t) || {}, { validationBehavior: p } = d;
    f.length === 0 && (f = [
      null
    ]);
    let h = f.map((m, v) => {
      let g = {
        type: "hidden",
        autoComplete: c.autoComplete,
        name: i,
        form: o,
        disabled: a,
        value: m ?? ""
      };
      return p === "native" ? /* @__PURE__ */ G.createElement("input", {
        key: v,
        ...g,
        ref: v === 0 ? l : null,
        style: {
          display: "none"
        },
        type: "text",
        required: v === 0 ? c.required : !1,
        onChange: () => {
        }
      }) : /* @__PURE__ */ G.createElement("input", {
        key: v,
        ...g,
        ref: v === 0 ? l : null
      });
    });
    return /* @__PURE__ */ G.createElement(G.Fragment, null, h);
  }
  return null;
}
const Nb = /* @__PURE__ */ Le({}), L7 = /* @__PURE__ */ Cb(function(t, n) {
  [t, n] = Ai(t, n, Nb);
  let { elementType: r = "label", ...i } = t, o = Fn[r];
  return /* @__PURE__ */ G.createElement(o, {
    className: "react-aria-Label",
    ...i,
    ref: n
  });
}), V7 = /* @__PURE__ */ Le(null), jb = /* @__PURE__ */ Le({}), Fb = /* @__PURE__ */ Cb(function(t, n) {
  [t, n] = Ai(t, n, jb);
  let r = t, { isPending: i } = r, { buttonProps: o, isPressed: a } = N7(t, n);
  o = K7(o, i);
  let { focusProps: s, isFocused: l, isFocusVisible: u } = yp(t), { hoverProps: c, isHovered: f } = sl({
    ...t,
    isDisabled: t.isDisabled || i
  }), d = {
    isHovered: f,
    isPressed: (r.isPressed || a) && !i,
    isFocused: l,
    isFocusVisible: u,
    isDisabled: t.isDisabled || !1,
    isPending: i ?? !1
  }, p = Rr({
    ...t,
    values: d,
    defaultClassName: "react-aria-Button"
  }), h = Zn(o.id), m = Zn(), v = o["aria-labelledby"];
  i && (v ? v = `${v} ${m}` : o["aria-label"] && (v = `${h} ${m}`));
  let g = ve(i);
  De(() => {
    let E = {
      "aria-labelledby": v || h
    };
    (!g.current && l && i || g.current && l && !i) && Gw(E, "assertive"), g.current = i;
  }, [
    i,
    l,
    v,
    h
  ]);
  let b = xn(t, {
    global: !0
  });
  return delete b.onClick, /* @__PURE__ */ G.createElement(Fn.button, {
    ...nt(b, p, o, s, c),
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    type: o.type === "submit" && i ? "button" : o.type,
    id: h,
    ref: n,
    "aria-labelledby": v,
    slot: t.slot || void 0,
    "aria-disabled": i ? "true" : o["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": d.isPressed || void 0,
    "data-hovered": f || void 0,
    "data-focused": l || void 0,
    "data-pending": i || void 0,
    "data-focus-visible": u || void 0
  }, /* @__PURE__ */ G.createElement(V7.Provider, {
    value: {
      id: m
    }
  }, p.children));
}), B7 = /Focus|Blur|Hover|Pointer(Enter|Leave|Over|Out)|Mouse(Enter|Leave|Over|Out)/;
function K7(e, t) {
  if (t) {
    for (const n in e) n.startsWith("on") && !B7.test(n) && (e[n] = void 0);
    e.href = void 0, e.target = void 0;
  }
  return e;
}
const bp = /* @__PURE__ */ Le({});
class Fx {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.prevKey) !== null && r !== void 0 ? r : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.nextKey) !== null && r !== void 0 ? r : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    let n = this.keyMap.get(t);
    return n?.childNodes || [];
  }
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t;
    let n = (s) => {
      if (this.keyMap.set(s.key, s), s.childNodes && s.type === "section") for (let l of s.childNodes) n(l);
    };
    for (let s of t) n(s);
    let r = null, i = 0, o = 0;
    for (let [s, l] of this.keyMap)
      r ? (r.nextKey = s, l.prevKey = r.key) : (this.firstKey = s, l.prevKey = void 0), l.type === "item" && (l.index = i++), (l.type === "section" || l.type === "item") && o++, r = l, r.nextKey = void 0;
    this._size = o;
    var a;
    this.lastKey = (a = r?.key) !== null && a !== void 0 ? a : null;
  }
}
class Hr extends Set {
  constructor(t, n, r) {
    super(t), t instanceof Hr ? (this.anchorKey = n ?? t.anchorKey, this.currentKey = r ?? t.currentKey) : (this.anchorKey = n ?? null, this.currentKey = r ?? null);
  }
}
function U7(e, t) {
  if (e.size !== t.size) return !1;
  for (let n of e)
    if (!t.has(n)) return !1;
  return !0;
}
function zb(e) {
  let { selectionMode: t = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: r, selectionBehavior: i = "toggle", disabledBehavior: o = "all" } = e, a = ve(!1), [, s] = je(!1), l = ve(null), u = ve(null), [, c] = je(null), f = Ee(() => zx(e.selectedKeys), [
    e.selectedKeys
  ]), d = Ee(() => zx(e.defaultSelectedKeys, new Hr()), [
    e.defaultSelectedKeys
  ]), [p, h] = fp(f, d, e.onSelectionChange), m = Ee(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), [v, g] = je(i);
  i === "replace" && v === "toggle" && typeof p == "object" && p.size === 0 && g("replace");
  let b = ve(i);
  return De(() => {
    i !== b.current && (g(i), b.current = i);
  }, [
    i
  ]), {
    selectionMode: t,
    disallowEmptySelection: n,
    selectionBehavior: v,
    setSelectionBehavior: g,
    get isFocused() {
      return a.current;
    },
    setFocused(E) {
      a.current = E, s(E);
    },
    get focusedKey() {
      return l.current;
    },
    get childFocusStrategy() {
      return u.current;
    },
    setFocusedKey(E, x = "first") {
      l.current = E, u.current = x, c(E);
    },
    selectedKeys: p,
    setSelectedKeys(E) {
      (r || !U7(E, p)) && h(E);
    },
    disabledKeys: m,
    disabledBehavior: o
  };
}
function zx(e, t) {
  return e ? e === "all" ? "all" : new Hr(e) : t;
}
class ac {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(t) {
    this.state.setSelectionBehavior(t);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(t) {
    this.state.setFocused(t);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(t, n) {
    (t == null || this.collection.getItem(t)) && this.state.setFocusedKey(t, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(t) {
    if (this.state.selectionMode === "none") return !1;
    let n = this.getKey(t);
    return n == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(n) : this.state.selectedKeys.has(n);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let t = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = t.every((r) => n.has(r)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let t = null;
    for (let r of this.state.selectedKeys) {
      let i = this.collection.getItem(r);
      (!t || i && tm(this.collection, i, t) < 0) && (t = i);
    }
    var n;
    return (n = t?.key) !== null && n !== void 0 ? n : null;
  }
  get lastSelectedKey() {
    let t = null;
    for (let r of this.state.selectedKeys) {
      let i = this.collection.getItem(r);
      (!t || i && tm(this.collection, i, t) > 0) && (t = i);
    }
    var n;
    return (n = t?.key) !== null && n !== void 0 ? n : null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r;
    if (this.state.selectedKeys === "all") r = new Hr([
      n
    ], n, n);
    else {
      let a = this.state.selectedKeys;
      var i;
      let s = (i = a.anchorKey) !== null && i !== void 0 ? i : n;
      r = new Hr(a, s, n);
      var o;
      for (let l of this.getKeyRange(s, (o = a.currentKey) !== null && o !== void 0 ? o : n)) r.delete(l);
      for (let l of this.getKeyRange(n, s)) this.canSelectItem(l) && r.add(l);
    }
    this.state.setSelectedKeys(r);
  }
  getKeyRange(t, n) {
    let r = this.collection.getItem(t), i = this.collection.getItem(n);
    return r && i ? tm(this.collection, r, i) <= 0 ? this.getKeyRangeInternal(t, n) : this.getKeyRangeInternal(n, t) : [];
  }
  getKeyRangeInternal(t, n) {
    var r;
    if (!((r = this.layoutDelegate) === null || r === void 0) && r.getKeyRange) return this.layoutDelegate.getKeyRange(t, n);
    let i = [], o = t;
    for (; o != null; ) {
      let a = this.collection.getItem(o);
      if (a && (a.type === "item" || a.type === "cell" && this.allowsCellSelection) && i.push(o), o === n) return i;
      o = this.collection.getKeyAfter(o);
    }
    return [];
  }
  getKey(t) {
    let n = this.collection.getItem(t);
    if (!n || n.type === "cell" && this.allowsCellSelection) return t;
    for (; n && n.type !== "item" && n.parentKey != null; ) n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(t)) {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r = new Hr(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    r.has(n) ? r.delete(n) : this.canSelectItem(n) && (r.add(n), r.anchorKey = n, r.currentKey = n), !(this.disallowEmptySelection && r.size === 0) && this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(t) {
    if (this.selectionMode === "none") return;
    let n = this.getKey(t);
    if (n == null) return;
    let r = this.canSelectItem(n) ? new Hr([
      n
    ], n, n) : new Hr();
    this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(t) {
    if (this.selectionMode === "none") return;
    let n = new Hr();
    for (let r of t) {
      let i = this.getKey(r);
      if (i != null && (n.add(i), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let t = [], n = (r) => {
      for (; r != null; ) {
        if (this.canSelectItem(r)) {
          var i;
          let a = this.collection.getItem(r);
          a?.type === "item" && t.push(r);
          var o;
          a?.hasChildNodes && (this.allowsCellSelection || a.type !== "item") && n((o = (i = e7(bP(a, this.collection))) === null || i === void 0 ? void 0 : i.key) !== null && o !== void 0 ? o : null);
        }
        r = this.collection.getKeyAfter(r);
      }
    };
    return n(this.collection.getFirstKey()), t;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new Hr());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(t, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(t) && !this.disallowEmptySelection ? this.toggleSelection(t) : this.replaceSelection(t) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(t) : this.replaceSelection(t));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(t) {
    if (t === this.state.selectedKeys) return !0;
    let n = this.selectedKeys;
    if (t.size !== n.size) return !1;
    for (let r of t)
      if (!n.has(r)) return !1;
    for (let r of n)
      if (!t.has(r)) return !1;
    return !0;
  }
  canSelectItem(t) {
    var n;
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(t)) return !1;
    let r = this.collection.getItem(t);
    return !(!r || !(r == null || (n = r.props) === null || n === void 0) && n.isDisabled || r.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(t) {
    var n, r;
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(t) || !!(!((r = this.collection.getItem(t)) === null || r === void 0 || (n = r.props) === null || n === void 0) && n.isDisabled));
  }
  isLink(t) {
    var n, r;
    return !!(!((r = this.collection.getItem(t)) === null || r === void 0 || (n = r.props) === null || n === void 0) && n.href);
  }
  getItemProps(t) {
    var n;
    return (n = this.collection.getItem(t)) === null || n === void 0 ? void 0 : n.props;
  }
  withCollection(t) {
    return new ac(t, this.state, {
      allowsCellSelection: this.allowsCellSelection,
      layoutDelegate: this.layoutDelegate || void 0
    });
  }
  constructor(t, n, r) {
    this.collection = t, this.state = n;
    var i;
    this.allowsCellSelection = (i = r?.allowsCellSelection) !== null && i !== void 0 ? i : !1, this._isSelectAll = null, this.layoutDelegate = r?.layoutDelegate || null;
  }
}
function mD(e) {
  let { filter: t, layoutDelegate: n } = e, r = zb(e), i = Ee(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), o = Ne((u) => t ? new Fx(t(u)) : new Fx(u), [
    t
  ]), a = Ee(() => ({
    suppressTextValueWarning: e.suppressTextValueWarning
  }), [
    e.suppressTextValueWarning
  ]), s = yP(e, o, a), l = Ee(() => new ac(s, r, {
    layoutDelegate: n
  }), [
    s,
    r,
    n
  ]);
  return vD(s, l), {
    collection: s,
    disabledKeys: i,
    selectionManager: l
  };
}
function q7(e, t) {
  let n = Ee(() => t ? e.collection.filter(t) : e.collection, [
    e.collection,
    t
  ]), r = e.selectionManager.withCollection(n);
  return vD(n, r), {
    collection: n,
    selectionManager: r,
    disabledKeys: e.disabledKeys
  };
}
function vD(e, t) {
  const n = ve(null);
  De(() => {
    if (t.focusedKey != null && !e.getItem(t.focusedKey) && n.current) {
      const c = n.current.getItem(t.focusedKey), f = [
        ...n.current.getKeys()
      ].map((g) => {
        const b = n.current.getItem(g);
        return b?.type === "item" ? b : null;
      }).filter((g) => g !== null), d = [
        ...e.getKeys()
      ].map((g) => {
        const b = e.getItem(g);
        return b?.type === "item" ? b : null;
      }).filter((g) => g !== null);
      var r, i;
      const p = ((r = f?.length) !== null && r !== void 0 ? r : 0) - ((i = d?.length) !== null && i !== void 0 ? i : 0);
      var o, a, s;
      let h = Math.min(p > 1 ? Math.max(((o = c?.index) !== null && o !== void 0 ? o : 0) - p + 1, 0) : (a = c?.index) !== null && a !== void 0 ? a : 0, ((s = d?.length) !== null && s !== void 0 ? s : 0) - 1), m = null, v = !1;
      for (; h >= 0; ) {
        if (!t.isDisabled(d[h].key)) {
          m = d[h];
          break;
        }
        if (h < d.length - 1 && !v) h++;
        else {
          v = !0;
          var l, u;
          h > ((l = c?.index) !== null && l !== void 0 ? l : 0) && (h = (u = c?.index) !== null && u !== void 0 ? u : 0), h--;
        }
      }
      t.setFocusedKey(m ? m.key : null);
    }
    n.current = e;
  }, [
    e,
    t
  ]);
}
function Lb(e) {
  let [t, n] = fp(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = Ne(() => {
    n(!0);
  }, [
    n
  ]), i = Ne(() => {
    n(!1);
  }, [
    n
  ]), o = Ne(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: i,
    toggle: o
  };
}
function gD(e) {
  let t = Lb(e), [n, r] = je(null), [i, o] = je([]), a = () => {
    o([]), t.close();
  };
  return {
    focusStrategy: n,
    ...t,
    open(u = null) {
      r(u), t.open();
    },
    toggle(u = null) {
      r(u), t.toggle();
    },
    close() {
      a();
    },
    expandedKeysStack: i,
    openSubmenu: (u, c) => {
      o((f) => c > f.length ? f : [
        ...f.slice(0, c),
        u
      ]);
    },
    closeSubmenu: (u, c) => {
      o((f) => f[c] === u ? f.slice(0, c) : f);
    }
  };
}
function H7(e) {
  let { selectionMode: t = "single" } = e, n = Lb(e), [r, i] = je(null), o = Ee(() => {
    var x;
    return e.defaultValue !== void 0 ? e.defaultValue : t === "single" ? (x = e.defaultSelectedKey) !== null && x !== void 0 ? x : null : [];
  }, [
    e.defaultValue,
    e.defaultSelectedKey,
    t
  ]), a = Ee(() => e.value !== void 0 ? e.value : t === "single" ? e.selectedKey : void 0, [
    e.value,
    e.selectedKey,
    t
  ]), [s, l] = fp(a, o, e.onChange), u = t === "single" && Array.isArray(s) ? s[0] : s, c = (x) => {
    if (t === "single") {
      var S, $;
      let P = Array.isArray(x) ? ($ = x[0]) !== null && $ !== void 0 ? $ : null : x;
      l(P), P !== u && ((S = e.onSelectionChange) === null || S === void 0 || S.call(e, P));
    } else {
      let P = [];
      Array.isArray(x) ? P = x : x != null && (P = [
        x
      ]), l(P);
    }
  }, f = mD({
    ...e,
    selectionMode: t,
    disallowEmptySelection: t === "single",
    allowDuplicateSelectionEvents: !0,
    selectedKeys: Ee(() => W7(u), [
      u
    ]),
    onSelectionChange: (x) => {
      if (x !== "all") {
        if (t === "single") {
          var S;
          let $ = (S = x.values().next().value) !== null && S !== void 0 ? S : null;
          c($), n.close();
        } else c([
          ...x
        ]);
        h.commitValidation();
      }
    }
  }), d = f.selectionManager.firstSelectedKey, p = Ee(() => [
    ...f.selectionManager.selectedKeys
  ].map((x) => f.collection.getItem(x)).filter((x) => x != null), [
    f.selectionManager.selectedKeys,
    f.collection
  ]), h = o7({
    ...e,
    value: Array.isArray(u) && u.length === 0 ? null : u
  }), [m, v] = je(!1), [g] = je(u);
  var b, E;
  return {
    ...h,
    ...f,
    ...n,
    value: u,
    defaultValue: o ?? g,
    setValue: c,
    selectedKey: d,
    setSelectedKey: c,
    selectedItem: (b = p[0]) !== null && b !== void 0 ? b : null,
    selectedItems: p,
    defaultSelectedKey: (E = e.defaultSelectedKey) !== null && E !== void 0 ? E : e.selectionMode === "single" ? g : null,
    focusStrategy: r,
    open(x = null) {
      (f.collection.size !== 0 || e.allowsEmptyCollection) && (i(x), n.open());
    },
    toggle(x = null) {
      (f.collection.size !== 0 || e.allowsEmptyCollection) && (i(x), n.toggle());
    },
    isFocused: m,
    setFocused: v
  };
}
function W7(e) {
  if (e !== void 0)
    return e === null ? [] : Array.isArray(e) ? e : [
      e
    ];
}
class Z7 {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.prevKey) !== null && r !== void 0 ? r : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.nextKey) !== null && r !== void 0 ? r : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  constructor(t, { expandedKeys: n } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t, n = n || /* @__PURE__ */ new Set();
    let r = (s) => {
      if (this.keyMap.set(s.key, s), s.childNodes && (s.type === "section" || n.has(s.key))) for (let l of s.childNodes) r(l);
    };
    for (let s of t) r(s);
    let i = null, o = 0;
    for (let [s, l] of this.keyMap)
      i ? (i.nextKey = s, l.prevKey = i.key) : (this.firstKey = s, l.prevKey = void 0), l.type === "item" && (l.index = o++), i = l, i.nextKey = void 0;
    var a;
    this.lastKey = (a = i?.key) !== null && a !== void 0 ? a : null;
  }
}
function G7(e) {
  let { onExpandedChange: t } = e, [n, r] = fp(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), t), i = zb(e), o = Ee(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), a = yP(e, Ne((l) => new Z7(l, {
    expandedKeys: n
  }), [
    n
  ]), null);
  return De(() => {
    i.focusedKey != null && !a.getItem(i.focusedKey) && i.setFocusedKey(null);
  }, [
    a,
    i.focusedKey
  ]), {
    collection: a,
    expandedKeys: n,
    disabledKeys: o,
    toggleKey: (l) => {
      r(Y7(n, l));
    },
    setExpandedKeys: r,
    selectionManager: new ac(a, i)
  };
}
function Y7(e, t) {
  let n = new Set(e);
  return n.has(t) ? n.delete(t) : n.add(t), n;
}
const Q7 = /* @__PURE__ */ Le(null), J7 = /* @__PURE__ */ Le(null), X7 = /* @__PURE__ */ Le({});
let eV = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...i } = e;
  return i;
};
const tV = /* @__PURE__ */ Cb(function(t, n) {
  [t, n] = Ai(t, n, X7);
  let { hoverProps: r, isHovered: i } = sl({
    ...t,
    isDisabled: t.disabled
  }), { isFocused: o, isFocusVisible: a, focusProps: s } = yp({
    isTextInput: !0,
    autoFocus: t.autoFocus
  }), l = !!t["aria-invalid"] && t["aria-invalid"] !== "false", u = Rr({
    ...t,
    values: {
      isHovered: i,
      isFocused: o,
      isFocusVisible: a,
      isDisabled: t.disabled || !1,
      isInvalid: l
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ G.createElement(Fn.input, {
    ...nt(eV(t), s, r),
    ...u,
    ref: n,
    "data-focused": o || void 0,
    "data-disabled": t.disabled || void 0,
    "data-hovered": i || void 0,
    "data-focus-visible": a || void 0,
    "data-invalid": l || void 0
  });
}), _p = /* @__PURE__ */ Le({}), yD = /* @__PURE__ */ Le(null), nV = /* @__PURE__ */ Jt(function(t, n) {
  let { render: r } = Ce(yD);
  return /* @__PURE__ */ G.createElement(G.Fragment, null, r(t, n));
});
function bD(e, t) {
  var n;
  let r = e?.renderDropIndicator, i = e == null || (n = e.isVirtualDragging) === null || n === void 0 ? void 0 : n.call(e), o = Ne((a) => {
    if (i || t?.isDropTarget(a)) return r ? r(a) : /* @__PURE__ */ G.createElement(nV, {
      target: a
    });
  }, [
    t?.target,
    i,
    r
  ]);
  return e?.useDropIndicator ? o : void 0;
}
function rV(e, t, n) {
  var r, i;
  let o = e.focusedKey, a = null;
  if (!(t == null || (r = t.isVirtualDragging) === null || r === void 0) && r.call(t) && (n == null || (i = n.target) === null || i === void 0 ? void 0 : i.type) === "item" && (a = n.target.key, n.target.dropPosition === "after")) {
    let f = n.collection.getKeyAfter(a), d = null;
    if (f != null) {
      var s, l;
      let p = (l = (s = n.collection.getItem(a)) === null || s === void 0 ? void 0 : s.level) !== null && l !== void 0 ? l : 0;
      for (; f; ) {
        let h = n.collection.getItem(f);
        if (!h) break;
        if (h.type !== "item") {
          f = n.collection.getKeyAfter(f);
          continue;
        }
        var u;
        if (((u = h.level) !== null && u !== void 0 ? u : 0) <= p) break;
        d = f, f = n.collection.getKeyAfter(f);
      }
    }
    var c;
    a = (c = f ?? d) !== null && c !== void 0 ? c : a;
  }
  return Ee(() => new Set([
    o,
    a
  ].filter((f) => f != null)), [
    o,
    a
  ]);
}
const _D = /* @__PURE__ */ Le({}), iV = /* @__PURE__ */ Le(null);
function wD(e) {
  let t = ve({});
  return /* @__PURE__ */ G.createElement(iV.Provider, {
    value: t
  }, e.children);
}
const xD = /* @__PURE__ */ Le({
  isSelected: !1
}), ED = /* @__PURE__ */ Le({});
class oV extends ll {
  filter(t, n) {
    let r = n.getItem(this.prevKey);
    if (r && r.type !== "separator") {
      let i = this.clone();
      return n.addDescendants(i, t), i;
    }
    return null;
  }
}
oV.type = "separator";
const Vb = /* @__PURE__ */ Le(null), cl = /* @__PURE__ */ Le(null), aV = /* @__PURE__ */ Jt(function(t, n) {
  [t, n] = Ai(t, n, Vb);
  let r = Ce(cl);
  return r ? /* @__PURE__ */ G.createElement(SD, {
    state: r,
    props: t,
    listBoxRef: n
  }) : /* @__PURE__ */ G.createElement(Ib, {
    content: /* @__PURE__ */ G.createElement(pD, t)
  }, (i) => /* @__PURE__ */ G.createElement(sV, {
    props: t,
    listBoxRef: n,
    collection: i
  }));
});
function sV({ props: e, listBoxRef: t, collection: n }) {
  e = {
    ...e,
    collection: n,
    children: null,
    items: null
  };
  let { layoutDelegate: r } = Ce(ul), i = mD({
    ...e,
    layoutDelegate: r
  });
  return /* @__PURE__ */ G.createElement(SD, {
    state: i,
    props: e,
    listBoxRef: t
  });
}
function SD({ state: e, props: t, listBoxRef: n }) {
  [t, n] = Ai(t, n, qv);
  let { dragAndDropHooks: r, layout: i = "stack", orientation: o = "vertical", filter: a } = t, s = q7(e, a), { collection: l, selectionManager: u } = s, c = !!r?.useDraggableCollectionState, f = !!r?.useDroppableCollectionState, { direction: d } = al(), { disabledBehavior: p, disabledKeys: h } = u, m = xb({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: v, layoutDelegate: g, dropTargetDelegate: b, CollectionRoot: E } = Ce(ul), x = Ee(() => t.keyboardDelegate || new Db({
    collection: l,
    collator: m,
    ref: n,
    disabledKeys: h,
    disabledBehavior: p,
    layout: i,
    orientation: o,
    direction: d,
    layoutDelegate: g
  }), [
    l,
    m,
    n,
    p,
    h,
    o,
    d,
    t.keyboardDelegate,
    i,
    g
  ]), { listBoxProps: S } = Q9({
    ...t,
    shouldSelectOnPressUp: c || t.shouldSelectOnPressUp,
    keyboardDelegate: x,
    isVirtualized: v
  }, s, n), $ = ve(c), P = ve(f);
  De(() => {
    process.env.NODE_ENV !== "production" && ($.current !== c && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), P.current !== f && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."));
  }, [
    c,
    f
  ]);
  let y, _, w, A = !1, k = null, N = ve(null);
  if (c && r) {
    y = r.useDraggableCollectionState({
      collection: l,
      selectionManager: u,
      preview: r.renderDragPreview ? N : void 0
    }), r.useDraggableCollection({}, y, n);
    let M = r.DragPreview;
    k = r.renderDragPreview ? /* @__PURE__ */ G.createElement(M, {
      ref: N
    }, r.renderDragPreview) : null;
  }
  if (f && r) {
    _ = r.useDroppableCollectionState({
      collection: l,
      selectionManager: u
    });
    let M = r.dropTargetDelegate || b || new r.ListDropTargetDelegate(l, n, {
      orientation: o,
      layout: i,
      direction: d
    });
    w = r.useDroppableCollection({
      keyboardDelegate: x,
      dropTargetDelegate: M
    }, _, n), A = _.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: I, isFocused: B, isFocusVisible: q } = yp(), ee = s.collection.size === 0, re = {
    isDropTarget: A,
    isEmpty: ee,
    isFocused: B,
    isFocusVisible: q,
    layout: t.layout || "stack",
    state: s
  }, Z = Rr({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-ListBox",
    values: re
  }), T = null;
  ee && t.renderEmptyState && (T = /* @__PURE__ */ G.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, t.renderEmptyState(re)));
  let F = xn(t, {
    global: !0
  });
  return /* @__PURE__ */ G.createElement(Ob, null, /* @__PURE__ */ G.createElement(Fn.div, {
    ...nt(F, Z, S, I, w?.collectionProps),
    ref: n,
    slot: t.slot || void 0,
    onScroll: t.onScroll,
    "data-drop-target": A || void 0,
    "data-empty": ee || void 0,
    "data-focused": B || void 0,
    "data-focus-visible": q || void 0,
    "data-layout": t.layout || "stack",
    "data-orientation": t.orientation || "vertical"
  }, /* @__PURE__ */ G.createElement(Ra, {
    values: [
      [
        Vb,
        t
      ],
      [
        cl,
        s
      ],
      [
        _p,
        {
          dragAndDropHooks: r,
          dragState: y,
          dropState: _
        }
      ],
      [
        ED,
        {
          elementType: "div"
        }
      ],
      [
        yD,
        {
          render: cV
        }
      ],
      [
        hD,
        {
          name: "ListBoxSection",
          render: lV
        }
      ]
    ]
  }, /* @__PURE__ */ G.createElement(wD, null, /* @__PURE__ */ G.createElement(E, {
    collection: l,
    scrollRef: n,
    persistedKeys: rV(u, r, _),
    renderDropIndicator: bD(r, _)
  }))), T, k));
}
function lV(e, t, n, r = "react-aria-ListBoxSection") {
  let i = Ce(cl), { dragAndDropHooks: o, dropState: a } = Ce(_p), { CollectionBranch: s } = Ce(ul), [l, u] = wb();
  var c;
  let { headingProps: f, groupProps: d } = r7({
    heading: u,
    "aria-label": (c = e["aria-label"]) !== null && c !== void 0 ? c : void 0
  }), p = Rr({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    values: void 0
  }), h = xn(e, {
    global: !0
  });
  return delete h.id, /* @__PURE__ */ G.createElement(Fn.section, {
    ...nt(h, p, d),
    ref: t
  }, /* @__PURE__ */ G.createElement(_D.Provider, {
    value: {
      ...f,
      ref: l
    }
  }, /* @__PURE__ */ G.createElement(s, {
    collection: i.collection,
    parent: n,
    renderDropIndicator: bD(o, a)
  })));
}
const uV = /* @__PURE__ */ Mb(Ab, function(t, n, r) {
  let i = ol(n), o = Ce(cl), { dragAndDropHooks: a, dragState: s, dropState: l } = Ce(_p), { optionProps: u, labelProps: c, descriptionProps: f, ...d } = n7({
    key: r.key,
    "aria-label": t?.["aria-label"]
  }, o, i), { hoverProps: p, isHovered: h } = sl({
    isDisabled: !d.allowsSelection && !d.hasAction,
    onHoverStart: r.props.onHoverStart,
    onHoverChange: r.props.onHoverChange,
    onHoverEnd: r.props.onHoverEnd
  }), { keyboardProps: m } = Tb(t), { focusProps: v } = $b(t), g = null;
  s && a && (g = a.useDraggableItem({
    key: r.key,
    hasAction: d.hasAction
  }, s));
  let b = null;
  l && a && (b = a.useDroppableItem({
    target: {
      type: "item",
      key: r.key,
      dropPosition: "on"
    }
  }, l, i));
  let E = s && s.isDragging(r.key), x = Rr({
    ...t,
    id: void 0,
    children: t.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...d,
      isHovered: h,
      selectionMode: o.selectionManager.selectionMode,
      selectionBehavior: o.selectionManager.selectionBehavior,
      allowsDragging: !!s,
      isDragging: E,
      isDropTarget: b?.isDropTarget
    }
  });
  De(() => {
    !r.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    r.textValue
  ]);
  let S = t.href ? Fn.a : Fn.div, $ = xn(t, {
    global: !0
  });
  return delete $.id, delete $.onClick, t.href && u.tabIndex == null && (u.tabIndex = -1), /* @__PURE__ */ G.createElement(S, {
    ...nt($, x, u, p, m, v, g?.dragProps, b?.dropProps),
    ref: i,
    "data-allows-dragging": !!s || void 0,
    "data-selected": d.isSelected || void 0,
    "data-disabled": d.isDisabled || void 0,
    "data-hovered": h || void 0,
    "data-focused": d.isFocused || void 0,
    "data-focus-visible": d.isFocusVisible || void 0,
    "data-pressed": d.isPressed || void 0,
    "data-dragging": E || void 0,
    "data-drop-target": b?.isDropTarget || void 0,
    "data-selection-mode": o.selectionManager.selectionMode === "none" ? void 0 : o.selectionManager.selectionMode
  }, /* @__PURE__ */ G.createElement(Ra, {
    values: [
      [
        bp,
        {
          slots: {
            [_b]: c,
            label: c,
            description: f
          }
        }
      ],
      [
        xD,
        {
          isSelected: d.isSelected
        }
      ]
    ]
  }, x.children));
});
function cV(e, t) {
  t = ol(t);
  let { dragAndDropHooks: n, dropState: r } = Ce(_p), { dropIndicatorProps: i, isHidden: o, isDropTarget: a } = n.useDropIndicator(e, r, t);
  return o ? null : /* @__PURE__ */ G.createElement(dV, {
    ...e,
    dropIndicatorProps: i,
    isDropTarget: a,
    ref: t
  });
}
function fV(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, ...i } = e, o = Rr({
    ...i,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ G.createElement(Fn.div, {
    ...n,
    ...o,
    role: "option",
    ref: t,
    "data-drop-target": r || void 0
  });
}
const dV = /* @__PURE__ */ Jt(fV);
Mb(sD, function(t, n, r) {
  let i = Ce(cl), { isLoading: o, onLoadMore: a, scrollOffset: s, ...l } = t, u = ve(null), c = Ee(() => ({
    onLoadMore: a,
    collection: i?.collection,
    sentinelRef: u,
    scrollOffset: s
  }), [
    a,
    s,
    i?.collection
  ]);
  dL(c, u);
  let f = Rr({
    ...l,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-ListBoxLoadingIndicator",
    values: void 0
  }), d = {
    // For Android talkback
    tabIndex: -1
  };
  return /* @__PURE__ */ G.createElement(G.Fragment, null, /* @__PURE__ */ G.createElement("div", {
    style: {
      position: "relative",
      width: 0,
      height: 0
    },
    inert: pL(!0)
  }, /* @__PURE__ */ G.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: u,
    style: {
      position: "absolute",
      height: 1,
      width: 1
    }
  })), o && f.children && /* @__PURE__ */ G.createElement(Fn.div, {
    ...nt(xn(t, {
      global: !0
    }), d),
    ...f,
    // aria-selected isn't needed here since this option is not selectable.
    role: "option",
    ref: n
  }, f.children));
});
const pV = /* @__PURE__ */ Le({
  placement: "bottom"
}), Bb = /* @__PURE__ */ Le(null), Lx = /* @__PURE__ */ Le(null), $D = /* @__PURE__ */ Jt(function(t, n) {
  [t, n] = Ai(t, n, Bb);
  let r = Ce(Ub), i = Lb(t), o = t.isOpen != null || t.defaultOpen != null || !r ? i : r, a = gL(n, o.isOpen) || t.isExiting || !1, s = w7(), { direction: l } = al();
  if (s) {
    let u = t.children;
    return typeof u == "function" && (u = u({
      trigger: t.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ G.createElement(G.Fragment, null, u);
  }
  return o && !o.isOpen && !a ? null : /* @__PURE__ */ G.createElement(hV, {
    ...t,
    triggerRef: t.triggerRef,
    state: o,
    popoverRef: n,
    isExiting: a,
    dir: l
  });
});
function hV({ state: e, isExiting: t, UNSTABLE_portalContainer: n, clearContexts: r, ...i }) {
  let o = ve(null), a = ve(null), s = Ce(Lx), l = s && i.trigger === "SubmenuTrigger";
  var u;
  let { popoverProps: c, underlayProps: f, arrowProps: d, placement: p, triggerAnchorPoint: h } = V9({
    ...i,
    offset: (u = i.offset) !== null && u !== void 0 ? u : 8,
    arrowRef: o,
    // If this is a submenu/subdialog, use the root popover's container
    // to detect outside interaction and add aria-hidden.
    groupRef: l ? s : a
  }, e), m = i.popoverRef, v = vL(m, !!p) || i.isEntering || !1, g = Rr({
    ...i,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: i.trigger || null,
      placement: p,
      isEntering: v,
      isExiting: t
    }
  }), b = !i.isNonModal || i.trigger === "SubmenuTrigger", [E, x] = je(!1);
  ot(() => {
    m.current && x(b && !m.current.querySelector("[role=dialog]"));
  }, [
    m,
    b
  ]), De(() => {
    E && (i.trigger !== "SubmenuTrigger" || Pu() !== "pointer") && m.current && !od(m.current) && Ns(m.current);
  }, [
    E,
    m,
    i.trigger
  ]);
  let S = Ee(() => {
    let _ = g.children;
    if (r) for (let w of r) _ = /* @__PURE__ */ G.createElement(w.Provider, {
      value: null
    }, _);
    return _;
  }, [
    g.children,
    r
  ]), $ = {
    ...c.style,
    "--trigger-anchor-point": h ? `${h.x}px ${h.y}px` : void 0,
    ...g.style
  }, P = /* @__PURE__ */ G.createElement(Fn.div, {
    ...nt(xn(i, {
      global: !0
    }), c),
    ...g,
    role: E ? "dialog" : void 0,
    tabIndex: E ? -1 : void 0,
    "aria-label": i["aria-label"],
    "aria-labelledby": i["aria-labelledby"],
    ref: m,
    slot: i.slot || void 0,
    style: $,
    dir: i.dir,
    "data-trigger": i.trigger,
    "data-placement": p,
    "data-entering": v || void 0,
    "data-exiting": t || void 0
  }, !i.isNonModal && /* @__PURE__ */ G.createElement(Ex, {
    onDismiss: e.close
  }), /* @__PURE__ */ G.createElement(pV.Provider, {
    value: {
      ...d,
      placement: p,
      ref: o
    }
  }, S), /* @__PURE__ */ G.createElement(Ex, {
    onDismiss: e.close
  }));
  if (!l) return /* @__PURE__ */ G.createElement(Sx, {
    ...i,
    shouldContainFocus: E,
    isExiting: t,
    portalContainer: n
  }, !i.isNonModal && e.isOpen && /* @__PURE__ */ G.createElement("div", {
    "data-testid": "underlay",
    ...f,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ G.createElement("div", {
    ref: a,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ G.createElement(Lx.Provider, {
    value: a
  }, P)));
  var y;
  return /* @__PURE__ */ G.createElement(Sx, {
    ...i,
    shouldContainFocus: E,
    isExiting: t,
    portalContainer: (y = n ?? s?.current) !== null && y !== void 0 ? y : void 0
  }, P);
}
const mV = /* @__PURE__ */ Le({}), TD = /* @__PURE__ */ Le(null), Kb = /* @__PURE__ */ Le(null), cg = /* @__PURE__ */ Le(null), hd = /* @__PURE__ */ Le(null);
function vV(e) {
  let t = gD(e), n = ve(null), { menuTriggerProps: r, menuProps: i } = iD({
    ...e,
    type: "menu"
  }, t, n), [o, a] = je(null), s = Ne(() => {
    n.current && a(n.current.offsetWidth + "px");
  }, [
    n
  ]);
  ad({
    ref: n,
    onResize: s
  });
  let l = ve(null);
  return /* @__PURE__ */ G.createElement(Ra, {
    values: [
      [
        TD,
        {
          ...i,
          ref: l
        }
      ],
      [
        Ub,
        t
      ],
      [
        cg,
        t
      ],
      [
        Bb,
        {
          trigger: "MenuTrigger",
          triggerRef: n,
          scrollRef: l,
          placement: "bottom start",
          style: {
            "--trigger-width": o
          },
          "aria-labelledby": i["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ G.createElement($k, {
    ...r,
    ref: n,
    isPressed: t.isOpen
  }, e.children));
}
const gV = /* @__PURE__ */ Le(null);
class yV extends ll {
  filter(t, n, r) {
    let i = t.getItem(this.firstChildKey);
    if (i && r(i.textValue, this)) {
      let o = this.clone();
      return n.addDescendants(o, t), o;
    }
    return null;
  }
}
yV.type = "submenutrigger";
const bV = /* @__PURE__ */ Jt(function(t, n) {
  return [t, n] = Ai(t, n, TD), /* @__PURE__ */ G.createElement(Ib, {
    content: /* @__PURE__ */ G.createElement(pD, t)
  }, (r) => /* @__PURE__ */ G.createElement(_V, {
    props: t,
    collection: r,
    menuRef: n
  }));
});
function _V({ props: e, collection: t, menuRef: n }) {
  [e, n] = Ai(e, n, qv);
  let { filter: r, ...i } = e, o = Ee(() => r ? t.filter(r) : t, [
    t,
    r
  ]), a = G7({
    ...e,
    collection: o,
    children: void 0
  }), s = Ce(cg), { isVirtualized: l, CollectionRoot: u } = Ce(ul), { menuProps: c } = u7({
    ...e,
    isVirtualized: l,
    onClose: e.onClose || s?.close
  }, a, n), f = Rr({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-Menu",
    values: {
      isEmpty: a.collection.size === 0
    }
  }), d = null;
  a.collection.size === 0 && e.renderEmptyState && (d = /* @__PURE__ */ G.createElement("div", {
    role: "menuitem",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState()));
  let p = xn(e, {
    global: !0
  });
  return /* @__PURE__ */ G.createElement(Ob, null, /* @__PURE__ */ G.createElement(Fn.div, {
    ...nt(p, f, c),
    ref: n,
    slot: e.slot || void 0,
    "data-empty": a.collection.size === 0 || void 0,
    onScroll: e.onScroll
  }, /* @__PURE__ */ G.createElement(Ra, {
    values: [
      [
        Kb,
        a
      ],
      [
        ED,
        {
          elementType: "div"
        }
      ],
      [
        hD,
        {
          name: "MenuSection",
          render: xV
        }
      ],
      [
        gV,
        {
          parentMenuRef: n,
          shouldUseVirtualFocus: i?.shouldUseVirtualFocus
        }
      ],
      [
        Au,
        {
          shouldCloseOnSelect: e.shouldCloseOnSelect
        }
      ],
      [
        qv,
        null
      ],
      [
        $z,
        null
      ],
      [
        hd,
        a.selectionManager
      ],
      /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */
      /* We assume the context can never change between defined and undefined. */
      /* eslint-disable-next-line react-hooks/rules-of-hooks */
      [
        cg,
        s ?? gD({})
      ]
    ]
  }, /* @__PURE__ */ G.createElement(wD, null, /* @__PURE__ */ G.createElement(u, {
    collection: a.collection,
    persistedKeys: R7(a.selectionManager.focusedKey),
    scrollRef: n
  }))), d));
}
class wV extends ac {
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(t, n) {
    return this.parent.setFocusedKey(t, n);
  }
  setFocused(t) {
    this.parent.setFocused(t);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
  constructor(t, n) {
    super(t.collection, n), this.parent = t;
  }
}
function xV(e, t, n, r = "react-aria-MenuSection") {
  var i, o, a;
  let s = Ce(Kb), { CollectionBranch: l } = Ce(ul), [u, c] = wb();
  var f;
  let { headingProps: d, groupProps: p } = f7({
    heading: c,
    "aria-label": (f = n.props["aria-label"]) !== null && f !== void 0 ? f : void 0
  }), h = Rr({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    className: (i = n.props) === null || i === void 0 ? void 0 : i.className,
    style: (o = n.props) === null || o === void 0 ? void 0 : o.style,
    values: void 0
  }), m = Ce(hd), v = zb(e), g = e.selectionMode != null ? new wV(m, v) : m, b = (a = dp(Au)) === null || a === void 0 ? void 0 : a.shouldCloseOnSelect, E = xn(e, {
    global: !0
  });
  delete E.id;
  var x;
  return /* @__PURE__ */ G.createElement(Fn.section, {
    ...nt(E, h, p),
    ref: t
  }, /* @__PURE__ */ G.createElement(Ra, {
    values: [
      [
        _D,
        {
          ...d,
          ref: u
        }
      ],
      [
        hd,
        g
      ],
      [
        Au,
        {
          shouldCloseOnSelect: (x = e.shouldCloseOnSelect) !== null && x !== void 0 ? x : b
        }
      ]
    ]
  }, /* @__PURE__ */ G.createElement(l, {
    collection: s.collection,
    parent: n
  })));
}
const Au = /* @__PURE__ */ Le(null), EV = /* @__PURE__ */ Mb(Ab, function(t, n, r) {
  var i;
  [t, n] = Ai(t, n, Au);
  let o = (i = dp(Au)) === null || i === void 0 ? void 0 : i.id, a = Ce(Kb), s = ol(n), l = Ce(hd), { isVirtualized: u } = Ce(ul), { menuItemProps: c, labelProps: f, descriptionProps: d, keyboardShortcutProps: p, ...h } = c7({
    ...t,
    id: o,
    key: r.key,
    selectionManager: l,
    isVirtualized: u
  }, a, s), { hoverProps: m, isHovered: v } = sl({
    isDisabled: h.isDisabled
  }), g = Rr({
    ...t,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...h,
      isHovered: v,
      isFocusVisible: h.isFocusVisible,
      selectionMode: l.selectionMode,
      selectionBehavior: l.selectionBehavior,
      hasSubmenu: !!t["aria-haspopup"],
      isOpen: t["aria-expanded"] === "true"
    }
  }), b = t.href ? Fn.a : Fn.div, E = xn(t, {
    global: !0
  });
  return delete E.id, delete E.onClick, /* @__PURE__ */ G.createElement(b, {
    ...nt(E, g, c, m),
    ref: s,
    "data-disabled": h.isDisabled || void 0,
    "data-hovered": v || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": h.isFocusVisible || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-selected": h.isSelected || void 0,
    "data-selection-mode": l.selectionMode === "none" ? void 0 : l.selectionMode,
    "data-has-submenu": !!t["aria-haspopup"] || void 0,
    "data-open": t["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ G.createElement(Ra, {
    values: [
      [
        bp,
        {
          slots: {
            [_b]: f,
            label: f,
            description: d
          }
        }
      ],
      [
        mV,
        p
      ],
      [
        xD,
        {
          isSelected: h.isSelected
        }
      ]
    ]
  }, g.children));
}), Ub = /* @__PURE__ */ Le(null), SV = /* @__PURE__ */ Jt(function(t, n) {
  let { onSelect: r, acceptedFileTypes: i, allowsMultiple: o, defaultCamera: a, children: s, acceptDirectory: l, ...u } = t, c = ol(n), f = xn(u, {
    global: !0
  });
  return /* @__PURE__ */ G.createElement(G.Fragment, null, /* @__PURE__ */ G.createElement($k, {
    onPress: () => {
      var d, p;
      !((d = c.current) === null || d === void 0) && d.value && (c.current.value = ""), (p = c.current) === null || p === void 0 || p.click();
    }
  }, s), /* @__PURE__ */ G.createElement(tV, {
    ...f,
    className: "",
    type: "file",
    ref: c,
    style: {
      display: "none"
    },
    accept: i?.toString(),
    onChange: (d) => r?.(Te(d).files),
    capture: a,
    multiple: o,
    // @ts-expect-error
    webkitdirectory: l ? "" : void 0
  }));
}), OD = /* @__PURE__ */ Le(null), $V = /* @__PURE__ */ Le(null), TV = /* @__PURE__ */ Jt(function(t, n) {
  [t, n] = Ai(t, n, OD);
  let { children: r, isDisabled: i = !1, isInvalid: o = !1, isRequired: a = !1 } = t, s = Ee(() => typeof r == "function" ? r({
    isOpen: !1,
    isDisabled: i,
    isInvalid: o,
    isRequired: a,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : r, [
    r,
    i,
    o,
    a
  ]);
  return /* @__PURE__ */ G.createElement(Ib, {
    content: s
  }, (l) => /* @__PURE__ */ G.createElement(kV, {
    props: t,
    collection: l,
    selectRef: n
  }));
}), OV = [
  Nb,
  jb,
  bp
];
function kV({ props: e, selectRef: t, collection: n }) {
  let { validationBehavior: r } = dp(J7) || {};
  var i, o;
  let a = (o = (i = e.validationBehavior) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : "native", s = H7({
    ...e,
    collection: n,
    children: void 0,
    validationBehavior: a
  }), { isFocusVisible: l, focusProps: u } = yp({
    within: !0
  }), c = ve(null), [f, d] = wb(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: p, triggerProps: h, valueProps: m, menuProps: v, descriptionProps: g, errorMessageProps: b, hiddenSelectProps: E, ...x } = j7({
    ...SL(e),
    label: d,
    validationBehavior: a
  }, s, c), [S, $] = je(null), P = Ne(() => {
    c.current && $(c.current.offsetWidth + "px");
  }, [
    c
  ]);
  ad({
    ref: c,
    onResize: P
  });
  let y = Ee(() => ({
    isOpen: s.isOpen,
    isFocused: s.isFocused,
    isFocusVisible: l,
    isDisabled: e.isDisabled || !1,
    isInvalid: x.isInvalid || !1,
    isRequired: e.isRequired || !1
  }), [
    s.isOpen,
    s.isFocused,
    l,
    e.isDisabled,
    x.isInvalid,
    e.isRequired
  ]), _ = Rr({
    ...e,
    values: y,
    defaultClassName: "react-aria-Select"
  }), w = xn(e, {
    global: !0
  });
  delete w.id;
  let A = ve(null);
  return /* @__PURE__ */ G.createElement(Ra, {
    values: [
      [
        OD,
        e
      ],
      [
        $V,
        s
      ],
      [
        PV,
        m
      ],
      [
        Nb,
        {
          ...p,
          ref: f,
          elementType: "span"
        }
      ],
      [
        jb,
        {
          ...h,
          ref: c,
          isPressed: s.isOpen,
          autoFocus: e.autoFocus
        }
      ],
      [
        Ub,
        s
      ],
      [
        Bb,
        {
          trigger: "Select",
          triggerRef: c,
          scrollRef: A,
          placement: "bottom start",
          style: {
            "--trigger-width": S
          },
          "aria-labelledby": v["aria-labelledby"],
          clearContexts: OV
        }
      ],
      [
        Vb,
        {
          ...v,
          ref: A
        }
      ],
      [
        cl,
        s
      ],
      [
        bp,
        {
          slots: {
            description: g,
            errorMessage: b
          }
        }
      ],
      [
        Q7,
        x
      ]
    ]
  }, /* @__PURE__ */ G.createElement(Fn.div, {
    ...nt(w, _, u),
    ref: t,
    slot: e.slot || void 0,
    "data-focused": s.isFocused || void 0,
    "data-focus-visible": l || void 0,
    "data-open": s.isOpen || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": x.isInvalid || void 0,
    "data-required": e.isRequired || void 0
  }, _.children, /* @__PURE__ */ G.createElement(z7, {
    ...E,
    autoComplete: e.autoComplete
  })));
}
const PV = /* @__PURE__ */ Le(null), Nue = ({
  options: e,
  onSelect: t,
  label: n,
  className: r = ""
}) => /* @__PURE__ */ R.jsxs(
  TV,
  {
    className: r,
    onSelectionChange: (i) => {
      t(i);
    },
    children: [
      /* @__PURE__ */ R.jsx(Fb, { children: /* @__PURE__ */ R.jsxs("span", { "aria-hidden": "true", children: [
        n && /* @__PURE__ */ R.jsx(L7, { children: n }),
        /* @__PURE__ */ R.jsx(cr, { className: "px-2", icon: P$, size: "sm" })
      ] }) }),
      /* @__PURE__ */ R.jsx($D, { className: "bg-white border border-black", children: /* @__PURE__ */ R.jsx(aV, { children: e.map((i) => /* @__PURE__ */ R.jsx(uV, { id: i.id, children: /* @__PURE__ */ R.jsx("span", { className: "p-1 bg-white w-full block cursor-auto focus:outline-2 focus:outline-neutral-800 ", children: i.label }) }, `dropdown-${i.id}`)) }) })
    ]
  }
), md = Jt(({ className: e, ...t }, n) => /* @__PURE__ */ R.jsx("input", { ref: n, className: Wn(
  "bg-neutral-200 p-2 block h-auto max-h-8 my-2 border-black border dark:bg-neutral-500 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-400",
  e
), ...t })), DV = Jt(({ className: e, ...t }, n) => /* @__PURE__ */ R.jsx("select", { ref: n, ...t, className: Wn("bg-neutral-200 rounded-md p-2 block h-auto", e) })), jue = Jt(({ field: e, onChange: t, other: n, ...r }, i) => {
  const [o, a] = je(!1);
  switch (e.type) {
    case "textarea":
      return /* @__PURE__ */ R.jsx(
        "textarea",
        {
          ref: i,
          onChange: t,
          ...r
        }
      );
    case "select":
      return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
        /* @__PURE__ */ R.jsxs(
          DV,
          {
            ref: i,
            required: !e.optional,
            onChange: (s) => {
              s.target.value === "other" ? a(!0) : a(!1), t && t(s);
            },
            ...r,
            children: [
              e.options.map((s, l) => /* @__PURE__ */ R.jsx("option", { value: s, children: s }, l)),
              e?.allowOther && /* @__PURE__ */ R.jsx("option", { value: "other", children: "Other" })
            ]
          }
        ),
        o && n?.()
      ] });
    case "submit":
      return /* @__PURE__ */ R.jsx(
        $y,
        {
          ref: i,
          onChange: t,
          ...r,
          type: "submit",
          children: e.text
        }
      );
    case "email":
      return /* @__PURE__ */ R.jsx(
        md,
        {
          required: !e.optional,
          ref: i,
          onChange: t,
          type: "email",
          ...r
        }
      );
    default:
      return /* @__PURE__ */ R.jsx(
        md,
        {
          required: !e.optional,
          ref: i,
          onChange: t,
          ...r
        }
      );
  }
}), AV = a6`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`, om = o6.span`
  animation: ${AV} 3s linear infinite;
  animation-delay: ${({ index: e }) => e * 0.1}s;
`, Fue = () => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
  /* @__PURE__ */ R.jsx(om, { index: 0, children: "." }),
  /* @__PURE__ */ R.jsx(om, { index: 1, children: "." }),
  /* @__PURE__ */ R.jsx(om, { index: 2, children: "." })
] }), CV = (e) => /* @__PURE__ */ R.jsx("p", { ...e, className: "text-red-500 text-sm" });
class zue extends Gd {
  constructor() {
    super(...arguments);
    pi(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError(n) {
    return { hasError: !0 };
  }
  componentDidCatch(n, r) {
    console.error("Uncaught error:", n, r);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ R.jsx("h1", { children: "Sorry.. there was an error" }) : this.props.children;
  }
}
var Cn = /* @__PURE__ */ ((e) => (e.ALL = "all", e.NONE = "none", e.FILE = "file", e.DIR = "dir", e.FILE_LIST = "file_list", e.DIR_LIST = "dir_list", e))(Cn || {});
function oe(e, t, n) {
  function r(s, l) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: l,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, l);
    const u = a.prototype, c = Object.keys(u);
    for (let f = 0; f < c.length; f++) {
      const d = c[f];
      d in s || (s[d] = u[d].bind(s));
    }
  }
  const i = n?.Parent ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var l;
    const u = n != null && n.Parent ? new o() : this;
    r(u, s), (l = u._zod).deferred ?? (l.deferred = []);
    for (const c of u._zod.deferred)
      c();
    return u;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var l, u;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (u = (l = s?._zod) == null ? void 0 : l.traits) == null ? void 0 : u.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
let Ts = class extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}, kD = class extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
};
const PD = {};
function ko(e) {
  return PD;
}
function DD(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, r]) => t.indexOf(+n) === -1).map(([n, r]) => r);
}
function fg(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function qb(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Hb(e) {
  return e == null;
}
function Wb(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function IV(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = t.toString();
  let i = (r.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(r)) {
    const l = r.match(/\d?e-(\d?)/);
    l != null && l[1] && (i = Number.parseInt(l[1]));
  }
  const o = n > i ? n : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const Vx = Symbol("evaluating");
function tt(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== Vx)
        return r === void 0 && (r = Vx, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Fa(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Fo(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function Bx(e) {
  return JSON.stringify(e);
}
function MV(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const AD = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function vd(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const RV = qb(() => {
  var e;
  if (typeof navigator < "u" && (e = navigator?.userAgent) != null && e.includes("Cloudflare"))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function js(e) {
  if (vd(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(vd(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function CD(e) {
  return js(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const NV = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Fs(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function zo(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function Be(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function jV(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const FV = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function zV(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = Fo(e._zod.def, {
    get shape() {
      const o = {};
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && (o[a] = n.shape[a]);
      }
      return Fa(this, "shape", o), o;
    },
    checks: []
  });
  return zo(e, i);
}
function LV(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = Fo(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && delete o[a];
      }
      return Fa(this, "shape", o), o;
    },
    checks: []
  });
  return zo(e, i);
}
function VV(e, t) {
  if (!js(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const i = e._zod.def.shape;
    for (const o in t)
      if (Object.getOwnPropertyDescriptor(i, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const r = Fo(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return Fa(this, "shape", i), i;
    }
  });
  return zo(e, r);
}
function BV(e, t) {
  if (!js(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = Fo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Fa(this, "shape", r), r;
    }
  });
  return zo(e, n);
}
function KV(e, t) {
  const n = Fo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Fa(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return zo(e, n);
}
function UV(e, t, n) {
  const r = t._zod.def.checks;
  if (r && r.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const i = Fo(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, a = { ...o };
      if (n)
        for (const s in n) {
          if (!(s in o))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s]);
        }
      else
        for (const s in o)
          a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s];
      return Fa(this, "shape", a), a;
    },
    checks: []
  });
  return zo(t, i);
}
function qV(e, t, n) {
  const r = Fo(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (n)
        for (const a in n) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return Fa(this, "shape", o), o;
    }
  });
  return zo(t, r);
}
function ps(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function hs(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function qc(e) {
  return typeof e == "string" ? e : e?.message;
}
function Po(e, t, n) {
  var r, i, o, a, s, l;
  const u = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const c = qc((o = (i = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : i.error) == null ? void 0 : o.call(i, e)) ?? qc((a = t?.error) == null ? void 0 : a.call(t, e)) ?? qc((s = n.customError) == null ? void 0 : s.call(n, e)) ?? qc((l = n.localeError) == null ? void 0 : l.call(n, e)) ?? "Invalid input";
    u.message = c;
  }
  return delete u.inst, delete u.continue, t != null && t.reportInput || delete u.input, u;
}
function Zb(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Cu(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const ID = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, fg, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, MD = oe("$ZodError", ID), RD = oe("$ZodError", ID, { Parent: Error });
function HV(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function WV(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => r({ issues: a }));
      else if (o.code === "invalid_key")
        r({ issues: o.issues });
      else if (o.code === "invalid_element")
        r({ issues: o.issues });
      else if (o.path.length === 0)
        n._errors.push(t(o));
      else {
        let a = n, s = 0;
        for (; s < o.path.length; ) {
          const l = o.path[s];
          s === o.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(t(o))) : a[l] = a[l] || { _errors: [] }, a = a[l], s++;
        }
      }
  };
  return r(e), n;
}
const Gb = (e) => (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise)
    throw new Ts();
  if (a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Po(l, o, ko())));
    throw AD(s, i?.callee), s;
  }
  return a.value;
}, Yb = (e) => async (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Po(l, o, ko())));
    throw AD(s, i?.callee), s;
  }
  return a.value;
}, wp = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, i);
  if (o instanceof Promise)
    throw new Ts();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? MD)(o.issues.map((a) => Po(a, i, ko())))
  } : { success: !0, data: o.value };
}, ZV = /* @__PURE__ */ wp(RD), xp = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => Po(a, i, ko())))
  } : { success: !0, data: o.value };
}, GV = /* @__PURE__ */ xp(RD), YV = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Gb(e)(t, n, i);
}, QV = (e) => (t, n, r) => Gb(e)(t, n, r), JV = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Yb(e)(t, n, i);
}, XV = (e) => async (t, n, r) => Yb(e)(t, n, r), eB = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return wp(e)(t, n, i);
}, tB = (e) => (t, n, r) => wp(e)(t, n, r), nB = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return xp(e)(t, n, i);
}, rB = (e) => async (t, n, r) => xp(e)(t, n, r), iB = /^[cC][^\s-]{8,}$/, oB = /^[0-9a-z]+$/, aB = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, sB = /^[0-9a-vA-V]{20}$/, lB = /^[A-Za-z0-9]{27}$/, uB = /^[a-zA-Z0-9_-]{21}$/, cB = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, fB = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Kx = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, dB = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, pB = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function hB() {
  return new RegExp(pB, "u");
}
const mB = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, vB = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, gB = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, yB = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, bB = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, ND = /^[A-Za-z0-9_-]*$/, _B = /^\+[1-9]\d{6,14}$/, jD = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", wB = /* @__PURE__ */ new RegExp(`^${jD}$`);
function FD(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function xB(e) {
  return new RegExp(`^${FD(e)}$`);
}
function EB(e) {
  const t = FD({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${jD}T(?:${r})$`);
}
const SB = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, $B = /^-?\d+$/, zD = /^-?\d+(?:\.\d+)?$/, TB = /^(?:true|false)$/i, OB = /^[^A-Z]*$/, kB = /^[^a-z]*$/, Xn = /* @__PURE__ */ oe("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), LD = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, VD = /* @__PURE__ */ oe("$ZodCheckLessThan", (e, t) => {
  Xn.init(e, t);
  const n = LD[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), BD = /* @__PURE__ */ oe("$ZodCheckGreaterThan", (e, t) => {
  Xn.init(e, t);
  const n = LD[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), PB = /* @__PURE__ */ oe("$ZodCheckMultipleOf", (e, t) => {
  Xn.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : IV(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), DB = /* @__PURE__ */ oe("$ZodCheckNumberFormat", (e, t) => {
  var n;
  Xn.init(e, t), t.format = t.format || "float64";
  const r = (n = t.format) == null ? void 0 : n.includes("int"), i = r ? "int" : "number", [o, a] = FV[t.format];
  e._zod.onattach.push((s) => {
    const l = s._zod.bag;
    l.format = t.format, l.minimum = o, l.maximum = a, r && (l.pattern = $B);
  }), e._zod.check = (s) => {
    const l = s.value;
    if (r) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: i,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < o && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > a && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: a,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), AB = /* @__PURE__ */ oe("$ZodCheckMaxLength", (e, t) => {
  var n;
  Xn.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Hb(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = Zb(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), CB = /* @__PURE__ */ oe("$ZodCheckMinLength", (e, t) => {
  var n;
  Xn.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Hb(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = Zb(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), IB = /* @__PURE__ */ oe("$ZodCheckLengthEquals", (e, t) => {
  var n;
  Xn.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Hb(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, o = i.length;
    if (o === t.length)
      return;
    const a = Zb(i), s = o > t.length;
    r.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ep = /* @__PURE__ */ oe("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  Xn.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), MB = /* @__PURE__ */ oe("$ZodCheckRegex", (e, t) => {
  Ep.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), RB = /* @__PURE__ */ oe("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = OB), Ep.init(e, t);
}), NB = /* @__PURE__ */ oe("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = kB), Ep.init(e, t);
}), jB = /* @__PURE__ */ oe("$ZodCheckIncludes", (e, t) => {
  Xn.init(e, t);
  const n = Fs(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), FB = /* @__PURE__ */ oe("$ZodCheckStartsWith", (e, t) => {
  Xn.init(e, t);
  const n = new RegExp(`^${Fs(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), zB = /* @__PURE__ */ oe("$ZodCheckEndsWith", (e, t) => {
  Xn.init(e, t);
  const n = new RegExp(`.*${Fs(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), LB = /* @__PURE__ */ oe("$ZodCheckOverwrite", (e, t) => {
  Xn.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
let VB = class {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((o) => o), r = Math.min(...n.map((o) => o.length - o.trimStart().length)), i = n.map((o) => o.slice(r)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of i)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, r.join(`
`));
  }
};
const BB = {
  major: 4,
  minor: 3,
  patch: 6
}, At = /* @__PURE__ */ oe("$ZodType", (e, t) => {
  var n, r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = BB;
  const i = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && i.unshift(e);
  for (const o of i)
    for (const a of o._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (n = e._zod.deferred) == null || n.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, l, u) => {
      let c = ps(s), f;
      for (const d of l) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (c)
          continue;
        const p = s.issues.length, h = d._zod.check(s);
        if (h instanceof Promise && u?.async === !1)
          throw new Ts();
        if (f || h instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await h, s.issues.length !== p && (c || (c = ps(s, p)));
          });
        else {
          if (s.issues.length === p)
            continue;
          c || (c = ps(s, p));
        }
      }
      return f ? f.then(() => s) : s;
    }, a = (s, l, u) => {
      if (ps(s))
        return s.aborted = !0, s;
      const c = o(l, i, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new Ts();
        return c.then((f) => e._zod.parse(f, u));
      }
      return e._zod.parse(c, u);
    };
    e._zod.run = (s, l) => {
      if (l.skipChecks)
        return e._zod.parse(s, l);
      if (l.direction === "backward") {
        const c = e._zod.parse({ value: s.value, issues: [] }, { ...l, skipChecks: !0 });
        return c instanceof Promise ? c.then((f) => a(f, s, l)) : a(c, s, l);
      }
      const u = e._zod.parse(s, l);
      if (u instanceof Promise) {
        if (l.async === !1)
          throw new Ts();
        return u.then((c) => o(c, i, l));
      }
      return o(u, i, l);
    };
  }
  tt(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = ZV(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return GV(e, o).then((s) => {
          var l;
          return s.success ? { value: s.data } : { issues: (l = s.error) == null ? void 0 : l.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Qb = /* @__PURE__ */ oe("$ZodString", (e, t) => {
  var n;
  At.init(e, t), e._zod.pattern = [...((n = e?._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? SB(e._zod.bag), e._zod.parse = (r, i) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), jt = /* @__PURE__ */ oe("$ZodStringFormat", (e, t) => {
  Ep.init(e, t), Qb.init(e, t);
}), KB = /* @__PURE__ */ oe("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = fB), jt.init(e, t);
}), UB = /* @__PURE__ */ oe("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Kx(n));
  } else
    t.pattern ?? (t.pattern = Kx());
  jt.init(e, t);
}), qB = /* @__PURE__ */ oe("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = dB), jt.init(e, t);
}), HB = /* @__PURE__ */ oe("$ZodURL", (e, t) => {
  jt.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), WB = /* @__PURE__ */ oe("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = hB()), jt.init(e, t);
}), ZB = /* @__PURE__ */ oe("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = uB), jt.init(e, t);
}), GB = /* @__PURE__ */ oe("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = iB), jt.init(e, t);
}), YB = /* @__PURE__ */ oe("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = oB), jt.init(e, t);
}), QB = /* @__PURE__ */ oe("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = aB), jt.init(e, t);
}), JB = /* @__PURE__ */ oe("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = sB), jt.init(e, t);
}), XB = /* @__PURE__ */ oe("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = lB), jt.init(e, t);
}), eK = /* @__PURE__ */ oe("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = EB(t)), jt.init(e, t);
}), tK = /* @__PURE__ */ oe("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = wB), jt.init(e, t);
}), nK = /* @__PURE__ */ oe("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = xB(t)), jt.init(e, t);
}), rK = /* @__PURE__ */ oe("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = cB), jt.init(e, t);
}), iK = /* @__PURE__ */ oe("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = mB), jt.init(e, t), e._zod.bag.format = "ipv4";
}), oK = /* @__PURE__ */ oe("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = vB), jt.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), aK = /* @__PURE__ */ oe("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = gB), jt.init(e, t);
}), sK = /* @__PURE__ */ oe("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = yB), jt.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, o] = r;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function KD(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const lK = /* @__PURE__ */ oe("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = bB), jt.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    KD(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function uK(e) {
  if (!ND.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return KD(n);
}
const cK = /* @__PURE__ */ oe("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = ND), jt.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    uK(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), fK = /* @__PURE__ */ oe("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = _B), jt.init(e, t);
});
function dK(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const pK = /* @__PURE__ */ oe("$ZodJWT", (e, t) => {
  jt.init(e, t), e._zod.check = (n) => {
    dK(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), UD = /* @__PURE__ */ oe("$ZodNumber", (e, t) => {
  At.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? zD, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const i = n.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return n;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), n;
  };
}), hK = /* @__PURE__ */ oe("$ZodNumberFormat", (e, t) => {
  DB.init(e, t), UD.init(e, t);
}), mK = /* @__PURE__ */ oe("$ZodBoolean", (e, t) => {
  At.init(e, t), e._zod.pattern = TB, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const i = n.value;
    return typeof i == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), n;
  };
}), vK = /* @__PURE__ */ oe("$ZodUnknown", (e, t) => {
  At.init(e, t), e._zod.parse = (n) => n;
}), gK = /* @__PURE__ */ oe("$ZodNever", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
}), yK = /* @__PURE__ */ oe("$ZodDate", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = new Date(n.value);
      } catch {
      }
    const i = n.value, o = i instanceof Date;
    return o && !Number.isNaN(i.getTime()) || n.issues.push({
      expected: "date",
      code: "invalid_type",
      input: i,
      ...o ? { received: "Invalid Date" } : {},
      inst: e
    }), n;
  };
});
function Ux(e, t, n) {
  e.issues.length && t.issues.push(...hs(n, e.issues)), t.value[n] = e.value;
}
const bK = /* @__PURE__ */ oe("$ZodArray", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], l = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      l instanceof Promise ? o.push(l.then((u) => Ux(u, n, a))) : Ux(l, n, a);
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
});
function gd(e, t, n, r, i) {
  if (e.issues.length) {
    if (i && !(n in r))
      return;
    t.issues.push(...hs(n, e.issues));
  }
  e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function qD(e) {
  var t, n, r, i;
  const o = Object.keys(e.shape);
  for (const s of o)
    if (!((i = (r = (n = (t = e.shape) == null ? void 0 : t[s]) == null ? void 0 : n._zod) == null ? void 0 : r.traits) != null && i.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const a = jV(e.shape);
  return {
    ...e,
    keys: o,
    keySet: new Set(o),
    numKeys: o.length,
    optionalKeys: new Set(a)
  };
}
function HD(e, t, n, r, i, o) {
  const a = [], s = i.keySet, l = i.catchall._zod, u = l.def.type, c = l.optout === "optional";
  for (const f in t) {
    if (s.has(f))
      continue;
    if (u === "never") {
      a.push(f);
      continue;
    }
    const d = l.run({ value: t[f], issues: [] }, r);
    d instanceof Promise ? e.push(d.then((p) => gd(p, n, f, t, c))) : gd(d, n, f, t, c);
  }
  return a.length && n.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const _K = /* @__PURE__ */ oe("$ZodObject", (e, t) => {
  At.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const l = { ...s };
        return Object.defineProperty(t, "shape", {
          value: l
        }), l;
      }
    });
  }
  const r = qb(() => qD(t));
  tt(e._zod, "propValues", () => {
    const s = t.shape, l = {};
    for (const u in s) {
      const c = s[u]._zod;
      if (c.values) {
        l[u] ?? (l[u] = /* @__PURE__ */ new Set());
        for (const f of c.values)
          l[u].add(f);
      }
    }
    return l;
  });
  const i = vd, o = t.catchall;
  let a;
  e._zod.parse = (s, l) => {
    a ?? (a = r.value);
    const u = s.value;
    if (!i(u))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: u,
        inst: e
      }), s;
    s.value = {};
    const c = [], f = a.shape;
    for (const d of a.keys) {
      const p = f[d], h = p._zod.optout === "optional", m = p._zod.run({ value: u[d], issues: [] }, l);
      m instanceof Promise ? c.push(m.then((v) => gd(v, s, d, u, h))) : gd(m, s, d, u, h);
    }
    return o ? HD(c, u, s, l, r.value, e) : c.length ? Promise.all(c).then(() => s) : s;
  };
}), wK = /* @__PURE__ */ oe("$ZodObjectJIT", (e, t) => {
  _K.init(e, t);
  const n = e._zod.parse, r = qb(() => qD(t)), i = (f) => {
    var d;
    const p = new VB(["shape", "payload", "ctx"]), h = r.value, m = (E) => {
      const x = Bx(E);
      return `shape[${x}]._zod.run({ value: input[${x}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const v = /* @__PURE__ */ Object.create(null);
    let g = 0;
    for (const E of h.keys)
      v[E] = `key_${g++}`;
    p.write("const newResult = {};");
    for (const E of h.keys) {
      const x = v[E], S = Bx(E), $ = f[E], P = ((d = $?._zod) == null ? void 0 : d.optout) === "optional";
      p.write(`const ${x} = ${m(E)};`), P ? p.write(`
        if (${x}.issues.length) {
          if (${S} in input) {
            payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${S}, ...iss.path] : [${S}]
            })));
          }
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `) : p.write(`
        if (${x}.issues.length) {
          payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${S}, ...iss.path] : [${S}]
          })));
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `);
    }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const b = p.compile();
    return (E, x) => b(f, E, x);
  };
  let o;
  const a = vd, s = !PD.jitless, l = s && RV.value, u = t.catchall;
  let c;
  e._zod.parse = (f, d) => {
    c ?? (c = r.value);
    const p = f.value;
    return a(p) ? s && l && d?.async === !1 && d.jitless !== !0 ? (o || (o = i(t.shape)), f = o(f, d), u ? HD([], p, f, d, c, e) : f) : n(f, d) : (f.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), f);
  };
});
function qx(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !ps(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((a) => Po(a, r, ko())))
  }), t);
}
const xK = /* @__PURE__ */ oe("$ZodUnion", (e, t) => {
  At.init(e, t), tt(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), tt(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), tt(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), tt(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => Wb(o.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (n)
      return r(i, o);
    let a = !1;
    const s = [];
    for (const l of t.options) {
      const u = l._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (u instanceof Promise)
        s.push(u), a = !0;
      else {
        if (u.issues.length === 0)
          return u;
        s.push(u);
      }
    }
    return a ? Promise.all(s).then((l) => qx(l, i, e, o)) : qx(s, i, e, o);
  };
}), EK = /* @__PURE__ */ oe("$ZodIntersection", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, o = t.left._zod.run({ value: i, issues: [] }, r), a = t.right._zod.run({ value: i, issues: [] }, r);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([s, l]) => Hx(n, s, l)) : Hx(n, o, a);
  };
});
function dg(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (js(e) && js(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((o) => n.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of r) {
      const a = dg(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], o = t[r], a = dg(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Hx(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).l = !0;
    } else
      e.issues.push(s);
  for (const s of n.issues)
    if (s.code === "unrecognized_keys")
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).r = !0;
    else
      e.issues.push(s);
  const o = [...r].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), ps(e))
    return e;
  const a = dg(t.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const SK = /* @__PURE__ */ oe("$ZodRecord", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!js(i))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    const o = [], a = t.keyType._zod.values;
    if (a) {
      n.value = {};
      const s = /* @__PURE__ */ new Set();
      for (const u of a)
        if (typeof u == "string" || typeof u == "number" || typeof u == "symbol") {
          s.add(typeof u == "number" ? u.toString() : u);
          const c = t.valueType._zod.run({ value: i[u], issues: [] }, r);
          c instanceof Promise ? o.push(c.then((f) => {
            f.issues.length && n.issues.push(...hs(u, f.issues)), n.value[u] = f.value;
          })) : (c.issues.length && n.issues.push(...hs(u, c.issues)), n.value[u] = c.value);
        }
      let l;
      for (const u in i)
        s.has(u) || (l = l ?? [], l.push(u));
      l && l.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: i,
        inst: e,
        keys: l
      });
    } else {
      n.value = {};
      for (const s of Reflect.ownKeys(i)) {
        if (s === "__proto__")
          continue;
        let l = t.keyType._zod.run({ value: s, issues: [] }, r);
        if (l instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (typeof s == "string" && zD.test(s) && l.issues.length) {
          const c = t.keyType._zod.run({ value: Number(s), issues: [] }, r);
          if (c instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          c.issues.length === 0 && (l = c);
        }
        if (l.issues.length) {
          t.mode === "loose" ? n.value[s] = i[s] : n.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: l.issues.map((c) => Po(c, r, ko())),
            input: s,
            path: [s],
            inst: e
          });
          continue;
        }
        const u = t.valueType._zod.run({ value: i[s], issues: [] }, r);
        u instanceof Promise ? o.push(u.then((c) => {
          c.issues.length && n.issues.push(...hs(s, c.issues)), n.value[l.value] = c.value;
        })) : (u.issues.length && n.issues.push(...hs(s, u.issues)), n.value[l.value] = u.value);
      }
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
}), $K = /* @__PURE__ */ oe("$ZodEnum", (e, t) => {
  At.init(e, t);
  const n = DD(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => NV.has(typeof i)).map((i) => typeof i == "string" ? Fs(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return r.has(a) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: e
    }), i;
  };
}), TK = /* @__PURE__ */ oe("$ZodLiteral", (e, t) => {
  if (At.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const n = new Set(t.values);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${t.values.map((r) => typeof r == "string" ? Fs(r) : r ? Fs(r.toString()) : String(r)).join("|")})$`), e._zod.parse = (r, i) => {
    const o = r.value;
    return n.has(o) || r.issues.push({
      code: "invalid_value",
      values: t.values,
      input: o,
      inst: e
    }), r;
  };
}), OK = /* @__PURE__ */ oe("$ZodTransform", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new kD(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n));
    if (i instanceof Promise)
      throw new Ts();
    return n.value = i, n;
  };
});
function Wx(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const WD = /* @__PURE__ */ oe("$ZodOptional", (e, t) => {
  At.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", tt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), tt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Wb(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((o) => Wx(o, n.value)) : Wx(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), kK = /* @__PURE__ */ oe("$ZodExactOptional", (e, t) => {
  WD.init(e, t), tt(e._zod, "values", () => t.innerType._zod.values), tt(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), PK = /* @__PURE__ */ oe("$ZodNullable", (e, t) => {
  At.init(e, t), tt(e._zod, "optin", () => t.innerType._zod.optin), tt(e._zod, "optout", () => t.innerType._zod.optout), tt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Wb(n.source)}|null)$`) : void 0;
  }), tt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), DK = /* @__PURE__ */ oe("$ZodDefault", (e, t) => {
  At.init(e, t), e._zod.optin = "optional", tt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => Zx(o, t)) : Zx(i, t);
  };
});
function Zx(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const AK = /* @__PURE__ */ oe("$ZodPrefault", (e, t) => {
  At.init(e, t), e._zod.optin = "optional", tt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), CK = /* @__PURE__ */ oe("$ZodNonOptional", (e, t) => {
  At.init(e, t), tt(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => Gx(o, e)) : Gx(i, e);
  };
});
function Gx(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const IK = /* @__PURE__ */ oe("$ZodCatch", (e, t) => {
  At.init(e, t), tt(e._zod, "optin", () => t.innerType._zod.optin), tt(e._zod, "optout", () => t.innerType._zod.optout), tt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((a) => Po(a, r, ko()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((o) => Po(o, r, ko()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), MK = /* @__PURE__ */ oe("$ZodPipe", (e, t) => {
  At.init(e, t), tt(e._zod, "values", () => t.in._zod.values), tt(e._zod, "optin", () => t.in._zod.optin), tt(e._zod, "optout", () => t.out._zod.optout), tt(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const o = t.out._zod.run(n, r);
      return o instanceof Promise ? o.then((a) => Hc(a, t.in, r)) : Hc(o, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => Hc(o, t.out, r)) : Hc(i, t.out, r);
  };
});
function Hc(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const RK = /* @__PURE__ */ oe("$ZodReadonly", (e, t) => {
  At.init(e, t), tt(e._zod, "propValues", () => t.innerType._zod.propValues), tt(e._zod, "values", () => t.innerType._zod.values), tt(e._zod, "optin", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), tt(e._zod, "optout", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(Yx) : Yx(i);
  };
});
function Yx(e) {
  return e.value = Object.freeze(e.value), e;
}
const NK = /* @__PURE__ */ oe("$ZodLazy", (e, t) => {
  At.init(e, t), tt(e._zod, "innerType", () => t.getter()), tt(e._zod, "pattern", () => {
    var n, r;
    return (r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.pattern;
  }), tt(e._zod, "propValues", () => {
    var n, r;
    return (r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.propValues;
  }), tt(e._zod, "optin", () => {
    var n, r;
    return ((r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin) ?? void 0;
  }), tt(e._zod, "optout", () => {
    var n, r;
    return ((r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout) ?? void 0;
  }), e._zod.parse = (n, r) => e._zod.innerType._zod.run(n, r);
}), jK = /* @__PURE__ */ oe("$ZodCustom", (e, t) => {
  Xn.init(e, t), At.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((o) => Qx(o, n, r, e));
    Qx(i, n, r, e);
  };
});
function Qx(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(Cu(i));
  }
}
var Jx;
let FK = class {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
};
function zK() {
  return new FK();
}
(Jx = globalThis).__zod_globalRegistry ?? (Jx.__zod_globalRegistry = zK());
const Yl = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function LK(e, t) {
  return new e({
    type: "string",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function VK(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Xx(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function BK(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function KK(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function UK(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qK(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function HK(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function WK(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ZK(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function GK(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function YK(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function QK(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function JK(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function XK(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eU(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tU(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nU(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rU(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function iU(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function oU(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function aU(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sU(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lU(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function uU(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cU(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fU(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dU(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pU(e, t) {
  return new e({
    type: "number",
    coerce: !0,
    checks: [],
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hU(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function mU(e, t) {
  return new e({
    type: "boolean",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function vU(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function gU(e, t) {
  return new e({
    type: "never",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yU(e, t) {
  return new e({
    type: "date",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eE(e, t) {
  return new VD({
    check: "less_than",
    ...Be(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Tf(e, t) {
  return new VD({
    check: "less_than",
    ...Be(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function tE(e, t) {
  return new BD({
    check: "greater_than",
    ...Be(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Of(e, t) {
  return new BD({
    check: "greater_than",
    ...Be(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function nE(e, t) {
  return new PB({
    check: "multiple_of",
    ...Be(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function ZD(e, t) {
  return new AB({
    check: "max_length",
    ...Be(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function yd(e, t) {
  return new CB({
    check: "min_length",
    ...Be(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function GD(e, t) {
  return new IB({
    check: "length_equals",
    ...Be(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function bU(e, t) {
  return new MB({
    check: "string_format",
    format: "regex",
    ...Be(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function _U(e) {
  return new RB({
    check: "string_format",
    format: "lowercase",
    ...Be(e)
  });
}
// @__NO_SIDE_EFFECTS__
function wU(e) {
  return new NB({
    check: "string_format",
    format: "uppercase",
    ...Be(e)
  });
}
// @__NO_SIDE_EFFECTS__
function xU(e, t) {
  return new jB({
    check: "string_format",
    format: "includes",
    ...Be(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function EU(e, t) {
  return new FB({
    check: "string_format",
    format: "starts_with",
    ...Be(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function SU(e, t) {
  return new zB({
    check: "string_format",
    format: "ends_with",
    ...Be(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function fl(e) {
  return new LB({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function $U(e) {
  return /* @__PURE__ */ fl((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function TU() {
  return /* @__PURE__ */ fl((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function OU() {
  return /* @__PURE__ */ fl((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function kU() {
  return /* @__PURE__ */ fl((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function PU() {
  return /* @__PURE__ */ fl((e) => MV(e));
}
// @__NO_SIDE_EFFECTS__
function DU(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...Be(n)
  });
}
// @__NO_SIDE_EFFECTS__
function AU(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...Be(n)
  });
}
// @__NO_SIDE_EFFECTS__
function CU(e) {
  const t = /* @__PURE__ */ IU((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(Cu(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(Cu(i));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function IU(e, t) {
  const n = new Xn({
    check: "custom",
    ...Be(t)
  });
  return n._zod.check = e, n;
}
function YD(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? Yl,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function Yt(e, t, n = { path: [], schemaPath: [] }) {
  var r, i, o;
  const a = e._zod.def, s = t.seen.get(e);
  if (s)
    return s.count++, n.schemaPath.includes(e) && (s.cycle = n.path), s.schema;
  const l = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, l);
  const u = (i = (r = e._zod).toJSONSchema) == null ? void 0 : i.call(r);
  if (u)
    l.schema = u;
  else {
    const f = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, l.schema, f);
    else {
      const p = l.schema, h = t.processors[a.type];
      if (!h)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${a.type}`);
      h(e, t, p, f);
    }
    const d = e._zod.parent;
    d && (l.ref || (l.ref = d), Yt(d, t, f), t.seen.get(d).isParent = !0);
  }
  const c = t.metadataRegistry.get(e);
  return c && Object.assign(l.schema, c), t.io === "input" && Pn(e) && (delete l.schema.examples, delete l.schema.default), t.io === "input" && l.schema._prefault && ((o = l.schema).default ?? (o.default = l.schema._prefault)), delete l.schema._prefault, t.seen.get(e).schema;
}
function QD(e, t) {
  var n, r, i, o;
  const a = e.seen.get(t);
  if (!a)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = /* @__PURE__ */ new Map();
  for (const c of e.seen.entries()) {
    const f = (n = e.metadataRegistry.get(c[0])) == null ? void 0 : n.id;
    if (f) {
      const d = s.get(f);
      if (d && d !== c[0])
        throw new Error(`Duplicate schema id "${f}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      s.set(f, c[0]);
    }
  }
  const l = (c) => {
    var f;
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const m = (f = e.external.registry.get(c[0])) == null ? void 0 : f.id, v = e.external.uri ?? ((b) => b);
      if (m)
        return { ref: v(m) };
      const g = c[1].defId ?? c[1].schema.id ?? `schema${e.counter++}`;
      return c[1].defId = g, { defId: g, ref: `${v("__shared")}#/${d}/${g}` };
    }
    if (c[1] === a)
      return { ref: "#" };
    const p = `#/${d}/`, h = c[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: h, ref: p + h };
  }, u = (c) => {
    if (c[1].schema.$ref)
      return;
    const f = c[1], { ref: d, defId: p } = l(c);
    f.def = { ...f.schema }, p && (f.defId = p);
    const h = f.schema;
    for (const m in h)
      delete h[m];
    h.$ref = d;
  };
  if (e.cycles === "throw")
    for (const c of e.seen.entries()) {
      const f = c[1];
      if (f.cycle)
        throw new Error(`Cycle detected: #/${(r = f.cycle) == null ? void 0 : r.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const c of e.seen.entries()) {
    const f = c[1];
    if (t === c[0]) {
      u(c);
      continue;
    }
    if (e.external) {
      const d = (i = e.external.registry.get(c[0])) == null ? void 0 : i.id;
      if (t !== c[0] && d) {
        u(c);
        continue;
      }
    }
    if ((o = e.metadataRegistry.get(c[0])) != null && o.id) {
      u(c);
      continue;
    }
    if (f.cycle) {
      u(c);
      continue;
    }
    if (f.count > 1 && e.reused === "ref") {
      u(c);
      continue;
    }
  }
}
function JD(e, t) {
  var n, r, i;
  const o = e.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (u) => {
    const c = e.seen.get(u);
    if (c.ref === null)
      return;
    const f = c.def ?? c.schema, d = { ...f }, p = c.ref;
    if (c.ref = null, p) {
      a(p);
      const m = e.seen.get(p), v = m.schema;
      if (v.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (f.allOf = f.allOf ?? [], f.allOf.push(v)) : Object.assign(f, v), Object.assign(f, d), u._zod.parent === p)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in d || delete f[g];
      if (v.$ref && m.def)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in m.def && JSON.stringify(f[g]) === JSON.stringify(m.def[g]) && delete f[g];
    }
    const h = u._zod.parent;
    if (h && h !== p) {
      a(h);
      const m = e.seen.get(h);
      if (m != null && m.schema.$ref && (f.$ref = m.schema.$ref, m.def))
        for (const v in f)
          v === "$ref" || v === "allOf" || v in m.def && JSON.stringify(f[v]) === JSON.stringify(m.def[v]) && delete f[v];
    }
    e.override({
      zodSchema: u,
      jsonSchema: f,
      path: c.path ?? []
    });
  };
  for (const u of [...e.seen.entries()].reverse())
    a(u[0]);
  const s = {};
  if (e.target === "draft-2020-12" ? s.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? s.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? s.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (n = e.external) != null && n.uri) {
    const u = (r = e.external.registry.get(t)) == null ? void 0 : r.id;
    if (!u)
      throw new Error("Schema is missing an `id` property");
    s.$id = e.external.uri(u);
  }
  Object.assign(s, o.def ?? o.schema);
  const l = ((i = e.external) == null ? void 0 : i.defs) ?? {};
  for (const u of e.seen.entries()) {
    const c = u[1];
    c.def && c.defId && (l[c.defId] = c.def);
  }
  e.external || Object.keys(l).length > 0 && (e.target === "draft-2020-12" ? s.$defs = l : s.definitions = l);
  try {
    const u = JSON.parse(JSON.stringify(s));
    return Object.defineProperty(u, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: bd(t, "input", e.processors),
          output: bd(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), u;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Pn(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return Pn(r.element, n);
  if (r.type === "set")
    return Pn(r.valueType, n);
  if (r.type === "lazy")
    return Pn(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return Pn(r.innerType, n);
  if (r.type === "intersection")
    return Pn(r.left, n) || Pn(r.right, n);
  if (r.type === "record" || r.type === "map")
    return Pn(r.keyType, n) || Pn(r.valueType, n);
  if (r.type === "pipe")
    return Pn(r.in, n) || Pn(r.out, n);
  if (r.type === "object") {
    for (const i in r.shape)
      if (Pn(r.shape[i], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const i of r.options)
      if (Pn(i, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const i of r.items)
      if (Pn(i, n))
        return !0;
    return !!(r.rest && Pn(r.rest, n));
  }
  return !1;
}
const MU = (e, t = {}) => (n) => {
  const r = YD({ ...n, processors: t });
  return Yt(e, r), QD(r, e), JD(r, e);
}, bd = (e, t, n = {}) => (r) => {
  const { libraryOptions: i, target: o } = r ?? {}, a = YD({ ...i ?? {}, target: o, io: t, processors: n });
  return Yt(e, a), QD(a, e), JD(a, e);
}, RU = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, NU = (e, t, n, r) => {
  const i = n;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: l, contentEncoding: u } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = RU[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), u && (i.contentEncoding = u), l && l.size > 0) {
    const c = [...l];
    c.length === 1 ? i.pattern = c[0].source : c.length > 1 && (i.allOf = [
      ...c.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, jU = (e, t, n, r) => {
  const i = n, { minimum: o, maximum: a, format: s, multipleOf: l, exclusiveMaximum: u, exclusiveMinimum: c } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = c, i.exclusiveMinimum = !0) : i.exclusiveMinimum = c), typeof o == "number" && (i.minimum = o, typeof c == "number" && t.target !== "draft-04" && (c >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof u == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = u, i.exclusiveMaximum = !0) : i.exclusiveMaximum = u), typeof a == "number" && (i.maximum = a, typeof u == "number" && t.target !== "draft-04" && (u <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof l == "number" && (i.multipleOf = l);
}, FU = (e, t, n, r) => {
  n.type = "boolean";
}, zU = (e, t, n, r) => {
  n.not = {};
}, LU = (e, t, n, r) => {
}, VU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Date cannot be represented in JSON Schema");
}, BU = (e, t, n, r) => {
  const i = e._zod.def, o = DD(i.entries);
  o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), n.enum = o;
}, KU = (e, t, n, r) => {
  const i = e._zod.def, o = [];
  for (const a of i.values)
    if (a === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof a == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      o.push(Number(a));
    } else
      o.push(a);
  if (o.length !== 0) if (o.length === 1) {
    const a = o[0];
    n.type = a === null ? "null" : typeof a, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [a] : n.const = a;
  } else
    o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), o.every((a) => typeof a == "boolean") && (n.type = "boolean"), o.every((a) => a === null) && (n.type = "null"), n.enum = o;
}, UU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, qU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, HU = (e, t, n, r) => {
  const i = n, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = Yt(o.element, t, { ...r, path: [...r.path, "items"] });
}, WU = (e, t, n, r) => {
  var i;
  const o = n, a = e._zod.def;
  o.type = "object", o.properties = {};
  const s = a.shape;
  for (const c in s)
    o.properties[c] = Yt(s[c], t, {
      ...r,
      path: [...r.path, "properties", c]
    });
  const l = new Set(Object.keys(s)), u = new Set([...l].filter((c) => {
    const f = a.shape[c]._zod;
    return t.io === "input" ? f.optin === void 0 : f.optout === void 0;
  }));
  u.size > 0 && (o.required = Array.from(u)), ((i = a.catchall) == null ? void 0 : i._zod.def.type) === "never" ? o.additionalProperties = !1 : a.catchall ? a.catchall && (o.additionalProperties = Yt(a.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, ZU = (e, t, n, r) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, l) => Yt(s, t, {
    ...r,
    path: [...r.path, o ? "oneOf" : "anyOf", l]
  }));
  o ? n.oneOf = a : n.anyOf = a;
}, GU = (e, t, n, r) => {
  const i = e._zod.def, o = Yt(i.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = Yt(i.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), s = (u) => "allOf" in u && Object.keys(u).length === 1, l = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  n.allOf = l;
}, YU = (e, t, n, r) => {
  const i = n, o = e._zod.def;
  i.type = "object";
  const a = o.keyType, s = a._zod.bag, l = s?.patterns;
  if (o.mode === "loose" && l && l.size > 0) {
    const c = Yt(o.valueType, t, {
      ...r,
      path: [...r.path, "patternProperties", "*"]
    });
    i.patternProperties = {};
    for (const f of l)
      i.patternProperties[f.source] = c;
  } else
    (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = Yt(o.keyType, t, {
      ...r,
      path: [...r.path, "propertyNames"]
    })), i.additionalProperties = Yt(o.valueType, t, {
      ...r,
      path: [...r.path, "additionalProperties"]
    });
  const u = a._zod.values;
  if (u) {
    const c = [...u].filter((f) => typeof f == "string" || typeof f == "number");
    c.length > 0 && (i.required = c);
  }
}, QU = (e, t, n, r) => {
  const i = e._zod.def, o = Yt(i.innerType, t, r), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, n.nullable = !0) : n.anyOf = [o, { type: "null" }];
}, JU = (e, t, n, r) => {
  const i = e._zod.def;
  Yt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, XU = (e, t, n, r) => {
  const i = e._zod.def;
  Yt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, eq = (e, t, n, r) => {
  const i = e._zod.def;
  Yt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, tq = (e, t, n, r) => {
  const i = e._zod.def;
  Yt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = a;
}, nq = (e, t, n, r) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  Yt(o, t, r);
  const a = t.seen.get(e);
  a.ref = o;
}, rq = (e, t, n, r) => {
  const i = e._zod.def;
  Yt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.readOnly = !0;
}, XD = (e, t, n, r) => {
  const i = e._zod.def;
  Yt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, iq = (e, t, n, r) => {
  const i = e._zod.innerType;
  Yt(i, t, r);
  const o = t.seen.get(e);
  o.ref = i;
}, oq = /* @__PURE__ */ oe("ZodISODateTime", (e, t) => {
  eK.init(e, t), Kt.init(e, t);
});
function aq(e) {
  return /* @__PURE__ */ lU(oq, e);
}
const sq = /* @__PURE__ */ oe("ZodISODate", (e, t) => {
  tK.init(e, t), Kt.init(e, t);
});
function lq(e) {
  return /* @__PURE__ */ uU(sq, e);
}
const uq = /* @__PURE__ */ oe("ZodISOTime", (e, t) => {
  nK.init(e, t), Kt.init(e, t);
});
function cq(e) {
  return /* @__PURE__ */ cU(uq, e);
}
const fq = /* @__PURE__ */ oe("ZodISODuration", (e, t) => {
  rK.init(e, t), Kt.init(e, t);
});
function dq(e) {
  return /* @__PURE__ */ fU(fq, e);
}
const pq = (e, t) => {
  MD.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => WV(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => HV(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, fg, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, fg, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Nr = oe("ZodError", pq, {
  Parent: Error
}), hq = /* @__PURE__ */ Gb(Nr), mq = /* @__PURE__ */ Yb(Nr), vq = /* @__PURE__ */ wp(Nr), gq = /* @__PURE__ */ xp(Nr), yq = /* @__PURE__ */ YV(Nr), bq = /* @__PURE__ */ QV(Nr), _q = /* @__PURE__ */ JV(Nr), wq = /* @__PURE__ */ XV(Nr), xq = /* @__PURE__ */ eB(Nr), Eq = /* @__PURE__ */ tB(Nr), Sq = /* @__PURE__ */ nB(Nr), $q = /* @__PURE__ */ rB(Nr), Ct = /* @__PURE__ */ oe("ZodType", (e, t) => (At.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: bd(e, "input"),
    output: bd(e, "output")
  }
}), e.toJSONSchema = MU(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(Fo(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, r) => zo(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => hq(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => vq(e, n, r), e.parseAsync = async (n, r) => mq(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => gq(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => yq(e, n, r), e.decode = (n, r) => bq(e, n, r), e.encodeAsync = async (n, r) => _q(e, n, r), e.decodeAsync = async (n, r) => wq(e, n, r), e.safeEncode = (n, r) => xq(e, n, r), e.safeDecode = (n, r) => Eq(e, n, r), e.safeEncodeAsync = async (n, r) => Sq(e, n, r), e.safeDecodeAsync = async (n, r) => $q(e, n, r), e.refine = (n, r) => e.check(wH(n, r)), e.superRefine = (n) => e.check(xH(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ fl(n)), e.optional = () => oE(e), e.exactOptional = () => sH(e), e.nullable = () => aE(e), e.nullish = () => oE(aE(e)), e.nonoptional = (n) => pH(e, n), e.array = () => Gn(e), e.or = (n) => za([e, n]), e.and = (n) => tH(e, n), e.transform = (n) => sE(e, oH(n)), e.default = (n) => cH(e, n), e.prefault = (n) => dH(e, n), e.catch = (n) => mH(e, n), e.pipe = (n) => sE(e, n), e.readonly = () => yH(e), e.describe = (n) => {
  const r = e.clone();
  return Yl.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = Yl.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return Yl.get(e);
  const r = e.clone();
  return Yl.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), e4 = /* @__PURE__ */ oe("_ZodString", (e, t) => {
  Qb.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (r, i, o) => NU(e, r, i);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(/* @__PURE__ */ bU(...r)), e.includes = (...r) => e.check(/* @__PURE__ */ xU(...r)), e.startsWith = (...r) => e.check(/* @__PURE__ */ EU(...r)), e.endsWith = (...r) => e.check(/* @__PURE__ */ SU(...r)), e.min = (...r) => e.check(/* @__PURE__ */ yd(...r)), e.max = (...r) => e.check(/* @__PURE__ */ ZD(...r)), e.length = (...r) => e.check(/* @__PURE__ */ GD(...r)), e.nonempty = (...r) => e.check(/* @__PURE__ */ yd(1, ...r)), e.lowercase = (r) => e.check(/* @__PURE__ */ _U(r)), e.uppercase = (r) => e.check(/* @__PURE__ */ wU(r)), e.trim = () => e.check(/* @__PURE__ */ TU()), e.normalize = (...r) => e.check(/* @__PURE__ */ $U(...r)), e.toLowerCase = () => e.check(/* @__PURE__ */ OU()), e.toUpperCase = () => e.check(/* @__PURE__ */ kU()), e.slugify = () => e.check(/* @__PURE__ */ PU());
}), Tq = /* @__PURE__ */ oe("ZodString", (e, t) => {
  Qb.init(e, t), e4.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ VK(Oq, n)), e.url = (n) => e.check(/* @__PURE__ */ HK(kq, n)), e.jwt = (n) => e.check(/* @__PURE__ */ sU(Kq, n)), e.emoji = (n) => e.check(/* @__PURE__ */ WK(Pq, n)), e.guid = (n) => e.check(/* @__PURE__ */ Xx(rE, n)), e.uuid = (n) => e.check(/* @__PURE__ */ BK(Wc, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ KK(Wc, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ UK(Wc, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ qK(Wc, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ ZK(Dq, n)), e.guid = (n) => e.check(/* @__PURE__ */ Xx(rE, n)), e.cuid = (n) => e.check(/* @__PURE__ */ GK(Aq, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ YK(Cq, n)), e.ulid = (n) => e.check(/* @__PURE__ */ QK(Iq, n)), e.base64 = (n) => e.check(/* @__PURE__ */ iU(Lq, n)), e.base64url = (n) => e.check(/* @__PURE__ */ oU(Vq, n)), e.xid = (n) => e.check(/* @__PURE__ */ JK(Mq, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ XK(Rq, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ eU(Nq, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ tU(jq, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ nU(Fq, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ rU(zq, n)), e.e164 = (n) => e.check(/* @__PURE__ */ aU(Bq, n)), e.datetime = (n) => e.check(aq(n)), e.date = (n) => e.check(lq(n)), e.time = (n) => e.check(cq(n)), e.duration = (n) => e.check(dq(n));
});
function Fe(e) {
  return /* @__PURE__ */ LK(Tq, e);
}
const Kt = /* @__PURE__ */ oe("ZodStringFormat", (e, t) => {
  jt.init(e, t), e4.init(e, t);
}), Oq = /* @__PURE__ */ oe("ZodEmail", (e, t) => {
  qB.init(e, t), Kt.init(e, t);
}), rE = /* @__PURE__ */ oe("ZodGUID", (e, t) => {
  KB.init(e, t), Kt.init(e, t);
}), Wc = /* @__PURE__ */ oe("ZodUUID", (e, t) => {
  UB.init(e, t), Kt.init(e, t);
}), kq = /* @__PURE__ */ oe("ZodURL", (e, t) => {
  HB.init(e, t), Kt.init(e, t);
}), Pq = /* @__PURE__ */ oe("ZodEmoji", (e, t) => {
  WB.init(e, t), Kt.init(e, t);
}), Dq = /* @__PURE__ */ oe("ZodNanoID", (e, t) => {
  ZB.init(e, t), Kt.init(e, t);
}), Aq = /* @__PURE__ */ oe("ZodCUID", (e, t) => {
  GB.init(e, t), Kt.init(e, t);
}), Cq = /* @__PURE__ */ oe("ZodCUID2", (e, t) => {
  YB.init(e, t), Kt.init(e, t);
}), Iq = /* @__PURE__ */ oe("ZodULID", (e, t) => {
  QB.init(e, t), Kt.init(e, t);
}), Mq = /* @__PURE__ */ oe("ZodXID", (e, t) => {
  JB.init(e, t), Kt.init(e, t);
}), Rq = /* @__PURE__ */ oe("ZodKSUID", (e, t) => {
  XB.init(e, t), Kt.init(e, t);
}), Nq = /* @__PURE__ */ oe("ZodIPv4", (e, t) => {
  iK.init(e, t), Kt.init(e, t);
}), jq = /* @__PURE__ */ oe("ZodIPv6", (e, t) => {
  oK.init(e, t), Kt.init(e, t);
}), Fq = /* @__PURE__ */ oe("ZodCIDRv4", (e, t) => {
  aK.init(e, t), Kt.init(e, t);
}), zq = /* @__PURE__ */ oe("ZodCIDRv6", (e, t) => {
  sK.init(e, t), Kt.init(e, t);
}), Lq = /* @__PURE__ */ oe("ZodBase64", (e, t) => {
  lK.init(e, t), Kt.init(e, t);
}), Vq = /* @__PURE__ */ oe("ZodBase64URL", (e, t) => {
  cK.init(e, t), Kt.init(e, t);
}), Bq = /* @__PURE__ */ oe("ZodE164", (e, t) => {
  fK.init(e, t), Kt.init(e, t);
}), Kq = /* @__PURE__ */ oe("ZodJWT", (e, t) => {
  pK.init(e, t), Kt.init(e, t);
}), Jb = /* @__PURE__ */ oe("ZodNumber", (e, t) => {
  UD.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (r, i, o) => jU(e, r, i), e.gt = (r, i) => e.check(/* @__PURE__ */ tE(r, i)), e.gte = (r, i) => e.check(/* @__PURE__ */ Of(r, i)), e.min = (r, i) => e.check(/* @__PURE__ */ Of(r, i)), e.lt = (r, i) => e.check(/* @__PURE__ */ eE(r, i)), e.lte = (r, i) => e.check(/* @__PURE__ */ Tf(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ Tf(r, i)), e.int = (r) => e.check(pg(r)), e.safe = (r) => e.check(pg(r)), e.positive = (r) => e.check(/* @__PURE__ */ tE(0, r)), e.nonnegative = (r) => e.check(/* @__PURE__ */ Of(0, r)), e.negative = (r) => e.check(/* @__PURE__ */ eE(0, r)), e.nonpositive = (r) => e.check(/* @__PURE__ */ Tf(0, r)), e.multipleOf = (r, i) => e.check(/* @__PURE__ */ nE(r, i)), e.step = (r, i) => e.check(/* @__PURE__ */ nE(r, i)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function ma(e) {
  return /* @__PURE__ */ dU(Jb, e);
}
const Uq = /* @__PURE__ */ oe("ZodNumberFormat", (e, t) => {
  hK.init(e, t), Jb.init(e, t);
});
function pg(e) {
  return /* @__PURE__ */ hU(Uq, e);
}
const qq = /* @__PURE__ */ oe("ZodBoolean", (e, t) => {
  mK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => FU(e, n, r);
});
function dn(e) {
  return /* @__PURE__ */ mU(qq, e);
}
const Hq = /* @__PURE__ */ oe("ZodUnknown", (e, t) => {
  vK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => LU();
});
function iE() {
  return /* @__PURE__ */ vU(Hq);
}
const Wq = /* @__PURE__ */ oe("ZodNever", (e, t) => {
  gK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => zU(e, n, r);
});
function Zq(e) {
  return /* @__PURE__ */ gU(Wq, e);
}
const Gq = /* @__PURE__ */ oe("ZodDate", (e, t) => {
  yK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (r, i, o) => VU(e, r), e.min = (r, i) => e.check(/* @__PURE__ */ Of(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ Tf(r, i));
  const n = e._zod.bag;
  e.minDate = n.minimum ? new Date(n.minimum) : null, e.maxDate = n.maximum ? new Date(n.maximum) : null;
});
function Yq(e) {
  return /* @__PURE__ */ yU(Gq, e);
}
const Qq = /* @__PURE__ */ oe("ZodArray", (e, t) => {
  bK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => HU(e, n, r, i), e.element = t.element, e.min = (n, r) => e.check(/* @__PURE__ */ yd(n, r)), e.nonempty = (n) => e.check(/* @__PURE__ */ yd(1, n)), e.max = (n, r) => e.check(/* @__PURE__ */ ZD(n, r)), e.length = (n, r) => e.check(/* @__PURE__ */ GD(n, r)), e.unwrap = () => e.element;
});
function Gn(e, t) {
  return /* @__PURE__ */ DU(Qq, e, t);
}
const Jq = /* @__PURE__ */ oe("ZodObject", (e, t) => {
  wK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => WU(e, n, r, i), tt(e, "shape", () => t.shape), e.keyof = () => t4(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: iE() }), e.loose = () => e.clone({ ...e._zod.def, catchall: iE() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Zq() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => VV(e, n), e.safeExtend = (n) => BV(e, n), e.merge = (n) => KV(e, n), e.pick = (n) => zV(e, n), e.omit = (n) => LV(e, n), e.partial = (...n) => UV(n4, e, n[0]), e.required = (...n) => qV(r4, e, n[0]);
});
function Je(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...Be(t)
  };
  return new Jq(n);
}
const Xq = /* @__PURE__ */ oe("ZodUnion", (e, t) => {
  xK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => ZU(e, n, r, i), e.options = t.options;
});
function za(e, t) {
  return new Xq({
    type: "union",
    options: e,
    ...Be(t)
  });
}
const eH = /* @__PURE__ */ oe("ZodIntersection", (e, t) => {
  EK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => GU(e, n, r, i);
});
function tH(e, t) {
  return new eH({
    type: "intersection",
    left: e,
    right: t
  });
}
const nH = /* @__PURE__ */ oe("ZodRecord", (e, t) => {
  SK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => YU(e, n, r, i), e.keyType = t.keyType, e.valueType = t.valueType;
});
function _d(e, t, n) {
  return new nH({
    type: "record",
    keyType: e,
    valueType: t,
    ...Be(n)
  });
}
const hg = /* @__PURE__ */ oe("ZodEnum", (e, t) => {
  $K.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (r, i, o) => BU(e, r, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const o = {};
    for (const a of r)
      if (n.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new hg({
      ...t,
      checks: [],
      ...Be(i),
      entries: o
    });
  }, e.exclude = (r, i) => {
    const o = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new hg({
      ...t,
      checks: [],
      ...Be(i),
      entries: o
    });
  };
});
function t4(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new hg({
    type: "enum",
    entries: n,
    ...Be(t)
  });
}
const rH = /* @__PURE__ */ oe("ZodLiteral", (e, t) => {
  TK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => KU(e, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function Yn(e, t) {
  return new rH({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...Be(t)
  });
}
const iH = /* @__PURE__ */ oe("ZodTransform", (e, t) => {
  OK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => qU(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new kD(e.constructor.name);
    n.addIssue = (o) => {
      if (typeof o == "string")
        n.issues.push(Cu(o, n.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = e), n.issues.push(Cu(a));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((o) => (n.value = o, n)) : (n.value = i, n);
  };
});
function oH(e) {
  return new iH({
    type: "transform",
    transform: e
  });
}
const n4 = /* @__PURE__ */ oe("ZodOptional", (e, t) => {
  WD.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => XD(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function oE(e) {
  return new n4({
    type: "optional",
    innerType: e
  });
}
const aH = /* @__PURE__ */ oe("ZodExactOptional", (e, t) => {
  kK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => XD(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function sH(e) {
  return new aH({
    type: "optional",
    innerType: e
  });
}
const lH = /* @__PURE__ */ oe("ZodNullable", (e, t) => {
  PK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => QU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function aE(e) {
  return new lH({
    type: "nullable",
    innerType: e
  });
}
const uH = /* @__PURE__ */ oe("ZodDefault", (e, t) => {
  DK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => XU(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function cH(e, t) {
  return new uH({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : CD(t);
    }
  });
}
const fH = /* @__PURE__ */ oe("ZodPrefault", (e, t) => {
  AK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => eq(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function dH(e, t) {
  return new fH({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : CD(t);
    }
  });
}
const r4 = /* @__PURE__ */ oe("ZodNonOptional", (e, t) => {
  CK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => JU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function pH(e, t) {
  return new r4({
    type: "nonoptional",
    innerType: e,
    ...Be(t)
  });
}
const hH = /* @__PURE__ */ oe("ZodCatch", (e, t) => {
  IK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => tq(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function mH(e, t) {
  return new hH({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const vH = /* @__PURE__ */ oe("ZodPipe", (e, t) => {
  MK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => nq(e, n, r, i), e.in = t.in, e.out = t.out;
});
function sE(e, t) {
  return new vH({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const gH = /* @__PURE__ */ oe("ZodReadonly", (e, t) => {
  RK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => rq(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function yH(e) {
  return new gH({
    type: "readonly",
    innerType: e
  });
}
const bH = /* @__PURE__ */ oe("ZodLazy", (e, t) => {
  NK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => iq(e, n, r, i), e.unwrap = () => e._zod.def.getter();
});
function Xb(e) {
  return new bH({
    type: "lazy",
    getter: e
  });
}
const _H = /* @__PURE__ */ oe("ZodCustom", (e, t) => {
  jK.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => UU(e, n);
});
function wH(e, t = {}) {
  return /* @__PURE__ */ AU(_H, e, t);
}
function xH(e) {
  return /* @__PURE__ */ CU(e);
}
function EH(e) {
  return /* @__PURE__ */ pU(Jb, e);
}
const SH = Je({
  _type: Yn("string"),
  _validation: Fe().optional(),
  _value: Fe().optional(),
  _optional: dn().optional()
}), $H = Je({
  _type: Yn("boolean"),
  _value: dn().optional(),
  _optional: dn().optional()
}), TH = Je({
  _type: Yn("selection"),
  _options: Gn(Fe()),
  _optional: dn().optional(),
  _value: Fe().optional()
}), i4 = Je({
  bucketId: ma(),
  isFolder: dn(),
  path: Fe()
}), OH = t4(Cn), xa = Xb(
  () => za([
    DH,
    kH,
    TH,
    SH,
    PH,
    $H
  ])
), kH = Je({
  _type: Yn("path"),
  _value: za([Gn(i4), Gn(Fe())]).optional(),
  // _value: z.array(s3PathSchema).optional(),
  _regexp: Fe().optional(),
  _optional: dn().optional(),
  _pathType: OH
}), PH = Xb(
  () => Je({
    _type: Yn("list"),
    _value: Gn(xa).optional(),
    _optional: dn().optional(),
    _schema: xa
  })
), DH = Xb(
  () => Je({
    _type: Yn("object"),
    _optional: dn().optional(),
    _fields: _d(Fe(), xa),
    _value: _d(Fe(), xa).optional(),
    _order: Gn(Fe()).optional()
  })
);
_d(
  EH(),
  xa
);
_d(
  Fe(),
  xa
);
const AH = Je({
  type: Yn("pattern"),
  pattern: Fe()
}), CH = Je({
  type: Yn("value"),
  value: za([Fe(), ma(), dn(), Gn(i4)])
}), IH = Je({
  type: Yn("code"),
  codeBase64: Fe()
}), MH = za([
  AH,
  CH,
  IH
]);
xa.and(
  Je({
    _actionData: MH.optional()
  })
);
const o4 = Je({
  permissions: Fe(),
  links: Fe(),
  owner: Fe(),
  group: Fe(),
  size: Fe(),
  month: Fe(),
  date: Fe(),
  yearOrTime: Fe(),
  name: Fe(),
  fullPath: Fe()
}), RH = Gn(o4);
Je({
  url: Fe()
});
Je({
  socketId: Fe(),
  hasSavedSession: dn().nullish()
});
Je({
  path: Fe()
});
Je({
  directory: Fe(),
  contents: RH
});
Je({
  syncPwd: dn()
});
Je({
  defaultDirectory: Fe(),
  termState: Fe().nullish()
});
Je({
  path: Fe()
});
Je({
  query: Fe()
});
Je({
  results: Gn(o4),
  date: Fe(),
  query: Fe()
});
Je({
  tinkerBoxId: ma(),
  rows: ma(),
  cols: ma(),
  syncPwd: dn().nullish()
});
Je({
  path: Fe()
});
Je({
  path: Fe()
});
Je({
  termState: Fe()
});
const NH = Je({
  name: Fe(),
  type: Yn("select"),
  options: Gn(Fe()),
  optional: dn().optional(),
  allowOther: dn().optional(),
  validate: Fe().optional(),
  question: Fe().optional()
}), jH = Je({
  name: Fe(),
  type: za([Yn("text"), Yn("textarea")]),
  optional: dn().optional(),
  validate: Fe().optional(),
  question: Fe().optional()
}), FH = Je({
  name: Fe(),
  type: Yn("email"),
  optional: dn().optional(),
  validate: Fe().optional(),
  question: Fe().optional()
}), zH = Je({
  name: Fe(),
  type: Yn("submit"),
  text: Fe().optional(),
  optional: dn().optional(),
  validate: Fe().optional(),
  question: Fe().optional()
});
Gn(
  Je({
    name: Fe(),
    value: Fe()
  })
);
za([
  NH,
  jH,
  FH,
  zH
]);
const LH = Je({
  id: ma(),
  name: Fe(),
  labId: ma(),
  status: Fe(),
  ipAddress: Fe().nullable(),
  lastLogin: Yq().nullable()
});
Je({
  tinkerboxes: Gn(LH)
});
const VH = Je({
  key: Fe(),
  name: Fe(),
  isFolder: dn(),
  bucket: Fe(),
  fullPath: Fe()
});
Je({
  contents: Gn(VH)
});
Je({
  buckets: Gn(
    Je({
      id: pg(),
      bucket: Fe(),
      region: Fe(),
      prefix: Fe().nullish()
    })
  )
});
var BH = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(t, n) {
    return "Cannot apply '" + t + "' to '" + n.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(t, n) {
    return "[mobx.array] Index out of bounds, " + t + " is larger than " + n;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(t) {
    return "Cannot initialize from classes that inherit from Map: " + t.constructor.name;
  },
  20: function(t) {
    return "Cannot initialize map from " + t;
  },
  21: function(t) {
    return "Cannot convert to map from '" + t + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(t) {
    return "Cannot obtain administration from " + t;
  },
  25: function(t, n) {
    return "the entry '" + t + "' does not exist in the observable map '" + n + "'";
  },
  26: "please specify a property",
  27: function(t, n) {
    return "no observable property '" + t.toString() + "' found on the observable object '" + n + "'";
  },
  28: function(t) {
    return "Cannot obtain atom from " + t;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(t, n) {
    return "Cycle detected in computation " + t + ": " + n;
  },
  33: function(t) {
    return "The setter of computed value '" + t + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(t) {
    return "[ComputedValue '" + t + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(t) {
    return "[mobx] `observableArray." + t + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + t + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, KH = process.env.NODE_ENV !== "production" ? BH : {};
function $e(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof e == "string" ? e : KH[e];
    throw typeof i == "function" && (i = i.apply(null, n)), new Error("[MobX] " + i);
  }
  throw new Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
var UH = {};
function Sp() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : UH;
}
var a4 = Object.assign, wd = Object.getOwnPropertyDescriptor, Ti = Object.defineProperty, $p = Object.prototype, xd = [];
Object.freeze(xd);
var s4 = {};
Object.freeze(s4);
var qH = typeof Proxy < "u", HH = /* @__PURE__ */ Object.toString();
function l4() {
  qH || $e(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function jl(e) {
  process.env.NODE_ENV !== "production" && me.verifyProxies && $e("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + e);
}
function ai() {
  return ++me.mobxGuid;
}
function e0(e) {
  var t = !1;
  return function() {
    if (!t)
      return t = !0, e.apply(this, arguments);
  };
}
var ms = function() {
};
function cn(e) {
  return typeof e == "function";
}
function Ea(e) {
  var t = typeof e;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function Tp(e) {
  return e !== null && typeof e == "object";
}
function sr(e) {
  if (!Tp(e))
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t == null)
    return !0;
  var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n.toString() === HH;
}
function u4(e) {
  var t = e?.constructor;
  return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function sc(e, t, n) {
  Ti(e, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: n
  });
}
function c4(e, t, n) {
  Ti(e, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: n
  });
}
function La(e, t) {
  var n = "isMobX" + e;
  return t.prototype[n] = !0, function(r) {
    return Tp(r) && r[n] === !0;
  };
}
function dl(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function WH(e) {
  var t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t), r = Object.getPrototypeOf(n);
  return r === null;
}
function Fi(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
var f4 = typeof Object.getOwnPropertySymbols < "u";
function ZH(e) {
  var t = Object.keys(e);
  if (!f4)
    return t;
  var n = Object.getOwnPropertySymbols(e);
  return n.length ? [].concat(t, n.filter(function(r) {
    return $p.propertyIsEnumerable.call(e, r);
  })) : t;
}
var zs = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : f4 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function mg(e) {
  return typeof e == "string" ? e : typeof e == "symbol" ? e.toString() : new String(e).toString();
}
function d4(e) {
  return e === null ? null : typeof e == "object" ? "" + e : e;
}
function Pr(e, t) {
  return $p.hasOwnProperty.call(e, t);
}
var GH = Object.getOwnPropertyDescriptors || function(t) {
  var n = {};
  return zs(t).forEach(function(r) {
    n[r] = wd(t, r);
  }), n;
};
function nr(e, t) {
  return !!(e & t);
}
function rr(e, t, n) {
  return n ? e |= t : e &= ~t, e;
}
function lE(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function YH(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, JH(r.key), r);
  }
}
function pl(e, t, n) {
  return t && YH(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function vs(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = XH(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zi() {
  return Zi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zi.apply(null, arguments);
}
function p4(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, vg(e, t);
}
function vg(e, t) {
  return vg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, vg(e, t);
}
function QH(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function JH(e) {
  var t = QH(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function XH(e, t) {
  if (e) {
    if (typeof e == "string") return lE(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? lE(e, t) : void 0;
  }
}
var Un = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function Oi(e) {
  function t(n, r) {
    if (uc(r))
      return e.decorate_20223_(n, r);
    lc(n, r, e);
  }
  return Object.assign(t, e);
}
function lc(e, t, n) {
  if (Pr(e, Un) || sc(e, Un, Zi({}, e[Un])), process.env.NODE_ENV !== "production" && Sd(n) && !Pr(e[Un], t)) {
    var r = e.constructor.name + ".prototype." + t.toString();
    $e("'" + r + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  eW(e, n, t), Sd(n) || (e[Un][t] = n);
}
function eW(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !Sd(t) && Pr(e[Un], n)) {
    var r = e.constructor.name + ".prototype." + n.toString(), i = e[Un][n].annotationType_, o = t.annotationType_;
    $e("Cannot apply '@" + o + "' to '" + r + "':" + (`
The field is already decorated with '@` + i + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function tW(e) {
  return Pr(e, Un) || sc(e, Un, Zi({}, e[Un])), e[Un];
}
function uc(e) {
  return typeof e == "object" && typeof e.kind == "string";
}
function Op(e, t) {
  process.env.NODE_ENV !== "production" && !t.includes(e.kind) && $e("The decorator applied to '" + String(e.name) + "' cannot be used on a " + e.kind + " element");
}
var Ue = /* @__PURE__ */ Symbol("mobx administration"), Lo = /* @__PURE__ */ (function() {
  function e(n) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Atom@" + ai() : "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = it.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = n;
  }
  var t = e.prototype;
  return t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.reportObserved = function() {
    return P4(this);
  }, t.reportChanged = function() {
    Sr(), D4(this), $r();
  }, t.toString = function() {
    return this.name_;
  }, pl(e, [{
    key: "isBeingObserved",
    get: function() {
      return nr(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return nr(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return nr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
Lo.isBeingObservedMask_ = 1;
Lo.isPendingUnobservationMask_ = 2;
Lo.diffValueMask_ = 4;
var t0 = /* @__PURE__ */ La("Atom", Lo);
function h4(e, t, n) {
  t === void 0 && (t = ms), n === void 0 && (n = ms);
  var r = new Lo(e);
  return t !== ms && mZ(r, t), n !== ms && N4(r, n), r;
}
function nW(e, t) {
  return G4(e, t);
}
function rW(e, t) {
  return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var Ed = {
  structural: nW,
  default: rW
};
function Sa(e, t, n) {
  return Ru(e) ? e : Array.isArray(e) ? un.array(e, {
    name: n
  }) : sr(e) ? un.object(e, void 0, {
    name: n
  }) : dl(e) ? un.map(e, {
    name: n
  }) : Fi(e) ? un.set(e, {
    name: n
  }) : typeof e == "function" && !Oa(e) && !Mu(e) ? u4(e) ? Ls(e) : Iu(n, e) : e;
}
function iW(e, t, n) {
  if (e == null || hl(e) || Mp(e) || Vo(e) || _i(e))
    return e;
  if (Array.isArray(e))
    return un.array(e, {
      name: n,
      deep: !1
    });
  if (sr(e))
    return un.object(e, void 0, {
      name: n,
      deep: !1
    });
  if (dl(e))
    return un.map(e, {
      name: n,
      deep: !1
    });
  if (Fi(e))
    return un.set(e, {
      name: n,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && $e("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function kp(e) {
  return e;
}
function oW(e, t) {
  return process.env.NODE_ENV !== "production" && Ru(e) && $e("observable.struct should not be used with observable values"), G4(e, t) ? t : e;
}
var aW = "override";
function Sd(e) {
  return e.annotationType_ === aW;
}
function cc(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: sW,
    extend_: lW,
    decorate_20223_: uW
  };
}
function sW(e, t, n, r) {
  var i;
  if ((i = this.options_) != null && i.bound)
    return this.extend_(e, t, n, !1) === null ? 0 : 1;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if (Oa(n.value))
    return 1;
  var o = m4(e, this, t, n, !1);
  return Ti(r, t, o), 2;
}
function lW(e, t, n, r) {
  var i = m4(e, this, t, n);
  return e.defineProperty_(t, i, r);
}
function uW(e, t) {
  process.env.NODE_ENV !== "production" && Op(t, ["method", "field"]);
  var n = t.kind, r = t.name, i = t.addInitializer, o = this, a = function(u) {
    var c, f, d, p;
    return $a((c = (f = o.options_) == null ? void 0 : f.name) != null ? c : r.toString(), u, (d = (p = o.options_) == null ? void 0 : p.autoAction) != null ? d : !1);
  };
  if (n == "field")
    return function(l) {
      var u, c = l;
      return Oa(c) || (c = a(c)), (u = o.options_) != null && u.bound && (c = c.bind(this), c.isMobxAction = !0), c;
    };
  if (n == "method") {
    var s;
    return Oa(e) || (e = a(e)), (s = this.options_) != null && s.bound && i(function() {
      var l = this, u = l[r].bind(l);
      u.isMobxAction = !0, l[r] = u;
    }), e;
  }
  $e("Cannot apply '" + o.annotationType_ + "' to '" + String(r) + "' (kind: " + n + "):" + (`
'` + o.annotationType_ + "' can only be used on properties with a function value."));
}
function cW(e, t, n, r) {
  var i = t.annotationType_, o = r.value;
  process.env.NODE_ENV !== "production" && !cn(o) && $e("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a function value."));
}
function m4(e, t, n, r, i) {
  var o, a, s, l, u, c, f;
  i === void 0 && (i = me.safeDescriptors), cW(e, t, n, r);
  var d = r.value;
  if ((o = t.options_) != null && o.bound) {
    var p;
    d = d.bind((p = e.proxy_) != null ? p : e.target_);
  }
  return {
    value: $a(
      (a = (s = t.options_) == null ? void 0 : s.name) != null ? a : n.toString(),
      d,
      (l = (u = t.options_) == null ? void 0 : u.autoAction) != null ? l : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (c = t.options_) != null && c.bound ? (f = e.proxy_) != null ? f : e.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: i ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !i
  };
}
function v4(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: fW,
    extend_: dW,
    decorate_20223_: pW
  };
}
function fW(e, t, n, r) {
  var i;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if ((i = this.options_) != null && i.bound && (!Pr(e.target_, t) || !Mu(e.target_[t])) && this.extend_(e, t, n, !1) === null)
    return 0;
  if (Mu(n.value))
    return 1;
  var o = g4(e, this, t, n, !1, !1);
  return Ti(r, t, o), 2;
}
function dW(e, t, n, r) {
  var i, o = g4(e, this, t, n, (i = this.options_) == null ? void 0 : i.bound);
  return e.defineProperty_(t, o, r);
}
function pW(e, t) {
  var n;
  process.env.NODE_ENV !== "production" && Op(t, ["method"]);
  var r = t.name, i = t.addInitializer;
  return Mu(e) || (e = Ls(e)), (n = this.options_) != null && n.bound && i(function() {
    var o = this, a = o[r].bind(o);
    a.isMobXFlow = !0, o[r] = a;
  }), e;
}
function hW(e, t, n, r) {
  var i = t.annotationType_, o = r.value;
  process.env.NODE_ENV !== "production" && !cn(o) && $e("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a generator function value."));
}
function g4(e, t, n, r, i, o) {
  o === void 0 && (o = me.safeDescriptors), hW(e, t, n, r);
  var a = r.value;
  if (Mu(a) || (a = Ls(a)), i) {
    var s;
    a = a.bind((s = e.proxy_) != null ? s : e.target_), a.isMobXFlow = !0;
  }
  return {
    value: a,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: o ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !o
  };
}
function n0(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: mW,
    extend_: vW,
    decorate_20223_: gW
  };
}
function mW(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function vW(e, t, n, r) {
  return yW(e, this, t, n), e.defineComputedProperty_(t, Zi({}, this.options_, {
    get: n.get,
    set: n.set
  }), r);
}
function gW(e, t) {
  process.env.NODE_ENV !== "production" && Op(t, ["getter"]);
  var n = this, r = t.name, i = t.addInitializer;
  return i(function() {
    var o = Ba(this)[Ue], a = Zi({}, n.options_, {
      get: e,
      context: this
    });
    a.name || (a.name = process.env.NODE_ENV !== "production" ? o.name_ + "." + r.toString() : "ObservableObject." + r.toString()), o.values_.set(r, new Cr(a));
  }), function() {
    return this[Ue].getObservablePropValue_(r);
  };
}
function yW(e, t, n, r) {
  var i = t.annotationType_, o = r.get;
  process.env.NODE_ENV !== "production" && !o && $e("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on getter(+setter) properties."));
}
function Pp(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: bW,
    extend_: _W,
    decorate_20223_: wW
  };
}
function bW(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function _W(e, t, n, r) {
  var i, o;
  return xW(e, this, t, n), e.defineObservableProperty_(t, n.value, (i = (o = this.options_) == null ? void 0 : o.enhancer) != null ? i : Sa, r);
}
function wW(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (t.kind === "field")
      throw $e("Please use `@observable accessor " + String(t.name) + "` instead of `@observable " + String(t.name) + "`");
    Op(t, ["accessor"]);
  }
  var n = this, r = t.kind, i = t.name, o = /* @__PURE__ */ new WeakSet();
  function a(s, l) {
    var u, c, f = Ba(s)[Ue], d = new va(l, (u = (c = n.options_) == null ? void 0 : c.enhancer) != null ? u : Sa, process.env.NODE_ENV !== "production" ? f.name_ + "." + i.toString() : "ObservableObject." + i.toString(), !1);
    f.values_.set(i, d), o.add(s);
  }
  if (r == "accessor")
    return {
      get: function() {
        return o.has(this) || a(this, e.get.call(this)), this[Ue].getObservablePropValue_(i);
      },
      set: function(l) {
        return o.has(this) || a(this, l), this[Ue].setObservablePropValue_(i, l);
      },
      init: function(l) {
        return o.has(this) || a(this, l), l;
      }
    };
}
function xW(e, t, n, r) {
  var i = t.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in r) && $e("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' cannot be used on getter/setter properties"));
}
var EW = "true", SW = /* @__PURE__ */ y4();
function y4(e) {
  return {
    annotationType_: EW,
    options_: e,
    make_: $W,
    extend_: TW,
    decorate_20223_: OW
  };
}
function $W(e, t, n, r) {
  var i, o;
  if (n.get)
    return Dp.make_(e, t, n, r);
  if (n.set) {
    var a = Oa(n.set) ? n.set : $a(t.toString(), n.set);
    return r === e.target_ ? e.defineProperty_(t, {
      configurable: me.safeDescriptors ? e.isPlainObject_ : !0,
      set: a
    }) === null ? 0 : 2 : (Ti(r, t, {
      configurable: !0,
      set: a
    }), 2);
  }
  if (r !== e.target_ && typeof n.value == "function") {
    var s;
    if (u4(n.value)) {
      var l, u = (l = this.options_) != null && l.autoBind ? Ls.bound : Ls;
      return u.make_(e, t, n, r);
    }
    var c = (s = this.options_) != null && s.autoBind ? Iu.bound : Iu;
    return c.make_(e, t, n, r);
  }
  var f = ((i = this.options_) == null ? void 0 : i.deep) === !1 ? un.ref : un;
  if (typeof n.value == "function" && (o = this.options_) != null && o.autoBind) {
    var d;
    n.value = n.value.bind((d = e.proxy_) != null ? d : e.target_);
  }
  return f.make_(e, t, n, r);
}
function TW(e, t, n, r) {
  var i, o;
  if (n.get)
    return Dp.extend_(e, t, n, r);
  if (n.set)
    return e.defineProperty_(t, {
      configurable: me.safeDescriptors ? e.isPlainObject_ : !0,
      set: $a(t.toString(), n.set)
    }, r);
  if (typeof n.value == "function" && (i = this.options_) != null && i.autoBind) {
    var a;
    n.value = n.value.bind((a = e.proxy_) != null ? a : e.target_);
  }
  var s = ((o = this.options_) == null ? void 0 : o.deep) === !1 ? un.ref : un;
  return s.extend_(e, t, n, r);
}
function OW(e, t) {
  $e("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var kW = "observable", PW = "observable.ref", DW = "observable.shallow", AW = "observable.struct", b4 = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(b4);
function Zc(e) {
  return e || b4;
}
var gg = /* @__PURE__ */ Pp(kW), CW = /* @__PURE__ */ Pp(PW, {
  enhancer: kp
}), IW = /* @__PURE__ */ Pp(DW, {
  enhancer: iW
}), MW = /* @__PURE__ */ Pp(AW, {
  enhancer: oW
}), _4 = /* @__PURE__ */ Oi(gg);
function Gc(e) {
  return e.deep === !0 ? Sa : e.deep === !1 ? kp : NW(e.defaultDecorator);
}
function RW(e) {
  var t;
  return e ? (t = e.defaultDecorator) != null ? t : y4(e) : void 0;
}
function NW(e) {
  var t, n;
  return e && (t = (n = e.options_) == null ? void 0 : n.enhancer) != null ? t : Sa;
}
function w4(e, t, n) {
  if (uc(t))
    return gg.decorate_20223_(e, t);
  if (Ea(t)) {
    lc(e, t, gg);
    return;
  }
  return Ru(e) ? e : sr(e) ? un.object(e, t, n) : Array.isArray(e) ? un.array(e, t) : dl(e) ? un.map(e, t) : Fi(e) ? un.set(e, t) : typeof e == "object" && e !== null ? e : un.box(e, t);
}
a4(w4, _4);
var jW = {
  box: function(t, n) {
    var r = Zc(n);
    return new va(t, Gc(r), r.name, !0, r.equals);
  },
  array: function(t, n) {
    var r = Zc(n);
    return (me.useProxies === !1 || r.proxy === !1 ? VZ : AZ)(t, Gc(r), r.name);
  },
  map: function(t, n) {
    var r = Zc(n);
    return new K4(t, Gc(r), r.name);
  },
  set: function(t, n) {
    var r = Zc(n);
    return new U4(t, Gc(r), r.name);
  },
  object: function(t, n, r) {
    return Bo(function() {
      return F4(me.useProxies === !1 || r?.proxy === !1 ? Ba({}, r) : TZ({}, r), t, n);
    });
  },
  ref: /* @__PURE__ */ Oi(CW),
  shallow: /* @__PURE__ */ Oi(IW),
  deep: _4,
  struct: /* @__PURE__ */ Oi(MW)
}, un = /* @__PURE__ */ a4(w4, jW), x4 = "computed", FW = "computed.struct", yg = /* @__PURE__ */ n0(x4), zW = /* @__PURE__ */ n0(FW, {
  equals: Ed.structural
}), Dp = function(t, n) {
  if (uc(n))
    return yg.decorate_20223_(t, n);
  if (Ea(n))
    return lc(t, n, yg);
  if (sr(t))
    return Oi(n0(x4, t));
  process.env.NODE_ENV !== "production" && (cn(t) || $e("First argument to `computed` should be an expression."), cn(n) && $e("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var r = sr(n) ? n : {};
  return r.get = t, r.name || (r.name = t.name || ""), new Cr(r);
};
Object.assign(Dp, yg);
Dp.struct = /* @__PURE__ */ Oi(zW);
var uE, cE, $d = 0, LW = 1, VW = (uE = (cE = /* @__PURE__ */ wd(function() {
}, "name")) == null ? void 0 : cE.configurable) != null ? uE : !1, fE = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function $a(e, t, n, r) {
  n === void 0 && (n = !1), process.env.NODE_ENV !== "production" && (cn(t) || $e("`action` can only be invoked on functions"), (typeof e != "string" || !e) && $e("actions should have valid names, got: '" + e + "'"));
  function i() {
    return BW(e, n, t, r || this, arguments);
  }
  return i.isMobxAction = !0, i.toString = function() {
    return t.toString();
  }, VW && (fE.value = e, Ti(i, "name", fE)), i;
}
function BW(e, t, n, r, i) {
  var o = KW(e, t, r, i);
  try {
    return n.apply(r, i);
  } catch (a) {
    throw o.error_ = a, a;
  } finally {
    UW(o);
  }
}
function KW(e, t, n, r) {
  var i = process.env.NODE_ENV !== "production" && yn() && !!e, o = 0;
  if (process.env.NODE_ENV !== "production" && i) {
    o = Date.now();
    var a = r ? Array.from(r) : xd;
    lr({
      type: i0,
      name: e,
      object: n,
      arguments: a
    });
  }
  var s = me.trackingDerivation, l = !t || !s;
  Sr();
  var u = me.allowStateChanges;
  l && (Va(), u = Ap(!0));
  var c = r0(!0), f = {
    runAsAction_: l,
    prevDerivation_: s,
    prevAllowStateChanges_: u,
    prevAllowStateReads_: c,
    notifySpy_: i,
    startTime_: o,
    actionId_: LW++,
    parentActionId_: $d
  };
  return $d = f.actionId_, f;
}
function UW(e) {
  $d !== e.actionId_ && $e(30), $d = e.parentActionId_, e.error_ !== void 0 && (me.suppressReactionErrors = !0), Cp(e.prevAllowStateChanges_), fu(e.prevAllowStateReads_), $r(), e.runAsAction_ && Bi(e.prevDerivation_), process.env.NODE_ENV !== "production" && e.notifySpy_ && ur({
    time: Date.now() - e.startTime_
  }), me.suppressReactionErrors = !1;
}
function qW(e, t) {
  var n = Ap(e);
  try {
    return t();
  } finally {
    Cp(n);
  }
}
function Ap(e) {
  var t = me.allowStateChanges;
  return me.allowStateChanges = e, t;
}
function Cp(e) {
  me.allowStateChanges = e;
}
var HW = "create", va = /* @__PURE__ */ (function(e) {
  function t(r, i, o, a, s) {
    var l;
    if (o === void 0 && (o = process.env.NODE_ENV !== "production" ? "ObservableValue@" + ai() : "ObservableValue"), a === void 0 && (a = !0), s === void 0 && (s = Ed.default), l = e.call(this, o) || this, l.enhancer = void 0, l.name_ = void 0, l.equals = void 0, l.hasUnreportedChange_ = !1, l.interceptors_ = void 0, l.changeListeners_ = void 0, l.value_ = void 0, l.dehancer = void 0, l.enhancer = i, l.name_ = o, l.equals = s, l.value_ = i(r, void 0, o), process.env.NODE_ENV !== "production" && a && yn()) {
      var u;
      Ta({
        type: HW,
        object: l,
        observableKind: "value",
        debugObjectName: l.name_,
        newValue: "" + ((u = l.value_) == null ? void 0 : u.toString())
      });
    }
    return l;
  }
  p4(t, e);
  var n = t.prototype;
  return n.dehanceValue = function(i) {
    return this.dehancer !== void 0 ? this.dehancer(i) : i;
  }, n.set = function(i) {
    var o = this.value_;
    if (i = this.prepareNewValue_(i), i !== me.UNCHANGED) {
      var a = yn();
      process.env.NODE_ENV !== "production" && a && lr({
        type: Qr,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: i,
        oldValue: o
      }), this.setNewValue_(i), process.env.NODE_ENV !== "production" && a && ur();
    }
  }, n.prepareNewValue_ = function(i) {
    if (Si(this), wr(this)) {
      var o = xr(this, {
        object: this,
        type: Qr,
        newValue: i
      });
      if (!o)
        return me.UNCHANGED;
      i = o.newValue;
    }
    return i = this.enhancer(i, this.value_, this.name_), this.equals(this.value_, i) ? me.UNCHANGED : i;
  }, n.setNewValue_ = function(i) {
    var o = this.value_;
    this.value_ = i, this.reportChanged(), Xr(this) && ei(this, {
      type: Qr,
      object: this,
      newValue: i,
      oldValue: o
    });
  }, n.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, n.intercept_ = function(i) {
    return fc(this, i);
  }, n.observe_ = function(i, o) {
    return o && i({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: Qr,
      newValue: this.value_,
      oldValue: void 0
    }), dc(this, i);
  }, n.raw = function() {
    return this.value_;
  }, n.toJSON = function() {
    return this.get();
  }, n.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, n.valueOf = function() {
    return d4(this.get());
  }, n[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, t;
})(Lo), Cr = /* @__PURE__ */ (function() {
  function e(n) {
    this.dependenciesState_ = it.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = it.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Td(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = Dr.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, n.get || $e(31), this.derivation = n.get, this.name_ = n.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + ai() : "ComputedValue"), n.set && (this.setter_ = $a(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", n.set)), this.equals_ = n.equals || (n.compareStructural || n.struct ? Ed.structural : Ed.default), this.scope_ = n.context, this.requiresReaction_ = n.requiresReaction, this.keepAlive_ = !!n.keepAlive;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    eZ(this);
  }, t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.get = function() {
    if (this.isComputing && $e(32, this.name_, this.derivation), me.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      bg(this) && (this.warnAboutUntrackedRead_(), Sr(), this.value_ = this.computeValue_(!1), $r());
    else if (P4(this), bg(this)) {
      var r = me.trackingContext;
      this.keepAlive_ && !r && (me.trackingContext = this), this.trackAndCompute() && XW(this), me.trackingContext = r;
    }
    var i = this.value_;
    if (kf(i))
      throw i.cause;
    return i;
  }, t.set = function(r) {
    if (this.setter_) {
      this.isRunningSetter && $e(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, r);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      $e(34, this.name_);
  }, t.trackAndCompute = function() {
    var r = this.value_, i = (
      /* see #1208 */
      this.dependenciesState_ === it.NOT_TRACKING_
    ), o = this.computeValue_(!0), a = i || kf(r) || kf(o) || !this.equals_(r, o);
    return a && (this.value_ = o, process.env.NODE_ENV !== "production" && yn() && Ta({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: r,
      newValue: o
    })), a;
  }, t.computeValue_ = function(r) {
    this.isComputing = !0;
    var i = Ap(!1), o;
    if (r)
      o = E4(this, this.derivation, this.scope_);
    else if (me.disableErrorBoundaries === !0)
      o = this.derivation.call(this.scope_);
    else
      try {
        o = this.derivation.call(this.scope_);
      } catch (a) {
        o = new Td(a);
      }
    return Cp(i), this.isComputing = !1, o;
  }, t.suspend_ = function() {
    this.keepAlive_ || (_g(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== Dr.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, t.observe_ = function(r, i) {
    var o = this, a = !0, s = void 0;
    return cZ(function() {
      var l = o.get();
      if (!a || i) {
        var u = Va();
        r({
          observableKind: "computed",
          debugObjectName: o.name_,
          type: Qr,
          object: o,
          newValue: l,
          oldValue: s
        }), Bi(u);
      }
      a = !1, s = l;
    });
  }, t.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== Dr.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : me.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, t.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, t.valueOf = function() {
    return d4(this.get());
  }, t[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, pl(e, [{
    key: "isComputing",
    get: function() {
      return nr(this.flags_, e.isComputingMask_);
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.isComputingMask_, r);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return nr(this.flags_, e.isRunningSetterMask_);
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.isRunningSetterMask_, r);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return nr(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return nr(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return nr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
Cr.isComputingMask_ = 1;
Cr.isRunningSetterMask_ = 2;
Cr.isBeingObservedMask_ = 4;
Cr.isPendingUnobservationMask_ = 8;
Cr.diffValueMask_ = 16;
var Ip = /* @__PURE__ */ La("ComputedValue", Cr), it;
(function(e) {
  e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
})(it || (it = {}));
var Dr;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
})(Dr || (Dr = {}));
var Td = function(t) {
  this.cause = void 0, this.cause = t;
};
function kf(e) {
  return e instanceof Td;
}
function bg(e) {
  switch (e.dependenciesState_) {
    case it.UP_TO_DATE_:
      return !1;
    case it.NOT_TRACKING_:
    case it.STALE_:
      return !0;
    case it.POSSIBLY_STALE_: {
      for (var t = r0(!0), n = Va(), r = e.observing_, i = r.length, o = 0; o < i; o++) {
        var a = r[o];
        if (Ip(a)) {
          if (me.disableErrorBoundaries)
            a.get();
          else
            try {
              a.get();
            } catch {
              return Bi(n), fu(t), !0;
            }
          if (e.dependenciesState_ === it.STALE_)
            return Bi(n), fu(t), !0;
        }
      }
      return $4(e), Bi(n), fu(t), !1;
    }
  }
}
function Si(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = e.observers_.size > 0;
    !me.allowStateChanges && (t || me.enforceActions === "always") && console.warn("[MobX] " + (me.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + e.name_);
  }
}
function WW(e) {
  process.env.NODE_ENV !== "production" && !me.allowStateReads && me.observableRequiresReaction && console.warn("[mobx] Observable '" + e.name_ + "' being read outside a reactive context.");
}
function E4(e, t, n) {
  var r = r0(!0);
  $4(e), e.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    e.runId_ === 0 ? 100 : e.observing_.length
  ), e.unboundDepsCount_ = 0, e.runId_ = ++me.runId;
  var i = me.trackingDerivation;
  me.trackingDerivation = e, me.inBatch++;
  var o;
  if (me.disableErrorBoundaries === !0)
    o = t.call(n);
  else
    try {
      o = t.call(n);
    } catch (a) {
      o = new Td(a);
    }
  return me.inBatch--, me.trackingDerivation = i, GW(e), ZW(e), fu(r), o;
}
function ZW(e) {
  process.env.NODE_ENV !== "production" && e.observing_.length === 0 && (typeof e.requiresObservable_ == "boolean" ? e.requiresObservable_ : me.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + e.name_ + "' is created/updated without reading any observable value.");
}
function GW(e) {
  for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = it.UP_TO_DATE_, i = 0, o = e.unboundDepsCount_, a = 0; a < o; a++) {
    var s = n[a];
    s.diffValue === 0 && (s.diffValue = 1, i !== a && (n[i] = s), i++), s.dependenciesState_ > r && (r = s.dependenciesState_);
  }
  for (n.length = i, e.newObserving_ = null, o = t.length; o--; ) {
    var l = t[o];
    l.diffValue === 0 && O4(l, e), l.diffValue = 0;
  }
  for (; i--; ) {
    var u = n[i];
    u.diffValue === 1 && (u.diffValue = 0, JW(u, e));
  }
  r !== it.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function _g(e) {
  var t = e.observing_;
  e.observing_ = [];
  for (var n = t.length; n--; )
    O4(t[n], e);
  e.dependenciesState_ = it.NOT_TRACKING_;
}
function S4(e) {
  var t = Va();
  try {
    return e();
  } finally {
    Bi(t);
  }
}
function Va() {
  var e = me.trackingDerivation;
  return me.trackingDerivation = null, e;
}
function Bi(e) {
  me.trackingDerivation = e;
}
function r0(e) {
  var t = me.allowStateReads;
  return me.allowStateReads = e, t;
}
function fu(e) {
  me.allowStateReads = e;
}
function $4(e) {
  if (e.dependenciesState_ !== it.UP_TO_DATE_) {
    e.dependenciesState_ = it.UP_TO_DATE_;
    for (var t = e.observing_, n = t.length; n--; )
      t[n].lowestObserverState_ = it.UP_TO_DATE_;
  }
}
var Pf = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, Df = !0, T4 = !1, me = /* @__PURE__ */ (function() {
  var e = /* @__PURE__ */ Sp();
  return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (Df = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new Pf().version && (Df = !1), Df ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /* @__PURE__ */ new Pf()) : (setTimeout(function() {
    T4 || $e(35);
  }, 1), new Pf());
})();
function YW() {
  if ((me.pendingReactions.length || me.inBatch || me.isRunningReactions) && $e(36), T4 = !0, Df) {
    var e = Sp();
    --e.__mobxInstanceCount === 0 && (e.__mobxGlobals = void 0), me = new Pf();
  }
}
function QW() {
  return me;
}
function JW(e, t) {
  e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function O4(e, t) {
  e.observers_.delete(t), e.observers_.size === 0 && k4(e);
}
function k4(e) {
  e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, me.pendingUnobservations.push(e));
}
function Sr() {
  me.inBatch++;
}
function $r() {
  if (--me.inBatch === 0) {
    I4();
    for (var e = me.pendingUnobservations, t = 0; t < e.length; t++) {
      var n = e[t];
      n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof Cr && n.suspend_());
    }
    me.pendingUnobservations = [];
  }
}
function P4(e) {
  WW(e);
  var t = me.trackingDerivation;
  return t !== null ? (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && me.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved) : (e.observers_.size === 0 && me.inBatch > 0 && k4(e), !1);
}
function D4(e) {
  e.lowestObserverState_ !== it.STALE_ && (e.lowestObserverState_ = it.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === it.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && t.isTracing_ !== Dr.NONE && A4(t, e), t.onBecomeStale_()), t.dependenciesState_ = it.STALE_;
  }));
}
function XW(e) {
  e.lowestObserverState_ !== it.STALE_ && (e.lowestObserverState_ = it.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === it.POSSIBLY_STALE_ ? (t.dependenciesState_ = it.STALE_, process.env.NODE_ENV !== "production" && t.isTracing_ !== Dr.NONE && A4(t, e)) : t.dependenciesState_ === it.UP_TO_DATE_ && (e.lowestObserverState_ = it.UP_TO_DATE_);
  }));
}
function eZ(e) {
  e.lowestObserverState_ === it.UP_TO_DATE_ && (e.lowestObserverState_ = it.POSSIBLY_STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === it.UP_TO_DATE_ && (t.dependenciesState_ = it.POSSIBLY_STALE_, t.onBecomeStale_());
  }));
}
function A4(e, t) {
  if (console.log("[mobx.trace] '" + e.name_ + "' is invalidated due to a change in: '" + t.name_ + "'"), e.isTracing_ === Dr.BREAK) {
    var n = [];
    C4(z4(e), n, 1), new Function(`debugger;
/*
Tracing '` + e.name_ + `'

You are entering this break point because derivation '` + e.name_ + "' is being traced and '" + t.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (e instanceof Cr ? e.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + n.join(`
`) + `
*/
    `)();
  }
}
function C4(e, t, n) {
  if (t.length >= 1e3) {
    t.push("(and many more)");
    return;
  }
  t.push("" + "	".repeat(n - 1) + e.name), e.dependencies && e.dependencies.forEach(function(r) {
    return C4(r, t, n + 1);
  });
}
var Pi = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Reaction@" + ai() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = it.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = Dr.NONE, this.name_ = n, this.onInvalidate_ = r, this.errorHandler_ = i, this.requiresObservable_ = o;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    this.schedule_();
  }, t.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, me.pendingReactions.push(this), I4());
  }, t.runReaction_ = function() {
    if (!this.isDisposed) {
      Sr(), this.isScheduled = !1;
      var r = me.trackingContext;
      if (me.trackingContext = this, bg(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending && yn() && Ta({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (i) {
          this.reportExceptionInDerivation_(i);
        }
      }
      me.trackingContext = r, $r();
    }
  }, t.track = function(r) {
    if (!this.isDisposed) {
      Sr();
      var i = yn(), o;
      process.env.NODE_ENV !== "production" && i && (o = Date.now(), lr({
        name: this.name_,
        type: "reaction"
      })), this.isRunning = !0;
      var a = me.trackingContext;
      me.trackingContext = this;
      var s = E4(this, r, void 0);
      me.trackingContext = a, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && _g(this), kf(s) && this.reportExceptionInDerivation_(s.cause), process.env.NODE_ENV !== "production" && i && ur({
        time: Date.now() - o
      }), $r();
    }
  }, t.reportExceptionInDerivation_ = function(r) {
    var i = this;
    if (this.errorHandler_) {
      this.errorHandler_(r, this);
      return;
    }
    if (me.disableErrorBoundaries)
      throw r;
    var o = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    me.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(o, r), process.env.NODE_ENV !== "production" && yn() && Ta({
      type: "error",
      name: this.name_,
      message: o,
      error: "" + r
    }), me.globalReactionErrorHandlers.forEach(function(a) {
      return a(r, i);
    });
  }, t.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || (Sr(), _g(this), $r()));
  }, t.getDisposer_ = function(r) {
    var i = this, o = function a() {
      i.dispose(), r == null || r.removeEventListener == null || r.removeEventListener("abort", a);
    };
    return r == null || r.addEventListener == null || r.addEventListener("abort", o), o[Ue] = this, "dispose" in Symbol && typeof Symbol.dispose == "symbol" && (o[Symbol.dispose] = o), o;
  }, t.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, t.trace = function(r) {
    r === void 0 && (r = !1), EZ(this, r);
  }, pl(e, [{
    key: "isDisposed",
    get: function() {
      return nr(this.flags_, e.isDisposedMask_);
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.isDisposedMask_, r);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return nr(this.flags_, e.isScheduledMask_);
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.isScheduledMask_, r);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return nr(this.flags_, e.isTrackPendingMask_);
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.isTrackPendingMask_, r);
    }
  }, {
    key: "isRunning",
    get: function() {
      return nr(this.flags_, e.isRunningMask_);
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.isRunningMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return nr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = rr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
Pi.isDisposedMask_ = 1;
Pi.isScheduledMask_ = 2;
Pi.isTrackPendingMask_ = 4;
Pi.isRunningMask_ = 8;
Pi.diffValueMask_ = 16;
var dE = 100, wg = function(t) {
  return t();
};
function I4() {
  me.inBatch > 0 || me.isRunningReactions || wg(tZ);
}
function tZ() {
  me.isRunningReactions = !0;
  for (var e = me.pendingReactions, t = 0; e.length > 0; ) {
    ++t === dE && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + dE + " iterations." + (" Probably there is a cycle in the reactive function: " + e[0]) : "[mobx] cycle in reaction: " + e[0]), e.splice(0));
    for (var n = e.splice(0), r = 0, i = n.length; r < i; r++)
      n[r].runReaction_();
  }
  me.isRunningReactions = !1;
}
var Od = /* @__PURE__ */ La("Reaction", Pi);
function nZ(e) {
  var t = wg;
  wg = function(r) {
    return e(function() {
      return t(r);
    });
  };
}
function yn() {
  return process.env.NODE_ENV !== "production" && !!me.spyListeners.length;
}
function Ta(e) {
  if (process.env.NODE_ENV !== "production" && me.spyListeners.length)
    for (var t = me.spyListeners, n = 0, r = t.length; n < r; n++)
      t[n](e);
}
function lr(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = Zi({}, e, {
      spyReportStart: !0
    });
    Ta(t);
  }
}
var rZ = {
  type: "report-end",
  spyReportEnd: !0
};
function ur(e) {
  process.env.NODE_ENV !== "production" && Ta(e ? Zi({}, e, {
    type: "report-end",
    spyReportEnd: !0
  }) : rZ);
}
function iZ(e) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (me.spyListeners.push(e), e0(function() {
    me.spyListeners = me.spyListeners.filter(function(t) {
      return t !== e;
    });
  }));
}
var i0 = "action", oZ = "action.bound", M4 = "autoAction", aZ = "autoAction.bound", sZ = "<unnamed action>", xg = /* @__PURE__ */ cc(i0), lZ = /* @__PURE__ */ cc(oZ, {
  bound: !0
}), Eg = /* @__PURE__ */ cc(M4, {
  autoAction: !0
}), uZ = /* @__PURE__ */ cc(aZ, {
  autoAction: !0,
  bound: !0
});
function R4(e) {
  var t = function(r, i) {
    if (cn(r))
      return $a(r.name || sZ, r, e);
    if (cn(i))
      return $a(r, i, e);
    if (uc(i))
      return (e ? Eg : xg).decorate_20223_(r, i);
    if (Ea(i))
      return lc(r, i, e ? Eg : xg);
    if (Ea(r))
      return Oi(cc(e ? M4 : i0, {
        name: r,
        autoAction: e
      }));
    process.env.NODE_ENV !== "production" && $e("Invalid arguments for `action`");
  };
  return t;
}
var gs = /* @__PURE__ */ R4(!1);
Object.assign(gs, xg);
var Iu = /* @__PURE__ */ R4(!0);
Object.assign(Iu, Eg);
gs.bound = /* @__PURE__ */ Oi(lZ);
Iu.bound = /* @__PURE__ */ Oi(uZ);
function Oa(e) {
  return cn(e) && e.isMobxAction === !0;
}
function cZ(e, t) {
  var n, r, i, o;
  t === void 0 && (t = s4), process.env.NODE_ENV !== "production" && (cn(e) || $e("Autorun expects a function as first argument"), Oa(e) && $e("Autorun does not accept actions since actions are untrackable"));
  var a = (n = (r = t) == null ? void 0 : r.name) != null ? n : process.env.NODE_ENV !== "production" ? e.name || "Autorun@" + ai() : "Autorun", s = !t.scheduler && !t.delay, l;
  if (s)
    l = new Pi(a, function() {
      this.track(f);
    }, t.onError, t.requiresObservable);
  else {
    var u = dZ(t), c = !1;
    l = new Pi(a, function() {
      c || (c = !0, u(function() {
        c = !1, l.isDisposed || l.track(f);
      }));
    }, t.onError, t.requiresObservable);
  }
  function f() {
    e(l);
  }
  return (i = t) != null && (i = i.signal) != null && i.aborted || l.schedule_(), l.getDisposer_((o = t) == null ? void 0 : o.signal);
}
var fZ = function(t) {
  return t();
};
function dZ(e) {
  return e.scheduler ? e.scheduler : e.delay ? function(t) {
    return setTimeout(t, e.delay);
  } : fZ;
}
var pZ = "onBO", hZ = "onBUO";
function mZ(e, t, n) {
  return j4(pZ, e, t, n);
}
function N4(e, t, n) {
  return j4(hZ, e, t, n);
}
function j4(e, t, n, r) {
  var i = Vs(t), o = cn(r) ? r : n, a = e + "L";
  return i[a] ? i[a].add(o) : i[a] = /* @__PURE__ */ new Set([o]), function() {
    var s = i[a];
    s && (s.delete(o), s.size === 0 && delete i[a]);
  };
}
var vZ = "never", Yc = "always", gZ = "observed";
function yZ(e) {
  e.isolateGlobalState === !0 && YW();
  var t = e.useProxies, n = e.enforceActions;
  if (t !== void 0 && (me.useProxies = t === Yc ? !0 : t === vZ ? !1 : typeof Proxy < "u"), t === "ifavailable" && (me.verifyProxies = !0), n !== void 0) {
    var r = n === Yc ? Yc : n === gZ;
    me.enforceActions = r, me.allowStateChanges = !(r === !0 || r === Yc);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(i) {
    i in e && (me[i] = !!e[i]);
  }), me.allowStateReads = !me.observableRequiresReaction, process.env.NODE_ENV !== "production" && me.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), e.reactionScheduler && nZ(e.reactionScheduler);
}
function F4(e, t, n, r) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && $e("'extendObservable' expected 2-4 arguments"), typeof e != "object" && $e("'extendObservable' expects an object as first argument"), Vo(e) && $e("'extendObservable' should not be used on maps, use map.merge instead"), sr(t) || $e("'extendObservable' only accepts plain objects as second argument"), (Ru(t) || Ru(n)) && $e("Extending an object with another observable (object) is not supported"));
  var i = GH(t);
  return Bo(function() {
    var o = Ba(e, r)[Ue];
    zs(i).forEach(function(a) {
      o.extend_(
        a,
        i[a],
        // must pass "undefined" for { key: undefined }
        n && a in n ? n[a] : !0
      );
    });
  }), e;
}
function z4(e, t) {
  return L4(Vs(e, t));
}
function L4(e) {
  var t = {
    name: e.name_
  };
  return e.observing_ && e.observing_.length > 0 && (t.dependencies = bZ(e.observing_).map(L4)), t;
}
function bZ(e) {
  return Array.from(new Set(e));
}
var _Z = 0;
function V4() {
  this.message = "FLOW_CANCELLED";
}
V4.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var am = /* @__PURE__ */ v4("flow"), wZ = /* @__PURE__ */ v4("flow.bound", {
  bound: !0
}), Ls = /* @__PURE__ */ Object.assign(function(t, n) {
  if (uc(n))
    return am.decorate_20223_(t, n);
  if (Ea(n))
    return lc(t, n, am);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && $e("Flow expects single argument with generator function");
  var r = t, i = r.name || "<unnamed flow>", o = function() {
    var s = this, l = arguments, u = ++_Z, c = gs(i + " - runid: " + u + " - init", r).apply(s, l), f, d = void 0, p = new Promise(function(h, m) {
      var v = 0;
      f = m;
      function g(x) {
        d = void 0;
        var S;
        try {
          S = gs(i + " - runid: " + u + " - yield " + v++, c.next).call(c, x);
        } catch ($) {
          return m($);
        }
        E(S);
      }
      function b(x) {
        d = void 0;
        var S;
        try {
          S = gs(i + " - runid: " + u + " - yield " + v++, c.throw).call(c, x);
        } catch ($) {
          return m($);
        }
        E(S);
      }
      function E(x) {
        if (cn(x?.then)) {
          x.then(E, m);
          return;
        }
        return x.done ? h(x.value) : (d = Promise.resolve(x.value), d.then(g, b));
      }
      g(void 0);
    });
    return p.cancel = gs(i + " - runid: " + u + " - cancel", function() {
      try {
        d && pE(d);
        var h = c.return(void 0), m = Promise.resolve(h.value);
        m.then(ms, ms), pE(m), f(new V4());
      } catch (v) {
        f(v);
      }
    }), p;
  };
  return o.isMobXFlow = !0, o;
}, am);
Ls.bound = /* @__PURE__ */ Oi(wZ);
function pE(e) {
  cn(e.cancel) && e.cancel();
}
function Mu(e) {
  return e?.isMobXFlow === !0;
}
function xZ(e, t) {
  return e ? hl(e) || !!e[Ue] || t0(e) || Od(e) || Ip(e) : !1;
}
function Ru(e) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && $e("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), xZ(e);
}
function EZ() {
  if (process.env.NODE_ENV !== "production") {
    for (var e = !1, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    typeof n[n.length - 1] == "boolean" && (e = n.pop());
    var i = SZ(n);
    if (!i)
      return $e("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    i.isTracing_ === Dr.NONE && console.log("[mobx.trace] '" + i.name_ + "' tracing enabled"), i.isTracing_ = e ? Dr.BREAK : Dr.LOG;
  }
}
function SZ(e) {
  switch (e.length) {
    case 0:
      return me.trackingDerivation;
    case 1:
      return Vs(e[0]);
    case 2:
      return Vs(e[0], e[1]);
  }
}
function zi(e, t) {
  t === void 0 && (t = void 0), Sr();
  try {
    return e.apply(t);
  } finally {
    $r();
  }
}
function Qo(e) {
  return e[Ue];
}
var $Z = {
  has: function(t, n) {
    return process.env.NODE_ENV !== "production" && me.trackingDerivation && jl("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), Qo(t).has_(n);
  },
  get: function(t, n) {
    return Qo(t).get_(n);
  },
  set: function(t, n, r) {
    var i;
    return Ea(n) ? (process.env.NODE_ENV !== "production" && !Qo(t).values_.has(n) && jl("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (i = Qo(t).set_(n, r, !0)) != null ? i : !0) : !1;
  },
  deleteProperty: function(t, n) {
    var r;
    return process.env.NODE_ENV !== "production" && jl("delete properties from an observable object. Use 'remove' from 'mobx' instead."), Ea(n) ? (r = Qo(t).delete_(n, !0)) != null ? r : !0 : !1;
  },
  defineProperty: function(t, n, r) {
    var i;
    return process.env.NODE_ENV !== "production" && jl("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (i = Qo(t).defineProperty_(n, r)) != null ? i : !0;
  },
  ownKeys: function(t) {
    return process.env.NODE_ENV !== "production" && me.trackingDerivation && jl("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), Qo(t).ownKeys_();
  },
  preventExtensions: function(t) {
    $e(13);
  }
};
function TZ(e, t) {
  var n, r;
  return l4(), e = Ba(e, t), (r = (n = e[Ue]).proxy_) != null ? r : n.proxy_ = new Proxy(e, $Z);
}
function wr(e) {
  return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function fc(e, t) {
  var n = e.interceptors_ || (e.interceptors_ = []);
  return n.push(t), e0(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function xr(e, t) {
  var n = Va();
  try {
    for (var r = [].concat(e.interceptors_ || []), i = 0, o = r.length; i < o && (t = r[i](t), t && !t.type && $e(14), !!t); i++)
      ;
    return t;
  } finally {
    Bi(n);
  }
}
function Xr(e) {
  return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function dc(e, t) {
  var n = e.changeListeners_ || (e.changeListeners_ = []);
  return n.push(t), e0(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function ei(e, t) {
  var n = Va(), r = e.changeListeners_;
  if (r) {
    r = r.slice();
    for (var i = 0, o = r.length; i < o; i++)
      r[i](t);
    Bi(n);
  }
}
function OZ(e, t, n) {
  return Bo(function() {
    var r, i = Ba(e, n)[Ue];
    process.env.NODE_ENV !== "production" && t && e[Un] && $e("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (r = t) != null || (t = tW(e)), zs(t).forEach(function(o) {
      return i.make_(o, t[o]);
    });
  }), e;
}
var sm = /* @__PURE__ */ Symbol("mobx-keys");
function kZ(e, t, n) {
  return process.env.NODE_ENV !== "production" && (!sr(e) && !sr(Object.getPrototypeOf(e)) && $e("'makeAutoObservable' can only be used for classes that don't have a superclass"), hl(e) && $e("makeAutoObservable can only be used on objects not already made observable")), sr(e) ? F4(e, e, t, n) : (Bo(function() {
    var r = Ba(e, n)[Ue];
    if (!e[sm]) {
      var i = Object.getPrototypeOf(e), o = new Set([].concat(zs(e), zs(i)));
      o.delete("constructor"), o.delete(Ue), sc(i, sm, o);
    }
    e[sm].forEach(function(a) {
      return r.make_(
        a,
        // must pass "undefined" for { key: undefined }
        t && a in t ? t[a] : !0
      );
    });
  }), e);
}
var hE = "splice", Qr = "update", PZ = 1e4, DZ = {
  get: function(t, n) {
    var r = t[Ue];
    return n === Ue ? r : n === "length" ? r.getArrayLength_() : typeof n == "string" && !isNaN(n) ? r.get_(parseInt(n)) : Pr(kd, n) ? kd[n] : t[n];
  },
  set: function(t, n, r) {
    var i = t[Ue];
    return n === "length" && i.setArrayLength_(r), typeof n == "symbol" || isNaN(n) ? t[n] = r : i.set_(parseInt(n), r), !0;
  },
  preventExtensions: function() {
    $e(15);
  }
}, o0 = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ai() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = o, this.atom_ = new Lo(n), this.enhancer_ = function(a, s) {
      return r(a, s, process.env.NODE_ENV !== "production" ? n + "[..]" : "ObservableArray[..]");
    };
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.dehanceValues_ = function(r) {
    return this.dehancer !== void 0 && r.length > 0 ? r.map(this.dehancer) : r;
  }, t.intercept_ = function(r) {
    return fc(this, r);
  }, t.observe_ = function(r, i) {
    return i === void 0 && (i = !1), i && r({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), dc(this, r);
  }, t.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, t.setArrayLength_ = function(r) {
    (typeof r != "number" || isNaN(r) || r < 0) && $e("Out of range: " + r);
    var i = this.values_.length;
    if (r !== i)
      if (r > i) {
        for (var o = new Array(r - i), a = 0; a < r - i; a++)
          o[a] = void 0;
        this.spliceWithArray_(i, 0, o);
      } else
        this.spliceWithArray_(r, i - r);
  }, t.updateArrayLength_ = function(r, i) {
    r !== this.lastKnownLength_ && $e(16), this.lastKnownLength_ += i, this.legacyMode_ && i > 0 && W4(r + i + 1);
  }, t.spliceWithArray_ = function(r, i, o) {
    var a = this;
    Si(this.atom_);
    var s = this.values_.length;
    if (r === void 0 ? r = 0 : r > s ? r = s : r < 0 && (r = Math.max(0, s + r)), arguments.length === 1 ? i = s - r : i == null ? i = 0 : i = Math.max(0, Math.min(i, s - r)), o === void 0 && (o = xd), wr(this)) {
      var l = xr(this, {
        object: this.proxy_,
        type: hE,
        index: r,
        removedCount: i,
        added: o
      });
      if (!l)
        return xd;
      i = l.removedCount, o = l.added;
    }
    if (o = o.length === 0 ? o : o.map(function(f) {
      return a.enhancer_(f, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var u = o.length - i;
      this.updateArrayLength_(s, u);
    }
    var c = this.spliceItemsIntoValues_(r, i, o);
    return (i !== 0 || o.length !== 0) && this.notifyArraySplice_(r, o, c), this.dehanceValues_(c);
  }, t.spliceItemsIntoValues_ = function(r, i, o) {
    if (o.length < PZ) {
      var a;
      return (a = this.values_).splice.apply(a, [r, i].concat(o));
    } else {
      var s = this.values_.slice(r, r + i), l = this.values_.slice(r + i);
      this.values_.length += o.length - i;
      for (var u = 0; u < o.length; u++)
        this.values_[r + u] = o[u];
      for (var c = 0; c < l.length; c++)
        this.values_[r + o.length + c] = l[c];
      return s;
    }
  }, t.notifyArrayChildUpdate_ = function(r, i, o) {
    var a = !this.owned_ && yn(), s = Xr(this), l = s || a ? {
      observableKind: "array",
      object: this.proxy_,
      type: Qr,
      debugObjectName: this.atom_.name_,
      index: r,
      newValue: i,
      oldValue: o
    } : null;
    process.env.NODE_ENV !== "production" && a && lr(l), this.atom_.reportChanged(), s && ei(this, l), process.env.NODE_ENV !== "production" && a && ur();
  }, t.notifyArraySplice_ = function(r, i, o) {
    var a = !this.owned_ && yn(), s = Xr(this), l = s || a ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: hE,
      index: r,
      removed: o,
      added: i,
      removedCount: o.length,
      addedCount: i.length
    } : null;
    process.env.NODE_ENV !== "production" && a && lr(l), this.atom_.reportChanged(), s && ei(this, l), process.env.NODE_ENV !== "production" && a && ur();
  }, t.get_ = function(r) {
    if (this.legacyMode_ && r >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + r + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + r);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[r]);
  }, t.set_ = function(r, i) {
    var o = this.values_;
    if (this.legacyMode_ && r > o.length && $e(17, r, o.length), r < o.length) {
      Si(this.atom_);
      var a = o[r];
      if (wr(this)) {
        var s = xr(this, {
          type: Qr,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: r,
          newValue: i
        });
        if (!s)
          return;
        i = s.newValue;
      }
      i = this.enhancer_(i, a);
      var l = i !== a;
      l && (o[r] = i, this.notifyArrayChildUpdate_(r, i, a));
    } else {
      for (var u = new Array(r + 1 - o.length), c = 0; c < u.length - 1; c++)
        u[c] = void 0;
      u[u.length - 1] = i, this.spliceWithArray_(o.length, 0, u);
    }
  }, e;
})();
function AZ(e, t, n, r) {
  return n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ai() : "ObservableArray"), r === void 0 && (r = !1), l4(), Bo(function() {
    var i = new o0(n, t, r, !1);
    c4(i.values_, Ue, i);
    var o = new Proxy(i.values_, DZ);
    return i.proxy_ = o, e && e.length && i.spliceWithArray_(0, 0, e), o;
  });
}
var kd = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var n = this[Ue];
    return n.spliceWithArray_(0, n.values_.length, t);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(t, n) {
    for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
      i[o - 2] = arguments[o];
    var a = this[Ue];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return a.spliceWithArray_(t);
      case 2:
        return a.spliceWithArray_(t, n);
    }
    return a.spliceWithArray_(t, n, i);
  },
  spliceWithArray: function(t, n, r) {
    return this[Ue].spliceWithArray_(t, n, r);
  },
  push: function() {
    for (var t = this[Ue], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.spliceWithArray_(t.values_.length, 0, r), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[Ue].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[Ue], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.spliceWithArray_(0, 0, r), t.values_.length;
  },
  reverse: function() {
    return me.trackingDerivation && $e(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    me.trackingDerivation && $e(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var n = this[Ue], r = n.dehanceValues_(n.values_).indexOf(t);
    return r > -1 ? (this.splice(r, 1), !0) : !1;
  }
};
St("at", hr);
St("concat", hr);
St("flat", hr);
St("includes", hr);
St("indexOf", hr);
St("join", hr);
St("lastIndexOf", hr);
St("slice", hr);
St("toString", hr);
St("toLocaleString", hr);
St("toSorted", hr);
St("toSpliced", hr);
St("with", hr);
St("every", si);
St("filter", si);
St("find", si);
St("findIndex", si);
St("findLast", si);
St("findLastIndex", si);
St("flatMap", si);
St("forEach", si);
St("map", si);
St("some", si);
St("toReversed", si);
St("reduce", B4);
St("reduceRight", B4);
function St(e, t) {
  typeof Array.prototype[e] == "function" && (kd[e] = t(e));
}
function hr(e) {
  return function() {
    var t = this[Ue];
    t.atom_.reportObserved();
    var n = t.dehanceValues_(t.values_);
    return n[e].apply(n, arguments);
  };
}
function si(e) {
  return function(t, n) {
    var r = this, i = this[Ue];
    i.atom_.reportObserved();
    var o = i.dehanceValues_(i.values_);
    return o[e](function(a, s) {
      return t.call(n, a, s, r);
    });
  };
}
function B4(e) {
  return function() {
    var t = this, n = this[Ue];
    n.atom_.reportObserved();
    var r = n.dehanceValues_(n.values_), i = arguments[0];
    return arguments[0] = function(o, a, s) {
      return i(o, a, s, t);
    }, r[e].apply(r, arguments);
  };
}
var CZ = /* @__PURE__ */ La("ObservableArrayAdministration", o0);
function Mp(e) {
  return Tp(e) && CZ(e[Ue]);
}
var IZ = {}, yo = "add", Pd = "delete", K4 = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    var o = this;
    r === void 0 && (r = Sa), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableMap@" + ai() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[Ue] = IZ, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = r, this.name_ = i, cn(Map) || $e(18), Bo(function() {
      o.keysAtom_ = h4(process.env.NODE_ENV !== "production" ? o.name_ + ".keys()" : "ObservableMap.keys()"), o.data_ = /* @__PURE__ */ new Map(), o.hasMap_ = /* @__PURE__ */ new Map(), n && o.merge(n);
    });
  }
  var t = e.prototype;
  return t.has_ = function(r) {
    return this.data_.has(r);
  }, t.has = function(r) {
    var i = this;
    if (!me.trackingDerivation)
      return this.has_(r);
    var o = this.hasMap_.get(r);
    if (!o) {
      var a = o = new va(this.has_(r), kp, process.env.NODE_ENV !== "production" ? this.name_ + "." + mg(r) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(r, a), N4(a, function() {
        return i.hasMap_.delete(r);
      });
    }
    return o.get();
  }, t.set = function(r, i) {
    var o = this.has_(r);
    if (wr(this)) {
      var a = xr(this, {
        type: o ? Qr : yo,
        object: this,
        newValue: i,
        name: r
      });
      if (!a)
        return this;
      i = a.newValue;
    }
    return o ? this.updateValue_(r, i) : this.addValue_(r, i), this;
  }, t.delete = function(r) {
    var i = this;
    if (Si(this.keysAtom_), wr(this)) {
      var o = xr(this, {
        type: Pd,
        object: this,
        name: r
      });
      if (!o)
        return !1;
    }
    if (this.has_(r)) {
      var a = yn(), s = Xr(this), l = s || a ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Pd,
        object: this,
        oldValue: this.data_.get(r).value_,
        name: r
      } : null;
      return process.env.NODE_ENV !== "production" && a && lr(l), zi(function() {
        var u;
        i.keysAtom_.reportChanged(), (u = i.hasMap_.get(r)) == null || u.setNewValue_(!1);
        var c = i.data_.get(r);
        c.setNewValue_(void 0), i.data_.delete(r);
      }), s && ei(this, l), process.env.NODE_ENV !== "production" && a && ur(), !0;
    }
    return !1;
  }, t.updateValue_ = function(r, i) {
    var o = this.data_.get(r);
    if (i = o.prepareNewValue_(i), i !== me.UNCHANGED) {
      var a = yn(), s = Xr(this), l = s || a ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Qr,
        object: this,
        oldValue: o.value_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && a && lr(l), o.setNewValue_(i), s && ei(this, l), process.env.NODE_ENV !== "production" && a && ur();
    }
  }, t.addValue_ = function(r, i) {
    var o = this;
    Si(this.keysAtom_), zi(function() {
      var u, c = new va(i, o.enhancer_, process.env.NODE_ENV !== "production" ? o.name_ + "." + mg(r) : "ObservableMap.key", !1);
      o.data_.set(r, c), i = c.value_, (u = o.hasMap_.get(r)) == null || u.setNewValue_(!0), o.keysAtom_.reportChanged();
    });
    var a = yn(), s = Xr(this), l = s || a ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: yo,
      object: this,
      name: r,
      newValue: i
    } : null;
    process.env.NODE_ENV !== "production" && a && lr(l), s && ei(this, l), process.env.NODE_ENV !== "production" && a && ur();
  }, t.get = function(r) {
    return this.has(r) ? this.dehanceValue_(this.data_.get(r).get()) : this.dehanceValue_(void 0);
  }, t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, t.values = function() {
    var r = this, i = this.keys();
    return mE({
      next: function() {
        var a = i.next(), s = a.done, l = a.value;
        return {
          done: s,
          value: s ? void 0 : r.get(l)
        };
      }
    });
  }, t.entries = function() {
    var r = this, i = this.keys();
    return mE({
      next: function() {
        var a = i.next(), s = a.done, l = a.value;
        return {
          done: s,
          value: s ? void 0 : [l, r.get(l)]
        };
      }
    });
  }, t[Symbol.iterator] = function() {
    return this.entries();
  }, t.forEach = function(r, i) {
    for (var o = vs(this), a; !(a = o()).done; ) {
      var s = a.value, l = s[0], u = s[1];
      r.call(i, u, l, this);
    }
  }, t.merge = function(r) {
    var i = this;
    return Vo(r) && (r = new Map(r)), zi(function() {
      sr(r) ? ZH(r).forEach(function(o) {
        return i.set(o, r[o]);
      }) : Array.isArray(r) ? r.forEach(function(o) {
        var a = o[0], s = o[1];
        return i.set(a, s);
      }) : dl(r) ? (WH(r) || $e(19, r), r.forEach(function(o, a) {
        return i.set(a, o);
      })) : r != null && $e(20, r);
    }), this;
  }, t.clear = function() {
    var r = this;
    zi(function() {
      S4(function() {
        for (var i = vs(r.keys()), o; !(o = i()).done; ) {
          var a = o.value;
          r.delete(a);
        }
      });
    });
  }, t.replace = function(r) {
    var i = this;
    return zi(function() {
      for (var o = MZ(r), a = /* @__PURE__ */ new Map(), s = !1, l = vs(i.data_.keys()), u; !(u = l()).done; ) {
        var c = u.value;
        if (!o.has(c)) {
          var f = i.delete(c);
          if (f)
            s = !0;
          else {
            var d = i.data_.get(c);
            a.set(c, d);
          }
        }
      }
      for (var p = vs(o.entries()), h; !(h = p()).done; ) {
        var m = h.value, v = m[0], g = m[1], b = i.data_.has(v);
        if (i.set(v, g), i.data_.has(v)) {
          var E = i.data_.get(v);
          a.set(v, E), b || (s = !0);
        }
      }
      if (!s)
        if (i.data_.size !== a.size)
          i.keysAtom_.reportChanged();
        else
          for (var x = i.data_.keys(), S = a.keys(), $ = x.next(), P = S.next(); !$.done; ) {
            if ($.value !== P.value) {
              i.keysAtom_.reportChanged();
              break;
            }
            $ = x.next(), P = S.next();
          }
      i.data_ = a;
    }), this;
  }, t.toString = function() {
    return "[object ObservableMap]";
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && $e("`observe` doesn't support fireImmediately=true in combination with maps."), dc(this, r);
  }, t.intercept_ = function(r) {
    return fc(this, r);
  }, pl(e, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
})(), Vo = /* @__PURE__ */ La("ObservableMap", K4);
function mE(e) {
  return e[Symbol.toStringTag] = "MapIterator", s0(e);
}
function MZ(e) {
  if (dl(e) || Vo(e))
    return e;
  if (Array.isArray(e))
    return new Map(e);
  if (sr(e)) {
    var t = /* @__PURE__ */ new Map();
    for (var n in e)
      t.set(n, e[n]);
    return t;
  } else
    return $e(21, e);
}
var RZ = {}, U4 = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    var o = this;
    r === void 0 && (r = Sa), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableSet@" + ai() : "ObservableSet"), this.name_ = void 0, this[Ue] = RZ, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, cn(Set) || $e(22), this.enhancer_ = function(a, s) {
      return r(a, s, i);
    }, Bo(function() {
      o.atom_ = h4(o.name_), n && o.replace(n);
    });
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.clear = function() {
    var r = this;
    zi(function() {
      S4(function() {
        for (var i = vs(r.data_.values()), o; !(o = i()).done; ) {
          var a = o.value;
          r.delete(a);
        }
      });
    });
  }, t.forEach = function(r, i) {
    for (var o = vs(this), a; !(a = o()).done; ) {
      var s = a.value;
      r.call(i, s, s, this);
    }
  }, t.add = function(r) {
    var i = this;
    if (Si(this.atom_), wr(this)) {
      var o = xr(this, {
        type: yo,
        object: this,
        newValue: r
      });
      if (!o)
        return this;
      r = o.newValue;
    }
    if (!this.has(r)) {
      zi(function() {
        i.data_.add(i.enhancer_(r, void 0)), i.atom_.reportChanged();
      });
      var a = process.env.NODE_ENV !== "production" && yn(), s = Xr(this), l = s || a ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: yo,
        object: this,
        newValue: r
      } : null;
      a && process.env.NODE_ENV !== "production" && lr(l), s && ei(this, l), a && process.env.NODE_ENV !== "production" && ur();
    }
    return this;
  }, t.delete = function(r) {
    var i = this;
    if (wr(this)) {
      var o = xr(this, {
        type: Pd,
        object: this,
        oldValue: r
      });
      if (!o)
        return !1;
    }
    if (this.has(r)) {
      var a = process.env.NODE_ENV !== "production" && yn(), s = Xr(this), l = s || a ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Pd,
        object: this,
        oldValue: r
      } : null;
      return a && process.env.NODE_ENV !== "production" && lr(l), zi(function() {
        i.atom_.reportChanged(), i.data_.delete(r);
      }), s && ei(this, l), a && process.env.NODE_ENV !== "production" && ur(), !0;
    }
    return !1;
  }, t.has = function(r) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(r));
  }, t.entries = function() {
    var r = this.values();
    return vE({
      next: function() {
        var o = r.next(), a = o.value, s = o.done;
        return s ? {
          value: void 0,
          done: s
        } : {
          value: [a, a],
          done: s
        };
      }
    });
  }, t.keys = function() {
    return this.values();
  }, t.values = function() {
    this.atom_.reportObserved();
    var r = this, i = this.data_.values();
    return vE({
      next: function() {
        var a = i.next(), s = a.value, l = a.done;
        return l ? {
          value: void 0,
          done: l
        } : {
          value: r.dehanceValue_(s),
          done: l
        };
      }
    });
  }, t.intersection = function(r) {
    if (Fi(r) && !_i(r))
      return r.intersection(this);
    var i = new Set(this);
    return i.intersection(r);
  }, t.union = function(r) {
    if (Fi(r) && !_i(r))
      return r.union(this);
    var i = new Set(this);
    return i.union(r);
  }, t.difference = function(r) {
    return new Set(this).difference(r);
  }, t.symmetricDifference = function(r) {
    if (Fi(r) && !_i(r))
      return r.symmetricDifference(this);
    var i = new Set(this);
    return i.symmetricDifference(r);
  }, t.isSubsetOf = function(r) {
    return new Set(this).isSubsetOf(r);
  }, t.isSupersetOf = function(r) {
    return new Set(this).isSupersetOf(r);
  }, t.isDisjointFrom = function(r) {
    if (Fi(r) && !_i(r))
      return r.isDisjointFrom(this);
    var i = new Set(this);
    return i.isDisjointFrom(r);
  }, t.replace = function(r) {
    var i = this;
    return _i(r) && (r = new Set(r)), zi(function() {
      Array.isArray(r) ? (i.clear(), r.forEach(function(o) {
        return i.add(o);
      })) : Fi(r) ? (i.clear(), r.forEach(function(o) {
        return i.add(o);
      })) : r != null && $e("Cannot initialize set from " + r);
    }), this;
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && $e("`observe` doesn't support fireImmediately=true in combination with sets."), dc(this, r);
  }, t.intercept_ = function(r) {
    return fc(this, r);
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.toString = function() {
    return "[object ObservableSet]";
  }, t[Symbol.iterator] = function() {
    return this.values();
  }, pl(e, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
})(), _i = /* @__PURE__ */ La("ObservableSet", U4);
function vE(e) {
  return e[Symbol.toStringTag] = "SetIterator", s0(e);
}
var gE = /* @__PURE__ */ Object.create(null), yE = "remove", Sg = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    r === void 0 && (r = /* @__PURE__ */ new Map()), o === void 0 && (o = SW), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = n, this.values_ = r, this.name_ = i, this.defaultAnnotation_ = o, this.keysAtom_ = new Lo(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = sr(this.target_), process.env.NODE_ENV !== "production" && !Y4(this.defaultAnnotation_) && $e("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var t = e.prototype;
  return t.getObservablePropValue_ = function(r) {
    return this.values_.get(r).get();
  }, t.setObservablePropValue_ = function(r, i) {
    var o = this.values_.get(r);
    if (o instanceof Cr)
      return o.set(i), !0;
    if (wr(this)) {
      var a = xr(this, {
        type: Qr,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: i
      });
      if (!a)
        return null;
      i = a.newValue;
    }
    if (i = o.prepareNewValue_(i), i !== me.UNCHANGED) {
      var s = Xr(this), l = process.env.NODE_ENV !== "production" && yn(), u = s || l ? {
        type: Qr,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: o.value_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && l && lr(u), o.setNewValue_(i), s && ei(this, u), process.env.NODE_ENV !== "production" && l && ur();
    }
    return !0;
  }, t.get_ = function(r) {
    return me.trackingDerivation && !Pr(this.target_, r) && this.has_(r), this.target_[r];
  }, t.set_ = function(r, i, o) {
    return o === void 0 && (o = !1), Pr(this.target_, r) ? this.values_.has(r) ? this.setObservablePropValue_(r, i) : o ? Reflect.set(this.target_, r, i) : (this.target_[r] = i, !0) : this.extend_(r, {
      value: i,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, o);
  }, t.has_ = function(r) {
    if (!me.trackingDerivation)
      return r in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var i = this.pendingKeys_.get(r);
    return i || (i = new va(r in this.target_, kp, process.env.NODE_ENV !== "production" ? this.name_ + "." + mg(r) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(r, i)), i.get();
  }, t.make_ = function(r, i) {
    if (i === !0 && (i = this.defaultAnnotation_), i !== !1) {
      if (wE(this, i, r), !(r in this.target_)) {
        var o;
        if ((o = this.target_[Un]) != null && o[r])
          return;
        $e(1, i.annotationType_, this.name_ + "." + r.toString());
      }
      for (var a = this.target_; a && a !== $p; ) {
        var s = wd(a, r);
        if (s) {
          var l = i.make_(this, r, s, a);
          if (l === 0)
            return;
          if (l === 1)
            break;
        }
        a = Object.getPrototypeOf(a);
      }
      _E(this, i, r);
    }
  }, t.extend_ = function(r, i, o, a) {
    if (a === void 0 && (a = !1), o === !0 && (o = this.defaultAnnotation_), o === !1)
      return this.defineProperty_(r, i, a);
    wE(this, o, r);
    var s = o.extend_(this, r, i, a);
    return s && _E(this, o, r), s;
  }, t.defineProperty_ = function(r, i, o) {
    o === void 0 && (o = !1), Si(this.keysAtom_);
    try {
      Sr();
      var a = this.delete_(r);
      if (!a)
        return a;
      if (wr(this)) {
        var s = xr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: yo,
          newValue: i.value
        });
        if (!s)
          return null;
        var l = s.newValue;
        i.value !== l && (i = Zi({}, i, {
          value: l
        }));
      }
      if (o) {
        if (!Reflect.defineProperty(this.target_, r, i))
          return !1;
      } else
        Ti(this.target_, r, i);
      this.notifyPropertyAddition_(r, i.value);
    } finally {
      $r();
    }
    return !0;
  }, t.defineObservableProperty_ = function(r, i, o, a) {
    a === void 0 && (a = !1), Si(this.keysAtom_);
    try {
      Sr();
      var s = this.delete_(r);
      if (!s)
        return s;
      if (wr(this)) {
        var l = xr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: yo,
          newValue: i
        });
        if (!l)
          return null;
        i = l.newValue;
      }
      var u = bE(r), c = {
        configurable: me.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: u.get,
        set: u.set
      };
      if (a) {
        if (!Reflect.defineProperty(this.target_, r, c))
          return !1;
      } else
        Ti(this.target_, r, c);
      var f = new va(i, o, process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key", !1);
      this.values_.set(r, f), this.notifyPropertyAddition_(r, f.value_);
    } finally {
      $r();
    }
    return !0;
  }, t.defineComputedProperty_ = function(r, i, o) {
    o === void 0 && (o = !1), Si(this.keysAtom_);
    try {
      Sr();
      var a = this.delete_(r);
      if (!a)
        return a;
      if (wr(this)) {
        var s = xr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: yo,
          newValue: void 0
        });
        if (!s)
          return null;
      }
      i.name || (i.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key"), i.context = this.proxy_ || this.target_;
      var l = bE(r), u = {
        configurable: me.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: l.get,
        set: l.set
      };
      if (o) {
        if (!Reflect.defineProperty(this.target_, r, u))
          return !1;
      } else
        Ti(this.target_, r, u);
      this.values_.set(r, new Cr(i)), this.notifyPropertyAddition_(r, void 0);
    } finally {
      $r();
    }
    return !0;
  }, t.delete_ = function(r, i) {
    if (i === void 0 && (i = !1), Si(this.keysAtom_), !Pr(this.target_, r))
      return !0;
    if (wr(this)) {
      var o = xr(this, {
        object: this.proxy_ || this.target_,
        name: r,
        type: yE
      });
      if (!o)
        return null;
    }
    try {
      var a;
      Sr();
      var s = Xr(this), l = process.env.NODE_ENV !== "production" && yn(), u = this.values_.get(r), c = void 0;
      if (!u && (s || l)) {
        var f;
        c = (f = wd(this.target_, r)) == null ? void 0 : f.value;
      }
      if (i) {
        if (!Reflect.deleteProperty(this.target_, r))
          return !1;
      } else
        delete this.target_[r];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[r], u && (this.values_.delete(r), u instanceof va && (c = u.value_), D4(u)), this.keysAtom_.reportChanged(), (a = this.pendingKeys_) == null || (a = a.get(r)) == null || a.set(r in this.target_), s || l) {
        var d = {
          type: yE,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: c,
          name: r
        };
        process.env.NODE_ENV !== "production" && l && lr(d), s && ei(this, d), process.env.NODE_ENV !== "production" && l && ur();
      }
    } finally {
      $r();
    }
    return !0;
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && $e("`observe` doesn't support the fire immediately property for observable objects."), dc(this, r);
  }, t.intercept_ = function(r) {
    return fc(this, r);
  }, t.notifyPropertyAddition_ = function(r, i) {
    var o, a = Xr(this), s = process.env.NODE_ENV !== "production" && yn();
    if (a || s) {
      var l = a || s ? {
        type: yo,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && s && lr(l), a && ei(this, l), process.env.NODE_ENV !== "production" && s && ur();
    }
    (o = this.pendingKeys_) == null || (o = o.get(r)) == null || o.set(!0), this.keysAtom_.reportChanged();
  }, t.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), zs(this.target_);
  }, t.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, e;
})();
function Ba(e, t) {
  var n;
  if (process.env.NODE_ENV !== "production" && t && hl(e) && $e("Options can't be provided for already observable objects."), Pr(e, Ue))
    return process.env.NODE_ENV !== "production" && !(Z4(e) instanceof Sg) && $e("Cannot convert '" + Dd(e) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), e;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(e) && $e("Cannot make the designated object observable; it is not extensible");
  var r = (n = t?.name) != null ? n : process.env.NODE_ENV !== "production" ? (sr(e) ? "ObservableObject" : e.constructor.name) + "@" + ai() : "ObservableObject", i = new Sg(e, /* @__PURE__ */ new Map(), String(r), RW(t));
  return sc(e, Ue, i), e;
}
var NZ = /* @__PURE__ */ La("ObservableObjectAdministration", Sg);
function bE(e) {
  return gE[e] || (gE[e] = {
    get: function() {
      return this[Ue].getObservablePropValue_(e);
    },
    set: function(n) {
      return this[Ue].setObservablePropValue_(e, n);
    }
  });
}
function hl(e) {
  return Tp(e) ? NZ(e[Ue]) : !1;
}
function _E(e, t, n) {
  var r;
  process.env.NODE_ENV !== "production" && (e.appliedAnnotations_[n] = t), (r = e.target_[Un]) == null || delete r[n];
}
function wE(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !Y4(t) && $e("Cannot annotate '" + e.name_ + "." + n.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !Sd(t) && Pr(e.appliedAnnotations_, n)) {
    var r = e.name_ + "." + n.toString(), i = e.appliedAnnotations_[n].annotationType_, o = t.annotationType_;
    $e("Cannot apply '" + o + "' to '" + r + "':" + (`
The field is already annotated with '` + i + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var jZ = /* @__PURE__ */ H4(0), FZ = /* @__PURE__ */ (function() {
  var e = !1, t = {};
  return Object.defineProperty(t, "0", {
    set: function() {
      e = !0;
    }
  }), Object.create(t)[0] = 1, e === !1;
})(), lm = 0, q4 = function() {
};
function zZ(e, t) {
  Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ !== void 0 ? e.prototype.__proto__ = t : e.prototype = t;
}
zZ(q4, Array.prototype);
var a0 = /* @__PURE__ */ (function(e) {
  function t(r, i, o, a) {
    var s;
    return o === void 0 && (o = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ai() : "ObservableArray"), a === void 0 && (a = !1), s = e.call(this) || this, Bo(function() {
      var l = new o0(o, i, a, !0);
      l.proxy_ = s, c4(s, Ue, l), r && r.length && s.spliceWithArray(0, 0, r), FZ && Object.defineProperty(s, "0", jZ);
    }), s;
  }
  p4(t, e);
  var n = t.prototype;
  return n.concat = function() {
    this[Ue].atom_.reportObserved();
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      o.map(function(s) {
        return Mp(s) ? s.slice() : s;
      })
    );
  }, n[Symbol.iterator] = function() {
    var r = this, i = 0;
    return s0({
      next: function() {
        return i < r.length ? {
          value: r[i++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, pl(t, [{
    key: "length",
    get: function() {
      return this[Ue].getArrayLength_();
    },
    set: function(i) {
      this[Ue].setArrayLength_(i);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
})(q4);
Object.entries(kd).forEach(function(e) {
  var t = e[0], n = e[1];
  t !== "concat" && sc(a0.prototype, t, n);
});
function H4(e) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[Ue].get_(e);
    },
    set: function(n) {
      this[Ue].set_(e, n);
    }
  };
}
function LZ(e) {
  Ti(a0.prototype, "" + e, H4(e));
}
function W4(e) {
  if (e > lm) {
    for (var t = lm; t < e + 100; t++)
      LZ(t);
    lm = e;
  }
}
W4(1e3);
function VZ(e, t, n) {
  return new a0(e, t, n);
}
function Vs(e, t) {
  if (typeof e == "object" && e !== null) {
    if (Mp(e))
      return t !== void 0 && $e(23), e[Ue].atom_;
    if (_i(e))
      return e.atom_;
    if (Vo(e)) {
      if (t === void 0)
        return e.keysAtom_;
      var n = e.data_.get(t) || e.hasMap_.get(t);
      return n || $e(25, t, Dd(e)), n;
    }
    if (hl(e)) {
      if (!t)
        return $e(26);
      var r = e[Ue].values_.get(t);
      return r || $e(27, t, Dd(e)), r;
    }
    if (t0(e) || Ip(e) || Od(e))
      return e;
  } else if (cn(e) && Od(e[Ue]))
    return e[Ue];
  $e(28);
}
function Z4(e, t) {
  if (e || $e(29), t0(e) || Ip(e) || Od(e) || Vo(e) || _i(e))
    return e;
  if (e[Ue])
    return e[Ue];
  $e(24, e);
}
function Dd(e, t) {
  var n;
  if (t !== void 0)
    n = Vs(e, t);
  else {
    if (Oa(e))
      return e.name;
    hl(e) || Vo(e) || _i(e) ? n = Z4(e) : n = Vs(e);
  }
  return n.name_;
}
function Bo(e) {
  var t = Va(), n = Ap(!0);
  Sr();
  try {
    return e();
  } finally {
    $r(), Cp(n), Bi(t);
  }
}
var xE = $p.toString;
function G4(e, t, n) {
  return n === void 0 && (n = -1), $g(e, t, n);
}
function $g(e, t, n, r, i) {
  if (e === t)
    return e !== 0 || 1 / e === 1 / t;
  if (e == null || t == null)
    return !1;
  if (e !== e)
    return t !== t;
  var o = typeof e;
  if (o !== "function" && o !== "object" && typeof t != "object")
    return !1;
  var a = xE.call(e);
  if (a !== xE.call(t))
    return !1;
  switch (a) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + e == "" + t;
    case "[object Number]":
      return +e != +e ? +t != +t : +e == 0 ? 1 / +e === 1 / t : +e == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
    case "[object Map]":
    case "[object Set]":
      n >= 0 && n++;
      break;
  }
  e = EE(e), t = EE(t);
  var s = a === "[object Array]";
  if (!s) {
    if (typeof e != "object" || typeof t != "object")
      return !1;
    var l = e.constructor, u = t.constructor;
    if (l !== u && !(cn(l) && l instanceof l && cn(u) && u instanceof u) && "constructor" in e && "constructor" in t)
      return !1;
  }
  if (n === 0)
    return !1;
  n < 0 && (n = -1), r = r || [], i = i || [];
  for (var c = r.length; c--; )
    if (r[c] === e)
      return i[c] === t;
  if (r.push(e), i.push(t), s) {
    if (c = e.length, c !== t.length)
      return !1;
    for (; c--; )
      if (!$g(e[c], t[c], n - 1, r, i))
        return !1;
  } else {
    var f = Object.keys(e), d = f.length;
    if (Object.keys(t).length !== d)
      return !1;
    for (var p = 0; p < d; p++) {
      var h = f[p];
      if (!(Pr(t, h) && $g(e[h], t[h], n - 1, r, i)))
        return !1;
    }
  }
  return r.pop(), i.pop(), !0;
}
function EE(e) {
  return Mp(e) ? e.slice() : dl(e) || Vo(e) || Fi(e) || _i(e) ? Array.from(e.entries()) : e;
}
var SE, BZ = ((SE = Sp().Iterator) == null ? void 0 : SE.prototype) || {};
function s0(e) {
  return e[Symbol.iterator] = KZ, Object.assign(Object.create(BZ), e);
}
function KZ() {
  return this;
}
function Y4(e) {
  return (
    // Can be function
    e instanceof Object && typeof e.annotationType_ == "string" && cn(e.make_) && cn(e.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(e) {
  var t = Sp();
  typeof t[e] > "u" && $e("MobX requires global '" + e + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: iZ,
  extras: {
    getDebugName: Dd
  },
  $mobx: Ue
});
if (!je)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!OZ)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function UZ(e) {
  e();
}
function qZ(e) {
  e || (e = UZ, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), yZ({ reactionScheduler: e });
}
function HZ(e) {
  return z4(e);
}
var WZ = 1e4, ZZ = 1e4, GZ = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(r) {
          r === void 0 && (r = WZ), clearTimeout(n.sweepTimeout), n.sweepTimeout = void 0;
          var i = Date.now();
          n.registrations.forEach(function(o, a) {
            i - o.registeredAt >= r && (n.finalize(o.value), n.registrations.delete(a));
          }), n.registrations.size > 0 && n.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          n.sweep(0);
        }
      });
    }
    return Object.defineProperty(e.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t, n, r) {
        this.registrations.set(r, {
          value: n,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(e.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t) {
        this.registrations.delete(t);
      }
    }), Object.defineProperty(e.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, ZZ));
      }
    }), e;
  })()
), YZ = typeof FinalizationRegistry < "u" ? FinalizationRegistry : GZ, Nu = new YZ(function(e) {
  var t;
  (t = e.reaction) === null || t === void 0 || t.dispose(), e.reaction = null;
});
function $E(e) {
  e.reaction = new Pi("observer".concat(e.name), function() {
    var t;
    e.stateVersion = Symbol(), (t = e.onStoreChange) === null || t === void 0 || t.call(e);
  });
}
function QZ(e, t) {
  t === void 0 && (t = "observed");
  var n = G.useRef(null);
  if (!n.current) {
    var r = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: t,
      subscribe: function(s) {
        return Nu.unregister(r), r.onStoreChange = s, r.reaction || ($E(r), r.stateVersion = Symbol()), function() {
          var l;
          r.onStoreChange = null, (l = r.reaction) === null || l === void 0 || l.dispose(), r.reaction = null;
        };
      },
      getSnapshot: function() {
        return r.stateVersion;
      }
    };
    n.current = r;
  }
  var i = n.current;
  i.reaction || ($E(i), Nu.register(n, i, i)), G.useDebugValue(i.reaction, HZ), fD.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    i.subscribe,
    i.getSnapshot,
    i.getSnapshot
  );
  var o, a;
  if (i.reaction.track(function() {
    try {
      o = e();
    } catch (s) {
      a = s;
    }
  }), a)
    throw a;
  return o;
}
var um, cm, JZ = !0, TE = !0, Q4 = typeof Symbol == "function" && Symbol.for, XZ = (cm = (um = Object.getOwnPropertyDescriptor(function() {
}, "name")) === null || um === void 0 ? void 0 : um.configurable) !== null && cm !== void 0 ? cm : !1, OE = Q4 ? Symbol.for("react.forward_ref") : typeof Jt == "function" && Jt(function(e) {
  return null;
}).$$typeof, kE = Q4 ? Symbol.for("react.memo") : typeof Uf == "function" && Uf(function(e) {
  return null;
}).$$typeof;
function eG(e, t) {
  var n;
  if (process.env.NODE_ENV, kE && e.$$typeof === kE)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var r = (n = void 0) !== null && n !== void 0 ? n : !1, i = e, o = e.displayName || e.name;
  if (OE && e.$$typeof === OE && (r = !0, i = e.render, typeof i != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var a = function(s, l) {
    return QZ(function() {
      return i(s, l);
    }, o);
  };
  return a.displayName = e.displayName, XZ && Object.defineProperty(a, "name", {
    value: e.name,
    writable: !0,
    configurable: !0
  }), e.contextTypes && (a.contextTypes = e.contextTypes, process.env.NODE_ENV !== "production" && TE && (TE = !1, console.warn("[mobx-react-lite] Support for Legacy Context in function components will be removed in the next major release."))), r && (a = Jt(a)), a = Uf(a), nG(e, a), process.env.NODE_ENV !== "production" && Object.defineProperty(a, "contextTypes", {
    set: function() {
      var s, l;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((s = this.type) === null || s === void 0 ? void 0 : s.displayName) || ((l = this.type) === null || l === void 0 ? void 0 : l.name) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), a;
}
var tG = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function nG(e, t) {
  Object.keys(e).forEach(function(n) {
    tG[n] || Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
  });
}
process.env.NODE_ENV;
function rG(e, t) {
  return je(function() {
    return un(e(), t, { autoBind: !0 });
  })[0];
}
var fm;
qZ(i6);
fm = Nu.finalizeAllImmediately;
function iG(e, t) {
  if (PE(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (var i = 0; i < n.length; i++)
    if (!Object.hasOwnProperty.call(t, n[i]) || !PE(e[n[i]], t[n[i]]))
      return !1;
  return !0;
}
function PE(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var DE = /* @__PURE__ */ Symbol("patchMixins"), J4 = /* @__PURE__ */ Symbol("patchedDefinition");
function oG(e, t) {
  var n = e[DE] = e[DE] || {}, r = n[t] = n[t] || {};
  return r.locks = r.locks || 0, r.methods = r.methods || [], r;
}
function AE(e, t) {
  for (var n = this, r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
    i[o - 2] = arguments[o];
  t.locks++;
  try {
    var a;
    return e != null && (a = e.apply(this, i)), a;
  } finally {
    t.locks--, t.locks === 0 && t.methods.forEach(function(s) {
      s.apply(n, i);
    });
  }
}
function CE(e, t) {
  var n = function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    AE.call.apply(AE, [this, e, t].concat(o));
  };
  return n;
}
function aG(e, t, n) {
  var r = oG(e, t);
  r.methods.indexOf(n) < 0 && r.methods.push(n);
  var i = Object.getOwnPropertyDescriptor(e, t);
  if (!(i && i[J4])) {
    var o = e[t], a = X4(e, t, i ? i.enumerable : void 0, r, o);
    Object.defineProperty(e, t, a);
  }
}
function X4(e, t, n, r, i) {
  var o, a = CE(i, r);
  return o = {}, o[J4] = !0, o.get = function() {
    return a;
  }, o.set = function(l) {
    if (this === e)
      a = CE(l, r);
    else {
      var u = X4(this, t, n, r, l);
      Object.defineProperty(this, t, u);
    }
  }, o.configurable = !0, o.enumerable = n, o;
}
var IE = /* @__PURE__ */ Symbol("ObserverAdministration"), ME = /* @__PURE__ */ Symbol("isMobXReactObserver"), eA;
process.env.NODE_ENV !== "production" && (eA = {
  props: /* @__PURE__ */ dm("props"),
  state: /* @__PURE__ */ dm("state"),
  context: /* @__PURE__ */ dm("context")
});
function ju(e) {
  var t;
  return (t = e[IE]) != null ? t : e[IE] = {
    reaction: null,
    mounted: !1,
    reactionInvalidatedBeforeMount: !1,
    forceUpdate: null,
    name: Af(e.constructor),
    state: void 0,
    props: void 0,
    context: void 0
  };
}
function sG(e) {
  var t = e.prototype;
  if (e[ME]) {
    var n = Af(e);
    throw new Error("The provided component class (" + n + ") has already been declared as an observer component.");
  } else
    e[ME] = !0;
  if (t.componentWillReact)
    throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (e.__proto__ !== _$) {
    if (!t.shouldComponentUpdate)
      t.shouldComponentUpdate = RE;
    else if (t.shouldComponentUpdate !== RE)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  process.env.NODE_ENV !== "production" && Object.defineProperties(t, eA);
  var r = t.render;
  if (typeof r != "function") {
    var i = Af(e);
    throw new Error("[mobx-react] class component (" + i + ") is missing `render` method.\n`observer` requires `render` being a function defined on prototype.\n`render = () => {}` or `render = function() {}` is not supported.");
  }
  t.render = function() {
    return Object.defineProperty(this, "render", {
      // There is no safe way to replace render, therefore it's forbidden.
      configurable: !1,
      writable: !1,
      value: lG.call(this, r)
    }), this.render();
  };
  var o = t.componentDidMount;
  return t.componentDidMount = function() {
    var a = this;
    if (process.env.NODE_ENV !== "production" && this.componentDidMount !== Object.getPrototypeOf(this).componentDidMount) {
      var s = Af(e);
      throw new Error("[mobx-react] `observer(" + s + ").componentDidMount` must be defined on prototype.\n`componentDidMount = () => {}` or `componentDidMount = function() {}` is not supported.");
    }
    var l = ju(this);
    return l.mounted = !0, Nu.unregister(this), l.forceUpdate = function() {
      return a.forceUpdate();
    }, (!l.reaction || l.reactionInvalidatedBeforeMount) && l.forceUpdate(), o?.apply(this, arguments);
  }, aG(t, "componentWillUnmount", function() {
    var a, s = ju(this);
    (a = s.reaction) == null || a.dispose(), s.reaction = null, s.forceUpdate = null, s.mounted = !1, s.reactionInvalidatedBeforeMount = !1;
  }), e;
}
function Af(e) {
  return e.displayName || e.name || "<component>";
}
function lG(e) {
  var t = e.bind(this), n = ju(this);
  function r() {
    n.reaction || (n.reaction = uG(n), n.mounted || Nu.register(this, n, this));
    var i = void 0, o = void 0;
    if (n.reaction.track(function() {
      try {
        o = qW(!1, t);
      } catch (a) {
        i = a;
      }
    }), i)
      throw i;
    return o;
  }
  return r;
}
function uG(e) {
  return new Pi(e.name + ".render()", function() {
    if (!e.mounted) {
      e.reactionInvalidatedBeforeMount = !0;
      return;
    }
    try {
      e.forceUpdate == null || e.forceUpdate();
    } catch {
      var t;
      (t = e.reaction) == null || t.dispose(), e.reaction = null;
    }
  });
}
function RE(e, t) {
  return this.state !== t ? !0 : !iG(this.props, e);
}
function dm(e) {
  return {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var n = ju(this), r = QW().trackingDerivation;
      if (r && r !== n.reaction)
        throw new Error('[mobx-react] Cannot read "' + n.name + "." + e + `" in a reactive context, as it isn't observable.
                    Please use component lifecycle method to copy the value into a local observable first.
                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations`);
      return n[e];
    },
    set: function(n) {
      ju(this)[e] = n;
    }
  };
}
function tA(e, t) {
  return e.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`"), Object.prototype.isPrototypeOf.call(Gd, e) || Object.prototype.isPrototypeOf.call(_$, e) ? sG(e) : eG(e);
}
G.version.split(".")[0];
if (!Gd)
  throw new Error("mobx-react requires React to be available");
if (!un)
  throw new Error("mobx-react requires mobx to be available");
const nA = Le({
  dragDropManager: void 0
});
function vr(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var NE = (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})(), jE = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, FE = {
  INIT: "@@redux/INIT" + jE(),
  REPLACE: "@@redux/REPLACE" + jE()
};
function cG(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function fG(e) {
  if (e === void 0) return "undefined";
  if (e === null) return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e)) return "array";
  if (hG(e)) return "date";
  if (pG(e)) return "error";
  var n = dG(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function dG(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function pG(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function hG(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Ya(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = fG(e)), t;
}
function rA(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? vr(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? vr(1) : "Expected the enhancer to be a function. Instead, received: '" + Ya(n) + "'");
    return n(rA)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? vr(2) : "Expected the root reducer to be a function. Instead, received: '" + Ya(e) + "'");
  var i = e, o = t, a = [], s = a, l = !1;
  function u() {
    s === a && (s = a.slice());
  }
  function c() {
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? vr(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function f(m) {
    if (typeof m != "function")
      throw new Error(process.env.NODE_ENV === "production" ? vr(4) : "Expected the listener to be a function. Instead, received: '" + Ya(m) + "'");
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? vr(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var v = !0;
    return u(), s.push(m), function() {
      if (v) {
        if (l)
          throw new Error(process.env.NODE_ENV === "production" ? vr(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        v = !1, u();
        var b = s.indexOf(m);
        s.splice(b, 1), a = null;
      }
    };
  }
  function d(m) {
    if (!cG(m))
      throw new Error(process.env.NODE_ENV === "production" ? vr(7) : "Actions must be plain objects. Instead, the actual type was: '" + Ya(m) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof m.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? vr(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? vr(9) : "Reducers may not dispatch actions.");
    try {
      l = !0, o = i(o, m);
    } finally {
      l = !1;
    }
    for (var v = a = s, g = 0; g < v.length; g++) {
      var b = v[g];
      b();
    }
    return m;
  }
  function p(m) {
    if (typeof m != "function")
      throw new Error(process.env.NODE_ENV === "production" ? vr(10) : "Expected the nextReducer to be a function. Instead, received: '" + Ya(m));
    i = m, d({
      type: FE.REPLACE
    });
  }
  function h() {
    var m, v = f;
    return m = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(b) {
        if (typeof b != "object" || b === null)
          throw new Error(process.env.NODE_ENV === "production" ? vr(11) : "Expected the observer to be an object. Instead, received: '" + Ya(b) + "'");
        function E() {
          b.next && b.next(c());
        }
        E();
        var x = v(E);
        return {
          unsubscribe: x
        };
      }
    }, m[NE] = function() {
      return this;
    }, m;
  }
  return d({
    type: FE.INIT
  }), r = {
    dispatch: d,
    subscribe: f,
    getState: c,
    replaceReducer: p
  }, r[NE] = h, r;
}
function Ze(e, t, ...n) {
  if (mG() && t === void 0)
    throw new Error("invariant requires an error message argument");
  if (!e) {
    let r;
    if (t === void 0)
      r = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      let i = 0;
      r = new Error(t.replace(/%s/g, function() {
        return n[i++];
      })), r.name = "Invariant Violation";
    }
    throw r.framesToPop = 1, r;
  }
}
function mG() {
  return typeof process < "u" && process.env.NODE_ENV === "production";
}
function vG(e, t, n) {
  return t.split(".").reduce(
    (r, i) => r && r[i] ? r[i] : n || null,
    e
  );
}
function gG(e, t) {
  return e.filter(
    (n) => n !== t
  );
}
function iA(e) {
  return typeof e == "object";
}
function yG(e, t) {
  const n = /* @__PURE__ */ new Map(), r = (o) => {
    n.set(o, n.has(o) ? n.get(o) + 1 : 1);
  };
  e.forEach(r), t.forEach(r);
  const i = [];
  return n.forEach((o, a) => {
    o === 1 && i.push(a);
  }), i;
}
function bG(e, t) {
  return e.filter(
    (n) => t.indexOf(n) > -1
  );
}
const l0 = "dnd-core/INIT_COORDS", Rp = "dnd-core/BEGIN_DRAG", u0 = "dnd-core/PUBLISH_DRAG_SOURCE", Np = "dnd-core/HOVER", jp = "dnd-core/DROP", Fp = "dnd-core/END_DRAG";
function zE(e, t) {
  return {
    type: l0,
    payload: {
      sourceClientOffset: t || null,
      clientOffset: e || null
    }
  };
}
const _G = {
  type: l0,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function wG(e) {
  return function(n = [], r = {
    publishSource: !0
  }) {
    const { publishSource: i = !0, clientOffset: o, getSourceClientOffset: a } = r, s = e.getMonitor(), l = e.getRegistry();
    e.dispatch(zE(o)), xG(n, s, l);
    const u = $G(n, s);
    if (u == null) {
      e.dispatch(_G);
      return;
    }
    let c = null;
    if (o) {
      if (!a)
        throw new Error("getSourceClientOffset must be defined");
      EG(a), c = a(u);
    }
    e.dispatch(zE(o, c));
    const d = l.getSource(u).beginDrag(s, u);
    if (d == null)
      return;
    SG(d), l.pinSource(u);
    const p = l.getSourceType(u);
    return {
      type: Rp,
      payload: {
        itemType: p,
        item: d,
        sourceId: u,
        clientOffset: o || null,
        sourceClientOffset: c || null,
        isSourcePublic: !!i
      }
    };
  };
}
function xG(e, t, n) {
  Ze(!t.isDragging(), "Cannot call beginDrag while dragging."), e.forEach(function(r) {
    Ze(n.getSource(r), "Expected sourceIds to be registered.");
  });
}
function EG(e) {
  Ze(typeof e == "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function SG(e) {
  Ze(iA(e), "Item must be an object.");
}
function $G(e, t) {
  let n = null;
  for (let r = e.length - 1; r >= 0; r--)
    if (t.canDragSource(e[r])) {
      n = e[r];
      break;
    }
  return n;
}
function TG(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function OG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      TG(e, i, n[i]);
    });
  }
  return e;
}
function kG(e) {
  return function(n = {}) {
    const r = e.getMonitor(), i = e.getRegistry();
    PG(r), CG(r).forEach((a, s) => {
      const l = DG(a, s, i, r), u = {
        type: jp,
        payload: {
          dropResult: OG({}, n, l)
        }
      };
      e.dispatch(u);
    });
  };
}
function PG(e) {
  Ze(e.isDragging(), "Cannot call drop while not dragging."), Ze(!e.didDrop(), "Cannot call drop twice during one drag operation.");
}
function DG(e, t, n, r) {
  const i = n.getTarget(e);
  let o = i ? i.drop(r, e) : void 0;
  return AG(o), typeof o > "u" && (o = t === 0 ? {} : r.getDropResult()), o;
}
function AG(e) {
  Ze(typeof e > "u" || iA(e), "Drop result must either be an object or undefined.");
}
function CG(e) {
  const t = e.getTargetIds().filter(e.canDropOnTarget, e);
  return t.reverse(), t;
}
function IG(e) {
  return function() {
    const n = e.getMonitor(), r = e.getRegistry();
    MG(n);
    const i = n.getSourceId();
    return i != null && (r.getSource(i, !0).endDrag(n, i), r.unpinSource()), {
      type: Fp
    };
  };
}
function MG(e) {
  Ze(e.isDragging(), "Cannot call endDrag while not dragging.");
}
function Tg(e, t) {
  return t === null ? e === null : Array.isArray(e) ? e.some(
    (n) => n === t
  ) : e === t;
}
function RG(e) {
  return function(n, { clientOffset: r } = {}) {
    NG(n);
    const i = n.slice(0), o = e.getMonitor(), a = e.getRegistry(), s = o.getItemType();
    return FG(i, a, s), jG(i, o, a), zG(i, o, a), {
      type: Np,
      payload: {
        targetIds: i,
        clientOffset: r || null
      }
    };
  };
}
function NG(e) {
  Ze(Array.isArray(e), "Expected targetIds to be an array.");
}
function jG(e, t, n) {
  Ze(t.isDragging(), "Cannot call hover while not dragging."), Ze(!t.didDrop(), "Cannot call hover after drop.");
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    Ze(e.lastIndexOf(i) === r, "Expected targetIds to be unique in the passed array.");
    const o = n.getTarget(i);
    Ze(o, "Expected targetIds to be registered.");
  }
}
function FG(e, t, n) {
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r], o = t.getTargetType(i);
    Tg(o, n) || e.splice(r, 1);
  }
}
function zG(e, t, n) {
  e.forEach(function(r) {
    n.getTarget(r).hover(t, r);
  });
}
function LG(e) {
  return function() {
    if (e.getMonitor().isDragging())
      return {
        type: u0
      };
  };
}
function VG(e) {
  return {
    beginDrag: wG(e),
    publishDragSource: LG(e),
    hover: RG(e),
    drop: kG(e),
    endDrag: IG(e)
  };
}
class BG {
  receiveBackend(t) {
    this.backend = t;
  }
  getMonitor() {
    return this.monitor;
  }
  getBackend() {
    return this.backend;
  }
  getRegistry() {
    return this.monitor.registry;
  }
  getActions() {
    const t = this, { dispatch: n } = this.store;
    function r(o) {
      return (...a) => {
        const s = o.apply(t, a);
        typeof s < "u" && n(s);
      };
    }
    const i = VG(this);
    return Object.keys(i).reduce((o, a) => {
      const s = i[a];
      return o[a] = r(s), o;
    }, {});
  }
  dispatch(t) {
    this.store.dispatch(t);
  }
  constructor(t, n) {
    this.isSetUp = !1, this.handleRefCountChange = () => {
      const r = this.store.getState().refCount > 0;
      this.backend && (r && !this.isSetUp ? (this.backend.setup(), this.isSetUp = !0) : !r && this.isSetUp && (this.backend.teardown(), this.isSetUp = !1));
    }, this.store = t, this.monitor = n, t.subscribe(this.handleRefCountChange);
  }
}
function KG(e, t) {
  return {
    x: e.x + t.x,
    y: e.y + t.y
  };
}
function oA(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function UG(e) {
  const { clientOffset: t, initialClientOffset: n, initialSourceClientOffset: r } = e;
  return !t || !n || !r ? null : oA(KG(t, r), n);
}
function qG(e) {
  const { clientOffset: t, initialClientOffset: n } = e;
  return !t || !n ? null : oA(t, n);
}
const du = [], c0 = [];
du.__IS_NONE__ = !0;
c0.__IS_ALL__ = !0;
function HG(e, t) {
  return e === du ? !1 : e === c0 || typeof t > "u" ? !0 : bG(t, e).length > 0;
}
class WG {
  subscribeToStateChange(t, n = {}) {
    const { handlerIds: r } = n;
    Ze(typeof t == "function", "listener must be a function."), Ze(typeof r > "u" || Array.isArray(r), "handlerIds, when specified, must be an array of strings.");
    let i = this.store.getState().stateId;
    const o = () => {
      const a = this.store.getState(), s = a.stateId;
      try {
        s === i || s === i + 1 && !HG(a.dirtyHandlerIds, r) || t();
      } finally {
        i = s;
      }
    };
    return this.store.subscribe(o);
  }
  subscribeToOffsetChange(t) {
    Ze(typeof t == "function", "listener must be a function.");
    let n = this.store.getState().dragOffset;
    const r = () => {
      const i = this.store.getState().dragOffset;
      i !== n && (n = i, t());
    };
    return this.store.subscribe(r);
  }
  canDragSource(t) {
    if (!t)
      return !1;
    const n = this.registry.getSource(t);
    return Ze(n, `Expected to find a valid source. sourceId=${t}`), this.isDragging() ? !1 : n.canDrag(this, t);
  }
  canDropOnTarget(t) {
    if (!t)
      return !1;
    const n = this.registry.getTarget(t);
    if (Ze(n, `Expected to find a valid target. targetId=${t}`), !this.isDragging() || this.didDrop())
      return !1;
    const r = this.registry.getTargetType(t), i = this.getItemType();
    return Tg(r, i) && n.canDrop(this, t);
  }
  isDragging() {
    return !!this.getItemType();
  }
  isDraggingSource(t) {
    if (!t)
      return !1;
    const n = this.registry.getSource(t, !0);
    if (Ze(n, `Expected to find a valid source. sourceId=${t}`), !this.isDragging() || !this.isSourcePublic())
      return !1;
    const r = this.registry.getSourceType(t), i = this.getItemType();
    return r !== i ? !1 : n.isDragging(this, t);
  }
  isOverTarget(t, n = {
    shallow: !1
  }) {
    if (!t)
      return !1;
    const { shallow: r } = n;
    if (!this.isDragging())
      return !1;
    const i = this.registry.getTargetType(t), o = this.getItemType();
    if (o && !Tg(i, o))
      return !1;
    const a = this.getTargetIds();
    if (!a.length)
      return !1;
    const s = a.indexOf(t);
    return r ? s === a.length - 1 : s > -1;
  }
  getItemType() {
    return this.store.getState().dragOperation.itemType;
  }
  getItem() {
    return this.store.getState().dragOperation.item;
  }
  getSourceId() {
    return this.store.getState().dragOperation.sourceId;
  }
  getTargetIds() {
    return this.store.getState().dragOperation.targetIds;
  }
  getDropResult() {
    return this.store.getState().dragOperation.dropResult;
  }
  didDrop() {
    return this.store.getState().dragOperation.didDrop;
  }
  isSourcePublic() {
    return !!this.store.getState().dragOperation.isSourcePublic;
  }
  getInitialClientOffset() {
    return this.store.getState().dragOffset.initialClientOffset;
  }
  getInitialSourceClientOffset() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  }
  getClientOffset() {
    return this.store.getState().dragOffset.clientOffset;
  }
  getSourceClientOffset() {
    return UG(this.store.getState().dragOffset);
  }
  getDifferenceFromInitialOffset() {
    return qG(this.store.getState().dragOffset);
  }
  constructor(t, n) {
    this.store = t, this.registry = n;
  }
}
const LE = typeof global < "u" ? global : self, aA = LE.MutationObserver || LE.WebKitMutationObserver;
function sA(e) {
  return function() {
    const n = setTimeout(i, 0), r = setInterval(i, 50);
    function i() {
      clearTimeout(n), clearInterval(r), e();
    }
  };
}
function ZG(e) {
  let t = 1;
  const n = new aA(e), r = document.createTextNode("");
  return n.observe(r, {
    characterData: !0
  }), function() {
    t = -t, r.data = t;
  };
}
const GG = typeof aA == "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  ZG
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  sA
);
class YG {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(t) {
    const { queue: n, requestFlush: r } = this;
    n.length || (r(), this.flushing = !0), n[n.length] = t;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: t } = this;
      for (; this.index < t.length; ) {
        const n = this.index;
        if (this.index++, t[n].call(), this.index > this.capacity) {
          for (let r = 0, i = t.length - this.index; r < i; r++)
            t[r] = t[r + this.index];
          t.length -= this.index, this.index = 0;
        }
      }
      t.length = 0, this.index = 0, this.flushing = !1;
    }, this.registerPendingError = (t) => {
      this.pendingErrors.push(t), this.requestErrorThrow();
    }, this.requestFlush = GG(this.flush), this.requestErrorThrow = sA(() => {
      if (this.pendingErrors.length)
        throw this.pendingErrors.shift();
    });
  }
}
class QG {
  call() {
    try {
      this.task && this.task();
    } catch (t) {
      this.onError(t);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(t, n) {
    this.onError = t, this.release = n, this.task = null;
  }
}
class JG {
  create(t) {
    const n = this.freeTasks, r = n.length ? n.pop() : new QG(
      this.onError,
      (i) => n[n.length] = i
    );
    return r.task = t, r;
  }
  constructor(t) {
    this.onError = t, this.freeTasks = [];
  }
}
const lA = new YG(), XG = new JG(lA.registerPendingError);
function eY(e) {
  lA.enqueueTask(XG.create(e));
}
const f0 = "dnd-core/ADD_SOURCE", d0 = "dnd-core/ADD_TARGET", p0 = "dnd-core/REMOVE_SOURCE", zp = "dnd-core/REMOVE_TARGET";
function tY(e) {
  return {
    type: f0,
    payload: {
      sourceId: e
    }
  };
}
function nY(e) {
  return {
    type: d0,
    payload: {
      targetId: e
    }
  };
}
function rY(e) {
  return {
    type: p0,
    payload: {
      sourceId: e
    }
  };
}
function iY(e) {
  return {
    type: zp,
    payload: {
      targetId: e
    }
  };
}
function oY(e) {
  Ze(typeof e.canDrag == "function", "Expected canDrag to be a function."), Ze(typeof e.beginDrag == "function", "Expected beginDrag to be a function."), Ze(typeof e.endDrag == "function", "Expected endDrag to be a function.");
}
function aY(e) {
  Ze(typeof e.canDrop == "function", "Expected canDrop to be a function."), Ze(typeof e.hover == "function", "Expected hover to be a function."), Ze(typeof e.drop == "function", "Expected beginDrag to be a function.");
}
function Og(e, t) {
  if (t && Array.isArray(e)) {
    e.forEach(
      (n) => Og(n, !1)
    );
    return;
  }
  Ze(typeof e == "string" || typeof e == "symbol", t ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var _r;
(function(e) {
  e.SOURCE = "SOURCE", e.TARGET = "TARGET";
})(_r || (_r = {}));
let sY = 0;
function lY() {
  return sY++;
}
function uY(e) {
  const t = lY().toString();
  switch (e) {
    case _r.SOURCE:
      return `S${t}`;
    case _r.TARGET:
      return `T${t}`;
    default:
      throw new Error(`Unknown Handler Role: ${e}`);
  }
}
function VE(e) {
  switch (e[0]) {
    case "S":
      return _r.SOURCE;
    case "T":
      return _r.TARGET;
    default:
      throw new Error(`Cannot parse handler ID: ${e}`);
  }
}
function BE(e, t) {
  const n = e.entries();
  let r = !1;
  do {
    const { done: i, value: [, o] } = n.next();
    if (o === t)
      return !0;
    r = !!i;
  } while (!r);
  return !1;
}
class cY {
  addSource(t, n) {
    Og(t), oY(n);
    const r = this.addHandler(_r.SOURCE, t, n);
    return this.store.dispatch(tY(r)), r;
  }
  addTarget(t, n) {
    Og(t, !0), aY(n);
    const r = this.addHandler(_r.TARGET, t, n);
    return this.store.dispatch(nY(r)), r;
  }
  containsHandler(t) {
    return BE(this.dragSources, t) || BE(this.dropTargets, t);
  }
  getSource(t, n = !1) {
    return Ze(this.isSourceId(t), "Expected a valid source ID."), n && t === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(t);
  }
  getTarget(t) {
    return Ze(this.isTargetId(t), "Expected a valid target ID."), this.dropTargets.get(t);
  }
  getSourceType(t) {
    return Ze(this.isSourceId(t), "Expected a valid source ID."), this.types.get(t);
  }
  getTargetType(t) {
    return Ze(this.isTargetId(t), "Expected a valid target ID."), this.types.get(t);
  }
  isSourceId(t) {
    return VE(t) === _r.SOURCE;
  }
  isTargetId(t) {
    return VE(t) === _r.TARGET;
  }
  removeSource(t) {
    Ze(this.getSource(t), "Expected an existing source."), this.store.dispatch(rY(t)), eY(() => {
      this.dragSources.delete(t), this.types.delete(t);
    });
  }
  removeTarget(t) {
    Ze(this.getTarget(t), "Expected an existing target."), this.store.dispatch(iY(t)), this.dropTargets.delete(t), this.types.delete(t);
  }
  pinSource(t) {
    const n = this.getSource(t);
    Ze(n, "Expected an existing source."), this.pinnedSourceId = t, this.pinnedSource = n;
  }
  unpinSource() {
    Ze(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
  }
  addHandler(t, n, r) {
    const i = uY(t);
    return this.types.set(i, n), t === _r.SOURCE ? this.dragSources.set(i, r) : t === _r.TARGET && this.dropTargets.set(i, r), i;
  }
  constructor(t) {
    this.types = /* @__PURE__ */ new Map(), this.dragSources = /* @__PURE__ */ new Map(), this.dropTargets = /* @__PURE__ */ new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = t;
  }
}
const fY = (e, t) => e === t;
function dY(e, t) {
  return !e && !t ? !0 : !e || !t ? !1 : e.x === t.x && e.y === t.y;
}
function pY(e, t, n = fY) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; ++r)
    if (!n(e[r], t[r]))
      return !1;
  return !0;
}
function hY(e = du, t) {
  switch (t.type) {
    case Np:
      break;
    case f0:
    case d0:
    case zp:
    case p0:
      return du;
    case Rp:
    case u0:
    case Fp:
    case jp:
    default:
      return c0;
  }
  const { targetIds: n = [], prevTargetIds: r = [] } = t.payload, i = yG(n, r);
  if (!(i.length > 0 || !pY(n, r)))
    return du;
  const a = r[r.length - 1], s = n[n.length - 1];
  return a !== s && (a && i.push(a), s && i.push(s)), i;
}
function mY(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function vY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      mY(e, i, n[i]);
    });
  }
  return e;
}
const KE = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function gY(e = KE, t) {
  const { payload: n } = t;
  switch (t.type) {
    case l0:
    case Rp:
      return {
        initialSourceClientOffset: n.sourceClientOffset,
        initialClientOffset: n.clientOffset,
        clientOffset: n.clientOffset
      };
    case Np:
      return dY(e.clientOffset, n.clientOffset) ? e : vY({}, e, {
        clientOffset: n.clientOffset
      });
    case Fp:
    case jp:
      return KE;
    default:
      return e;
  }
}
function yY(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Qa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      yY(e, i, n[i]);
    });
  }
  return e;
}
const bY = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: !1,
  isSourcePublic: null
};
function _Y(e = bY, t) {
  const { payload: n } = t;
  switch (t.type) {
    case Rp:
      return Qa({}, e, {
        itemType: n.itemType,
        item: n.item,
        sourceId: n.sourceId,
        isSourcePublic: n.isSourcePublic,
        dropResult: null,
        didDrop: !1
      });
    case u0:
      return Qa({}, e, {
        isSourcePublic: !0
      });
    case Np:
      return Qa({}, e, {
        targetIds: n.targetIds
      });
    case zp:
      return e.targetIds.indexOf(n.targetId) === -1 ? e : Qa({}, e, {
        targetIds: gG(e.targetIds, n.targetId)
      });
    case jp:
      return Qa({}, e, {
        dropResult: n.dropResult,
        didDrop: !0,
        targetIds: []
      });
    case Fp:
      return Qa({}, e, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: !1,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return e;
  }
}
function wY(e = 0, t) {
  switch (t.type) {
    case f0:
    case d0:
      return e + 1;
    case p0:
    case zp:
      return e - 1;
    default:
      return e;
  }
}
function xY(e = 0) {
  return e + 1;
}
function EY(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function SY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      EY(e, i, n[i]);
    });
  }
  return e;
}
function $Y(e = {}, t) {
  return {
    dirtyHandlerIds: hY(e.dirtyHandlerIds, {
      type: t.type,
      payload: SY({}, t.payload, {
        prevTargetIds: vG(e, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: gY(e.dragOffset, t),
    refCount: wY(e.refCount, t),
    dragOperation: _Y(e.dragOperation, t),
    stateId: xY(e.stateId)
  };
}
function TY(e, t = void 0, n = {}, r = !1) {
  const i = OY(r), o = new WG(i, new cY(i)), a = new BG(i, o), s = e(a, t, n);
  return a.receiveBackend(s), a;
}
function OY(e) {
  const t = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return rA($Y, e && t && t({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
function kY(e, t) {
  if (e == null) return {};
  var n = PY(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function PY(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
let UE = 0;
const Cf = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var DY = /* @__PURE__ */ Uf(function(t) {
  var { children: n } = t, r = kY(t, [
    "children"
  ]);
  const [i, o] = AY(r);
  return De(() => {
    if (o) {
      const a = uA();
      return ++UE, () => {
        --UE === 0 && (a[Cf] = null);
      };
    }
  }, []), /* @__PURE__ */ R.jsx(nA.Provider, {
    value: i,
    children: n
  });
});
function AY(e) {
  if ("manager" in e)
    return [
      {
        dragDropManager: e.manager
      },
      !1
    ];
  const t = CY(e.backend, e.context, e.options, e.debugMode), n = !e.context;
  return [
    t,
    n
  ];
}
function CY(e, t = uA(), n, r) {
  const i = t;
  return i[Cf] || (i[Cf] = {
    dragDropManager: TY(e, t, n, r)
  }), i[Cf];
}
function uA() {
  return typeof global < "u" ? global : window;
}
var pm, qE;
function IY() {
  return qE || (qE = 1, pm = function e(t, n) {
    if (t === n) return !0;
    if (t && n && typeof t == "object" && typeof n == "object") {
      if (t.constructor !== n.constructor) return !1;
      var r, i, o;
      if (Array.isArray(t)) {
        if (r = t.length, r != n.length) return !1;
        for (i = r; i-- !== 0; )
          if (!e(t[i], n[i])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
      if (o = Object.keys(t), r = o.length, r !== Object.keys(n).length) return !1;
      for (i = r; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
      for (i = r; i-- !== 0; ) {
        var a = o[i];
        if (!e(t[a], n[a])) return !1;
      }
      return !0;
    }
    return t !== t && n !== n;
  }), pm;
}
var MY = IY();
const RY = /* @__PURE__ */ Yd(MY), ka = typeof window < "u" ? y$ : De;
function NY(e, t, n) {
  const [r, i] = je(
    () => t(e)
  ), o = Ne(() => {
    const a = t(e);
    RY(r, a) || (i(a), n && n());
  }, [
    r,
    e,
    n
  ]);
  return ka(o), [
    r,
    o
  ];
}
function jY(e, t, n) {
  const [r, i] = NY(e, t, n);
  return ka(function() {
    const a = e.getHandlerId();
    if (a != null)
      return e.subscribeToStateChange(i, {
        handlerIds: [
          a
        ]
      });
  }, [
    e,
    i
  ]), r;
}
function cA(e, t, n) {
  return jY(
    t,
    e || (() => ({})),
    () => n.reconnect()
  );
}
function fA(e, t) {
  const n = [];
  return typeof e != "function" && n.push(e), Ee(() => typeof e == "function" ? e() : e, n);
}
function FY(e) {
  return Ee(
    () => e.hooks.dragSource(),
    [
      e
    ]
  );
}
function zY(e) {
  return Ee(
    () => e.hooks.dragPreview(),
    [
      e
    ]
  );
}
let hm = !1, mm = !1;
class LY {
  receiveHandlerId(t) {
    this.sourceId = t;
  }
  getHandlerId() {
    return this.sourceId;
  }
  canDrag() {
    Ze(!hm, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return hm = !0, this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      hm = !1;
    }
  }
  isDragging() {
    if (!this.sourceId)
      return !1;
    Ze(!mm, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return mm = !0, this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      mm = !1;
    }
  }
  subscribeToStateChange(t, n) {
    return this.internalMonitor.subscribeToStateChange(t, n);
  }
  isDraggingSource(t) {
    return this.internalMonitor.isDraggingSource(t);
  }
  isOverTarget(t, n) {
    return this.internalMonitor.isOverTarget(t, n);
  }
  getTargetIds() {
    return this.internalMonitor.getTargetIds();
  }
  isSourcePublic() {
    return this.internalMonitor.isSourcePublic();
  }
  getSourceId() {
    return this.internalMonitor.getSourceId();
  }
  subscribeToOffsetChange(t) {
    return this.internalMonitor.subscribeToOffsetChange(t);
  }
  canDragSource(t) {
    return this.internalMonitor.canDragSource(t);
  }
  canDropOnTarget(t) {
    return this.internalMonitor.canDropOnTarget(t);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(t) {
    this.sourceId = null, this.internalMonitor = t.getMonitor();
  }
}
let vm = !1;
class VY {
  receiveHandlerId(t) {
    this.targetId = t;
  }
  getHandlerId() {
    return this.targetId;
  }
  subscribeToStateChange(t, n) {
    return this.internalMonitor.subscribeToStateChange(t, n);
  }
  canDrop() {
    if (!this.targetId)
      return !1;
    Ze(!vm, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      return vm = !0, this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      vm = !1;
    }
  }
  isOver(t) {
    return this.targetId ? this.internalMonitor.isOverTarget(this.targetId, t) : !1;
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(t) {
    this.targetId = null, this.internalMonitor = t.getMonitor();
  }
}
function BY(e, t, n) {
  const r = n.getRegistry(), i = r.addTarget(e, t);
  return [
    i,
    () => r.removeTarget(i)
  ];
}
function KY(e, t, n) {
  const r = n.getRegistry(), i = r.addSource(e, t);
  return [
    i,
    () => r.removeSource(i)
  ];
}
function kg(e, t, n, r) {
  let i;
  if (i !== void 0)
    return !!i;
  if (e === t)
    return !0;
  if (typeof e != "object" || !e || typeof t != "object" || !t)
    return !1;
  const o = Object.keys(e), a = Object.keys(t);
  if (o.length !== a.length)
    return !1;
  const s = Object.prototype.hasOwnProperty.bind(t);
  for (let l = 0; l < o.length; l++) {
    const u = o[l];
    if (!s(u))
      return !1;
    const c = e[u], f = t[u];
    if (i = void 0, i === !1 || i === void 0 && c !== f)
      return !1;
  }
  return !0;
}
function Pg(e) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    e !== null && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current")
  );
}
function UY(e) {
  if (typeof e.type == "string")
    return;
  const t = e.type.displayName || e.type.name || "the component";
  throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${t} into a <div>, or turn it into a drag source or a drop target itself.`);
}
function qY(e) {
  return (t = null, n = null) => {
    if (!_y(t)) {
      const o = t;
      return e(o, n), o;
    }
    const r = t;
    return UY(r), HY(r, n ? (o) => e(o, n) : e);
  };
}
function dA(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const r = e[n];
    if (n.endsWith("Ref"))
      t[n] = e[n];
    else {
      const i = qY(r);
      t[n] = () => i;
    }
  }), t;
}
function HE(e, t) {
  typeof e == "function" ? e(t) : e.current = t;
}
function HY(e, t) {
  const n = e.ref;
  return Ze(typeof n != "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), n ? Kf(e, {
    ref: (r) => {
      HE(n, r), HE(t, r);
    }
  }) : Kf(e, {
    ref: t
  });
}
class WY {
  receiveHandlerId(t) {
    this.handlerId !== t && (this.handlerId = t, this.reconnect());
  }
  get connectTarget() {
    return this.dragSource;
  }
  get dragSourceOptions() {
    return this.dragSourceOptionsInternal;
  }
  set dragSourceOptions(t) {
    this.dragSourceOptionsInternal = t;
  }
  get dragPreviewOptions() {
    return this.dragPreviewOptionsInternal;
  }
  set dragPreviewOptions(t) {
    this.dragPreviewOptionsInternal = t;
  }
  reconnect() {
    const t = this.reconnectDragSource();
    this.reconnectDragPreview(t);
  }
  reconnectDragSource() {
    const t = this.dragSource, n = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    return n && this.disconnectDragSource(), this.handlerId ? t ? (n && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = t, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, t, this.dragSourceOptions)), n) : (this.lastConnectedDragSource = t, n) : n;
  }
  reconnectDragPreview(t = !1) {
    const n = this.dragPreview, r = t || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    if (r && this.disconnectDragPreview(), !!this.handlerId) {
      if (!n) {
        this.lastConnectedDragPreview = n;
        return;
      }
      r && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = n, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, n, this.dragPreviewOptions));
    }
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didConnectedDragSourceChange() {
    return this.lastConnectedDragSource !== this.dragSource;
  }
  didConnectedDragPreviewChange() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  }
  didDragSourceOptionsChange() {
    return !kg(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  }
  didDragPreviewOptionsChange() {
    return !kg(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  }
  disconnectDragSource() {
    this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
  }
  disconnectDragPreview() {
    this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
  }
  get dragSource() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  }
  get dragPreview() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  }
  clearDragSource() {
    this.dragSourceNode = null, this.dragSourceRef = null;
  }
  clearDragPreview() {
    this.dragPreviewNode = null, this.dragPreviewRef = null;
  }
  constructor(t) {
    this.hooks = dA({
      dragSource: (n, r) => {
        this.clearDragSource(), this.dragSourceOptions = r || null, Pg(n) ? this.dragSourceRef = n : this.dragSourceNode = n, this.reconnectDragSource();
      },
      dragPreview: (n, r) => {
        this.clearDragPreview(), this.dragPreviewOptions = r || null, Pg(n) ? this.dragPreviewRef = n : this.dragPreviewNode = n, this.reconnectDragPreview();
      }
    }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = t;
  }
}
class ZY {
  get connectTarget() {
    return this.dropTarget;
  }
  reconnect() {
    const t = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    t && this.disconnectDropTarget();
    const n = this.dropTarget;
    if (this.handlerId) {
      if (!n) {
        this.lastConnectedDropTarget = n;
        return;
      }
      t && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = n, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, n, this.dropTargetOptions));
    }
  }
  receiveHandlerId(t) {
    t !== this.handlerId && (this.handlerId = t, this.reconnect());
  }
  get dropTargetOptions() {
    return this.dropTargetOptionsInternal;
  }
  set dropTargetOptions(t) {
    this.dropTargetOptionsInternal = t;
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didDropTargetChange() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  }
  didOptionsChange() {
    return !kg(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  }
  disconnectDropTarget() {
    this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
  }
  get dropTarget() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  }
  clearDropTarget() {
    this.dropTargetRef = null, this.dropTargetNode = null;
  }
  constructor(t) {
    this.hooks = dA({
      dropTarget: (n, r) => {
        this.clearDropTarget(), this.dropTargetOptions = r, Pg(n) ? this.dropTargetRef = n : this.dropTargetNode = n, this.reconnect();
      }
    }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = t;
  }
}
function ml() {
  const { dragDropManager: e } = Ce(nA);
  return Ze(e != null, "Expected drag drop context"), e;
}
function GY(e, t) {
  const n = ml(), r = Ee(
    () => new WY(n.getBackend()),
    [
      n
    ]
  );
  return ka(() => (r.dragSourceOptions = e || null, r.reconnect(), () => r.disconnectDragSource()), [
    r,
    e
  ]), ka(() => (r.dragPreviewOptions = t || null, r.reconnect(), () => r.disconnectDragPreview()), [
    r,
    t
  ]), r;
}
function YY() {
  const e = ml();
  return Ee(
    () => new LY(e),
    [
      e
    ]
  );
}
class QY {
  beginDrag() {
    const t = this.spec, n = this.monitor;
    let r = null;
    return typeof t.item == "object" ? r = t.item : typeof t.item == "function" ? r = t.item(n) : r = {}, r ?? null;
  }
  canDrag() {
    const t = this.spec, n = this.monitor;
    return typeof t.canDrag == "boolean" ? t.canDrag : typeof t.canDrag == "function" ? t.canDrag(n) : !0;
  }
  isDragging(t, n) {
    const r = this.spec, i = this.monitor, { isDragging: o } = r;
    return o ? o(i) : n === t.getSourceId();
  }
  endDrag() {
    const t = this.spec, n = this.monitor, r = this.connector, { end: i } = t;
    i && i(n.getItem(), n), r.reconnect();
  }
  constructor(t, n, r) {
    this.spec = t, this.monitor = n, this.connector = r;
  }
}
function JY(e, t, n) {
  const r = Ee(
    () => new QY(e, t, n),
    [
      t,
      n
    ]
  );
  return De(() => {
    r.spec = e;
  }, [
    e
  ]), r;
}
function XY(e) {
  return Ee(() => {
    const t = e.type;
    return Ze(t != null, "spec.type must be defined"), t;
  }, [
    e
  ]);
}
function eQ(e, t, n) {
  const r = ml(), i = JY(e, t, n), o = XY(e);
  ka(function() {
    if (o != null) {
      const [s, l] = KY(o, i, r);
      return t.receiveHandlerId(s), n.receiveHandlerId(s), l;
    }
  }, [
    r,
    t,
    n,
    i,
    o
  ]);
}
function pA(e, t) {
  const n = fA(e);
  Ze(!n.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  const r = YY(), i = GY(n.options, n.previewOptions);
  return eQ(n, r, i), [
    cA(n.collect, r, i),
    FY(i),
    zY(i)
  ];
}
function tQ(e) {
  return Ee(
    () => e.hooks.dropTarget(),
    [
      e
    ]
  );
}
function nQ(e) {
  const t = ml(), n = Ee(
    () => new ZY(t.getBackend()),
    [
      t
    ]
  );
  return ka(() => (n.dropTargetOptions = e || null, n.reconnect(), () => n.disconnectDropTarget()), [
    e
  ]), n;
}
function rQ() {
  const e = ml();
  return Ee(
    () => new VY(e),
    [
      e
    ]
  );
}
function iQ(e) {
  const { accept: t } = e;
  return Ee(() => (Ze(e.accept != null, "accept must be defined"), Array.isArray(t) ? t : [
    t
  ]), [
    t
  ]);
}
class oQ {
  canDrop() {
    const t = this.spec, n = this.monitor;
    return t.canDrop ? t.canDrop(n.getItem(), n) : !0;
  }
  hover() {
    const t = this.spec, n = this.monitor;
    t.hover && t.hover(n.getItem(), n);
  }
  drop() {
    const t = this.spec, n = this.monitor;
    if (t.drop)
      return t.drop(n.getItem(), n);
  }
  constructor(t, n) {
    this.spec = t, this.monitor = n;
  }
}
function aQ(e, t) {
  const n = Ee(
    () => new oQ(e, t),
    [
      t
    ]
  );
  return De(() => {
    n.spec = e;
  }, [
    e
  ]), n;
}
function sQ(e, t, n) {
  const r = ml(), i = aQ(e, t), o = iQ(e);
  ka(function() {
    const [s, l] = BY(o, i, r);
    return t.receiveHandlerId(s), n.receiveHandlerId(s), l;
  }, [
    r,
    t,
    i,
    n,
    o.map(
      (a) => a.toString()
    ).join("|")
  ]);
}
function lQ(e, t) {
  const n = fA(e), r = rQ(), i = nQ(n.options);
  return sQ(n, r, i), [
    cA(n.collect, r, i),
    tQ(i)
  ];
}
function hA(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
function uQ(e, t) {
  return e.filter(
    (n) => n !== t
  );
}
function cQ(e, t) {
  const n = /* @__PURE__ */ new Set(), r = (o) => n.add(o);
  e.forEach(r), t.forEach(r);
  const i = [];
  return n.forEach(
    (o) => i.push(o)
  ), i;
}
class fQ {
  enter(t) {
    const n = this.entered.length, r = (i) => this.isNodeInDocument(i) && (!i.contains || i.contains(t));
    return this.entered = cQ(this.entered.filter(r), [
      t
    ]), n === 0 && this.entered.length > 0;
  }
  leave(t) {
    const n = this.entered.length;
    return this.entered = uQ(this.entered.filter(this.isNodeInDocument), t), n > 0 && this.entered.length === 0;
  }
  reset() {
    this.entered = [];
  }
  constructor(t) {
    this.entered = [], this.isNodeInDocument = t;
  }
}
class dQ {
  initializeExposedProperties() {
    Object.keys(this.config.exposeProperties).forEach((t) => {
      Object.defineProperty(this.item, t, {
        configurable: !0,
        enumerable: !0,
        get() {
          return console.warn(`Browser doesn't allow reading "${t}" until the drop event.`), null;
        }
      });
    });
  }
  loadDataTransfer(t) {
    if (t) {
      const n = {};
      Object.keys(this.config.exposeProperties).forEach((r) => {
        const i = this.config.exposeProperties[r];
        i != null && (n[r] = {
          value: i(t, this.config.matchesTypes),
          configurable: !0,
          enumerable: !0
        });
      }), Object.defineProperties(this.item, n);
    }
  }
  canDrag() {
    return !0;
  }
  beginDrag() {
    return this.item;
  }
  isDragging(t, n) {
    return n === t.getSourceId();
  }
  endDrag() {
  }
  constructor(t) {
    this.config = t, this.item = {}, this.initializeExposedProperties();
  }
}
const mA = "__NATIVE_FILE__", vA = "__NATIVE_URL__", gA = "__NATIVE_TEXT__", yA = "__NATIVE_HTML__", WE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE: mA,
  HTML: yA,
  TEXT: gA,
  URL: vA
}, Symbol.toStringTag, { value: "Module" }));
function gm(e, t, n) {
  const r = t.reduce(
    (i, o) => i || e.getData(o),
    ""
  );
  return r ?? n;
}
const Dg = {
  [mA]: {
    exposeProperties: {
      files: (e) => Array.prototype.slice.call(e.files),
      items: (e) => e.items,
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Files"
    ]
  },
  [yA]: {
    exposeProperties: {
      html: (e, t) => gm(e, t, ""),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Html",
      "text/html"
    ]
  },
  [vA]: {
    exposeProperties: {
      urls: (e, t) => gm(e, t, "").split(`
`),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Url",
      "text/uri-list"
    ]
  },
  [gA]: {
    exposeProperties: {
      text: (e, t) => gm(e, t, ""),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Text",
      "text/plain"
    ]
  }
};
function pQ(e, t) {
  const n = Dg[e];
  if (!n)
    throw new Error(`native type ${e} has no configuration`);
  const r = new dQ(n);
  return r.loadDataTransfer(t), r;
}
function ym(e) {
  if (!e)
    return null;
  const t = Array.prototype.slice.call(e.types || []);
  return Object.keys(Dg).filter((n) => {
    const r = Dg[n];
    return r?.matchesTypes ? r.matchesTypes.some(
      (i) => t.indexOf(i) > -1
    ) : !1;
  })[0] || null;
}
const hQ = hA(
  () => /firefox/i.test(navigator.userAgent)
), bA = hA(
  () => !!window.safari
);
class ZE {
  interpolate(t) {
    const { xs: n, ys: r, c1s: i, c2s: o, c3s: a } = this;
    let s = n.length - 1;
    if (t === n[s])
      return r[s];
    let l = 0, u = a.length - 1, c;
    for (; l <= u; ) {
      c = Math.floor(0.5 * (l + u));
      const p = n[c];
      if (p < t)
        l = c + 1;
      else if (p > t)
        u = c - 1;
      else
        return r[c];
    }
    s = Math.max(0, u);
    const f = t - n[s], d = f * f;
    return r[s] + i[s] * f + o[s] * d + a[s] * f * d;
  }
  constructor(t, n) {
    const { length: r } = t, i = [];
    for (let p = 0; p < r; p++)
      i.push(p);
    i.sort(
      (p, h) => t[p] < t[h] ? -1 : 1
    );
    const o = [], a = [];
    let s, l;
    for (let p = 0; p < r - 1; p++)
      s = t[p + 1] - t[p], l = n[p + 1] - n[p], o.push(s), a.push(l / s);
    const u = [
      a[0]
    ];
    for (let p = 0; p < o.length - 1; p++) {
      const h = a[p], m = a[p + 1];
      if (h * m <= 0)
        u.push(0);
      else {
        s = o[p];
        const v = o[p + 1], g = s + v;
        u.push(3 * g / ((g + v) / h + (g + s) / m));
      }
    }
    u.push(a[a.length - 1]);
    const c = [], f = [];
    let d;
    for (let p = 0; p < u.length - 1; p++) {
      d = a[p];
      const h = u[p], m = 1 / o[p], v = h + u[p + 1] - d - d;
      c.push((d - h - v) * m), f.push(v * m * m);
    }
    this.xs = t, this.ys = n, this.c1s = u, this.c2s = c, this.c3s = f;
  }
}
const mQ = 1;
function _A(e) {
  const t = e.nodeType === mQ ? e : e.parentElement;
  if (!t)
    return null;
  const { top: n, left: r } = t.getBoundingClientRect();
  return {
    x: r,
    y: n
  };
}
function Qc(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function vQ(e) {
  var t;
  return e.nodeName === "IMG" && (hQ() || !(!((t = document.documentElement) === null || t === void 0) && t.contains(e)));
}
function gQ(e, t, n, r) {
  let i = e ? t.width : n, o = e ? t.height : r;
  return bA() && e && (o /= window.devicePixelRatio, i /= window.devicePixelRatio), {
    dragPreviewWidth: i,
    dragPreviewHeight: o
  };
}
function yQ(e, t, n, r, i) {
  const o = vQ(t), s = _A(o ? e : t), l = {
    x: n.x - s.x,
    y: n.y - s.y
  }, { offsetWidth: u, offsetHeight: c } = e, { anchorX: f, anchorY: d } = r, { dragPreviewWidth: p, dragPreviewHeight: h } = gQ(o, t, u, c), m = () => {
    let $ = new ZE([
      0,
      0.5,
      1
    ], [
      // Dock to the top
      l.y,
      // Align at the center
      l.y / c * h,
      // Dock to the bottom
      l.y + h - c
    ]).interpolate(d);
    return bA() && o && ($ += (window.devicePixelRatio - 1) * h), $;
  }, v = () => new ZE([
    0,
    0.5,
    1
  ], [
    // Dock to the left
    l.x,
    // Align at the center
    l.x / u * p,
    // Dock to the right
    l.x + p - u
  ]).interpolate(f), { offsetX: g, offsetY: b } = i, E = g === 0 || g, x = b === 0 || b;
  return {
    x: E ? g : v(),
    y: x ? b : m()
  };
}
class bQ {
  get window() {
    if (this.globalContext)
      return this.globalContext;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var t;
    return !((t = this.globalContext) === null || t === void 0) && t.document ? this.globalContext.document : this.window ? this.window.document : void 0;
  }
  get rootElement() {
    var t;
    return ((t = this.optionsArgs) === null || t === void 0 ? void 0 : t.rootElement) || this.window;
  }
  constructor(t, n) {
    this.ownerDocument = null, this.globalContext = t, this.optionsArgs = n;
  }
}
function _Q(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function GE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      _Q(e, i, n[i]);
    });
  }
  return e;
}
class wQ {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var t, n;
    return {
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      sourceNodeOptions: this.sourceNodeOptions.size,
      sourceNodes: this.sourceNodes.size,
      dragStartSourceIds: ((t = this.dragStartSourceIds) === null || t === void 0 ? void 0 : t.length) || 0,
      dropTargetIds: this.dropTargetIds.length,
      dragEnterTargetIds: this.dragEnterTargetIds.length,
      dragOverTargetIds: ((n = this.dragOverTargetIds) === null || n === void 0 ? void 0 : n.length) || 0
    };
  }
  // public for test
  get window() {
    return this.options.window;
  }
  get document() {
    return this.options.document;
  }
  /**
  * Get the root element to use for event subscriptions
  */
  get rootElement() {
    return this.options.rootElement;
  }
  setup() {
    const t = this.rootElement;
    if (t !== void 0) {
      if (t.__isReactDndBackendSetUp)
        throw new Error("Cannot have two HTML5 backends at the same time.");
      t.__isReactDndBackendSetUp = !0, this.addEventListeners(t);
    }
  }
  teardown() {
    const t = this.rootElement;
    if (t !== void 0 && (t.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.rootElement), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId)) {
      var n;
      (n = this.window) === null || n === void 0 || n.cancelAnimationFrame(this.asyncEndDragFrameId);
    }
  }
  connectDragPreview(t, n, r) {
    return this.sourcePreviewNodeOptions.set(t, r), this.sourcePreviewNodes.set(t, n), () => {
      this.sourcePreviewNodes.delete(t), this.sourcePreviewNodeOptions.delete(t);
    };
  }
  connectDragSource(t, n, r) {
    this.sourceNodes.set(t, n), this.sourceNodeOptions.set(t, r);
    const i = (a) => this.handleDragStart(a, t), o = (a) => this.handleSelectStart(a);
    return n.setAttribute("draggable", "true"), n.addEventListener("dragstart", i), n.addEventListener("selectstart", o), () => {
      this.sourceNodes.delete(t), this.sourceNodeOptions.delete(t), n.removeEventListener("dragstart", i), n.removeEventListener("selectstart", o), n.setAttribute("draggable", "false");
    };
  }
  connectDropTarget(t, n) {
    const r = (a) => this.handleDragEnter(a, t), i = (a) => this.handleDragOver(a, t), o = (a) => this.handleDrop(a, t);
    return n.addEventListener("dragenter", r), n.addEventListener("dragover", i), n.addEventListener("drop", o), () => {
      n.removeEventListener("dragenter", r), n.removeEventListener("dragover", i), n.removeEventListener("drop", o);
    };
  }
  addEventListeners(t) {
    t.addEventListener && (t.addEventListener("dragstart", this.handleTopDragStart), t.addEventListener("dragstart", this.handleTopDragStartCapture, !0), t.addEventListener("dragend", this.handleTopDragEndCapture, !0), t.addEventListener("dragenter", this.handleTopDragEnter), t.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), t.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), t.addEventListener("dragover", this.handleTopDragOver), t.addEventListener("dragover", this.handleTopDragOverCapture, !0), t.addEventListener("drop", this.handleTopDrop), t.addEventListener("drop", this.handleTopDropCapture, !0));
  }
  removeEventListeners(t) {
    t.removeEventListener && (t.removeEventListener("dragstart", this.handleTopDragStart), t.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), t.removeEventListener("dragend", this.handleTopDragEndCapture, !0), t.removeEventListener("dragenter", this.handleTopDragEnter), t.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), t.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), t.removeEventListener("dragover", this.handleTopDragOver), t.removeEventListener("dragover", this.handleTopDragOverCapture, !0), t.removeEventListener("drop", this.handleTopDrop), t.removeEventListener("drop", this.handleTopDropCapture, !0));
  }
  getCurrentSourceNodeOptions() {
    const t = this.monitor.getSourceId(), n = this.sourceNodeOptions.get(t);
    return GE({
      dropEffect: this.altKeyPressed ? "copy" : "move"
    }, n || {});
  }
  getCurrentDropEffect() {
    return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
  }
  getCurrentSourcePreviewNodeOptions() {
    const t = this.monitor.getSourceId(), n = this.sourcePreviewNodeOptions.get(t);
    return GE({
      anchorX: 0.5,
      anchorY: 0.5,
      captureDraggingState: !1
    }, n || {});
  }
  isDraggingNativeItem() {
    const t = this.monitor.getItemType();
    return Object.keys(WE).some(
      (n) => WE[n] === t
    );
  }
  beginDragNativeItem(t, n) {
    this.clearCurrentDragSourceNode(), this.currentNativeSource = pQ(t, n), this.currentNativeHandle = this.registry.addSource(t, this.currentNativeSource), this.actions.beginDrag([
      this.currentNativeHandle
    ]);
  }
  setCurrentDragSourceNode(t) {
    this.clearCurrentDragSourceNode(), this.currentDragSourceNode = t;
    const n = 1e3;
    this.mouseMoveTimeoutTimer = setTimeout(() => {
      var r;
      return (r = this.rootElement) === null || r === void 0 ? void 0 : r.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
    }, n);
  }
  clearCurrentDragSourceNode() {
    if (this.currentDragSourceNode) {
      if (this.currentDragSourceNode = null, this.rootElement) {
        var t;
        (t = this.window) === null || t === void 0 || t.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
      }
      return this.mouseMoveTimeoutTimer = null, !0;
    }
    return !1;
  }
  handleDragStart(t, n) {
    t.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(n));
  }
  handleDragEnter(t, n) {
    this.dragEnterTargetIds.unshift(n);
  }
  handleDragOver(t, n) {
    this.dragOverTargetIds === null && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(n);
  }
  handleDrop(t, n) {
    this.dropTargetIds.unshift(n);
  }
  constructor(t, n, r) {
    this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourceNodeOptions = /* @__PURE__ */ new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = !1, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.lastClientOffset = null, this.hoverRafId = null, this.getSourceClientOffset = (i) => {
      const o = this.sourceNodes.get(i);
      return o && _A(o) || null;
    }, this.endDragNativeItem = () => {
      this.isDraggingNativeItem() && (this.actions.endDrag(), this.currentNativeHandle && this.registry.removeSource(this.currentNativeHandle), this.currentNativeHandle = null, this.currentNativeSource = null);
    }, this.isNodeInDocument = (i) => !!(i && this.document && this.document.body && this.document.body.contains(i)), this.endDragIfSourceWasRemovedFromDOM = () => {
      const i = this.currentDragSourceNode;
      i == null || this.isNodeInDocument(i) || (this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover());
    }, this.scheduleHover = (i) => {
      this.hoverRafId === null && typeof requestAnimationFrame < "u" && (this.hoverRafId = requestAnimationFrame(() => {
        this.monitor.isDragging() && this.actions.hover(i || [], {
          clientOffset: this.lastClientOffset
        }), this.hoverRafId = null;
      }));
    }, this.cancelHover = () => {
      this.hoverRafId !== null && typeof cancelAnimationFrame < "u" && (cancelAnimationFrame(this.hoverRafId), this.hoverRafId = null);
    }, this.handleTopDragStartCapture = () => {
      this.clearCurrentDragSourceNode(), this.dragStartSourceIds = [];
    }, this.handleTopDragStart = (i) => {
      if (i.defaultPrevented)
        return;
      const { dragStartSourceIds: o } = this;
      this.dragStartSourceIds = null;
      const a = Qc(i);
      this.monitor.isDragging() && (this.actions.endDrag(), this.cancelHover()), this.actions.beginDrag(o || [], {
        publishSource: !1,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset: a
      });
      const { dataTransfer: s } = i, l = ym(s);
      if (this.monitor.isDragging()) {
        if (s && typeof s.setDragImage == "function") {
          const c = this.monitor.getSourceId(), f = this.sourceNodes.get(c), d = this.sourcePreviewNodes.get(c) || f;
          if (d) {
            const { anchorX: p, anchorY: h, offsetX: m, offsetY: v } = this.getCurrentSourcePreviewNodeOptions(), E = yQ(f, d, a, {
              anchorX: p,
              anchorY: h
            }, {
              offsetX: m,
              offsetY: v
            });
            s.setDragImage(d, E.x, E.y);
          }
        }
        try {
          s?.setData("application/json", {});
        } catch {
        }
        this.setCurrentDragSourceNode(i.target);
        const { captureDraggingState: u } = this.getCurrentSourcePreviewNodeOptions();
        u ? this.actions.publishDragSource() : setTimeout(
          () => this.actions.publishDragSource(),
          0
        );
      } else if (l)
        this.beginDragNativeItem(l);
      else {
        if (s && !s.types && (i.target && !i.target.hasAttribute || !i.target.hasAttribute("draggable")))
          return;
        i.preventDefault();
      }
    }, this.handleTopDragEndCapture = () => {
      this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleTopDragEnterCapture = (i) => {
      if (this.dragEnterTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
      if (!this.enterLeaveCounter.enter(i.target) || this.monitor.isDragging())
        return;
      const { dataTransfer: s } = i, l = ym(s);
      l && this.beginDragNativeItem(l, s);
    }, this.handleTopDragEnter = (i) => {
      const { dragEnterTargetIds: o } = this;
      if (this.dragEnterTargetIds = [], !this.monitor.isDragging())
        return;
      this.altKeyPressed = i.altKey, o.length > 0 && this.actions.hover(o, {
        clientOffset: Qc(i)
      }), o.some(
        (s) => this.monitor.canDropOnTarget(s)
      ) && (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect()));
    }, this.handleTopDragOverCapture = (i) => {
      if (this.dragOverTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
    }, this.handleTopDragOver = (i) => {
      const { dragOverTargetIds: o } = this;
      if (this.dragOverTargetIds = [], !this.monitor.isDragging()) {
        i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none");
        return;
      }
      this.altKeyPressed = i.altKey, this.lastClientOffset = Qc(i), this.scheduleHover(o), (o || []).some(
        (s) => this.monitor.canDropOnTarget(s)
      ) ? (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect())) : this.isDraggingNativeItem() ? i.preventDefault() : (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none"));
    }, this.handleTopDragLeaveCapture = (i) => {
      this.isDraggingNativeItem() && i.preventDefault(), this.enterLeaveCounter.leave(i.target) && (this.isDraggingNativeItem() && setTimeout(
        () => this.endDragNativeItem(),
        0
      ), this.cancelHover());
    }, this.handleTopDropCapture = (i) => {
      if (this.dropTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        i.preventDefault(), (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      } else ym(i.dataTransfer) && i.preventDefault();
      this.enterLeaveCounter.reset();
    }, this.handleTopDrop = (i) => {
      const { dropTargetIds: o } = this;
      this.dropTargetIds = [], this.actions.hover(o, {
        clientOffset: Qc(i)
      }), this.actions.drop({
        dropEffect: this.getCurrentDropEffect()
      }), this.isDraggingNativeItem() ? this.endDragNativeItem() : this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleSelectStart = (i) => {
      const o = i.target;
      typeof o.dragDrop == "function" && (o.tagName === "INPUT" || o.tagName === "SELECT" || o.tagName === "TEXTAREA" || o.isContentEditable || (i.preventDefault(), o.dragDrop()));
    }, this.options = new bQ(n, r), this.actions = t.getActions(), this.monitor = t.getMonitor(), this.registry = t.getRegistry(), this.enterLeaveCounter = new fQ(this.isNodeInDocument);
  }
}
const xQ = function(t, n, r) {
  return new wQ(t, n, r);
}, EQ = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function Bs(e, t, n) {
  const r = SQ(e), { webkitRelativePath: i } = e, o = typeof t == "string" ? t : typeof i == "string" && i.length > 0 ? i : `./${e.name}`;
  return typeof r.path != "string" && YE(r, "path", o), YE(r, "relativePath", o), r;
}
function SQ(e) {
  const { name: t } = e;
  if (t && t.lastIndexOf(".") !== -1 && !e.type) {
    const r = t.split(".").pop().toLowerCase(), i = EQ.get(r);
    i && Object.defineProperty(e, "type", {
      value: i,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
function YE(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const $Q = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function TQ(e) {
  return Na(this, void 0, void 0, function* () {
    return Ad(e) && OQ(e.dataTransfer) ? AQ(e.dataTransfer, e.type) : kQ(e) ? PQ(e) : Array.isArray(e) && e.every((t) => "getFile" in t && typeof t.getFile == "function") ? DQ(e) : [];
  });
}
function OQ(e) {
  return Ad(e);
}
function kQ(e) {
  return Ad(e) && Ad(e.target);
}
function Ad(e) {
  return typeof e == "object" && e !== null;
}
function PQ(e) {
  return Ag(e.target.files).map((t) => Bs(t));
}
function DQ(e) {
  return Na(this, void 0, void 0, function* () {
    return (yield Promise.all(e.map((n) => n.getFile()))).map((n) => Bs(n));
  });
}
function AQ(e, t) {
  return Na(this, void 0, void 0, function* () {
    if (e.items) {
      const n = Ag(e.items).filter((i) => i.kind === "file");
      if (t !== "drop")
        return n;
      const r = yield Promise.all(n.map(CQ));
      return QE(wA(r));
    }
    return QE(Ag(e.files).map((n) => Bs(n)));
  });
}
function QE(e) {
  return e.filter((t) => $Q.indexOf(t.name) === -1);
}
function Ag(e) {
  if (e === null)
    return [];
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    t.push(r);
  }
  return t;
}
function CQ(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return JE(e);
  const t = e.webkitGetAsEntry();
  return t && t.isDirectory ? xA(t) : JE(e, t);
}
function wA(e) {
  return e.reduce((t, n) => [
    ...t,
    ...Array.isArray(n) ? wA(n) : [n]
  ], []);
}
function JE(e, t) {
  return Na(this, void 0, void 0, function* () {
    var n;
    if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
      const o = yield e.getAsFileSystemHandle();
      if (o === null)
        throw new Error(`${e} is not a File`);
      if (o !== void 0) {
        const a = yield o.getFile();
        return a.handle = o, Bs(a);
      }
    }
    const r = e.getAsFile();
    if (!r)
      throw new Error(`${e} is not a File`);
    return Bs(r, (n = t?.fullPath) !== null && n !== void 0 ? n : void 0);
  });
}
function IQ(e) {
  return Na(this, void 0, void 0, function* () {
    return e.isDirectory ? xA(e) : MQ(e);
  });
}
function xA(e) {
  const t = e.createReader();
  return new Promise((n, r) => {
    const i = [];
    function o() {
      t.readEntries((a) => Na(this, void 0, void 0, function* () {
        if (a.length) {
          const s = Promise.all(a.map(IQ));
          i.push(s), o();
        } else
          try {
            const s = yield Promise.all(i);
            n(s);
          } catch (s) {
            r(s);
          }
      }), (a) => {
        r(a);
      });
    }
    o();
  });
}
function MQ(e) {
  return Na(this, void 0, void 0, function* () {
    return new Promise((t, n) => {
      e.file((r) => {
        const i = Bs(r, e.fullPath);
        t(i);
      }, (r) => {
        n(r);
      });
    });
  });
}
var Jc = {}, XE;
function RQ() {
  return XE || (XE = 1, Jc.__esModule = !0, Jc.default = function(e, t) {
    if (e && t) {
      var n = Array.isArray(t) ? t : t.split(",");
      if (n.length === 0)
        return !0;
      var r = e.name || "", i = (e.type || "").toLowerCase(), o = i.replace(/\/.*$/, "");
      return n.some(function(a) {
        var s = a.trim().toLowerCase();
        return s.charAt(0) === "." ? r.toLowerCase().endsWith(s) : s.endsWith("/*") ? o === s.replace(/\/.*$/, "") : i === s;
      });
    }
    return !0;
  }), Jc;
}
var NQ = RQ();
const bm = /* @__PURE__ */ Yd(NQ);
function eS(e) {
  return zQ(e) || FQ(e) || SA(e) || jQ();
}
function jQ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FQ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function zQ(e) {
  if (Array.isArray(e)) return Cg(e);
}
function tS(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function nS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tS(Object(n), !0).forEach(function(r) {
      EA(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tS(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function EA(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Fu(e, t) {
  return BQ(e) || VQ(e, t) || SA(e, t) || LQ();
}
function LQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SA(e, t) {
  if (e) {
    if (typeof e == "string") return Cg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Cg(e, t);
  }
}
function Cg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function VQ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, a, s;
    try {
      for (n = n.call(e); !(i = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function BQ(e) {
  if (Array.isArray(e)) return e;
}
var KQ = typeof bm == "function" ? bm : bm.default, UQ = "file-invalid-type", qQ = "file-too-large", HQ = "file-too-small", WQ = "too-many-files", ZQ = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = t.split(","), r = n.length > 1 ? "one of ".concat(n.join(", ")) : n[0];
  return {
    code: UQ,
    message: "File type must be ".concat(r)
  };
}, rS = function(t) {
  return {
    code: qQ,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, iS = function(t) {
  return {
    code: HQ,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, GQ = {
  code: WQ,
  message: "Too many files"
};
function YQ(e) {
  return e.type === "" && typeof e.getAsFile == "function";
}
function $A(e, t) {
  var n = e.type === "application/x-moz-file" || KQ(e, t) || YQ(e);
  return [n, n ? null : ZQ(t)];
}
function TA(e, t, n) {
  if (ta(e.size))
    if (ta(t) && ta(n)) {
      if (e.size > n) return [!1, rS(n)];
      if (e.size < t) return [!1, iS(t)];
    } else {
      if (ta(t) && e.size < t) return [!1, iS(t)];
      if (ta(n) && e.size > n) return [!1, rS(n)];
    }
  return [!0, null];
}
function ta(e) {
  return e != null;
}
function QQ(e) {
  var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, o = e.multiple, a = e.maxFiles, s = e.validator;
  return !o && t.length > 1 || o && a >= 1 && t.length > a ? !1 : t.every(function(l) {
    var u = $A(l, n), c = Fu(u, 1), f = c[0], d = TA(l, r, i), p = Fu(d, 1), h = p[0], m = s ? s(l) : null;
    return f && h && !m;
  });
}
function Cd(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function Fl(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function oS(e) {
  e.preventDefault();
}
function JQ(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function XQ(e) {
  return e.indexOf("Edge/") !== -1;
}
function eJ() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return JQ(e) || XQ(e);
}
function vi() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
      o[a - 1] = arguments[a];
    return t.some(function(s) {
      return !Cd(r) && s && s.apply(void 0, [r].concat(o)), Cd(r);
    });
  };
}
function tJ() {
  return "showOpenFilePicker" in window;
}
function nJ(e) {
  if (ta(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = Fu(n, 2), i = r[0], o = r[1], a = !0;
      return OA(i) || (console.warn('Skipped "'.concat(i, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), a = !1), (!Array.isArray(o) || !o.every(kA)) && (console.warn('Skipped "'.concat(i, '" because an invalid file extension was provided.')), a = !1), a;
    }).reduce(function(n, r) {
      var i = Fu(r, 2), o = i[0], a = i[1];
      return nS(nS({}, n), {}, EA({}, o, a));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function rJ(e) {
  if (ta(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = Fu(n, 2), i = r[0], o = r[1];
      return [].concat(eS(t), [i], eS(o));
    }, []).filter(function(t) {
      return OA(t) || kA(t);
    }).join(",");
}
function iJ(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function oJ(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function OA(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function kA(e) {
  return /^.*\.[\w]+$/.test(e);
}
var aJ = ["children"], sJ = ["open"], lJ = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], uJ = ["refKey", "onChange", "onClick"];
function aS(e) {
  return dJ(e) || fJ(e) || PA(e) || cJ();
}
function cJ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fJ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function dJ(e) {
  if (Array.isArray(e)) return Ig(e);
}
function _m(e, t) {
  return mJ(e) || hJ(e, t) || PA(e, t) || pJ();
}
function pJ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PA(e, t) {
  if (e) {
    if (typeof e == "string") return Ig(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ig(e, t);
  }
}
function Ig(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function hJ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, a, s;
    try {
      for (n = n.call(e); !(i = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function mJ(e) {
  if (Array.isArray(e)) return e;
}
function sS(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ot(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sS(Object(n), !0).forEach(function(r) {
      Mg(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sS(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Mg(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Id(e, t) {
  if (e == null) return {};
  var n = vJ(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function vJ(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var h0 = /* @__PURE__ */ Jt(function(e, t) {
  var n = e.children, r = Id(e, aJ), i = AA(r), o = i.open, a = Id(i, sJ);
  return n6(t, function() {
    return {
      open: o
    };
  }, [o]), /* @__PURE__ */ G.createElement(wy, null, n(Ot(Ot({}, a), {}, {
    open: o
  })));
});
h0.displayName = "Dropzone";
var DA = {
  disabled: !1,
  getFilesFromEvent: TQ,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
h0.defaultProps = DA;
h0.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: Re.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: Re.objectOf(Re.arrayOf(Re.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: Re.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: Re.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: Re.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: Re.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: Re.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: Re.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: Re.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: Re.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: Re.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: Re.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: Re.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: Re.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: Re.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: Re.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: Re.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: Re.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: Re.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: Re.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: Re.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: Re.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: Re.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: Re.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: Re.func
};
var Rg = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  isDragGlobal: !1,
  acceptedFiles: [],
  fileRejections: []
};
function AA() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Ot(Ot({}, DA), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, o = t.maxSize, a = t.minSize, s = t.multiple, l = t.maxFiles, u = t.onDragEnter, c = t.onDragLeave, f = t.onDragOver, d = t.onDrop, p = t.onDropAccepted, h = t.onDropRejected, m = t.onFileDialogCancel, v = t.onFileDialogOpen, g = t.useFsAccessApi, b = t.autoFocus, E = t.preventDropOnDocument, x = t.noClick, S = t.noKeyboard, $ = t.noDrag, P = t.noDragEventsBubbling, y = t.onError, _ = t.validator, w = Ee(function() {
    return rJ(n);
  }, [n]), A = Ee(function() {
    return nJ(n);
  }, [n]), k = Ee(function() {
    return typeof v == "function" ? v : lS;
  }, [v]), N = Ee(function() {
    return typeof m == "function" ? m : lS;
  }, [m]), I = ve(null), B = ve(null), q = b$(gJ, Rg), ee = _m(q, 2), re = ee[0], Z = ee[1], T = re.isFocused, F = re.isFileDialogActive, M = ve(typeof window < "u" && window.isSecureContext && g && tJ()), K = function() {
    !M.current && F && setTimeout(function() {
      if (B.current) {
        var J = B.current.files;
        J.length || (Z({
          type: "closeDialog"
        }), N());
      }
    }, 300);
  };
  De(function() {
    return window.addEventListener("focus", K, !1), function() {
      window.removeEventListener("focus", K, !1);
    };
  }, [B, F, N, M]);
  var te = ve([]), se = ve([]), de = function(J) {
    I.current && I.current.contains(J.target) || (J.preventDefault(), te.current = []);
  };
  De(function() {
    return E && (document.addEventListener("dragover", oS, !1), document.addEventListener("drop", de, !1)), function() {
      E && (document.removeEventListener("dragover", oS), document.removeEventListener("drop", de));
    };
  }, [I, E]), De(function() {
    var Q = function(qe) {
      se.current = [].concat(aS(se.current), [qe.target]), Fl(qe) && Z({
        isDragGlobal: !0,
        type: "setDragGlobal"
      });
    }, J = function(qe) {
      se.current = se.current.filter(function(rt) {
        return rt !== qe.target && rt !== null;
      }), !(se.current.length > 0) && Z({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    }, ae = function() {
      se.current = [], Z({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    }, be = function() {
      se.current = [], Z({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    };
    return document.addEventListener("dragenter", Q, !1), document.addEventListener("dragleave", J, !1), document.addEventListener("dragend", ae, !1), document.addEventListener("drop", be, !1), function() {
      document.removeEventListener("dragenter", Q), document.removeEventListener("dragleave", J), document.removeEventListener("dragend", ae), document.removeEventListener("drop", be);
    };
  }, [I]), De(function() {
    return !r && b && I.current && I.current.focus(), function() {
    };
  }, [I, b, r]);
  var ge = Ne(function(Q) {
    y ? y(Q) : console.error(Q);
  }, [y]), V = Ne(function(Q) {
    Q.preventDefault(), Q.persist(), pe(Q), te.current = [].concat(aS(te.current), [Q.target]), Fl(Q) && Promise.resolve(i(Q)).then(function(J) {
      if (!(Cd(Q) && !P)) {
        var ae = J.length, be = ae > 0 && QQ({
          files: J,
          accept: w,
          minSize: a,
          maxSize: o,
          multiple: s,
          maxFiles: l,
          validator: _
        }), Ae = ae > 0 && !be;
        Z({
          isDragAccept: be,
          isDragReject: Ae,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), u && u(Q);
      }
    }).catch(function(J) {
      return ge(J);
    });
  }, [i, u, ge, P, w, a, o, s, l, _]), O = Ne(function(Q) {
    Q.preventDefault(), Q.persist(), pe(Q);
    var J = Fl(Q);
    if (J && Q.dataTransfer)
      try {
        Q.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return J && f && f(Q), !1;
  }, [f, P]), D = Ne(function(Q) {
    Q.preventDefault(), Q.persist(), pe(Q);
    var J = te.current.filter(function(be) {
      return I.current && I.current.contains(be);
    }), ae = J.indexOf(Q.target);
    ae !== -1 && J.splice(ae, 1), te.current = J, !(J.length > 0) && (Z({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), Fl(Q) && c && c(Q));
  }, [I, c, P]), C = Ne(function(Q, J) {
    var ae = [], be = [];
    Q.forEach(function(Ae) {
      var qe = $A(Ae, w), rt = _m(qe, 2), mt = rt[0], _t = rt[1], ci = TA(Ae, a, o), fi = _m(ci, 2), Ri = fi[0], Wo = fi[1], di = _ ? _(Ae) : null;
      if (mt && Ri && !di)
        ae.push(Ae);
      else {
        var no = [_t, Wo];
        di && (no = no.concat(di)), be.push({
          file: Ae,
          errors: no.filter(function(zr) {
            return zr;
          })
        });
      }
    }), (!s && ae.length > 1 || s && l >= 1 && ae.length > l) && (ae.forEach(function(Ae) {
      be.push({
        file: Ae,
        errors: [GQ]
      });
    }), ae.splice(0)), Z({
      acceptedFiles: ae,
      fileRejections: be,
      isDragReject: be.length > 0,
      type: "setFiles"
    }), d && d(ae, be, J), be.length > 0 && h && h(be, J), ae.length > 0 && p && p(ae, J);
  }, [Z, s, w, a, o, l, d, p, h, _]), z = Ne(function(Q) {
    Q.preventDefault(), Q.persist(), pe(Q), te.current = [], Fl(Q) && Promise.resolve(i(Q)).then(function(J) {
      Cd(Q) && !P || C(J, Q);
    }).catch(function(J) {
      return ge(J);
    }), Z({
      type: "reset"
    });
  }, [i, C, ge, P]), H = Ne(function() {
    if (M.current) {
      Z({
        type: "openDialog"
      }), k();
      var Q = {
        multiple: s,
        types: A
      };
      window.showOpenFilePicker(Q).then(function(J) {
        return i(J);
      }).then(function(J) {
        C(J, null), Z({
          type: "closeDialog"
        });
      }).catch(function(J) {
        iJ(J) ? (N(J), Z({
          type: "closeDialog"
        })) : oJ(J) ? (M.current = !1, B.current ? (B.current.value = null, B.current.click()) : ge(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : ge(J);
      });
      return;
    }
    B.current && (Z({
      type: "openDialog"
    }), k(), B.current.value = null, B.current.click());
  }, [Z, k, N, g, C, ge, A, s]), X = Ne(function(Q) {
    !I.current || !I.current.isEqualNode(Q.target) || (Q.key === " " || Q.key === "Enter" || Q.keyCode === 32 || Q.keyCode === 13) && (Q.preventDefault(), H());
  }, [I, H]), fe = Ne(function() {
    Z({
      type: "focus"
    });
  }, []), ce = Ne(function() {
    Z({
      type: "blur"
    });
  }, []), xe = Ne(function() {
    x || (eJ() ? setTimeout(H, 0) : H());
  }, [x, H]), ne = function(J) {
    return r ? null : J;
  }, we = function(J) {
    return S ? null : ne(J);
  }, ke = function(J) {
    return $ ? null : ne(J);
  }, pe = function(J) {
    P && J.stopPropagation();
  }, j = Ee(function() {
    return function() {
      var Q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, J = Q.refKey, ae = J === void 0 ? "ref" : J, be = Q.role, Ae = Q.onKeyDown, qe = Q.onFocus, rt = Q.onBlur, mt = Q.onClick, _t = Q.onDragEnter, ci = Q.onDragOver, fi = Q.onDragLeave, Ri = Q.onDrop, Wo = Id(Q, lJ);
      return Ot(Ot(Mg({
        onKeyDown: we(vi(Ae, X)),
        onFocus: we(vi(qe, fe)),
        onBlur: we(vi(rt, ce)),
        onClick: ne(vi(mt, xe)),
        onDragEnter: ke(vi(_t, V)),
        onDragOver: ke(vi(ci, O)),
        onDragLeave: ke(vi(fi, D)),
        onDrop: ke(vi(Ri, z)),
        role: typeof be == "string" && be !== "" ? be : "presentation"
      }, ae, I), !r && !S ? {
        tabIndex: 0
      } : {}), Wo);
    };
  }, [I, X, fe, ce, xe, V, O, D, z, S, $, r]), U = Ne(function(Q) {
    Q.stopPropagation();
  }, []), Y = Ee(function() {
    return function() {
      var Q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, J = Q.refKey, ae = J === void 0 ? "ref" : J, be = Q.onChange, Ae = Q.onClick, qe = Id(Q, uJ), rt = Mg({
        accept: w,
        multiple: s,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: ne(vi(be, z)),
        onClick: ne(vi(Ae, U)),
        tabIndex: -1
      }, ae, B);
      return Ot(Ot({}, rt), qe);
    };
  }, [B, n, s, z, r]);
  return Ot(Ot({}, re), {}, {
    isFocused: T && !r,
    getRootProps: j,
    getInputProps: Y,
    rootRef: I,
    inputRef: B,
    open: ne(H)
  });
}
function gJ(e, t) {
  switch (t.type) {
    case "focus":
      return Ot(Ot({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return Ot(Ot({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return Ot(Ot({}, Rg), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return Ot(Ot({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return Ot(Ot({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return Ot(Ot({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections,
        isDragReject: t.isDragReject
      });
    case "setDragGlobal":
      return Ot(Ot({}, e), {}, {
        isDragGlobal: t.isDragGlobal
      });
    case "reset":
      return Ot({}, Rg);
    default:
      return e;
  }
}
function lS() {
}
const CA = (e) => /* @__PURE__ */ R.jsx("input", { type: "checkbox", ...e, className: "bg-neutral-600 checkbox" });
var pc = (e) => e.type === "checkbox", ca = (e) => e instanceof Date, Kn = (e) => e == null;
const IA = (e) => typeof e == "object";
var Gt = (e) => !Kn(e) && !Array.isArray(e) && IA(e) && !ca(e), yJ = (e) => Gt(e) && e.target ? pc(e.target) ? e.target.checked : e.target.value : e, MA = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, bJ = (e, t) => e.has(MA(t)), _J = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Gt(t) && t.hasOwnProperty("isPrototypeOf");
}, m0 = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function sn(e) {
  if (e instanceof Date)
    return new Date(e);
  const t = typeof FileList < "u" && e instanceof FileList;
  if (m0 && (e instanceof Blob || t))
    return e;
  const n = Array.isArray(e);
  if (!n && !(Gt(e) && _J(e)))
    return e;
  const r = n ? [] : Object.create(Object.getPrototypeOf(e));
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (r[i] = sn(e[i]));
  return r;
}
var Lp = (e) => /^\w*$/.test(e), Vt = (e) => e === void 0, v0 = (e) => Array.isArray(e) ? e.filter(Boolean) : [], g0 = (e) => v0(e.replace(/["|']|\]/g, "").split(/\.|\[/)), ze = (e, t, n) => {
  if (!t || !Gt(e))
    return n;
  const r = (Lp(t) ? [t] : g0(t)).reduce((i, o) => Kn(i) ? i : i[o], e);
  return Vt(r) || r === e ? Vt(e[t]) ? n : e[t] : r;
}, yi = (e) => typeof e == "boolean", Zr = (e) => typeof e == "function", Tt = (e, t, n) => {
  let r = -1;
  const i = Lp(t) ? [t] : g0(t), o = i.length, a = o - 1;
  for (; ++r < o; ) {
    const s = i[r];
    let l = n;
    if (r !== a) {
      const u = e[s];
      l = Gt(u) || Array.isArray(u) ? u : isNaN(+i[r + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    e[s] = l, e = e[s];
  }
};
const Ja = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  SUBMIT: "submit",
  TRIGGER: "trigger",
  VALID: "valid"
}, Gr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, qr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, wm = "form", RA = "root", wJ = G.createContext(null);
wJ.displayName = "HookFormControlContext";
var xJ = (e, t, n, r = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const o in e)
    Object.defineProperty(i, o, {
      get: () => {
        const a = o;
        return t._proxyFormState[a] !== Gr.all && (t._proxyFormState[a] = !r || Gr.all), e[a];
      }
    });
  return i;
};
const EJ = typeof window < "u" ? G.useLayoutEffect : G.useEffect;
var In = (e) => typeof e == "string", SJ = (e, t, n, r, i) => In(e) ? (r && t.watch.add(e), ze(n, e, i)) : Array.isArray(e) ? e.map((o) => (r && t.watch.add(o), ze(n, o))) : (r && (t.watchAll = !0), n), Ng = (e) => Kn(e) || !IA(e);
function ho(e, t, n = /* @__PURE__ */ new WeakSet()) {
  if (Ng(e) || Ng(t))
    return Object.is(e, t);
  if (ca(e) && ca(t))
    return Object.is(e.getTime(), t.getTime());
  const r = Object.keys(e), i = Object.keys(t);
  if (r.length !== i.length)
    return !1;
  if (n.has(e) || n.has(t))
    return !0;
  n.add(e), n.add(t);
  for (const o of r) {
    const a = e[o];
    if (!i.includes(o))
      return !1;
    if (o !== "ref") {
      const s = t[o];
      if (ca(a) && ca(s) || Gt(a) && Gt(s) || Array.isArray(a) && Array.isArray(s) ? !ho(a, s, n) : !Object.is(a, s))
        return !1;
    }
  }
  return !0;
}
const $J = G.createContext(null);
$J.displayName = "HookFormContext";
var TJ = (e, t, n, r, i) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: i || !0
  }
} : {}, pu = (e) => Array.isArray(e) ? e : [e], uS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const o of e)
        o.next && o.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
};
function NA(e, t) {
  const n = {};
  for (const r in e)
    if (e.hasOwnProperty(r)) {
      const i = e[r], o = t[r];
      if (i && Gt(i) && o) {
        const a = NA(i, o);
        Gt(a) && (n[r] = a);
      } else e[r] && (n[r] = o);
    }
  return n;
}
var An = (e) => Gt(e) && !Object.keys(e).length, y0 = (e) => e.type === "file", Md = (e) => {
  if (!m0)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, jA = (e) => e.type === "select-multiple", b0 = (e) => e.type === "radio", OJ = (e) => b0(e) || pc(e), xm = (e) => Md(e) && e.isConnected;
function kJ(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = Vt(e) ? r++ : e[t[r++]];
  return e;
}
function PJ(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !Vt(e[t]))
      return !1;
  return !0;
}
function nn(e, t) {
  const n = Array.isArray(t) ? t : Lp(t) ? [t] : g0(t), r = n.length === 1 ? e : kJ(e, n), i = n.length - 1, o = n[i];
  return r && delete r[o], i !== 0 && (Gt(r) && An(r) || Array.isArray(r) && PJ(r)) && nn(e, n.slice(0, -1)), e;
}
var DJ = (e) => {
  for (const t in e)
    if (Zr(e[t]))
      return !0;
  return !1;
};
function FA(e) {
  return Array.isArray(e) || Gt(e) && !DJ(e);
}
function jg(e, t = {}) {
  for (const n in e) {
    const r = e[n];
    FA(r) ? (t[n] = Array.isArray(r) ? [] : {}, jg(r, t[n])) : Vt(r) || (t[n] = !0);
  }
  return t;
}
function rs(e, t, n) {
  n || (n = jg(t));
  for (const r in e) {
    const i = e[r];
    if (FA(i))
      Vt(t) || Ng(n[r]) ? n[r] = jg(i, Array.isArray(i) ? [] : {}) : rs(i, Kn(t) ? {} : t[r], n[r]);
    else {
      const o = t[r];
      n[r] = !ho(i, o);
    }
  }
  return n;
}
const cS = {
  value: !1,
  isValid: !1
}, fS = { value: !0, isValid: !0 };
var zA = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Vt(e[0].attributes.value) ? Vt(e[0].value) || e[0].value === "" ? fS : { value: e[0].value, isValid: !0 } : fS
    ) : cS;
  }
  return cS;
}, LA = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => Vt(e) ? e : t ? e === "" ? NaN : e && +e : n && In(e) ? new Date(e) : r ? r(e) : e;
const dS = {
  isValid: !1,
  value: null
};
var VA = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, dS) : dS;
function pS(e) {
  const t = e.ref;
  return y0(t) ? t.files : b0(t) ? VA(e.refs).value : jA(t) ? [...t.selectedOptions].map(({ value: n }) => n) : pc(t) ? zA(e.refs).value : LA(Vt(t.value) ? e.ref.value : t.value, e);
}
var AJ = (e, t, n, r) => {
  const i = {};
  for (const o of e) {
    const a = ze(t, o);
    a && Tt(i, o, a._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: r
  };
}, Rd = (e) => e instanceof RegExp, zl = (e) => Vt(e) ? e : Rd(e) ? e.source : Gt(e) ? Rd(e.value) ? e.value.source : e.value : e, hS = (e) => ({
  isOnSubmit: !e || e === Gr.onSubmit,
  isOnBlur: e === Gr.onBlur,
  isOnChange: e === Gr.onChange,
  isOnAll: e === Gr.all,
  isOnTouch: e === Gr.onTouched
});
const mS = "AsyncFunction";
var CJ = (e) => !!e && !!e.validate && !!(Zr(e.validate) && e.validate.constructor.name === mS || Gt(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === mS)), IJ = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), vS = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const hu = (e, t, n, r) => {
  for (const i of n || Object.keys(e)) {
    const o = ze(e, i);
    if (o) {
      const { _f: a, ...s } = o;
      if (a) {
        if (a.refs && a.refs[0] && t(a.refs[0], i) && !r)
          return !0;
        if (a.ref && t(a.ref, a.name) && !r)
          return !0;
        if (hu(s, t))
          break;
      } else if (Gt(s) && hu(s, t))
        break;
    }
  }
};
function gS(e, t, n) {
  const r = ze(e, n);
  if (r || Lp(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const o = i.join("."), a = ze(t, o), s = ze(e, o);
    if (a && !Array.isArray(a) && n !== o)
      return { name: n };
    if (s && s.type)
      return {
        name: o,
        error: s
      };
    if (s && s.root && s.root.type)
      return {
        name: `${o}.root`,
        error: s.root
      };
    i.pop();
  }
  return {
    name: n
  };
}
var MJ = (e, t, n, r) => {
  n(e);
  const { name: i, ...o } = e;
  return An(o) || Object.keys(o).length >= Object.keys(t).length || Object.keys(o).find((a) => t[a] === (!r || Gr.all));
}, RJ = (e, t, n) => !e || !t || e === t || pu(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r))), NJ = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, jJ = (e, t) => !v0(ze(e, t)).length && nn(e, t), FJ = (e, t, n) => {
  const r = pu(ze(e, n));
  return Tt(r, RA, t[n]), Tt(e, n, r), e;
};
function yS(e, t, n = "validate") {
  if (In(e) || Array.isArray(e) && e.every(In) || yi(e) && !e)
    return {
      type: n,
      message: In(e) ? e : "",
      ref: t
    };
}
var Xa = (e) => Gt(e) && !Rd(e) ? e : {
  value: e,
  message: ""
}, bS = async (e, t, n, r, i, o) => {
  const { ref: a, refs: s, required: l, maxLength: u, minLength: c, min: f, max: d, pattern: p, validate: h, name: m, valueAsNumber: v, mount: g } = e._f, b = ze(n, m);
  if (!g || t.has(m))
    return {};
  const E = s ? s[0] : a, x = (k) => {
    i && E.reportValidity && (E.setCustomValidity(yi(k) ? "" : k || ""), E.reportValidity());
  }, S = {}, $ = b0(a), P = pc(a), y = $ || P, _ = (v || y0(a)) && Vt(a.value) && Vt(b) || Md(a) && a.value === "" || b === "" || Array.isArray(b) && !b.length, w = TJ.bind(null, m, r, S), A = (k, N, I, B = qr.maxLength, q = qr.minLength) => {
    const ee = k ? N : I;
    S[m] = {
      type: k ? B : q,
      message: ee,
      ref: a,
      ...w(k ? B : q, ee)
    };
  };
  if (o ? !Array.isArray(b) || !b.length : l && (!y && (_ || Kn(b)) || yi(b) && !b || P && !zA(s).isValid || $ && !VA(s).isValid)) {
    const { value: k, message: N } = In(l) ? { value: !!l, message: l } : Xa(l);
    if (k && (S[m] = {
      type: qr.required,
      message: N,
      ref: E,
      ...w(qr.required, N)
    }, !r))
      return x(N), S;
  }
  if (!_ && (!Kn(f) || !Kn(d))) {
    let k, N;
    const I = Xa(d), B = Xa(f);
    if (!Kn(b) && !isNaN(b)) {
      const q = a.valueAsNumber || b && +b;
      Kn(I.value) || (k = q > I.value), Kn(B.value) || (N = q < B.value);
    } else {
      const q = a.valueAsDate || new Date(b), ee = (T) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + T), re = a.type == "time", Z = a.type == "week";
      In(I.value) && b && (k = re ? ee(b) > ee(I.value) : Z ? b > I.value : q > new Date(I.value)), In(B.value) && b && (N = re ? ee(b) < ee(B.value) : Z ? b < B.value : q < new Date(B.value));
    }
    if ((k || N) && (A(!!k, I.message, B.message, qr.max, qr.min), !r))
      return x(S[m].message), S;
  }
  if ((u || c) && !_ && (In(b) || o && Array.isArray(b))) {
    const k = Xa(u), N = Xa(c), I = !Kn(k.value) && b.length > +k.value, B = !Kn(N.value) && b.length < +N.value;
    if ((I || B) && (A(I, k.message, N.message), !r))
      return x(S[m].message), S;
  }
  if (p && !_ && In(b)) {
    const { value: k, message: N } = Xa(p);
    if (Rd(k) && !b.match(k) && (S[m] = {
      type: qr.pattern,
      message: N,
      ref: a,
      ...w(qr.pattern, N)
    }, !r))
      return x(N), S;
  }
  if (h) {
    if (Zr(h)) {
      const k = await h(b, n), N = yS(k, E);
      if (N && (S[m] = {
        ...N,
        ...w(qr.validate, N.message)
      }, !r))
        return x(N.message), S;
    } else if (Gt(h)) {
      let k = {};
      for (const N in h) {
        if (!An(k) && !r)
          break;
        const I = yS(await h[N](b, n), E, N);
        I && (k = {
          ...I,
          ...w(N, I.message)
        }, x(I.message), r && (S[m] = k));
      }
      if (!An(k) && (S[m] = {
        ref: E,
        ...k
      }, !r))
        return S;
    }
  }
  return x(!0), S;
};
const zJ = {
  mode: Gr.onSubmit,
  reValidateMode: Gr.onChange,
  shouldFocusError: !0
};
function LJ(e = {}) {
  let t = {
    ...zJ,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: Zr(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, i = Gt(t.defaultValues) || Gt(t.values) ? sn(t.defaultValues || t.values) || {} : {}, o = t.shouldUnregister ? {} : sn(i), a = {
    action: !1,
    mount: !1,
    watch: !1,
    keepIsValid: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, u = 0;
  const c = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, f = {
    ...c
  };
  let d = {
    ...f
  };
  const p = {
    array: uS(),
    state: uS()
  }, h = t.criteriaMode === Gr.all, m = (j) => (U) => {
    clearTimeout(u), u = setTimeout(j, U);
  }, v = async (j) => {
    if (!a.keepIsValid && !t.disabled && (f.isValid || d.isValid || j)) {
      let U;
      t.resolver ? (U = An((await y()).errors), g()) : U = await A({
        fields: r,
        onlyCheckValid: !0,
        eventType: Ja.VALID
      }), U !== n.isValid && p.state.next({
        isValid: U
      });
    }
  }, g = (j, U) => {
    !t.disabled && (f.isValidating || f.validatingFields || d.isValidating || d.validatingFields) && ((j || Array.from(s.mount)).forEach((Y) => {
      Y && (U ? Tt(n.validatingFields, Y, U) : nn(n.validatingFields, Y));
    }), p.state.next({
      validatingFields: n.validatingFields,
      isValidating: !An(n.validatingFields)
    }));
  }, b = (j, U = [], Y, Q, J = !0, ae = !0) => {
    if (Q && Y && !t.disabled) {
      if (a.action = !0, ae && Array.isArray(ze(r, j))) {
        const be = Y(ze(r, j), Q.argA, Q.argB);
        J && Tt(r, j, be);
      }
      if (ae && Array.isArray(ze(n.errors, j))) {
        const be = Y(ze(n.errors, j), Q.argA, Q.argB);
        J && Tt(n.errors, j, be), jJ(n.errors, j);
      }
      if ((f.touchedFields || d.touchedFields) && ae && Array.isArray(ze(n.touchedFields, j))) {
        const be = Y(ze(n.touchedFields, j), Q.argA, Q.argB);
        J && Tt(n.touchedFields, j, be);
      }
      if (f.dirtyFields || d.dirtyFields) {
        const be = rs(i, o), Ae = MA(j);
        Tt(n.dirtyFields, Ae, ze(be, Ae));
      }
      p.state.next({
        name: j,
        isDirty: N(j, U),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      Tt(o, j, U);
  }, E = (j, U) => {
    Tt(n.errors, j, U), p.state.next({
      errors: n.errors
    });
  }, x = (j) => {
    n.errors = j, p.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, S = (j, U, Y, Q) => {
    const J = ze(r, j);
    if (J) {
      const ae = ze(o, j, Vt(Y) ? ze(i, j) : Y);
      Vt(ae) || Q && Q.defaultChecked || U ? Tt(o, j, U ? ae : pS(J._f)) : q(j, ae), a.mount && !a.action && v();
    }
  }, $ = (j, U, Y, Q, J) => {
    let ae = !1, be = !1;
    const Ae = {
      name: j
    };
    if (!t.disabled) {
      if (!Y || Q) {
        (f.isDirty || d.isDirty) && (be = n.isDirty, n.isDirty = Ae.isDirty = N(), ae = be !== Ae.isDirty);
        const qe = ho(ze(i, j), U);
        be = !!ze(n.dirtyFields, j), qe ? nn(n.dirtyFields, j) : Tt(n.dirtyFields, j, !0), Ae.dirtyFields = n.dirtyFields, ae = ae || (f.dirtyFields || d.dirtyFields) && be !== !qe;
      }
      if (Y) {
        const qe = ze(n.touchedFields, j);
        qe || (Tt(n.touchedFields, j, Y), Ae.touchedFields = n.touchedFields, ae = ae || (f.touchedFields || d.touchedFields) && qe !== Y);
      }
      ae && J && p.state.next(Ae);
    }
    return ae ? Ae : {};
  }, P = (j, U, Y, Q) => {
    const J = ze(n.errors, j), ae = (f.isValid || d.isValid) && yi(U) && n.isValid !== U;
    if (t.delayError && Y ? (l = m(() => E(j, Y)), l(t.delayError)) : (clearTimeout(u), l = null, Y ? Tt(n.errors, j, Y) : nn(n.errors, j)), (Y ? !ho(J, Y) : J) || !An(Q) || ae) {
      const be = {
        ...Q,
        ...ae && yi(U) ? { isValid: U } : {},
        errors: n.errors,
        name: j
      };
      n = {
        ...n,
        ...be
      }, p.state.next(be);
    }
  }, y = async (j) => (g(j, !0), await t.resolver(o, t.context, AJ(j || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation))), _ = async (j) => {
    const { errors: U } = await y(j);
    if (g(j), j)
      for (const Y of j) {
        const Q = ze(U, Y);
        Q ? Tt(n.errors, Y, Q) : nn(n.errors, Y);
      }
    else
      n.errors = U;
    return U;
  }, w = async ({ name: j, eventType: U }) => {
    if (e.validate) {
      const Y = await e.validate({
        formValues: o,
        formState: n,
        name: j,
        eventType: U
      });
      if (Gt(Y))
        for (const Q in Y)
          Y[Q] && se(`${wm}.${Q}`, {
            message: In(Y.message) ? Y.message : "",
            type: qr.validate
          });
      else In(Y) || !Y ? se(wm, {
        message: Y || "",
        type: qr.validate
      }) : te(wm);
      return Y;
    }
    return !0;
  }, A = async ({ fields: j, onlyCheckValid: U, name: Y, eventType: Q, context: J = {
    valid: !0,
    runRootValidation: !1
  } }) => {
    if (e.validate && (J.runRootValidation = !0, !await w({
      name: Y,
      eventType: Q
    }) && (J.valid = !1, U)))
      return J.valid;
    for (const ae in j) {
      const be = j[ae];
      if (be) {
        const { _f: Ae, ...qe } = be;
        if (Ae) {
          const rt = s.array.has(Ae.name), mt = be._f && CJ(be._f);
          mt && f.validatingFields && g([Ae.name], !0);
          const _t = await bS(be, s.disabled, o, h, t.shouldUseNativeValidation && !U, rt);
          if (mt && f.validatingFields && g([Ae.name]), _t[Ae.name] && (J.valid = !1, U) || (!U && (ze(_t, Ae.name) ? rt ? FJ(n.errors, _t, Ae.name) : Tt(n.errors, Ae.name, _t[Ae.name]) : nn(n.errors, Ae.name)), e.shouldUseNativeValidation && _t[Ae.name]))
            break;
        }
        !An(qe) && await A({
          context: J,
          onlyCheckValid: U,
          fields: qe,
          name: ae,
          eventType: Q
        });
      }
    }
    return J.valid;
  }, k = () => {
    for (const j of s.unMount) {
      const U = ze(r, j);
      U && (U._f.refs ? U._f.refs.every((Y) => !xm(Y)) : !xm(U._f.ref)) && O(j);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, N = (j, U) => !t.disabled && (j && U && Tt(o, j, U), !ho(M(), i)), I = (j, U, Y) => SJ(j, s, {
    ...a.mount ? o : Vt(U) ? i : In(j) ? { [j]: U } : U
  }, Y, U), B = (j) => v0(ze(a.mount ? o : i, j, t.shouldUnregister ? ze(i, j, []) : [])), q = (j, U, Y = {}) => {
    const Q = ze(r, j);
    let J = U;
    if (Q) {
      const ae = Q._f;
      ae && (!ae.disabled && Tt(o, j, LA(U, ae)), J = Md(ae.ref) && Kn(U) ? "" : U, jA(ae.ref) ? [...ae.ref.options].forEach((be) => be.selected = J.includes(be.value)) : ae.refs ? pc(ae.ref) ? ae.refs.forEach((be) => {
        (!be.defaultChecked || !be.disabled) && (Array.isArray(J) ? be.checked = !!J.find((Ae) => Ae === be.value) : be.checked = J === be.value || !!J);
      }) : ae.refs.forEach((be) => be.checked = be.value === J) : y0(ae.ref) ? ae.ref.value = "" : (ae.ref.value = J, ae.ref.type || p.state.next({
        name: j,
        values: sn(o)
      })));
    }
    (Y.shouldDirty || Y.shouldTouch) && $(j, J, Y.shouldTouch, Y.shouldDirty, !0), Y.shouldValidate && F(j);
  }, ee = (j, U, Y) => {
    for (const Q in U) {
      if (!U.hasOwnProperty(Q))
        return;
      const J = U[Q], ae = j + "." + Q, be = ze(r, ae);
      (s.array.has(j) || Gt(J) || be && !be._f) && !ca(J) ? ee(ae, J, Y) : q(ae, J, Y);
    }
  }, re = (j, U, Y = {}) => {
    const Q = ze(r, j), J = s.array.has(j), ae = sn(U);
    Tt(o, j, ae), J ? (p.array.next({
      name: j,
      values: sn(o)
    }), (f.isDirty || f.dirtyFields || d.isDirty || d.dirtyFields) && Y.shouldDirty && p.state.next({
      name: j,
      dirtyFields: rs(i, o),
      isDirty: N(j, ae)
    })) : Q && !Q._f && !Kn(ae) ? ee(j, ae, Y) : q(j, ae, Y), vS(j, s) ? p.state.next({
      ...n,
      name: j,
      values: sn(o)
    }) : p.state.next({
      name: a.mount ? j : void 0,
      values: sn(o)
    });
  }, Z = async (j) => {
    a.mount = !0;
    const U = j.target;
    let Y = U.name, Q = !0;
    const J = ze(r, Y), ae = (qe) => {
      Q = Number.isNaN(qe) || ca(qe) && isNaN(qe.getTime()) || ho(qe, ze(o, Y, qe));
    }, be = hS(t.mode), Ae = hS(t.reValidateMode);
    if (J) {
      let qe, rt;
      const mt = U.type ? pS(J._f) : yJ(j), _t = j.type === Ja.BLUR || j.type === Ja.FOCUS_OUT, ci = !IJ(J._f) && !e.validate && !t.resolver && !ze(n.errors, Y) && !J._f.deps || NJ(_t, ze(n.touchedFields, Y), n.isSubmitted, Ae, be), fi = vS(Y, s, _t);
      Tt(o, Y, mt), _t ? (!U || !U.readOnly) && (J._f.onBlur && J._f.onBlur(j), l && l(0)) : J._f.onChange && J._f.onChange(j);
      const Ri = $(Y, mt, _t), Wo = !An(Ri) || fi;
      if (!_t && p.state.next({
        name: Y,
        type: j.type,
        values: sn(o)
      }), ci)
        return (f.isValid || d.isValid) && (t.mode === "onBlur" ? _t && v() : _t || v()), Wo && p.state.next({ name: Y, ...fi ? {} : Ri });
      if (!t.resolver && e.validate && await w({
        name: Y,
        eventType: j.type
      }), !_t && fi && p.state.next({ ...n }), t.resolver) {
        const { errors: di } = await y([Y]);
        if (g([Y]), ae(mt), Q) {
          const no = gS(n.errors, r, Y), zr = gS(di, r, no.name || Y);
          qe = zr.error, Y = zr.name, rt = An(di);
        }
      } else
        g([Y], !0), qe = (await bS(J, s.disabled, o, h, t.shouldUseNativeValidation))[Y], g([Y]), ae(mt), Q && (qe ? rt = !1 : (f.isValid || d.isValid) && (rt = await A({
          fields: r,
          onlyCheckValid: !0,
          name: Y,
          eventType: j.type
        })));
      Q && (J._f.deps && (!Array.isArray(J._f.deps) || J._f.deps.length > 0) && F(J._f.deps), P(Y, rt, qe, Ri));
    }
  }, T = (j, U) => {
    if (ze(n.errors, U) && j.focus)
      return j.focus(), 1;
  }, F = async (j, U = {}) => {
    let Y, Q;
    const J = pu(j);
    if (t.resolver) {
      const ae = await _(Vt(j) ? j : J);
      Y = An(ae), Q = j ? !J.some((be) => ze(ae, be)) : Y;
    } else j ? (Q = (await Promise.all(J.map(async (ae) => {
      const be = ze(r, ae);
      return await A({
        fields: be && be._f ? { [ae]: be } : be,
        eventType: Ja.TRIGGER
      });
    }))).every(Boolean), !(!Q && !n.isValid) && v()) : Q = Y = await A({
      fields: r,
      name: j,
      eventType: Ja.TRIGGER
    });
    return p.state.next({
      ...!In(j) || (f.isValid || d.isValid) && Y !== n.isValid ? {} : { name: j },
      ...t.resolver || !j ? { isValid: Y } : {},
      errors: n.errors
    }), U.shouldFocus && !Q && hu(r, T, j ? J : s.mount), Q;
  }, M = (j, U) => {
    let Y = {
      ...a.mount ? o : i
    };
    return U && (Y = NA(U.dirtyFields ? n.dirtyFields : n.touchedFields, Y)), Vt(j) ? Y : In(j) ? ze(Y, j) : j.map((Q) => ze(Y, Q));
  }, K = (j, U) => ({
    invalid: !!ze((U || n).errors, j),
    isDirty: !!ze((U || n).dirtyFields, j),
    error: ze((U || n).errors, j),
    isValidating: !!ze(n.validatingFields, j),
    isTouched: !!ze((U || n).touchedFields, j)
  }), te = (j) => {
    const U = j ? pu(j) : void 0;
    U?.forEach((Y) => nn(n.errors, Y)), U ? U.forEach((Y) => {
      p.state.next({
        name: Y,
        errors: n.errors
      });
    }) : p.state.next({
      errors: {}
    });
  }, se = (j, U, Y) => {
    const Q = (ze(r, j, { _f: {} })._f || {}).ref, J = ze(n.errors, j) || {}, { ref: ae, message: be, type: Ae, ...qe } = J;
    Tt(n.errors, j, {
      ...qe,
      ...U,
      ref: Q
    }), p.state.next({
      name: j,
      errors: n.errors,
      isValid: !1
    }), Y && Y.shouldFocus && Q && Q.focus && Q.focus();
  }, de = (j, U) => Zr(j) ? p.state.subscribe({
    next: (Y) => "values" in Y && j(I(void 0, U), Y)
  }) : I(j, U, !0), ge = (j) => p.state.subscribe({
    next: (U) => {
      RJ(j.name, U.name, j.exact) && MJ(U, j.formState || f, we, j.reRenderRoot) && j.callback({
        values: { ...o },
        ...n,
        ...U,
        defaultValues: i
      });
    }
  }).unsubscribe, V = (j) => (a.mount = !0, d = {
    ...d,
    ...j.formState
  }, ge({
    ...j,
    formState: {
      ...c,
      ...j.formState
    }
  })), O = (j, U = {}) => {
    for (const Y of j ? pu(j) : s.mount)
      s.mount.delete(Y), s.array.delete(Y), U.keepValue || (nn(r, Y), nn(o, Y)), !U.keepError && nn(n.errors, Y), !U.keepDirty && nn(n.dirtyFields, Y), !U.keepTouched && nn(n.touchedFields, Y), !U.keepIsValidating && nn(n.validatingFields, Y), !t.shouldUnregister && !U.keepDefaultValue && nn(i, Y);
    p.state.next({
      values: sn(o)
    }), p.state.next({
      ...n,
      ...U.keepDirty ? { isDirty: N() } : {}
    }), !U.keepIsValid && v();
  }, D = ({ disabled: j, name: U }) => {
    if (yi(j) && a.mount || j || s.disabled.has(U)) {
      const J = s.disabled.has(U) !== !!j;
      j ? s.disabled.add(U) : s.disabled.delete(U), J && a.mount && !a.action && v();
    }
  }, C = (j, U = {}) => {
    let Y = ze(r, j);
    const Q = yi(U.disabled) || yi(t.disabled);
    return Tt(r, j, {
      ...Y || {},
      _f: {
        ...Y && Y._f ? Y._f : { ref: { name: j } },
        name: j,
        mount: !0,
        ...U
      }
    }), s.mount.add(j), Y ? D({
      disabled: yi(U.disabled) ? U.disabled : t.disabled,
      name: j
    }) : S(j, !0, U.value), {
      ...Q ? { disabled: U.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!U.required,
        min: zl(U.min),
        max: zl(U.max),
        minLength: zl(U.minLength),
        maxLength: zl(U.maxLength),
        pattern: zl(U.pattern)
      } : {},
      name: j,
      onChange: Z,
      onBlur: Z,
      ref: (J) => {
        if (J) {
          C(j, U), Y = ze(r, j);
          const ae = Vt(J.value) && J.querySelectorAll && J.querySelectorAll("input,select,textarea")[0] || J, be = OJ(ae), Ae = Y._f.refs || [];
          if (be ? Ae.find((qe) => qe === ae) : ae === Y._f.ref)
            return;
          Tt(r, j, {
            _f: {
              ...Y._f,
              ...be ? {
                refs: [
                  ...Ae.filter(xm),
                  ae,
                  ...Array.isArray(ze(i, j)) ? [{}] : []
                ],
                ref: { type: ae.type, name: j }
              } : { ref: ae }
            }
          }), S(j, !1, void 0, ae);
        } else
          Y = ze(r, j, {}), Y._f && (Y._f.mount = !1), (t.shouldUnregister || U.shouldUnregister) && !(bJ(s.array, j) && a.action) && s.unMount.add(j);
      }
    };
  }, z = () => t.shouldFocusError && hu(r, T, s.mount), H = (j) => {
    yi(j) && (p.state.next({ disabled: j }), hu(r, (U, Y) => {
      const Q = ze(r, Y);
      Q && (U.disabled = Q._f.disabled || j, Array.isArray(Q._f.refs) && Q._f.refs.forEach((J) => {
        J.disabled = Q._f.disabled || j;
      }));
    }, 0, !1));
  }, X = (j, U) => async (Y) => {
    let Q;
    Y && (Y.preventDefault && Y.preventDefault(), Y.persist && Y.persist());
    let J = sn(o);
    if (p.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: ae, values: be } = await y();
      g(), n.errors = ae, J = sn(be);
    } else
      await A({
        fields: r,
        eventType: Ja.SUBMIT
      });
    if (s.disabled.size)
      for (const ae of s.disabled)
        nn(J, ae);
    if (nn(n.errors, RA), An(n.errors)) {
      p.state.next({
        errors: {}
      });
      try {
        await j(J, Y);
      } catch (ae) {
        Q = ae;
      }
    } else
      U && await U({ ...n.errors }, Y), z(), setTimeout(z);
    if (p.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: An(n.errors) && !Q,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), Q)
      throw Q;
  }, fe = (j, U = {}) => {
    ze(r, j) && (Vt(U.defaultValue) ? re(j, sn(ze(i, j))) : (re(j, U.defaultValue), Tt(i, j, sn(U.defaultValue))), U.keepTouched || nn(n.touchedFields, j), U.keepDirty || (nn(n.dirtyFields, j), n.isDirty = U.defaultValue ? N(j, sn(ze(i, j))) : N()), U.keepError || (nn(n.errors, j), f.isValid && v()), p.state.next({ ...n }));
  }, ce = (j, U = {}) => {
    const Y = j ? sn(j) : i, Q = sn(Y), J = An(j), ae = J ? i : Q;
    if (U.keepDefaultValues || (i = Y), !U.keepValues) {
      if (U.keepDirtyValues) {
        const be = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(rs(i, o))
        ]);
        for (const Ae of Array.from(be)) {
          const qe = ze(n.dirtyFields, Ae), rt = ze(o, Ae), mt = ze(ae, Ae);
          qe && !Vt(rt) ? Tt(ae, Ae, rt) : !qe && !Vt(mt) && re(Ae, mt);
        }
      } else {
        if (m0 && Vt(j))
          for (const be of s.mount) {
            const Ae = ze(r, be);
            if (Ae && Ae._f) {
              const qe = Array.isArray(Ae._f.refs) ? Ae._f.refs[0] : Ae._f.ref;
              if (Md(qe)) {
                const rt = qe.closest("form");
                if (rt) {
                  rt.reset();
                  break;
                }
              }
            }
          }
        if (U.keepFieldsRef)
          for (const be of s.mount)
            re(be, ze(ae, be));
        else
          r = {};
      }
      o = t.shouldUnregister ? U.keepDefaultValues ? sn(i) : {} : sn(ae), p.array.next({
        values: { ...ae }
      }), p.state.next({
        values: { ...ae }
      });
    }
    s = {
      mount: U.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !f.isValid || !!U.keepIsValid || !!U.keepDirtyValues || !t.shouldUnregister && !An(ae), a.watch = !!t.shouldUnregister, a.keepIsValid = !!U.keepIsValid, a.action = !1, U.keepErrors || (n.errors = {}), p.state.next({
      submitCount: U.keepSubmitCount ? n.submitCount : 0,
      isDirty: J ? !1 : U.keepDirty ? n.isDirty : !!(U.keepDefaultValues && !ho(j, i)),
      isSubmitted: U.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: J ? {} : U.keepDirtyValues ? U.keepDefaultValues && o ? rs(i, o) : n.dirtyFields : U.keepDefaultValues && j ? rs(i, j) : U.keepDirty ? n.dirtyFields : {},
      touchedFields: U.keepTouched ? n.touchedFields : {},
      errors: U.keepErrors ? n.errors : {},
      isSubmitSuccessful: U.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: i
    });
  }, xe = (j, U) => ce(Zr(j) ? j(o) : j, { ...t.resetOptions, ...U }), ne = (j, U = {}) => {
    const Y = ze(r, j), Q = Y && Y._f;
    if (Q) {
      const J = Q.refs ? Q.refs[0] : Q.ref;
      J.focus && setTimeout(() => {
        J.focus(), U.shouldSelect && Zr(J.select) && J.select();
      });
    }
  }, we = (j) => {
    n = {
      ...n,
      ...j
    };
  }, pe = {
    control: {
      register: C,
      unregister: O,
      getFieldState: K,
      handleSubmit: X,
      setError: se,
      _subscribe: ge,
      _runSchema: y,
      _updateIsValidating: g,
      _focusError: z,
      _getWatch: I,
      _getDirty: N,
      _setValid: v,
      _setFieldArray: b,
      _setDisabledField: D,
      _setErrors: x,
      _getFieldArray: B,
      _reset: ce,
      _resetDefaultValues: () => Zr(t.defaultValues) && t.defaultValues().then((j) => {
        xe(j, t.resetOptions), p.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: k,
      _disableForm: H,
      _subjects: p,
      _proxyFormState: f,
      get _fields() {
        return r;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return a;
      },
      set _state(j) {
        a = j;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return s;
      },
      set _names(j) {
        s = j;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return t;
      },
      set _options(j) {
        t = {
          ...t,
          ...j
        };
      }
    },
    subscribe: V,
    trigger: F,
    register: C,
    handleSubmit: X,
    watch: de,
    setValue: re,
    getValues: M,
    reset: xe,
    resetField: fe,
    clearErrors: te,
    unregister: O,
    setError: se,
    setFocus: ne,
    getFieldState: K
  };
  return {
    ...pe,
    formControl: pe
  };
}
function VJ(e = {}) {
  const t = G.useRef(void 0), n = G.useRef(void 0), [r, i] = G.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Zr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    isReady: !1,
    defaultValues: Zr(e.defaultValues) ? void 0 : e.defaultValues
  });
  if (!t.current)
    if (e.formControl)
      t.current = {
        ...e.formControl,
        formState: r
      }, e.defaultValues && !Zr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: a, ...s } = LJ(e);
      t.current = {
        ...s,
        formState: r
      };
    }
  const o = t.current.control;
  return o._options = e, EJ(() => {
    const a = o._subscribe({
      formState: o._proxyFormState,
      callback: () => i({ ...o._formState }),
      reRenderRoot: !0
    });
    return i((s) => ({
      ...s,
      isReady: !0
    })), o._formState.isReady = !0, a;
  }, [o]), G.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), G.useEffect(() => {
    e.mode && (o._options.mode = e.mode), e.reValidateMode && (o._options.reValidateMode = e.reValidateMode);
  }, [o, e.mode, e.reValidateMode]), G.useEffect(() => {
    e.errors && (o._setErrors(e.errors), o._focusError());
  }, [o, e.errors]), G.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [o, e.shouldUnregister]), G.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const a = o._getDirty();
      a !== r.isDirty && o._subjects.state.next({
        isDirty: a
      });
    }
  }, [o, r.isDirty]), G.useEffect(() => {
    var a;
    e.values && !ho(e.values, n.current) ? (o._reset(e.values, {
      keepFieldsRef: !0,
      ...o._options.resetOptions
    }), !((a = o._options.resetOptions) === null || a === void 0) && a.keepIsValid || o._setValid(), n.current = e.values, i((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [o, e.values]), G.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), t.current.formState = G.useMemo(() => xJ(r, o), [o, r]), t.current;
}
const BJ = Jt(
  ({ className: e, ...t }, n) => /* @__PURE__ */ R.jsx(
    "input",
    {
      ref: n,
      ...t,
      className: Wn(
        "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
        e
      )
    }
  )
), KJ = (e, t) => {
  const n = (r) => {
    e.current && !e.current.contains(r.target) && t();
  };
  De(() => (document.addEventListener("click", n), () => {
    document.removeEventListener("click", n);
  }));
};
function UJ(e, t, n = 250) {
  const [r, i] = je(0);
  return De(() => {
    const o = setTimeout(() => {
      i(0);
    }, n);
    return r === 2 && t(), () => clearTimeout(o);
  }, [r]), () => i((o) => o + 1);
}
var hc = "delete", kt = 5, Tr = 1 << kt, jn = Tr - 1, Xe = {};
function Fg() {
  return { value: !1 };
}
function Or(e) {
  e && (e.value = !0);
}
function _0() {
}
function Ks(e) {
  return e.size === void 0 && (e.size = e.__iterate(BA)), e.size;
}
function Do(e, t) {
  if (typeof t != "number") {
    var n = t >>> 0;
    if ("" + n !== t || n === 4294967295)
      return NaN;
    t = n;
  }
  return t < 0 ? Ks(e) + t : t;
}
function BA() {
  return !0;
}
function Vp(e, t, n) {
  return (e === 0 && !UA(e) || n !== void 0 && e <= -n) && (t === void 0 || n !== void 0 && t >= n);
}
function mc(e, t) {
  return KA(e, t, 0);
}
function Bp(e, t) {
  return KA(e, t, t);
}
function KA(e, t, n) {
  return e === void 0 ? n : UA(e) ? t === 1 / 0 ? t : Math.max(0, t + e) | 0 : t === void 0 || t === e ? e : Math.min(t, e) | 0;
}
function UA(e) {
  return e < 0 || e === 0 && 1 / e === -1 / 0;
}
var qA = "@@__IMMUTABLE_ITERABLE__@@";
function Qn(e) {
  return !!(e && e[qA]);
}
var HA = "@@__IMMUTABLE_KEYED__@@";
function It(e) {
  return !!(e && e[HA]);
}
var WA = "@@__IMMUTABLE_INDEXED__@@";
function Hn(e) {
  return !!(e && e[WA]);
}
function Kp(e) {
  return It(e) || Hn(e);
}
var Qt = function(e) {
  return Qn(e) ? e : fr(e);
}, jr = /* @__PURE__ */ (function(e) {
  function t(n) {
    return It(n) ? n : Ko(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(Qt), Ka = /* @__PURE__ */ (function(e) {
  function t(n) {
    return Hn(n) ? n : li(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(Qt), vl = /* @__PURE__ */ (function(e) {
  function t(n) {
    return Qn(n) && !Kp(n) ? n : _l(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(Qt);
Qt.Keyed = jr;
Qt.Indexed = Ka;
Qt.Set = vl;
var ZA = "@@__IMMUTABLE_SEQ__@@";
function w0(e) {
  return !!(e && e[ZA]);
}
var GA = "@@__IMMUTABLE_RECORD__@@";
function gl(e) {
  return !!(e && e[GA]);
}
function Ci(e) {
  return Qn(e) || gl(e);
}
var yl = "@@__IMMUTABLE_ORDERED__@@";
function ti(e) {
  return !!(e && e[yl]);
}
var vc = 0, ri = 1, Ir = 2, zg = typeof Symbol == "function" && Symbol.iterator, YA = "@@iterator", Up = zg || YA, st = function(e) {
  this.next = e;
};
st.prototype.toString = function() {
  return "[Iterator]";
};
st.KEYS = vc;
st.VALUES = ri;
st.ENTRIES = Ir;
st.prototype.inspect = st.prototype.toSource = function() {
  return this.toString();
};
st.prototype[Up] = function() {
  return this;
};
function Nt(e, t, n, r) {
  var i = e === 0 ? t : e === 1 ? n : [t, n];
  return r ? r.value = i : r = {
    value: i,
    done: !1
  }, r;
}
function Jn() {
  return { value: void 0, done: !0 };
}
function QA(e) {
  return Array.isArray(e) ? !0 : !!qp(e);
}
function _S(e) {
  return e && typeof e.next == "function";
}
function Lg(e) {
  var t = qp(e);
  return t && t.call(e);
}
function qp(e) {
  var t = e && (zg && e[zg] || e[YA]);
  if (typeof t == "function")
    return t;
}
function qJ(e) {
  var t = qp(e);
  return t && t === e.entries;
}
function HJ(e) {
  var t = qp(e);
  return t && t === e.keys;
}
var bl = Object.prototype.hasOwnProperty;
function JA(e) {
  return Array.isArray(e) || typeof e == "string" ? !0 : e && typeof e == "object" && Number.isInteger(e.length) && e.length >= 0 && (e.length === 0 ? Object.keys(e).length === 1 : e.hasOwnProperty(e.length - 1));
}
var fr = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? E0() : Ci(n) ? n.toSeq() : ZJ(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, t.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, t.prototype.__iterate = function(n, r) {
    var i = this._cache;
    if (i) {
      for (var o = i.length, a = 0; a !== o; ) {
        var s = i[r ? o - ++a : a++];
        if (n(s[1], s[0], this) === !1)
          break;
      }
      return a;
    }
    return this.__iterateUncached(n, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._cache;
    if (i) {
      var o = i.length, a = 0;
      return new st(function() {
        if (a === o)
          return Jn();
        var s = i[r ? o - ++a : a++];
        return Nt(n, s[0], s[1]);
      });
    }
    return this.__iteratorUncached(n, r);
  }, t;
})(Qt), Ko = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? E0().toKeyedSeq() : Qn(n) ? It(n) ? n.toSeq() : n.fromEntrySeq() : gl(n) ? n.toSeq() : S0(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toKeyedSeq = function() {
    return this;
  }, t;
})(fr), li = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? E0() : Qn(n) ? It(n) ? n.entrySeq() : n.toIndexedSeq() : gl(n) ? n.toSeq().entrySeq() : XA(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toIndexedSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, t;
})(fr), _l = /* @__PURE__ */ (function(e) {
  function t(n) {
    return (Qn(n) && !Kp(n) ? n : li(n)).toSetSeq();
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toSetSeq = function() {
    return this;
  }, t;
})(fr);
fr.isSeq = w0;
fr.Keyed = Ko;
fr.Set = _l;
fr.Indexed = li;
fr.prototype[ZA] = !0;
var Pa = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._array = n, this.size = n.length;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return this.has(n) ? this._array[Do(this, n)] : r;
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this._array, o = i.length, a = 0; a !== o; ) {
      var s = r ? o - ++a : a++;
      if (n(i[s], s, this) === !1)
        break;
    }
    return a;
  }, t.prototype.__iterator = function(n, r) {
    var i = this._array, o = i.length, a = 0;
    return new st(function() {
      if (a === o)
        return Jn();
      var s = r ? o - ++a : a++;
      return Nt(n, s, i[s]);
    });
  }, t;
})(li), x0 = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r = Object.keys(n).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(n) : []
    );
    this._object = n, this._keys = r, this.size = r.length;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return r !== void 0 && !this.has(n) ? r : this._object[n];
  }, t.prototype.has = function(n) {
    return bl.call(this._object, n);
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this._object, o = this._keys, a = o.length, s = 0; s !== a; ) {
      var l = o[r ? a - ++s : s++];
      if (n(i[l], l, this) === !1)
        break;
    }
    return s;
  }, t.prototype.__iterator = function(n, r) {
    var i = this._object, o = this._keys, a = o.length, s = 0;
    return new st(function() {
      if (s === a)
        return Jn();
      var l = o[r ? a - ++s : s++];
      return Nt(n, l, i[l]);
    });
  }, t;
})(Ko);
x0.prototype[yl] = !0;
var WJ = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._collection = n, this.size = n.length || n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.__iterateUncached = function(n, r) {
    if (r)
      return this.cacheResult().__iterate(n, r);
    var i = this._collection, o = Lg(i), a = 0;
    if (_S(o))
      for (var s; !(s = o.next()).done && n(s.value, a++, this) !== !1; )
        ;
    return a;
  }, t.prototype.__iteratorUncached = function(n, r) {
    if (r)
      return this.cacheResult().__iterator(n, r);
    var i = this._collection, o = Lg(i);
    if (!_S(o))
      return new st(Jn);
    var a = 0;
    return new st(function() {
      var s = o.next();
      return s.done ? s : Nt(n, a++, s.value);
    });
  }, t;
})(li), wS;
function E0() {
  return wS || (wS = new Pa([]));
}
function S0(e) {
  var t = $0(e);
  if (t)
    return t.fromEntrySeq();
  if (typeof e == "object")
    return new x0(e);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + e
  );
}
function XA(e) {
  var t = $0(e);
  if (t)
    return t;
  throw new TypeError(
    "Expected Array or collection object of values: " + e
  );
}
function ZJ(e) {
  var t = $0(e);
  if (t)
    return qJ(e) ? t.fromEntrySeq() : HJ(e) ? t.toSetSeq() : t;
  if (typeof e == "object")
    return new x0(e);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + e
  );
}
function $0(e) {
  return JA(e) ? new Pa(e) : QA(e) ? new WJ(e) : void 0;
}
var eC = "@@__IMMUTABLE_MAP__@@";
function T0(e) {
  return !!(e && e[eC]);
}
function tC(e) {
  return T0(e) && ti(e);
}
function xS(e) {
  return !!(e && typeof e.equals == "function" && typeof e.hashCode == "function");
}
function ar(e, t) {
  if (e === t || e !== e && t !== t)
    return !0;
  if (!e || !t)
    return !1;
  if (typeof e.valueOf == "function" && typeof t.valueOf == "function") {
    if (e = e.valueOf(), t = t.valueOf(), e === t || e !== e && t !== t)
      return !0;
    if (!e || !t)
      return !1;
  }
  return !!(xS(e) && xS(t) && e.equals(t));
}
var Ll = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(e, t) {
  e |= 0, t |= 0;
  var n = e & 65535, r = t & 65535;
  return n * r + ((e >>> 16) * r + n * (t >>> 16) << 16 >>> 0) | 0;
};
function Hp(e) {
  return e >>> 1 & 1073741824 | e & 3221225471;
}
var GJ = Object.prototype.valueOf;
function tr(e) {
  if (e == null)
    return ES(e);
  if (typeof e.hashCode == "function")
    return Hp(e.hashCode(e));
  var t = tX(e);
  if (t == null)
    return ES(t);
  switch (typeof t) {
    case "boolean":
      return t ? 1108378657 : 1108378656;
    case "number":
      return YJ(t);
    case "string":
      return t.length > nX ? QJ(t) : Vg(t);
    case "object":
    case "function":
      return XJ(t);
    case "symbol":
      return JJ(t);
    default:
      if (typeof t.toString == "function")
        return Vg(t.toString());
      throw new Error("Value type " + typeof t + " cannot be hashed.");
  }
}
function ES(e) {
  return e === null ? 1108378658 : 1108378659;
}
function YJ(e) {
  if (e !== e || e === 1 / 0)
    return 0;
  var t = e | 0;
  for (t !== e && (t ^= e * 4294967295); e > 4294967295; )
    e /= 4294967295, t ^= e;
  return Hp(t);
}
function QJ(e) {
  var t = $m[e];
  return t === void 0 && (t = Vg(e), Sm === rX && (Sm = 0, $m = {}), Sm++, $m[e] = t), t;
}
function Vg(e) {
  for (var t = 0, n = 0; n < e.length; n++)
    t = 31 * t + e.charCodeAt(n) | 0;
  return Hp(t);
}
function JJ(e) {
  var t = TS[e];
  return t !== void 0 || (t = nC(), TS[e] = t), t;
}
function XJ(e) {
  var t;
  if (Bg && (t = Kg.get(e), t !== void 0) || (t = e[na], t !== void 0) || !$S && (t = e.propertyIsEnumerable && e.propertyIsEnumerable[na], t !== void 0 || (t = eX(e), t !== void 0)))
    return t;
  if (t = nC(), Bg)
    Kg.set(e, t);
  else {
    if (SS !== void 0 && SS(e) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if ($S)
      Object.defineProperty(e, na, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: t
      });
    else if (e.propertyIsEnumerable !== void 0 && e.propertyIsEnumerable === e.constructor.prototype.propertyIsEnumerable)
      e.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, e.propertyIsEnumerable[na] = t;
    else if (e.nodeType !== void 0)
      e[na] = t;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return t;
}
var SS = Object.isExtensible, $S = (function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
})();
function eX(e) {
  if (e && e.nodeType > 0)
    switch (e.nodeType) {
      case 1:
        return e.uniqueID;
      case 9:
        return e.documentElement && e.documentElement.uniqueID;
    }
}
function tX(e) {
  return e.valueOf !== GJ && typeof e.valueOf == "function" ? e.valueOf(e) : e;
}
function nC() {
  var e = ++Em;
  return Em & 1073741824 && (Em = 0), e;
}
var Bg = typeof WeakMap == "function", Kg;
Bg && (Kg = /* @__PURE__ */ new WeakMap());
var TS = /* @__PURE__ */ Object.create(null), Em = 0, na = "__immutablehash__";
typeof Symbol == "function" && (na = Symbol(na));
var nX = 16, rX = 255, Sm = 0, $m = {}, Wp = /* @__PURE__ */ (function(e) {
  function t(n, r) {
    this._iter = n, this._useKeys = r, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return this._iter.get(n, r);
  }, t.prototype.has = function(n) {
    return this._iter.has(n);
  }, t.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, t.prototype.reverse = function() {
    var n = this, r = O0(this, !0);
    return this._useKeys || (r.valueSeq = function() {
      return n._iter.toSeq().reverse();
    }), r;
  }, t.prototype.map = function(n, r) {
    var i = this, o = sC(this, n, r);
    return this._useKeys || (o.valueSeq = function() {
      return i._iter.toSeq().map(n, r);
    }), o;
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o, a) {
      return n(o, a, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    return this._iter.__iterator(n, r);
  }, t;
})(Ko);
Wp.prototype[yl] = !0;
var rC = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.includes = function(n) {
    return this._iter.includes(n);
  }, t.prototype.__iterate = function(n, r) {
    var i = this, o = 0;
    return r && Ks(this), this._iter.__iterate(
      function(a) {
        return n(a, r ? i.size - ++o : o++, i);
      },
      r
    );
  }, t.prototype.__iterator = function(n, r) {
    var i = this, o = this._iter.__iterator(ri, r), a = 0;
    return r && Ks(this), new st(function() {
      var s = o.next();
      return s.done ? s : Nt(
        n,
        r ? i.size - ++a : a++,
        s.value,
        s
      );
    });
  }, t;
})(li), iC = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.has = function(n) {
    return this._iter.includes(n);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o) {
      return n(o, o, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._iter.__iterator(ri, r);
    return new st(function() {
      var o = i.next();
      return o.done ? o : Nt(n, o.value, o.value, o);
    });
  }, t;
})(_l), oC = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o) {
      if (o) {
        kS(o);
        var a = Qn(o);
        return n(
          a ? o.get(1) : o[1],
          a ? o.get(0) : o[0],
          i
        );
      }
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._iter.__iterator(ri, r);
    return new st(function() {
      for (; ; ) {
        var o = i.next();
        if (o.done)
          return o;
        var a = o.value;
        if (a) {
          kS(a);
          var s = Qn(a);
          return Nt(
            n,
            s ? a.get(0) : a[0],
            s ? a.get(1) : a[1],
            o
          );
        }
      }
    });
  }, t;
})(Ko);
rC.prototype.cacheResult = Wp.prototype.cacheResult = iC.prototype.cacheResult = oC.prototype.cacheResult = D0;
function aC(e) {
  var t = Ii(e);
  return t._iter = e, t.size = e.size, t.flip = function() {
    return e;
  }, t.reverse = function() {
    var n = e.reverse.apply(this);
    return n.flip = function() {
      return e.reverse();
    }, n;
  }, t.has = function(n) {
    return e.includes(n);
  }, t.includes = function(n) {
    return e.has(n);
  }, t.cacheResult = D0, t.__iterateUncached = function(n, r) {
    var i = this;
    return e.__iterate(function(o, a) {
      return n(a, o, i) !== !1;
    }, r);
  }, t.__iteratorUncached = function(n, r) {
    if (n === Ir) {
      var i = e.__iterator(n, r);
      return new st(function() {
        var o = i.next();
        if (!o.done) {
          var a = o.value[0];
          o.value[0] = o.value[1], o.value[1] = a;
        }
        return o;
      });
    }
    return e.__iterator(
      n === ri ? vc : ri,
      r
    );
  }, t;
}
function sC(e, t, n) {
  var r = Ii(e);
  return r.size = e.size, r.has = function(i) {
    return e.has(i);
  }, r.get = function(i, o) {
    var a = e.get(i, Xe);
    return a === Xe ? o : t.call(n, a, i, e);
  }, r.__iterateUncached = function(i, o) {
    var a = this;
    return e.__iterate(
      function(s, l, u) {
        return i(t.call(n, s, l, u), l, a) !== !1;
      },
      o
    );
  }, r.__iteratorUncached = function(i, o) {
    var a = e.__iterator(Ir, o);
    return new st(function() {
      var s = a.next();
      if (s.done)
        return s;
      var l = s.value, u = l[0];
      return Nt(
        i,
        u,
        t.call(n, l[1], u, e),
        s
      );
    });
  }, r;
}
function O0(e, t) {
  var n = this, r = Ii(e);
  return r._iter = e, r.size = e.size, r.reverse = function() {
    return e;
  }, e.flip && (r.flip = function() {
    var i = aC(e);
    return i.reverse = function() {
      return e.flip();
    }, i;
  }), r.get = function(i, o) {
    return e.get(t ? i : -1 - i, o);
  }, r.has = function(i) {
    return e.has(t ? i : -1 - i);
  }, r.includes = function(i) {
    return e.includes(i);
  }, r.cacheResult = D0, r.__iterate = function(i, o) {
    var a = this, s = 0;
    return o && Ks(e), e.__iterate(
      function(l, u) {
        return i(l, t ? u : o ? a.size - ++s : s++, a);
      },
      !o
    );
  }, r.__iterator = function(i, o) {
    var a = 0;
    o && Ks(e);
    var s = e.__iterator(Ir, !o);
    return new st(function() {
      var l = s.next();
      if (l.done)
        return l;
      var u = l.value;
      return Nt(
        i,
        t ? u[0] : o ? n.size - ++a : a++,
        u[1],
        l
      );
    });
  }, r;
}
function lC(e, t, n, r) {
  var i = Ii(e);
  return r && (i.has = function(o) {
    var a = e.get(o, Xe);
    return a !== Xe && !!t.call(n, a, o, e);
  }, i.get = function(o, a) {
    var s = e.get(o, Xe);
    return s !== Xe && t.call(n, s, o, e) ? s : a;
  }), i.__iterateUncached = function(o, a) {
    var s = this, l = 0;
    return e.__iterate(function(u, c, f) {
      if (t.call(n, u, c, f))
        return l++, o(u, r ? c : l - 1, s);
    }, a), l;
  }, i.__iteratorUncached = function(o, a) {
    var s = e.__iterator(Ir, a), l = 0;
    return new st(function() {
      for (; ; ) {
        var u = s.next();
        if (u.done)
          return u;
        var c = u.value, f = c[0], d = c[1];
        if (t.call(n, d, f, e))
          return Nt(o, r ? f : l++, d, u);
      }
    });
  }, i;
}
function iX(e, t, n) {
  var r = xl().asMutable();
  return e.__iterate(function(i, o) {
    r.update(t.call(n, i, o, e), 0, function(a) {
      return a + 1;
    });
  }), r.asImmutable();
}
function oX(e, t, n) {
  var r = It(e), i = (ti(e) ? Yi() : xl()).asMutable();
  e.__iterate(function(a, s) {
    i.update(
      t.call(n, a, s, e),
      function(l) {
        return l = l || [], l.push(r ? [s, a] : a), l;
      }
    );
  });
  var o = P0(e);
  return i.map(function(a) {
    return gt(e, o(a));
  }).asImmutable();
}
function aX(e, t, n) {
  var r = It(e), i = [[], []];
  e.__iterate(function(a, s) {
    i[t.call(n, a, s, e) ? 1 : 0].push(
      r ? [s, a] : a
    );
  });
  var o = P0(e);
  return i.map(function(a) {
    return gt(e, o(a));
  });
}
function k0(e, t, n, r) {
  var i = e.size;
  if (Vp(t, n, i))
    return e;
  if (typeof i > "u" && (t < 0 || n < 0))
    return k0(e.toSeq().cacheResult(), t, n, r);
  var o = mc(t, i), a = Bp(n, i), s = a - o, l;
  s === s && (l = s < 0 ? 0 : s);
  var u = Ii(e);
  return u.size = l === 0 ? l : e.size && l || void 0, !r && w0(e) && l >= 0 && (u.get = function(c, f) {
    return c = Do(this, c), c >= 0 && c < l ? e.get(c + o, f) : f;
  }), u.__iterateUncached = function(c, f) {
    var d = this;
    if (l === 0)
      return 0;
    if (f)
      return this.cacheResult().__iterate(c, f);
    var p = 0, h = !0, m = 0;
    return e.__iterate(function(v, g) {
      if (!(h && (h = p++ < o)))
        return m++, c(v, r ? g : m - 1, d) !== !1 && m !== l;
    }), m;
  }, u.__iteratorUncached = function(c, f) {
    if (l !== 0 && f)
      return this.cacheResult().__iterator(c, f);
    if (l === 0)
      return new st(Jn);
    var d = e.__iterator(c, f), p = 0, h = 0;
    return new st(function() {
      for (; p++ < o; )
        d.next();
      if (++h > l)
        return Jn();
      var m = d.next();
      return r || c === ri || m.done ? m : c === vc ? Nt(c, h - 1, void 0, m) : Nt(c, h - 1, m.value[1], m);
    });
  }, u;
}
function sX(e, t, n) {
  var r = Ii(e);
  return r.__iterateUncached = function(i, o) {
    var a = this;
    if (o)
      return this.cacheResult().__iterate(i, o);
    var s = 0;
    return e.__iterate(
      function(l, u, c) {
        return t.call(n, l, u, c) && ++s && i(l, u, a);
      }
    ), s;
  }, r.__iteratorUncached = function(i, o) {
    var a = this;
    if (o)
      return this.cacheResult().__iterator(i, o);
    var s = e.__iterator(Ir, o), l = !0;
    return new st(function() {
      if (!l)
        return Jn();
      var u = s.next();
      if (u.done)
        return u;
      var c = u.value, f = c[0], d = c[1];
      return t.call(n, d, f, a) ? i === Ir ? u : Nt(i, f, d, u) : (l = !1, Jn());
    });
  }, r;
}
function uC(e, t, n, r) {
  var i = Ii(e);
  return i.__iterateUncached = function(o, a) {
    var s = this;
    if (a)
      return this.cacheResult().__iterate(o, a);
    var l = !0, u = 0;
    return e.__iterate(function(c, f, d) {
      if (!(l && (l = t.call(n, c, f, d))))
        return u++, o(c, r ? f : u - 1, s);
    }), u;
  }, i.__iteratorUncached = function(o, a) {
    var s = this;
    if (a)
      return this.cacheResult().__iterator(o, a);
    var l = e.__iterator(Ir, a), u = !0, c = 0;
    return new st(function() {
      var f, d, p;
      do {
        if (f = l.next(), f.done)
          return r || o === ri ? f : o === vc ? Nt(o, c++, void 0, f) : Nt(o, c++, f.value[1], f);
        var h = f.value;
        d = h[0], p = h[1], u && (u = t.call(n, p, d, s));
      } while (u);
      return o === Ir ? f : Nt(o, d, p, f);
    });
  }, i;
}
function lX(e, t) {
  var n = It(e), r = [e].concat(t).map(function(a) {
    return Qn(a) ? n && (a = jr(a)) : a = n ? S0(a) : XA(Array.isArray(a) ? a : [a]), a;
  }).filter(function(a) {
    return a.size !== 0;
  });
  if (r.length === 0)
    return e;
  if (r.length === 1) {
    var i = r[0];
    if (i === e || n && It(i) || Hn(e) && Hn(i))
      return i;
  }
  var o = new Pa(r);
  return n ? o = o.toKeyedSeq() : Hn(e) || (o = o.toSetSeq()), o = o.flatten(!0), o.size = r.reduce(function(a, s) {
    if (a !== void 0) {
      var l = s.size;
      if (l !== void 0)
        return a + l;
    }
  }, 0), o;
}
function cC(e, t, n) {
  var r = Ii(e);
  return r.__iterateUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterate(i, o);
    var a = 0, s = !1;
    function l(u, c) {
      u.__iterate(function(f, d) {
        return (!t || c < t) && Qn(f) ? l(f, c + 1) : (a++, i(f, n ? d : a - 1, r) === !1 && (s = !0)), !s;
      }, o);
    }
    return l(e, 0), a;
  }, r.__iteratorUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterator(i, o);
    var a = e.__iterator(i, o), s = [], l = 0;
    return new st(function() {
      for (; a; ) {
        var u = a.next();
        if (u.done !== !1) {
          a = s.pop();
          continue;
        }
        var c = u.value;
        if (i === Ir && (c = c[1]), (!t || s.length < t) && Qn(c))
          s.push(a), a = c.__iterator(i, o);
        else
          return n ? u : Nt(i, l++, c, u);
      }
      return Jn();
    });
  }, r;
}
function uX(e, t, n) {
  var r = P0(e);
  return e.toSeq().map(function(i, o) {
    return r(t.call(n, i, o, e));
  }).flatten(!0);
}
function cX(e, t) {
  var n = Ii(e);
  return n.size = e.size && e.size * 2 - 1, n.__iterateUncached = function(r, i) {
    var o = this, a = 0;
    return e.__iterate(
      function(s) {
        return (!a || r(t, a++, o) !== !1) && r(s, a++, o) !== !1;
      },
      i
    ), a;
  }, n.__iteratorUncached = function(r, i) {
    var o = e.__iterator(ri, i), a = 0, s;
    return new st(function() {
      return (!s || a % 2) && (s = o.next(), s.done) ? s : a % 2 ? Nt(r, a++, t) : Nt(r, a++, s.value, s);
    });
  }, n;
}
function Us(e, t, n) {
  t || (t = fC);
  var r = It(e), i = 0, o = e.toSeq().map(function(a, s) {
    return [s, a, i++, n ? n(a, s, e) : a];
  }).valueSeq().toArray();
  return o.sort(function(a, s) {
    return t(a[3], s[3]) || a[2] - s[2];
  }).forEach(
    r ? function(a, s) {
      o[s].length = 2;
    } : function(a, s) {
      o[s] = a[1];
    }
  ), r ? Ko(o) : Hn(e) ? li(o) : _l(o);
}
function Xc(e, t, n) {
  if (t || (t = fC), n) {
    var r = e.toSeq().map(function(i, o) {
      return [i, n(i, o, e)];
    }).reduce(function(i, o) {
      return OS(t, i[1], o[1]) ? o : i;
    });
    return r && r[0];
  }
  return e.reduce(function(i, o) {
    return OS(t, i, o) ? o : i;
  });
}
function OS(e, t, n) {
  var r = e(n, t);
  return r === 0 && n !== t && (n == null || n !== n) || r > 0;
}
function ef(e, t, n, r) {
  var i = Ii(e), o = new Pa(n).map(function(a) {
    return a.size;
  });
  return i.size = r ? o.max() : o.min(), i.__iterate = function(a, s) {
    for (var l = this.__iterator(ri, s), u, c = 0; !(u = l.next()).done && a(u.value, c++, this) !== !1; )
      ;
    return c;
  }, i.__iteratorUncached = function(a, s) {
    var l = n.map(
      function(f) {
        return f = Qt(f), Lg(s ? f.reverse() : f);
      }
    ), u = 0, c = !1;
    return new st(function() {
      var f;
      return c || (f = l.map(function(d) {
        return d.next();
      }), c = r ? f.every(function(d) {
        return d.done;
      }) : f.some(function(d) {
        return d.done;
      })), c ? Jn() : Nt(
        a,
        u++,
        t.apply(
          null,
          f.map(function(d) {
            return d.value;
          })
        )
      );
    });
  }, i;
}
function gt(e, t) {
  return e === t ? e : w0(e) ? t : e.constructor(t);
}
function kS(e) {
  if (e !== Object(e))
    throw new TypeError("Expected [K, V] tuple: " + e);
}
function P0(e) {
  return It(e) ? jr : Hn(e) ? Ka : vl;
}
function Ii(e) {
  return Object.create(
    (It(e) ? Ko : Hn(e) ? li : _l).prototype
  );
}
function D0() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : fr.prototype.cacheResult.call(this);
}
function fC(e, t) {
  return e === void 0 && t === void 0 ? 0 : e === void 0 ? 1 : t === void 0 ? -1 : e > t ? 1 : e < t ? -1 : 0;
}
function wi(e, t) {
  t = t || 0;
  for (var n = Math.max(0, e.length - t), r = new Array(n), i = 0; i < n; i++)
    r[i] = e[i + t];
  return r;
}
function A0(e, t) {
  if (!e)
    throw new Error(t);
}
function ir(e) {
  A0(
    e !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function dC(e) {
  if (JA(e) && typeof e != "string")
    return e;
  if (ti(e))
    return e.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + e
  );
}
var fX = Object.prototype.toString;
function dX(e) {
  if (!e || typeof e != "object" || fX.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var n = t, r = Object.getPrototypeOf(t); r !== null; )
    n = r, r = Object.getPrototypeOf(n);
  return n === t;
}
function Ao(e) {
  return typeof e == "object" && (Ci(e) || Array.isArray(e) || dX(e));
}
function zu(e) {
  try {
    return typeof e == "string" ? JSON.stringify(e) : String(e);
  } catch {
    return JSON.stringify(e);
  }
}
function pX(e, t) {
  return Ci(e) ? e.has(t) : Ao(e) && bl.call(e, t);
}
function pC(e, t, n) {
  return Ci(e) ? e.get(t, n) : pX(e, t) ? typeof e.get == "function" ? e.get(t) : e[t] : n;
}
function gc(e) {
  return typeof e == "string" && (e === "__proto__" || e === "constructor");
}
function Nd(e) {
  if (Array.isArray(e))
    return wi(e);
  var t = {};
  for (var n in e)
    gc(n) || bl.call(e, n) && (t[n] = e[n]);
  return t;
}
function hX(e, t) {
  if (!Ao(e))
    throw new TypeError(
      "Cannot update non-data-structure value: " + e
    );
  if (Ci(e)) {
    if (!e.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + e
      );
    return e.remove(t);
  }
  if (!bl.call(e, t))
    return e;
  var n = Nd(e);
  return Array.isArray(n) ? n.splice(t, 1) : delete n[t], n;
}
function mX(e, t, n) {
  if (gc(t))
    return e;
  if (!Ao(e))
    throw new TypeError(
      "Cannot update non-data-structure value: " + e
    );
  if (Ci(e)) {
    if (!e.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + e
      );
    return e.set(t, n);
  }
  if (bl.call(e, t) && n === e[t])
    return e;
  var r = Nd(e);
  return r[t] = n, r;
}
function wl(e, t, n, r) {
  r || (r = n, n = void 0);
  var i = hC(
    Ci(e),
    e,
    dC(t),
    0,
    n,
    r
  );
  return i === Xe ? n : i;
}
function hC(e, t, n, r, i, o) {
  var a = t === Xe;
  if (r === n.length) {
    var s = a ? i : t, l = o(s);
    return l === s ? t : l;
  }
  if (!a && !Ao(t))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + n.slice(0, r).map(zu) + "]: " + t
    );
  var u = n[r], c = a ? Xe : pC(t, u, Xe), f = hC(
    c === Xe ? e : Ci(c),
    c,
    n,
    r + 1,
    i,
    o
  );
  return f === c ? t : f === Xe ? hX(t, u) : mX(
    a ? e ? Yr() : {} : t,
    u,
    f
  );
}
function vX(e, t, n) {
  return wl(e, t, Xe, function() {
    return n;
  });
}
function C0(e, t) {
  return vX(this, e, t);
}
function gX(e, t) {
  return wl(e, t, function() {
    return Xe;
  });
}
function I0(e) {
  return gX(this, e);
}
function mC(e, t, n, r) {
  return wl(e, [t], n, r);
}
function M0(e, t, n) {
  return arguments.length === 1 ? e(this) : mC(this, e, t, n);
}
function R0(e, t, n) {
  return wl(this, e, t, n);
}
function vC() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  return yC(this, e);
}
function gC(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  if (typeof e != "function")
    throw new TypeError("Invalid merger function: " + e);
  return yC(this, t, e);
}
function yC(e, t, n) {
  for (var r = [], i = 0; i < t.length; i++) {
    var o = jr(t[i]);
    o.size !== 0 && r.push(o);
  }
  return r.length === 0 ? e : e.toSeq().size === 0 && !e.__ownerID && r.length === 1 ? e.constructor(r[0]) : e.withMutations(function(a) {
    for (var s = n ? function(u, c) {
      mC(
        a,
        c,
        Xe,
        function(f) {
          return f === Xe ? u : n(f, u, c);
        }
      );
    } : function(u, c) {
      a.set(c, u);
    }, l = 0; l < r.length; l++)
      r[l].forEach(s);
  });
}
function N0(e, t, n) {
  return j0(e, t, yX(n));
}
function j0(e, t, n) {
  if (!Ao(e))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + e
    );
  if (Ci(e))
    return typeof n == "function" && e.mergeWith ? e.mergeWith.apply(e, [n].concat(t)) : e.merge ? e.merge.apply(e, t) : e.concat.apply(e, t);
  for (var r = Array.isArray(e), i = e, o = r ? Ka : jr, a = r ? function(l) {
    i === e && (i = Nd(i)), i.push(l);
  } : function(l, u) {
    if (!gc(u)) {
      var c = bl.call(i, u), f = c && n ? n(i[u], l, u) : l;
      (!c || f !== i[u]) && (i === e && (i = Nd(i)), i[u] = f);
    }
  }, s = 0; s < t.length; s++)
    o(t[s]).forEach(a);
  return i;
}
function yX(e) {
  function t(n, r, i) {
    return Ao(n) && Ao(r) && bX(n, r) ? j0(n, [r], t) : e ? e(n, r, i) : r;
  }
  return t;
}
function bX(e, t) {
  var n = fr(e), r = fr(t);
  return Hn(n) === Hn(r) && It(n) === It(r);
}
function bC() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  return N0(this, e);
}
function _C(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return N0(this, t, e);
}
function F0(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return wl(this, e, Yr(), function(r) {
    return j0(r, t);
  });
}
function z0(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return wl(
    this,
    e,
    Yr(),
    function(r) {
      return N0(r, t);
    }
  );
}
function yc(e) {
  var t = this.asMutable();
  return e(t), t.wasAltered() ? t.__ensureOwner(this.__ownerID) : this;
}
function bc() {
  return this.__ownerID ? this : this.__ensureOwner(new _0());
}
function _c() {
  return this.__ensureOwner();
}
function L0() {
  return this.__altered;
}
var xl = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Yr() : T0(n) && !ti(n) ? n : Yr().withMutations(function(r) {
      var i = e(n);
      ir(i.size), i.forEach(function(o, a) {
        return r.set(a, o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    return Yr().withMutations(function(i) {
      for (var o = 0; o < n.length; o += 2) {
        if (o + 1 >= n.length)
          throw new Error("Missing value for key: " + n[o]);
        i.set(n[o], n[o + 1]);
      }
    });
  }, t.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, t.prototype.get = function(n, r) {
    return this._root ? this._root.get(0, void 0, n, r) : r;
  }, t.prototype.set = function(n, r) {
    return AS(this, n, r);
  }, t.prototype.remove = function(n) {
    return AS(this, n, Xe);
  }, t.prototype.deleteAll = function(n) {
    var r = Qt(n);
    return r.size === 0 ? this : this.withMutations(function(i) {
      r.forEach(function(o) {
        return i.remove(o);
      });
    });
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : Yr();
  }, t.prototype.sort = function(n) {
    return Yi(Us(this, n));
  }, t.prototype.sortBy = function(n, r) {
    return Yi(Us(this, r, n));
  }, t.prototype.map = function(n, r) {
    var i = this;
    return this.withMutations(function(o) {
      o.forEach(function(a, s) {
        o.set(s, n.call(r, a, s, i));
      });
    });
  }, t.prototype.__iterator = function(n, r) {
    return new _X(this, n, r);
  }, t.prototype.__iterate = function(n, r) {
    var i = this, o = 0;
    return this._root && this._root.iterate(function(a) {
      return o++, n(a[1], a[0], i);
    }, r), o;
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? V0(this.size, this._root, n, this.__hash) : this.size === 0 ? Yr() : (this.__ownerID = n, this.__altered = !1, this);
  }, t;
})(jr);
xl.isMap = T0;
var Dt = xl.prototype;
Dt[eC] = !0;
Dt[hc] = Dt.remove;
Dt.removeAll = Dt.deleteAll;
Dt.setIn = C0;
Dt.removeIn = Dt.deleteIn = I0;
Dt.update = M0;
Dt.updateIn = R0;
Dt.merge = Dt.concat = vC;
Dt.mergeWith = gC;
Dt.mergeDeep = bC;
Dt.mergeDeepWith = _C;
Dt.mergeIn = F0;
Dt.mergeDeepIn = z0;
Dt.withMutations = yc;
Dt.wasAltered = L0;
Dt.asImmutable = _c;
Dt["@@transducer/init"] = Dt.asMutable = bc;
Dt["@@transducer/step"] = function(e, t) {
  return e.set(t[0], t[1]);
};
Dt["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
var Lu = function(e, t) {
  this.ownerID = e, this.entries = t;
};
Lu.prototype.get = function(e, t, n, r) {
  for (var i = this.entries, o = 0, a = i.length; o < a; o++)
    if (ar(n, i[o][0]))
      return i[o][1];
  return r;
};
Lu.prototype.update = function(e, t, n, r, i, o, a) {
  for (var s = i === Xe, l = this.entries, u = 0, c = l.length; u < c && !ar(r, l[u][0]); u++)
    ;
  var f = u < c;
  if (f ? l[u][1] === i : s)
    return this;
  if (Or(a), (s || !f) && Or(o), !(s && l.length === 1)) {
    if (!f && !s && l.length >= TX)
      return wX(e, l, r, i);
    var d = e && e === this.ownerID, p = d ? l : wi(l);
    return f ? s ? u === c - 1 ? p.pop() : p[u] = p.pop() : p[u] = [r, i] : p.push([r, i]), d ? (this.entries = p, this) : new Lu(e, p);
  }
};
var qs = function(e, t, n) {
  this.ownerID = e, this.bitmap = t, this.nodes = n;
};
qs.prototype.get = function(e, t, n, r) {
  t === void 0 && (t = tr(n));
  var i = 1 << ((e === 0 ? t : t >>> e) & jn), o = this.bitmap;
  return (o & i) === 0 ? r : this.nodes[wC(o & i - 1)].get(
    e + kt,
    t,
    n,
    r
  );
};
qs.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = tr(r));
  var s = (t === 0 ? n : n >>> t) & jn, l = 1 << s, u = this.bitmap, c = (u & l) !== 0;
  if (!c && i === Xe)
    return this;
  var f = wC(u & l - 1), d = this.nodes, p = c ? d[f] : void 0, h = B0(
    p,
    e,
    t + kt,
    n,
    r,
    i,
    o,
    a
  );
  if (h === p)
    return this;
  if (!c && h && d.length >= OX)
    return EX(e, d, u, s, h);
  if (c && !h && d.length === 2 && CS(d[f ^ 1]))
    return d[f ^ 1];
  if (c && h && d.length === 1 && CS(h))
    return h;
  var m = e && e === this.ownerID, v = c ? h ? u : u ^ l : u | l, g = c ? h ? xC(d, f, h, m) : $X(d, f, m) : SX(d, f, h, m);
  return m ? (this.bitmap = v, this.nodes = g, this) : new qs(e, v, g);
};
var Vu = function(e, t, n) {
  this.ownerID = e, this.count = t, this.nodes = n;
};
Vu.prototype.get = function(e, t, n, r) {
  t === void 0 && (t = tr(n));
  var i = (e === 0 ? t : t >>> e) & jn, o = this.nodes[i];
  return o ? o.get(e + kt, t, n, r) : r;
};
Vu.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = tr(r));
  var s = (t === 0 ? n : n >>> t) & jn, l = i === Xe, u = this.nodes, c = u[s];
  if (l && !c)
    return this;
  var f = B0(
    c,
    e,
    t + kt,
    n,
    r,
    i,
    o,
    a
  );
  if (f === c)
    return this;
  var d = this.count;
  if (!c)
    d++;
  else if (!f && (d--, d < kX))
    return xX(e, u, d, s);
  var p = e && e === this.ownerID, h = xC(u, s, f, p);
  return p ? (this.count = d, this.nodes = h, this) : new Vu(e, d, h);
};
var Hs = function(e, t, n) {
  this.ownerID = e, this.keyHash = t, this.entries = n;
};
Hs.prototype.get = function(e, t, n, r) {
  for (var i = this.entries, o = 0, a = i.length; o < a; o++)
    if (ar(n, i[o][0]))
      return i[o][1];
  return r;
};
Hs.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = tr(r));
  var s = i === Xe;
  if (n !== this.keyHash)
    return s ? this : (Or(a), Or(o), K0(this, e, t, n, [r, i]));
  for (var l = this.entries, u = 0, c = l.length; u < c && !ar(r, l[u][0]); u++)
    ;
  var f = u < c;
  if (f ? l[u][1] === i : s)
    return this;
  if (Or(a), (s || !f) && Or(o), s && c === 2)
    return new Gi(e, this.keyHash, l[u ^ 1]);
  var d = e && e === this.ownerID, p = d ? l : wi(l);
  return f ? s ? u === c - 1 ? p.pop() : p[u] = p.pop() : p[u] = [r, i] : p.push([r, i]), d ? (this.entries = p, this) : new Hs(e, this.keyHash, p);
};
var Gi = function(e, t, n) {
  this.ownerID = e, this.keyHash = t, this.entry = n;
};
Gi.prototype.get = function(e, t, n, r) {
  return ar(n, this.entry[0]) ? this.entry[1] : r;
};
Gi.prototype.update = function(e, t, n, r, i, o, a) {
  var s = i === Xe, l = ar(r, this.entry[0]);
  if (l ? i === this.entry[1] : s)
    return this;
  if (Or(a), s) {
    Or(o);
    return;
  }
  return l ? e && e === this.ownerID ? (this.entry[1] = i, this) : new Gi(e, this.keyHash, [r, i]) : (Or(o), K0(this, e, t, tr(r), [r, i]));
};
Lu.prototype.iterate = Hs.prototype.iterate = function(e, t) {
  for (var n = this.entries, r = 0, i = n.length - 1; r <= i; r++)
    if (e(n[t ? i - r : r]) === !1)
      return !1;
};
qs.prototype.iterate = Vu.prototype.iterate = function(e, t) {
  for (var n = this.nodes, r = 0, i = n.length - 1; r <= i; r++) {
    var o = n[t ? i - r : r];
    if (o && o.iterate(e, t) === !1)
      return !1;
  }
};
Gi.prototype.iterate = function(e, t) {
  return e(this.entry);
};
var _X = /* @__PURE__ */ (function(e) {
  function t(n, r, i) {
    this._type = r, this._reverse = i, this._stack = n._root && PS(n._root);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.next = function() {
    for (var n = this._type, r = this._stack; r; ) {
      var i = r.node, o = r.index++, a = void 0;
      if (i.entry) {
        if (o === 0)
          return Tm(n, i.entry);
      } else if (i.entries) {
        if (a = i.entries.length - 1, o <= a)
          return Tm(
            n,
            i.entries[this._reverse ? a - o : o]
          );
      } else if (a = i.nodes.length - 1, o <= a) {
        var s = i.nodes[this._reverse ? a - o : o];
        if (s) {
          if (s.entry)
            return Tm(n, s.entry);
          r = this._stack = PS(s, r);
        }
        continue;
      }
      r = this._stack = this._stack.__prev;
    }
    return Jn();
  }, t;
})(st);
function Tm(e, t) {
  return Nt(e, t[0], t[1]);
}
function PS(e, t) {
  return {
    node: e,
    index: 0,
    __prev: t
  };
}
function V0(e, t, n, r) {
  var i = Object.create(Dt);
  return i.size = e, i._root = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var DS;
function Yr() {
  return DS || (DS = V0(0));
}
function AS(e, t, n) {
  var r, i;
  if (e._root) {
    var o = Fg(), a = Fg();
    if (r = B0(
      e._root,
      e.__ownerID,
      0,
      void 0,
      t,
      n,
      o,
      a
    ), !a.value)
      return e;
    i = e.size + (o.value ? n === Xe ? -1 : 1 : 0);
  } else {
    if (n === Xe)
      return e;
    i = 1, r = new Lu(e.__ownerID, [[t, n]]);
  }
  return e.__ownerID ? (e.size = i, e._root = r, e.__hash = void 0, e.__altered = !0, e) : r ? V0(i, r) : Yr();
}
function B0(e, t, n, r, i, o, a, s) {
  return e ? e.update(
    t,
    n,
    r,
    i,
    o,
    a,
    s
  ) : o === Xe ? e : (Or(s), Or(a), new Gi(t, r, [i, o]));
}
function CS(e) {
  return e.constructor === Gi || e.constructor === Hs;
}
function K0(e, t, n, r, i) {
  if (e.keyHash === r)
    return new Hs(t, r, [e.entry, i]);
  var o = (n === 0 ? e.keyHash : e.keyHash >>> n) & jn, a = (n === 0 ? r : r >>> n) & jn, s, l = o === a ? [K0(e, t, n + kt, r, i)] : (s = new Gi(t, r, i), o < a ? [e, s] : [s, e]);
  return new qs(t, 1 << o | 1 << a, l);
}
function wX(e, t, n, r) {
  e || (e = new _0());
  for (var i = new Gi(e, tr(n), [n, r]), o = 0; o < t.length; o++) {
    var a = t[o];
    i = i.update(e, 0, void 0, a[0], a[1]);
  }
  return i;
}
function xX(e, t, n, r) {
  for (var i = 0, o = 0, a = new Array(n), s = 0, l = 1, u = t.length; s < u; s++, l <<= 1) {
    var c = t[s];
    c !== void 0 && s !== r && (i |= l, a[o++] = c);
  }
  return new qs(e, i, a);
}
function EX(e, t, n, r, i) {
  for (var o = 0, a = new Array(Tr), s = 0; n !== 0; s++, n >>>= 1)
    a[s] = n & 1 ? t[o++] : void 0;
  return a[r] = i, new Vu(e, o + 1, a);
}
function wC(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), e = e + (e >> 4) & 252645135, e += e >> 8, e += e >> 16, e & 127;
}
function xC(e, t, n, r) {
  var i = r ? e : wi(e);
  return i[t] = n, i;
}
function SX(e, t, n, r) {
  var i = e.length + 1;
  if (r && t + 1 === i)
    return e[t] = n, e;
  for (var o = new Array(i), a = 0, s = 0; s < i; s++)
    s === t ? (o[s] = n, a = -1) : o[s] = e[s + a];
  return o;
}
function $X(e, t, n) {
  var r = e.length - 1;
  if (n && t === r)
    return e.pop(), e;
  for (var i = new Array(r), o = 0, a = 0; a < r; a++)
    a === t && (o = 1), i[a] = e[a + o];
  return i;
}
var TX = Tr / 4, OX = Tr / 2, kX = Tr / 4, EC = "@@__IMMUTABLE_LIST__@@";
function SC(e) {
  return !!(e && e[EC]);
}
var Zp = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r = If();
    if (n == null)
      return r;
    if (SC(n))
      return n;
    var i = e(n), o = i.size;
    return o === 0 ? r : (ir(o), o > 0 && o < Tr ? Bu(0, o, kt, null, new _o(i.toArray())) : r.withMutations(function(a) {
      a.setSize(o), i.forEach(function(s, l) {
        return a.set(l, s);
      });
    }));
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, t.prototype.get = function(n, r) {
    if (n = Do(this, n), n >= 0 && n < this.size) {
      n += this._origin;
      var i = $C(this, n);
      return i && i.array[n & jn];
    }
    return r;
  }, t.prototype.set = function(n, r) {
    return PX(this, n, r);
  }, t.prototype.remove = function(n) {
    return this.has(n) ? n === 0 ? this.shift() : n === this.size - 1 ? this.pop() : this.splice(n, 1) : this;
  }, t.prototype.insert = function(n, r) {
    return this.splice(n, 0, r);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = kt, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : If();
  }, t.prototype.push = function() {
    var n = arguments, r = this.size;
    return this.withMutations(function(i) {
      so(i, 0, r + n.length);
      for (var o = 0; o < n.length; o++)
        i.set(r + o, n[o]);
    });
  }, t.prototype.pop = function() {
    return so(this, 0, -1);
  }, t.prototype.unshift = function() {
    var n = arguments;
    return this.withMutations(function(r) {
      so(r, -n.length);
      for (var i = 0; i < n.length; i++)
        r.set(i, n[i]);
    });
  }, t.prototype.shift = function() {
    return so(this, 1);
  }, t.prototype.concat = function() {
    for (var n = arguments, r = [], i = 0; i < arguments.length; i++) {
      var o = n[i], a = e(
        typeof o != "string" && QA(o) ? o : [o]
      );
      a.size !== 0 && r.push(a);
    }
    return r.length === 0 ? this : this.size === 0 && !this.__ownerID && r.length === 1 ? this.constructor(r[0]) : this.withMutations(function(s) {
      r.forEach(function(l) {
        return l.forEach(function(u) {
          return s.push(u);
        });
      });
    });
  }, t.prototype.setSize = function(n) {
    return so(this, 0, n);
  }, t.prototype.map = function(n, r) {
    var i = this;
    return this.withMutations(function(o) {
      for (var a = 0; a < i.size; a++)
        o.set(a, n.call(r, o.get(a), a, i));
    });
  }, t.prototype.slice = function(n, r) {
    var i = this.size;
    return Vp(n, r, i) ? this : so(
      this,
      mc(n, i),
      Bp(r, i)
    );
  }, t.prototype.__iterator = function(n, r) {
    var i = r ? this.size : 0, o = IS(this, r);
    return new st(function() {
      var a = o();
      return a === mu ? Jn() : Nt(n, r ? --i : i++, a);
    });
  }, t.prototype.__iterate = function(n, r) {
    for (var i = r ? this.size : 0, o = IS(this, r), a; (a = o()) !== mu && n(a, r ? --i : i++, this) !== !1; )
      ;
    return i;
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? Bu(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      n,
      this.__hash
    ) : this.size === 0 ? If() : (this.__ownerID = n, this.__altered = !1, this);
  }, t;
})(Ka);
Zp.isList = SC;
var an = Zp.prototype;
an[EC] = !0;
an[hc] = an.remove;
an.merge = an.concat;
an.setIn = C0;
an.deleteIn = an.removeIn = I0;
an.update = M0;
an.updateIn = R0;
an.mergeIn = F0;
an.mergeDeepIn = z0;
an.withMutations = yc;
an.wasAltered = L0;
an.asImmutable = _c;
an["@@transducer/init"] = an.asMutable = bc;
an["@@transducer/step"] = function(e, t) {
  return e.push(t);
};
an["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
var _o = function(e, t) {
  this.array = e, this.ownerID = t;
};
_o.prototype.removeBefore = function(e, t, n) {
  if (n === t ? 1 << t : this.array.length === 0)
    return this;
  var r = n >>> t & jn;
  if (r >= this.array.length)
    return new _o([], e);
  var i = r === 0, o;
  if (t > 0) {
    var a = this.array[r];
    if (o = a && a.removeBefore(e, t - kt, n), o === a && i)
      return this;
  }
  if (i && !o)
    return this;
  var s = Ws(this, e);
  if (!i)
    for (var l = 0; l < r; l++)
      s.array[l] = void 0;
  return o && (s.array[r] = o), s;
};
_o.prototype.removeAfter = function(e, t, n) {
  if (n === (t ? 1 << t : 0) || this.array.length === 0)
    return this;
  var r = n - 1 >>> t & jn;
  if (r >= this.array.length)
    return this;
  var i;
  if (t > 0) {
    var o = this.array[r];
    if (i = o && o.removeAfter(e, t - kt, n), i === o && r === this.array.length - 1)
      return this;
  }
  var a = Ws(this, e);
  return a.array.splice(r + 1), i && (a.array[r] = i), a;
};
var mu = {};
function IS(e, t) {
  var n = e._origin, r = e._capacity, i = Ku(r), o = e._tail;
  return a(e._root, e._level, 0);
  function a(u, c, f) {
    return c === 0 ? s(u, f) : l(u, c, f);
  }
  function s(u, c) {
    var f = c === i ? o && o.array : u && u.array, d = c > n ? 0 : n - c, p = r - c;
    return p > Tr && (p = Tr), function() {
      if (d === p)
        return mu;
      var h = t ? --p : d++;
      return f && f[h];
    };
  }
  function l(u, c, f) {
    var d, p = u && u.array, h = f > n ? 0 : n - f >> c, m = (r - f >> c) + 1;
    return m > Tr && (m = Tr), function() {
      for (; ; ) {
        if (d) {
          var v = d();
          if (v !== mu)
            return v;
          d = null;
        }
        if (h === m)
          return mu;
        var g = t ? --m : h++;
        d = a(
          p && p[g],
          c - kt,
          f + (g << c)
        );
      }
    };
  }
}
function Bu(e, t, n, r, i, o, a) {
  var s = Object.create(an);
  return s.size = t - e, s._origin = e, s._capacity = t, s._level = n, s._root = r, s._tail = i, s.__ownerID = o, s.__hash = a, s.__altered = !1, s;
}
var MS;
function If() {
  return MS || (MS = Bu(0, 0, kt));
}
function PX(e, t, n) {
  if (t = Do(e, t), t !== t)
    return e;
  if (t >= e.size || t < 0)
    return e.withMutations(function(a) {
      t < 0 ? so(a, t).set(0, n) : so(a, 0, t + 1).set(t, n);
    });
  t += e._origin;
  var r = e._tail, i = e._root, o = Fg();
  return t >= Ku(e._capacity) ? r = Ug(r, e.__ownerID, 0, t, n, o) : i = Ug(
    i,
    e.__ownerID,
    e._level,
    t,
    n,
    o
  ), o.value ? e.__ownerID ? (e._root = i, e._tail = r, e.__hash = void 0, e.__altered = !0, e) : Bu(e._origin, e._capacity, e._level, i, r) : e;
}
function Ug(e, t, n, r, i, o) {
  var a = r >>> n & jn, s = e && a < e.array.length;
  if (!s && i === void 0)
    return e;
  var l;
  if (n > 0) {
    var u = e && e.array[a], c = Ug(
      u,
      t,
      n - kt,
      r,
      i,
      o
    );
    return c === u ? e : (l = Ws(e, t), l.array[a] = c, l);
  }
  return s && e.array[a] === i ? e : (o && Or(o), l = Ws(e, t), i === void 0 && a === l.array.length - 1 ? l.array.pop() : l.array[a] = i, l);
}
function Ws(e, t) {
  return t && e && t === e.ownerID ? e : new _o(e ? e.array.slice() : [], t);
}
function $C(e, t) {
  if (t >= Ku(e._capacity))
    return e._tail;
  if (t < 1 << e._level + kt) {
    for (var n = e._root, r = e._level; n && r > 0; )
      n = n.array[t >>> r & jn], r -= kt;
    return n;
  }
}
function so(e, t, n) {
  t !== void 0 && (t |= 0), n !== void 0 && (n |= 0);
  var r = e.__ownerID || new _0(), i = e._origin, o = e._capacity, a = i + t, s = n === void 0 ? o : n < 0 ? o + n : i + n;
  if (a === i && s === o)
    return e;
  if (a >= s)
    return e.clear();
  for (var l = e._level, u = e._root, c = 0; a + c < 0; )
    u = new _o(
      u && u.array.length ? [void 0, u] : [],
      r
    ), l += kt, c += 1 << l;
  c && (a += c, i += c, s += c, o += c);
  for (var f = Ku(o), d = Ku(s); d >= 1 << l + kt; )
    u = new _o(
      u && u.array.length ? [u] : [],
      r
    ), l += kt;
  var p = e._tail, h = d < f ? $C(e, s - 1) : d > f ? new _o([], r) : p;
  if (p && d > f && a < o && p.array.length) {
    u = Ws(u, r);
    for (var m = u, v = l; v > kt; v -= kt) {
      var g = f >>> v & jn;
      m = m.array[g] = Ws(m.array[g], r);
    }
    m.array[f >>> kt & jn] = p;
  }
  if (s < o && (h = h && h.removeAfter(r, 0, s)), a >= d)
    a -= d, s -= d, l = kt, u = null, h = h && h.removeBefore(r, 0, a);
  else if (a > i || d < f) {
    for (c = 0; u; ) {
      var b = a >>> l & jn;
      if (b !== d >>> l & jn)
        break;
      b && (c += (1 << l) * b), l -= kt, u = u.array[b];
    }
    u && a > i && (u = u.removeBefore(r, l, a - c)), u && d < f && (u = u.removeAfter(
      r,
      l,
      d - c
    )), c && (a -= c, s -= c);
  }
  return e.__ownerID ? (e.size = s - a, e._origin = a, e._capacity = s, e._level = l, e._root = u, e._tail = h, e.__hash = void 0, e.__altered = !0, e) : Bu(a, s, l, u, h);
}
function Ku(e) {
  return e < Tr ? 0 : e - 1 >>> kt << kt;
}
var Yi = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Ql() : tC(n) ? n : Ql().withMutations(function(r) {
      var i = jr(n);
      ir(i.size), i.forEach(function(o, a) {
        return r.set(a, o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, t.prototype.get = function(n, r) {
    var i = this._map.get(n);
    return i !== void 0 ? this._list.get(i)[1] : r;
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : Ql();
  }, t.prototype.set = function(n, r) {
    return NS(this, n, r);
  }, t.prototype.remove = function(n) {
    return NS(this, n, Xe);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._list.__iterate(
      function(o) {
        return o && n(o[1], o[0], i);
      },
      r
    );
  }, t.prototype.__iterator = function(n, r) {
    return this._list.fromEntrySeq().__iterator(n, r);
  }, t.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var r = this._map.__ensureOwner(n), i = this._list.__ensureOwner(n);
    return n ? U0(r, i, n, this.__hash) : this.size === 0 ? Ql() : (this.__ownerID = n, this.__altered = !1, this._map = r, this._list = i, this);
  }, t;
})(xl);
Yi.isOrderedMap = tC;
Yi.prototype[yl] = !0;
Yi.prototype[hc] = Yi.prototype.remove;
function U0(e, t, n, r) {
  var i = Object.create(Yi.prototype);
  return i.size = e ? e.size : 0, i._map = e, i._list = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var RS;
function Ql() {
  return RS || (RS = U0(Yr(), If()));
}
function NS(e, t, n) {
  var r = e._map, i = e._list, o = r.get(t), a = o !== void 0, s, l;
  if (n === Xe) {
    if (!a)
      return e;
    i.size >= Tr && i.size >= r.size * 2 ? (l = i.filter(function(u, c) {
      return u !== void 0 && o !== c;
    }), s = l.toKeyedSeq().map(function(u) {
      return u[0];
    }).flip().toMap(), e.__ownerID && (s.__ownerID = l.__ownerID = e.__ownerID)) : (s = r.remove(t), l = o === i.size - 1 ? i.pop() : i.set(o, void 0));
  } else if (a) {
    if (n === i.get(o)[1])
      return e;
    s = r, l = i.set(o, [t, n]);
  } else
    s = r.set(t, i.size), l = i.set(i.size, [t, n]);
  return e.__ownerID ? (e.size = s.size, e._map = s, e._list = l, e.__hash = void 0, e.__altered = !0, e) : U0(s, l);
}
var TC = "@@__IMMUTABLE_STACK__@@";
function qg(e) {
  return !!(e && e[TC]);
}
var q0 = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? tf() : qg(n) ? n : tf().pushAll(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, t.prototype.get = function(n, r) {
    var i = this._head;
    for (n = Do(this, n); i && n--; )
      i = i.next;
    return i ? i.value : r;
  }, t.prototype.peek = function() {
    return this._head && this._head.value;
  }, t.prototype.push = function() {
    var n = arguments;
    if (arguments.length === 0)
      return this;
    for (var r = this.size + arguments.length, i = this._head, o = arguments.length - 1; o >= 0; o--)
      i = {
        value: n[o],
        next: i
      };
    return this.__ownerID ? (this.size = r, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Jl(r, i);
  }, t.prototype.pushAll = function(n) {
    if (n = e(n), n.size === 0)
      return this;
    if (this.size === 0 && qg(n))
      return n;
    ir(n.size);
    var r = this.size, i = this._head;
    return n.__iterate(function(o) {
      r++, i = {
        value: o,
        next: i
      };
    }, !0), this.__ownerID ? (this.size = r, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Jl(r, i);
  }, t.prototype.pop = function() {
    return this.slice(1);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : tf();
  }, t.prototype.slice = function(n, r) {
    if (Vp(n, r, this.size))
      return this;
    var i = mc(n, this.size), o = Bp(r, this.size);
    if (o !== this.size)
      return e.prototype.slice.call(this, n, r);
    for (var a = this.size - i, s = this._head; i--; )
      s = s.next;
    return this.__ownerID ? (this.size = a, this._head = s, this.__hash = void 0, this.__altered = !0, this) : Jl(a, s);
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? Jl(this.size, this._head, n, this.__hash) : this.size === 0 ? tf() : (this.__ownerID = n, this.__altered = !1, this);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    if (r)
      return new Pa(this.toArray()).__iterate(
        function(s, l) {
          return n(s, l, i);
        },
        r
      );
    for (var o = 0, a = this._head; a && n(a.value, o++, this) !== !1; )
      a = a.next;
    return o;
  }, t.prototype.__iterator = function(n, r) {
    if (r)
      return new Pa(this.toArray()).__iterator(n, r);
    var i = 0, o = this._head;
    return new st(function() {
      if (o) {
        var a = o.value;
        return o = o.next, Nt(n, i++, a);
      }
      return Jn();
    });
  }, t;
})(Ka);
q0.isStack = qg;
var zn = q0.prototype;
zn[TC] = !0;
zn.shift = zn.pop;
zn.unshift = zn.push;
zn.unshiftAll = zn.pushAll;
zn.withMutations = yc;
zn.wasAltered = L0;
zn.asImmutable = _c;
zn["@@transducer/init"] = zn.asMutable = bc;
zn["@@transducer/step"] = function(e, t) {
  return e.unshift(t);
};
zn["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
function Jl(e, t, n, r) {
  var i = Object.create(zn);
  return i.size = e, i._head = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var jS;
function tf() {
  return jS || (jS = Jl(0));
}
var OC = "@@__IMMUTABLE_SET__@@";
function H0(e) {
  return !!(e && e[OC]);
}
function kC(e) {
  return H0(e) && ti(e);
}
function PC(e, t) {
  if (e === t)
    return !0;
  if (!Qn(t) || e.size !== void 0 && t.size !== void 0 && e.size !== t.size || e.__hash !== void 0 && t.__hash !== void 0 && e.__hash !== t.__hash || It(e) !== It(t) || Hn(e) !== Hn(t) || ti(e) !== ti(t))
    return !1;
  if (e.size === 0 && t.size === 0)
    return !0;
  var n = !Kp(e);
  if (ti(e)) {
    var r = e.entries();
    return t.every(function(l, u) {
      var c = r.next().value;
      return c && ar(c[1], l) && (n || ar(c[0], u));
    }) && r.next().done;
  }
  var i = !1;
  if (e.size === void 0)
    if (t.size === void 0)
      typeof e.cacheResult == "function" && e.cacheResult();
    else {
      i = !0;
      var o = e;
      e = t, t = o;
    }
  var a = !0, s = t.__iterate(function(l, u) {
    if (n ? !e.has(l) : i ? !ar(l, e.get(u, Xe)) : !ar(e.get(u, Xe), l))
      return a = !1, !1;
  });
  return a && e.size === s;
}
function Ua(e, t) {
  var n = function(r) {
    e.prototype[r] = t[r];
  };
  return Object.keys(t).forEach(n), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(n), e;
}
function jd(e) {
  if (!e || typeof e != "object")
    return e;
  if (!Qn(e)) {
    if (!Ao(e))
      return e;
    e = fr(e);
  }
  if (It(e)) {
    var t = {};
    return e.__iterate(function(r, i) {
      gc(i) || (t[i] = jd(r));
    }), t;
  }
  var n = [];
  return e.__iterate(function(r) {
    n.push(jd(r));
  }), n;
}
var Gp = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Xl() : H0(n) && !ti(n) ? n : Xl().withMutations(function(r) {
      var i = e(n);
      ir(i.size), i.forEach(function(o) {
        return r.add(o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(n) {
    return this(jr(n).keySeq());
  }, t.intersect = function(n) {
    return n = Qt(n).toArray(), n.length ? bn.intersect.apply(t(n.pop()), n) : Xl();
  }, t.union = function(n) {
    return n = Qt(n).toArray(), n.length ? bn.union.apply(t(n.pop()), n) : Xl();
  }, t.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, t.prototype.has = function(n) {
    return this._map.has(n);
  }, t.prototype.add = function(n) {
    return nf(this, this._map.set(n, n));
  }, t.prototype.remove = function(n) {
    return nf(this, this._map.remove(n));
  }, t.prototype.clear = function() {
    return nf(this, this._map.clear());
  }, t.prototype.map = function(n, r) {
    var i = this, o = !1, a = nf(
      this,
      this._map.mapEntries(function(s) {
        var l = s[1], u = n.call(r, l, l, i);
        return u !== l && (o = !0), [u, u];
      }, r)
    );
    return o ? a : this;
  }, t.prototype.union = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    return n = n.filter(function(i) {
      return i.size !== 0;
    }), n.length === 0 ? this : this.size === 0 && !this.__ownerID && n.length === 1 ? this.constructor(n[0]) : this.withMutations(function(i) {
      for (var o = 0; o < n.length; o++)
        typeof n[o] == "string" ? i.add(n[o]) : e(n[o]).forEach(function(a) {
          return i.add(a);
        });
    });
  }, t.prototype.intersect = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    if (n.length === 0)
      return this;
    n = n.map(function(o) {
      return e(o);
    });
    var i = [];
    return this.forEach(function(o) {
      n.every(function(a) {
        return a.includes(o);
      }) || i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(a) {
        o.remove(a);
      });
    });
  }, t.prototype.subtract = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    if (n.length === 0)
      return this;
    n = n.map(function(o) {
      return e(o);
    });
    var i = [];
    return this.forEach(function(o) {
      n.some(function(a) {
        return a.includes(o);
      }) && i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(a) {
        o.remove(a);
      });
    });
  }, t.prototype.sort = function(n) {
    return Uu(Us(this, n));
  }, t.prototype.sortBy = function(n, r) {
    return Uu(Us(this, r, n));
  }, t.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._map.__iterate(function(o) {
      return n(o, o, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    return this._map.__iterator(n, r);
  }, t.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var r = this._map.__ensureOwner(n);
    return n ? this.__make(r, n) : this.size === 0 ? this.__empty() : (this.__ownerID = n, this._map = r, this);
  }, t;
})(vl);
Gp.isSet = H0;
var bn = Gp.prototype;
bn[OC] = !0;
bn[hc] = bn.remove;
bn.merge = bn.concat = bn.union;
bn.withMutations = yc;
bn.asImmutable = _c;
bn["@@transducer/init"] = bn.asMutable = bc;
bn["@@transducer/step"] = function(e, t) {
  return e.add(t);
};
bn["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
bn.__empty = Xl;
bn.__make = DC;
function nf(e, t) {
  return e.__ownerID ? (e.size = t.size, e._map = t, e) : t === e._map ? e : t.size === 0 ? e.__empty() : e.__make(t);
}
function DC(e, t) {
  var n = Object.create(bn);
  return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
}
var FS;
function Xl() {
  return FS || (FS = DC(Yr()));
}
var DX = /* @__PURE__ */ (function(e) {
  function t(n, r, i) {
    if (!(this instanceof t))
      return new t(n, r, i);
    if (A0(i !== 0, "Cannot step a Range by 0"), n = n || 0, r === void 0 && (r = 1 / 0), i = i === void 0 ? 1 : Math.abs(i), r < n && (i = -i), this._start = n, this._end = r, this._step = i, this.size = Math.max(0, Math.ceil((r - n) / i - 1) + 1), this.size === 0) {
      if (Om)
        return Om;
      Om = this;
    }
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, t.prototype.get = function(n, r) {
    return this.has(n) ? this._start + Do(this, n) * this._step : r;
  }, t.prototype.includes = function(n) {
    var r = (n - this._start) / this._step;
    return r >= 0 && r < this.size && r === Math.floor(r);
  }, t.prototype.slice = function(n, r) {
    return Vp(n, r, this.size) ? this : (n = mc(n, this.size), r = Bp(r, this.size), r <= n ? new t(0, 0) : new t(
      this.get(n, this._end),
      this.get(r, this._end),
      this._step
    ));
  }, t.prototype.indexOf = function(n) {
    var r = n - this._start;
    if (r % this._step === 0) {
      var i = r / this._step;
      if (i >= 0 && i < this.size)
        return i;
    }
    return -1;
  }, t.prototype.lastIndexOf = function(n) {
    return this.indexOf(n);
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this.size, o = this._step, a = r ? this._start + (i - 1) * o : this._start, s = 0; s !== i && n(a, r ? i - ++s : s++, this) !== !1; )
      a += r ? -o : o;
    return s;
  }, t.prototype.__iterator = function(n, r) {
    var i = this.size, o = this._step, a = r ? this._start + (i - 1) * o : this._start, s = 0;
    return new st(function() {
      if (s === i)
        return Jn();
      var l = a;
      return a += r ? -o : o, Nt(n, r ? i - ++s : s++, l);
    });
  }, t.prototype.equals = function(n) {
    return n instanceof t ? this._start === n._start && this._end === n._end && this._step === n._step : PC(this, n);
  }, t;
})(li), Om;
function AC(e, t, n) {
  for (var r = dC(t), i = 0; i !== r.length; )
    if (e = pC(e, r[i++], Xe), e === Xe)
      return n;
  return e;
}
function CC(e, t) {
  return AC(this, e, t);
}
function AX(e, t) {
  return AC(e, t, Xe) !== Xe;
}
function CX(e) {
  return AX(this, e);
}
function IC() {
  ir(this.size);
  var e = {};
  return this.__iterate(function(t, n) {
    gc(n) || (e[n] = t);
  }), e;
}
Qt.isIterable = Qn;
Qt.isKeyed = It;
Qt.isIndexed = Hn;
Qt.isAssociative = Kp;
Qt.isOrdered = ti;
Qt.Iterator = st;
Ua(Qt, {
  toArray: function() {
    ir(this.size);
    var e = new Array(this.size || 0), t = It(this), n = 0;
    return this.__iterate(function(r, i) {
      e[n++] = t ? [i, r] : r;
    }), e;
  },
  toIndexedSeq: function() {
    return new rC(this);
  },
  toJS: function() {
    return jd(this);
  },
  toKeyedSeq: function() {
    return new Wp(this, !0);
  },
  toMap: function() {
    return xl(this.toKeyedSeq());
  },
  toObject: IC,
  toOrderedMap: function() {
    return Yi(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return Uu(It(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return Gp(It(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new iC(this);
  },
  toSeq: function() {
    return Hn(this) ? this.toIndexedSeq() : It(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return q0(It(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return Zp(It(this) ? this.valueSeq() : this);
  },
  toString: function() {
    return "[Collection]";
  },
  __toString: function(e, t) {
    return this.size === 0 ? e + t : e + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + t;
  },
  concat: function() {
    for (var e = [], t = arguments.length; t--; )
      e[t] = arguments[t];
    return gt(this, lX(this, e));
  },
  includes: function(e) {
    return this.some(function(t) {
      return ar(t, e);
    });
  },
  entries: function() {
    return this.__iterator(Ir);
  },
  every: function(e, t) {
    ir(this.size);
    var n = !0;
    return this.__iterate(function(r, i, o) {
      if (!e.call(t, r, i, o))
        return n = !1, !1;
    }), n;
  },
  filter: function(e, t) {
    return gt(this, lC(this, e, t, !0));
  },
  partition: function(e, t) {
    return aX(this, e, t);
  },
  find: function(e, t, n) {
    var r = this.findEntry(e, t);
    return r ? r[1] : n;
  },
  forEach: function(e, t) {
    return ir(this.size), this.__iterate(t ? e.bind(t) : e);
  },
  join: function(e) {
    ir(this.size), e = e !== void 0 ? "" + e : ",";
    var t = "", n = !0;
    return this.__iterate(function(r) {
      n ? n = !1 : t += e, t += r != null ? r.toString() : "";
    }), t;
  },
  keys: function() {
    return this.__iterator(vc);
  },
  map: function(e, t) {
    return gt(this, sC(this, e, t));
  },
  reduce: function(e, t, n) {
    return zS(
      this,
      e,
      t,
      n,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(e, t, n) {
    return zS(
      this,
      e,
      t,
      n,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return gt(this, O0(this, !0));
  },
  slice: function(e, t) {
    return gt(this, k0(this, e, t, !0));
  },
  some: function(e, t) {
    ir(this.size);
    var n = !1;
    return this.__iterate(function(r, i, o) {
      if (e.call(t, r, i, o))
        return n = !0, !1;
    }), n;
  },
  sort: function(e) {
    return gt(this, Us(this, e));
  },
  values: function() {
    return this.__iterator(ri);
  },
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(e, t) {
    return Ks(
      e ? this.toSeq().filter(e, t) : this
    );
  },
  countBy: function(e, t) {
    return iX(this, e, t);
  },
  equals: function(e) {
    return PC(this, e);
  },
  entrySeq: function() {
    var e = this;
    if (e._cache)
      return new Pa(e._cache);
    var t = e.toSeq().map(MX).toIndexedSeq();
    return t.fromEntrySeq = function() {
      return e.toSeq();
    }, t;
  },
  filterNot: function(e, t) {
    return this.filter(km(e), t);
  },
  findEntry: function(e, t, n) {
    var r = n;
    return this.__iterate(function(i, o, a) {
      if (e.call(t, i, o, a))
        return r = [o, i], !1;
    }), r;
  },
  findKey: function(e, t) {
    var n = this.findEntry(e, t);
    return n && n[0];
  },
  findLast: function(e, t, n) {
    return this.toKeyedSeq().reverse().find(e, t, n);
  },
  findLastEntry: function(e, t, n) {
    return this.toKeyedSeq().reverse().findEntry(e, t, n);
  },
  findLastKey: function(e, t) {
    return this.toKeyedSeq().reverse().findKey(e, t);
  },
  first: function(e) {
    return this.find(BA, null, e);
  },
  flatMap: function(e, t) {
    return gt(this, uX(this, e, t));
  },
  flatten: function(e) {
    return gt(this, cC(this, e, !0));
  },
  fromEntrySeq: function() {
    return new oC(this);
  },
  get: function(e, t) {
    return this.find(function(n, r) {
      return ar(r, e);
    }, void 0, t);
  },
  getIn: CC,
  groupBy: function(e, t) {
    return oX(this, e, t);
  },
  has: function(e) {
    return this.get(e, Xe) !== Xe;
  },
  hasIn: CX,
  isSubset: function(e) {
    return e = typeof e.includes == "function" ? e : Qt(e), this.every(function(t) {
      return e.includes(t);
    });
  },
  isSuperset: function(e) {
    return e = typeof e.isSubset == "function" ? e : Qt(e), e.isSubset(this);
  },
  keyOf: function(e) {
    return this.findKey(function(t) {
      return ar(t, e);
    });
  },
  keySeq: function() {
    return this.toSeq().map(IX).toIndexedSeq();
  },
  last: function(e) {
    return this.toSeq().reverse().first(e);
  },
  lastKeyOf: function(e) {
    return this.toKeyedSeq().reverse().keyOf(e);
  },
  max: function(e) {
    return Xc(this, e);
  },
  maxBy: function(e, t) {
    return Xc(this, t, e);
  },
  min: function(e) {
    return Xc(
      this,
      e ? LS(e) : BS
    );
  },
  minBy: function(e, t) {
    return Xc(
      this,
      t ? LS(t) : BS,
      e
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(e) {
    return e === 0 ? this : this.slice(Math.max(0, e));
  },
  skipLast: function(e) {
    return e === 0 ? this : this.slice(0, -Math.max(0, e));
  },
  skipWhile: function(e, t) {
    return gt(this, uC(this, e, t, !0));
  },
  skipUntil: function(e, t) {
    return this.skipWhile(km(e), t);
  },
  sortBy: function(e, t) {
    return gt(this, Us(this, t, e));
  },
  take: function(e) {
    return this.slice(0, Math.max(0, e));
  },
  takeLast: function(e) {
    return this.slice(-Math.max(0, e));
  },
  takeWhile: function(e, t) {
    return gt(this, sX(this, e, t));
  },
  takeUntil: function(e, t) {
    return this.takeWhile(km(e), t);
  },
  update: function(e) {
    return e(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  hashCode: function() {
    return this.__hash || (this.__hash = RX(this));
  }
});
var Tn = Qt.prototype;
Tn[qA] = !0;
Tn[Up] = Tn.values;
Tn.toJSON = Tn.toArray;
Tn.__toStringMapper = zu;
Tn.inspect = Tn.toSource = function() {
  return this.toString();
};
Tn.chain = Tn.flatMap;
Tn.contains = Tn.includes;
Ua(jr, {
  flip: function() {
    return gt(this, aC(this));
  },
  mapEntries: function(e, t) {
    var n = this, r = 0;
    return gt(
      this,
      this.toSeq().map(function(i, o) {
        return e.call(t, [o, i], r++, n);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(e, t) {
    var n = this;
    return gt(
      this,
      this.toSeq().flip().map(function(r, i) {
        return e.call(t, r, i, n);
      }).flip()
    );
  }
});
var wc = jr.prototype;
wc[HA] = !0;
wc[Up] = Tn.entries;
wc.toJSON = IC;
wc.__toStringMapper = function(e, t) {
  return zu(t) + ": " + zu(e);
};
Ua(Ka, {
  toKeyedSeq: function() {
    return new Wp(this, !1);
  },
  filter: function(e, t) {
    return gt(this, lC(this, e, t, !1));
  },
  findIndex: function(e, t) {
    var n = this.findEntry(e, t);
    return n ? n[0] : -1;
  },
  indexOf: function(e) {
    var t = this.keyOf(e);
    return t === void 0 ? -1 : t;
  },
  lastIndexOf: function(e) {
    var t = this.lastKeyOf(e);
    return t === void 0 ? -1 : t;
  },
  reverse: function() {
    return gt(this, O0(this, !1));
  },
  slice: function(e, t) {
    return gt(this, k0(this, e, t, !1));
  },
  splice: function(e, t) {
    var n = arguments.length;
    if (t = Math.max(t || 0, 0), n === 0 || n === 2 && !t)
      return this;
    e = mc(e, e < 0 ? this.count() : this.size);
    var r = this.slice(0, e);
    return gt(
      this,
      n === 1 ? r : r.concat(wi(arguments, 2), this.slice(e + t))
    );
  },
  findLastIndex: function(e, t) {
    var n = this.findLastEntry(e, t);
    return n ? n[0] : -1;
  },
  first: function(e) {
    return this.get(0, e);
  },
  flatten: function(e) {
    return gt(this, cC(this, e, !1));
  },
  get: function(e, t) {
    return e = Do(this, e), e < 0 || this.size === 1 / 0 || this.size !== void 0 && e > this.size ? t : this.find(function(n, r) {
      return r === e;
    }, void 0, t);
  },
  has: function(e) {
    return e = Do(this, e), e >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || e < this.size : this.indexOf(e) !== -1);
  },
  interpose: function(e) {
    return gt(this, cX(this, e));
  },
  interleave: function() {
    var e = [this].concat(wi(arguments)), t = ef(this.toSeq(), li.of, e), n = t.flatten(!0);
    return t.size && (n.size = t.size * e.length), gt(this, n);
  },
  keySeq: function() {
    return DX(0, this.size);
  },
  last: function(e) {
    return this.get(-1, e);
  },
  skipWhile: function(e, t) {
    return gt(this, uC(this, e, t, !1));
  },
  zip: function() {
    var e = [this].concat(wi(arguments));
    return gt(this, ef(this, VS, e));
  },
  zipAll: function() {
    var e = [this].concat(wi(arguments));
    return gt(this, ef(this, VS, e, !0));
  },
  zipWith: function(e) {
    var t = wi(arguments);
    return t[0] = this, gt(this, ef(this, e, t));
  }
});
var El = Ka.prototype;
El[WA] = !0;
El[yl] = !0;
Ua(vl, {
  get: function(e, t) {
    return this.has(e) ? e : t;
  },
  includes: function(e) {
    return this.has(e);
  },
  keySeq: function() {
    return this.valueSeq();
  }
});
var Zs = vl.prototype;
Zs.has = Tn.includes;
Zs.contains = Zs.includes;
Zs.keys = Zs.values;
Ua(Ko, wc);
Ua(li, El);
Ua(_l, Zs);
function zS(e, t, n, r, i, o) {
  return ir(e.size), e.__iterate(function(a, s, l) {
    i ? (i = !1, n = a) : n = t.call(r, n, a, s, l);
  }, o), n;
}
function IX(e, t) {
  return t;
}
function MX(e, t) {
  return [t, e];
}
function km(e) {
  return function() {
    return !e.apply(this, arguments);
  };
}
function LS(e) {
  return function() {
    return -e.apply(this, arguments);
  };
}
function VS() {
  return wi(arguments);
}
function BS(e, t) {
  return e < t ? 1 : e > t ? -1 : 0;
}
function RX(e) {
  if (e.size === 1 / 0)
    return 0;
  var t = ti(e), n = It(e), r = t ? 1 : 0, i = e.__iterate(
    n ? t ? function(o, a) {
      r = 31 * r + KS(tr(o), tr(a)) | 0;
    } : function(o, a) {
      r = r + KS(tr(o), tr(a)) | 0;
    } : t ? function(o) {
      r = 31 * r + tr(o) | 0;
    } : function(o) {
      r = r + tr(o) | 0;
    }
  );
  return NX(i, r);
}
function NX(e, t) {
  return t = Ll(t, 3432918353), t = Ll(t << 15 | t >>> -15, 461845907), t = Ll(t << 13 | t >>> -13, 5), t = (t + 3864292196 | 0) ^ e, t = Ll(t ^ t >>> 16, 2246822507), t = Ll(t ^ t >>> 13, 3266489909), t = Hp(t ^ t >>> 16), t;
}
function KS(e, t) {
  return e ^ t + 2654435769 + (e << 6) + (e >> 2) | 0;
}
var Uu = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Hg() : kC(n) ? n : Hg().withMutations(function(r) {
      var i = vl(n);
      ir(i.size), i.forEach(function(o) {
        return r.add(o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(n) {
    return this(jr(n).keySeq());
  }, t.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, t;
})(Gp);
Uu.isOrderedSet = kC;
var qa = Uu.prototype;
qa[yl] = !0;
qa.zip = El.zip;
qa.zipWith = El.zipWith;
qa.zipAll = El.zipAll;
qa.__empty = Hg;
qa.__make = MC;
function MC(e, t) {
  var n = Object.create(qa);
  return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
}
var US;
function Hg() {
  return US || (US = MC(Ql()));
}
function jX(e) {
  if (gl(e))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (Ci(e))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (e === null || typeof e != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var pn = function(e, t) {
  var n;
  jX(e);
  var r = function(o) {
    var a = this;
    if (o instanceof r)
      return o;
    if (!(this instanceof r))
      return new r(o);
    if (!n) {
      n = !0;
      var s = Object.keys(e), l = i._indices = {};
      i._name = t, i._keys = s, i._defaultValues = e;
      for (var u = 0; u < s.length; u++) {
        var c = s[u];
        l[c] = u, i[c] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + Z0(this) + ' with property "' + c + '" since that property name is part of the Record API.'
        ) : FX(i, c);
      }
    }
    return this.__ownerID = void 0, this._values = Zp().withMutations(function(f) {
      f.setSize(a._keys.length), jr(o).forEach(function(d, p) {
        f.set(a._indices[p], d === a._defaultValues[p] ? void 0 : d);
      });
    }), this;
  }, i = r.prototype = Object.create(Et);
  return i.constructor = r, t && (r.displayName = t), r;
};
pn.prototype.toString = function() {
  for (var e = Z0(this) + " { ", t = this._keys, n, r = 0, i = t.length; r !== i; r++)
    n = t[r], e += (r ? ", " : "") + n + ": " + zu(this.get(n));
  return e + " }";
};
pn.prototype.equals = function(e) {
  return this === e || gl(e) && Gs(this).equals(Gs(e));
};
pn.prototype.hashCode = function() {
  return Gs(this).hashCode();
};
pn.prototype.has = function(e) {
  return this._indices.hasOwnProperty(e);
};
pn.prototype.get = function(e, t) {
  if (!this.has(e))
    return t;
  var n = this._indices[e], r = this._values.get(n);
  return r === void 0 ? this._defaultValues[e] : r;
};
pn.prototype.set = function(e, t) {
  if (this.has(e)) {
    var n = this._values.set(
      this._indices[e],
      t === this._defaultValues[e] ? void 0 : t
    );
    if (n !== this._values && !this.__ownerID)
      return W0(this, n);
  }
  return this;
};
pn.prototype.remove = function(e) {
  return this.set(e);
};
pn.prototype.clear = function() {
  var e = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : W0(this, e);
};
pn.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
pn.prototype.toSeq = function() {
  return Gs(this);
};
pn.prototype.toJS = function() {
  return jd(this);
};
pn.prototype.entries = function() {
  return this.__iterator(Ir);
};
pn.prototype.__iterator = function(e, t) {
  return Gs(this).__iterator(e, t);
};
pn.prototype.__iterate = function(e, t) {
  return Gs(this).__iterate(e, t);
};
pn.prototype.__ensureOwner = function(e) {
  if (e === this.__ownerID)
    return this;
  var t = this._values.__ensureOwner(e);
  return e ? W0(this, t, e) : (this.__ownerID = e, this._values = t, this);
};
pn.isRecord = gl;
pn.getDescriptiveName = Z0;
var Et = pn.prototype;
Et[GA] = !0;
Et[hc] = Et.remove;
Et.deleteIn = Et.removeIn = I0;
Et.getIn = CC;
Et.hasIn = Tn.hasIn;
Et.merge = vC;
Et.mergeWith = gC;
Et.mergeIn = F0;
Et.mergeDeep = bC;
Et.mergeDeepWith = _C;
Et.mergeDeepIn = z0;
Et.setIn = C0;
Et.update = M0;
Et.updateIn = R0;
Et.withMutations = yc;
Et.asMutable = bc;
Et.asImmutable = _c;
Et[Up] = Et.entries;
Et.toJSON = Et.toObject = Tn.toObject;
Et.inspect = Et.toSource = function() {
  return this.toString();
};
function W0(e, t, n) {
  var r = Object.create(Object.getPrototypeOf(e));
  return r._values = t, r.__ownerID = n, r;
}
function Z0(e) {
  return e.constructor.displayName || e.constructor.name || "Record";
}
function Gs(e) {
  return S0(e._keys.map(function(t) {
    return [t, e.get(t)];
  }));
}
function FX(e, t) {
  try {
    Object.defineProperty(e, t, {
      get: function() {
        return this.get(t);
      },
      set: function(n) {
        A0(this.__ownerID, "Cannot set on an immutable record."), this.set(t, n);
      }
    });
  } catch {
  }
}
const RC = (e, t) => {
  De(() => (document.addEventListener("keydown", (n) => {
    e[n.key] && e[n.key]();
  }), () => {
    document.removeEventListener("keydown", () => null);
  }), t || []);
}, zX = Mr(
  [
    "dark:bg-neutral-900",
    "dark:text-neutral-200",
    "absolute",
    "transform",
    "shadow-sm",
    "border",
    "border-black",
    "top-1/2",
    "left-1/2",
    "bg-neutral-100",
    "max-h-[75vh]",
    "z-50"
  ],
  {
    variants: {
      size: {
        fit: ["w-auto", "h-auto"],
        sm: ["w-sm", "h-[50vh]"],
        md: ["w-md", "h-[50vh]"],
        lg: ["w-lg", "h-[50vh]"]
      }
    }
  }
), LX = ({
  children: e,
  visible: t,
  onClose: n,
  className: r,
  containerClassName: i = "modal-root",
  variant: o = "lg"
}) => {
  const a = ve(null), { root: s } = VX();
  return RC({
    Escape: n
  }), s ? t ? ga(
    /* @__PURE__ */ R.jsx(Vv, { children: /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ R.jsx(
        Nn.div,
        {
          className: Wn(
            "fixed top-0 left-0 w-screen h-screen opacity-80 bg-neutral-700 z-40 overlay",
            r
          ),
          onClick: () => n(),
          initial: { opacity: 0 },
          animate: { opacity: 0.8 }
        }
      ),
      /* @__PURE__ */ R.jsx(
        Nn.div,
        {
          className: Wn(
            zX({ size: o }),
            i
          ),
          ref: a,
          initial: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "100vh"
          },
          animate: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "50vh"
          },
          exit: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) ",
            top: "100vh"
          },
          children: e
        }
      )
    ] }) }),
    s
  ) : null : (console.error("No root element found"), null);
}, NC = Le({ root: null }), VX = () => G.useContext(NC), Uue = ({
  className: e = "modal-root",
  children: t
}) => {
  const [n, r] = G.useState(null);
  return /* @__PURE__ */ R.jsxs(NC.Provider, { value: { root: n }, children: [
    t,
    /* @__PURE__ */ R.jsx("div", { ref: r, className: e })
  ] });
}, BX = ({
  visible: e,
  onClose: t,
  onCreateFolder: n
}) => {
  const { register: r, handleSubmit: i, reset: o } = VJ({ defaultValues: { name: "" } }), { ref: a, ...s } = r("name"), [l, u] = je(null);
  return De(() => {
    l && l.focus();
  }, [l]), /* @__PURE__ */ R.jsx(
    LX,
    {
      visible: e,
      onClose: () => t(!1),
      variant: "fit",
      children: /* @__PURE__ */ R.jsxs("div", { className: "border-black border w-full h-full bg-white p-4", children: [
        /* @__PURE__ */ R.jsx("h1", { children: "create folder" }),
        /* @__PURE__ */ R.jsxs(
          "form",
          {
            className: "flex flex-col items-center justify-center gap-4",
            onSubmit: i((c) => {
              o(), n(c.name);
            }),
            children: [
              /* @__PURE__ */ R.jsx(
                BJ,
                {
                  ref: (c) => {
                    a(c), u(c);
                  },
                  className: "block",
                  ...s,
                  type: "text",
                  placeholder: "folder name"
                }
              ),
              /* @__PURE__ */ R.jsx($y, { children: "Create" })
            ]
          }
        )
      ] })
    }
  );
}, KX = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216.49,79.52l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.52ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M208,88H152V32Z", opacity: "0.2" }), /* @__PURE__ */ ue.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM152,88V44l44,44Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Z" }))
  ]
]), UX = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM44,56H90.61l10.67,12H44ZM212,196H44V92H212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ue.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM36,56a4,4,0,0,1,4-4H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4Z" }))
  ]
]), qX = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM90.61,56l10.67,12H44V56ZM212,196H44V92H212Zm-72-76v12h12a12,12,0,0,1,0,24H140v12a12,12,0,0,1-24,0V156H104a12,12,0,0,1,0-24h12V120a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ue.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Zm112,96H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2ZM158,144a6,6,0,0,1-6,6H134v18a6,6,0,0,1-12,0V150H104a6,6,0,0,1,0-12h18V120a6,6,0,0,1,12,0v18h18A6,6,0,0,1,158,144Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM40,52H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36V56A4,4,0,0,1,40,52ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4ZM156,144a4,4,0,0,1-4,4H132v20a4,4,0,0,1-8,0V148H104a4,4,0,0,1,0-8h20V120a4,4,0,0,1,8,0v20h20A4,4,0,0,1,156,144Z" }))
  ]
]), HX = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM40,76H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24ZM216,180H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M216,64V192H40V64Z", opacity: "0.2" }), /* @__PURE__ */ ue.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM192,184H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM40,70H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z" }))
  ]
]), WX = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M228,144v64a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V144a12,12,0,0,1,24,0v52H204V144a12,12,0,0,1,24,0ZM96.49,80.49,116,61v83a12,12,0,0,0,24,0V61l19.51,19.52a12,12,0,1,0,17-17l-40-40a12,12,0,0,0-17,0l-40,40a12,12,0,1,0,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement(
      "path",
      {
        d: "M216,48V208H40V48A16,16,0,0,1,56,32H200A16,16,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ue.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM88,80h32v64a8,8,0,0,0,16,0V80h32a8,8,0,0,0,5.66-13.66l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,88,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M222,144v64a6,6,0,0,1-6,6H40a6,6,0,0,1-6-6V144a6,6,0,0,1,12,0v58H210V144a6,6,0,0,1,12,0ZM92.24,76.24,122,46.49V144a6,6,0,0,0,12,0V46.49l29.76,29.75a6,6,0,0,0,8.48-8.48l-40-40a6,6,0,0,0-8.48,0l-40,40a6,6,0,0,0,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ue.createElement(ue.Fragment, null, /* @__PURE__ */ ue.createElement("path", { d: "M220,144v64a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V144a4,4,0,0,1,8,0v60H212V144a4,4,0,0,1,8,0ZM90.83,74.83,124,41.66V144a4,4,0,0,0,8,0V41.66l33.17,33.17a4,4,0,1,0,5.66-5.66l-40-40a4,4,0,0,0-5.66,0l-40,40a4,4,0,0,0,5.66,5.66Z" }))
  ]
]), ZX = Le({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), Sl = ue.forwardRef(
  (e, t) => {
    const {
      alt: n,
      color: r,
      size: i,
      weight: o,
      mirrored: a,
      children: s,
      weights: l,
      ...u
    } = e, {
      color: c = "currentColor",
      size: f,
      weight: d = "regular",
      mirrored: p = !1,
      ...h
    } = ue.useContext(ZX);
    return /* @__PURE__ */ ue.createElement(
      "svg",
      {
        ref: t,
        xmlns: "http://www.w3.org/2000/svg",
        width: i ?? f,
        height: i ?? f,
        fill: r ?? c,
        viewBox: "0 0 256 256",
        transform: a || p ? "scale(-1, 1)" : void 0,
        ...h,
        ...u
      },
      !!n && /* @__PURE__ */ ue.createElement("title", null, n),
      s,
      l.get(o ?? d)
    );
  }
);
Sl.displayName = "IconBase";
const jC = ue.forwardRef((e, t) => /* @__PURE__ */ ue.createElement(Sl, { ref: t, ...e, weights: KX }));
jC.displayName = "FileIcon";
const GX = jC, FC = ue.forwardRef((e, t) => /* @__PURE__ */ ue.createElement(Sl, { ref: t, ...e, weights: UX }));
FC.displayName = "FolderIcon";
const YX = FC, zC = ue.forwardRef((e, t) => /* @__PURE__ */ ue.createElement(Sl, { ref: t, ...e, weights: qX }));
zC.displayName = "FolderPlusIcon";
const QX = zC, LC = ue.forwardRef((e, t) => /* @__PURE__ */ ue.createElement(Sl, { ref: t, ...e, weights: HX }));
LC.displayName = "ListIcon";
const JX = LC, VC = ue.forwardRef((e, t) => /* @__PURE__ */ ue.createElement(Sl, { ref: t, ...e, weights: WX }));
VC.displayName = "UploadSimpleIcon";
const XX = VC;
var Pm, qS;
function eee() {
  if (qS) return Pm;
  qS = 1;
  function e(i) {
    if (typeof i != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(i));
  }
  function t(i, o) {
    for (var a = "", s = 0, l = -1, u = 0, c, f = 0; f <= i.length; ++f) {
      if (f < i.length)
        c = i.charCodeAt(f);
      else {
        if (c === 47)
          break;
        c = 47;
      }
      if (c === 47) {
        if (!(l === f - 1 || u === 1)) if (l !== f - 1 && u === 2) {
          if (a.length < 2 || s !== 2 || a.charCodeAt(a.length - 1) !== 46 || a.charCodeAt(a.length - 2) !== 46) {
            if (a.length > 2) {
              var d = a.lastIndexOf("/");
              if (d !== a.length - 1) {
                d === -1 ? (a = "", s = 0) : (a = a.slice(0, d), s = a.length - 1 - a.lastIndexOf("/")), l = f, u = 0;
                continue;
              }
            } else if (a.length === 2 || a.length === 1) {
              a = "", s = 0, l = f, u = 0;
              continue;
            }
          }
          o && (a.length > 0 ? a += "/.." : a = "..", s = 2);
        } else
          a.length > 0 ? a += "/" + i.slice(l + 1, f) : a = i.slice(l + 1, f), s = f - l - 1;
        l = f, u = 0;
      } else c === 46 && u !== -1 ? ++u : u = -1;
    }
    return a;
  }
  function n(i, o) {
    var a = o.dir || o.root, s = o.base || (o.name || "") + (o.ext || "");
    return a ? a === o.root ? a + s : a + i + s : s;
  }
  var r = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var o = "", a = !1, s, l = arguments.length - 1; l >= -1 && !a; l--) {
        var u;
        l >= 0 ? u = arguments[l] : (s === void 0 && (s = process.cwd()), u = s), e(u), u.length !== 0 && (o = u + "/" + o, a = u.charCodeAt(0) === 47);
      }
      return o = t(o, !a), a ? o.length > 0 ? "/" + o : "/" : o.length > 0 ? o : ".";
    },
    normalize: function(o) {
      if (e(o), o.length === 0) return ".";
      var a = o.charCodeAt(0) === 47, s = o.charCodeAt(o.length - 1) === 47;
      return o = t(o, !a), o.length === 0 && !a && (o = "."), o.length > 0 && s && (o += "/"), a ? "/" + o : o;
    },
    isAbsolute: function(o) {
      return e(o), o.length > 0 && o.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var o, a = 0; a < arguments.length; ++a) {
        var s = arguments[a];
        e(s), s.length > 0 && (o === void 0 ? o = s : o += "/" + s);
      }
      return o === void 0 ? "." : r.normalize(o);
    },
    relative: function(o, a) {
      if (e(o), e(a), o === a || (o = r.resolve(o), a = r.resolve(a), o === a)) return "";
      for (var s = 1; s < o.length && o.charCodeAt(s) === 47; ++s)
        ;
      for (var l = o.length, u = l - s, c = 1; c < a.length && a.charCodeAt(c) === 47; ++c)
        ;
      for (var f = a.length, d = f - c, p = u < d ? u : d, h = -1, m = 0; m <= p; ++m) {
        if (m === p) {
          if (d > p) {
            if (a.charCodeAt(c + m) === 47)
              return a.slice(c + m + 1);
            if (m === 0)
              return a.slice(c + m);
          } else u > p && (o.charCodeAt(s + m) === 47 ? h = m : m === 0 && (h = 0));
          break;
        }
        var v = o.charCodeAt(s + m), g = a.charCodeAt(c + m);
        if (v !== g)
          break;
        v === 47 && (h = m);
      }
      var b = "";
      for (m = s + h + 1; m <= l; ++m)
        (m === l || o.charCodeAt(m) === 47) && (b.length === 0 ? b += ".." : b += "/..");
      return b.length > 0 ? b + a.slice(c + h) : (c += h, a.charCodeAt(c) === 47 && ++c, a.slice(c));
    },
    _makeLong: function(o) {
      return o;
    },
    dirname: function(o) {
      if (e(o), o.length === 0) return ".";
      for (var a = o.charCodeAt(0), s = a === 47, l = -1, u = !0, c = o.length - 1; c >= 1; --c)
        if (a = o.charCodeAt(c), a === 47) {
          if (!u) {
            l = c;
            break;
          }
        } else
          u = !1;
      return l === -1 ? s ? "/" : "." : s && l === 1 ? "//" : o.slice(0, l);
    },
    basename: function(o, a) {
      if (a !== void 0 && typeof a != "string") throw new TypeError('"ext" argument must be a string');
      e(o);
      var s = 0, l = -1, u = !0, c;
      if (a !== void 0 && a.length > 0 && a.length <= o.length) {
        if (a.length === o.length && a === o) return "";
        var f = a.length - 1, d = -1;
        for (c = o.length - 1; c >= 0; --c) {
          var p = o.charCodeAt(c);
          if (p === 47) {
            if (!u) {
              s = c + 1;
              break;
            }
          } else
            d === -1 && (u = !1, d = c + 1), f >= 0 && (p === a.charCodeAt(f) ? --f === -1 && (l = c) : (f = -1, l = d));
        }
        return s === l ? l = d : l === -1 && (l = o.length), o.slice(s, l);
      } else {
        for (c = o.length - 1; c >= 0; --c)
          if (o.charCodeAt(c) === 47) {
            if (!u) {
              s = c + 1;
              break;
            }
          } else l === -1 && (u = !1, l = c + 1);
        return l === -1 ? "" : o.slice(s, l);
      }
    },
    extname: function(o) {
      e(o);
      for (var a = -1, s = 0, l = -1, u = !0, c = 0, f = o.length - 1; f >= 0; --f) {
        var d = o.charCodeAt(f);
        if (d === 47) {
          if (!u) {
            s = f + 1;
            break;
          }
          continue;
        }
        l === -1 && (u = !1, l = f + 1), d === 46 ? a === -1 ? a = f : c !== 1 && (c = 1) : a !== -1 && (c = -1);
      }
      return a === -1 || l === -1 || // We saw a non-dot character immediately before the dot
      c === 0 || // The (right-most) trimmed path component is exactly '..'
      c === 1 && a === l - 1 && a === s + 1 ? "" : o.slice(a, l);
    },
    format: function(o) {
      if (o === null || typeof o != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof o);
      return n("/", o);
    },
    parse: function(o) {
      e(o);
      var a = { root: "", dir: "", base: "", ext: "", name: "" };
      if (o.length === 0) return a;
      var s = o.charCodeAt(0), l = s === 47, u;
      l ? (a.root = "/", u = 1) : u = 0;
      for (var c = -1, f = 0, d = -1, p = !0, h = o.length - 1, m = 0; h >= u; --h) {
        if (s = o.charCodeAt(h), s === 47) {
          if (!p) {
            f = h + 1;
            break;
          }
          continue;
        }
        d === -1 && (p = !1, d = h + 1), s === 46 ? c === -1 ? c = h : m !== 1 && (m = 1) : c !== -1 && (m = -1);
      }
      return c === -1 || d === -1 || // We saw a non-dot character immediately before the dot
      m === 0 || // The (right-most) trimmed path component is exactly '..'
      m === 1 && c === d - 1 && c === f + 1 ? d !== -1 && (f === 0 && l ? a.base = a.name = o.slice(1, d) : a.base = a.name = o.slice(f, d)) : (f === 0 && l ? (a.name = o.slice(1, c), a.base = o.slice(1, d)) : (a.name = o.slice(f, c), a.base = o.slice(f, d)), a.ext = o.slice(c, d)), f > 0 ? a.dir = o.slice(0, f - 1) : l && (a.dir = "/"), a;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return r.posix = r, Pm = r, Pm;
}
var Os = eee();
const BC = Mr([
  "dark:hover:bg-neutral-300",
  "dark:hover:text-neutral-700",
  "hover:bg-neutral-100",
  "p-1",
  "items-center",
  "gap-2",
  "whitespace-nowrap",
  "w-full",
  "flex",
  "text-left",
  "text-sm",
  "disabled:text-neutral-500",
  "disabled:hover:bg-none",
  "cursor-default"
]);
function fa({ className: e = "", ...t }) {
  return /* @__PURE__ */ R.jsx(EV, { ...t, className: BC({}) });
}
const tee = Mr([
  "bg-white",
  "text-black",
  "border-b",
  "border",
  "shadow-md",
  "p-2"
]);
function G0({ children: e, button: t, className: n, isOpen: r, setOpen: i }) {
  return /* @__PURE__ */ R.jsxs(vV, { isOpen: r, onOpenChange: i, children: [
    /* @__PURE__ */ R.jsx(Fb, { children: t || /* @__PURE__ */ R.jsx(
      cr,
      {
        className: "dark:text-neutral-300 text-neutral-700",
        icon: V6
      }
    ) }),
    /* @__PURE__ */ R.jsx($D, { children: /* @__PURE__ */ R.jsx(bV, { className: Wn(tee({}), n), children: e }) })
  ] });
}
const nee = tA(
  ({
    store: e,
    homeDirectory: t,
    searchDisabled: n,
    searchBarExtras: r
  }) => /* @__PURE__ */ R.jsxs("header", { className: "row-start-1 w-full", children: [
    /* @__PURE__ */ R.jsxs("div", { className: "px-2 flex w-full gap-4 border border-black", children: [
      /* @__PURE__ */ R.jsx("div", { className: "flex w-full", children: /* @__PURE__ */ R.jsx(
        "input",
        {
          disabled: n,
          value: e.searchQuery ?? "",
          onChange: (i) => e.setSearchQuery(i.target.value),
          className: "w-full p-1 rounded border-none h-6 my-auto flex-grow bg-white dark:bg-neutral-300 text-neutral-600 focus:outline-none",
          type: "text",
          placeholder: "search..."
        }
      ) }),
      /* @__PURE__ */ R.jsxs("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ R.jsx(
          SV,
          {
            onSelect: (i) => {
              i && e.onDrop(Array.from(i));
            },
            children: /* @__PURE__ */ R.jsx(Fb, { className: BC(), children: /* @__PURE__ */ R.jsx(XX, { size: 18 }) })
          }
        ),
        r && r(e.searchQuery ?? ""),
        /* @__PURE__ */ R.jsx(G0, { children: /* @__PURE__ */ R.jsxs(fa, { onAction: () => {
          e.setCreateFolderModalVisible(!0);
        }, children: [
          /* @__PURE__ */ R.jsx(QX, { size: 18 }),
          " Create Folder"
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ R.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300 hover:fill-neutral-300",
        onClick: () => e.popToRoot(),
        children: [
          t,
          "/"
        ]
      }
    ),
    e.currentPath.map((i, o) => /* @__PURE__ */ R.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300",
        onClick: () => {
          o !== e.currentPath.length - 1 && e.popFolderHistoryToIndex(o);
        },
        children: [
          Os.basename(i),
          "/"
        ]
      },
      `${i}-${o}`
    ))
  ] })
);
function ree({ files: e }) {
  return /* @__PURE__ */ R.jsxs("div", { children: [
    /* @__PURE__ */ R.jsx("p", { className: "m-2", children: "Uploading:" }),
    /* @__PURE__ */ R.jsx("ul", { children: e.map((t) => /* @__PURE__ */ R.jsx("li", { className: "pl-4 list-none", children: t.name }, t.name)) })
  ] });
}
class iee {
  constructor(t) {
    pi(this, "searchQuery", null);
    pi(this, "currentPath", []);
    pi(this, "searchResults", null);
    pi(this, "createFolderModalVisible", !1);
    pi(this, "onSearch");
    pi(this, "onUpload");
    pi(this, "onNavigate");
    pi(this, "searchLoading", !1);
    t ? this.currentPath = t : this.currentPath = [], kZ(this), this.onDrop = this.onDrop.bind(this), this.pushPathPart = this.pushPathPart.bind(this), this.setCreateFolderModalVisible = this.setCreateFolderModalVisible.bind(this), this.setSearchQuery = this.setSearchQuery.bind(this), this.popFolderHistory = this.popFolderHistory.bind(this), this.popFolderHistoryToIndex = this.popFolderHistoryToIndex.bind(this), this.setSearchResults = this.setSearchResults.bind(this);
  }
  setCreateFolderModalVisible(t) {
    this.createFolderModalVisible = t;
  }
  pushPathPart(t) {
    this.currentPath.push(t);
  }
  popFolderHistory() {
    this.currentPath.pop(), this.onNavigate?.(
      this.currentPath
    );
  }
  popToRoot() {
    this.currentPath = [], this.onNavigate?.([]);
  }
  popFolderHistoryToIndex(t) {
    this.currentPath = this.currentPath.slice(0, t + 1), this.onNavigate?.(
      this.currentPath
    );
  }
  async setSearchResults(t) {
    this.searchResults = t;
  }
  async setSearchQuery(t) {
    if (this.searchQuery = t, t) {
      if (!this.onSearch)
        return;
    } else {
      this.searchResults = null, this.searchLoading = !1;
      return;
    }
    this.onSearch(t);
  }
  // get currentFolderPath() {
  //     if (this.currentPath.length === 0) {
  //         return "";
  //     }
  //     // return this.folderHistory.reduce((acc, f) => acc + f, "");
  //     return this.currentPath[this.currentPath.length - 1];
  // }
  async onDrop(t) {
    if (t[0].size / (1024 * 1024 * 1024) > 1)
      throw gr("File cannot be bigger than 1GB"), new Error("File cannot be bigger than 1GB");
    if (this.onUpload)
      try {
        const i = await this.onUpload(t);
        if (!i)
          return;
        const o = gr(/* @__PURE__ */ R.jsx(ree, { files: t }), {
          progress: 0
        });
        i.subscribe({
          onProgress: (a) => {
            gr.update(o, {
              progress: a
            });
          },
          onError: (a) => {
            gr.error("Something went wrong!: " + a.message);
          },
          onComplete: () => {
            gr.dismiss(o);
          }
        });
      } catch (i) {
        gr.error("Something went wrong!: " + i);
      }
  }
}
function eu(e, t) {
  return !!t.find(
    ({ path: n, isFolder: r }) => e.path === n && r === e.isFolder
  );
}
function oee(e, t, n) {
  switch (n) {
    case Cn.ALL:
      return eu(t, e) ? e.filter((r) => r.path !== t.path) : [...e, t];
    case Cn.FILE:
      return t.isFolder ? e : eu(t, e) ? [] : [t];
    case Cn.DIR:
      return t.isFolder ? eu(t, e) ? [] : [t] : e;
    case Cn.FILE_LIST:
      return t.isFolder ? e : eu(t, e) ? e.filter((r) => r.path !== t.path) : [...e, t];
    case Cn.NONE:
    default:
      return e;
  }
}
const Fd = () => /* @__PURE__ */ R.jsx("div", { className: "flex-grow" });
function KC({
  onDelete: e,
  path: t,
  onPreview: n,
  onDownload: r,
  onMoveUpAFolder: i,
  className: o = "",
  isOpen: a,
  setOpen: s
}) {
  return /* @__PURE__ */ R.jsxs(
    G0,
    {
      button: /* @__PURE__ */ R.jsx(JX, { className: o, size: 18, "data-testid": `path-actions-${t.path}` }),
      isOpen: a,
      setOpen: s,
      children: [
        !t.isFolder && r && /* @__PURE__ */ R.jsx(
          fa,
          {
            onAction: async () => {
              r(t);
            },
            children: "Download"
          }
        ),
        i && /* @__PURE__ */ R.jsx(
          fa,
          {
            onAction: async () => {
              const l = Os.dirname(Os.dirname(t.path)), u = Os.basename(t.path), c = `${l}/${u}`;
              i(l === "." ? null : { path: t, parent: l, newPath: c });
            },
            children: "Move Up a Folder"
          }
        ),
        e && /* @__PURE__ */ R.jsx(fa, { onAction: () => e(), children: "Delete" }),
        !t.isFolder && n && /* @__PURE__ */ R.jsx(fa, { onAction: () => n(t), children: "Preview" })
      ]
    }
  );
}
const aee = Mr(
  [
    "relative",
    "flex",
    "gap-2",
    "p-1",
    "select-none",
    "hover:bg-neutral-200",
    "dark:hover:bg-neutral-600",
    "items-center",
    "w-full",
    "group"
  ],
  {
    variants: {
      selected: {
        true: ["text-blue-500", "hover:after:h-0"],
        false: ["text-neutral-800", "dark:text-neutral-200"]
      },
      isOver: {
        true: ["bg-neutral-300", "dark:bg-neutral-600"],
        false: ["bg-transparent"]
      }
    }
  }
), UC = Jt(
  (e, t) => {
    const {
      children: n,
      selected: r,
      showCheckbox: i = !0,
      style: o,
      onCheckboxValueChange: a,
      onClick: s,
      isOver: l,
      path: u
    } = e;
    return /* @__PURE__ */ R.jsxs(
      Nn.div,
      {
        "data-testid": `file-${u}`,
        className: aee({ selected: r, isOver: l }),
        ref: t,
        style: o,
        onClick: (c) => {
          c.stopPropagation, s?.(c);
        },
        layout: !0,
        children: [
          i && /* @__PURE__ */ R.jsx(
            CA,
            {
              onClick: (c) => c.stopPropagation(),
              onChange: (c) => {
                a(c.currentTarget.checked);
              },
              className: "mr-2",
              checked: r
            }
          ),
          n
        ]
      }
    );
  }
), see = ({
  path: e,
  onClick: t,
  selected: n,
  readOnly: r = !1,
  showFullPath: i = !1,
  onDelete: o,
  style: a,
  onPreview: s,
  onDownload: l,
  onMoveUpAFolder: u,
  showCheckbox: c = !0
}) => {
  const [, f] = pA({
    canDrag: !r,
    type: "S3File",
    item: { ...e },
    collect: (m) => ({
      isDragging: m.isDragging()
    })
  }), d = Os.basename(e.path), [p, h] = je(!1);
  return /* @__PURE__ */ R.jsxs(
    UC,
    {
      path: e.path,
      style: { ...a },
      onClick: (m) => {
        m.stopPropagation();
      },
      showCheckbox: c,
      onCheckboxValueChange: () => t(e),
      selected: n,
      ref: f,
      children: [
        /* @__PURE__ */ R.jsx(GX, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ R.jsx("div", { className: "flex flex-col justify-around flex-shrink h-full overflow-hidden", children: /* @__PURE__ */ R.jsx("p", { children: i ? e.path : d }) }),
        /* @__PURE__ */ R.jsx(Fd, {}),
        /* @__PURE__ */ R.jsx(
          KC,
          {
            className: `${p ? "" : "opacity-0 focus:opacity-100"} group-hover:opacity-100 focus:opacity-100`,
            onPreview: s,
            path: e,
            onDelete: o ? () => o?.(e) : void 0,
            onMoveUpAFolder: u,
            onDownload: l,
            isOpen: p,
            setOpen: h
          }
        )
      ]
    }
  );
}, lee = ({
  path: e,
  onClick: t,
  onDblClick: n,
  selected: r,
  onDrop: i,
  readOnly: o = !1,
  style: a,
  onDelete: s,
  showActions: l,
  onPreview: u,
  showFullPath: c,
  showCheckbox: f = !0
}) => {
  const d = UJ(
    () => {
    },
    () => n(e)
  ), [, p] = pA({
    canDrag: !o,
    type: "S3Folder",
    item: { ...e },
    collect: (g) => ({
      isDragging: g.isDragging()
    })
  }), [h] = je(!1), [{ isOver: m }, v] = lQ({
    canDrop: () => !o,
    accept: ["S3Folder", "S3File"],
    drop: (g) => i(g),
    collect: (g) => ({
      isOver: g.isOver()
    })
  });
  return /* @__PURE__ */ R.jsx("div", { ref: v, style: a, children: /* @__PURE__ */ R.jsxs(
    UC,
    {
      path: e.path,
      selected: r,
      isOver: m,
      onClick: (g) => {
        g.stopPropagation(), d();
      },
      ref: p,
      showCheckbox: f,
      onCheckboxValueChange: () => t(e),
      children: [
        /* @__PURE__ */ R.jsx(YX, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ R.jsx("div", { className: "flex flex-col justify-around h-full", children: /* @__PURE__ */ R.jsx("p", { children: c ? e.path : Os.basename(e.path) }) }),
        /* @__PURE__ */ R.jsx(Fd, {}),
        l && u && s && h && /* @__PURE__ */ R.jsx(
          KC,
          {
            onPreview: u,
            path: e,
            onDelete: s ? () => s(e) : void 0
          }
        )
      ]
    }
  ) });
};
function uee(e, t) {
  De(() => {
    for (const n in e)
      e.hasOwnProperty(n) && e[n] && (t[n] = e[n]);
  }, [e, t]);
}
const cee = tA(
  ({
    selectionMode: e = Cn.NONE,
    // files,
    selection: t,
    onSelectionChange: n,
    readOnly: r = !1,
    className: i,
    showActions: o = !0,
    onDownload: a,
    onMoveUpAFolder: s,
    style: l,
    onPreview: u,
    onDelete: c,
    onMove: f,
    onCreateFolder: d,
    loading: p = !1,
    onSearch: h,
    searchDisabled: m = !1,
    onNavigate: v,
    filePathHomeDirectory: g = "~",
    onUpload: b,
    searchBarExtras: E,
    files: x,
    // getFiles,
    path: S
  }) => {
    const $ = rG(() => new iee(S)), { getRootProps: P, getInputProps: y, isDragActive: _ } = AA({
      noClick: !0,
      onDrop: $.onDrop
    }), w = Ne(
      (I) => oee(t, I, e),
      [t, e]
    ), A = Ne(async () => {
      $.searchLoading = !0;
      const I = $.searchQuery;
      if (!h || !I) {
        $.searchLoading = !1;
        return;
      }
      $.setSearchResults([]), setTimeout(async () => {
        if ($.searchQuery === I && I) {
          const B = await h(I);
          if (!B) return;
          $.setSearchResults(B), $.searchLoading = !1;
        }
      }, 500);
    }, [h, $.searchQuery]);
    De(() => {
      $.onSearch = A;
    }, [A]), uee(
      {
        onUpload: b,
        onNavigate: v,
        currentPath: S
      },
      $
    );
    const k = $.searchResults || x || [], N = ve(null);
    return /* @__PURE__ */ R.jsxs(
      "div",
      {
        className: Wn(
          "grid-rows-[2rem 1fr] box-border relative flex flex-col justify-start flex-grow w-full gap-2 overflow-auto text-neutral-800 bg-white",
          i
        ),
        style: l,
        ...P(),
        children: [
          _ && /* @__PURE__ */ R.jsx(
            "div",
            {
              style: { zIndex: 999 },
              className: "w-full h-full absolute top-0 left-0 flex justify-center items-center z-[999] bg-opacity-20 text-orange-2 pointer-events-none bg-white text-4xl",
              children: "Drop files here"
            }
          ),
          /* @__PURE__ */ R.jsx("input", { className: "z-50 bg-purple-500", ...y() }),
          /* @__PURE__ */ R.jsx("div", { children: /* @__PURE__ */ R.jsx(
            nee,
            {
              searchDisabled: m,
              selection: t,
              store: $,
              homeDirectory: g,
              searchBarExtras: E
            }
          ) }),
          e !== Cn.NONE && /* @__PURE__ */ R.jsxs("div", { className: "mr-auto ml-1 flex items-center gap-2 text-neutral-400", children: [
            /* @__PURE__ */ R.jsx(
              CA,
              {
                checked: t.length > 0,
                onChange: () => {
                  k && (t.length === 0 ? n?.([...t, ...k]) : n?.([]));
                }
              }
            ),
            /* @__PURE__ */ R.jsxs("p", { className: "text-xs", children: [
              t.length,
              " file",
              t.length !== 1 && "s",
              " selected"
            ] })
          ] }),
          /* @__PURE__ */ R.jsx(
            "div",
            {
              ref: N,
              className: "relative flex-grow overflow-auto",
              children: /* @__PURE__ */ R.jsx(DY, { backend: xQ, children: /* @__PURE__ */ R.jsxs("div", { className: "row-start-2 row-span-1 flex-grow relative", children: [
                p ? /* @__PURE__ */ R.jsx("p", { className: "py-2 italic text-neutral-600", children: "Loading..." }) : null,
                k?.length === 0 && !$.searchLoading && !p && /* @__PURE__ */ R.jsx("p", { className: "py-2 italic text-neutral-600", children: "No files" }),
                $.searchLoading && /* @__PURE__ */ R.jsx("p", { className: "py-2 italic text-neutral-600", children: "Searching..." }),
                k && k.length > 0 && k.map((I) => {
                  const B = {
                    key: fee(I),
                    showActions: o,
                    readOnly: r,
                    onDelete: c ? () => {
                      c([I]), n?.([]);
                    } : void 0,
                    onClick: (q) => {
                      const ee = w(q);
                      n?.(ee);
                    },
                    showFullPath: !!$.searchQuery,
                    // show full path if searching
                    path: I,
                    selected: eu(I, t),
                    onPreview: u
                  };
                  return I.isFolder ? /* @__PURE__ */ R.jsx(
                    lee,
                    {
                      ...B,
                      showCheckbox: e !== Cn.NONE && e !== Cn.FILE && e !== Cn.FILE_LIST,
                      onDblClick: (q) => {
                        const ee = q.path.split("/").filter(Boolean).pop();
                        ee && ($.pushPathPart(ee), v?.($.currentPath));
                      },
                      onDrop: (q) => f?.(q, I)
                    }
                  ) : /* @__PURE__ */ R.jsx(
                    see,
                    {
                      ...B,
                      showCheckbox: e !== Cn.NONE && e !== Cn.DIR && e !== Cn.DIR_LIST,
                      onMoveUpAFolder: s,
                      onDownload: a
                    }
                  );
                })
              ] }) })
            }
          ),
          /* @__PURE__ */ R.jsx(
            BX,
            {
              visible: $.createFolderModalVisible,
              onClose: () => $.setCreateFolderModalVisible(!1),
              onCreateFolder: async (I) => {
                d?.(I, $.currentPath), $.setCreateFolderModalVisible(!1);
              }
            }
          )
        ]
      }
    );
  }
), fee = (e) => `${e.isFolder ? "folder" : "file"}-${e.path}`;
var dee = Object.defineProperty, pee = (e, t, n) => t in e ? dee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, hee = (e, t, n) => pee(e, t + "", n), Wg = function(e, t) {
  return Wg = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, Wg(e, t);
};
function ui(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Wg(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var W = function() {
  return W = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, W.apply(this, arguments);
};
function Ki(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function lo(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (f) {
        a(f);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (f) {
        a(f);
      }
    }
    function u(c) {
      c.done ? o(c.value) : i(c.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function uo(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = s(0), a.throw = s(1), a.return = s(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function _n(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Dm = "Invariant Violation", HS = Object.setPrototypeOf, mee = HS === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : HS, qC = (
  /** @class */
  (function(e) {
    ui(t, e);
    function t(n) {
      n === void 0 && (n = Dm);
      var r = e.call(this, typeof n == "number" ? Dm + ": " + n + " (see https://github.com/apollographql/invariant-packages)" : n) || this;
      return r.framesToPop = 1, r.name = Dm, mee(r, t.prototype), r;
    }
    return t;
  })(Error)
);
function ra(e, t) {
  if (!e)
    throw new qC(t);
}
var HC = ["debug", "log", "warn", "error", "silent"], vee = HC.indexOf("log");
function rf(e) {
  return function() {
    if (HC.indexOf(e) >= vee) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = rf("debug"), e.log = rf("log"), e.warn = rf("warn"), e.error = rf("error");
})(ra || (ra = {}));
var Y0 = "3.14.1";
function Wr(e) {
  try {
    return e();
  } catch {
  }
}
const zd = Wr(function() {
  return globalThis;
}) || Wr(function() {
  return window;
}) || Wr(function() {
  return self;
}) || Wr(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Wr(function() {
  return Wr.constructor("return this")();
});
var WS = /* @__PURE__ */ new Map();
function Zg(e) {
  var t = WS.get(e) || 1;
  return WS.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function WC(e, t) {
  t === void 0 && (t = 0);
  var n = Zg("stringifyForDisplay");
  return JSON.stringify(e, function(r, i) {
    return i === void 0 ? n : i;
  }, t).split(JSON.stringify(n)).join("<undefined>");
}
function of(e) {
  return function(t) {
    for (var n = [], r = 1; r < arguments.length; r++)
      n[r - 1] = arguments[r];
    if (typeof t == "number") {
      var i = t;
      t = Q0(i), t || (t = J0(i, n), n = []);
    }
    e.apply(void 0, [t].concat(n));
  };
}
var Se = Object.assign(function(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  e || ra(e, Q0(t, n) || J0(t, n));
}, {
  debug: of(ra.debug),
  log: of(ra.log),
  warn: of(ra.warn),
  error: of(ra.error)
});
function Ln(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return new qC(Q0(e, t) || J0(e, t));
}
var ZS = Symbol.for("ApolloErrorMessageHandler_" + Y0);
function ZC(e) {
  if (typeof e == "string")
    return e;
  try {
    return WC(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function Q0(e, t) {
  if (t === void 0 && (t = []), !!e)
    return zd[ZS] && zd[ZS](e, t.map(ZC));
}
function J0(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: Y0,
      message: e,
      args: t.map(ZC)
    })));
}
var Bt = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function gee(e, t) {
  throw new Error("Unexpected invariant triggered.");
}
var Gg = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function GC(e) {
  var t = e.prototype.toJSON;
  typeof t == "function" || gee(), e.prototype.inspect = t, Gg && (e.prototype[Gg] = t);
}
var yee = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    this.start = n.start, this.end = r.end, this.startToken = n, this.endToken = r, this.source = i;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
})();
GC(yee);
var bee = /* @__PURE__ */ (function() {
  function e(n, r, i, o, a, s, l) {
    this.kind = n, this.start = r, this.end = i, this.line = o, this.column = a, this.value = l, this.prev = s, this.next = null;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
})();
GC(bee);
function GS(e) {
  return e != null && typeof e.kind == "string";
}
function Mf(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Mf = function(t) {
    return typeof t;
  } : Mf = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mf(e);
}
var _ee = 10, YC = 2;
function wee(e) {
  return Yp(e, []);
}
function Yp(e, t) {
  switch (Mf(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : xee(e, t);
    default:
      return String(e);
  }
}
function xee(e, t) {
  if (t.indexOf(e) !== -1)
    return "[Circular]";
  var n = [].concat(t, [e]), r = $ee(e);
  if (r !== void 0) {
    var i = r.call(e);
    if (i !== e)
      return typeof i == "string" ? i : Yp(i, n);
  } else if (Array.isArray(e))
    return See(e, n);
  return Eee(e, n);
}
function Eee(e, t) {
  var n = Object.keys(e);
  if (n.length === 0)
    return "{}";
  if (t.length > YC)
    return "[" + Tee(e) + "]";
  var r = n.map(function(i) {
    var o = Yp(e[i], t);
    return i + ": " + o;
  });
  return "{ " + r.join(", ") + " }";
}
function See(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > YC)
    return "[Array]";
  for (var n = Math.min(_ee, e.length), r = e.length - n, i = [], o = 0; o < n; ++o)
    i.push(Yp(e[o], t));
  return r === 1 ? i.push("... 1 more item") : r > 1 && i.push("... ".concat(r, " more items")), "[" + i.join(", ") + "]";
}
function $ee(e) {
  var t = e[String(Gg)];
  if (typeof t == "function")
    return t;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function Tee(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var n = e.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return t;
}
function Oee(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = e.indexOf(`
`) === -1, i = e[0] === " " || e[0] === "	", o = e[e.length - 1] === '"', a = e[e.length - 1] === "\\", s = !r || o || a || n, l = "";
  return s && !(r && i) && (l += `
` + t), l += t ? e.replace(/\n/g, `
` + t) : e, s && (l += `
`), '"""' + l.replace(/"""/g, '\\"""') + '"""';
}
var kee = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Qp = Object.freeze({});
function ii(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : kee, r = void 0, i = Array.isArray(e), o = [e], a = -1, s = [], l = void 0, u = void 0, c = void 0, f = [], d = [], p = e;
  do {
    a++;
    var h = a === o.length, m = h && s.length !== 0;
    if (h) {
      if (u = d.length === 0 ? void 0 : f[f.length - 1], l = c, c = d.pop(), m) {
        if (i)
          l = l.slice();
        else {
          for (var v = {}, g = 0, b = Object.keys(l); g < b.length; g++) {
            var E = b[g];
            v[E] = l[E];
          }
          l = v;
        }
        for (var x = 0, S = 0; S < s.length; S++) {
          var $ = s[S][0], P = s[S][1];
          i && ($ -= x), i && P === null ? (l.splice($, 1), x++) : l[$] = P;
        }
      }
      a = r.index, o = r.keys, s = r.edits, i = r.inArray, r = r.prev;
    } else {
      if (u = c ? i ? a : o[a] : void 0, l = c ? c[u] : p, l == null)
        continue;
      c && f.push(u);
    }
    var y = void 0;
    if (!Array.isArray(l)) {
      if (!GS(l))
        throw new Error("Invalid AST Node: ".concat(wee(l), "."));
      var _ = Pee(t, l.kind, h);
      if (_) {
        if (y = _.call(t, l, u, c, f, d), y === Qp)
          break;
        if (y === !1) {
          if (!h) {
            f.pop();
            continue;
          }
        } else if (y !== void 0 && (s.push([u, y]), !h))
          if (GS(y))
            l = y;
          else {
            f.pop();
            continue;
          }
      }
    }
    if (y === void 0 && m && s.push([u, l]), h)
      f.pop();
    else {
      var w;
      r = {
        inArray: i,
        index: a,
        keys: o,
        edits: s,
        prev: r
      }, i = Array.isArray(l), o = i ? l : (w = n[l.kind]) !== null && w !== void 0 ? w : [], a = -1, s = [], c && d.push(c), c = l;
    }
  } while (r !== void 0);
  return s.length !== 0 && (p = s[s.length - 1][1]), p;
}
function Pee(e, t, n) {
  var r = e[t];
  if (r) {
    if (!n && typeof r == "function")
      return r;
    var i = n ? r.leave : r.enter;
    if (typeof i == "function")
      return i;
  } else {
    var o = n ? e.leave : e.enter;
    if (o) {
      if (typeof o == "function")
        return o;
      var a = o[t];
      if (typeof a == "function")
        return a;
    }
  }
}
function Dee(e) {
  return ii(e, {
    leave: Cee
  });
}
var Aee = 80, Cee = {
  Name: function(e) {
    return e.value;
  },
  Variable: function(e) {
    return "$" + e.name;
  },
  // Document
  Document: function(e) {
    return Ie(e.definitions, `

`) + `
`;
  },
  OperationDefinition: function(e) {
    var t = e.operation, n = e.name, r = zt("(", Ie(e.variableDefinitions, ", "), ")"), i = Ie(e.directives, " "), o = e.selectionSet;
    return !n && !i && !r && t === "query" ? o : Ie([t, Ie([n, r]), i, o], " ");
  },
  VariableDefinition: function(e) {
    var t = e.variable, n = e.type, r = e.defaultValue, i = e.directives;
    return t + ": " + n + zt(" = ", r) + zt(" ", Ie(i, " "));
  },
  SelectionSet: function(e) {
    var t = e.selections;
    return Kr(t);
  },
  Field: function(e) {
    var t = e.alias, n = e.name, r = e.arguments, i = e.directives, o = e.selectionSet, a = zt("", t, ": ") + n, s = a + zt("(", Ie(r, ", "), ")");
    return s.length > Aee && (s = a + zt(`(
`, Rf(Ie(r, `
`)), `
)`)), Ie([s, Ie(i, " "), o], " ");
  },
  Argument: function(e) {
    var t = e.name, n = e.value;
    return t + ": " + n;
  },
  // Fragments
  FragmentSpread: function(e) {
    var t = e.name, n = e.directives;
    return "..." + t + zt(" ", Ie(n, " "));
  },
  InlineFragment: function(e) {
    var t = e.typeCondition, n = e.directives, r = e.selectionSet;
    return Ie(["...", zt("on ", t), Ie(n, " "), r], " ");
  },
  FragmentDefinition: function(e) {
    var t = e.name, n = e.typeCondition, r = e.variableDefinitions, i = e.directives, o = e.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(t).concat(zt("(", Ie(r, ", "), ")"), " ") + "on ".concat(n, " ").concat(zt("", Ie(i, " "), " ")) + o
    );
  },
  // Value
  IntValue: function(e) {
    var t = e.value;
    return t;
  },
  FloatValue: function(e) {
    var t = e.value;
    return t;
  },
  StringValue: function(e, t) {
    var n = e.value, r = e.block;
    return r ? Oee(n, t === "description" ? "" : "  ") : JSON.stringify(n);
  },
  BooleanValue: function(e) {
    var t = e.value;
    return t ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(e) {
    var t = e.value;
    return t;
  },
  ListValue: function(e) {
    var t = e.values;
    return "[" + Ie(t, ", ") + "]";
  },
  ObjectValue: function(e) {
    var t = e.fields;
    return "{" + Ie(t, ", ") + "}";
  },
  ObjectField: function(e) {
    var t = e.name, n = e.value;
    return t + ": " + n;
  },
  // Directive
  Directive: function(e) {
    var t = e.name, n = e.arguments;
    return "@" + t + zt("(", Ie(n, ", "), ")");
  },
  // Type
  NamedType: function(e) {
    var t = e.name;
    return t;
  },
  ListType: function(e) {
    var t = e.type;
    return "[" + t + "]";
  },
  NonNullType: function(e) {
    var t = e.type;
    return t + "!";
  },
  // Type System Definitions
  SchemaDefinition: Br(function(e) {
    var t = e.directives, n = e.operationTypes;
    return Ie(["schema", Ie(t, " "), Kr(n)], " ");
  }),
  OperationTypeDefinition: function(e) {
    var t = e.operation, n = e.type;
    return t + ": " + n;
  },
  ScalarTypeDefinition: Br(function(e) {
    var t = e.name, n = e.directives;
    return Ie(["scalar", t, Ie(n, " ")], " ");
  }),
  ObjectTypeDefinition: Br(function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Ie(["type", t, zt("implements ", Ie(n, " & ")), Ie(r, " "), Kr(i)], " ");
  }),
  FieldDefinition: Br(function(e) {
    var t = e.name, n = e.arguments, r = e.type, i = e.directives;
    return t + (YS(n) ? zt(`(
`, Rf(Ie(n, `
`)), `
)`) : zt("(", Ie(n, ", "), ")")) + ": " + r + zt(" ", Ie(i, " "));
  }),
  InputValueDefinition: Br(function(e) {
    var t = e.name, n = e.type, r = e.defaultValue, i = e.directives;
    return Ie([t + ": " + n, zt("= ", r), Ie(i, " ")], " ");
  }),
  InterfaceTypeDefinition: Br(function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Ie(["interface", t, zt("implements ", Ie(n, " & ")), Ie(r, " "), Kr(i)], " ");
  }),
  UnionTypeDefinition: Br(function(e) {
    var t = e.name, n = e.directives, r = e.types;
    return Ie(["union", t, Ie(n, " "), r && r.length !== 0 ? "= " + Ie(r, " | ") : ""], " ");
  }),
  EnumTypeDefinition: Br(function(e) {
    var t = e.name, n = e.directives, r = e.values;
    return Ie(["enum", t, Ie(n, " "), Kr(r)], " ");
  }),
  EnumValueDefinition: Br(function(e) {
    var t = e.name, n = e.directives;
    return Ie([t, Ie(n, " ")], " ");
  }),
  InputObjectTypeDefinition: Br(function(e) {
    var t = e.name, n = e.directives, r = e.fields;
    return Ie(["input", t, Ie(n, " "), Kr(r)], " ");
  }),
  DirectiveDefinition: Br(function(e) {
    var t = e.name, n = e.arguments, r = e.repeatable, i = e.locations;
    return "directive @" + t + (YS(n) ? zt(`(
`, Rf(Ie(n, `
`)), `
)`) : zt("(", Ie(n, ", "), ")")) + (r ? " repeatable" : "") + " on " + Ie(i, " | ");
  }),
  SchemaExtension: function(e) {
    var t = e.directives, n = e.operationTypes;
    return Ie(["extend schema", Ie(t, " "), Kr(n)], " ");
  },
  ScalarTypeExtension: function(e) {
    var t = e.name, n = e.directives;
    return Ie(["extend scalar", t, Ie(n, " ")], " ");
  },
  ObjectTypeExtension: function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Ie(["extend type", t, zt("implements ", Ie(n, " & ")), Ie(r, " "), Kr(i)], " ");
  },
  InterfaceTypeExtension: function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Ie(["extend interface", t, zt("implements ", Ie(n, " & ")), Ie(r, " "), Kr(i)], " ");
  },
  UnionTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.types;
    return Ie(["extend union", t, Ie(n, " "), r && r.length !== 0 ? "= " + Ie(r, " | ") : ""], " ");
  },
  EnumTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.values;
    return Ie(["extend enum", t, Ie(n, " "), Kr(r)], " ");
  },
  InputObjectTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.fields;
    return Ie(["extend input", t, Ie(n, " "), Kr(r)], " ");
  }
};
function Br(e) {
  return function(t) {
    return Ie([t.description, e(t)], `
`);
  };
}
function Ie(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (t = e?.filter(function(r) {
    return r;
  }).join(n)) !== null && t !== void 0 ? t : "";
}
function Kr(e) {
  return zt(`{
`, Rf(Ie(e, `
`)), `
}`);
}
function zt(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return t != null && t !== "" ? e + t + n : "";
}
function Rf(e) {
  return zt("  ", e.replace(/\n/g, `
  `));
}
function Iee(e) {
  return e.indexOf(`
`) !== -1;
}
function YS(e) {
  return e != null && e.some(Iee);
}
function QS(e) {
  return e.kind === Bt.FIELD || e.kind === Bt.FRAGMENT_SPREAD || e.kind === Bt.INLINE_FRAGMENT;
}
function xc(e, t) {
  var n = e.directives;
  return !n || !n.length ? !0 : Nee(n).every(function(r) {
    var i = r.directive, o = r.ifArgument, a = !1;
    return o.value.kind === "Variable" ? (a = t && t[o.value.name.value], Se(a !== void 0, 105, i.name.value)) : a = o.value.value, i.name.value === "skip" ? !a : a;
  });
}
function qu(e, t, n) {
  var r = new Set(e), i = r.size;
  return ii(t, {
    Directive: function(o) {
      if (r.delete(o.name.value) && (!n || !r.size))
        return Qp;
    }
  }), n ? !r.size : r.size < i;
}
function Mee(e) {
  return e && qu(["client", "export"], e, !0);
}
function Ree(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function Nee(e) {
  var t = [];
  return e && e.length && e.forEach(function(n) {
    if (Ree(n)) {
      var r = n.arguments, i = n.name.value;
      Se(r && r.length === 1, 106, i);
      var o = r[0];
      Se(o.name && o.name.value === "if", 107, i);
      var a = o.value;
      Se(a && (a.kind === "Variable" || a.kind === "BooleanValue"), 108, i), t.push({ directive: n, ifArgument: o });
    }
  }), t;
}
function jee(e) {
  var t, n, r = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(o) {
    var a = o.name;
    return a.value === "unmask";
  });
  if (!r)
    return "mask";
  var i = (n = r.arguments) === null || n === void 0 ? void 0 : n.find(function(o) {
    var a = o.name;
    return a.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === Bt.VARIABLE ? globalThis.__DEV__ !== !1 && Se.warn(109) : i.value.kind !== Bt.STRING ? globalThis.__DEV__ !== !1 && Se.warn(110) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && Se.warn(111, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const Fee = () => /* @__PURE__ */ Object.create(null), { forEach: zee, slice: JS } = Array.prototype, { hasOwnProperty: Lee } = Object.prototype;
class to {
  constructor(t = !0, n = Fee) {
    this.weakness = t, this.makeData = n;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let n = this;
    return zee.call(t, (r) => n = n.getChildTrie(r)), Lee.call(n, "data") ? n.data : n.data = this.makeData(JS.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let n = this;
    for (let r = 0, i = t.length; n && r < i; ++r) {
      const o = n.mapFor(t[r], !1);
      n = o && o.get(t[r]);
    }
    return n && n.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let n;
    if (t.length) {
      const r = t[0], i = this.mapFor(r, !1), o = i && i.get(r);
      o && (n = o.removeArray(JS.call(t, 1)), !o.data && !o.weak && !(o.strong && o.strong.size) && i.delete(r));
    } else
      n = this.data, delete this.data;
    return n;
  }
  getChildTrie(t) {
    const n = this.mapFor(t, !0);
    let r = n.get(t);
    return r || n.set(t, r = new to(this.weakness, this.makeData)), r;
  }
  mapFor(t, n) {
    return this.weakness && Vee(t) ? this.weak || (n ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (n ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function Vee(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var Bee = Wr(function() {
  return navigator.product;
}) == "ReactNative", Ha = typeof WeakMap == "function" && !(Bee && !global.HermesInternal), X0 = typeof WeakSet == "function", QC = typeof Symbol == "function" && typeof Symbol.for == "function", Jp = QC && Symbol.asyncIterator;
Wr(function() {
  return window.document.createElement;
});
Wr(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function Mt(e) {
  return e !== null && typeof e == "object";
}
function Kee(e, t) {
  var n = t, r = [];
  e.definitions.forEach(function(o) {
    if (o.kind === "OperationDefinition")
      throw Ln(
        112,
        o.operation,
        o.name ? " named '".concat(o.name.value, "'") : ""
      );
    o.kind === "FragmentDefinition" && r.push(o);
  }), typeof n > "u" && (Se(r.length === 1, 113, r.length), n = r[0].name.value);
  var i = W(W({}, e), { definitions: _n([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: n
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return i;
}
function $l(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(n) {
    t[n.name.value] = n;
  }), t;
}
function Xp(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var n = e.name.value;
      if (typeof t == "function")
        return t(n);
      var r = t && t[n];
      return Se(r, 114, n), r || null;
    }
    default:
      return null;
  }
}
function Uee(e) {
  var t = !0;
  return ii(e, {
    FragmentSpread: function(n) {
      if (t = !!n.directives && n.directives.some(function(r) {
        return r.name.value === "unmask";
      }), !t)
        return Qp;
    }
  }), t;
}
function qee() {
}
class Yg {
  constructor(t = 1 / 0, n = qee) {
    this.max = t, this.dispose = n, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const n = this.getNode(t);
    return n && n.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const n = this.map.get(t);
    if (n && n !== this.newest) {
      const { older: r, newer: i } = n;
      i && (i.older = r), r && (r.newer = i), n.older = this.newest, n.older.newer = n, n.newer = null, this.newest = n, n === this.oldest && (this.oldest = i);
    }
    return n;
  }
  set(t, n) {
    let r = this.getNode(t);
    return r ? r.value = n : (r = {
      key: t,
      value: n,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.map.set(t, r), r.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const n = this.map.get(t);
    return n ? (n === this.newest && (this.newest = n.older), n === this.oldest && (this.oldest = n.newer), n.newer && (n.newer.older = n.older), n.older && (n.older.newer = n.newer), this.map.delete(t), this.dispose(n.value, t), !0) : !1;
  }
}
function Qg() {
}
const Hee = Qg, Wee = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, Zee = typeof WeakMap < "u" ? WeakMap : Map, Gee = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: Qg,
    unregister: Qg
  };
}, Yee = 10024;
class Ld {
  constructor(t = 1 / 0, n = Hee) {
    this.max = t, this.dispose = n, this.map = new Zee(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const r = this.unfinalizedNodes.values();
      for (let i = 0; i < Yee; i++) {
        const o = r.next().value;
        if (!o)
          break;
        this.unfinalizedNodes.delete(o);
        const a = o.key;
        delete o.key, o.keyRef = new Wee(a), this.registry.register(a, o, o);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new Gee(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const n = this.getNode(t);
    return n && n.value;
  }
  getNode(t) {
    const n = this.map.get(t);
    if (n && n !== this.newest) {
      const { older: r, newer: i } = n;
      i && (i.older = r), r && (r.newer = i), n.older = this.newest, n.older.newer = n, n.newer = null, this.newest = n, n === this.oldest && (this.oldest = i);
    }
    return n;
  }
  set(t, n) {
    let r = this.getNode(t);
    return r ? r.value = n : (r = {
      key: t,
      value: n,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.scheduleFinalization(r), this.map.set(t, r), this.size++, r.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const n = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, n), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), n && this.map.delete(n);
  }
  delete(t) {
    const n = this.map.get(t);
    return n ? (this.deleteNode(n), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var Am = /* @__PURE__ */ new WeakSet();
function JC(e) {
  e.size <= (e.max || -1) || Am.has(e) || (Am.add(e), setTimeout(function() {
    e.clean(), Am.delete(e);
  }, 100));
}
var XC = function(e, t) {
  var n = new Ld(e, t);
  return n.set = function(r, i) {
    var o = Ld.prototype.set.call(this, r, i);
    return JC(this), o;
  }, n;
}, Qee = function(e, t) {
  var n = new Yg(e, t);
  return n.set = function(r, i) {
    var o = Yg.prototype.set.call(this, r, i);
    return JC(this), o;
  }, n;
}, Jee = Symbol.for("apollo.cacheSize"), Qi = W({}, zd[Jee]), Xo = {};
function eI(e, t) {
  Xo[e] = t;
}
var Xee = globalThis.__DEV__ !== !1 ? rte : void 0, ete = globalThis.__DEV__ !== !1 ? ite : void 0, tte = globalThis.__DEV__ !== !1 ? tI : void 0;
function nte() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var n = t[0], r = t[1];
    return [
      n,
      Qi[n] || r
    ];
  }));
}
function rte() {
  var e, t, n, r, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: nte(),
    sizes: W({ print: (e = Xo.print) === null || e === void 0 ? void 0 : e.call(Xo), parser: (t = Xo.parser) === null || t === void 0 ? void 0 : t.call(Xo), canonicalStringify: (n = Xo.canonicalStringify) === null || n === void 0 ? void 0 : n.call(Xo), links: Xg(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: rI(this.queryManager.documentTransform)
    } }, (i = (r = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(r))
  };
}
function tI() {
  return {
    cache: {
      fragmentQueryDocuments: co(this.getFragmentDoc)
    }
  };
}
function ite() {
  var e = this.config.fragments;
  return W(W({}, tI.apply(this)), { addTypenameDocumentTransform: rI(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: co(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: co(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: co(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: co(e?.findFragmentSpreads),
    lookup: co(e?.lookup),
    transform: co(e?.transform)
  } });
}
function ote(e) {
  return !!e && "dirtyKey" in e;
}
function co(e) {
  return ote(e) ? e.size : void 0;
}
function nI(e) {
  return e != null;
}
function rI(e) {
  return Jg(e).map(function(t) {
    return { cache: t };
  });
}
function Jg(e) {
  return e ? _n(_n([
    co(e?.performWork)
  ], Jg(e?.left), !0), Jg(e?.right), !0).filter(nI) : [];
}
function Xg(e) {
  var t;
  return e ? _n(_n([
    (t = e?.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], Xg(e?.left), !0), Xg(e?.right), !0).filter(nI) : [];
}
var wo = Object.assign(function(e) {
  return JSON.stringify(e, ate);
}, {
  reset: function() {
    ys = new Qee(
      Qi.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && eI("canonicalStringify", function() {
  return ys.size;
});
var ys;
wo.reset();
function ate(e, t) {
  if (t && typeof t == "object") {
    var n = Object.getPrototypeOf(t);
    if (n === Object.prototype || n === null) {
      var r = Object.keys(t);
      if (r.every(ste))
        return t;
      var i = JSON.stringify(r), o = ys.get(i);
      if (!o) {
        r.sort();
        var a = JSON.stringify(r);
        o = ys.get(a) || r, ys.set(i, o), ys.set(a, o);
      }
      var s = Object.create(n);
      return o.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function ste(e, t, n) {
  return t === 0 || n[t - 1] <= e;
}
function ks(e) {
  return { __ref: String(e) };
}
function dt(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function lte(e) {
  return Mt(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function ute(e) {
  return e.kind === "StringValue";
}
function cte(e) {
  return e.kind === "BooleanValue";
}
function fte(e) {
  return e.kind === "IntValue";
}
function dte(e) {
  return e.kind === "FloatValue";
}
function pte(e) {
  return e.kind === "Variable";
}
function hte(e) {
  return e.kind === "ObjectValue";
}
function mte(e) {
  return e.kind === "ListValue";
}
function vte(e) {
  return e.kind === "EnumValue";
}
function gte(e) {
  return e.kind === "NullValue";
}
function Ys(e, t, n, r) {
  if (fte(n) || dte(n))
    e[t.value] = Number(n.value);
  else if (cte(n) || ute(n))
    e[t.value] = n.value;
  else if (hte(n)) {
    var i = {};
    n.fields.map(function(a) {
      return Ys(i, a.name, a.value, r);
    }), e[t.value] = i;
  } else if (pte(n)) {
    var o = (r || {})[n.name.value];
    e[t.value] = o;
  } else if (mte(n))
    e[t.value] = n.values.map(function(a) {
      var s = {};
      return Ys(s, t, a, r), s[t.value];
    });
  else if (vte(n))
    e[t.value] = n.value;
  else if (gte(n))
    e[t.value] = null;
  else
    throw Ln(123, t.value, n.kind);
}
function yte(e, t) {
  var n = null;
  e.directives && (n = {}, e.directives.forEach(function(i) {
    n[i.name.value] = {}, i.arguments && i.arguments.forEach(function(o) {
      var a = o.name, s = o.value;
      return Ys(n[i.name.value], a, s, t);
    });
  }));
  var r = null;
  return e.arguments && e.arguments.length && (r = {}, e.arguments.forEach(function(i) {
    var o = i.name, a = i.value;
    return Ys(r, o, a, t);
  })), iI(e.name.value, r, n);
}
var bte = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], Vl = wo, iI = Object.assign(function(e, t, n) {
  if (t && n && n.connection && n.connection.key)
    if (n.connection.filter && n.connection.filter.length > 0) {
      var r = n.connection.filter ? n.connection.filter : [];
      r.sort();
      var i = {};
      return r.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(n.connection.key, "(").concat(Vl(i), ")");
    } else
      return n.connection.key;
  var o = e;
  if (t) {
    var a = Vl(t);
    o += "(".concat(a, ")");
  }
  return n && Object.keys(n).forEach(function(s) {
    bte.indexOf(s) === -1 && (n[s] && Object.keys(n[s]).length ? o += "@".concat(s, "(").concat(Vl(n[s]), ")") : o += "@".concat(s));
  }), o;
}, {
  setStringify: function(e) {
    var t = Vl;
    return Vl = e, t;
  }
});
function eh(e, t) {
  if (e.arguments && e.arguments.length) {
    var n = {};
    return e.arguments.forEach(function(r) {
      var i = r.name, o = r.value;
      return Ys(n, i, o, t);
    }), n;
  }
  return null;
}
function Ji(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function ey(e, t, n) {
  for (var r, i = 0, o = t.selections; i < o.length; i++) {
    var a = o[i];
    if (Co(a)) {
      if (a.name.value === "__typename")
        return e[Ji(a)];
    } else r ? r.push(a) : r = [a];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (r)
    for (var s = 0, l = r; s < l.length; s++) {
      var a = l[s], u = ey(e, Xp(a, n).selectionSet, n);
      if (typeof u == "string")
        return u;
    }
}
function Co(e) {
  return e.kind === "Field";
}
function _te(e) {
  return e.kind === "InlineFragment";
}
function Tl(e) {
  Se(e && e.kind === "Document", 115);
  var t = e.definitions.filter(function(n) {
    return n.kind !== "FragmentDefinition";
  }).map(function(n) {
    if (n.kind !== "OperationDefinition")
      throw Ln(116, n.kind);
    return n;
  });
  return Se(t.length <= 1, 117, t.length), e;
}
function Da(e) {
  return Tl(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function tu(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function Ol(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function oI(e) {
  var t = Da(e);
  return Se(t && t.operation === "query", 118), t;
}
function aI(e) {
  Se(e.kind === "Document", 119), Se(e.definitions.length <= 1, 120);
  var t = e.definitions[0];
  return Se(t.kind === "FragmentDefinition", 121), t;
}
function Ec(e) {
  Tl(e);
  for (var t, n = 0, r = e.definitions; n < r.length; n++) {
    var i = r[n];
    if (i.kind === "OperationDefinition") {
      var o = i.operation;
      if (o === "query" || o === "mutation" || o === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw Ln(122);
}
function e1(e) {
  var t = /* @__PURE__ */ Object.create(null), n = e && e.variableDefinitions;
  return n && n.length && n.forEach(function(r) {
    r.defaultValue && Ys(t, r.variable.name, r.defaultValue);
  }), t;
}
let hn = null;
const XS = {};
let wte = 1;
const xte = () => class {
  constructor() {
    this.id = [
      "slot",
      wte++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = hn; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === XS)
          break;
        return e !== hn && (hn.slots[this.id] = t), !0;
      }
    return hn && (hn.slots[this.id] = XS), !1;
  }
  getValue() {
    if (this.hasValue())
      return hn.slots[this.id];
  }
  withValue(e, t, n, r) {
    const i = {
      __proto__: null,
      [this.id]: e
    }, o = hn;
    hn = { parent: o, slots: i };
    try {
      return t.apply(r, n);
    } finally {
      hn = o;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = hn;
    return function() {
      const n = hn;
      try {
        return hn = t, e.apply(this, arguments);
      } finally {
        hn = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, n) {
    if (hn) {
      const r = hn;
      try {
        return hn = null, e.apply(n, t);
      } finally {
        hn = r;
      }
    } else
      return e.apply(n, t);
  }
};
function e2(e) {
  try {
    return e();
  } catch {
  }
}
const Cm = "@wry/context:Slot", Ete = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  e2(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  e2(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), t2 = Ete, kl = t2[Cm] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Cm] || (function(e) {
  try {
    Object.defineProperty(t2, Cm, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(xte()), { bind: que, noContext: Hue } = kl, th = new kl(), { hasOwnProperty: Ste } = Object.prototype, t1 = Array.from || function(e) {
  const t = [];
  return e.forEach((n) => t.push(n)), t;
};
function n1(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const Hu = [], $te = 100;
function Qs(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function sI(e, t) {
  const n = e.length;
  return (
    // Unknown values are not equal to each other.
    n > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    n === t.length && // The underlying value or exception must be the same.
    e[n - 1] === t[n - 1]
  );
}
function lI(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function uI(e) {
  return e.slice(0);
}
class nh {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++nh.count;
  }
  peek() {
    if (this.value.length === 1 && !Io(this))
      return n2(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return Qs(!this.recomputing, "already recomputing"), n2(this), Io(this) ? Tte(this, t) : lI(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, cI(this), n1(this));
  }
  dispose() {
    this.setDirty(), mI(this), r1(this, (t, n) => {
      t.setDirty(), vI(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = Hu.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (t1(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), Hu.push(this.deps), this.deps = null);
  }
}
nh.count = 0;
function n2(e) {
  const t = th.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Io(e) ? dI(t, e) : pI(t, e), t;
}
function Tte(e, t) {
  return mI(e), th.withValue(e, Ote, [e, t]), Pte(e, t) && kte(e), lI(e.value);
}
function Ote(e, t) {
  e.recomputing = !0;
  const { normalizeResult: n } = e;
  let r;
  n && e.value.length === 1 && (r = uI(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), n && r && !sI(r, e.value))
      try {
        e.value[0] = n(e.value[0], r[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function Io(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function kte(e) {
  e.dirty = !1, !Io(e) && fI(e);
}
function cI(e) {
  r1(e, dI);
}
function fI(e) {
  r1(e, pI);
}
function r1(e, t) {
  const n = e.parents.size;
  if (n) {
    const r = t1(e.parents);
    for (let i = 0; i < n; ++i)
      t(r[i], e);
  }
}
function dI(e, t) {
  Qs(e.childValues.has(t)), Qs(Io(t));
  const n = !Io(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = Hu.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), n && cI(e);
}
function pI(e, t) {
  Qs(e.childValues.has(t)), Qs(!Io(t));
  const n = e.childValues.get(t);
  n.length === 0 ? e.childValues.set(t, uI(t.value)) : sI(n, t.value) || e.setDirty(), hI(e, t), !Io(e) && fI(e);
}
function hI(e, t) {
  const n = e.dirtyChildren;
  n && (n.delete(t), n.size === 0 && (Hu.length < $te && Hu.push(n), e.dirtyChildren = null));
}
function mI(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, n) => {
    vI(e, n);
  }), e.forgetDeps(), Qs(e.dirtyChildren === null);
}
function vI(e, t) {
  t.parents.delete(e), e.childValues.delete(t), hI(e, t);
}
function Pte(e, t) {
  if (typeof e.subscribe == "function")
    try {
      n1(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const Dte = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function gI(e) {
  const t = /* @__PURE__ */ new Map();
  function n(r) {
    const i = th.getValue();
    if (i) {
      let o = t.get(r);
      o || t.set(r, o = /* @__PURE__ */ new Set()), i.dependOn(o);
    }
  }
  return n.dirty = function(r, i) {
    const o = t.get(r);
    if (o) {
      const a = i && Ste.call(Dte, i) ? i : "setDirty";
      t1(o).forEach((s) => s[a]()), t.delete(r), n1(o);
    }
  }, n;
}
let r2;
function Ate(...e) {
  return (r2 || (r2 = new to(typeof WeakMap == "function"))).lookupArray(e);
}
const Im = /* @__PURE__ */ new Set();
function Wu(e, { max: t = Math.pow(2, 16), keyArgs: n, makeCacheKey: r = Ate, normalizeResult: i, subscribe: o, cache: a = Yg } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof a == "function" ? new a(t, (d) => d.dispose()) : a, l = function() {
    const d = r.apply(null, n ? n.apply(null, arguments) : arguments);
    if (d === void 0)
      return e.apply(null, arguments);
    let p = s.get(d);
    p || (s.set(d, p = new nh(e)), p.normalizeResult = i, p.subscribe = o, p.forget = () => s.delete(d));
    const h = p.recompute(Array.prototype.slice.call(arguments));
    return s.set(d, p), Im.add(s), th.hasValue() || (Im.forEach((m) => m.clean()), Im.clear()), h;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: n,
    makeCacheKey: r,
    normalizeResult: i,
    subscribe: o,
    cache: s
  });
  function u(d) {
    const p = d && s.get(d);
    p && p.setDirty();
  }
  l.dirtyKey = u, l.dirty = function() {
    u(r.apply(null, arguments));
  };
  function c(d) {
    const p = d && s.get(d);
    if (p)
      return p.peek();
  }
  l.peekKey = c, l.peek = function() {
    return c(r.apply(null, arguments));
  };
  function f(d) {
    return d ? s.delete(d) : !1;
  }
  return l.forgetKey = f, l.forget = function() {
    return f(r.apply(null, arguments));
  }, l.makeCacheKey = r, l.getKey = n ? function() {
    return r.apply(null, n.apply(null, arguments));
  } : r, Object.freeze(l);
}
function Cte(e) {
  return e;
}
var yI = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = /* @__PURE__ */ Object.create(null)), this.resultCache = X0 ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, n.getCacheKey && (this.getCacheKey = n.getCacheKey), this.cached = n.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(Cte, { cache: !1 });
    }, e.split = function(t, n, r) {
      return r === void 0 && (r = e.identity()), Object.assign(new e(
        function(i) {
          var o = t(i) ? n : r;
          return o.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: n, right: r });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var n = new to(Ha);
        this.performWork = Wu(e.prototype.performWork.bind(this), {
          makeCacheKey: function(r) {
            var i = t.getCacheKey(r);
            if (i)
              return Se(Array.isArray(i), 104), n.lookupArray(i);
          },
          max: Qi["documentTransform.cache"],
          cache: Ld
        });
      }
    }, e.prototype.performWork = function(t) {
      return Tl(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var n = this.performWork(t);
      return this.resultCache.add(n), n;
    }, e.prototype.concat = function(t) {
      var n = this;
      return Object.assign(new e(
        function(r) {
          return t.transformDocument(n.transformDocument(r));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), vu, bo = Object.assign(function(e) {
  var t = vu.get(e);
  return t || (t = Dee(e), vu.set(e, t)), t;
}, {
  reset: function() {
    vu = new XC(
      Qi.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
bo.reset();
globalThis.__DEV__ !== !1 && eI("print", function() {
  return vu ? vu.size : 0;
});
var qt = Array.isArray;
function Di(e) {
  return Array.isArray(e) && e.length > 0;
}
var i2 = {
  kind: Bt.FIELD,
  name: {
    kind: Bt.NAME,
    value: "__typename"
  }
};
function bI(e, t) {
  return !e || e.selectionSet.selections.every(function(n) {
    return n.kind === Bt.FRAGMENT_SPREAD && bI(t[n.name.value], t);
  });
}
function Ite(e) {
  return bI(Da(e) || aI(e), $l(Ol(e))) ? null : e;
}
function Mte(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return e.forEach(function(r) {
    r && (r.name ? t.set(r.name, r) : r.test && n.set(r.test, r));
  }), function(r) {
    var i = t.get(r.name.value);
    return !i && n.size && n.forEach(function(o, a) {
      a(r) && (i = o);
    }), i;
  };
}
function o2(e) {
  var t = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = e);
    var r = t.get(n);
    return r || t.set(n, r = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), r;
  };
}
function _I(e, t) {
  Tl(t);
  for (var n = o2(""), r = o2(""), i = function(g) {
    for (var b = 0, E = void 0; b < g.length && (E = g[b]); ++b)
      if (!qt(E)) {
        if (E.kind === Bt.OPERATION_DEFINITION)
          return n(E.name && E.name.value);
        if (E.kind === Bt.FRAGMENT_DEFINITION)
          return r(E.name.value);
      }
    return globalThis.__DEV__ !== !1 && Se.error(124), null;
  }, o = 0, a = t.definitions.length - 1; a >= 0; --a)
    t.definitions[a].kind === Bt.OPERATION_DEFINITION && ++o;
  var s = Mte(e), l = function(g) {
    return Di(g) && g.map(s).some(function(b) {
      return b && b.remove;
    });
  }, u = /* @__PURE__ */ new Map(), c = !1, f = {
    enter: function(g) {
      if (l(g.directives))
        return c = !0, null;
    }
  }, d = ii(t, {
    // These two AST node types share the same implementation, defined above.
    Field: f,
    InlineFragment: f,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(g, b, E, x, S) {
        var $ = i(S);
        $ && $.variables.add(g.name.value);
      }
    },
    FragmentSpread: {
      enter: function(g, b, E, x, S) {
        if (l(g.directives))
          return c = !0, null;
        var $ = i(S);
        $ && $.fragmentSpreads.add(g.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(g, b, E, x) {
        u.set(JSON.stringify(x), g);
      },
      leave: function(g, b, E, x) {
        var S = u.get(JSON.stringify(x));
        if (g === S)
          return g;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          o > 0 && g.selectionSet.selections.every(function($) {
            return $.kind === Bt.FIELD && $.name.value === "__typename";
          })
        )
          return r(g.name.value).removed = !0, c = !0, null;
      }
    },
    Directive: {
      leave: function(g) {
        if (s(g))
          return c = !0, null;
      }
    }
  });
  if (!c)
    return t;
  var p = function(g) {
    return g.transitiveVars || (g.transitiveVars = new Set(g.variables), g.removed || g.fragmentSpreads.forEach(function(b) {
      p(r(b)).transitiveVars.forEach(function(E) {
        g.transitiveVars.add(E);
      });
    })), g;
  }, h = /* @__PURE__ */ new Set();
  d.definitions.forEach(function(g) {
    g.kind === Bt.OPERATION_DEFINITION ? p(n(g.name && g.name.value)).fragmentSpreads.forEach(function(b) {
      h.add(b);
    }) : g.kind === Bt.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    o === 0 && !r(g.name.value).removed && h.add(g.name.value);
  }), h.forEach(function(g) {
    p(r(g)).fragmentSpreads.forEach(function(b) {
      h.add(b);
    });
  });
  var m = function(g) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!h.has(g) || r(g).removed);
  }, v = {
    enter: function(g) {
      if (m(g.name.value))
        return null;
    }
  };
  return Ite(ii(d, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: v,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: v,
    OperationDefinition: {
      leave: function(g) {
        if (g.variableDefinitions) {
          var b = p(
            // If an operation is anonymous, we use the empty string as its key.
            n(g.name && g.name.value)
          ).transitiveVars;
          if (b.size < g.variableDefinitions.length)
            return W(W({}, g), { variableDefinitions: g.variableDefinitions.filter(function(E) {
              return b.has(E.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var i1 = Object.assign(function(e) {
  return ii(e, {
    SelectionSet: {
      enter: function(t, n, r) {
        if (!(r && r.kind === Bt.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var o = i.some(function(s) {
              return Co(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!o) {
              var a = r;
              if (!(Co(a) && a.directives && a.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return W(W({}, t), { selections: _n(_n([], i, !0), [i2], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === i2;
  }
});
function Rte(e) {
  var t = Ec(e), n = t.operation;
  if (n === "query")
    return e;
  var r = ii(e, {
    OperationDefinition: {
      enter: function(i) {
        return W(W({}, i), { operation: "query" });
      }
    }
  });
  return r;
}
function wI(e) {
  Tl(e);
  var t = _I([
    {
      test: function(n) {
        return n.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function Nte(e) {
  return Tl(e), ii(e, {
    FragmentSpread: function(t) {
      var n;
      if (!(!((n = t.directives) === null || n === void 0) && n.some(function(r) {
        return r.name.value === "unmask";
      })))
        return W(W({}, t), { directives: _n(_n([], t.directives || [], !0), [
          {
            kind: Bt.DIRECTIVE,
            name: { kind: Bt.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var jte = Object.prototype.hasOwnProperty;
function a2() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return rh(e);
}
function rh(e) {
  var t = e[0] || {}, n = e.length;
  if (n > 1)
    for (var r = new Mo(), i = 1; i < n; ++i)
      t = r.merge(t, e[i]);
  return t;
}
var Fte = function(e, t, n) {
  return this.merge(e[n], t[n]);
}, Mo = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = Fte), this.reconciler = t, this.isObject = Mt, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, n) {
      for (var r = this, i = [], o = 2; o < arguments.length; o++)
        i[o - 2] = arguments[o];
      return Mt(n) && Mt(t) ? (Object.keys(n).forEach(function(a) {
        if (jte.call(t, a)) {
          var s = t[a];
          if (n[a] !== s) {
            var l = r.reconciler.apply(r, _n([
              t,
              n,
              a
            ], i, !1));
            l !== s && (t = r.shallowCopyForMerge(t), t[a] = l);
          }
        } else
          t = r.shallowCopyForMerge(t), t[a] = n[a];
      }), t) : n;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return Mt(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = W({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function zte(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Lte(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Lte(e, t) {
  if (e) {
    if (typeof e == "string") return s2(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return s2(e, t);
  }
}
function s2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function l2(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function o1(e, t, n) {
  return t && l2(e.prototype, t), n && l2(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var a1 = function() {
  return typeof Symbol == "function";
}, s1 = function(e) {
  return a1() && !!Symbol[e];
}, l1 = function(e) {
  return s1(e) ? Symbol[e] : "@@" + e;
};
a1() && !s1("observable") && (Symbol.observable = Symbol("observable"));
var Vte = l1("iterator"), ty = l1("observable"), xI = l1("species");
function Vd(e, t) {
  var n = e[t];
  if (n != null) {
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    return n;
  }
}
function Bl(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[xI], t === null && (t = void 0)), t !== void 0 ? t : yt;
}
function Bte(e) {
  return e instanceof yt;
}
function Js(e) {
  Js.log ? Js.log(e) : setTimeout(function() {
    throw e;
  });
}
function Nf(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      Js(t);
    }
  });
}
function EI(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var n = Vd(t, "unsubscribe");
        n && n.call(t);
      }
    } catch (r) {
      Js(r);
    }
}
function ny(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function Kte(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var n = 0; n < t.length && (SI(e, t[n].type, t[n].value), e._state !== "closed"); ++n)
      ;
  }
}
function SI(e, t, n) {
  e._state = "running";
  var r = e._observer;
  try {
    var i = Vd(r, t);
    switch (t) {
      case "next":
        i && i.call(r, n);
        break;
      case "error":
        if (ny(e), i) i.call(r, n);
        else throw n;
        break;
      case "complete":
        ny(e), i && i.call(r);
        break;
    }
  } catch (o) {
    Js(o);
  }
  e._state === "closed" ? EI(e) : e._state === "running" && (e._state = "ready");
}
function Mm(e, t, n) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: n
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: n
      }], Nf(function() {
        return Kte(e);
      });
      return;
    }
    SI(e, t, n);
  }
}
var Ute = /* @__PURE__ */ (function() {
  function e(n, r) {
    this._cleanup = void 0, this._observer = n, this._queue = void 0, this._state = "initializing";
    var i = new qte(this);
    try {
      this._cleanup = r.call(void 0, i);
    } catch (o) {
      i.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (ny(this), EI(this));
  }, o1(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), qte = /* @__PURE__ */ (function() {
  function e(n) {
    this._subscription = n;
  }
  var t = e.prototype;
  return t.next = function(n) {
    Mm(this._subscription, "next", n);
  }, t.error = function(n) {
    Mm(this._subscription, "error", n);
  }, t.complete = function() {
    Mm(this._subscription, "complete");
  }, o1(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), yt = /* @__PURE__ */ (function() {
  function e(n) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof n != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = n;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new Ute(n, this._subscriber);
  }, t.forEach = function(n) {
    var r = this;
    return new Promise(function(i, o) {
      if (typeof n != "function") {
        o(new TypeError(n + " is not a function"));
        return;
      }
      function a() {
        s.unsubscribe(), i();
      }
      var s = r.subscribe({
        next: function(l) {
          try {
            n(l, a);
          } catch (u) {
            o(u), s.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
    });
  }, t.map = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Bl(this);
    return new i(function(o) {
      return r.subscribe({
        next: function(a) {
          try {
            a = n(a);
          } catch (s) {
            return o.error(s);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Bl(this);
    return new i(function(o) {
      return r.subscribe({
        next: function(a) {
          try {
            if (!n(a)) return;
          } catch (s) {
            return o.error(s);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Bl(this), o = arguments.length > 1, a = !1, s = arguments[1], l = s;
    return new i(function(u) {
      return r.subscribe({
        next: function(c) {
          var f = !a;
          if (a = !0, !f || o)
            try {
              l = n(l, c);
            } catch (d) {
              return u.error(d);
            }
          else
            l = c;
        },
        error: function(c) {
          u.error(c);
        },
        complete: function() {
          if (!a && !o) return u.error(new TypeError("Cannot reduce an empty sequence"));
          u.next(l), u.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = Bl(this);
    return new a(function(s) {
      var l, u = 0;
      function c(f) {
        l = f.subscribe({
          next: function(d) {
            s.next(d);
          },
          error: function(d) {
            s.error(d);
          },
          complete: function() {
            u === i.length ? (l = void 0, s.complete()) : c(a.from(i[u++]));
          }
        });
      }
      return c(n), function() {
        l && (l.unsubscribe(), l = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Bl(this);
    return new i(function(o) {
      var a = [], s = r.subscribe({
        next: function(u) {
          if (n)
            try {
              u = n(u);
            } catch (f) {
              return o.error(f);
            }
          var c = i.from(u).subscribe({
            next: function(f) {
              o.next(f);
            },
            error: function(f) {
              o.error(f);
            },
            complete: function() {
              var f = a.indexOf(c);
              f >= 0 && a.splice(f, 1), l();
            }
          });
          a.push(c);
        },
        error: function(u) {
          o.error(u);
        },
        complete: function() {
          l();
        }
      });
      function l() {
        s.closed && a.length === 0 && o.complete();
      }
      return function() {
        a.forEach(function(u) {
          return u.unsubscribe();
        }), s.unsubscribe();
      };
    });
  }, t[ty] = function() {
    return this;
  }, e.from = function(n) {
    var r = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var i = Vd(n, ty);
    if (i) {
      var o = i.call(n);
      if (Object(o) !== o) throw new TypeError(o + " is not an object");
      return Bte(o) && o.constructor === r ? o : new r(function(a) {
        return o.subscribe(a);
      });
    }
    if (s1("iterator") && (i = Vd(n, Vte), i))
      return new r(function(a) {
        Nf(function() {
          if (!a.closed) {
            for (var s = zte(i.call(n)), l; !(l = s()).done; ) {
              var u = l.value;
              if (a.next(u), a.closed) return;
            }
            a.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new r(function(a) {
        Nf(function() {
          if (!a.closed) {
            for (var s = 0; s < n.length; ++s)
              if (a.next(n[s]), a.closed) return;
            a.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    var o = typeof this == "function" ? this : e;
    return new o(function(a) {
      Nf(function() {
        if (!a.closed) {
          for (var s = 0; s < r.length; ++s)
            if (a.next(r[s]), a.closed) return;
          a.complete();
        }
      });
    });
  }, o1(e, null, [{
    key: xI,
    get: function() {
      return this;
    }
  }]), e;
})();
a1() && Object.defineProperty(yt, Symbol("extensions"), {
  value: {
    symbol: ty,
    hostReportError: Js
  },
  configurable: !0
});
function Hte(e) {
  var t, n = e.Symbol;
  if (typeof n == "function")
    if (n.observable)
      t = n.observable;
    else {
      typeof n.for == "function" ? t = n.for("https://github.com/benlesh/symbol-observable") : t = n("https://github.com/benlesh/symbol-observable");
      try {
        n.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var is;
typeof self < "u" ? is = self : typeof window < "u" ? is = window : typeof global < "u" ? is = global : typeof module < "u" ? is = module : is = Function("return this")();
Hte(is);
var u2 = yt.prototype, c2 = "@@observable";
u2[c2] || (u2[c2] = function() {
  return this;
});
function Wte(e) {
  return e.catch(function() {
  }), e;
}
var Zte = Object.prototype.toString;
function $I(e) {
  return ry(e);
}
function ry(e, t) {
  switch (Zte.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = e.slice(0);
      return t.set(e, n), n.forEach(function(i, o) {
        n[o] = ry(i, t);
      }), n;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = Object.create(Object.getPrototypeOf(e));
      return t.set(e, r), Object.keys(e).forEach(function(i) {
        r[i] = ry(e[i], t);
      }), r;
    }
    default:
      return e;
  }
}
function Gte(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(n) {
    Mt(n) && Yte(n) === n && Object.getOwnPropertyNames(n).forEach(function(r) {
      Mt(n[r]) && t.add(n[r]);
    });
  }), e;
}
function Yte(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function Bd(e) {
  return globalThis.__DEV__ !== !1 && Gte(e), e;
}
function gu(e, t, n) {
  var r = [];
  e.forEach(function(i) {
    return i[t] && r.push(i);
  }), r.forEach(function(i) {
    return i[t](n);
  });
}
function Rm(e, t, n) {
  return new yt(function(r) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(u) {
          return u(l());
        });
      }
    };
    function o(l, u) {
      return function(c) {
        if (l) {
          var f = function() {
            return r.closed ? (
              /* will be swallowed */
              0
            ) : l(c);
          };
          i = i.then(f, f).then(function(d) {
            return r.next(d);
          }, function(d) {
            return r.error(d);
          });
        } else
          r[u](c);
      };
    }
    var a = {
      next: o(t, "next"),
      error: o(n, "error"),
      complete: function() {
        i.then(function() {
          return r.complete();
        });
      }
    }, s = e.subscribe(a);
    return function() {
      return s.unsubscribe();
    };
  });
}
function TI(e) {
  function t(n) {
    Object.defineProperty(e, n, { value: yt });
  }
  return QC && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function f2(e) {
  return e && typeof e.then == "function";
}
var os = (
  /** @class */
  (function(e) {
    ui(t, e);
    function t(n) {
      var r = e.call(this, function(i) {
        return r.addObserver(i), function() {
          return r.removeObserver(i);
        };
      }) || this;
      return r.observers = /* @__PURE__ */ new Set(), r.promise = new Promise(function(i, o) {
        r.resolve = i, r.reject = o;
      }), r.handlers = {
        next: function(i) {
          r.sub !== null && (r.latest = ["next", i], r.notify("next", i), gu(r.observers, "next", i));
        },
        error: function(i) {
          var o = r.sub;
          o !== null && (o && setTimeout(function() {
            return o.unsubscribe();
          }), r.sub = null, r.latest = ["error", i], r.reject(i), r.notify("error", i), gu(r.observers, "error", i));
        },
        complete: function() {
          var i = r, o = i.sub, a = i.sources, s = a === void 0 ? [] : a;
          if (o !== null) {
            var l = s.shift();
            l ? f2(l) ? l.then(function(u) {
              return r.sub = u.subscribe(r.handlers);
            }, r.handlers.error) : r.sub = l.subscribe(r.handlers) : (o && setTimeout(function() {
              return o.unsubscribe();
            }), r.sub = null, r.latest && r.latest[0] === "next" ? r.resolve(r.latest[1]) : r.resolve(), r.notify("complete"), gu(r.observers, "complete"));
          }
        }
      }, r.nextResultListeners = /* @__PURE__ */ new Set(), r.cancel = function(i) {
        r.reject(i), r.sources = [], r.handlers.error(i);
      }, r.promise.catch(function(i) {
      }), typeof n == "function" && (n = [new yt(n)]), f2(n) ? n.then(function(i) {
        return r.start(i);
      }, r.handlers.error) : r.start(n), r;
    }
    return t.prototype.start = function(n) {
      this.sub === void 0 && (this.sources = Array.from(n), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(n) {
      if (this.latest) {
        var r = this.latest[0], i = n[r];
        i && i.call(n, this.latest[1]), this.sub === null && r === "next" && n.complete && n.complete();
      }
    }, t.prototype.addObserver = function(n) {
      this.observers.has(n) || (this.deliverLastMessage(n), this.observers.add(n));
    }, t.prototype.removeObserver = function(n) {
      this.observers.delete(n) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(n, r) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(o) {
        return o(n, r);
      }));
    }, t.prototype.beforeNext = function(n) {
      var r = !1;
      this.nextResultListeners.add(function(i, o) {
        r || (r = !0, n(i, o));
      });
    }, t;
  })(yt)
);
TI(os);
function Ps(e) {
  return "incremental" in e;
}
function Qte(e) {
  return "hasNext" in e && "data" in e;
}
function Jte(e) {
  return Ps(e) || Qte(e);
}
function Xte(e) {
  return Mt(e) && "payload" in e;
}
function OI(e, t) {
  var n = e, r = new Mo();
  return Ps(t) && Di(t.incremental) && t.incremental.forEach(function(i) {
    for (var o = i.data, a = i.path, s = a.length - 1; s >= 0; --s) {
      var l = a[s], u = !isNaN(+l), c = u ? [] : {};
      c[l] = o, o = c;
    }
    n = r.merge(n, o);
  }), n;
}
function jf(e) {
  var t = iy(e);
  return Di(t);
}
function iy(e) {
  var t = Di(e.errors) ? e.errors.slice(0) : [];
  return Ps(e) && Di(e.incremental) && e.incremental.forEach(function(n) {
    n.errors && t.push.apply(t, n.errors);
  }), t;
}
function Xs() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(r) {
    r && Object.keys(r).forEach(function(i) {
      var o = r[i];
      o !== void 0 && (n[i] = o);
    });
  }), n;
}
function Nm(e, t) {
  return Xs(e, t, t.variables && {
    variables: Xs(W(W({}, e && e.variables), t.variables))
  });
}
var jm, ene = Symbol.for("apollo.deprecations"), d2 = Symbol.for("apollo.deprecations.slot"), oy = zd, ay = (jm = oy[d2]) !== null && jm !== void 0 ? jm : oy[d2] = new kl();
function tne(e) {
  return oy[ene] || (ay.getValue() || []).includes(e);
}
function En(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return ay.withValue.apply(ay, _n([Array.isArray(e) ? e : [e]], t, !1));
}
function Zt(e, t, n, r) {
  r === void 0 && (r = "Please remove this option."), ia(t, function() {
    t in e && globalThis.__DEV__ !== !1 && Se.warn(103, n, t, r);
  });
}
function ia(e, t) {
  tne(e) || t();
}
function Fm(e) {
  return new yt(function(t) {
    t.error(e);
  });
}
var kI = function(e, t, n) {
  var r = new Error(n);
  throw r.name = "ServerError", r.response = e, r.statusCode = e.status, r.result = t, r;
};
function nne(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], n = 0, r = Object.keys(e); n < r.length; n++) {
    var i = r[n];
    if (t.indexOf(i) < 0)
      throw Ln(58, i);
  }
  return e;
}
function rne(e, t) {
  var n = W({}, e), r = function(o) {
    typeof o == "function" ? n = W(W({}, n), o(n)) : n = W(W({}, n), o);
  }, i = function() {
    return W({}, n);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: r
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function ine(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? tu(t.query) || void 0 : ""), t;
}
function one(e, t) {
  var n = W({}, e), r = new Set(Object.keys(e));
  return ii(t, {
    Variable: function(i, o, a) {
      a && a.kind !== "VariableDefinition" && r.delete(i.name.value);
    }
  }), r.forEach(function(i) {
    delete n[i];
  }), n;
}
function p2(e, t) {
  return t ? t(e) : yt.of();
}
function Kl(e) {
  return typeof e == "function" ? new Uo(e) : e;
}
function af(e) {
  return e.request.length <= 1;
}
var Uo = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return yt.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(Kl).reduce(function(n, r) {
        return n.concat(r);
      });
    }, e.split = function(t, n, r) {
      var i = Kl(n), o = Kl(r || new e(p2)), a;
      return af(i) && af(o) ? a = new e(function(s) {
        return t(s) ? i.request(s) || yt.of() : o.request(s) || yt.of();
      }) : a = new e(function(s, l) {
        return t(s) ? i.request(s, l) || yt.of() : o.request(s, l) || yt.of();
      }), Object.assign(a, { left: i, right: o });
    }, e.execute = function(t, n) {
      return t.request(rne(n.context, ine(nne(n)))) || yt.of();
    }, e.concat = function(t, n) {
      var r = Kl(t);
      if (af(r))
        return globalThis.__DEV__ !== !1 && Se.warn(47, r), r;
      var i = Kl(n), o;
      return af(i) ? o = new e(function(a) {
        return r.request(a, function(s) {
          return i.request(s) || yt.of();
        }) || yt.of();
      }) : o = new e(function(a, s) {
        return r.request(a, function(l) {
          return i.request(l, s) || yt.of();
        }) || yt.of();
      }), Object.assign(o, { left: r, right: i });
    }, e.prototype.split = function(t, n, r) {
      return this.concat(e.split(t, n, r || new e(p2)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, n) {
      throw Ln(48);
    }, e.prototype.onError = function(t, n) {
      if (globalThis.__DEV__ !== !1 && ia("onError", function() {
        globalThis.__DEV__ !== !1 && Se.warn(49);
      }), n && n.error)
        return n.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Se.warn(50), this.onError = t, this;
    }, e;
  })()
);
Uo.from;
Uo.split;
var sy = Uo.execute;
function ane(e) {
  var t, n = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return n.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function sne(e) {
  var t = null, n = null, r = !1, i = [], o = [];
  function a(f) {
    if (!n) {
      if (o.length) {
        var d = o.shift();
        if (Array.isArray(d) && d[0])
          return d[0]({ value: f, done: !1 });
      }
      i.push(f);
    }
  }
  function s(f) {
    n = f;
    var d = o.slice();
    d.forEach(function(p) {
      p[1](f);
    }), !t || t();
  }
  function l() {
    r = !0;
    var f = o.slice();
    f.forEach(function(d) {
      d[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", a), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", a), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function u() {
    return new Promise(function(f, d) {
      if (n)
        return d(n);
      if (i.length)
        return f({ value: i.shift(), done: !1 });
      if (r)
        return f({ value: void 0, done: !0 });
      o.push([f, d]);
    });
  }
  var c = {
    next: function() {
      return u();
    }
  };
  return Jp && (c[Symbol.asyncIterator] = function() {
    return this;
  }), c;
}
function lne(e) {
  var t = !1, n = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(r, i) {
        e.then(function(o) {
          r({ value: o, done: !1 });
        }).catch(i);
      }));
    }
  };
  return Jp && (n[Symbol.asyncIterator] = function() {
    return this;
  }), n;
}
function h2(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return Jp && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function une(e) {
  return !!e.body;
}
function cne(e) {
  return !!e.getReader;
}
function fne(e) {
  return !!(Jp && e[Symbol.asyncIterator]);
}
function dne(e) {
  return !!e.stream;
}
function pne(e) {
  return !!e.arrayBuffer;
}
function hne(e) {
  return !!e.pipe;
}
function mne(e) {
  var t = e;
  if (une(e) && (t = e.body), fne(t))
    return ane(t);
  if (cne(t))
    return h2(t.getReader());
  if (dne(t))
    return h2(t.stream().getReader());
  if (pne(t))
    return lne(t.arrayBuffer());
  if (hne(t))
    return sne(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var u1 = Symbol();
function vne(e) {
  return e.extensions ? Array.isArray(e.extensions[u1]) : !1;
}
function PI(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var gne = function(e) {
  var t = _n(_n(_n([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(n) {
    return Mt(n) && n.message || "Error message not found.";
  }).join(`
`);
}, fo = (
  /** @class */
  (function(e) {
    ui(t, e);
    function t(n) {
      var r = n.graphQLErrors, i = n.protocolErrors, o = n.clientErrors, a = n.networkError, s = n.errorMessage, l = n.extraInfo, u = e.call(this, s) || this;
      return u.name = "ApolloError", u.graphQLErrors = r || [], u.protocolErrors = i || [], u.clientErrors = o || [], u.networkError = a || null, u.message = s || gne(u), u.extraInfo = l, u.cause = _n(_n(_n([
        a
      ], r || [], !0), i || [], !0), o || [], !0).find(function(c) {
        return !!c;
      }) || null, u.__proto__ = t.prototype, u;
    }
    return t;
  })(Error)
), m2 = Object.prototype.hasOwnProperty;
function yne(e, t) {
  return lo(this, void 0, void 0, function() {
    var n, r, i, o, a, s, l, u, c, f, d, p, h, m, v, g, b, E, x, S, $, P, y, _;
    return uo(this, function(w) {
      switch (w.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          n = new TextDecoder("utf-8"), r = (_ = e.headers) === null || _ === void 0 ? void 0 : _.get("content-type"), i = "boundary=", o = r != null && r.includes(i) ? r?.substring(r?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", a = `\r
--`.concat(o), s = "", l = mne(e), u = !0, w.label = 1;
        case 1:
          return u ? [4, l.next()] : [3, 3];
        case 2:
          for (c = w.sent(), f = c.value, d = c.done, p = typeof f == "string" ? f : n.decode(f), h = s.length - a.length + 1, u = !d, s += p, m = s.indexOf(a, h); m > -1; ) {
            if (v = void 0, P = [
              s.slice(0, m),
              s.slice(m + a.length)
            ], v = P[0], s = P[1], g = v.indexOf(`\r
\r
`), b = bne(v.slice(0, g)), E = b["content-type"], E && E.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (x = v.slice(g), x) {
              if (S = DI(e, x), Object.keys(S).length > 1 || "data" in S || "incremental" in S || "errors" in S || "payload" in S)
                if (Xte(S)) {
                  if ($ = {}, "payload" in S) {
                    if (Object.keys(S).length === 1 && S.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    $ = W({}, S.payload);
                  }
                  "errors" in S && ($ = W(W({}, $), { extensions: W(W({}, "extensions" in $ ? $.extensions : null), (y = {}, y[u1] = S.errors, y)) })), t($);
                } else
                  t(S);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(S).length === 1 && "hasNext" in S && !S.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            m = s.indexOf(a);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function bne(e) {
  var t = {};
  return e.split(`
`).forEach(function(n) {
    var r = n.indexOf(":");
    if (r > -1) {
      var i = n.slice(0, r).trim().toLowerCase(), o = n.slice(r + 1).trim();
      t[i] = o;
    }
  }), t;
}
function DI(e, t) {
  if (e.status >= 300) {
    var n = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    kI(e, n(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var r = i;
    throw r.name = "ServerParseError", r.response = e, r.statusCode = e.status, r.bodyText = t, r;
  }
}
function _ne(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function wne(e) {
  return function(t) {
    return t.text().then(function(n) {
      return DI(t, n);
    }).then(function(n) {
      return !Array.isArray(n) && !m2.call(n, "data") && !m2.call(n, "errors") && kI(t, n, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(r) {
        return r.operationName;
      }) : e.operationName, "'.")), n;
    });
  };
}
var ly = function(e, t) {
  var n;
  try {
    n = JSON.stringify(e);
  } catch (i) {
    var r = Ln(54, t, i.message);
    throw r.parseError = i, r;
  }
  return n;
}, xne = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, Ene = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, Sne = {
  method: "POST"
}, $ne = {
  http: xne,
  headers: Ene,
  options: Sne
}, Tne = function(e, t) {
  return t(e);
};
function One(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var i = {}, o = {};
  n.forEach(function(f) {
    i = W(W(W({}, i), f.options), { headers: W(W({}, i.headers), f.headers) }), f.credentials && (i.credentials = f.credentials), o = W(W({}, o), f.http);
  }), i.headers && (i.headers = kne(i.headers, o.preserveHeaderCase));
  var a = e.operationName, s = e.extensions, l = e.variables, u = e.query, c = { operationName: a, variables: l };
  return o.includeExtensions && (c.extensions = s), o.includeQuery && (c.query = t(u, bo)), {
    options: i,
    body: c
  };
}
function kne(e, t) {
  if (!t) {
    var n = {};
    return Object.keys(Object(e)).forEach(function(o) {
      n[o.toLowerCase()] = e[o];
    }), n;
  }
  var r = {};
  Object.keys(Object(e)).forEach(function(o) {
    r[o.toLowerCase()] = {
      originalName: o,
      value: e[o]
    };
  });
  var i = {};
  return Object.keys(r).forEach(function(o) {
    i[r[o].originalName] = r[o].value;
  }), i;
}
var Pne = function(e) {
  if (!e && typeof fetch > "u")
    throw Ln(51);
}, Dne = function(e, t) {
  var n = e.getContext(), r = n.uri;
  return r || (typeof t == "function" ? t(e) : t || "/graphql");
};
function Ane(e, t) {
  var n = [], r = function(f, d) {
    n.push("".concat(f, "=").concat(encodeURIComponent(d)));
  };
  if ("query" in t && r("query", t.query), t.operationName && r("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = ly(t.variables, "Variables map");
    } catch (f) {
      return { parseError: f };
    }
    r("variables", i);
  }
  if (t.extensions) {
    var o = void 0;
    try {
      o = ly(t.extensions, "Extensions map");
    } catch (f) {
      return { parseError: f };
    }
    r("extensions", o);
  }
  var a = "", s = e, l = e.indexOf("#");
  l !== -1 && (a = e.substr(l), s = e.substr(0, l));
  var u = s.indexOf("?") === -1 ? "?" : "&", c = s + u + n.join("&") + a;
  return { newURI: c };
}
var v2 = Wr(function() {
  return fetch;
}), Cne = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, n = t === void 0 ? "/graphql" : t, r = e.fetch, i = e.print, o = i === void 0 ? Tne : i, a = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, u = e.includeUnusedVariables, c = u === void 0 ? !1 : u, f = Ki(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && Pne(r || v2);
  var d = {
    http: { includeExtensions: a, preserveHeaderCase: s },
    options: f.fetchOptions,
    credentials: f.credentials,
    headers: f.headers
  };
  return new Uo(function(p) {
    var h = Dne(p, n), m = p.getContext(), v = {};
    if (m.clientAwareness) {
      var g = m.clientAwareness, b = g.name, E = g.version;
      b && (v["apollographql-client-name"] = b), E && (v["apollographql-client-version"] = E);
    }
    var x = W(W({}, v), m.headers), S = {
      http: m.http,
      options: m.fetchOptions,
      credentials: m.credentials,
      headers: x
    };
    if (qu(["client"], p.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Se.warn(52);
      var $ = wI(p.query);
      if (!$)
        return Fm(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      p.query = $;
    }
    var P = One(p, o, $ne, d, S), y = P.options, _ = P.body;
    _.variables && !c && (_.variables = one(_.variables, p.query));
    var w;
    !y.signal && typeof AbortController < "u" && (w = new AbortController(), y.signal = w.signal);
    var A = function(Z) {
      return Z.kind === "OperationDefinition" && Z.operation === "mutation";
    }, k = function(Z) {
      return Z.kind === "OperationDefinition" && Z.operation === "subscription";
    }, N = k(Ec(p.query)), I = qu(["defer"], p.query);
    if (l && !p.query.definitions.some(A) && (y.method = "GET"), I || N) {
      y.headers = y.headers || {};
      var B = "multipart/mixed;";
      N && I && globalThis.__DEV__ !== !1 && Se.warn(53), N ? B += "boundary=graphql;subscriptionSpec=1.0,application/json" : I && (B += "deferSpec=20220824,application/json"), y.headers.accept = B;
    }
    if (y.method === "GET") {
      var q = Ane(h, _), ee = q.newURI, re = q.parseError;
      if (re)
        return Fm(re);
      h = ee;
    } else
      try {
        y.body = ly(_, "Payload");
      } catch (Z) {
        return Fm(Z);
      }
    return new yt(function(Z) {
      var T = r || Wr(function() {
        return fetch;
      }) || v2, F = Z.next.bind(Z);
      return T(h, y).then(function(M) {
        var K;
        p.setContext({ response: M });
        var te = (K = M.headers) === null || K === void 0 ? void 0 : K.get("content-type");
        return te !== null && /^multipart\/mixed/i.test(te) ? yne(M, F) : wne(p)(M).then(F);
      }).then(function() {
        w = void 0, Z.complete();
      }).catch(function(M) {
        w = void 0, _ne(M, Z);
      }), function() {
        w && w.abort();
      };
    });
  });
}, Ine = (
  /** @class */
  (function(e) {
    ui(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, Cne(n).request) || this;
      return r.options = n, r;
    }
    return t;
  })(Uo)
);
const { toString: g2, hasOwnProperty: Mne } = Object.prototype, y2 = Function.prototype.toString, uy = /* @__PURE__ */ new Map();
function wt(e, t) {
  try {
    return cy(e, t);
  } finally {
    uy.clear();
  }
}
function cy(e, t) {
  if (e === t)
    return !0;
  const n = g2.call(e), r = g2.call(t);
  if (n !== r)
    return !1;
  switch (n) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (_2(e, t))
        return !0;
      const i = b2(e), o = b2(t), a = i.length;
      if (a !== o.length)
        return !1;
      for (let s = 0; s < a; ++s)
        if (!Mne.call(t, i[s]))
          return !1;
      for (let s = 0; s < a; ++s) {
        const l = i[s];
        if (!cy(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (_2(e, t))
        return !0;
      const i = e.entries(), o = n === "[object Map]";
      for (; ; ) {
        const a = i.next();
        if (a.done)
          break;
        const [s, l] = a.value;
        if (!t.has(s) || o && !cy(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = y2.call(e);
      return i !== y2.call(t) ? !1 : !jne(i, Nne);
    }
  }
  return !1;
}
function b2(e) {
  return Object.keys(e).filter(Rne, e);
}
function Rne(e) {
  return this[e] !== void 0;
}
const Nne = "{ [native code] }";
function jne(e, t) {
  const n = e.length - t.length;
  return n >= 0 && e.indexOf(t, n) === n;
}
function _2(e, t) {
  let n = uy.get(e);
  if (n) {
    if (n.has(t))
      return !0;
  } else
    uy.set(e, n = /* @__PURE__ */ new Set());
  return n.add(t), !1;
}
function AI(e, t, n, r) {
  var i = t.data, o = Ki(t, ["data"]), a = n.data, s = Ki(n, ["data"]);
  return wt(o, s) && Ff(Ec(e).selectionSet, i, a, {
    fragmentMap: $l(Ol(e)),
    variables: r
  });
}
function Ff(e, t, n, r) {
  if (t === n)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(o) {
    if (i.has(o) || (i.add(o), !xc(o, r.variables)) || w2(o))
      return !0;
    if (Co(o)) {
      var a = Ji(o), s = t && t[a], l = n && n[a], u = o.selectionSet;
      if (!u)
        return wt(s, l);
      var c = Array.isArray(s), f = Array.isArray(l);
      if (c !== f)
        return !1;
      if (c && f) {
        var d = s.length;
        if (l.length !== d)
          return !1;
        for (var p = 0; p < d; ++p)
          if (!Ff(u, s[p], l[p], r))
            return !1;
        return !0;
      }
      return Ff(u, s, l, r);
    } else {
      var h = Xp(o, r.fragmentMap);
      if (h)
        return w2(h) ? !0 : Ff(
          h.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          n,
          r
        );
    }
  });
}
function w2(e) {
  return !!e.directives && e.directives.some(Fne);
}
function Fne(e) {
  return e.name.value === "nonreactive";
}
var CI = Ha ? WeakMap : Map, II = X0 ? WeakSet : Set, c1 = new kl(), x2 = !1;
function MI() {
  x2 || (x2 = !0, globalThis.__DEV__ !== !1 && Se.warn(64));
}
function RI(e, t, n) {
  return c1.withValue(!0, function() {
    var r = nu(e, t, n, !1);
    return Object.isFrozen(e) && Bd(r), r;
  });
}
function zne(e, t) {
  if (t.has(e))
    return t.get(e);
  var n = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, n), n;
}
function nu(e, t, n, r, i) {
  var o, a = n.knownChanged, s = zne(e, n.mutableTargets);
  if (Array.isArray(e)) {
    for (var l = 0, u = Array.from(e.entries()); l < u.length; l++) {
      var c = u[l], f = c[0], d = c[1];
      if (d === null) {
        s[f] = null;
        continue;
      }
      var p = nu(d, t, n, r, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(f, "]") : void 0);
      a.has(p) && a.add(s), s[f] = p;
    }
    return a.has(s) ? s : e;
  }
  for (var h = 0, m = t.selections; h < m.length; h++) {
    var v = m[h], g = void 0;
    if (r && a.add(s), v.kind === Bt.FIELD) {
      var b = Ji(v), E = v.selectionSet;
      if (g = s[b] || e[b], g === void 0)
        continue;
      if (E && g !== null) {
        var p = nu(e[b], E, n, r, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(b) : void 0);
        a.has(p) && (g = p);
      }
      globalThis.__DEV__ === !1 && (s[b] = g), globalThis.__DEV__ !== !1 && (r && b !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((o = Object.getOwnPropertyDescriptor(s, b)) === null || o === void 0) && o.value) ? Object.defineProperty(s, b, Lne(b, g, i || "", n.operationName, n.operationType)) : (delete s[b], s[b] = g));
    }
    if (v.kind === Bt.INLINE_FRAGMENT && (!v.typeCondition || n.cache.fragmentMatches(v, e.__typename)) && (g = nu(e, v.selectionSet, n, r, i)), v.kind === Bt.FRAGMENT_SPREAD) {
      var x = v.name.value, S = n.fragmentMap[x] || (n.fragmentMap[x] = n.cache.lookupFragment(x));
      Se(S, 59, x);
      var $ = jee(v);
      $ !== "mask" && (g = nu(e, S.selectionSet, n, $ === "migrate", i));
    }
    a.has(g) && a.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && a.add(s), a.has(s) ? s : e;
}
function Lne(e, t, n, r, i) {
  var o = function() {
    return c1.getValue() || (globalThis.__DEV__ !== !1 && Se.warn(60, r ? "".concat(i, " '").concat(r, "'") : "anonymous ".concat(i), "".concat(n, ".").concat(e).replace(/^\./, "")), o = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return o();
    },
    set: function(a) {
      o = function() {
        return a;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function NI(e, t, n, r) {
  if (!n.fragmentMatches)
    return globalThis.__DEV__ !== !1 && MI(), e;
  var i = t.definitions.filter(function(a) {
    return a.kind === Bt.FRAGMENT_DEFINITION;
  });
  typeof r > "u" && (Se(i.length === 1, 61, i.length), r = i[0].name.value);
  var o = i.find(function(a) {
    return a.name.value === r;
  });
  return Se(!!o, 62, r), e == null || wt(e, {}) ? e : RI(e, o.selectionSet, {
    operationType: "fragment",
    operationName: o.name.value,
    fragmentMap: $l(Ol(t)),
    cache: n,
    mutableTargets: new CI(),
    knownChanged: new II()
  });
}
function Vne(e, t, n) {
  var r;
  if (!n.fragmentMatches)
    return globalThis.__DEV__ !== !1 && MI(), e;
  var i = Da(t);
  return Se(i, 63), e == null ? e : RI(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (r = i.name) === null || r === void 0 ? void 0 : r.value,
    fragmentMap: $l(Ol(t)),
    cache: n,
    mutableTargets: new CI(),
    knownChanged: new II()
  });
}
var jI = (
  /** @class */
  (function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = Wu(Kee, {
        max: Qi["cache.fragmentQueryDocuments"] || 1e3,
        cache: Ld
      });
    }
    return e.prototype.lookupFragment = function(t) {
      return null;
    }, e.prototype.batch = function(t) {
      var n = this, r = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = t.update(n);
      }, r), i;
    }, e.prototype.recordOptimisticTransaction = function(t, n) {
      this.performTransaction(t, n);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, n) {
      var r = this;
      return n === void 0 && (n = !!t.optimistic), globalThis.__DEV__ !== !1 && Zt(t, "canonizeResults", "cache.readQuery"), En("canonizeResults", function() {
        return r.read(W(W({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: n }));
      });
    }, e.prototype.watchFragment = function(t) {
      var n = this, r = t.fragment, i = t.fragmentName, o = t.from, a = t.optimistic, s = a === void 0 ? !0 : a, l = Ki(t, ["fragment", "fragmentName", "from", "optimistic"]), u = this.getFragmentDoc(r, i), c = typeof o > "u" || typeof o == "string" ? o : this.identify(o), f = !!t[Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var d = i || aI(r).name.value;
        c || globalThis.__DEV__ !== !1 && Se.warn(1, d);
      }
      var p = W(W({}, l), { returnPartialData: !0, id: c, query: u, optimistic: s }), h;
      return new yt(function(m) {
        return n.watch(W(W({}, p), { immediate: !0, callback: function(v) {
          var g = f ? NI(v.result, r, n, i) : v.result;
          if (
            // Always ensure we deliver the first result
            !(h && AI(
              u,
              { data: h.result },
              { data: g },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              t.variables
            ))
          ) {
            var b = {
              data: g,
              complete: !!v.complete
            };
            v.missing && (b.missing = rh(v.missing.map(function(E) {
              return E.missing;
            }))), h = W(W({}, v), { result: g }), m.next(b);
          }
        } }));
      });
    }, e.prototype.readFragment = function(t, n) {
      var r = this;
      return n === void 0 && (n = !!t.optimistic), globalThis.__DEV__ !== !1 && Zt(t, "canonizeResults", "cache.readFragment"), En("canonizeResults", function() {
        return r.read(W(W({}, t), { query: r.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: n }));
      });
    }, e.prototype.writeQuery = function(t) {
      var n = t.id, r = t.data, i = Ki(t, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: n || "ROOT_QUERY",
        result: r
      }));
    }, e.prototype.writeFragment = function(t) {
      var n = t.id, r = t.data, i = t.fragment, o = t.fragmentName, a = Ki(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(a, {
        query: this.getFragmentDoc(i, o),
        dataId: n,
        result: r
      }));
    }, e.prototype.updateQuery = function(t, n) {
      return globalThis.__DEV__ !== !1 && Zt(t, "canonizeResults", "cache.updateQuery"), this.batch({
        update: function(r) {
          var i = En("canonizeResults", function() {
            return r.readQuery(t);
          }), o = n(i);
          return o == null ? i : (r.writeQuery(W(W({}, t), { data: o })), o);
        }
      });
    }, e.prototype.updateFragment = function(t, n) {
      return globalThis.__DEV__ !== !1 && Zt(t, "canonizeResults", "cache.updateFragment"), this.batch({
        update: function(r) {
          var i = En("canonizeResults", function() {
            return r.readFragment(t);
          }), o = n(i);
          return o == null ? i : (r.writeFragment(W(W({}, t), { data: o })), o);
        }
      });
    }, e;
  })()
);
globalThis.__DEV__ !== !1 && (jI.prototype.getMemoryInternals = tte);
var FI = (
  /** @class */
  (function(e) {
    ui(t, e);
    function t(n, r, i, o) {
      var a, s = e.call(this, n) || this;
      if (s.message = n, s.path = r, s.query = i, s.variables = o, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var l = s.path.length - 1; l >= 0; --l)
          s.missing = (a = {}, a[s.path[l]] = s.missing, a);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  })(Error)
), fn = Object.prototype.hasOwnProperty;
function Ul(e) {
  return e == null;
}
function zI(e, t) {
  var n = e.__typename, r = e.id, i = e._id;
  if (typeof n == "string" && (t && (t.keyObject = Ul(r) ? Ul(i) ? void 0 : { _id: i } : { id: r }), Ul(r) && !Ul(i) && (r = i), !Ul(r)))
    return "".concat(n, ":").concat(typeof r == "number" || typeof r == "string" ? r : JSON.stringify(r));
}
var LI = {
  dataIdFromObject: zI,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function Bne(e) {
  return Xs(LI, e);
}
function VI(e) {
  var t = e.canonizeResults;
  return t === void 0 ? LI.canonizeResults : t;
}
function Kne(e, t) {
  return dt(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var BI = /^[_a-z][_0-9a-z]*/i;
function Ro(e) {
  var t = e.match(BI);
  return t ? t[0] : e;
}
function fy(e, t, n) {
  return Mt(t) ? qt(t) ? t.every(function(r) {
    return fy(e, r, n);
  }) : e.selections.every(function(r) {
    if (Co(r) && xc(r, n)) {
      var i = Ji(r);
      return fn.call(t, i) && (!r.selectionSet || fy(r.selectionSet, t[i], n));
    }
    return !0;
  }) : !1;
}
function bs(e) {
  return Mt(e) && !dt(e) && !qt(e);
}
function Une() {
  return new Mo();
}
function KI(e, t) {
  var n = $l(Ol(e));
  return {
    fragmentMap: n,
    lookupFragment: function(r) {
      var i = n[r];
      return !i && t && (i = t.lookup(r)), i || null;
    }
  };
}
var zf = /* @__PURE__ */ Object.create(null), zm = function() {
  return zf;
}, E2 = /* @__PURE__ */ Object.create(null), Zu = (
  /** @class */
  (function() {
    function e(t, n) {
      var r = this;
      this.policies = t, this.group = n, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, o) {
        return Bd(dt(i) ? r.get(i.__ref, o) : i && i[o]);
      }, this.canRead = function(i) {
        return dt(i) ? r.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, o) {
        if (typeof i == "string")
          return ks(i);
        if (dt(i))
          return i;
        var a = r.policies.identify(i)[0];
        if (a) {
          var s = ks(a);
          return o && r.merge(a, i), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return W({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, n) {
      if (this.group.depend(t, n), fn.call(this.data, t)) {
        var r = this.data[t];
        if (r && fn.call(r, n))
          return r[n];
      }
      if (n === "__typename" && fn.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof ao)
        return this.parent.get(t, n);
    }, e.prototype.lookup = function(t, n) {
      if (n && this.group.depend(t, "__exists"), fn.call(this.data, t))
        return this.data[t];
      if (this instanceof ao)
        return this.parent.lookup(t, n);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, n) {
      var r = this, i;
      dt(t) && (t = t.__ref), dt(n) && (n = n.__ref);
      var o = typeof t == "string" ? this.lookup(i = t) : t, a = typeof n == "string" ? this.lookup(i = n) : n;
      if (a) {
        Se(typeof i == "string", 2);
        var s = new Mo(Hne).merge(o, a);
        if (this.data[i] = s, s !== o && (delete this.refs[i], this.group.caching)) {
          var l = /* @__PURE__ */ Object.create(null);
          o || (l.__exists = 1), Object.keys(a).forEach(function(u) {
            if (!o || o[u] !== s[u]) {
              l[u] = 1;
              var c = Ro(u);
              c !== u && !r.policies.hasKeyArgs(s.__typename, c) && (l[c] = 1), s[u] === void 0 && !(r instanceof ao) && delete s[u];
            }
          }), l.__typename && !(o && o.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === s.__typename && delete l.__typename, Object.keys(l).forEach(function(u) {
            return r.group.dirty(i, u);
          });
        }
      }
    }, e.prototype.modify = function(t, n) {
      var r = this, i = this.lookup(t);
      if (i) {
        var o = /* @__PURE__ */ Object.create(null), a = !1, s = !0, l = {
          DELETE: zf,
          INVALIDATE: E2,
          isReference: dt,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(u, c) {
            return r.policies.readField(typeof u == "string" ? {
              fieldName: u,
              from: c || ks(t)
            } : u, { store: r });
          }
        };
        if (Object.keys(i).forEach(function(u) {
          var c = Ro(u), f = i[u];
          if (f !== void 0) {
            var d = typeof n == "function" ? n : n[u] || n[c];
            if (d) {
              var p = d === zm ? zf : d(Bd(f), W(W({}, l), { fieldName: c, storeFieldName: u, storage: r.getStorage(t, u) }));
              if (p === E2)
                r.group.dirty(t, u);
              else if (p === zf && (p = void 0), p !== f && (o[u] = p, a = !0, f = p, globalThis.__DEV__ !== !1)) {
                var h = function(S) {
                  if (r.lookup(S.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && Se.warn(3, S), !0;
                };
                if (dt(p))
                  h(p);
                else if (Array.isArray(p))
                  for (var m = !1, v = void 0, g = 0, b = p; g < b.length; g++) {
                    var E = b[g];
                    if (dt(E)) {
                      if (m = !0, h(E))
                        break;
                    } else if (typeof E == "object" && E) {
                      var x = r.policies.identify(E)[0];
                      x && (v = E);
                    }
                    if (m && v !== void 0) {
                      globalThis.__DEV__ !== !1 && Se.warn(4, v);
                      break;
                    }
                  }
              }
            }
            f !== void 0 && (s = !1);
          }
        }), a)
          return this.merge(t, o), s && (this instanceof ao ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, n, r) {
      var i, o = this.lookup(t);
      if (o) {
        var a = this.getFieldValue(o, "__typename"), s = n && r ? this.policies.getStoreFieldName({ typename: a, fieldName: n, args: r }) : n;
        return this.modify(t, s ? (i = {}, i[s] = zm, i) : zm);
      }
      return !1;
    }, e.prototype.evict = function(t, n) {
      var r = !1;
      return t.id && (fn.call(this.data, t.id) && (r = this.delete(t.id, t.fieldName, t.args)), this instanceof ao && this !== n && (r = this.parent.evict(t, n) || r), (t.fieldName || r) && this.group.dirty(t.id, t.fieldName || "__exists")), r;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, n = this.toObject(), r = [];
      return this.getRootIdSet().forEach(function(i) {
        fn.call(t.policies.rootTypenamesById, i) || r.push(i);
      }), r.length && (n.__META = { extraRootIds: r.sort() }), n;
    }, e.prototype.replace = function(t) {
      var n = this;
      if (Object.keys(this.data).forEach(function(o) {
        t && fn.call(t, o) || n.delete(o);
      }), t) {
        var r = t.__META, i = Ki(t, ["__META"]);
        Object.keys(i).forEach(function(o) {
          n.merge(o, i[o]);
        }), r && r.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var n = --this.rootIds[t];
        return n || delete this.rootIds[t], n;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof ao ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, n = this.getRootIdSet(), r = this.toObject();
      n.forEach(function(a) {
        fn.call(r, a) && (Object.keys(t.findChildRefIds(a)).forEach(n.add, n), delete r[a]);
      });
      var i = Object.keys(r);
      if (i.length) {
        for (var o = this; o instanceof ao; )
          o = o.parent;
        i.forEach(function(a) {
          return o.delete(a);
        });
      }
      return i;
    }, e.prototype.findChildRefIds = function(t) {
      if (!fn.call(this.refs, t)) {
        var n = this.refs[t] = /* @__PURE__ */ Object.create(null), r = this.data[t];
        if (!r)
          return n;
        var i = /* @__PURE__ */ new Set([r]);
        i.forEach(function(o) {
          dt(o) && (n[o.__ref] = !0), Mt(o) && Object.keys(o).forEach(function(a) {
            var s = o[a];
            Mt(s) && i.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  })()
), UI = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = null), this.caching = t, this.parent = n, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? gI() : null, this.keyMaker = new to(Ha);
    }, e.prototype.depend = function(t, n) {
      if (this.d) {
        this.d(Lm(t, n));
        var r = Ro(n);
        r !== n && this.d(Lm(t, r)), this.parent && this.parent.depend(t, n);
      }
    }, e.prototype.dirty = function(t, n) {
      this.d && this.d.dirty(
        Lm(t, n),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        n === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  })()
);
function Lm(e, t) {
  return t + "#" + e;
}
function S2(e, t) {
  yu(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    (function(n) {
      ui(r, n);
      function r(i) {
        var o = i.policies, a = i.resultCaching, s = a === void 0 ? !0 : a, l = i.seed, u = n.call(this, o, new UI(s)) || this;
        return u.stump = new qne(u), u.storageTrie = new to(Ha), l && u.replace(l), u;
      }
      return r.prototype.addLayer = function(i, o) {
        return this.stump.addLayer(i, o);
      }, r.prototype.removeLayer = function() {
        return this;
      }, r.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, r;
    })(e)
  );
  e.Root = t;
})(Zu || (Zu = {}));
var ao = (
  /** @class */
  (function(e) {
    ui(t, e);
    function t(n, r, i, o) {
      var a = e.call(this, r.policies, o) || this;
      return a.id = n, a.parent = r, a.replay = i, a.group = o, i(a), a;
    }
    return t.prototype.addLayer = function(n, r) {
      return new t(n, this, r, this.group);
    }, t.prototype.removeLayer = function(n) {
      var r = this, i = this.parent.removeLayer(n);
      return n === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(o) {
        var a = r.data[o], s = i.lookup(o);
        s ? a ? a !== s && Object.keys(a).forEach(function(l) {
          wt(a[l], s[l]) || r.group.dirty(o, l);
        }) : (r.group.dirty(o, "__exists"), Object.keys(s).forEach(function(l) {
          r.group.dirty(o, l);
        })) : r.delete(o);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return W(W({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(n) {
      var r = this.parent.findChildRefIds(n);
      return fn.call(this.data, n) ? W(W({}, r), e.prototype.findChildRefIds.call(this, n)) : r;
    }, t.prototype.getStorage = function() {
      for (var n = this.parent; n.parent; )
        n = n.parent;
      return n.getStorage.apply(
        n,
        // @ts-expect-error
        arguments
      );
    }, t;
  })(Zu)
), qne = (
  /** @class */
  (function(e) {
    ui(t, e);
    function t(n) {
      return e.call(this, "EntityStore.Stump", n, function() {
      }, new UI(n.group.caching, n.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(n, r) {
      return this.parent.merge(n, r);
    }, t;
  })(ao)
);
function Hne(e, t, n) {
  var r = e[n], i = t[n];
  return wt(r, i) ? r : i;
}
function yu(e) {
  return !!(e instanceof Zu && e.group.caching);
}
function Wne(e) {
  return Mt(e) ? qt(e) ? e.slice(0) : W({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var $2 = (
  /** @class */
  (function() {
    function e() {
      this.known = new (X0 ? WeakSet : Set)(), this.pool = new to(Ha), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return Mt(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (Mt(t)) {
        var n = Wne(t);
        return this.passes.set(n, t), n;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var n = this;
      if (Mt(t)) {
        var r = this.passes.get(t);
        if (r)
          return r;
        var i = Object.getPrototypeOf(t);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var o = t.map(this.admit, this), a = this.pool.lookupArray(o);
            return a.array || (this.known.add(a.array = o), globalThis.__DEV__ !== !1 && Object.freeze(o)), a.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), l = [s], u = this.sortedKeys(t);
            l.push(u.json);
            var c = l.length;
            u.sorted.forEach(function(p) {
              l.push(n.admit(t[p]));
            });
            var a = this.pool.lookupArray(l);
            if (!a.object) {
              var f = a.object = Object.create(s);
              this.known.add(f), u.sorted.forEach(function(p, h) {
                f[p] = l[c + h];
              }), globalThis.__DEV__ !== !1 && Object.freeze(f);
            }
            return a.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var n = Object.keys(t), r = this.pool.lookupArray(n);
      if (!r.keys) {
        n.sort();
        var i = JSON.stringify(n);
        (r.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, r.keys = { sorted: n, json: i });
      }
      return r.keys;
    }, e;
  })()
);
function T2(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var Zne = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      this.knownResults = new (Ha ? WeakMap : Map)(), this.config = Xs(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: VI(t)
      }), this.canon = t.canon || new $2(), this.executeSelectionSet = Wu(function(r) {
        var i, o = r.context.canonizeResults, a = T2(r);
        a[3] = !o;
        var s = (i = n.executeSelectionSet).peek.apply(i, a);
        return s ? o ? W(W({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: n.canon.admit(s.result)
        }) : s : (S2(r.context.store, r.enclosingRef.__ref), n.execSelectionSetImpl(r));
      }, {
        max: this.config.resultCacheMaxSize || Qi["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: T2,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(r, i, o, a) {
          if (yu(o.store))
            return o.store.makeCacheKey(r, dt(i) ? i.__ref : i, o.varString, a);
        }
      }), this.executeSubSelectedArray = Wu(function(r) {
        return S2(r.context.store, r.enclosingRef.__ref), n.execSubSelectedArrayImpl(r);
      }, {
        max: this.config.resultCacheMaxSize || Qi["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(r) {
          var i = r.field, o = r.array, a = r.context;
          if (yu(a.store))
            return a.store.makeCacheKey(i, o, a.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new $2();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var n = t.store, r = t.query, i = t.rootId, o = i === void 0 ? "ROOT_QUERY" : i, a = t.variables, s = t.returnPartialData, l = s === void 0 ? !0 : s, u = t.canonizeResults, c = u === void 0 ? this.config.canonizeResults : u, f = this.config.cache.policies;
      a = W(W({}, e1(oI(r))), a);
      var d = ks(o), p = this.executeSelectionSet({
        selectionSet: Ec(r).selectionSet,
        objectOrReference: d,
        enclosingRef: d,
        context: W({ store: n, query: r, policies: f, variables: a, varString: wo(a), canonizeResults: c }, KI(r, this.config.fragments))
      }), h;
      if (p.missing && (h = [
        new FI(Gne(p.missing), p.missing, r, a)
      ], !l))
        throw h[0];
      return {
        result: p.result,
        complete: !h,
        missing: h
      };
    }, e.prototype.isFresh = function(t, n, r, i) {
      if (yu(i.store) && this.knownResults.get(t) === r) {
        var o = this.executeSelectionSet.peek(
          r,
          n,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (o && t === o.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var n = this, r = t.selectionSet, i = t.objectOrReference, o = t.enclosingRef, a = t.context;
      if (dt(i) && !a.policies.rootTypenamesById[i.__ref] && !a.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var s = a.variables, l = a.policies, u = a.store, c = u.getFieldValue(i, "__typename"), f = [], d, p = new Mo();
      this.config.addTypename && typeof c == "string" && !l.rootIdsByTypename[c] && f.push({ __typename: c });
      function h(E, x) {
        var S;
        return E.missing && (d = p.merge(d, (S = {}, S[x] = E.missing, S))), E.result;
      }
      var m = new Set(r.selections);
      m.forEach(function(E) {
        var x, S;
        if (xc(E, s))
          if (Co(E)) {
            var $ = l.readField({
              fieldName: E.name.value,
              field: E,
              variables: a.variables,
              from: i
            }, a), P = Ji(E);
            $ === void 0 ? i1.added(E) || (d = p.merge(d, (x = {}, x[P] = "Can't find field '".concat(E.name.value, "' on ").concat(dt(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), x))) : qt($) ? $.length > 0 && ($ = h(n.executeSubSelectedArray({
              field: E,
              array: $,
              enclosingRef: o,
              context: a
            }), P)) : E.selectionSet ? $ != null && ($ = h(n.executeSelectionSet({
              selectionSet: E.selectionSet,
              objectOrReference: $,
              enclosingRef: dt($) ? $ : o,
              context: a
            }), P)) : a.canonizeResults && ($ = n.canon.pass($)), $ !== void 0 && f.push((S = {}, S[P] = $, S));
          } else {
            var y = Xp(E, a.lookupFragment);
            if (!y && E.kind === Bt.FRAGMENT_SPREAD)
              throw Ln(10, E.name.value);
            y && l.fragmentMatches(y, c) && y.selectionSet.selections.forEach(m.add, m);
          }
      });
      var v = rh(f), g = { result: v, missing: d }, b = a.canonizeResults ? this.canon.admit(g) : Bd(g);
      return b.result && this.knownResults.set(b.result, r), b;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var n = this, r = t.field, i = t.array, o = t.enclosingRef, a = t.context, s, l = new Mo();
      function u(c, f) {
        var d;
        return c.missing && (s = l.merge(s, (d = {}, d[f] = c.missing, d))), c.result;
      }
      return r.selectionSet && (i = i.filter(a.store.canRead)), i = i.map(function(c, f) {
        return c === null ? null : qt(c) ? u(n.executeSubSelectedArray({
          field: r,
          array: c,
          enclosingRef: o,
          context: a
        }), f) : r.selectionSet ? u(n.executeSelectionSet({
          selectionSet: r.selectionSet,
          objectOrReference: c,
          enclosingRef: dt(c) ? c : o,
          context: a
        }), f) : (globalThis.__DEV__ !== !1 && Yne(a.store, r, c), c);
      }), {
        result: a.canonizeResults ? this.canon.admit(i) : i,
        missing: s
      };
    }, e;
  })()
);
function Gne(e) {
  try {
    JSON.stringify(e, function(t, n) {
      if (typeof n == "string")
        throw n;
      return n;
    });
  } catch (t) {
    return t;
  }
}
function Yne(e, t, n) {
  if (!t.selectionSet) {
    var r = /* @__PURE__ */ new Set([n]);
    r.forEach(function(i) {
      Mt(i) && (Se(
        !dt(i),
        11,
        Kne(e, i),
        t.name.value
      ), Object.values(i).forEach(r.add, r));
    });
  }
}
var f1 = new kl(), O2 = /* @__PURE__ */ new WeakMap();
function bu(e) {
  var t = O2.get(e);
  return t || O2.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: gI()
  }), t;
}
function k2(e) {
  bu(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function Qne(e) {
  bu(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function Jne(e) {
  var t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = function(o) {
    if (arguments.length > 0) {
      if (e !== o) {
        e = o, t.forEach(function(l) {
          bu(l).dep.dirty(r), Xne(l);
        });
        var a = Array.from(n);
        n.clear(), a.forEach(function(l) {
          return l(e);
        });
      }
    } else {
      var s = f1.getValue();
      s && (i(s), bu(s).dep(r));
    }
    return e;
  };
  r.onNextChange = function(o) {
    return n.add(o), function() {
      n.delete(o);
    };
  };
  var i = r.attachCache = function(o) {
    return t.add(o), bu(o).vars.add(r), r;
  };
  return r.forgetCache = function(o) {
    return t.delete(o);
  }, r;
}
function Xne(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var P2 = /* @__PURE__ */ Object.create(null);
function d1(e) {
  var t = JSON.stringify(e);
  return P2[t] || (P2[t] = /* @__PURE__ */ Object.create(null));
}
function D2(e) {
  var t = d1(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(n, r) {
    var i = function(a, s) {
      return r.readField(s, a);
    }, o = r.keyObject = p1(e, function(a) {
      var s = Ds(
        r.storeObject,
        a,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return s === void 0 && n !== r.storeObject && fn.call(n, a[0]) && (s = Ds(n, a, HI)), Se(s !== void 0, 5, a.join("."), n), s;
    });
    return "".concat(r.typename, ":").concat(JSON.stringify(o));
  });
}
function A2(e) {
  var t = d1(e);
  return t.keyArgsFn || (t.keyArgsFn = function(n, r) {
    var i = r.field, o = r.variables, a = r.fieldName, s = p1(e, function(u) {
      var c = u[0], f = c.charAt(0);
      if (f === "@") {
        if (i && Di(i.directives)) {
          var d = c.slice(1), p = i.directives.find(function(g) {
            return g.name.value === d;
          }), h = p && eh(p, o);
          return h && Ds(
            h,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            u.slice(1)
          );
        }
        return;
      }
      if (f === "$") {
        var m = c.slice(1);
        if (o && fn.call(o, m)) {
          var v = u.slice(0);
          return v[0] = m, Ds(o, v);
        }
        return;
      }
      if (n)
        return Ds(n, u);
    }), l = JSON.stringify(s);
    return (n || l !== "{}") && (a += ":" + l), a;
  });
}
function p1(e, t) {
  var n = new Mo();
  return qI(e).reduce(function(r, i) {
    var o, a = t(i);
    if (a !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        a = (o = {}, o[i[s]] = a, o);
      r = n.merge(r, a);
    }
    return r;
  }, /* @__PURE__ */ Object.create(null));
}
function qI(e) {
  var t = d1(e);
  if (!t.paths) {
    var n = t.paths = [], r = [];
    e.forEach(function(i, o) {
      qt(i) ? (qI(i).forEach(function(a) {
        return n.push(r.concat(a));
      }), r.length = 0) : (r.push(i), qt(e[o + 1]) || (n.push(r.slice(0)), r.length = 0));
    });
  }
  return t.paths;
}
function HI(e, t) {
  return e[t];
}
function Ds(e, t, n) {
  return n = n || HI, WI(t.reduce(function r(i, o) {
    return qt(i) ? i.map(function(a) {
      return r(a, o);
    }) : i && n(i, o);
  }, e));
}
function WI(e) {
  return Mt(e) ? qt(e) ? e.map(WI) : p1(Object.keys(e).sort(), function(t) {
    return Ds(e, t);
  }) : e;
}
function dy(e) {
  return e.args !== void 0 ? e.args : e.field ? eh(e.field, e.variables) : null;
}
var ere = function() {
}, C2 = function(e, t) {
  return t.fieldName;
}, I2 = function(e, t, n) {
  var r = n.mergeObjects;
  return r(e, t);
}, M2 = function(e, t) {
  return t;
}, tre = (
  /** @class */
  (function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = W({ dataIdFromObject: zI }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, n) {
      var r, i = this, o = n && (n.typename || ((r = n.storeObject) === null || r === void 0 ? void 0 : r.__typename)) || t.__typename;
      if (o === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var a = n && n.storeObject || t, s = W(W({}, n), { typename: o, storeObject: a, readField: n && n.readField || function() {
        var f = h1(arguments, a);
        return i.readField(f, {
          store: i.cache.data,
          variables: f.variables
        });
      } }), l, u = o && this.getTypePolicy(o), c = u && u.keyFn || this.config.dataIdFromObject;
      return c1.withValue(!0, function() {
        for (; c; ) {
          var f = c(W(W({}, t), a), s);
          if (qt(f))
            c = D2(f);
          else {
            l = f;
            break;
          }
        }
      }), l = l ? String(l) : void 0, s.keyObject ? [l, s.keyObject] : [l];
    }, e.prototype.addTypePolicies = function(t) {
      var n = this;
      Object.keys(t).forEach(function(r) {
        var i = t[r], o = i.queryType, a = i.mutationType, s = i.subscriptionType, l = Ki(i, ["queryType", "mutationType", "subscriptionType"]);
        o && n.setRootTypename("Query", r), a && n.setRootTypename("Mutation", r), s && n.setRootTypename("Subscription", r), fn.call(n.toBeAdded, r) ? n.toBeAdded[r].push(l) : n.toBeAdded[r] = [l];
      });
    }, e.prototype.updateTypePolicy = function(t, n, r) {
      var i = this.getTypePolicy(t), o = n.keyFields, a = n.fields;
      function s(l, u) {
        l.merge = typeof u == "function" ? u : u === !0 ? I2 : u === !1 ? M2 : l.merge;
      }
      s(i, n.merge), i.keyFn = // Pass false to disable normalization for this typename.
      o === !1 ? ere : qt(o) ? D2(o) : typeof o == "function" ? o : i.keyFn, a && Object.keys(a).forEach(function(l) {
        var u = r[l];
        (!u || u?.typename !== t) && (u = r[l] = { typename: t });
        var c = a[l];
        if (typeof c == "function")
          u.read = c;
        else {
          var f = c.keyArgs, d = c.read, p = c.merge;
          u.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          f === !1 ? C2 : qt(f) ? A2(f) : typeof f == "function" ? f : u.keyFn, typeof d == "function" && (u.read = d), s(u, p);
        }
        u.read && u.merge && (u.keyFn = u.keyFn || C2);
      });
    }, e.prototype.setRootTypename = function(t, n) {
      n === void 0 && (n = t);
      var r = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[r];
      n !== i && (Se(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[n] = r, this.rootTypenamesById[r] = n);
    }, e.prototype.addPossibleTypes = function(t) {
      var n = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(r) {
        n.getSupertypeSet(r, !0), t[r].forEach(function(i) {
          n.getSupertypeSet(i, !0).add(r);
          var o = i.match(BI);
          (!o || o[0] !== i) && n.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var n = this;
      if (!fn.call(this.typePolicies, t)) {
        var r = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        r.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(t);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(a, s) {
          if (a.test(t)) {
            var l = n.supertypeMap.get(s);
            l && l.forEach(function(u) {
              return i.add(u);
            });
          }
        })), i && i.size && i.forEach(function(a) {
          var s = n.getTypePolicy(a), l = s.fields, u = Ki(s, ["fields"]);
          Object.assign(r, u), Object.assign(r.fields, l);
        });
      }
      var o = this.toBeAdded[t];
      return o && o.length && o.splice(0).forEach(function(a) {
        n.updateTypePolicy(t, a, n.typePolicies[t].fields);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, n) {
      if (t)
        return this.getTypePolicy(t).fields[n];
    }, e.prototype.getSupertypeSet = function(t, n) {
      var r = this.supertypeMap.get(t);
      return !r && n && this.supertypeMap.set(t, r = /* @__PURE__ */ new Set()), r;
    }, e.prototype.fragmentMatches = function(t, n, r, i) {
      var o = this;
      if (!t.typeCondition)
        return !0;
      if (!n)
        return !1;
      var a = t.typeCondition.name.value;
      if (n === a)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(a))
        for (var s = this.getSupertypeSet(n, !0), l = [s], u = function(h) {
          var m = o.getSupertypeSet(h, !1);
          m && m.size && l.indexOf(m) < 0 && l.push(m);
        }, c = !!(r && this.fuzzySubtypes.size), f = !1, d = 0; d < l.length; ++d) {
          var p = l[d];
          if (p.has(a))
            return s.has(a) || (f && globalThis.__DEV__ !== !1 && Se.warn(7, n, a), s.add(a)), !0;
          p.forEach(u), c && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          d === l.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          fy(t.selectionSet, r, i) && (c = !1, f = !0, this.fuzzySubtypes.forEach(function(h, m) {
            var v = n.match(h);
            v && v[0] === n && u(m);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, n) {
      var r = this.getFieldPolicy(t, n);
      return !!(r && r.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var n = t.typename, r = t.fieldName, i = this.getFieldPolicy(n, r), o, a = i && i.keyFn;
      if (a && n)
        for (var s = {
          typename: n,
          fieldName: r,
          field: t.field || null,
          variables: t.variables
        }, l = dy(t); a; ) {
          var u = a(l, s);
          if (qt(u))
            a = A2(u);
          else {
            o = u || r;
            break;
          }
        }
      return o === void 0 && (o = t.field ? yte(t.field, t.variables) : iI(r, dy(t))), o === !1 ? r : r === Ro(o) ? o : r + ":" + o;
    }, e.prototype.readField = function(t, n) {
      var r = t.from;
      if (r) {
        var i = t.field || t.fieldName;
        if (i) {
          if (t.typename === void 0) {
            var o = n.store.getFieldValue(r, "__typename");
            o && (t.typename = o);
          }
          var a = this.getStoreFieldName(t), s = Ro(a), l = n.store.getFieldValue(r, a), u = this.getFieldPolicy(t.typename, s), c = u && u.read;
          if (c) {
            var f = R2(this, r, t, n, n.store.getStorage(dt(r) ? r.__ref : r, a));
            return f1.withValue(this.cache, c, [
              l,
              f
            ]);
          }
          return l;
        }
      }
    }, e.prototype.getReadFunction = function(t, n) {
      var r = this.getFieldPolicy(t, n);
      return r && r.read;
    }, e.prototype.getMergeFunction = function(t, n, r) {
      var i = this.getFieldPolicy(t, n), o = i && i.merge;
      return !o && r && (i = this.getTypePolicy(r), o = i && i.merge), o;
    }, e.prototype.runMergeFunction = function(t, n, r, i, o) {
      var a = r.field, s = r.typename, l = r.merge;
      return l === I2 ? ZI(i.store)(t, n) : l === M2 ? n : (i.overwrite && (t = void 0), l(t, n, R2(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: a.name.value,
          field: a,
          variables: i.variables
        },
        i,
        o || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  })()
);
function R2(e, t, n, r, i) {
  var o = e.getStoreFieldName(n), a = Ro(o), s = n.variables || r.variables, l = r.store, u = l.toReference, c = l.canRead;
  return {
    args: dy(n),
    field: n.field || null,
    fieldName: a,
    storeFieldName: o,
    variables: s,
    isReference: dt,
    toReference: u,
    storage: i,
    cache: e.cache,
    canRead: c,
    readField: function() {
      return e.readField(h1(arguments, t, s), r);
    },
    mergeObjects: ZI(r.store)
  };
}
function h1(e, t, n) {
  var r = e[0], i = e[1], o = e.length, a;
  return typeof r == "string" ? a = {
    fieldName: r,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: o > 1 ? i : t
  } : (a = W({}, r), fn.call(a, "from") || (a.from = t)), globalThis.__DEV__ !== !1 && a.from === void 0 && globalThis.__DEV__ !== !1 && Se.warn(8, WC(Array.from(e))), a.variables === void 0 && (a.variables = n), a;
}
function ZI(e) {
  return function(t, n) {
    if (qt(t) || qt(n))
      throw Ln(9);
    if (Mt(t) && Mt(n)) {
      var r = e.getFieldValue(t, "__typename"), i = e.getFieldValue(n, "__typename"), o = r && i && r !== i;
      if (o)
        return n;
      if (dt(t) && bs(n))
        return e.merge(t.__ref, n), t;
      if (bs(t) && dt(n))
        return e.merge(t, n.__ref), n;
      if (bs(t) && bs(n))
        return W(W({}, t), n);
    }
    return n;
  };
}
function Vm(e, t, n) {
  var r = "".concat(t).concat(n), i = e.flavors.get(r);
  return i || e.flavors.set(r, i = e.clientOnly === t && e.deferred === n ? e : W(W({}, e), { clientOnly: t, deferred: n })), i;
}
var nre = (
  /** @class */
  (function() {
    function e(t, n, r) {
      this.cache = t, this.reader = n, this.fragments = r;
    }
    return e.prototype.writeToStore = function(t, n) {
      var r = this, i = n.query, o = n.result, a = n.dataId, s = n.variables, l = n.overwrite, u = Da(i), c = Une();
      s = W(W({}, e1(u)), s);
      var f = W(W({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(p, h) {
        return c.merge(p, h);
      }, variables: s, varString: wo(s) }, KI(i, this.fragments)), { overwrite: !!l, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), d = this.processSelectionSet({
        result: o || /* @__PURE__ */ Object.create(null),
        dataId: a,
        selectionSet: u.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: f
      });
      if (!dt(d))
        throw Ln(12, o);
      return f.incomingById.forEach(function(p, h) {
        var m = p.storeObject, v = p.mergeTree, g = p.fieldNodeSet, b = ks(h);
        if (v && v.map.size) {
          var E = r.applyMerges(v, b, m, f);
          if (dt(E))
            return;
          m = E;
        }
        if (globalThis.__DEV__ !== !1 && !f.overwrite) {
          var x = /* @__PURE__ */ Object.create(null);
          g.forEach(function(P) {
            P.selectionSet && (x[P.name.value] = !0);
          });
          var S = function(P) {
            return x[Ro(P)] === !0;
          }, $ = function(P) {
            var y = v && v.map.get(P);
            return !!(y && y.info && y.info.merge);
          };
          Object.keys(m).forEach(function(P) {
            S(P) && !$(P) && rre(b, m, P, f.store);
          });
        }
        t.merge(h, m);
      }), t.retain(d.__ref), d;
    }, e.prototype.processSelectionSet = function(t) {
      var n = this, r = t.dataId, i = t.result, o = t.selectionSet, a = t.context, s = t.mergeTree, l = this.cache.policies, u = /* @__PURE__ */ Object.create(null), c = r && l.rootTypenamesById[r] || ey(i, o, a.fragmentMap) || r && a.store.get(r, "__typename");
      typeof c == "string" && (u.__typename = c);
      var f = function() {
        var E = h1(arguments, u, a.variables);
        if (dt(E.from)) {
          var x = a.incomingById.get(E.from.__ref);
          if (x) {
            var S = l.readField(W(W({}, E), { from: x.storeObject }), a);
            if (S !== void 0)
              return S;
          }
        }
        return l.readField(E, a);
      }, d = /* @__PURE__ */ new Set();
      this.flattenFields(
        o,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        a,
        c
      ).forEach(function(E, x) {
        var S, $ = Ji(x), P = i[$];
        if (d.add(x), P !== void 0) {
          var y = l.getStoreFieldName({
            typename: c,
            fieldName: x.name.value,
            field: x,
            variables: E.variables
          }), _ = N2(s, y), w = n.processFieldValue(
            P,
            x,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            x.selectionSet ? Vm(E, !1, !1) : E,
            _
          ), A = void 0;
          x.selectionSet && (dt(w) || bs(w)) && (A = f("__typename", w));
          var k = l.getMergeFunction(c, x.name.value, A);
          k ? _.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: x,
            typename: c,
            merge: k
          } : j2(s, y), u = E.merge(u, (S = {}, S[y] = w, S));
        } else globalThis.__DEV__ !== !1 && !E.clientOnly && !E.deferred && !i1.added(x) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !l.getReadFunction(c, x.name.value) && globalThis.__DEV__ !== !1 && Se.error(13, Ji(x), i);
      });
      try {
        var p = l.identify(i, {
          typename: c,
          selectionSet: o,
          fragmentMap: a.fragmentMap,
          storeObject: u,
          readField: f
        }), h = p[0], m = p[1];
        r = r || h, m && (u = a.merge(u, m));
      } catch (E) {
        if (!r)
          throw E;
      }
      if (typeof r == "string") {
        var v = ks(r), g = a.written[r] || (a.written[r] = []);
        if (g.indexOf(o) >= 0 || (g.push(o), this.reader && this.reader.isFresh(i, v, o, a)))
          return v;
        var b = a.incomingById.get(r);
        return b ? (b.storeObject = a.merge(b.storeObject, u), b.mergeTree = py(b.mergeTree, s), d.forEach(function(E) {
          return b.fieldNodeSet.add(E);
        })) : a.incomingById.set(r, {
          storeObject: u,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: Kd(s) ? void 0 : s,
          fieldNodeSet: d
        }), v;
      }
      return u;
    }, e.prototype.processFieldValue = function(t, n, r, i) {
      var o = this;
      return !n.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? $I(t) : t : qt(t) ? t.map(function(a, s) {
        var l = o.processFieldValue(a, n, r, N2(i, s));
        return j2(i, s), l;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: n.selectionSet,
        context: r,
        mergeTree: i
      });
    }, e.prototype.flattenFields = function(t, n, r, i) {
      i === void 0 && (i = ey(n, t, r.fragmentMap));
      var o = /* @__PURE__ */ new Map(), a = this.cache.policies, s = new to(!1);
      return (function l(u, c) {
        var f = s.lookup(
          u,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          c.clientOnly,
          c.deferred
        );
        f.visited || (f.visited = !0, u.selections.forEach(function(d) {
          if (xc(d, r.variables)) {
            var p = c.clientOnly, h = c.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(p && h) && Di(d.directives) && d.directives.forEach(function(g) {
                var b = g.name.value;
                if (b === "client" && (p = !0), b === "defer") {
                  var E = eh(g, r.variables);
                  (!E || E.if !== !1) && (h = !0);
                }
              }), Co(d)
            ) {
              var m = o.get(d);
              m && (p = p && m.clientOnly, h = h && m.deferred), o.set(d, Vm(r, p, h));
            } else {
              var v = Xp(d, r.lookupFragment);
              if (!v && d.kind === Bt.FRAGMENT_SPREAD)
                throw Ln(14, d.name.value);
              v && a.fragmentMatches(v, i, n, r.variables) && l(v.selectionSet, Vm(r, p, h));
            }
          }
        }));
      })(t, r), o;
    }, e.prototype.applyMerges = function(t, n, r, i, o) {
      var a, s = this;
      if (t.map.size && !dt(r)) {
        var l = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !qt(r) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (dt(n) || bs(n)) ? n : void 0
        ), u = r;
        l && !o && (o = [dt(l) ? l.__ref : l]);
        var c, f = function(d, p) {
          return qt(d) ? typeof p == "number" ? d[p] : void 0 : i.store.getFieldValue(d, String(p));
        };
        t.map.forEach(function(d, p) {
          var h = f(l, p), m = f(u, p);
          if (m !== void 0) {
            o && o.push(p);
            var v = s.applyMerges(d, h, m, i, o);
            v !== m && (c = c || /* @__PURE__ */ new Map(), c.set(p, v)), o && Se(o.pop() === p);
          }
        }), c && (r = qt(u) ? u.slice(0) : W({}, u), c.forEach(function(d, p) {
          r[p] = d;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(n, r, t.info, i, o && (a = i.store).getStorage.apply(a, o)) : r;
    }, e;
  })()
), GI = [];
function N2(e, t) {
  var n = e.map;
  return n.has(t) || n.set(t, GI.pop() || { map: /* @__PURE__ */ new Map() }), n.get(t);
}
function py(e, t) {
  if (e === t || !t || Kd(t))
    return e;
  if (!e || Kd(e))
    return t;
  var n = e.info && t.info ? W(W({}, e.info), t.info) : e.info || t.info, r = e.map.size && t.map.size, i = r ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, o = { info: n, map: i };
  if (r) {
    var a = new Set(t.map.keys());
    e.map.forEach(function(s, l) {
      o.map.set(l, py(s, t.map.get(l))), a.delete(l);
    }), a.forEach(function(s) {
      o.map.set(s, py(t.map.get(s), e.map.get(s)));
    });
  }
  return o;
}
function Kd(e) {
  return !e || !(e.info || e.map.size);
}
function j2(e, t) {
  var n = e.map, r = n.get(t);
  r && Kd(r) && (GI.push(r), n.delete(t));
}
var F2 = /* @__PURE__ */ new Set();
function rre(e, t, n, r) {
  var i = function(f) {
    var d = r.getFieldValue(f, n);
    return typeof d == "object" && d;
  }, o = i(e);
  if (o) {
    var a = i(t);
    if (a && !dt(o) && !wt(o, a) && !Object.keys(o).every(function(f) {
      return r.getFieldValue(a, f) !== void 0;
    })) {
      var s = r.getFieldValue(e, "__typename") || r.getFieldValue(t, "__typename"), l = Ro(n), u = "".concat(s, ".").concat(l);
      if (!F2.has(u)) {
        F2.add(u);
        var c = [];
        !qt(o) && !qt(a) && [o, a].forEach(function(f) {
          var d = r.getFieldValue(f, "__typename");
          typeof d == "string" && !c.includes(d) && c.push(d);
        }), globalThis.__DEV__ !== !1 && Se.warn(15, l, s, c.length ? "either ensure all objects of type " + c.join(" and ") + " have an ID or a custom merge function, or " : "", u, W({}, o), W({}, a));
      }
    }
  }
}
var ire = (
  /** @class */
  (function(e) {
    ui(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this) || this;
      return r.watches = /* @__PURE__ */ new Set(), r.addTypenameTransform = new yI(i1), r.assumeImmutableResults = !0, r.makeVar = Jne, r.txCount = 0, globalThis.__DEV__ !== !1 && (Zt(n, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`."), Zt(n, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.")), r.config = Bne(n), r.addTypename = !!r.config.addTypename, r.policies = new tre({
        cache: r,
        dataIdFromObject: r.config.dataIdFromObject,
        possibleTypes: r.config.possibleTypes,
        typePolicies: r.config.typePolicies
      }), r.init(), r;
    }
    return t.prototype.init = function() {
      var n = this.data = new Zu.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = n.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(n) {
      var r = this, i = this.storeReader, o = this.config.fragments;
      this.addTypenameTransform.resetCache(), o?.resetCaches(), this.storeWriter = new nre(this, this.storeReader = new Zne({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: VI(this.config),
        canon: n ? void 0 : i && i.canon,
        fragments: o
      }), o), this.maybeBroadcastWatch = Wu(function(a, s) {
        return r.broadcastWatch(a, s);
      }, {
        max: this.config.resultCacheMaxSize || Qi["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(a) {
          var s = a.optimistic ? r.optimisticData : r.data;
          if (yu(s)) {
            var l = a.optimistic, u = a.id, c = a.variables;
            return s.makeCacheKey(
              a.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              a.callback,
              wo({ optimistic: l, id: u, variables: c })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(a) {
        return a.resetCaching();
      });
    }, t.prototype.restore = function(n) {
      return this.init(), n && this.data.replace(n), this;
    }, t.prototype.extract = function(n) {
      return n === void 0 && (n = !1), (n ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(n) {
      globalThis.__DEV__ !== !1 && Zt(n, "canonizeResults", "cache.read");
      var r = n.returnPartialData, i = r === void 0 ? !1 : r;
      try {
        return this.storeReader.diffQueryAgainstStore(W(W({}, n), { store: n.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (o) {
        if (o instanceof FI)
          return null;
        throw o;
      }
    }, t.prototype.write = function(n) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, n);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(n) {
      if (fn.call(n, "id") && !n.id)
        return !1;
      var r = n.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, r.modify(n.id || "ROOT_QUERY", n.fields);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(n) {
      return globalThis.__DEV__ !== !1 && Zt(n, "canonizeResults", "cache.diff"), this.storeReader.diffQueryAgainstStore(W(W({}, n), { store: n.optimistic ? this.optimisticData : this.data, rootId: n.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(n) {
      var r = this;
      return this.watches.size || Qne(this), this.watches.add(n), n.immediate && this.maybeBroadcastWatch(n), function() {
        r.watches.delete(n) && !r.watches.size && k2(r), r.maybeBroadcastWatch.forget(n);
      };
    }, t.prototype.gc = function(n) {
      globalThis.__DEV__ !== !1 && Zt(n || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option."), wo.reset(), bo.reset();
      var r = this.optimisticData.gc();
      return n && !this.txCount && (n.resetResultCache ? this.resetResultCache(n.resetResultIdentities) : n.resetResultIdentities && this.storeReader.resetCanon()), r;
    }, t.prototype.retain = function(n, r) {
      return (r ? this.optimisticData : this.data).retain(n);
    }, t.prototype.release = function(n, r) {
      return (r ? this.optimisticData : this.data).release(n);
    }, t.prototype.identify = function(n) {
      if (dt(n))
        return n.__ref;
      try {
        return this.policies.identify(n)[0];
      } catch (r) {
        globalThis.__DEV__ !== !1 && Se.warn(r);
      }
    }, t.prototype.evict = function(n) {
      if (!n.id) {
        if (fn.call(n, "id"))
          return !1;
        n = W(W({}, n), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(n, this.data);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(n) {
      var r = this;
      return this.init(), wo.reset(), n && n.discardWatches ? (this.watches.forEach(function(i) {
        return r.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), k2(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(n) {
      var r = this.optimisticData.removeLayer(n);
      r !== this.optimisticData && (this.optimisticData = r, this.broadcastWatches());
    }, t.prototype.batch = function(n) {
      var r = this, i = n.update, o = n.optimistic, a = o === void 0 ? !0 : o, s = n.removeOptimistic, l = n.onWatchUpdated, u, c = function(d) {
        var p = r, h = p.data, m = p.optimisticData;
        ++r.txCount, d && (r.data = r.optimisticData = d);
        try {
          return u = i(r);
        } finally {
          --r.txCount, r.data = h, r.optimisticData = m;
        }
      }, f = /* @__PURE__ */ new Set();
      return l && !this.txCount && this.broadcastWatches(W(W({}, n), { onWatchUpdated: function(d) {
        return f.add(d), !1;
      } })), typeof a == "string" ? this.optimisticData = this.optimisticData.addLayer(a, c) : a === !1 ? c(this.data) : c(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), l && f.size ? (this.broadcastWatches(W(W({}, n), { onWatchUpdated: function(d, p) {
        var h = l.call(this, d, p);
        return h !== !1 && f.delete(d), h;
      } })), f.size && f.forEach(function(d) {
        return r.maybeBroadcastWatch.dirty(d);
      })) : this.broadcastWatches(n), u;
    }, t.prototype.performTransaction = function(n, r) {
      return this.batch({
        update: n,
        optimistic: r || r !== null
      });
    }, t.prototype.transformDocument = function(n) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(n));
    }, t.prototype.fragmentMatches = function(n, r) {
      return this.policies.fragmentMatches(n, r);
    }, t.prototype.lookupFragment = function(n) {
      var r;
      return ((r = this.config.fragments) === null || r === void 0 ? void 0 : r.lookup(n)) || null;
    }, t.prototype.broadcastWatches = function(n) {
      var r = this;
      this.txCount || this.watches.forEach(function(i) {
        return r.maybeBroadcastWatch(i, n);
      });
    }, t.prototype.addFragmentsToDocument = function(n) {
      var r = this.config.fragments;
      return r ? r.transform(n) : n;
    }, t.prototype.addTypenameToDocument = function(n) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(n) : n;
    }, t.prototype.broadcastWatch = function(n, r) {
      var i = this, o = n.lastDiff, a = En("canonizeResults", function() {
        return i.diff(n);
      });
      r && (n.optimistic && typeof r.optimistic == "string" && (a.fromOptimisticTransaction = !0), r.onWatchUpdated && r.onWatchUpdated.call(this, n, a, o) === !1) || (!o || !wt(o.result, a.result)) && n.callback(n.lastDiff = a, o);
    }, t;
  })(jI)
);
globalThis.__DEV__ !== !1 && (ire.prototype.getMemoryInternals = ete);
var ft;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(ft || (ft = {}));
function _s(e) {
  return e ? e < 7 : !1;
}
var z2 = Object.assign, ore = Object.hasOwnProperty, Lf = (
  /** @class */
  (function(e) {
    ui(t, e);
    function t(n) {
      var r = n.queryManager, i = n.queryInfo, o = n.options, a = this, s = t.inactiveOnCreation.getValue();
      a = e.call(this, function(g) {
        a._getOrCreateQuery();
        try {
          var b = g._subscription._observer;
          b && !b.error && (b.error = are);
        } catch {
        }
        var E = !a.observers.size;
        a.observers.add(g);
        var x = a.last;
        return x && x.error ? g.error && g.error(x.error) : x && x.result && g.next && g.next(a.maskResult(x.result)), E && a.reobserve().catch(function() {
        }), function() {
          a.observers.delete(g) && !a.observers.size && a.tearDownQuery();
        };
      }) || this, a.observers = /* @__PURE__ */ new Set(), a.subscriptions = /* @__PURE__ */ new Set(), a.dirty = !1, a._getOrCreateQuery = function() {
        return s && (r.queries.set(a.queryId, i), s = !1), a.queryManager.getOrCreateQuery(a.queryId);
      }, a.queryInfo = i, a.queryManager = r, a.waitForOwnResult = Bm(o.fetchPolicy), a.isTornDown = !1, a.subscribeToMore = a.subscribeToMore.bind(a), a.maskResult = a.maskResult.bind(a);
      var l = r.defaultOptions.watchQuery, u = l === void 0 ? {} : l, c = u.fetchPolicy, f = c === void 0 ? "cache-first" : c, d = o.fetchPolicy, p = d === void 0 ? f : d, h = o.initialFetchPolicy, m = h === void 0 ? p === "standby" ? f : p : h;
      a.options = W(W({}, o), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: m,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: p
      }), a.queryId = i.queryId || r.generateQueryId();
      var v = Da(a.query);
      return a.queryName = v && v.name && v.name.value, a;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var n = this;
      return globalThis.__DEV__ !== !1 && ia("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && Se.warn(23);
      }), new Promise(function(r, i) {
        var o = {
          next: function(s) {
            r(s), n.observers.delete(o), n.observers.size || n.queryManager.removeQuery(n.queryId), setTimeout(function() {
              a.unsubscribe();
            }, 0);
          },
          error: i
        }, a = n.subscribe(o);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(n) {
      var r = this;
      n === void 0 && (n = !0);
      var i = En("getLastResult", function() {
        return r.getLastResult(!0);
      }), o = this.queryInfo.networkStatus || i && i.networkStatus || ft.ready, a = W(W({}, i), { loading: _s(o), networkStatus: o }), s = this.options.fetchPolicy, l = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Bm(l) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var u = this.queryInfo.getDiff();
        (u.complete || this.options.returnPartialData) && (a.data = u.result), wt(a.data, {}) && (a.data = void 0), u.complete ? (delete a.partial, u.complete && a.networkStatus === ft.loading && (l === "cache-first" || l === "cache-only") && (a.networkStatus = ft.ready, a.loading = !1)) : a.partial = !0, a.networkStatus === ft.ready && (a.error || a.errors) && (a.networkStatus = ft.error), globalThis.__DEV__ !== !1 && !u.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && YI(u.missing);
      }
      return n && this.updateLastResult(a), a;
    }, t.prototype.getCurrentResult = function(n) {
      return n === void 0 && (n = !0), this.maskResult(this.getCurrentFullResult(n));
    }, t.prototype.isDifferentFromLastResult = function(n, r) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), o = this.queryManager.dataMasking, a = o ? i.nonReactiveQuery : this.query, s = o || i.hasNonreactiveDirective ? !AI(a, this.last.result, n, this.variables) : !wt(this.last.result, n);
      return s || r && !wt(this.last.variables, r);
    }, t.prototype.getLast = function(n, r) {
      var i = this.last;
      if (i && i[n] && (!r || wt(i.variables, this.variables)))
        return i[n];
    }, t.prototype.getLastResult = function(n) {
      return globalThis.__DEV__ !== !1 && ia("getLastResult", function() {
        globalThis.__DEV__ !== !1 && Se.warn(24);
      }), this.getLast("result", n);
    }, t.prototype.getLastError = function(n) {
      return globalThis.__DEV__ !== !1 && ia("getLastError", function() {
        globalThis.__DEV__ !== !1 && Se.warn(25);
      }), this.getLast("error", n);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && ia("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && Se.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Se.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(n) {
      var r, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, o = this.options.fetchPolicy;
      if (o === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && n && ore.call(n, "variables")) {
        var a = oI(this.query), s = a.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && Se.warn(
          28,
          n,
          ((r = a.name) === null || r === void 0 ? void 0 : r.value) || a
        );
      }
      return n && !wt(this.options.variables, n) && (i.variables = this.options.variables = W(W({}, this.options.variables), n)), this.queryInfo.resetLastWrite(), this.reobserve(i, ft.refetch);
    }, t.prototype.fetchMore = function(n) {
      var r = this, i = W(W({}, n.query ? n : W(W(W(W({}, this.options), { query: this.options.query }), n), { variables: W(W({}, this.options.variables), n.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var o = this.queryManager.generateQueryId();
      this.lastQuery = n.query ? this.transformDocument(this.options.query) : i.query;
      var a = this.queryInfo, s = a.networkStatus;
      a.networkStatus = ft.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), u = n?.updateQuery, c = this.options.fetchPolicy !== "no-cache";
      return c || Se(u, 29), this.queryManager.fetchQuery(o, i, ft.fetchMore).then(function(f) {
        if (r.queryManager.removeQuery(o), a.networkStatus === ft.fetchMore && (a.networkStatus = s), c)
          r.queryManager.cache.batch({
            update: function(h) {
              var m = n.updateQuery;
              m ? h.updateQuery({
                query: r.query,
                variables: r.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(v) {
                return m(v, {
                  fetchMoreResult: f.data,
                  variables: i.variables
                });
              }) : h.writeQuery({
                query: i.query,
                variables: i.variables,
                data: f.data
              });
            },
            onWatchUpdated: function(h) {
              l.add(h.query);
            }
          });
        else {
          var d = r.getLast("result"), p = u(d.data, {
            fetchMoreResult: f.data,
            variables: i.variables
          });
          r.reportResult(W(W({}, d), { networkStatus: s, loading: _s(s), data: p }), r.variables);
        }
        return r.maskResult(f);
      }).finally(function() {
        c && !l.has(r.query) && r.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(n) {
      var r = this, i = this.queryManager.startGraphQLSubscription({
        query: n.document,
        variables: n.variables,
        context: n.context
      }).subscribe({
        next: function(o) {
          var a = n.updateQuery;
          a && r.updateQuery(function(s, l) {
            return a(s, W({ subscriptionData: o }, l));
          });
        },
        error: function(o) {
          if (n.onError) {
            n.onError(o);
            return;
          }
          globalThis.__DEV__ !== !1 && Se.error(30, o);
        }
      });
      return this.subscriptions.add(i), function() {
        r.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(n) {
      return globalThis.__DEV__ !== !1 && (Zt(n, "canonizeResults", "setOptions"), ia("setOptions", function() {
        globalThis.__DEV__ !== !1 && Se.warn(31);
      })), this.reobserve(n);
    }, t.prototype.silentSetOptions = function(n) {
      var r = Xs(this.options, n || {});
      z2(this.options, r);
    }, t.prototype.setVariables = function(n) {
      var r = this;
      return wt(this.variables, n) ? this.observers.size ? En("observableQuery.result", function() {
        return r.result();
      }) : Promise.resolve() : (this.options.variables = n, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: n
      }, ft.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(n) {
      var r = this.queryManager, i = r.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), o = i.result, a = i.complete, s = n(o, {
        variables: this.variables,
        complete: !!a,
        previousData: o
      });
      s && (r.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), r.broadcastQueries());
    }, t.prototype.startPolling = function(n) {
      this.options.pollInterval = n, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(n, r) {
      if (r.nextFetchPolicy) {
        var i = r.fetchPolicy, o = i === void 0 ? "cache-first" : i, a = r.initialFetchPolicy, s = a === void 0 ? o : a;
        o === "standby" || (typeof r.nextFetchPolicy == "function" ? r.fetchPolicy = r.nextFetchPolicy(o, {
          reason: n,
          options: r,
          observable: this,
          initialFetchPolicy: s
        }) : n === "variables-changed" ? r.fetchPolicy = s : r.fetchPolicy = r.nextFetchPolicy);
      }
      return r.fetchPolicy;
    }, t.prototype.fetch = function(n, r, i) {
      var o = this._getOrCreateQuery();
      return o.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(o, n, r, i);
    }, t.prototype.updatePolling = function() {
      var n = this;
      if (!this.queryManager.ssrMode) {
        var r = this, i = r.pollingInfo, o = r.options.pollInterval;
        if (!o || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === o)) {
          Se(o, 32);
          var a = i || (this.pollingInfo = {});
          a.interval = o;
          var s = function() {
            var u, c;
            n.pollingInfo && (!_s(n.queryInfo.networkStatus) && !(!((c = (u = n.options).skipPollAttempt) === null || c === void 0) && c.call(u)) ? n.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: n.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, ft.poll).then(l, l) : l());
          }, l = function() {
            var u = n.pollingInfo;
            u && (clearTimeout(u.timeout), u.timeout = setTimeout(s, u.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(n, r) {
      var i = this;
      r === void 0 && (r = this.variables);
      var o = En("getLastError", function() {
        return i.getLastError();
      });
      return o && this.last && !wt(r, this.last.variables) && (o = void 0), this.last = W({ result: this.queryManager.assumeImmutableResults ? n : $I(n), variables: r }, o ? { error: o } : null);
    }, t.prototype.reobserveAsConcast = function(n, r) {
      var i = this;
      this.isTornDown = !1;
      var o = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        r === ft.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        r === ft.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        r === ft.poll
      ), a = this.options.variables, s = this.options.fetchPolicy, l = Xs(this.options, n || {}), u = o ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : z2(this.options, l), c = this.transformDocument(u.query);
      this.lastQuery = c, o || (this.updatePolling(), n && n.variables && !wt(n.variables, a) && // Don't mess with the fetchPolicy if it's currently "standby".
      u.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (u.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof u.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", u), r === void 0 && (r = ft.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Bm(u.fetchPolicy));
      var f = function() {
        i.concast === h && (i.waitForOwnResult = !1);
      }, d = u.variables && W({}, u.variables), p = this.fetch(u, r, c), h = p.concast, m = p.fromLink, v = {
        next: function(g) {
          wt(i.variables, d) && (f(), i.reportResult(g, d));
        },
        error: function(g) {
          wt(i.variables, d) && (PI(g) || (g = new fo({ networkError: g })), f(), i.reportError(g, d));
        }
      };
      return !o && (m || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = h, this.observer = v), h.addObserver(v), h;
    }, t.prototype.reobserve = function(n, r) {
      return Wte(this.reobserveAsConcast(n, r).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var n = this, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var o = this.last;
      En("resetLastResults", function() {
        return n.resetLastResults();
      });
      var a = this.subscribe.apply(this, r);
      return this.last = o, a;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(n, r) {
      var i = this, o = En("getLastError", function() {
        return i.getLastError();
      }), a = this.isDifferentFromLastResult(n, r);
      (o || !n.partial || this.options.returnPartialData) && this.updateLastResult(n, r), (o || a) && gu(this.observers, "next", this.maskResult(n));
    }, t.prototype.reportError = function(n, r) {
      var i = this, o = W(W({}, En("getLastResult", function() {
        return i.getLastResult();
      })), { error: n, errors: n.graphQLErrors, networkStatus: ft.error, loading: !1 });
      this.updateLastResult(o, r), gu(this.observers, "error", this.last.error = n);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(n) {
        return n.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(n) {
      return this.queryManager.transform(n);
    }, t.prototype.maskResult = function(n) {
      return n && "data" in n ? W(W({}, n), { data: this.queryManager.maskOperation({
        document: this.query,
        data: n.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : n;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var n = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return n.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !_s(this.queryInfo.networkStatus))) {
        var n = this.queryInfo.getDiff();
        n.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var n = this.options, r = n.fetchPolicy, i = n.nextFetchPolicy;
      return r === "cache-and-network" || r === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(o, a) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(o, a) : r;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new kl(), t;
  })(yt)
);
TI(Lf);
function are(e) {
  globalThis.__DEV__ !== !1 && Se.error(33, e.message, e.stack);
}
function YI(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && Se.debug(34, e);
}
function Bm(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var ws = new (Ha ? WeakMap : Map)();
function Km(e, t) {
  var n = e[t];
  typeof n == "function" && (e[t] = function() {
    return ws.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (ws.get(e) + 1) % 1e15
    ), n.apply(this, arguments);
  });
}
var Um = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = t.generateQueryId()), this.queryId = n, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var r = this.cache = t.cache;
      ws.has(r) || (ws.set(r, 0), Km(r, "evict"), Km(r, "modify"), Km(r, "reset"));
    }
    return e.prototype.init = function(t) {
      var n = t.networkStatus || ft.loading;
      return this.variables && this.networkStatus !== ft.loading && !wt(this.variables, t.variables) && (n = ft.setVariables), wt(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: n
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, n = this.getDiffOptions();
      if (this.lastDiff && wt(n, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var r = this.observableQuery;
      if (r && r.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = En("canonizeResults", function() {
        return t.cache.diff(n);
      });
      return this.updateLastDiff(i, n), i;
    }, e.prototype.updateLastDiff = function(t, n) {
      this.lastDiff = t ? {
        diff: t,
        options: n || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var n;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (n = this.observableQuery) === null || n === void 0 ? void 0 : n.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var n = this, r, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && En("getLastError", function() {
        var o;
        return (o = n.observableQuery) === null || o === void 0 ? void 0 : o.getLastError();
      }) || (this.updateLastDiff(t), wt(i && i.result, t && t.result) || (r = this.observableQuery) === null || r === void 0 || r.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var n = this.observableQuery;
        n && n.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var n = this;
      t === void 0 && (t = this.variables);
      var r = this.observableQuery;
      if (!(r && r.options.fetchPolicy === "no-cache")) {
        var i = W(W({}, this.getDiffOptions(t)), { watcher: this, callback: function(o) {
          return n.setDiff(o);
        } });
        (!this.lastWatch || !wt(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, n) {
      var r = this.lastWrite;
      return !(r && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      r.dmCount === ws.get(this.cache) && wt(n, r.variables) && wt(t.data, r.result.data));
    }, e.prototype.markResult = function(t, n, r, i) {
      var o = this, a, s = new Mo(), l = Di(t.errors) ? t.errors.slice(0) : [];
      if ((a = this.observableQuery) === null || a === void 0 || a.resetNotifications(), "incremental" in t && Di(t.incremental)) {
        var u = OI(this.getDiff().result, t);
        t.data = u;
      } else if ("hasNext" in t && t.hasNext) {
        var c = this.getDiff();
        t.data = s.merge(c.result, t.data);
      }
      this.graphQLErrors = l, r.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(r.variables)) : i !== 0 && (hy(t, r.errorPolicy) ? this.cache.performTransaction(function(f) {
        if (o.shouldWrite(t, r.variables))
          f.writeQuery({
            query: n,
            data: t.data,
            variables: r.variables,
            overwrite: i === 1
          }), o.lastWrite = {
            result: t,
            variables: r.variables,
            dmCount: ws.get(o.cache)
          };
        else if (o.lastDiff && o.lastDiff.diff.complete) {
          t.data = o.lastDiff.diff.result;
          return;
        }
        var d = o.getDiffOptions(r.variables), p = En("canonizeResults", function() {
          return f.diff(d);
        });
        !o.stopped && wt(o.variables, r.variables) && o.updateWatch(r.variables), o.updateLastDiff(p, d), p.complete && (t.data = p.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = ft.ready;
    }, e.prototype.markError = function(t) {
      var n;
      return this.networkStatus = ft.error, this.lastWrite = void 0, (n = this.observableQuery) === null || n === void 0 || n.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function hy(e, t) {
  t === void 0 && (t = "none");
  var n = t === "ignore" || t === "all", r = !jf(e);
  return !r && n && e.data && (r = !0), r;
}
var sre = Object.prototype.hasOwnProperty, L2 = /* @__PURE__ */ Object.create(null), lre = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new XC(
        Qi["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new to(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var r = new yI(
        function(o) {
          return n.cache.transformDocument(o);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? r.concat(i).concat(r) : r, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(n, r) {
        t.stopQueryNoBroadcast(r);
      }), this.cancelPendingFetches(Ln(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(n) {
        return n(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return lo(this, arguments, void 0, function(n) {
        var r, i, o, a, s, l, u, c = n.mutation, f = n.variables, d = n.optimisticResponse, p = n.updateQueries, h = n.refetchQueries, m = h === void 0 ? [] : h, v = n.awaitRefetchQueries, g = v === void 0 ? !1 : v, b = n.update, E = n.onQueryUpdated, x = n.fetchPolicy, S = x === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : x, $ = n.errorPolicy, P = $ === void 0 ? ((u = this.defaultOptions.mutate) === null || u === void 0 ? void 0 : u.errorPolicy) || "none" : $, y = n.keepRootFields, _ = n.context;
        return uo(this, function(w) {
          switch (w.label) {
            case 0:
              return Se(c, 36), Se(S === "network-only" || S === "no-cache", 37), r = this.generateMutationId(), c = this.cache.transformForLink(this.transform(c)), i = this.getDocumentInfo(c).hasClientExports, f = this.getVariables(c, f), i ? [4, this.localState.addExportedVariables(c, f, _)] : [3, 2];
            case 1:
              f = w.sent(), w.label = 2;
            case 2:
              return o = this.mutationStore && (this.mutationStore[r] = {
                mutation: c,
                variables: f,
                loading: !0,
                error: null
              }), a = d && this.markMutationOptimistic(d, {
                mutationId: r,
                document: c,
                variables: f,
                fetchPolicy: S,
                errorPolicy: P,
                context: _,
                updateQueries: p,
                update: b,
                keepRootFields: y
              }), this.broadcastQueries(), s = this, [2, new Promise(function(A, k) {
                return Rm(s.getObservableFromLink(c, W(W({}, _), { optimisticResponse: a ? d : void 0 }), f, {}, !1), function(N) {
                  if (jf(N) && P === "none")
                    throw new fo({
                      graphQLErrors: iy(N)
                    });
                  o && (o.loading = !1, o.error = null);
                  var I = W({}, N);
                  return typeof m == "function" && (m = m(I)), P === "ignore" && jf(I) && delete I.errors, s.markMutationResult({
                    mutationId: r,
                    result: I,
                    document: c,
                    variables: f,
                    fetchPolicy: S,
                    errorPolicy: P,
                    context: _,
                    update: b,
                    updateQueries: p,
                    awaitRefetchQueries: g,
                    refetchQueries: m,
                    removeOptimistic: a ? r : void 0,
                    onQueryUpdated: E,
                    keepRootFields: y
                  });
                }).subscribe({
                  next: function(N) {
                    s.broadcastQueries(), (!("hasNext" in N) || N.hasNext === !1) && A(W(W({}, N), { data: s.maskOperation({
                      document: c,
                      data: N.data,
                      fetchPolicy: S,
                      id: r
                    }) }));
                  },
                  error: function(N) {
                    o && (o.loading = !1, o.error = N), a && s.cache.removeOptimistic(r), s.broadcastQueries(), k(N instanceof fo ? N : new fo({
                      networkError: N
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, n) {
      var r = this;
      n === void 0 && (n = this.cache);
      var i = t.result, o = [], a = t.fetchPolicy === "no-cache";
      if (!a && hy(i, t.errorPolicy)) {
        if (Ps(i) || o.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), Ps(i) && Di(i.incremental)) {
          var s = n.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = OI(s.result, i)), typeof l < "u" && (i.data = l, o.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var u = t.updateQueries;
        u && this.queries.forEach(function(f, d) {
          var p = f.observableQuery, h = p && p.queryName;
          if (!(!h || !sre.call(u, h))) {
            var m = u[h], v = r.queries.get(d), g = v.document, b = v.variables, E = n.diff({
              query: g,
              variables: b,
              returnPartialData: !0,
              optimistic: !1
            }), x = E.result, S = E.complete;
            if (S && x) {
              var $ = m(x, {
                mutationResult: i,
                queryName: g && tu(g) || void 0,
                queryVariables: b
              });
              $ && o.push({
                result: $,
                dataId: "ROOT_QUERY",
                query: g,
                variables: b
              });
            }
          }
        });
      }
      if (o.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function(f) {
            a || o.forEach(function(m) {
              return f.write(m);
            });
            var d = t.update, p = !Jte(i) || Ps(i) && !i.hasNext;
            if (d) {
              if (!a) {
                var h = f.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: r.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                h.complete && (i = W(W({}, i), { data: h.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              p && d(f, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !a && !t.keepRootFields && p && f.modify({
              id: "ROOT_MUTATION",
              fields: function(m, v) {
                var g = v.fieldName, b = v.DELETE;
                return g === "__typename" ? m : b;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(f) {
          return c.push(f);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(c).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, n) {
      var r = this, i = typeof t == "function" ? t(n.variables, { IGNORE: L2 }) : t;
      return i === L2 ? !1 : (this.cache.recordOptimisticTransaction(function(o) {
        try {
          r.markMutationResult(W(W({}, n), { result: { data: i } }), o);
        } catch (a) {
          globalThis.__DEV__ !== !1 && Se.error(a);
        }
      }, n.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, n, r) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), n, r).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(n, r) {
        t[r] = {
          variables: n.variables,
          networkStatus: n.networkStatus,
          networkError: n.networkError,
          graphQLErrors: n.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var n = this.queries.get(t);
      n && (n.networkError = void 0, n.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var n = this.transformCache;
      if (!n.has(t)) {
        var r = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: Mee(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: qu(["nonreactive"], t),
          nonReactiveQuery: Nte(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: _I([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: e1(Da(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: W(W({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? W(W({}, i), { operation: "query" }) : i;
          }) })
        };
        n.set(t, r);
      }
      return n.get(t);
    }, e.prototype.getVariables = function(t, n) {
      return W(W({}, this.getDocumentInfo(t).defaultVars), n);
    }, e.prototype.watchQuery = function(t) {
      var n = this.transform(t.query);
      t = W(W({}, t), { variables: this.getVariables(n, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var r = new Um(this), i = new Lf({
        queryManager: this,
        queryInfo: r,
        options: t
      });
      return i.lastQuery = n, Lf.inactiveOnCreation.getValue() || this.queries.set(i.queryId, r), r.init({
        document: n,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, n) {
      var r = this;
      n === void 0 && (n = this.generateQueryId()), Se(t.query, 38), Se(t.query.kind === "Document", 39), Se(!t.returnPartialData, 40), Se(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(n, W(W({}, t), { query: i })).then(function(o) {
        return o && W(W({}, o), { data: r.maskOperation({
          document: i,
          data: o.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      }).finally(function() {
        return r.stopQuery(n);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var n = this.queries.get(t);
      n && n.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(Ln(42)), this.queries.forEach(function(n) {
        n.observableQuery ? n.networkStatus = ft.loading : n.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var n = this;
      t === void 0 && (t = "active");
      var r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), o.set(s, !1);
        else if (lte(s)) {
          var l = bo(n.transform(s));
          i.set(l, tu(s)), o.set(l, !1);
        } else Mt(s) && s.query && a.add(s);
      }), this.queries.forEach(function(s, l) {
        var u = s.observableQuery, c = s.document;
        if (u) {
          if (t === "all") {
            r.set(l, u);
            return;
          }
          var f = u.queryName, d = u.options.fetchPolicy;
          if (d === "standby" || t === "active" && !u.hasObservers())
            return;
          (t === "active" || f && o.has(f) || c && o.has(bo(c))) && (r.set(l, u), f && o.set(f, !0), c && o.set(bo(c), !0));
        }
      }), a.size && a.forEach(function(s) {
        var l = Zg("legacyOneTimeQuery"), u = n.getOrCreateQuery(l).init({
          document: s.query,
          variables: s.variables
        }), c = new Lf({
          queryManager: n,
          queryInfo: u,
          options: W(W({}, s), { fetchPolicy: "network-only" })
        });
        Se(c.queryId === l), u.setObservableQuery(c), r.set(l, c);
      }), globalThis.__DEV__ !== !1 && o.size && o.forEach(function(s, l) {
        if (!s) {
          var u = i.get(l);
          u ? globalThis.__DEV__ !== !1 && Se.warn(43, u) : globalThis.__DEV__ !== !1 && Se.warn(44);
        }
      }), r;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var n = this;
      t === void 0 && (t = !1);
      var r = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, o) {
        var a = i.options.fetchPolicy;
        En("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || a !== "standby" && a !== "cache-only") && r.push(i.refetch()), (n.queries.get(o) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(r);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var n = this, r = t.query, i = t.variables, o = t.fetchPolicy, a = t.errorPolicy, s = a === void 0 ? "none" : a, l = t.context, u = l === void 0 ? {} : l, c = t.extensions, f = c === void 0 ? {} : c;
      r = this.transform(r), i = this.getVariables(r, i);
      var d = function(h) {
        return n.getObservableFromLink(r, u, h, f).map(function(m) {
          o !== "no-cache" && (hy(m, s) && n.cache.write({
            query: r,
            result: m.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: h
          }), n.broadcastQueries());
          var v = jf(m), g = vne(m);
          if (v || g) {
            var b = {};
            if (v && (b.graphQLErrors = m.errors), g && (b.protocolErrors = m.extensions[u1]), s === "none" || g)
              throw new fo(b);
          }
          return s === "ignore" && delete m.errors, m;
        });
      };
      if (this.getDocumentInfo(r).hasClientExports) {
        var p = this.localState.addExportedVariables(r, i, u).then(d);
        return new yt(function(h) {
          var m = null;
          return p.then(function(v) {
            return m = v.subscribe(h);
          }, h.error), function() {
            return m && m.unsubscribe();
          };
        });
      }
      return d(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var n;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((n = this.queries.get(t)) === null || n === void 0 || n.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var n;
        return (n = t.observableQuery) === null || n === void 0 ? void 0 : n.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, n, r, i, o) {
      var a = this, s;
      o === void 0 && (o = (s = n?.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var l, u = this.getDocumentInfo(t), c = u.serverQuery, f = u.clientQuery;
      if (c) {
        var d = this, p = d.inFlightLinkObservables, h = d.link, m = {
          query: c,
          variables: r,
          operationName: tu(c) || void 0,
          context: this.prepareContext(W(W({}, n), { forceFetch: !o })),
          extensions: i
        };
        if (n = m.context, o) {
          var v = bo(c), g = wo(r), b = p.lookup(v, g);
          if (l = b.observable, !l) {
            var E = new os([
              sy(h, m)
            ]);
            l = b.observable = E, E.beforeNext(function x(S, $) {
              S === "next" && "hasNext" in $ && $.hasNext ? E.beforeNext(x) : p.remove(v, g);
            });
          }
        } else
          l = new os([
            sy(h, m)
          ]);
      } else
        l = new os([yt.of({ data: {} })]), n = this.prepareContext(n);
      return f && (l = Rm(l, function(x) {
        return a.localState.runResolvers({
          document: f,
          remoteResult: x,
          context: n,
          variables: r
        });
      })), l;
    }, e.prototype.getResultsFromLink = function(t, n, r) {
      var i = t.lastRequestId = this.generateRequestId(), o = this.cache.transformForLink(r.query);
      return Rm(this.getObservableFromLink(o, r.context, r.variables), function(a) {
        var s = iy(a), l = s.length > 0, u = r.errorPolicy;
        if (i >= t.lastRequestId) {
          if (l && u === "none")
            throw t.markError(new fo({
              graphQLErrors: s
            }));
          t.markResult(a, o, r, n), t.markReady();
        }
        var c = {
          data: a.data,
          loading: !1,
          networkStatus: ft.ready
        };
        return l && u === "none" && (c.data = void 0), l && u !== "ignore" && (c.errors = s, c.networkStatus = ft.error), c;
      }, function(a) {
        var s = PI(a) ? a : new fo({ networkError: a });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, n, r, i) {
      var o = this;
      r === void 0 && (r = ft.loading), i === void 0 && (i = n.query);
      var a = this.getVariables(i, n.variables), s = this.defaultOptions.watchQuery, l = n.fetchPolicy, u = l === void 0 ? s && s.fetchPolicy || "cache-first" : l, c = n.errorPolicy, f = c === void 0 ? s && s.errorPolicy || "none" : c, d = n.returnPartialData, p = d === void 0 ? !1 : d, h = n.notifyOnNetworkStatusChange, m = h === void 0 ? !1 : h, v = n.context, g = v === void 0 ? {} : v, b = Object.assign({}, n, {
        query: i,
        variables: a,
        fetchPolicy: u,
        errorPolicy: f,
        returnPartialData: p,
        notifyOnNetworkStatusChange: m,
        context: g
      }), E = function(y) {
        b.variables = y;
        var _ = o.fetchQueryByPolicy(t, b, r);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          b.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          _.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", n), _
        );
      }, x = function() {
        return o.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(y) {
        x(), setTimeout(function() {
          return S.cancel(y);
        });
      });
      var S, $;
      if (this.getDocumentInfo(b.query).hasClientExports)
        S = new os(this.localState.addExportedVariables(b.query, b.variables, b.context).then(E).then(function(y) {
          return y.sources;
        })), $ = !0;
      else {
        var P = E(b.variables);
        $ = P.fromLink, S = new os(P.sources);
      }
      return S.promise.then(x, x), {
        concast: S,
        fromLink: $
      };
    }, e.prototype.refetchQueries = function(t) {
      var n = this, r = t.updateCache, i = t.include, o = t.optimistic, a = o === void 0 ? !1 : o, s = t.removeOptimistic, l = s === void 0 ? a ? Zg("refetchQueries") : void 0 : s, u = t.onQueryUpdated, c = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(d, p) {
        c.set(p, {
          oq: d,
          lastDiff: (n.queries.get(p) || d.queryInfo).getDiff()
        });
      });
      var f = /* @__PURE__ */ new Map();
      return r && this.cache.batch({
        update: r,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: a && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(d, p, h) {
          var m = d.watcher instanceof Um && d.watcher.observableQuery;
          if (m) {
            if (u) {
              c.delete(m.queryId);
              var v = u(m, p, h);
              return v === !0 && (v = m.refetch()), v !== !1 && f.set(m, v), v;
            }
            u !== null && c.set(m.queryId, { oq: m, lastDiff: h, diff: p });
          }
        }
      }), c.size && c.forEach(function(d, p) {
        var h = d.oq, m = d.lastDiff, v = d.diff, g;
        u && (v || (v = En("canonizeResults", function() {
          return n.cache.diff(h.queryInfo.getDiffOptions());
        })), g = u(h, v, m)), (!u || g === !0) && (g = h.refetch()), g !== !1 && f.set(h, g), p.indexOf("legacyOneTimeQuery") >= 0 && n.stopQueryNoBroadcast(p);
      }), l && this.cache.removeOptimistic(l), f;
    }, e.prototype.maskOperation = function(t) {
      var n, r, i, o = t.document, a = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, l = t.id, u = (n = Da(o)) === null || n === void 0 ? void 0 : n.operation, c = ((r = u?.[0]) !== null && r !== void 0 ? r : "o") + l;
        this.dataMasking && s === "no-cache" && !Uee(o) && !this.noCacheWarningsByQueryId.has(c) && (this.noCacheWarningsByQueryId.add(c), globalThis.__DEV__ !== !1 && Se.warn(
          45,
          (i = tu(o)) !== null && i !== void 0 ? i : "Unnamed ".concat(u ?? "operation")
        ));
      }
      return this.dataMasking ? Vne(a, o, this.cache) : a;
    }, e.prototype.maskFragment = function(t) {
      var n = t.data, r = t.fragment, i = t.fragmentName;
      return this.dataMasking ? NI(n, r, this.cache, i) : n;
    }, e.prototype.fetchQueryByPolicy = function(t, n, r) {
      var i = this, o = n.query, a = n.variables, s = n.fetchPolicy, l = n.refetchWritePolicy, u = n.errorPolicy, c = n.returnPartialData, f = n.context, d = n.notifyOnNetworkStatusChange, p = t.networkStatus;
      t.init({
        document: o,
        variables: a,
        networkStatus: r
      });
      var h = function() {
        return t.getDiff();
      }, m = function(x, S) {
        S === void 0 && (S = t.networkStatus || ft.loading);
        var $ = x.result;
        globalThis.__DEV__ !== !1 && !c && !wt($, {}) && YI(x.missing);
        var P = function(y) {
          return yt.of(W({ data: y, loading: _s(S), networkStatus: S }, x.complete ? null : { partial: !0 }));
        };
        return $ && i.getDocumentInfo(o).hasForcedResolvers ? i.localState.runResolvers({
          document: o,
          remoteResult: { data: $ },
          context: f,
          variables: a,
          onlyRunForcedResolvers: !0
        }).then(function(y) {
          return P(y.data || void 0);
        }) : u === "none" && S === ft.refetch && Array.isArray(x.missing) ? P(void 0) : P($);
      }, v = s === "no-cache" ? 0 : r === ft.refetch && l !== "merge" ? 1 : 2, g = function() {
        return i.getResultsFromLink(t, v, {
          query: o,
          variables: a,
          context: f,
          fetchPolicy: s,
          errorPolicy: u
        });
      }, b = d && typeof p == "number" && p !== r && _s(r);
      switch (s) {
        default:
        case "cache-first": {
          var E = h();
          return E.complete ? {
            fromLink: !1,
            sources: [m(E, t.markReady())]
          } : c || b ? {
            fromLink: !0,
            sources: [m(E), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-and-network": {
          var E = h();
          return E.complete || c || b ? {
            fromLink: !0,
            sources: [m(E), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [m(h(), t.markReady())]
          };
        case "network-only":
          return b ? {
            fromLink: !0,
            sources: [m(h()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "no-cache":
          return b ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [m(t.getDiff()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new Um(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var n = this.localState.prepareContext(t);
      return W(W(W({}, this.defaultContext), n), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), ure = (
  /** @class */
  (function() {
    function e(t) {
      var n = t.cache, r = t.client, i = t.resolvers, o = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = n, r && (this.client = r), i && this.addResolvers(i), o && this.setFragmentMatcher(o);
    }
    return e.prototype.addResolvers = function(t) {
      var n = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(r) {
        n.resolvers = a2(n.resolvers, r);
      }) : this.resolvers = a2(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return lo(this, arguments, void 0, function(n) {
        var r = n.document, i = n.remoteResult, o = n.context, a = n.variables, s = n.onlyRunForcedResolvers, l = s === void 0 ? !1 : s;
        return uo(this, function(u) {
          return r ? [2, this.resolveDocument(r, i.data, o, a, this.fragmentMatcher, l).then(function(c) {
            return W(W({}, i), { data: c.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return qu(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return wI(t);
    }, e.prototype.prepareContext = function(t) {
      var n = this.cache;
      return W(W({}, t), {
        cache: n,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(r) {
          return n.identify(r);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return lo(this, arguments, void 0, function(n, r, i) {
        return r === void 0 && (r = {}), i === void 0 && (i = {}), uo(this, function(o) {
          return n ? [2, this.resolveDocument(n, this.buildRootValueFromCache(n, r) || {}, this.prepareContext(i), r).then(function(a) {
            return W(W({}, r), a.exportedVariables);
          })] : [2, W({}, r)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var n = !1;
      return ii(t, {
        Directive: {
          enter: function(r) {
            if (r.name.value === "client" && r.arguments && (n = r.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), n))
              return Qp;
          }
        }
      }), n;
    }, e.prototype.buildRootValueFromCache = function(t, n) {
      return this.cache.diff({
        query: Rte(t),
        variables: n,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, n) {
      return lo(this, arguments, void 0, function(r, i, o, a, s, l) {
        var u, c, f, d, p, h, m, v, g, b, E;
        return o === void 0 && (o = {}), a === void 0 && (a = {}), s === void 0 && (s = function() {
          return !0;
        }), l === void 0 && (l = !1), uo(this, function(x) {
          return u = Ec(r), c = Ol(r), f = $l(c), d = this.collectSelectionsToResolve(u, f), p = u.operation, h = p ? p.charAt(0).toUpperCase() + p.slice(1) : "Query", m = this, v = m.cache, g = m.client, b = {
            fragmentMap: f,
            context: W(W({}, o), { cache: v, client: g }),
            variables: a,
            fragmentMatcher: s,
            defaultOperationType: h,
            exportedVariables: {},
            selectionsToResolve: d,
            onlyRunForcedResolvers: l
          }, E = !1, [2, this.resolveSelectionSet(u.selectionSet, E, i, b).then(function(S) {
            return {
              result: S,
              exportedVariables: b.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, n, r, i) {
      return lo(this, void 0, void 0, function() {
        var o, a, s, l, u, c = this;
        return uo(this, function(f) {
          return o = i.fragmentMap, a = i.context, s = i.variables, l = [r], u = function(d) {
            return lo(c, void 0, void 0, function() {
              var p, h;
              return uo(this, function(m) {
                return !n && !i.selectionsToResolve.has(d) ? [
                  2
                  /*return*/
                ] : xc(d, s) ? Co(d) ? [2, this.resolveField(d, n, r, i).then(function(v) {
                  var g;
                  typeof v < "u" && l.push((g = {}, g[Ji(d)] = v, g));
                })] : (_te(d) ? p = d : (p = o[d.name.value], Se(p, 21, d.name.value)), p && p.typeCondition && (h = p.typeCondition.name.value, i.fragmentMatcher(r, h, a)) ? [2, this.resolveSelectionSet(p.selectionSet, n, r, i).then(function(v) {
                  l.push(v);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(u)).then(function() {
            return rh(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, n, r, i) {
      return lo(this, void 0, void 0, function() {
        var o, a, s, l, u, c, f, d, p, h = this;
        return uo(this, function(m) {
          return r ? (o = i.variables, a = t.name.value, s = Ji(t), l = a !== s, u = r[s] || r[a], c = Promise.resolve(u), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (f = r.__typename || i.defaultOperationType, d = this.resolvers && this.resolvers[f], d && (p = d[l ? a : s], p && (c = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            f1.withValue(this.cache, p, [
              r,
              eh(t, o),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, c.then(function(v) {
            var g, b;
            if (v === void 0 && (v = u), t.directives && t.directives.forEach(function(x) {
              x.name.value === "export" && x.arguments && x.arguments.forEach(function(S) {
                S.name.value === "as" && S.value.kind === "StringValue" && (i.exportedVariables[S.value.value] = v);
              });
            }), !t.selectionSet || v == null)
              return v;
            var E = (b = (g = t.directives) === null || g === void 0 ? void 0 : g.some(function(x) {
              return x.name.value === "client";
            })) !== null && b !== void 0 ? b : !1;
            if (Array.isArray(v))
              return h.resolveSubSelectedArray(t, n || E, v, i);
            if (t.selectionSet)
              return h.resolveSelectionSet(t.selectionSet, n || E, v, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, n, r, i) {
      var o = this;
      return Promise.all(r.map(function(a) {
        if (a === null)
          return null;
        if (Array.isArray(a))
          return o.resolveSubSelectedArray(t, n, a, i);
        if (t.selectionSet)
          return o.resolveSelectionSet(t.selectionSet, n, a, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, n) {
      var r = function(a) {
        return !Array.isArray(a);
      }, i = this.selectionsToResolveCache;
      function o(a) {
        if (!i.has(a)) {
          var s = /* @__PURE__ */ new Set();
          i.set(a, s), ii(a, {
            Directive: function(l, u, c, f, d) {
              l.name.value === "client" && d.forEach(function(p) {
                r(p) && QS(p) && s.add(p);
              });
            },
            FragmentSpread: function(l, u, c, f, d) {
              var p = n[l.name.value];
              Se(p, 22, l.name.value);
              var h = o(p);
              h.size > 0 && (d.forEach(function(m) {
                r(m) && QS(m) && s.add(m);
              }), s.add(l), h.forEach(function(m) {
                s.add(m);
              }));
            }
          });
        }
        return i.get(a);
      }
      return o(t);
    }, e;
  })()
), V2 = !1, cre = (
  /** @class */
  (function() {
    function e(t) {
      var n = this, r, i, o;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw Ln(16);
      var a = t.uri, s = t.credentials, l = t.headers, u = t.cache, c = t.documentTransform, f = t.ssrMode, d = f === void 0 ? !1 : f, p = t.ssrForceFetchDelay, h = p === void 0 ? 0 : p, m = t.connectToDevTools, v = t.queryDeduplication, g = v === void 0 ? !0 : v, b = t.defaultOptions, E = t.defaultContext, x = t.assumeImmutableResults, S = x === void 0 ? u.assumeImmutableResults : x, $ = t.resolvers, P = t.typeDefs, y = t.fragmentMatcher, _ = t.clientAwareness, w = t.name, A = t.version, k = t.devtools, N = t.dataMasking;
      globalThis.__DEV__ !== !1 && (Zt(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), Zt(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), Zt(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), Zt(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), Zt(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), Zt(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), Zt(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && Se.warn(17));
      var I = t.link;
      I || (I = a ? new Ine({ uri: a, credentials: s, headers: l }) : Uo.empty()), this.link = I, this.cache = u, this.disableNetworkFetches = d || h > 0, this.queryDeduplication = g, this.defaultOptions = b || /* @__PURE__ */ Object.create(null), this.typeDefs = P, this.devtoolsConfig = W(W({}, k), { enabled: (r = k?.enabled) !== null && r !== void 0 ? r : m }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), h && setTimeout(function() {
        return n.disableNetworkFetches = !1;
      }, h), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = Y0, this.localState = new ure({
        cache: u,
        client: this,
        resolvers: $,
        fragmentMatcher: y
      }), this.queryManager = new lre({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: E,
        documentTransform: c,
        queryDeduplication: g,
        ssrMode: d,
        dataMasking: !!N,
        clientAwareness: {
          name: (i = _?.name) !== null && i !== void 0 ? i : w,
          version: (o = _?.version) !== null && o !== void 0 ? o : A
        },
        localState: this.localState,
        assumeImmutableResults: S,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          n.devToolsHookCb && n.devToolsHookCb({
            action: {},
            state: {
              queries: n.queryManager.getQueryStore(),
              mutations: n.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: n.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, n = Symbol.for("apollo.devtools");
        (t[n] = t[n] || []).push(this), t.__APOLLO_CLIENT__ = this, !V2 && globalThis.__DEV__ !== !1 && (V2 = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var r = window.navigator, i = r && r.userAgent, o = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? o = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (o = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), o && globalThis.__DEV__ !== !1 && Se.log("Download the Apollo DevTools for a better development experience: %s", o);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = Nm(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = W(W({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (Zt(t, "canonizeResults", "client.watchQuery"), Zt(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = Nm(this.defaultOptions.query, t)), Se(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = W(W({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (Zt(t, "canonizeResults", "client.query"), Zt(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && Se.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = Nm(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var n = this, r = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return W(W({}, i), { data: n.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      });
    }, e.prototype.readQuery = function(t, n) {
      return n === void 0 && (n = !1), this.cache.readQuery(t, n);
    }, e.prototype.watchFragment = function(t) {
      var n;
      return this.cache.watchFragment(W(W({}, t), (n = {}, n[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, n)));
    }, e.prototype.readFragment = function(t, n) {
      return n === void 0 && (n = !1), this.cache.readFragment(t, n);
    }, e.prototype.writeQuery = function(t) {
      var n = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), n;
    }, e.prototype.writeFragment = function(t) {
      var n = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), n;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return sy(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(n) {
          return n();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(n) {
          return n();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var n = this;
      return this.resetStoreCallbacks.push(t), function() {
        n.resetStoreCallbacks = n.resetStoreCallbacks.filter(function(r) {
          return r !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var n = this;
      return this.clearStoreCallbacks.push(t), function() {
        n.clearStoreCallbacks = n.clearStoreCallbacks.filter(function(r) {
          return r !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var n = this.queryManager.refetchQueries(t), r = [], i = [];
      n.forEach(function(a, s) {
        r.push(s), i.push(a);
      });
      var o = Promise.all(i);
      return o.queries = r, o.results = i, o.catch(function(a) {
        globalThis.__DEV__ !== !1 && Se.debug(20, a);
      }), o;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (cre.prototype.getMemoryInternals = Xee);
function fre(e) {
  return Mt(e) && "code" in e && "reason" in e;
}
function dre(e) {
  var t;
  return Mt(e) && ((t = e.target) === null || t === void 0 ? void 0 : t.readyState) === WebSocket.CLOSED;
}
/** @class */
(function(e) {
  ui(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.client = n, r;
  }
  return t.prototype.request = function(n) {
    var r = this;
    return new yt(function(i) {
      return r.client.subscribe(W(W({}, n), { query: bo(n.query) }), {
        next: i.next.bind(i),
        complete: i.complete.bind(i),
        error: function(o) {
          if (o instanceof Error)
            return i.error(o);
          var a = fre(o);
          return a || dre(o) ? i.error(
            // reason will be available on clean closes
            new Error("Socket closed".concat(a ? " with event ".concat(o.code) : "").concat(a ? " ".concat(o.reason) : ""))
          ) : i.error(new fo({
            graphQLErrors: Array.isArray(o) ? o : [o]
          }));
        }
        // casting around a wrong type in graphql-ws, which incorrectly expects `Sink<ExecutionResult>`
      });
    });
  }, t;
})(Uo);
var B2;
(function(e) {
  e[e.InternalServerError = 4500] = "InternalServerError", e[e.InternalClientError = 4005] = "InternalClientError", e[e.BadRequest = 4400] = "BadRequest", e[e.BadResponse = 4004] = "BadResponse", e[e.Unauthorized = 4401] = "Unauthorized", e[e.Forbidden = 4403] = "Forbidden", e[e.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", e[e.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", e[e.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", e[e.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", e[e.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(B2 || (B2 = {}));
var K2;
(function(e) {
  e.ConnectionInit = "connection_init", e.ConnectionAck = "connection_ack", e.Ping = "ping", e.Pong = "pong", e.Subscribe = "subscribe", e.Next = "next", e.Error = "error", e.Complete = "complete";
})(K2 || (K2 = {}));
function le(e, t, n) {
  function r(s, l) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: l,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, l);
    const u = a.prototype, c = Object.keys(u);
    for (let f = 0; f < c.length; f++) {
      const d = c[f];
      d in s || (s[d] = u[d].bind(s));
    }
  }
  const i = n?.Parent ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var l;
    const u = n != null && n.Parent ? new o() : this;
    r(u, s), (l = u._zod).deferred ?? (l.deferred = []);
    for (const c of u._zod.deferred)
      c();
    return u;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var l, u;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (u = (l = s?._zod) == null ? void 0 : l.traits) == null ? void 0 : u.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class As extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class QI extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const JI = {};
function Aa(e) {
  return JI;
}
function XI(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, r]) => t.indexOf(+n) === -1).map(([n, r]) => r);
}
function my(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function m1(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function v1(e) {
  return e == null;
}
function g1(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function pre(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = t.toString();
  let i = (r.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(r)) {
    const l = r.match(/\d?e-(\d?)/);
    l != null && l[1] && (i = Number.parseInt(l[1]));
  }
  const o = n > i ? n : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const U2 = Symbol("evaluating");
function pt(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== U2)
        return r === void 0 && (r = U2, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Wa(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function qo(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function q2(e) {
  return JSON.stringify(e);
}
function hre(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const e3 = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Ud(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const mre = m1(() => {
  var e;
  if (typeof navigator < "u" && (e = navigator?.userAgent) != null && e.includes("Cloudflare"))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function Gu(e) {
  if (Ud(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(Ud(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function t3(e) {
  return Gu(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const vre = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function ih(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Ho(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function Ke(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function gre(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const yre = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function bre(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = qo(e._zod.def, {
    get shape() {
      const o = {};
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && (o[a] = n.shape[a]);
      }
      return Wa(this, "shape", o), o;
    },
    checks: []
  });
  return Ho(e, i);
}
function _re(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = qo(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && delete o[a];
      }
      return Wa(this, "shape", o), o;
    },
    checks: []
  });
  return Ho(e, i);
}
function wre(e, t) {
  if (!Gu(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const i = e._zod.def.shape;
    for (const o in t)
      if (Object.getOwnPropertyDescriptor(i, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const r = qo(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return Wa(this, "shape", i), i;
    }
  });
  return Ho(e, r);
}
function xre(e, t) {
  if (!Gu(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = qo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Wa(this, "shape", r), r;
    }
  });
  return Ho(e, n);
}
function Ere(e, t) {
  const n = qo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Wa(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Ho(e, n);
}
function Sre(e, t, n) {
  const r = t._zod.def.checks;
  if (r && r.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const i = qo(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, a = { ...o };
      if (n)
        for (const s in n) {
          if (!(s in o))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s]);
        }
      else
        for (const s in o)
          a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s];
      return Wa(this, "shape", a), a;
    },
    checks: []
  });
  return Ho(t, i);
}
function $re(e, t, n) {
  const r = qo(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (n)
        for (const a in n) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return Wa(this, "shape", o), o;
    }
  });
  return Ho(t, r);
}
function xs(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function n3(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function sf(e) {
  return typeof e == "string" ? e : e?.message;
}
function Ca(e, t, n) {
  var r, i, o, a, s, l;
  const u = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const c = sf((o = (i = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : i.error) == null ? void 0 : o.call(i, e)) ?? sf((a = t?.error) == null ? void 0 : a.call(t, e)) ?? sf((s = n.customError) == null ? void 0 : s.call(n, e)) ?? sf((l = n.localeError) == null ? void 0 : l.call(n, e)) ?? "Invalid input";
    u.message = c;
  }
  return delete u.inst, delete u.continue, t != null && t.reportInput || delete u.input, u;
}
function y1(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Yu(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const r3 = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, my, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, i3 = le("$ZodError", r3), o3 = le("$ZodError", r3, { Parent: Error });
function Tre(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function Ore(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => r({ issues: a }));
      else if (o.code === "invalid_key")
        r({ issues: o.issues });
      else if (o.code === "invalid_element")
        r({ issues: o.issues });
      else if (o.path.length === 0)
        n._errors.push(t(o));
      else {
        let a = n, s = 0;
        for (; s < o.path.length; ) {
          const l = o.path[s];
          s === o.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(t(o))) : a[l] = a[l] || { _errors: [] }, a = a[l], s++;
        }
      }
  };
  return r(e), n;
}
const b1 = (e) => (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise)
    throw new As();
  if (a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Ca(l, o, Aa())));
    throw e3(s, i?.callee), s;
  }
  return a.value;
}, _1 = (e) => async (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Ca(l, o, Aa())));
    throw e3(s, i?.callee), s;
  }
  return a.value;
}, oh = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, i);
  if (o instanceof Promise)
    throw new As();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? i3)(o.issues.map((a) => Ca(a, i, Aa())))
  } : { success: !0, data: o.value };
}, kre = /* @__PURE__ */ oh(o3), ah = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => Ca(a, i, Aa())))
  } : { success: !0, data: o.value };
}, Pre = /* @__PURE__ */ ah(o3), Dre = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return b1(e)(t, n, i);
}, Are = (e) => (t, n, r) => b1(e)(t, n, r), Cre = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return _1(e)(t, n, i);
}, Ire = (e) => async (t, n, r) => _1(e)(t, n, r), Mre = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return oh(e)(t, n, i);
}, Rre = (e) => (t, n, r) => oh(e)(t, n, r), Nre = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return ah(e)(t, n, i);
}, jre = (e) => async (t, n, r) => ah(e)(t, n, r), Fre = /^[cC][^\s-]{8,}$/, zre = /^[0-9a-z]+$/, Lre = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Vre = /^[0-9a-vA-V]{20}$/, Bre = /^[A-Za-z0-9]{27}$/, Kre = /^[a-zA-Z0-9_-]{21}$/, Ure = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, qre = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, H2 = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Hre = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Wre = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Zre() {
  return new RegExp(Wre, "u");
}
const Gre = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Yre = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Qre = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Jre = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Xre = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, a3 = /^[A-Za-z0-9_-]*$/, eie = /^\+[1-9]\d{6,14}$/, s3 = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", tie = /* @__PURE__ */ new RegExp(`^${s3}$`);
function l3(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function nie(e) {
  return new RegExp(`^${l3(e)}$`);
}
function rie(e) {
  const t = l3({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${s3}T(?:${r})$`);
}
const iie = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, oie = /^-?\d+$/, aie = /^-?\d+(?:\.\d+)?$/, sie = /^(?:true|false)$/i, lie = /^[^A-Z]*$/, uie = /^[^a-z]*$/, er = /* @__PURE__ */ le("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), u3 = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, c3 = /* @__PURE__ */ le("$ZodCheckLessThan", (e, t) => {
  er.init(e, t);
  const n = u3[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), f3 = /* @__PURE__ */ le("$ZodCheckGreaterThan", (e, t) => {
  er.init(e, t);
  const n = u3[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), cie = /* @__PURE__ */ le("$ZodCheckMultipleOf", (e, t) => {
  er.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : pre(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), fie = /* @__PURE__ */ le("$ZodCheckNumberFormat", (e, t) => {
  var n;
  er.init(e, t), t.format = t.format || "float64";
  const r = (n = t.format) == null ? void 0 : n.includes("int"), i = r ? "int" : "number", [o, a] = yre[t.format];
  e._zod.onattach.push((s) => {
    const l = s._zod.bag;
    l.format = t.format, l.minimum = o, l.maximum = a, r && (l.pattern = oie);
  }), e._zod.check = (s) => {
    const l = s.value;
    if (r) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: i,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < o && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > a && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: a,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), die = /* @__PURE__ */ le("$ZodCheckMaxLength", (e, t) => {
  var n;
  er.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !v1(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = y1(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), pie = /* @__PURE__ */ le("$ZodCheckMinLength", (e, t) => {
  var n;
  er.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !v1(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = y1(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), hie = /* @__PURE__ */ le("$ZodCheckLengthEquals", (e, t) => {
  var n;
  er.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !v1(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, o = i.length;
    if (o === t.length)
      return;
    const a = y1(i), s = o > t.length;
    r.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), sh = /* @__PURE__ */ le("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  er.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), mie = /* @__PURE__ */ le("$ZodCheckRegex", (e, t) => {
  sh.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), vie = /* @__PURE__ */ le("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = lie), sh.init(e, t);
}), gie = /* @__PURE__ */ le("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = uie), sh.init(e, t);
}), yie = /* @__PURE__ */ le("$ZodCheckIncludes", (e, t) => {
  er.init(e, t);
  const n = ih(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), bie = /* @__PURE__ */ le("$ZodCheckStartsWith", (e, t) => {
  er.init(e, t);
  const n = new RegExp(`^${ih(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), _ie = /* @__PURE__ */ le("$ZodCheckEndsWith", (e, t) => {
  er.init(e, t);
  const n = new RegExp(`.*${ih(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), wie = /* @__PURE__ */ le("$ZodCheckOverwrite", (e, t) => {
  er.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class xie {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((o) => o), r = Math.min(...n.map((o) => o.length - o.trimStart().length)), i = n.map((o) => o.slice(r)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of i)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, r.join(`
`));
  }
}
const Eie = {
  major: 4,
  minor: 3,
  patch: 6
}, Xt = /* @__PURE__ */ le("$ZodType", (e, t) => {
  var n, r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Eie;
  const i = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && i.unshift(e);
  for (const o of i)
    for (const a of o._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (n = e._zod.deferred) == null || n.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, l, u) => {
      let c = xs(s), f;
      for (const d of l) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (c)
          continue;
        const p = s.issues.length, h = d._zod.check(s);
        if (h instanceof Promise && u?.async === !1)
          throw new As();
        if (f || h instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await h, s.issues.length !== p && (c || (c = xs(s, p)));
          });
        else {
          if (s.issues.length === p)
            continue;
          c || (c = xs(s, p));
        }
      }
      return f ? f.then(() => s) : s;
    }, a = (s, l, u) => {
      if (xs(s))
        return s.aborted = !0, s;
      const c = o(l, i, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new As();
        return c.then((f) => e._zod.parse(f, u));
      }
      return e._zod.parse(c, u);
    };
    e._zod.run = (s, l) => {
      if (l.skipChecks)
        return e._zod.parse(s, l);
      if (l.direction === "backward") {
        const c = e._zod.parse({ value: s.value, issues: [] }, { ...l, skipChecks: !0 });
        return c instanceof Promise ? c.then((f) => a(f, s, l)) : a(c, s, l);
      }
      const u = e._zod.parse(s, l);
      if (u instanceof Promise) {
        if (l.async === !1)
          throw new As();
        return u.then((c) => o(c, i, l));
      }
      return o(u, i, l);
    };
  }
  pt(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = kre(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return Pre(e, o).then((s) => {
          var l;
          return s.success ? { value: s.data } : { issues: (l = s.error) == null ? void 0 : l.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), w1 = /* @__PURE__ */ le("$ZodString", (e, t) => {
  var n;
  Xt.init(e, t), e._zod.pattern = [...((n = e?._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? iie(e._zod.bag), e._zod.parse = (r, i) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), Ft = /* @__PURE__ */ le("$ZodStringFormat", (e, t) => {
  sh.init(e, t), w1.init(e, t);
}), Sie = /* @__PURE__ */ le("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = qre), Ft.init(e, t);
}), $ie = /* @__PURE__ */ le("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = H2(n));
  } else
    t.pattern ?? (t.pattern = H2());
  Ft.init(e, t);
}), Tie = /* @__PURE__ */ le("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Hre), Ft.init(e, t);
}), Oie = /* @__PURE__ */ le("$ZodURL", (e, t) => {
  Ft.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), kie = /* @__PURE__ */ le("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Zre()), Ft.init(e, t);
}), Pie = /* @__PURE__ */ le("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Kre), Ft.init(e, t);
}), Die = /* @__PURE__ */ le("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Fre), Ft.init(e, t);
}), Aie = /* @__PURE__ */ le("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = zre), Ft.init(e, t);
}), Cie = /* @__PURE__ */ le("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = Lre), Ft.init(e, t);
}), Iie = /* @__PURE__ */ le("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = Vre), Ft.init(e, t);
}), Mie = /* @__PURE__ */ le("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Bre), Ft.init(e, t);
}), Rie = /* @__PURE__ */ le("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = rie(t)), Ft.init(e, t);
}), Nie = /* @__PURE__ */ le("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = tie), Ft.init(e, t);
}), jie = /* @__PURE__ */ le("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = nie(t)), Ft.init(e, t);
}), Fie = /* @__PURE__ */ le("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = Ure), Ft.init(e, t);
}), zie = /* @__PURE__ */ le("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Gre), Ft.init(e, t), e._zod.bag.format = "ipv4";
}), Lie = /* @__PURE__ */ le("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Yre), Ft.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Vie = /* @__PURE__ */ le("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = Qre), Ft.init(e, t);
}), Bie = /* @__PURE__ */ le("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Jre), Ft.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, o] = r;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function d3(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Kie = /* @__PURE__ */ le("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Xre), Ft.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    d3(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function Uie(e) {
  if (!a3.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return d3(n);
}
const qie = /* @__PURE__ */ le("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = a3), Ft.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    Uie(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Hie = /* @__PURE__ */ le("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = eie), Ft.init(e, t);
});
function Wie(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const Zie = /* @__PURE__ */ le("$ZodJWT", (e, t) => {
  Ft.init(e, t), e._zod.check = (n) => {
    Wie(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), p3 = /* @__PURE__ */ le("$ZodNumber", (e, t) => {
  Xt.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? aie, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const i = n.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return n;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), n;
  };
}), Gie = /* @__PURE__ */ le("$ZodNumberFormat", (e, t) => {
  fie.init(e, t), p3.init(e, t);
}), Yie = /* @__PURE__ */ le("$ZodBoolean", (e, t) => {
  Xt.init(e, t), e._zod.pattern = sie, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const i = n.value;
    return typeof i == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), n;
  };
}), Qie = /* @__PURE__ */ le("$ZodUnknown", (e, t) => {
  Xt.init(e, t), e._zod.parse = (n) => n;
}), Jie = /* @__PURE__ */ le("$ZodNever", (e, t) => {
  Xt.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function W2(e, t, n) {
  e.issues.length && t.issues.push(...n3(n, e.issues)), t.value[n] = e.value;
}
const Xie = /* @__PURE__ */ le("$ZodArray", (e, t) => {
  Xt.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], l = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      l instanceof Promise ? o.push(l.then((u) => W2(u, n, a))) : W2(l, n, a);
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
});
function qd(e, t, n, r, i) {
  if (e.issues.length) {
    if (i && !(n in r))
      return;
    t.issues.push(...n3(n, e.issues));
  }
  e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function h3(e) {
  var t, n, r, i;
  const o = Object.keys(e.shape);
  for (const s of o)
    if (!((i = (r = (n = (t = e.shape) == null ? void 0 : t[s]) == null ? void 0 : n._zod) == null ? void 0 : r.traits) != null && i.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const a = gre(e.shape);
  return {
    ...e,
    keys: o,
    keySet: new Set(o),
    numKeys: o.length,
    optionalKeys: new Set(a)
  };
}
function m3(e, t, n, r, i, o) {
  const a = [], s = i.keySet, l = i.catchall._zod, u = l.def.type, c = l.optout === "optional";
  for (const f in t) {
    if (s.has(f))
      continue;
    if (u === "never") {
      a.push(f);
      continue;
    }
    const d = l.run({ value: t[f], issues: [] }, r);
    d instanceof Promise ? e.push(d.then((p) => qd(p, n, f, t, c))) : qd(d, n, f, t, c);
  }
  return a.length && n.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const eoe = /* @__PURE__ */ le("$ZodObject", (e, t) => {
  Xt.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const l = { ...s };
        return Object.defineProperty(t, "shape", {
          value: l
        }), l;
      }
    });
  }
  const r = m1(() => h3(t));
  pt(e._zod, "propValues", () => {
    const s = t.shape, l = {};
    for (const u in s) {
      const c = s[u]._zod;
      if (c.values) {
        l[u] ?? (l[u] = /* @__PURE__ */ new Set());
        for (const f of c.values)
          l[u].add(f);
      }
    }
    return l;
  });
  const i = Ud, o = t.catchall;
  let a;
  e._zod.parse = (s, l) => {
    a ?? (a = r.value);
    const u = s.value;
    if (!i(u))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: u,
        inst: e
      }), s;
    s.value = {};
    const c = [], f = a.shape;
    for (const d of a.keys) {
      const p = f[d], h = p._zod.optout === "optional", m = p._zod.run({ value: u[d], issues: [] }, l);
      m instanceof Promise ? c.push(m.then((v) => qd(v, s, d, u, h))) : qd(m, s, d, u, h);
    }
    return o ? m3(c, u, s, l, r.value, e) : c.length ? Promise.all(c).then(() => s) : s;
  };
}), toe = /* @__PURE__ */ le("$ZodObjectJIT", (e, t) => {
  eoe.init(e, t);
  const n = e._zod.parse, r = m1(() => h3(t)), i = (f) => {
    var d;
    const p = new xie(["shape", "payload", "ctx"]), h = r.value, m = (E) => {
      const x = q2(E);
      return `shape[${x}]._zod.run({ value: input[${x}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const v = /* @__PURE__ */ Object.create(null);
    let g = 0;
    for (const E of h.keys)
      v[E] = `key_${g++}`;
    p.write("const newResult = {};");
    for (const E of h.keys) {
      const x = v[E], S = q2(E), $ = f[E], P = ((d = $?._zod) == null ? void 0 : d.optout) === "optional";
      p.write(`const ${x} = ${m(E)};`), P ? p.write(`
        if (${x}.issues.length) {
          if (${S} in input) {
            payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${S}, ...iss.path] : [${S}]
            })));
          }
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `) : p.write(`
        if (${x}.issues.length) {
          payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${S}, ...iss.path] : [${S}]
          })));
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `);
    }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const b = p.compile();
    return (E, x) => b(f, E, x);
  };
  let o;
  const a = Ud, s = !JI.jitless, l = s && mre.value, u = t.catchall;
  let c;
  e._zod.parse = (f, d) => {
    c ?? (c = r.value);
    const p = f.value;
    return a(p) ? s && l && d?.async === !1 && d.jitless !== !0 ? (o || (o = i(t.shape)), f = o(f, d), u ? m3([], p, f, d, c, e) : f) : n(f, d) : (f.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), f);
  };
});
function Z2(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !xs(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((a) => Ca(a, r, Aa())))
  }), t);
}
const noe = /* @__PURE__ */ le("$ZodUnion", (e, t) => {
  Xt.init(e, t), pt(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), pt(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), pt(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), pt(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => g1(o.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (n)
      return r(i, o);
    let a = !1;
    const s = [];
    for (const l of t.options) {
      const u = l._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (u instanceof Promise)
        s.push(u), a = !0;
      else {
        if (u.issues.length === 0)
          return u;
        s.push(u);
      }
    }
    return a ? Promise.all(s).then((l) => Z2(l, i, e, o)) : Z2(s, i, e, o);
  };
}), roe = /* @__PURE__ */ le("$ZodIntersection", (e, t) => {
  Xt.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, o = t.left._zod.run({ value: i, issues: [] }, r), a = t.right._zod.run({ value: i, issues: [] }, r);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([s, l]) => G2(n, s, l)) : G2(n, o, a);
  };
});
function vy(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Gu(e) && Gu(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((o) => n.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of r) {
      const a = vy(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], o = t[r], a = vy(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function G2(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).l = !0;
    } else
      e.issues.push(s);
  for (const s of n.issues)
    if (s.code === "unrecognized_keys")
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).r = !0;
    else
      e.issues.push(s);
  const o = [...r].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), xs(e))
    return e;
  const a = vy(t.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const ioe = /* @__PURE__ */ le("$ZodEnum", (e, t) => {
  Xt.init(e, t);
  const n = XI(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => vre.has(typeof i)).map((i) => typeof i == "string" ? ih(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return r.has(a) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: e
    }), i;
  };
}), ooe = /* @__PURE__ */ le("$ZodTransform", (e, t) => {
  Xt.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new QI(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n));
    if (i instanceof Promise)
      throw new As();
    return n.value = i, n;
  };
});
function Y2(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const v3 = /* @__PURE__ */ le("$ZodOptional", (e, t) => {
  Xt.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", pt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), pt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${g1(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((o) => Y2(o, n.value)) : Y2(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), aoe = /* @__PURE__ */ le("$ZodExactOptional", (e, t) => {
  v3.init(e, t), pt(e._zod, "values", () => t.innerType._zod.values), pt(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), soe = /* @__PURE__ */ le("$ZodNullable", (e, t) => {
  Xt.init(e, t), pt(e._zod, "optin", () => t.innerType._zod.optin), pt(e._zod, "optout", () => t.innerType._zod.optout), pt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${g1(n.source)}|null)$`) : void 0;
  }), pt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), loe = /* @__PURE__ */ le("$ZodDefault", (e, t) => {
  Xt.init(e, t), e._zod.optin = "optional", pt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => Q2(o, t)) : Q2(i, t);
  };
});
function Q2(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const uoe = /* @__PURE__ */ le("$ZodPrefault", (e, t) => {
  Xt.init(e, t), e._zod.optin = "optional", pt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), coe = /* @__PURE__ */ le("$ZodNonOptional", (e, t) => {
  Xt.init(e, t), pt(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => J2(o, e)) : J2(i, e);
  };
});
function J2(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const foe = /* @__PURE__ */ le("$ZodCatch", (e, t) => {
  Xt.init(e, t), pt(e._zod, "optin", () => t.innerType._zod.optin), pt(e._zod, "optout", () => t.innerType._zod.optout), pt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((a) => Ca(a, r, Aa()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((o) => Ca(o, r, Aa()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), doe = /* @__PURE__ */ le("$ZodPipe", (e, t) => {
  Xt.init(e, t), pt(e._zod, "values", () => t.in._zod.values), pt(e._zod, "optin", () => t.in._zod.optin), pt(e._zod, "optout", () => t.out._zod.optout), pt(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const o = t.out._zod.run(n, r);
      return o instanceof Promise ? o.then((a) => lf(a, t.in, r)) : lf(o, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => lf(o, t.out, r)) : lf(i, t.out, r);
  };
});
function lf(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const poe = /* @__PURE__ */ le("$ZodReadonly", (e, t) => {
  Xt.init(e, t), pt(e._zod, "propValues", () => t.innerType._zod.propValues), pt(e._zod, "values", () => t.innerType._zod.values), pt(e._zod, "optin", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), pt(e._zod, "optout", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(X2) : X2(i);
  };
});
function X2(e) {
  return e.value = Object.freeze(e.value), e;
}
const hoe = /* @__PURE__ */ le("$ZodCustom", (e, t) => {
  er.init(e, t), Xt.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((o) => e$(o, n, r, e));
    e$(i, n, r, e);
  };
});
function e$(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(Yu(i));
  }
}
var t$;
class moe {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function voe() {
  return new moe();
}
(t$ = globalThis).__zod_globalRegistry ?? (t$.__zod_globalRegistry = voe());
const ru = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function goe(e, t) {
  return new e({
    type: "string",
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yoe(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function n$(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function boe(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function _oe(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function woe(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xoe(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Eoe(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Soe(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $oe(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Toe(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ooe(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function koe(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Poe(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Doe(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Aoe(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Coe(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ioe(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Moe(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Roe(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Noe(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function joe(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Foe(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zoe(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Loe(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Voe(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Boe(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Koe(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Uoe(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qoe(e, t) {
  return new e({
    type: "boolean",
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Hoe(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function Woe(e, t) {
  return new e({
    type: "never",
    ...Ke(t)
  });
}
// @__NO_SIDE_EFFECTS__
function r$(e, t) {
  return new c3({
    check: "less_than",
    ...Ke(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function qm(e, t) {
  return new c3({
    check: "less_than",
    ...Ke(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function i$(e, t) {
  return new f3({
    check: "greater_than",
    ...Ke(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Hm(e, t) {
  return new f3({
    check: "greater_than",
    ...Ke(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function o$(e, t) {
  return new cie({
    check: "multiple_of",
    ...Ke(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function g3(e, t) {
  return new die({
    check: "max_length",
    ...Ke(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Hd(e, t) {
  return new pie({
    check: "min_length",
    ...Ke(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function y3(e, t) {
  return new hie({
    check: "length_equals",
    ...Ke(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function Zoe(e, t) {
  return new mie({
    check: "string_format",
    format: "regex",
    ...Ke(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function Goe(e) {
  return new vie({
    check: "string_format",
    format: "lowercase",
    ...Ke(e)
  });
}
// @__NO_SIDE_EFFECTS__
function Yoe(e) {
  return new gie({
    check: "string_format",
    format: "uppercase",
    ...Ke(e)
  });
}
// @__NO_SIDE_EFFECTS__
function Qoe(e, t) {
  return new yie({
    check: "string_format",
    format: "includes",
    ...Ke(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function Joe(e, t) {
  return new bie({
    check: "string_format",
    format: "starts_with",
    ...Ke(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Xoe(e, t) {
  return new _ie({
    check: "string_format",
    format: "ends_with",
    ...Ke(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Pl(e) {
  return new wie({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function eae(e) {
  return /* @__PURE__ */ Pl((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function tae() {
  return /* @__PURE__ */ Pl((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function nae() {
  return /* @__PURE__ */ Pl((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function rae() {
  return /* @__PURE__ */ Pl((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function iae() {
  return /* @__PURE__ */ Pl((e) => hre(e));
}
// @__NO_SIDE_EFFECTS__
function oae(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...Ke(n)
  });
}
// @__NO_SIDE_EFFECTS__
function aae(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...Ke(n)
  });
}
// @__NO_SIDE_EFFECTS__
function sae(e) {
  const t = /* @__PURE__ */ lae((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(Yu(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(Yu(i));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function lae(e, t) {
  const n = new er({
    check: "custom",
    ...Ke(t)
  });
  return n._zod.check = e, n;
}
function b3(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? ru,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function wn(e, t, n = { path: [], schemaPath: [] }) {
  var r, i, o;
  const a = e._zod.def, s = t.seen.get(e);
  if (s)
    return s.count++, n.schemaPath.includes(e) && (s.cycle = n.path), s.schema;
  const l = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, l);
  const u = (i = (r = e._zod).toJSONSchema) == null ? void 0 : i.call(r);
  if (u)
    l.schema = u;
  else {
    const f = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, l.schema, f);
    else {
      const p = l.schema, h = t.processors[a.type];
      if (!h)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${a.type}`);
      h(e, t, p, f);
    }
    const d = e._zod.parent;
    d && (l.ref || (l.ref = d), wn(d, t, f), t.seen.get(d).isParent = !0);
  }
  const c = t.metadataRegistry.get(e);
  return c && Object.assign(l.schema, c), t.io === "input" && Dn(e) && (delete l.schema.examples, delete l.schema.default), t.io === "input" && l.schema._prefault && ((o = l.schema).default ?? (o.default = l.schema._prefault)), delete l.schema._prefault, t.seen.get(e).schema;
}
function _3(e, t) {
  var n, r, i, o;
  const a = e.seen.get(t);
  if (!a)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = /* @__PURE__ */ new Map();
  for (const c of e.seen.entries()) {
    const f = (n = e.metadataRegistry.get(c[0])) == null ? void 0 : n.id;
    if (f) {
      const d = s.get(f);
      if (d && d !== c[0])
        throw new Error(`Duplicate schema id "${f}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      s.set(f, c[0]);
    }
  }
  const l = (c) => {
    var f;
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const m = (f = e.external.registry.get(c[0])) == null ? void 0 : f.id, v = e.external.uri ?? ((b) => b);
      if (m)
        return { ref: v(m) };
      const g = c[1].defId ?? c[1].schema.id ?? `schema${e.counter++}`;
      return c[1].defId = g, { defId: g, ref: `${v("__shared")}#/${d}/${g}` };
    }
    if (c[1] === a)
      return { ref: "#" };
    const p = `#/${d}/`, h = c[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: h, ref: p + h };
  }, u = (c) => {
    if (c[1].schema.$ref)
      return;
    const f = c[1], { ref: d, defId: p } = l(c);
    f.def = { ...f.schema }, p && (f.defId = p);
    const h = f.schema;
    for (const m in h)
      delete h[m];
    h.$ref = d;
  };
  if (e.cycles === "throw")
    for (const c of e.seen.entries()) {
      const f = c[1];
      if (f.cycle)
        throw new Error(`Cycle detected: #/${(r = f.cycle) == null ? void 0 : r.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const c of e.seen.entries()) {
    const f = c[1];
    if (t === c[0]) {
      u(c);
      continue;
    }
    if (e.external) {
      const d = (i = e.external.registry.get(c[0])) == null ? void 0 : i.id;
      if (t !== c[0] && d) {
        u(c);
        continue;
      }
    }
    if ((o = e.metadataRegistry.get(c[0])) != null && o.id) {
      u(c);
      continue;
    }
    if (f.cycle) {
      u(c);
      continue;
    }
    if (f.count > 1 && e.reused === "ref") {
      u(c);
      continue;
    }
  }
}
function w3(e, t) {
  var n, r, i;
  const o = e.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (u) => {
    const c = e.seen.get(u);
    if (c.ref === null)
      return;
    const f = c.def ?? c.schema, d = { ...f }, p = c.ref;
    if (c.ref = null, p) {
      a(p);
      const m = e.seen.get(p), v = m.schema;
      if (v.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (f.allOf = f.allOf ?? [], f.allOf.push(v)) : Object.assign(f, v), Object.assign(f, d), u._zod.parent === p)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in d || delete f[g];
      if (v.$ref && m.def)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in m.def && JSON.stringify(f[g]) === JSON.stringify(m.def[g]) && delete f[g];
    }
    const h = u._zod.parent;
    if (h && h !== p) {
      a(h);
      const m = e.seen.get(h);
      if (m != null && m.schema.$ref && (f.$ref = m.schema.$ref, m.def))
        for (const v in f)
          v === "$ref" || v === "allOf" || v in m.def && JSON.stringify(f[v]) === JSON.stringify(m.def[v]) && delete f[v];
    }
    e.override({
      zodSchema: u,
      jsonSchema: f,
      path: c.path ?? []
    });
  };
  for (const u of [...e.seen.entries()].reverse())
    a(u[0]);
  const s = {};
  if (e.target === "draft-2020-12" ? s.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? s.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? s.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (n = e.external) != null && n.uri) {
    const u = (r = e.external.registry.get(t)) == null ? void 0 : r.id;
    if (!u)
      throw new Error("Schema is missing an `id` property");
    s.$id = e.external.uri(u);
  }
  Object.assign(s, o.def ?? o.schema);
  const l = ((i = e.external) == null ? void 0 : i.defs) ?? {};
  for (const u of e.seen.entries()) {
    const c = u[1];
    c.def && c.defId && (l[c.defId] = c.def);
  }
  e.external || Object.keys(l).length > 0 && (e.target === "draft-2020-12" ? s.$defs = l : s.definitions = l);
  try {
    const u = JSON.parse(JSON.stringify(s));
    return Object.defineProperty(u, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Wd(t, "input", e.processors),
          output: Wd(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), u;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Dn(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return Dn(r.element, n);
  if (r.type === "set")
    return Dn(r.valueType, n);
  if (r.type === "lazy")
    return Dn(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return Dn(r.innerType, n);
  if (r.type === "intersection")
    return Dn(r.left, n) || Dn(r.right, n);
  if (r.type === "record" || r.type === "map")
    return Dn(r.keyType, n) || Dn(r.valueType, n);
  if (r.type === "pipe")
    return Dn(r.in, n) || Dn(r.out, n);
  if (r.type === "object") {
    for (const i in r.shape)
      if (Dn(r.shape[i], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const i of r.options)
      if (Dn(i, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const i of r.items)
      if (Dn(i, n))
        return !0;
    return !!(r.rest && Dn(r.rest, n));
  }
  return !1;
}
const uae = (e, t = {}) => (n) => {
  const r = b3({ ...n, processors: t });
  return wn(e, r), _3(r, e), w3(r, e);
}, Wd = (e, t, n = {}) => (r) => {
  const { libraryOptions: i, target: o } = r ?? {}, a = b3({ ...i ?? {}, target: o, io: t, processors: n });
  return wn(e, a), _3(a, e), w3(a, e);
}, cae = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, fae = (e, t, n, r) => {
  const i = n;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: l, contentEncoding: u } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = cae[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), u && (i.contentEncoding = u), l && l.size > 0) {
    const c = [...l];
    c.length === 1 ? i.pattern = c[0].source : c.length > 1 && (i.allOf = [
      ...c.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, dae = (e, t, n, r) => {
  const i = n, { minimum: o, maximum: a, format: s, multipleOf: l, exclusiveMaximum: u, exclusiveMinimum: c } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = c, i.exclusiveMinimum = !0) : i.exclusiveMinimum = c), typeof o == "number" && (i.minimum = o, typeof c == "number" && t.target !== "draft-04" && (c >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof u == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = u, i.exclusiveMaximum = !0) : i.exclusiveMaximum = u), typeof a == "number" && (i.maximum = a, typeof u == "number" && t.target !== "draft-04" && (u <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof l == "number" && (i.multipleOf = l);
}, pae = (e, t, n, r) => {
  n.type = "boolean";
}, hae = (e, t, n, r) => {
  n.not = {};
}, mae = (e, t, n, r) => {
}, vae = (e, t, n, r) => {
  const i = e._zod.def, o = XI(i.entries);
  o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), n.enum = o;
}, gae = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, yae = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, bae = (e, t, n, r) => {
  const i = n, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = wn(o.element, t, { ...r, path: [...r.path, "items"] });
}, _ae = (e, t, n, r) => {
  var i;
  const o = n, a = e._zod.def;
  o.type = "object", o.properties = {};
  const s = a.shape;
  for (const c in s)
    o.properties[c] = wn(s[c], t, {
      ...r,
      path: [...r.path, "properties", c]
    });
  const l = new Set(Object.keys(s)), u = new Set([...l].filter((c) => {
    const f = a.shape[c]._zod;
    return t.io === "input" ? f.optin === void 0 : f.optout === void 0;
  }));
  u.size > 0 && (o.required = Array.from(u)), ((i = a.catchall) == null ? void 0 : i._zod.def.type) === "never" ? o.additionalProperties = !1 : a.catchall ? a.catchall && (o.additionalProperties = wn(a.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, wae = (e, t, n, r) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, l) => wn(s, t, {
    ...r,
    path: [...r.path, o ? "oneOf" : "anyOf", l]
  }));
  o ? n.oneOf = a : n.anyOf = a;
}, xae = (e, t, n, r) => {
  const i = e._zod.def, o = wn(i.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = wn(i.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), s = (u) => "allOf" in u && Object.keys(u).length === 1, l = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  n.allOf = l;
}, Eae = (e, t, n, r) => {
  const i = e._zod.def, o = wn(i.innerType, t, r), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, n.nullable = !0) : n.anyOf = [o, { type: "null" }];
}, Sae = (e, t, n, r) => {
  const i = e._zod.def;
  wn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, $ae = (e, t, n, r) => {
  const i = e._zod.def;
  wn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, Tae = (e, t, n, r) => {
  const i = e._zod.def;
  wn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, Oae = (e, t, n, r) => {
  const i = e._zod.def;
  wn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = a;
}, kae = (e, t, n, r) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  wn(o, t, r);
  const a = t.seen.get(e);
  a.ref = o;
}, Pae = (e, t, n, r) => {
  const i = e._zod.def;
  wn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.readOnly = !0;
}, x3 = (e, t, n, r) => {
  const i = e._zod.def;
  wn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Dae = /* @__PURE__ */ le("ZodISODateTime", (e, t) => {
  Rie.init(e, t), Ut.init(e, t);
});
function Aae(e) {
  return /* @__PURE__ */ zoe(Dae, e);
}
const Cae = /* @__PURE__ */ le("ZodISODate", (e, t) => {
  Nie.init(e, t), Ut.init(e, t);
});
function Iae(e) {
  return /* @__PURE__ */ Loe(Cae, e);
}
const Mae = /* @__PURE__ */ le("ZodISOTime", (e, t) => {
  jie.init(e, t), Ut.init(e, t);
});
function Rae(e) {
  return /* @__PURE__ */ Voe(Mae, e);
}
const Nae = /* @__PURE__ */ le("ZodISODuration", (e, t) => {
  Fie.init(e, t), Ut.init(e, t);
});
function jae(e) {
  return /* @__PURE__ */ Boe(Nae, e);
}
const Fae = (e, t) => {
  i3.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => Ore(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => Tre(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, my, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, my, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Fr = le("ZodError", Fae, {
  Parent: Error
}), zae = /* @__PURE__ */ b1(Fr), Lae = /* @__PURE__ */ _1(Fr), Vae = /* @__PURE__ */ oh(Fr), Bae = /* @__PURE__ */ ah(Fr), Kae = /* @__PURE__ */ Dre(Fr), Uae = /* @__PURE__ */ Are(Fr), qae = /* @__PURE__ */ Cre(Fr), Hae = /* @__PURE__ */ Ire(Fr), Wae = /* @__PURE__ */ Mre(Fr), Zae = /* @__PURE__ */ Rre(Fr), Gae = /* @__PURE__ */ Nre(Fr), Yae = /* @__PURE__ */ jre(Fr), en = /* @__PURE__ */ le("ZodType", (e, t) => (Xt.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: Wd(e, "input"),
    output: Wd(e, "output")
  }
}), e.toJSONSchema = uae(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(qo(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, r) => Ho(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => zae(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => Vae(e, n, r), e.parseAsync = async (n, r) => Lae(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => Bae(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => Kae(e, n, r), e.decode = (n, r) => Uae(e, n, r), e.encodeAsync = async (n, r) => qae(e, n, r), e.decodeAsync = async (n, r) => Hae(e, n, r), e.safeEncode = (n, r) => Wae(e, n, r), e.safeDecode = (n, r) => Zae(e, n, r), e.safeEncodeAsync = async (n, r) => Gae(e, n, r), e.safeDecodeAsync = async (n, r) => Yae(e, n, r), e.refine = (n, r) => e.check(Bse(n, r)), e.superRefine = (n) => e.check(Kse(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ Pl(n)), e.optional = () => l$(e), e.exactOptional = () => Pse(e), e.nullable = () => u$(e), e.nullish = () => l$(u$(e)), e.nonoptional = (n) => Rse(e, n), e.array = () => at(e), e.or = (n) => Ese([e, n]), e.and = (n) => $se(e, n), e.transform = (n) => c$(e, Ose(n)), e.default = (n) => Cse(e, n), e.prefault = (n) => Mse(e, n), e.catch = (n) => jse(e, n), e.pipe = (n) => c$(e, n), e.readonly = () => Lse(e), e.describe = (n) => {
  const r = e.clone();
  return ru.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = ru.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return ru.get(e);
  const r = e.clone();
  return ru.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), E3 = /* @__PURE__ */ le("_ZodString", (e, t) => {
  w1.init(e, t), en.init(e, t), e._zod.processJSONSchema = (r, i, o) => fae(e, r, i);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(/* @__PURE__ */ Zoe(...r)), e.includes = (...r) => e.check(/* @__PURE__ */ Qoe(...r)), e.startsWith = (...r) => e.check(/* @__PURE__ */ Joe(...r)), e.endsWith = (...r) => e.check(/* @__PURE__ */ Xoe(...r)), e.min = (...r) => e.check(/* @__PURE__ */ Hd(...r)), e.max = (...r) => e.check(/* @__PURE__ */ g3(...r)), e.length = (...r) => e.check(/* @__PURE__ */ y3(...r)), e.nonempty = (...r) => e.check(/* @__PURE__ */ Hd(1, ...r)), e.lowercase = (r) => e.check(/* @__PURE__ */ Goe(r)), e.uppercase = (r) => e.check(/* @__PURE__ */ Yoe(r)), e.trim = () => e.check(/* @__PURE__ */ tae()), e.normalize = (...r) => e.check(/* @__PURE__ */ eae(...r)), e.toLowerCase = () => e.check(/* @__PURE__ */ nae()), e.toUpperCase = () => e.check(/* @__PURE__ */ rae()), e.slugify = () => e.check(/* @__PURE__ */ iae());
}), Qae = /* @__PURE__ */ le("ZodString", (e, t) => {
  w1.init(e, t), E3.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ yoe(Jae, n)), e.url = (n) => e.check(/* @__PURE__ */ Eoe(Xae, n)), e.jwt = (n) => e.check(/* @__PURE__ */ Foe(hse, n)), e.emoji = (n) => e.check(/* @__PURE__ */ Soe(ese, n)), e.guid = (n) => e.check(/* @__PURE__ */ n$(a$, n)), e.uuid = (n) => e.check(/* @__PURE__ */ boe(uf, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ _oe(uf, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ woe(uf, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ xoe(uf, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ $oe(tse, n)), e.guid = (n) => e.check(/* @__PURE__ */ n$(a$, n)), e.cuid = (n) => e.check(/* @__PURE__ */ Toe(nse, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ Ooe(rse, n)), e.ulid = (n) => e.check(/* @__PURE__ */ koe(ise, n)), e.base64 = (n) => e.check(/* @__PURE__ */ Roe(fse, n)), e.base64url = (n) => e.check(/* @__PURE__ */ Noe(dse, n)), e.xid = (n) => e.check(/* @__PURE__ */ Poe(ose, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ Doe(ase, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ Aoe(sse, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ Coe(lse, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ Ioe(use, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ Moe(cse, n)), e.e164 = (n) => e.check(/* @__PURE__ */ joe(pse, n)), e.datetime = (n) => e.check(Aae(n)), e.date = (n) => e.check(Iae(n)), e.time = (n) => e.check(Rae(n)), e.duration = (n) => e.check(jae(n));
});
function ie(e) {
  return /* @__PURE__ */ goe(Qae, e);
}
const Ut = /* @__PURE__ */ le("ZodStringFormat", (e, t) => {
  Ft.init(e, t), E3.init(e, t);
}), Jae = /* @__PURE__ */ le("ZodEmail", (e, t) => {
  Tie.init(e, t), Ut.init(e, t);
}), a$ = /* @__PURE__ */ le("ZodGUID", (e, t) => {
  Sie.init(e, t), Ut.init(e, t);
}), uf = /* @__PURE__ */ le("ZodUUID", (e, t) => {
  $ie.init(e, t), Ut.init(e, t);
}), Xae = /* @__PURE__ */ le("ZodURL", (e, t) => {
  Oie.init(e, t), Ut.init(e, t);
}), ese = /* @__PURE__ */ le("ZodEmoji", (e, t) => {
  kie.init(e, t), Ut.init(e, t);
}), tse = /* @__PURE__ */ le("ZodNanoID", (e, t) => {
  Pie.init(e, t), Ut.init(e, t);
}), nse = /* @__PURE__ */ le("ZodCUID", (e, t) => {
  Die.init(e, t), Ut.init(e, t);
}), rse = /* @__PURE__ */ le("ZodCUID2", (e, t) => {
  Aie.init(e, t), Ut.init(e, t);
}), ise = /* @__PURE__ */ le("ZodULID", (e, t) => {
  Cie.init(e, t), Ut.init(e, t);
}), ose = /* @__PURE__ */ le("ZodXID", (e, t) => {
  Iie.init(e, t), Ut.init(e, t);
}), ase = /* @__PURE__ */ le("ZodKSUID", (e, t) => {
  Mie.init(e, t), Ut.init(e, t);
}), sse = /* @__PURE__ */ le("ZodIPv4", (e, t) => {
  zie.init(e, t), Ut.init(e, t);
}), lse = /* @__PURE__ */ le("ZodIPv6", (e, t) => {
  Lie.init(e, t), Ut.init(e, t);
}), use = /* @__PURE__ */ le("ZodCIDRv4", (e, t) => {
  Vie.init(e, t), Ut.init(e, t);
}), cse = /* @__PURE__ */ le("ZodCIDRv6", (e, t) => {
  Bie.init(e, t), Ut.init(e, t);
}), fse = /* @__PURE__ */ le("ZodBase64", (e, t) => {
  Kie.init(e, t), Ut.init(e, t);
}), dse = /* @__PURE__ */ le("ZodBase64URL", (e, t) => {
  qie.init(e, t), Ut.init(e, t);
}), pse = /* @__PURE__ */ le("ZodE164", (e, t) => {
  Hie.init(e, t), Ut.init(e, t);
}), hse = /* @__PURE__ */ le("ZodJWT", (e, t) => {
  Zie.init(e, t), Ut.init(e, t);
}), S3 = /* @__PURE__ */ le("ZodNumber", (e, t) => {
  p3.init(e, t), en.init(e, t), e._zod.processJSONSchema = (r, i, o) => dae(e, r, i), e.gt = (r, i) => e.check(/* @__PURE__ */ i$(r, i)), e.gte = (r, i) => e.check(/* @__PURE__ */ Hm(r, i)), e.min = (r, i) => e.check(/* @__PURE__ */ Hm(r, i)), e.lt = (r, i) => e.check(/* @__PURE__ */ r$(r, i)), e.lte = (r, i) => e.check(/* @__PURE__ */ qm(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ qm(r, i)), e.int = (r) => e.check(s$(r)), e.safe = (r) => e.check(s$(r)), e.positive = (r) => e.check(/* @__PURE__ */ i$(0, r)), e.nonnegative = (r) => e.check(/* @__PURE__ */ Hm(0, r)), e.negative = (r) => e.check(/* @__PURE__ */ r$(0, r)), e.nonpositive = (r) => e.check(/* @__PURE__ */ qm(0, r)), e.multipleOf = (r, i) => e.check(/* @__PURE__ */ o$(r, i)), e.step = (r, i) => e.check(/* @__PURE__ */ o$(r, i)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function Oe(e) {
  return /* @__PURE__ */ Koe(S3, e);
}
const mse = /* @__PURE__ */ le("ZodNumberFormat", (e, t) => {
  Gie.init(e, t), S3.init(e, t);
});
function s$(e) {
  return /* @__PURE__ */ Uoe(mse, e);
}
const vse = /* @__PURE__ */ le("ZodBoolean", (e, t) => {
  Yie.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => pae(e, n, r);
});
function dr(e) {
  return /* @__PURE__ */ qoe(vse, e);
}
const gse = /* @__PURE__ */ le("ZodUnknown", (e, t) => {
  Qie.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => mae();
});
function Zd() {
  return /* @__PURE__ */ Hoe(gse);
}
const yse = /* @__PURE__ */ le("ZodNever", (e, t) => {
  Jie.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => hae(e, n, r);
});
function bse(e) {
  return /* @__PURE__ */ Woe(yse, e);
}
const _se = /* @__PURE__ */ le("ZodArray", (e, t) => {
  Xie.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => bae(e, n, r, i), e.element = t.element, e.min = (n, r) => e.check(/* @__PURE__ */ Hd(n, r)), e.nonempty = (n) => e.check(/* @__PURE__ */ Hd(1, n)), e.max = (n, r) => e.check(/* @__PURE__ */ g3(n, r)), e.length = (n, r) => e.check(/* @__PURE__ */ y3(n, r)), e.unwrap = () => e.element;
});
function at(e, t) {
  return /* @__PURE__ */ oae(_se, e, t);
}
const wse = /* @__PURE__ */ le("ZodObject", (e, t) => {
  toe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => _ae(e, n, r, i), pt(e, "shape", () => t.shape), e.keyof = () => Mi(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Zd() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Zd() }), e.strict = () => e.clone({ ...e._zod.def, catchall: bse() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => wre(e, n), e.safeExtend = (n) => xre(e, n), e.merge = (n) => Ere(e, n), e.pick = (n) => bre(e, n), e.omit = (n) => _re(e, n), e.partial = (...n) => Sre($3, e, n[0]), e.required = (...n) => $re(T3, e, n[0]);
});
function he(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...Ke(t)
  };
  return new wse(n);
}
const xse = /* @__PURE__ */ le("ZodUnion", (e, t) => {
  noe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => wae(e, n, r, i), e.options = t.options;
});
function Ese(e, t) {
  return new xse({
    type: "union",
    options: e,
    ...Ke(t)
  });
}
const Sse = /* @__PURE__ */ le("ZodIntersection", (e, t) => {
  roe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => xae(e, n, r, i);
});
function $se(e, t) {
  return new Sse({
    type: "intersection",
    left: e,
    right: t
  });
}
const gy = /* @__PURE__ */ le("ZodEnum", (e, t) => {
  ioe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (r, i, o) => vae(e, r, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const o = {};
    for (const a of r)
      if (n.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new gy({
      ...t,
      checks: [],
      ...Ke(i),
      entries: o
    });
  }, e.exclude = (r, i) => {
    const o = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new gy({
      ...t,
      checks: [],
      ...Ke(i),
      entries: o
    });
  };
});
function Mi(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new gy({
    type: "enum",
    entries: n,
    ...Ke(t)
  });
}
const Tse = /* @__PURE__ */ le("ZodTransform", (e, t) => {
  ooe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => yae(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new QI(e.constructor.name);
    n.addIssue = (o) => {
      if (typeof o == "string")
        n.issues.push(Yu(o, n.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = e), n.issues.push(Yu(a));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((o) => (n.value = o, n)) : (n.value = i, n);
  };
});
function Ose(e) {
  return new Tse({
    type: "transform",
    transform: e
  });
}
const $3 = /* @__PURE__ */ le("ZodOptional", (e, t) => {
  v3.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => x3(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function l$(e) {
  return new $3({
    type: "optional",
    innerType: e
  });
}
const kse = /* @__PURE__ */ le("ZodExactOptional", (e, t) => {
  aoe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => x3(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Pse(e) {
  return new kse({
    type: "optional",
    innerType: e
  });
}
const Dse = /* @__PURE__ */ le("ZodNullable", (e, t) => {
  soe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => Eae(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function u$(e) {
  return new Dse({
    type: "nullable",
    innerType: e
  });
}
const Ase = /* @__PURE__ */ le("ZodDefault", (e, t) => {
  loe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => $ae(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Cse(e, t) {
  return new Ase({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t3(t);
    }
  });
}
const Ise = /* @__PURE__ */ le("ZodPrefault", (e, t) => {
  uoe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => Tae(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Mse(e, t) {
  return new Ise({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t3(t);
    }
  });
}
const T3 = /* @__PURE__ */ le("ZodNonOptional", (e, t) => {
  coe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => Sae(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Rse(e, t) {
  return new T3({
    type: "nonoptional",
    innerType: e,
    ...Ke(t)
  });
}
const Nse = /* @__PURE__ */ le("ZodCatch", (e, t) => {
  foe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => Oae(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function jse(e, t) {
  return new Nse({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Fse = /* @__PURE__ */ le("ZodPipe", (e, t) => {
  doe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => kae(e, n, r, i), e.in = t.in, e.out = t.out;
});
function c$(e, t) {
  return new Fse({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const zse = /* @__PURE__ */ le("ZodReadonly", (e, t) => {
  poe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => Pae(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Lse(e) {
  return new zse({
    type: "readonly",
    innerType: e
  });
}
const Vse = /* @__PURE__ */ le("ZodCustom", (e, t) => {
  hoe.init(e, t), en.init(e, t), e._zod.processJSONSchema = (n, r, i) => gae(e, n);
});
function Bse(e, t = {}) {
  return /* @__PURE__ */ aae(Vse, e, t);
}
function Kse(e) {
  return /* @__PURE__ */ sae(e);
}
const Use = he({
  id: ie(),
  name: ie(),
  slug: ie(),
  status: Mi(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  input: he({}).partial().passthrough(),
  output: he({}).partial().passthrough().nullable(),
  createdAt: ie(),
  startedAt: ie().nullable(),
  endedAt: ie().nullable()
}).passthrough();
he({ analyses: at(Use) }).passthrough();
he({
  name: ie().min(1).max(100),
  outputLocation: he({ s3BucketId: Oe(), path: ie().optional() }).passthrough(),
  analysisSchemaId: Oe().int().gt(0),
  version: Oe(),
  input: Zd()
}).passthrough();
he({
  analysisId: ie().nullable(),
  analysisSlug: ie().nullable(),
  success: dr()
}).passthrough();
const qse = he({ id: Oe(), name: ie(), versions: at(Oe()) }).passthrough();
he({ analysisSchemas: at(qse) }).passthrough();
const O3 = he({
  id: Oe(),
  name: ie(),
  schema: he({}).partial().passthrough()
}).passthrough(), f$ = he({ id: Oe(), name: ie(), valueSchema: O3 }).passthrough(), Hse = he({
  analysisSchemaId: Oe(),
  version: Oe(),
  createdAt: ie(),
  description: he({ short: ie().nullable(), long: ie().nullable() }).partial().passthrough(),
  inputs: at(f$),
  outputs: at(f$)
}).passthrough();
he({ versions: at(Hse) }).passthrough();
he({ logs: at(ie()) }).passthrough();
const Wse = he({
  id: ie(),
  name: ie(),
  status: ie(),
  analysisId: ie(),
  startedAt: ie(),
  endedAt: ie(),
  memory: Oe(),
  vcpus: Oe(),
  cost: Oe()
}).passthrough();
he({ tasks: at(Wse) }).passthrough();
he({
  totalCost: Oe(),
  tasks: at(he({ name: ie(), cost: Oe() }).passthrough()),
  runner: Oe()
}).passthrough();
const Zse = he({
  analysisSchemaId: Oe(),
  version: Oe(),
  name: ie()
}).passthrough();
he({ next: at(Zse) }).passthrough();
he({ valueSchemas: at(O3) }).passthrough();
const Gse = Mi([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), k3 = Mi([
  "admin",
  "credits_unlimited",
  "files_read",
  "keypair_read",
  "lab_create",
  "labmember_read",
  "labmember_write",
  "lab_read",
  "plexus_read",
  "plexus_write",
  "tinkerbox_launch",
  "tinkerbox_read",
  "user_update"
]), P3 = he({
  id: ie(),
  firstname: ie().nullable(),
  lastname: ie().nullable(),
  email: ie().nullable(),
  keyPairId: Oe(),
  roles: at(Gse),
  permissions: at(k3)
}).passthrough();
he({ user: P3 }).partial().passthrough();
he({ email: ie() }).passthrough();
he({ success: dr() }).passthrough();
he({ otp: ie() }).passthrough();
he({ success: dr() }).passthrough();
const Yse = he({ success: dr() }).passthrough();
he({ token: ie() }).passthrough();
he({ token: ie() }).passthrough();
he({ valid: dr() }).passthrough();
he({ name: ie(), permissions: at(k3) }).passthrough();
const Qse = he({
  id: Oe(),
  instanceProfile: ie().nullable(),
  securityGroup: ie().nullable()
}).passthrough(), lh = he({
  id: Oe(),
  name: ie(),
  labId: Oe().nullish(),
  userId: ie().nullish(),
  status: Mi([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: ie().nullish(),
  lastLogin: ie().nullish(),
  keypairId: Oe().nullish()
}).passthrough();
he({
  infra: at(Qse),
  keyPairs: at(ie()),
  tinkerBoxes: at(lh)
}).passthrough();
he({ count: Oe().gte(1).lte(15) }).passthrough();
he({
  firstname: ie().min(1),
  lastname: ie().min(1),
  email: ie().email(),
  password: ie().min(8)
}).passthrough();
he({ users: at(P3) }).passthrough();
he({
  firstname: ie().nullable(),
  lastname: ie().nullable(),
  email: ie().nullable()
}).partial().passthrough();
const Jse = he({ tinkerBox: lh, keyMaterial: ie() }).passthrough();
he({ tinkerBoxes: at(Jse) }).passthrough();
const Xse = he({
  labName: ie(),
  ec2Cost: Oe(),
  s3Cost: Oe(),
  efsCost: Oe(),
  totalCost: Oe()
}).passthrough();
he({ clients: at(Xse) }).passthrough();
const ele = he({
  name: ie(),
  labName: ie(),
  usage: ie(),
  cost: Oe()
}).passthrough();
he({ tinkerBoxes: at(ele) }).passthrough();
he({ tinkerboxes: at(lh) }).passthrough();
he({ tinkerBox: lh }).passthrough();
he({ name: ie() }).passthrough();
const tle = he({
  id: Oe(),
  date: ie(),
  tinkerBoxName: ie(),
  lastLoginDate: ie().nullable(),
  lastCommandDate: ie().nullable(),
  lastCommand: ie().nullable(),
  activeProcesses: dr(),
  status: Mi([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  tinkerBoxId: Oe(),
  autoStopTime: ie().nullable()
}).passthrough();
he({ allLastActivity: at(tle) }).passthrough();
he({ name: ie().nullable() }).partial().passthrough();
const nle = he({
  id: Oe(),
  name: ie(),
  s3BucketId: Oe(),
  keyPairId: Oe()
}).passthrough();
he({ labs: at(nle) }).passthrough();
he({
  name: ie(),
  numTinkerBoxes: Oe().optional().default(1)
}).passthrough();
he({ labId: Oe(), taskId: ie() }).passthrough();
he({ id: ie(), labId: Oe(), logs: ie() }).passthrough();
const D3 = he({
  id: Oe(),
  labId: Oe(),
  userId: ie(),
  role: Mi(["OWNER", "MEMBER"]),
  user: he({
    firstname: ie().nullable(),
    lastname: ie().nullable(),
    email: ie().nullable(),
    id: ie()
  }).partial().passthrough()
}).passthrough();
he({ labMember: D3.nullable() }).passthrough();
he({ labMembers: at(D3) }).passthrough();
he({
  labMember: he({
    id: Oe().int(),
    labId: Oe().int(),
    userId: ie(),
    role: Mi(["OWNER", "MEMBER"])
  }).passthrough()
}).passthrough();
he({ role: ie() }).passthrough();
he({ labMemberId: Oe(), role: ie() }).passthrough();
he({ success: dr() }).passthrough();
he({
  client_secret: ie().nullable(),
  status: ie().nullable(),
  payment_status: ie()
}).passthrough();
he({ name: ie(), email: ie().email(), message: ie() }).passthrough();
he({ path: ie(), s3BucketId: Oe().optional() }).passthrough();
const rle = he({ success: dr() }).passthrough(), ile = he({ url: ie() }).passthrough(), ole = he({
  isFolder: dr(),
  bucketId: Oe().optional(),
  path: ie()
}).passthrough(), ale = he({ contents: at(ole) }).passthrough(), sle = he({ files: at(ie()) }).passthrough();
he({
  buckets: at(he({
    id: Oe().int(),
    bucket: ie(),
    region: ie(),
    prefix: ie().nullish()
  }).passthrough())
}).passthrough();
he({
  source: he({
    isFolder: dr(),
    bucketId: Oe().optional(),
    path: ie()
  }).passthrough(),
  target: he({
    isFolder: dr(),
    bucketId: Oe().optional(),
    path: ie()
  }).passthrough()
}).passthrough();
const lle = he({
  fileTransfers: at(he({
    id: Oe().int(),
    name: ie(),
    userId: ie(),
    progress: Oe()
  }).passthrough())
}).passthrough(), ule = he({
  id: Oe(),
  name: ie(),
  analysisSchemaId: Oe(),
  analysisSchemaVersion: Oe(),
  config: he({}).partial().passthrough()
}).passthrough();
he({ templates: at(ule) }).passthrough();
he({
  name: ie().min(1).max(255),
  analysisSchemaId: Oe().int(),
  analysisSchemaVersion: Oe().int().gt(0),
  triggerLocation: he({
    bucketId: Oe().int().gt(0),
    folderPath: ie().max(2048)
  }).passthrough(),
  config: Zd()
}).passthrough();
he({
  id: Oe(),
  name: ie(),
  s3BucketId: Oe(),
  triggerFolder: ie(),
  analysisSchemaId: Oe(),
  analysisSchemaVersion: Oe(),
  config: he({}).partial().passthrough()
}).passthrough();
he({ name: ie(), enabled: dr() }).passthrough();
he({
  id: Oe(),
  name: ie(),
  schema: he({}).partial().passthrough()
}).passthrough();
he({
  id: Oe(),
  formId: Oe(),
  data: he({}).partial().passthrough(),
  dateCreated: ie()
}).passthrough();
he({
  id: Oe(),
  name: ie(),
  displayName: ie(),
  hichip: ie(),
  source: ie(),
  bucket: ie(),
  bedpeKey: ie(),
  hicKey: ie(),
  category: ie()
}).passthrough();
he({
  id: Oe(),
  sampleId: Oe(),
  cluster: ie(),
  chr: ie(),
  start: Oe(),
  end: Oe(),
  size: Oe(),
  genes: ie()
}).passthrough();
he({
  plotId: ie(),
  status: Mi(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  outputBucket: ie(),
  outputKey: ie(),
  inputs: he({}).partial().passthrough(),
  endedAt: ie().nullable(),
  downloadUrl: ie().nullable()
}).passthrough();
he({
  sample: ie(),
  range: ie(),
  genomeBuild: Mi(["hg19", "hg38"]),
  color: ie().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: ie(),
  flank: Oe(),
  bedpe: ie()
}).passthrough();
const A3 = he({
  id: Oe(),
  title: ie(),
  content: ie(),
  createdAt: ie(),
  updatedAt: ie(),
  isActive: dr()
}).passthrough();
he({ announcements: at(A3) }).passthrough();
he({ announcement: A3.nullable() }).passthrough();
const No = {
  SuccessDto: Yse,
  CreateDirectoryResponse: rle,
  PresignedUrlResponse: ile,
  ContentsResponse: ale,
  DeleteFilesResponse: sle,
  FileTransfersResponse: lle
};
class Wm {
  constructor(t) {
    hee(this, "fetch"), this.fetch = t;
  }
  async download(t, n, r = null, i = !0) {
    let o = `/files/presigned/${encodeURIComponent(n)}/url?method=download`;
    t && (o += `&bucket=${t}`), r && (o += `&limit=${r}`);
    const a = (await this.fetch(o, { method: "GET" }, No.PresignedUrlResponse)).url;
    if (i) {
      const s = document.createElement("a");
      s.href = a, s.download = "", s.target = "_blank", s.click(), document.body.appendChild(s), s.click(), setTimeout(() => {
        document.body.removeChild(s);
      });
    }
    return a;
  }
  async upload(t, n, r) {
    const i = [];
    let o = `/files/presigned/${encodeURIComponent(r)}/url?method=upload`;
    n && (o = o += `&bucket=${n}`);
    const a = (await this.fetch(o, { method: "GET" }, No.PresignedUrlResponse)).url, s = new XMLHttpRequest();
    return s.open("PUT", a), s.addEventListener("error", () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }), s.onerror = () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }, s.upload.addEventListener("progress", (l) => {
      const u = l.loaded / l.total;
      for (const c of i)
        c.onProgress(u);
    }), s.upload.addEventListener("load", () => {
      for (const l of i)
        l.onComplete();
      s.upload.removeEventListener("progress", () => null);
    }), s.send(t), {
      subscribe(l) {
        i.push(l);
      }
    };
  }
}
const C3 = ({ className: e = "" }) => /* @__PURE__ */ R.jsx(
  "svg",
  {
    className: `${e} block`,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.81 296.2",
    children: /* @__PURE__ */ R.jsx("g", { children: /* @__PURE__ */ R.jsx("path", { d: "M64.3,112.5C28.5,174.6-.4,225.4,0,225.6s34.7-9.2,76.2-20.7,76.3-21.1,77.4-21.3c1.8-.3,2.3,2.8,9.6,56,4.2,31,7.8,56.5,8,56.6s20.5-15.2,45.2-34.3c29.3-22.7,44.6-35.1,44.4-36.1C260.2,223.6,131.2.4,130.2,0,129.8-.1,100.1,50.5,64.3,112.5Z" }) })
  }
);
function d$(e) {
  De(() => {
    e && gr.error(e.toString());
  }, [e]);
}
async function cle(e, t, n) {
  await e(
    "/files/directory",
    {
      method: "POST",
      body: JSON.stringify({ s3BucketId: t, path: n })
    },
    No.CreateDirectoryResponse
  );
}
const fle = (e) => {
  const t = Ey({
    mutationKey: ["createFolder"],
    mutationFn: async (n) => cle(e, n.s3BucketId, n.path)
  });
  return { ...t, createFolder: t.mutateAsync };
};
async function dle(e, t, n) {
  let i = `/files/${encodeURIComponent(t)}?`;
  return n && (i += `&bucket=${n}`), await e(
    i,
    { method: "DELETE" },
    No.DeleteFilesResponse
  );
}
const ple = (e) => {
  const t = Ey({
    mutationKey: ["deleteFiles"],
    mutationFn: (n) => dle(e, n.path, n.s3BucketId)
  });
  return { ...t, deleteFiles: t.mutateAsync };
};
async function hle(e) {
  return e(
    "/file-transfer",
    { method: "GET" },
    No.FileTransfersResponse
  );
}
const mle = (e, t) => w$({
  queryKey: ["file-transfers"],
  queryFn: () => hle(t),
  refetchInterval: 500,
  enabled: e
}), vle = async (e, t, n) => await n(
  `/files/?search=${t}&bucket=${e}`,
  {},
  No.ContentsResponse
), gle = async (e, t, n) => {
  let i = `/files/${encodeURIComponent(t || "")}?`;
  return e && (i += `bucket=${e}`), await n(i, { method: "GET" }, No.ContentsResponse);
}, yle = (e, t, n) => w$({
  queryKey: ["files", e, t],
  queryFn: async () => gle(e, t, n),
  refetchInterval: 2e3
});
async function ble(e, t, n) {
  return n(
    "/files/move",
    {
      method: "POST",
      body: JSON.stringify({ source: e, target: t })
    },
    No.SuccessDto
  );
}
function _le(e) {
  const t = Ey({
    mutationKey: ["moveFiles"],
    mutationFn: ({ src: n, dest: r }) => ble(n, r, e)
  });
  return { ...t, moveFiles: t.mutateAsync };
}
function wle({
  s3BucketId: e,
  fetch: t,
  selectionMode: n,
  onSelectionChange: r,
  path: i,
  setPath: o,
  readOnly: a = !1,
  selection: s = [],
  className: l = ""
}) {
  const {
    data: u,
    error: c,
    refetch: f
  } = yle(e, i.join("/"), t), [d, p] = je(!1), { createFolder: h } = fle(t), { deleteFiles: m, error: v } = ple(t), { moveFiles: g, error: b } = _le(t), { data: E, error: x } = mle(d, t);
  De(() => {
    E?.fileTransfers && E.fileTransfers.length > 0;
  }, [E]), d$(b), d$(x), xle(E), De(() => {
    c && gr.error(c.message), v && gr.error(v.message);
  }, [c, v]);
  const S = u?.contents ?? [], $ = i.length > 0 ? `/${i.join("/")}` : "/";
  return /* @__PURE__ */ R.jsx(
    cee,
    {
      className: l,
      selectionMode: n,
      filePathHomeDirectory: /* @__PURE__ */ R.jsx(C3, { className: "inline w-3 h-3" }),
      files: S,
      selection: s,
      readOnly: a,
      onSelectionChange: r,
      onDownload: async (P) => {
        await new Wm(t).download(e, P.path, null, !0), f();
      },
      onMoveUpAFolder: async (P) => {
        if (!P) {
          gr.error("Already at root folder");
          return;
        }
        const { path: y, parent: _ } = P;
        await g({
          src: y,
          dest: { isFolder: !0, path: _, bucketId: y.bucketId }
        }), p(!0), await f();
      },
      path: i,
      onNavigate: (P) => {
        o(P);
      },
      onMove: async (P, y) => {
        if (!y.isFolder) {
          gr.error("Target must be a folder");
          return;
        }
        await g({ src: P, dest: y }), await f(), p(!0);
      },
      onSearch: async (P) => (await vle(e, P, t)).contents,
      onUpload: function(P) {
        const y = new Wm(t), _ = `${$}/${P[0].name}`;
        return y.upload(P[0], e, _);
      },
      onDelete: async (P) => {
        await m({ s3BucketId: e, path: P[0].path }), await f();
      },
      onCreateFolder: async (P) => {
        await h({ s3BucketId: e, path: P }), await f();
      },
      onPreview: async (P) => {
        await new Wm(t).download(e, P.path), f();
      }
    }
  );
}
const xle = (e) => {
  De(() => {
    if (e?.fileTransfers.length)
      for (const t of e.fileTransfers)
        gr(t.name, {
          progress: t.progress,
          toastId: t.id
        });
  }, [e]);
};
function Wue(e) {
  return /* @__PURE__ */ R.jsx(s6, { client: e.queryClient, children: /* @__PURE__ */ R.jsx(wle, { ...e }) });
}
var cf, Ele = new Uint8Array(16);
function Sle() {
  if (!cf && (cf = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !cf))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return cf(Ele);
}
const $le = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Tle(e) {
  return typeof e == "string" && $le.test(e);
}
var mn = [];
for (var Zm = 0; Zm < 256; ++Zm)
  mn.push((Zm + 256).toString(16).substr(1));
function Ole(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (mn[e[t + 0]] + mn[e[t + 1]] + mn[e[t + 2]] + mn[e[t + 3]] + "-" + mn[e[t + 4]] + mn[e[t + 5]] + "-" + mn[e[t + 6]] + mn[e[t + 7]] + "-" + mn[e[t + 8]] + mn[e[t + 9]] + "-" + mn[e[t + 10]] + mn[e[t + 11]] + mn[e[t + 12]] + mn[e[t + 13]] + mn[e[t + 14]] + mn[e[t + 15]]).toLowerCase();
  if (!Tle(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
function kle(e, t, n) {
  e = e || {};
  var r = e.random || (e.rng || Sle)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, Ole(r);
}
const Ple = (e) => {
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e.item(n);
    r && t.push(r);
  }
  return t;
}, Zue = ({
  children: e,
  onChange: t,
  className: n
}) => {
  const r = ve(kle());
  return /* @__PURE__ */ R.jsxs("div", { className: `${n} cursor-pointer`, children: [
    /* @__PURE__ */ R.jsx(
      "label",
      {
        htmlFor: r.current,
        onClick: (i) => i.stopPropagation(),
        className: "cursor-pointer",
        onKeyDown: (i) => {
          i.key === "Enter" && i.stopPropagation();
        },
        children: e
      }
    ),
    /* @__PURE__ */ R.jsx(
      "input",
      {
        onClick: (i) => i.stopPropagation(),
        onChange: (i) => {
          t(i.target.files ? Ple(i.target.files) : []);
        },
        className: "absolute w-0 h-0",
        type: "file",
        id: r.current
      }
    )
  ] });
}, Gue = ({ name: e, ...t }) => {
  const [n, r] = l6(e), { capture: i, ...o } = t;
  return /* @__PURE__ */ R.jsxs("div", { children: [
    /* @__PURE__ */ R.jsx(md, { ...o, ...n, placeholder: t.placeholder || e }),
    r.touched && r.error && /* @__PURE__ */ R.jsx(CV, { children: r.error })
  ] });
};
function Yue({ area: e, children: t, className: n }) {
  return /* @__PURE__ */ R.jsx("div", { className: `${n || ""}`, style: { gridArea: e }, children: t });
}
var Vf = { exports: {} }, Dle = Vf.exports, p$;
function Ale() {
  return p$ || (p$ = 1, (function(e, t) {
    (function(r, i) {
      e.exports = i(G);
    })(Dle, (n) => (
      /******/
      (() => {
        var r = {
          /***/
          "./node_modules/css-mediaquery/index.js": (
            /*!**********************************************!*\
              !*** ./node_modules/css-mediaquery/index.js ***!
              \**********************************************/
            /***/
            ((s, l) => {
              l.match = h, l.parse = m;
              var u = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, c = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, f = /^(?:(min|max)-)?(.+)/, d = /(em|rem|px|cm|mm|in|pt|pc)?$/, p = /(dpi|dpcm|dppx)?$/;
              function h(E, x) {
                return m(E).some(function(S) {
                  var $ = S.inverse, P = S.type === "all" || x.type === S.type;
                  if (P && $ || !(P || $))
                    return !1;
                  var y = S.expressions.every(function(_) {
                    var w = _.feature, A = _.modifier, k = _.value, N = x[w];
                    if (!N)
                      return !1;
                    switch (w) {
                      case "orientation":
                      case "scan":
                        return N.toLowerCase() === k.toLowerCase();
                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        k = b(k), N = b(N);
                        break;
                      case "resolution":
                        k = g(k), N = g(N);
                        break;
                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case /* Deprecated */
                      "device-pixel-ratio":
                        k = v(k), N = v(N);
                        break;
                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        k = parseInt(k, 10) || 1, N = parseInt(N, 10) || 0;
                        break;
                    }
                    switch (A) {
                      case "min":
                        return N >= k;
                      case "max":
                        return N <= k;
                      default:
                        return N === k;
                    }
                  });
                  return y && !$ || !y && $;
                });
              }
              function m(E) {
                return E.split(",").map(function(x) {
                  x = x.trim();
                  var S = x.match(u), $ = S[1], P = S[2], y = S[3] || "", _ = {};
                  return _.inverse = !!$ && $.toLowerCase() === "not", _.type = P ? P.toLowerCase() : "all", y = y.match(/\([^\)]+\)/g) || [], _.expressions = y.map(function(w) {
                    var A = w.match(c), k = A[1].toLowerCase().match(f);
                    return {
                      modifier: k[1],
                      feature: k[2],
                      value: A[2]
                    };
                  }), _;
                });
              }
              function v(E) {
                var x = Number(E), S;
                return x || (S = E.match(/^(\d+)\s*\/\s*(\d+)$/), x = S[1] / S[2]), x;
              }
              function g(E) {
                var x = parseFloat(E), S = String(E).match(p)[1];
                switch (S) {
                  case "dpcm":
                    return x / 2.54;
                  case "dppx":
                    return x * 96;
                  default:
                    return x;
                }
              }
              function b(E) {
                var x = parseFloat(E), S = String(E).match(d)[1];
                switch (S) {
                  case "em":
                    return x * 16;
                  case "rem":
                    return x * 16;
                  case "cm":
                    return x * 96 / 2.54;
                  case "mm":
                    return x * 96 / 2.54 / 10;
                  case "in":
                    return x * 96;
                  case "pt":
                    return x * 72;
                  case "pc":
                    return x * 72 / 12;
                  default:
                    return x;
                }
              }
            })
          ),
          /***/
          "./node_modules/hyphenate-style-name/index.js": (
            /*!****************************************************!*\
              !*** ./node_modules/hyphenate-style-name/index.js ***!
              \****************************************************/
            /***/
            ((s, l, u) => {
              u.r(l), u.d(l, {
                /* harmony export */
                default: () => m
                /* harmony export */
              });
              var c = /[A-Z]/g, f = /^ms-/, d = {};
              function p(v) {
                return "-" + v.toLowerCase();
              }
              function h(v) {
                if (d.hasOwnProperty(v))
                  return d[v];
                var g = v.replace(c, p);
                return d[v] = f.test(g) ? "-" + g : g;
              }
              const m = h;
            })
          ),
          /***/
          "./node_modules/matchmediaquery/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/matchmediaquery/index.js ***!
              \***********************************************/
            /***/
            ((s, l, u) => {
              var c = u(
                /*! css-mediaquery */
                "./node_modules/css-mediaquery/index.js"
              ).match, f = typeof window < "u" ? window.matchMedia : null;
              function d(h, m, v) {
                var g = this;
                if (f && !v) {
                  var b = f.call(window, h);
                  this.matches = b.matches, this.media = b.media, b.addListener(S);
                } else
                  this.matches = c(h, m), this.media = h;
                this.addListener = E, this.removeListener = x, this.dispose = $;
                function E(P) {
                  b && b.addListener(P);
                }
                function x(P) {
                  b && b.removeListener(P);
                }
                function S(P) {
                  g.matches = P.matches, g.media = P.media;
                }
                function $() {
                  b && b.removeListener(S);
                }
              }
              function p(h, m, v) {
                return new d(h, m, v);
              }
              s.exports = p;
            })
          ),
          /***/
          "./node_modules/object-assign/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/object-assign/index.js ***!
              \*********************************************/
            /***/
            ((s) => {
              /*
              object-assign
              (c) Sindre Sorhus
              @license MIT
              */
              var l = Object.getOwnPropertySymbols, u = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
              function f(p) {
                if (p == null)
                  throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(p);
              }
              function d() {
                try {
                  if (!Object.assign)
                    return !1;
                  var p = new String("abc");
                  if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5")
                    return !1;
                  for (var h = {}, m = 0; m < 10; m++)
                    h["_" + String.fromCharCode(m)] = m;
                  var v = Object.getOwnPropertyNames(h).map(function(b) {
                    return h[b];
                  });
                  if (v.join("") !== "0123456789")
                    return !1;
                  var g = {};
                  return "abcdefghijklmnopqrst".split("").forEach(function(b) {
                    g[b] = b;
                  }), Object.keys(Object.assign({}, g)).join("") === "abcdefghijklmnopqrst";
                } catch {
                  return !1;
                }
              }
              s.exports = d() ? Object.assign : function(p, h) {
                for (var m, v = f(p), g, b = 1; b < arguments.length; b++) {
                  m = Object(arguments[b]);
                  for (var E in m)
                    u.call(m, E) && (v[E] = m[E]);
                  if (l) {
                    g = l(m);
                    for (var x = 0; x < g.length; x++)
                      c.call(m, g[x]) && (v[g[x]] = m[g[x]]);
                  }
                }
                return v;
              };
            })
          ),
          /***/
          "./node_modules/prop-types/checkPropTypes.js": (
            /*!***************************************************!*\
              !*** ./node_modules/prop-types/checkPropTypes.js ***!
              \***************************************************/
            /***/
            ((s, l, u) => {
              var c = function() {
              };
              {
                var f = u(
                  /*! ./lib/ReactPropTypesSecret */
                  "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
                ), d = {}, p = u(
                  /*! ./lib/has */
                  "./node_modules/prop-types/lib/has.js"
                );
                c = function(m) {
                  var v = "Warning: " + m;
                  typeof console < "u" && console.error(v);
                  try {
                    throw new Error(v);
                  } catch {
                  }
                };
              }
              function h(m, v, g, b, E) {
                for (var x in m)
                  if (p(m, x)) {
                    var S;
                    try {
                      if (typeof m[x] != "function") {
                        var $ = Error(
                          (b || "React class") + ": " + g + " type `" + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof m[x] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                        );
                        throw $.name = "Invariant Violation", $;
                      }
                      S = m[x](v, x, b, g, null, f);
                    } catch (y) {
                      S = y;
                    }
                    if (S && !(S instanceof Error) && c(
                      (b || "React class") + ": type specification of " + g + " `" + x + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof S + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                    ), S instanceof Error && !(S.message in d)) {
                      d[S.message] = !0;
                      var P = E ? E() : "";
                      c(
                        "Failed " + g + " type: " + S.message + (P ?? "")
                      );
                    }
                  }
              }
              h.resetWarningCache = function() {
                d = {};
              }, s.exports = h;
            })
          ),
          /***/
          "./node_modules/prop-types/factoryWithTypeCheckers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
              \************************************************************/
            /***/
            ((s, l, u) => {
              var c = u(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), f = u(
                /*! object-assign */
                "./node_modules/object-assign/index.js"
              ), d = u(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), p = u(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              ), h = u(
                /*! ./checkPropTypes */
                "./node_modules/prop-types/checkPropTypes.js"
              ), m = function() {
              };
              m = function(g) {
                var b = "Warning: " + g;
                typeof console < "u" && console.error(b);
                try {
                  throw new Error(b);
                } catch {
                }
              };
              function v() {
                return null;
              }
              s.exports = function(g, b) {
                var E = typeof Symbol == "function" && Symbol.iterator, x = "@@iterator";
                function S(D) {
                  var C = D && (E && D[E] || D[x]);
                  if (typeof C == "function")
                    return C;
                }
                var $ = "<<anonymous>>", P = {
                  array: A("array"),
                  bigint: A("bigint"),
                  bool: A("boolean"),
                  func: A("function"),
                  number: A("number"),
                  object: A("object"),
                  string: A("string"),
                  symbol: A("symbol"),
                  any: k(),
                  arrayOf: N,
                  element: I(),
                  elementType: B(),
                  instanceOf: q,
                  node: T(),
                  objectOf: re,
                  oneOf: ee,
                  oneOfType: Z,
                  shape: M,
                  exact: K
                };
                function y(D, C) {
                  return D === C ? D !== 0 || 1 / D === 1 / C : D !== D && C !== C;
                }
                function _(D, C) {
                  this.message = D, this.data = C && typeof C == "object" ? C : {}, this.stack = "";
                }
                _.prototype = Error.prototype;
                function w(D) {
                  var C = {}, z = 0;
                  function H(fe, ce, xe, ne, we, ke, pe) {
                    if (ne = ne || $, ke = ke || xe, pe !== d) {
                      if (b) {
                        var j = new Error(
                          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                        );
                        throw j.name = "Invariant Violation", j;
                      } else if (typeof console < "u") {
                        var U = ne + ":" + xe;
                        !C[U] && // Avoid spamming the console because they are often not actionable except for lib authors
                        z < 3 && (m(
                          "You are manually calling a React.PropTypes validation function for the `" + ke + "` prop on `" + ne + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                        ), C[U] = !0, z++);
                      }
                    }
                    return ce[xe] == null ? fe ? ce[xe] === null ? new _("The " + we + " `" + ke + "` is marked as required " + ("in `" + ne + "`, but its value is `null`.")) : new _("The " + we + " `" + ke + "` is marked as required in " + ("`" + ne + "`, but its value is `undefined`.")) : null : D(ce, xe, ne, we, ke);
                  }
                  var X = H.bind(null, !1);
                  return X.isRequired = H.bind(null, !0), X;
                }
                function A(D) {
                  function C(z, H, X, fe, ce, xe) {
                    var ne = z[H], we = de(ne);
                    if (we !== D) {
                      var ke = ge(ne);
                      return new _(
                        "Invalid " + fe + " `" + ce + "` of type " + ("`" + ke + "` supplied to `" + X + "`, expected ") + ("`" + D + "`."),
                        { expectedType: D }
                      );
                    }
                    return null;
                  }
                  return w(C);
                }
                function k() {
                  return w(v);
                }
                function N(D) {
                  function C(z, H, X, fe, ce) {
                    if (typeof D != "function")
                      return new _("Property `" + ce + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
                    var xe = z[H];
                    if (!Array.isArray(xe)) {
                      var ne = de(xe);
                      return new _("Invalid " + fe + " `" + ce + "` of type " + ("`" + ne + "` supplied to `" + X + "`, expected an array."));
                    }
                    for (var we = 0; we < xe.length; we++) {
                      var ke = D(xe, we, X, fe, ce + "[" + we + "]", d);
                      if (ke instanceof Error)
                        return ke;
                    }
                    return null;
                  }
                  return w(C);
                }
                function I() {
                  function D(C, z, H, X, fe) {
                    var ce = C[z];
                    if (!g(ce)) {
                      var xe = de(ce);
                      return new _("Invalid " + X + " `" + fe + "` of type " + ("`" + xe + "` supplied to `" + H + "`, expected a single ReactElement."));
                    }
                    return null;
                  }
                  return w(D);
                }
                function B() {
                  function D(C, z, H, X, fe) {
                    var ce = C[z];
                    if (!c.isValidElementType(ce)) {
                      var xe = de(ce);
                      return new _("Invalid " + X + " `" + fe + "` of type " + ("`" + xe + "` supplied to `" + H + "`, expected a single ReactElement type."));
                    }
                    return null;
                  }
                  return w(D);
                }
                function q(D) {
                  function C(z, H, X, fe, ce) {
                    if (!(z[H] instanceof D)) {
                      var xe = D.name || $, ne = O(z[H]);
                      return new _("Invalid " + fe + " `" + ce + "` of type " + ("`" + ne + "` supplied to `" + X + "`, expected ") + ("instance of `" + xe + "`."));
                    }
                    return null;
                  }
                  return w(C);
                }
                function ee(D) {
                  if (!Array.isArray(D))
                    return arguments.length > 1 ? m(
                      "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                    ) : m("Invalid argument supplied to oneOf, expected an array."), v;
                  function C(z, H, X, fe, ce) {
                    for (var xe = z[H], ne = 0; ne < D.length; ne++)
                      if (y(xe, D[ne]))
                        return null;
                    var we = JSON.stringify(D, function(pe, j) {
                      var U = ge(j);
                      return U === "symbol" ? String(j) : j;
                    });
                    return new _("Invalid " + fe + " `" + ce + "` of value `" + String(xe) + "` " + ("supplied to `" + X + "`, expected one of " + we + "."));
                  }
                  return w(C);
                }
                function re(D) {
                  function C(z, H, X, fe, ce) {
                    if (typeof D != "function")
                      return new _("Property `" + ce + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
                    var xe = z[H], ne = de(xe);
                    if (ne !== "object")
                      return new _("Invalid " + fe + " `" + ce + "` of type " + ("`" + ne + "` supplied to `" + X + "`, expected an object."));
                    for (var we in xe)
                      if (p(xe, we)) {
                        var ke = D(xe, we, X, fe, ce + "." + we, d);
                        if (ke instanceof Error)
                          return ke;
                      }
                    return null;
                  }
                  return w(C);
                }
                function Z(D) {
                  if (!Array.isArray(D))
                    return m("Invalid argument supplied to oneOfType, expected an instance of array."), v;
                  for (var C = 0; C < D.length; C++) {
                    var z = D[C];
                    if (typeof z != "function")
                      return m(
                        "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + V(z) + " at index " + C + "."
                      ), v;
                  }
                  function H(X, fe, ce, xe, ne) {
                    for (var we = [], ke = 0; ke < D.length; ke++) {
                      var pe = D[ke], j = pe(X, fe, ce, xe, ne, d);
                      if (j == null)
                        return null;
                      j.data && p(j.data, "expectedType") && we.push(j.data.expectedType);
                    }
                    var U = we.length > 0 ? ", expected one of type [" + we.join(", ") + "]" : "";
                    return new _("Invalid " + xe + " `" + ne + "` supplied to " + ("`" + ce + "`" + U + "."));
                  }
                  return w(H);
                }
                function T() {
                  function D(C, z, H, X, fe) {
                    return te(C[z]) ? null : new _("Invalid " + X + " `" + fe + "` supplied to " + ("`" + H + "`, expected a ReactNode."));
                  }
                  return w(D);
                }
                function F(D, C, z, H, X) {
                  return new _(
                    (D || "React class") + ": " + C + " type `" + z + "." + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
                  );
                }
                function M(D) {
                  function C(z, H, X, fe, ce) {
                    var xe = z[H], ne = de(xe);
                    if (ne !== "object")
                      return new _("Invalid " + fe + " `" + ce + "` of type `" + ne + "` " + ("supplied to `" + X + "`, expected `object`."));
                    for (var we in D) {
                      var ke = D[we];
                      if (typeof ke != "function")
                        return F(X, fe, ce, we, ge(ke));
                      var pe = ke(xe, we, X, fe, ce + "." + we, d);
                      if (pe)
                        return pe;
                    }
                    return null;
                  }
                  return w(C);
                }
                function K(D) {
                  function C(z, H, X, fe, ce) {
                    var xe = z[H], ne = de(xe);
                    if (ne !== "object")
                      return new _("Invalid " + fe + " `" + ce + "` of type `" + ne + "` " + ("supplied to `" + X + "`, expected `object`."));
                    var we = f({}, z[H], D);
                    for (var ke in we) {
                      var pe = D[ke];
                      if (p(D, ke) && typeof pe != "function")
                        return F(X, fe, ce, ke, ge(pe));
                      if (!pe)
                        return new _(
                          "Invalid " + fe + " `" + ce + "` key `" + ke + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify(z[H], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(D), null, "  ")
                        );
                      var j = pe(xe, ke, X, fe, ce + "." + ke, d);
                      if (j)
                        return j;
                    }
                    return null;
                  }
                  return w(C);
                }
                function te(D) {
                  switch (typeof D) {
                    case "number":
                    case "string":
                    case "undefined":
                      return !0;
                    case "boolean":
                      return !D;
                    case "object":
                      if (Array.isArray(D))
                        return D.every(te);
                      if (D === null || g(D))
                        return !0;
                      var C = S(D);
                      if (C) {
                        var z = C.call(D), H;
                        if (C !== D.entries) {
                          for (; !(H = z.next()).done; )
                            if (!te(H.value))
                              return !1;
                        } else
                          for (; !(H = z.next()).done; ) {
                            var X = H.value;
                            if (X && !te(X[1]))
                              return !1;
                          }
                      } else
                        return !1;
                      return !0;
                    default:
                      return !1;
                  }
                }
                function se(D, C) {
                  return D === "symbol" ? !0 : C ? C["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && C instanceof Symbol : !1;
                }
                function de(D) {
                  var C = typeof D;
                  return Array.isArray(D) ? "array" : D instanceof RegExp ? "object" : se(C, D) ? "symbol" : C;
                }
                function ge(D) {
                  if (typeof D > "u" || D === null)
                    return "" + D;
                  var C = de(D);
                  if (C === "object") {
                    if (D instanceof Date)
                      return "date";
                    if (D instanceof RegExp)
                      return "regexp";
                  }
                  return C;
                }
                function V(D) {
                  var C = ge(D);
                  switch (C) {
                    case "array":
                    case "object":
                      return "an " + C;
                    case "boolean":
                    case "date":
                    case "regexp":
                      return "a " + C;
                    default:
                      return C;
                  }
                }
                function O(D) {
                  return !D.constructor || !D.constructor.name ? $ : D.constructor.name;
                }
                return P.checkPropTypes = h, P.resetWarningCache = h.resetWarningCache, P.PropTypes = P, P;
              };
            })
          ),
          /***/
          "./node_modules/prop-types/index.js": (
            /*!******************************************!*\
              !*** ./node_modules/prop-types/index.js ***!
              \******************************************/
            /***/
            ((s, l, u) => {
              {
                var c = u(
                  /*! react-is */
                  "./node_modules/react-is/index.js"
                ), f = !0;
                s.exports = u(
                  /*! ./factoryWithTypeCheckers */
                  "./node_modules/prop-types/factoryWithTypeCheckers.js"
                )(c.isElement, f);
              }
            })
          ),
          /***/
          "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
              \*************************************************************/
            /***/
            ((s) => {
              var l = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
              s.exports = l;
            })
          ),
          /***/
          "./node_modules/prop-types/lib/has.js": (
            /*!********************************************!*\
              !*** ./node_modules/prop-types/lib/has.js ***!
              \********************************************/
            /***/
            ((s) => {
              s.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            })
          ),
          /***/
          "./node_modules/react-is/cjs/react-is.development.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/react-is/cjs/react-is.development.js ***!
              \***********************************************************/
            /***/
            ((s, l) => {
              /** @license React v16.13.1
               * react-is.development.js
               *
               * Copyright (c) Facebook, Inc. and its affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */
              (function() {
                var u = typeof Symbol == "function" && Symbol.for, c = u ? Symbol.for("react.element") : 60103, f = u ? Symbol.for("react.portal") : 60106, d = u ? Symbol.for("react.fragment") : 60107, p = u ? Symbol.for("react.strict_mode") : 60108, h = u ? Symbol.for("react.profiler") : 60114, m = u ? Symbol.for("react.provider") : 60109, v = u ? Symbol.for("react.context") : 60110, g = u ? Symbol.for("react.async_mode") : 60111, b = u ? Symbol.for("react.concurrent_mode") : 60111, E = u ? Symbol.for("react.forward_ref") : 60112, x = u ? Symbol.for("react.suspense") : 60113, S = u ? Symbol.for("react.suspense_list") : 60120, $ = u ? Symbol.for("react.memo") : 60115, P = u ? Symbol.for("react.lazy") : 60116, y = u ? Symbol.for("react.block") : 60121, _ = u ? Symbol.for("react.fundamental") : 60117, w = u ? Symbol.for("react.responder") : 60118, A = u ? Symbol.for("react.scope") : 60119;
                function k(pe) {
                  return typeof pe == "string" || typeof pe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                  pe === d || pe === b || pe === h || pe === p || pe === x || pe === S || typeof pe == "object" && pe !== null && (pe.$$typeof === P || pe.$$typeof === $ || pe.$$typeof === m || pe.$$typeof === v || pe.$$typeof === E || pe.$$typeof === _ || pe.$$typeof === w || pe.$$typeof === A || pe.$$typeof === y);
                }
                function N(pe) {
                  if (typeof pe == "object" && pe !== null) {
                    var j = pe.$$typeof;
                    switch (j) {
                      case c:
                        var U = pe.type;
                        switch (U) {
                          case g:
                          case b:
                          case d:
                          case h:
                          case p:
                          case x:
                            return U;
                          default:
                            var Y = U && U.$$typeof;
                            switch (Y) {
                              case v:
                              case E:
                              case P:
                              case $:
                              case m:
                                return Y;
                              default:
                                return j;
                            }
                        }
                      case f:
                        return j;
                    }
                  }
                }
                var I = g, B = b, q = v, ee = m, re = c, Z = E, T = d, F = P, M = $, K = f, te = h, se = p, de = x, ge = !1;
                function V(pe) {
                  return ge || (ge = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(pe) || N(pe) === g;
                }
                function O(pe) {
                  return N(pe) === b;
                }
                function D(pe) {
                  return N(pe) === v;
                }
                function C(pe) {
                  return N(pe) === m;
                }
                function z(pe) {
                  return typeof pe == "object" && pe !== null && pe.$$typeof === c;
                }
                function H(pe) {
                  return N(pe) === E;
                }
                function X(pe) {
                  return N(pe) === d;
                }
                function fe(pe) {
                  return N(pe) === P;
                }
                function ce(pe) {
                  return N(pe) === $;
                }
                function xe(pe) {
                  return N(pe) === f;
                }
                function ne(pe) {
                  return N(pe) === h;
                }
                function we(pe) {
                  return N(pe) === p;
                }
                function ke(pe) {
                  return N(pe) === x;
                }
                l.AsyncMode = I, l.ConcurrentMode = B, l.ContextConsumer = q, l.ContextProvider = ee, l.Element = re, l.ForwardRef = Z, l.Fragment = T, l.Lazy = F, l.Memo = M, l.Portal = K, l.Profiler = te, l.StrictMode = se, l.Suspense = de, l.isAsyncMode = V, l.isConcurrentMode = O, l.isContextConsumer = D, l.isContextProvider = C, l.isElement = z, l.isForwardRef = H, l.isFragment = X, l.isLazy = fe, l.isMemo = ce, l.isPortal = xe, l.isProfiler = ne, l.isStrictMode = we, l.isSuspense = ke, l.isValidElementType = k, l.typeOf = N;
              })();
            })
          ),
          /***/
          "./node_modules/react-is/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/react-is/index.js ***!
              \****************************************/
            /***/
            ((s, l, u) => {
              s.exports = u(
                /*! ./cjs/react-is.development.js */
                "./node_modules/react-is/cjs/react-is.development.js"
              );
            })
          ),
          /***/
          "./node_modules/shallow-equal/dist/index.esm.js": (
            /*!******************************************************!*\
              !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
              \******************************************************/
            /***/
            ((s, l, u) => {
              u.r(l), u.d(l, {
                /* harmony export */
                shallowEqualArrays: () => (
                  /* binding */
                  f
                ),
                /* harmony export */
                shallowEqualObjects: () => (
                  /* binding */
                  c
                )
                /* harmony export */
              });
              function c(d, p) {
                if (d === p)
                  return !0;
                if (!d || !p)
                  return !1;
                var h = Object.keys(d), m = Object.keys(p), v = h.length;
                if (m.length !== v)
                  return !1;
                for (var g = 0; g < v; g++) {
                  var b = h[g];
                  if (d[b] !== p[b] || !Object.prototype.hasOwnProperty.call(p, b))
                    return !1;
                }
                return !0;
              }
              function f(d, p) {
                if (d === p)
                  return !0;
                if (!d || !p)
                  return !1;
                var h = d.length;
                if (p.length !== h)
                  return !1;
                for (var m = 0; m < h; m++)
                  if (d[m] !== p[m])
                    return !1;
                return !0;
              }
            })
          ),
          /***/
          "./src/Component.ts": (
            /*!**************************!*\
              !*** ./src/Component.ts ***!
              \**************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__rest || function(h, m) {
                var v = {};
                for (var g in h) Object.prototype.hasOwnProperty.call(h, g) && m.indexOf(g) < 0 && (v[g] = h[g]);
                if (h != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var b = 0, g = Object.getOwnPropertySymbols(h); b < g.length; b++)
                    m.indexOf(g[b]) < 0 && Object.prototype.propertyIsEnumerable.call(h, g[b]) && (v[g[b]] = h[g[b]]);
                return v;
              }, f = this && this.__importDefault || function(h) {
                return h && h.__esModule ? h : { default: h };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var d = f(u(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              )), p = function(h) {
                var m = h.children, v = h.device, g = h.onChange, b = c(h, ["children", "device", "onChange"]), E = (0, d.default)(b, v, g);
                return typeof m == "function" ? m(E) : E ? m : null;
              };
              l.default = p;
            })
          ),
          /***/
          "./src/Context.ts": (
            /*!************************!*\
              !*** ./src/Context.ts ***!
              \************************/
            /***/
            ((s, l, u) => {
              Object.defineProperty(l, "__esModule", { value: !0 });
              var c = u(
                /*! react */
                "react"
              ), f = (0, c.createContext)(void 0);
              l.default = f;
            })
          ),
          /***/
          "./src/index.ts": (
            /*!**********************!*\
              !*** ./src/index.ts ***!
              \**********************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(m) {
                return m && m.__esModule ? m : { default: m };
              };
              Object.defineProperty(l, "__esModule", { value: !0 }), l.Context = l.toQuery = l.useMediaQuery = l.default = void 0;
              var f = c(u(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              ));
              l.useMediaQuery = f.default;
              var d = c(u(
                /*! ./Component */
                "./src/Component.ts"
              ));
              l.default = d.default;
              var p = c(u(
                /*! ./toQuery */
                "./src/toQuery.ts"
              ));
              l.toQuery = p.default;
              var h = c(u(
                /*! ./Context */
                "./src/Context.ts"
              ));
              l.Context = h.default;
            })
          ),
          /***/
          "./src/mediaQuery.ts": (
            /*!***************************!*\
              !*** ./src/mediaQuery.ts ***!
              \***************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__assign || function() {
                return c = Object.assign || function(x) {
                  for (var S, $ = 1, P = arguments.length; $ < P; $++) {
                    S = arguments[$];
                    for (var y in S) Object.prototype.hasOwnProperty.call(S, y) && (x[y] = S[y]);
                  }
                  return x;
                }, c.apply(this, arguments);
              }, f = this && this.__rest || function(x, S) {
                var $ = {};
                for (var P in x) Object.prototype.hasOwnProperty.call(x, P) && S.indexOf(P) < 0 && ($[P] = x[P]);
                if (x != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var y = 0, P = Object.getOwnPropertySymbols(x); y < P.length; y++)
                    S.indexOf(P[y]) < 0 && Object.prototype.propertyIsEnumerable.call(x, P[y]) && ($[P[y]] = x[P[y]]);
                return $;
              }, d = this && this.__importDefault || function(x) {
                return x && x.__esModule ? x : { default: x };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var p = d(u(
                /*! prop-types */
                "./node_modules/prop-types/index.js"
              )), h = p.default.oneOfType([
                p.default.string,
                p.default.number
              ]), m = {
                all: p.default.bool,
                grid: p.default.bool,
                aural: p.default.bool,
                braille: p.default.bool,
                handheld: p.default.bool,
                print: p.default.bool,
                projection: p.default.bool,
                screen: p.default.bool,
                tty: p.default.bool,
                tv: p.default.bool,
                embossed: p.default.bool
              }, v = {
                orientation: p.default.oneOf([
                  "portrait",
                  "landscape"
                ]),
                scan: p.default.oneOf([
                  "progressive",
                  "interlace"
                ]),
                aspectRatio: p.default.string,
                deviceAspectRatio: p.default.string,
                height: h,
                deviceHeight: h,
                width: h,
                deviceWidth: h,
                color: p.default.bool,
                colorIndex: p.default.bool,
                monochrome: p.default.bool,
                resolution: h,
                type: Object.keys(m)
              };
              v.type;
              var g = f(
                v,
                ["type"]
              ), b = c({ minAspectRatio: p.default.string, maxAspectRatio: p.default.string, minDeviceAspectRatio: p.default.string, maxDeviceAspectRatio: p.default.string, minHeight: h, maxHeight: h, minDeviceHeight: h, maxDeviceHeight: h, minWidth: h, maxWidth: h, minDeviceWidth: h, maxDeviceWidth: h, minColor: p.default.number, maxColor: p.default.number, minColorIndex: p.default.number, maxColorIndex: p.default.number, minMonochrome: p.default.number, maxMonochrome: p.default.number, minResolution: h, maxResolution: h }, g), E = c(c({}, m), b);
              l.default = {
                all: E,
                types: m,
                matchers: v,
                features: b
              };
            })
          ),
          /***/
          "./src/toQuery.ts": (
            /*!************************!*\
              !*** ./src/toQuery.ts ***!
              \************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(g) {
                return g && g.__esModule ? g : { default: g };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var f = c(u(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), d = c(u(
                /*! ./mediaQuery */
                "./src/mediaQuery.ts"
              )), p = function(g) {
                return "not ".concat(g);
              }, h = function(g, b) {
                var E = (0, f.default)(g);
                return typeof b == "number" && (b = "".concat(b, "px")), b === !0 ? E : b === !1 ? p(E) : "(".concat(E, ": ").concat(b, ")");
              }, m = function(g) {
                return g.join(" and ");
              }, v = function(g) {
                var b = [];
                return Object.keys(d.default.all).forEach(function(E) {
                  var x = g[E];
                  x != null && b.push(h(E, x));
                }), m(b);
              };
              l.default = v;
            })
          ),
          /***/
          "./src/useMediaQuery.ts": (
            /*!******************************!*\
              !*** ./src/useMediaQuery.ts ***!
              \******************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(_) {
                return _ && _.__esModule ? _ : { default: _ };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var f = u(
                /*! react */
                "react"
              ), d = c(u(
                /*! matchmediaquery */
                "./node_modules/matchmediaquery/index.js"
              )), p = c(u(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), h = u(
                /*! shallow-equal */
                "./node_modules/shallow-equal/dist/index.esm.js"
              ), m = c(u(
                /*! ./toQuery */
                "./src/toQuery.ts"
              )), v = c(u(
                /*! ./Context */
                "./src/Context.ts"
              )), g = function(_) {
                return _.query || (0, m.default)(_);
              }, b = function(_) {
                if (_) {
                  var w = Object.keys(_);
                  return w.reduce(function(A, k) {
                    return A[(0, p.default)(k)] = _[k], A;
                  }, {});
                }
              }, E = function() {
                var _ = (0, f.useRef)(!1);
                return (0, f.useEffect)(function() {
                  _.current = !0;
                }, []), _.current;
              }, x = function(_) {
                var w = (0, f.useContext)(v.default), A = function() {
                  return b(_) || b(w);
                }, k = (0, f.useState)(A), N = k[0], I = k[1];
                return (0, f.useEffect)(function() {
                  var B = A();
                  (0, h.shallowEqualObjects)(N, B) || I(B);
                }, [_, w]), N;
              }, S = function(_) {
                var w = function() {
                  return g(_);
                }, A = (0, f.useState)(w), k = A[0], N = A[1];
                return (0, f.useEffect)(function() {
                  var I = w();
                  k !== I && N(I);
                }, [_]), k;
              }, $ = function(_, w) {
                var A = function() {
                  return (0, d.default)(_, w || {}, !!w);
                }, k = (0, f.useState)(A), N = k[0], I = k[1], B = E();
                return (0, f.useEffect)(function() {
                  if (B) {
                    var q = A();
                    return I(q), function() {
                      q && q.dispose();
                    };
                  }
                }, [_, w]), N;
              }, P = function(_) {
                var w = (0, f.useState)(_.matches), A = w[0], k = w[1];
                return (0, f.useEffect)(function() {
                  var N = function(I) {
                    k(I.matches);
                  };
                  return _.addListener(N), k(_.matches), function() {
                    _.removeListener(N);
                  };
                }, [_]), A;
              }, y = function(_, w, A) {
                var k = x(w), N = S(_);
                if (!N)
                  throw new Error("Invalid or missing MediaQuery!");
                var I = $(N, k), B = P(I), q = E();
                return (0, f.useEffect)(function() {
                  q && A && A(B);
                }, [B]), (0, f.useEffect)(function() {
                  return function() {
                    I && I.dispose();
                  };
                }, []), B;
              };
              l.default = y;
            })
          ),
          /***/
          react: (
            /*!**************************************************************************************!*\
              !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
              \**************************************************************************************/
            /***/
            ((s) => {
              s.exports = n;
            })
          )
          /******/
        }, i = {};
        function o(s) {
          var l = i[s];
          if (l !== void 0)
            return l.exports;
          var u = i[s] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return r[s].call(u.exports, u, u.exports, o), u.exports;
        }
        o.d = (s, l) => {
          for (var u in l)
            o.o(l, u) && !o.o(s, u) && Object.defineProperty(s, u, { enumerable: !0, get: l[u] });
        }, o.o = (s, l) => Object.prototype.hasOwnProperty.call(s, l), o.r = (s) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
        };
        var a = o("./src/index.ts");
        return a;
      })()
    ));
  })(Vf)), Vf.exports;
}
var Cle = /* @__PURE__ */ Ale();
const Ile = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, I3 = (e) => Cle.useMediaQuery({ minWidth: Ile[e] }), M3 = Le({}), x1 = () => Ce(M3), Mle = ({
  children: e,
  className: t = "",
  style: n = {},
  hideDrawerButton: r = !0
}) => {
  const { menuVisible: i, onMenuToggle: o, layoutRef: a } = x1(), s = I3("sm");
  return a ? ga(
    /* @__PURE__ */ R.jsxs(
      "nav",
      {
        className: Wn(
          "col-span-full bg-blue-500 flex justify-start items-center text-white px-4 col-start-1 row-span-1 w-full h-full",
          t
        ),
        style: n,
        children: [
          s && !r && /* @__PURE__ */ R.jsx(
            Uv,
            {
              className: "mr-8",
              sideBarVisible: i,
              onClick: () => o?.(!i)
            }
          ),
          e,
          !s && /* @__PURE__ */ R.jsx(R.Fragment, { children: /* @__PURE__ */ R.jsx(
            Uv,
            {
              sideBarVisible: i,
              onClick: () => o?.(!i)
            }
          ) })
        ]
      }
    ),
    a
  ) : null;
}, Rle = ({ children: e }) => {
  const { layoutRef: t } = x1();
  return t ? ga(
    /* @__PURE__ */ R.jsx("main", { className: "w-full h-full overflow-hidden row-start-2 col-start-2 col-span-full", children: e }),
    t
  ) : null;
}, h$ = Mr(
  [
    "bg-neutral-200",
    "h-full",
    "overflow-auto",
    "row-start-2",
    "col-span-1",
    "col-start-1"
  ],
  {
    variants: {
      size: {
        sm: ["sm:hidden", "block", "z-50"],
        lg: ["sm:block"]
      }
    }
  }
), Nle = ({ children: e }) => {
  const { onMenuToggle: t, menuVisible: n, layoutRef: r } = x1(), i = I3("sm");
  return r ? i ? n ? ga(
    /* @__PURE__ */ R.jsx(
      "aside",
      {
        className: h$({ size: "lg" }),
        children: e
      },
      "app-layout-menu"
    ),
    r
  ) : null : n ? ga(
    /* @__PURE__ */ R.jsxs(
      "aside",
      {
        className: h$({ size: "sm" }),
        children: [
          /* @__PURE__ */ R.jsx(
            "button",
            {
              onClick: () => t?.(!1),
              className: "ml-auto text-neutral-700",
              children: /* @__PURE__ */ R.jsx(cr, { icon: H6, size: "sm" })
            }
          ),
          e
        ]
      },
      "app-layout-menu"
    ),
    r
  ) : null : null;
};
function jle({
  to: e,
  icon: t,
  name: n,
  hasNotifications: r,
  children: i,
  href: o,
  linkProps: a
}) {
  if (!o && !e)
    throw new Error("to or href is required");
  return /* @__PURE__ */ R.jsx(dF, { children: /* @__PURE__ */ R.jsx("div", { className: "flex flex-col my-2", children: o ? /* @__PURE__ */ R.jsxs(
    "a",
    {
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      href: o,
      target: "_blank",
      rel: "noreferrer",
      children: [
        /* @__PURE__ */ R.jsxs("div", { className: "flex align-middle ", children: [
          r && /* @__PURE__ */ R.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ R.jsx(
            cr,
            {
              icon: t,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ R.jsx("p", { children: n })
        ] }),
        /* @__PURE__ */ R.jsx(Fd, {}),
        i
      ]
    }
  ) : /* @__PURE__ */ R.jsxs(
    es,
    {
      to: e,
      ...a || {},
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      children: [
        /* @__PURE__ */ R.jsxs("div", { className: "flex align-middle ", children: [
          r && /* @__PURE__ */ R.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ R.jsx(
            cr,
            {
              icon: t,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ R.jsx("p", { children: n })
        ] }),
        /* @__PURE__ */ R.jsx(Fd, {}),
        i
      ]
    }
  ) }) });
}
const Fle = Mr([
  "grid",
  "w-screen",
  "h-screen",
  "overflow-hidden",
  "bg-neutral-100",
  "flex-col",
  "app-layout",
  "grid-cols-[min-content_minmax(0,1fr)]",
  "grid-rows-[6rem_minmax(0,1fr)]"
]), uh = ({
  menuVisible: e = !1,
  children: t,
  onMenuToggle: n
}) => {
  const [r, i] = G.useState(null), [o, a] = G.useState(null), [s, l] = G.useState(null);
  return /* @__PURE__ */ R.jsx(
    M3.Provider,
    {
      value: {
        menuVisible: e,
        menuRef: s,
        onMenuToggle: n,
        layoutRef: r,
        headerRef: o
      },
      children: /* @__PURE__ */ R.jsx(
        "div",
        {
          className: Fle(),
          ref: i,
          children: t
        }
      )
    }
  );
};
uh.Header = Mle;
uh.Body = Rle;
uh.Menu = Nle;
uh.Link = jle;
const zle = ({
  onClick: e,
  sideBarVisible: t,
  className: n,
  showMenu: r = !0,
  isLoggedIn: i = !1,
  children: o
}) => /* @__PURE__ */ R.jsxs(
  "nav",
  {
    className: Wn(
      "w-screen h-full flex justify-between col-span-12 row-span-1 px-4 bg-blue-500",
      n
    ),
    children: [
      /* @__PURE__ */ R.jsxs("div", { className: "flex", children: [
        r && /* @__PURE__ */ R.jsx(
          Uv,
          {
            sideBarVisible: t,
            onClick: e || (() => null)
          }
        ),
        /* @__PURE__ */ R.jsx(es, { to: "/app", className: "block mx-4 my-auto h-1/2", children: /* @__PURE__ */ R.jsx(C3, { className: "w-8 h-8" }) }),
        /* @__PURE__ */ R.jsx("h1", { className: "my-auto text-xl text-white uppercase font-terminal ", children: o })
      ] }),
      /* @__PURE__ */ R.jsxs(
        G0,
        {
          className: "my-auto",
          button: /* @__PURE__ */ R.jsx(cr, { color: "white", size: "1x", icon: q6 }),
          children: [
            i && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
              /* @__PURE__ */ R.jsx("p", { className: "mb-8 border-b border-opacity-30 border-b-black" }),
              /* @__PURE__ */ R.jsx(es, { className: "menu-item", to: "/app/account", children: "Account" }),
              /* @__PURE__ */ R.jsx(es, { className: "menu-item", to: "/app/account/change-password", children: "Change Password" }),
              /* @__PURE__ */ R.jsx(es, { className: "menu-item", to: "/app/account/tokens", children: "CLI Tokens" }),
              /* @__PURE__ */ R.jsx(
                fa,
                {
                  onAction: async () => {
                  },
                  children: "Logout"
                }
              )
            ] }),
            !i && /* @__PURE__ */ R.jsx(es, { to: "/login", children: /* @__PURE__ */ R.jsx(fa, { children: "Login" }) })
          ]
        }
      )
    ]
  }
), Sc = {};
oi`
    mutation CreateFolder($newFolder: String!, $currentFolder: String!, $s3BucketId: Float) {
  createFolder(
    newFolder: $newFolder
    currentFolder: $currentFolder
    s3BucketId: $s3BucketId
  )
}
    `;
oi`
    mutation DeleteFiles($paths: [S3ObjectInput!]!) {
  deleteFilesResolver(paths: $paths)
}
    `;
oi`
    mutation MoveS3Files($target: S3ObjectInput!, $source: S3ObjectInput!) {
  moveS3Files(target: $target, source: $source)
}
    `;
oi`
    mutation MoveUpAFolder($moveUpAFolderPath: S3ObjectInput!) {
  moveUpAFolder(path: $moveUpAFolderPath)
}
    `;
oi`
    query FileTransfers {
  fileTransfers {
    name
    progress
    id
  }
}
    `;
oi`
    query FolderContents($s3BucketId: Float, $folder: String) {
  folderContents(s3BucketId: $s3BucketId, folder: $folder) {
    contents {
      key
      name
      isFolder
      fullPath
      bucket
    }
    errors
  }
  me {
    id
    awsUsername
  }
}
    `;
oi`
    query folderContentsSearch($search: String!, $s3BucketId: Int) {
  fileSearch(search: $search, s3BucketId: $s3BucketId) {
    results {
      fullPath
      key
      name
      isFolder
      bucket
    }
    errors
  }
}
    `;
const R3 = oi`
    query Me {
  me {
    id
    email
    awsUsername
    firstname
    lastname
    roles {
      role
    }
  }
}
    `;
function Lle(e) {
  const t = { ...Sc, ...e };
  return Qu.useQuery(R3, t);
}
function Vle(e) {
  const t = { ...Sc, ...e };
  return Qu.useLazyQuery(R3, t);
}
const N3 = oi`
    query PresignedDownloadUrl($bucket: String!, $key: String!, $limit: Float) {
  presignedDownloadUrl(bucket: $bucket, key: $key, limit: $limit)
}
    `;
function Ble(e) {
  const t = { ...Sc, ...e };
  return Qu.useQuery(N3, t);
}
function Kle(e) {
  const t = { ...Sc, ...e };
  return Qu.useLazyQuery(N3, t);
}
oi`
    subscription FileTranfersUpdated {
  fileTransfersUpdated {
    progress
    id
    name
  }
}
    `;
const Ule = oi`
    subscription TaskQueueLogs($jobId: String!) {
  taskQueueLogs(jobId: $jobId) {
    message
    timestamp
  }
}
    `;
function qle(e) {
  const t = { ...Sc, ...e };
  return Qu.useSubscription(Ule, t);
}
const Que = ({ appBarTitle: e }) => {
  const { data: t } = Lle();
  return /* @__PURE__ */ R.jsxs(Nn.div, { className: "grid w-screen h-screen bg-neutral-300 grid-rows-[4rem minmax(0, 1fr)] grid-cols-1", children: [
    /* @__PURE__ */ R.jsx(
      zle,
      {
        className: "h-16 bg-blue-600 ",
        onClick: () => null,
        sideBarVisible: !1,
        showMenu: !1,
        isLoggedIn: !!t?.me,
        children: e
      }
    ),
    /* @__PURE__ */ R.jsx("div", { className: "flex justify-around w-full h-full ", children: /* @__PURE__ */ R.jsx("div", { className: "w-full h-full max-w-6xl p-4 overflow-scroll bg-neutral-100", children: /* @__PURE__ */ R.jsx(u6, {}) }) })
  ] });
}, Hle = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}, Wle = ({
  children: e,
  className: t
}) => /* @__PURE__ */ R.jsx(
  Nn.div,
  {
    className: Wn("w-full min-h-full overflow-scroll", t),
    initial: "initial",
    animate: "in",
    exit: "out",
    variants: Hle,
    children: e
  }
), Zle = (e) => /* @__PURE__ */ R.jsx("h1", { className: "text-2xl flex-grow border-opacity-25", children: e.children }), j3 = ({ children: e, title: t, className: n }) => /* @__PURE__ */ R.jsx("div", { className: `flex py-2 mb-4 border-b border-black ${n}`, children: /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
  typeof t == "string" ? /* @__PURE__ */ R.jsx(Zle, { children: t }) : t,
  e
] }) }), Jue = () => /* @__PURE__ */ R.jsx(Wle, { children: /* @__PURE__ */ R.jsx(j3, { title: "Page not found" }) }), Gle = ({ data: e }) => {
  const t = URL.createObjectURL(e);
  return /* @__PURE__ */ R.jsx("div", { children: /* @__PURE__ */ R.jsx("img", { src: t, alt: "" }) });
}, Yle = () => /* @__PURE__ */ R.jsx("div", { className: "loader" }), Xue = () => /* @__PURE__ */ R.jsx("p", { children: "Loading..." });
async function F3(e, t, n, r) {
  const i = await e.getPage(n), o = i.getViewport({ scale: 5 });
  t.height = o.height, t.width = o.width;
  const a = t.getContext("2d");
  if (!a)
    return;
  const s = {
    canvasContext: a,
    viewport: o
  }, l = o.height * (n - 1);
  await i.render(s).promise, a.setTransform(1, 0, 0, 1, 0, 0), r.push({
    data: t.toDataURL(),
    offset: l,
    page: n
  }), n + 1 <= e.numPages && await F3(e, t, n + 1, r);
}
const Qle = ({ url: e, canvas: t }) => {
  const [n, r] = je(null), [i, o] = je([]), [a, s] = je(!1), l = Ne(
    async (u) => {
      if (!t || !n) return;
      const c = { data: [] };
      await F3(n, t, u, c.data), o(c.data), s(!0);
    },
    [n, s]
  );
  return De(() => {
    l(1);
  }, [n, l]), De(() => {
    ph.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${ph.version}/pdf.worker.js`, ph.getDocument({ url: e }).promise.then((c) => {
      r(c);
    });
  }, []), {
    ready: a,
    pageData: i,
    totalPages: n?.numPages
  };
}, Jle = ({ url: e }) => {
  const t = ve(null), { ready: n, pageData: r } = Qle({
    url: e,
    canvas: t.current
  });
  return /* @__PURE__ */ R.jsxs("div", { children: [
    !n && /* @__PURE__ */ R.jsx("canvas", { ref: t }),
    r.map(({ data: i }, o) => /* @__PURE__ */ R.jsx(
      "img",
      {
        className: "mb-2 max-w-xl",
        src: i
      },
      `pdf-preview-${e}=${o}`
    ))
  ] });
}, Xle = ({ data: e }) => {
  const [t, n] = je(null), r = async () => {
    const i = await e.text();
    n(i);
  };
  return De(() => {
    r();
  }, [e]), t ? /* @__PURE__ */ R.jsx("div", { children: /* @__PURE__ */ R.jsx("div", { dangerouslySetInnerHTML: { __html: t } }) }) : null;
};
var Bf = { exports: {} };
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/
var eue = Bf.exports, m$;
function tue() {
  return m$ || (m$ = 1, (function(e, t) {
    ((n, r) => {
      e.exports = r();
    })(eue, function n() {
      var r = typeof self < "u" ? self : typeof window < "u" ? window : r !== void 0 ? r : {}, i, o = !r.document && !!r.postMessage, a = r.IS_PAPA_WORKER || !1, s = {}, l = 0, u = {};
      function c(y) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, function(_) {
          var w = S(_);
          w.chunkSize = parseInt(w.chunkSize), _.step || _.chunk || (w.chunkSize = null), this._handle = new m(w), (this._handle.streamer = this)._config = w;
        }.call(this, y), this.parseChunk = function(_, w) {
          var A = parseInt(this._config.skipFirstNLines) || 0;
          if (this.isFirstChunk && 0 < A) {
            let N = this._config.newline;
            N || (k = this._config.quoteChar || '"', N = this._handle.guessLineEndings(_, k)), _ = [..._.split(N).slice(A)].join(N);
          }
          this.isFirstChunk && P(this._config.beforeFirstChunk) && (k = this._config.beforeFirstChunk(_)) !== void 0 && (_ = k), this.isFirstChunk = !1, this._halted = !1;
          var A = this._partialLine + _, k = (this._partialLine = "", this._handle.parse(A, this._baseIndex, !this._finished));
          if (!this._handle.paused() && !this._handle.aborted()) {
            if (_ = k.meta.cursor, A = (this._finished || (this._partialLine = A.substring(_ - this._baseIndex), this._baseIndex = _), k && k.data && (this._rowCount += k.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview), a) r.postMessage({ results: k, workerId: u.WORKER_ID, finished: A });
            else if (P(this._config.chunk) && !w) {
              if (this._config.chunk(k, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
              this._completeResults = k = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(k.data), this._completeResults.errors = this._completeResults.errors.concat(k.errors), this._completeResults.meta = k.meta), this._completed || !A || !P(this._config.complete) || k && k.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), A || k && k.meta.paused || this._nextChunk(), k;
          }
          this._halted = !0;
        }, this._sendError = function(_) {
          P(this._config.error) ? this._config.error(_) : a && this._config.error && r.postMessage({ workerId: u.WORKER_ID, error: _, finished: !1 });
        };
      }
      function f(y) {
        var _;
        (y = y || {}).chunkSize || (y.chunkSize = u.RemoteChunkSize), c.call(this, y), this._nextChunk = o ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(w) {
          this._input = w, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished) this._chunkLoaded();
          else {
            if (_ = new XMLHttpRequest(), this._config.withCredentials && (_.withCredentials = this._config.withCredentials), o || (_.onload = $(this._chunkLoaded, this), _.onerror = $(this._chunkError, this)), _.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !o), this._config.downloadRequestHeaders) {
              var w, A = this._config.downloadRequestHeaders;
              for (w in A) _.setRequestHeader(w, A[w]);
            }
            var k;
            this._config.chunkSize && (k = this._start + this._config.chunkSize - 1, _.setRequestHeader("Range", "bytes=" + this._start + "-" + k));
            try {
              _.send(this._config.downloadRequestBody);
            } catch (N) {
              this._chunkError(N.message);
            }
            o && _.status === 0 && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          _.readyState === 4 && (_.status < 200 || 400 <= _.status ? this._chunkError() : (this._start += this._config.chunkSize || _.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((w) => (w = w.getResponseHeader("Content-Range")) !== null ? parseInt(w.substring(w.lastIndexOf("/") + 1)) : -1)(_), this.parseChunk(_.responseText)));
        }, this._chunkError = function(w) {
          w = _.statusText || w, this._sendError(new Error(w));
        };
      }
      function d(y) {
        (y = y || {}).chunkSize || (y.chunkSize = u.LocalChunkSize), c.call(this, y);
        var _, w, A = typeof FileReader < "u";
        this.stream = function(k) {
          this._input = k, w = k.slice || k.webkitSlice || k.mozSlice, A ? ((_ = new FileReader()).onload = $(this._chunkLoaded, this), _.onerror = $(this._chunkError, this)) : _ = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var k = this._input, N = (this._config.chunkSize && (N = Math.min(this._start + this._config.chunkSize, this._input.size), k = w.call(k, this._start, N)), _.readAsText(k, this._config.encoding));
          A || this._chunkLoaded({ target: { result: N } });
        }, this._chunkLoaded = function(k) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(k.target.result);
        }, this._chunkError = function() {
          this._sendError(_.error);
        };
      }
      function p(y) {
        var _;
        c.call(this, y = y || {}), this.stream = function(w) {
          return _ = w, this._nextChunk();
        }, this._nextChunk = function() {
          var w, A;
          if (!this._finished) return w = this._config.chunkSize, _ = w ? (A = _.substring(0, w), _.substring(w)) : (A = _, ""), this._finished = !_, this.parseChunk(A);
        };
      }
      function h(y) {
        c.call(this, y = y || {});
        var _ = [], w = !0, A = !1;
        this.pause = function() {
          c.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          c.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(k) {
          this._input = k, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          A && _.length === 1 && (this._finished = !0);
        }, this._nextChunk = function() {
          this._checkIsFinished(), _.length ? this.parseChunk(_.shift()) : w = !0;
        }, this._streamData = $(function(k) {
          try {
            _.push(typeof k == "string" ? k : k.toString(this._config.encoding)), w && (w = !1, this._checkIsFinished(), this.parseChunk(_.shift()));
          } catch (N) {
            this._streamError(N);
          }
        }, this), this._streamError = $(function(k) {
          this._streamCleanUp(), this._sendError(k);
        }, this), this._streamEnd = $(function() {
          this._streamCleanUp(), A = !0, this._streamData("");
        }, this), this._streamCleanUp = $(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function m(y) {
        var _, w, A, k, N = Math.pow(2, 53), I = -N, B = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, q = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, ee = this, re = 0, Z = 0, T = !1, F = !1, M = [], K = { data: [], errors: [], meta: {} };
        function te(V) {
          return y.skipEmptyLines === "greedy" ? V.join("").trim() === "" : V.length === 1 && V[0].length === 0;
        }
        function se() {
          if (K && A && (ge("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + u.DefaultDelimiter + "'"), A = !1), y.skipEmptyLines && (K.data = K.data.filter(function(C) {
            return !te(C);
          })), de()) {
            let C = function(z, H) {
              P(y.transformHeader) && (z = y.transformHeader(z, H)), M.push(z);
            };
            if (K) if (Array.isArray(K.data[0])) {
              for (var V = 0; de() && V < K.data.length; V++) K.data[V].forEach(C);
              K.data.splice(0, 1);
            } else K.data.forEach(C);
          }
          function O(C, z) {
            for (var H = y.header ? {} : [], X = 0; X < C.length; X++) {
              var fe = X, ce = C[X], ce = ((xe, ne) => ((we) => (y.dynamicTypingFunction && y.dynamicTyping[we] === void 0 && (y.dynamicTyping[we] = y.dynamicTypingFunction(we)), (y.dynamicTyping[we] || y.dynamicTyping) === !0))(xe) ? ne === "true" || ne === "TRUE" || ne !== "false" && ne !== "FALSE" && (((we) => {
                if (B.test(we) && (we = parseFloat(we), I < we && we < N))
                  return 1;
              })(ne) ? parseFloat(ne) : q.test(ne) ? new Date(ne) : ne === "" ? null : ne) : ne)(fe = y.header ? X >= M.length ? "__parsed_extra" : M[X] : fe, ce = y.transform ? y.transform(ce, fe) : ce);
              fe === "__parsed_extra" ? (H[fe] = H[fe] || [], H[fe].push(ce)) : H[fe] = ce;
            }
            return y.header && (X > M.length ? ge("FieldMismatch", "TooManyFields", "Too many fields: expected " + M.length + " fields but parsed " + X, Z + z) : X < M.length && ge("FieldMismatch", "TooFewFields", "Too few fields: expected " + M.length + " fields but parsed " + X, Z + z)), H;
          }
          var D;
          K && (y.header || y.dynamicTyping || y.transform) && (D = 1, !K.data.length || Array.isArray(K.data[0]) ? (K.data = K.data.map(O), D = K.data.length) : K.data = O(K.data, 0), y.header && K.meta && (K.meta.fields = M), Z += D);
        }
        function de() {
          return y.header && M.length === 0;
        }
        function ge(V, O, D, C) {
          V = { type: V, code: O, message: D }, C !== void 0 && (V.row = C), K.errors.push(V);
        }
        P(y.step) && (k = y.step, y.step = function(V) {
          K = V, de() ? se() : (se(), K.data.length !== 0 && (re += V.data.length, y.preview && re > y.preview ? w.abort() : (K.data = K.data[0], k(K, ee))));
        }), this.parse = function(V, O, D) {
          var C = y.quoteChar || '"', C = (y.newline || (y.newline = this.guessLineEndings(V, C)), A = !1, y.delimiter ? P(y.delimiter) && (y.delimiter = y.delimiter(V), K.meta.delimiter = y.delimiter) : ((C = ((z, H, X, fe, ce) => {
            var xe, ne, we, ke;
            ce = ce || [",", "	", "|", ";", u.RECORD_SEP, u.UNIT_SEP];
            for (var pe = 0; pe < ce.length; pe++) {
              for (var j, U = ce[pe], Y = 0, Q = 0, J = 0, ae = (we = void 0, new g({ comments: fe, delimiter: U, newline: H, preview: 10 }).parse(z)), be = 0; be < ae.data.length; be++) X && te(ae.data[be]) ? J++ : (j = ae.data[be].length, Q += j, we === void 0 ? we = j : 0 < j && (Y += Math.abs(j - we), we = j));
              0 < ae.data.length && (Q /= ae.data.length - J), (ne === void 0 || Y <= ne) && (ke === void 0 || ke < Q) && 1.99 < Q && (ne = Y, xe = U, ke = Q);
            }
            return { successful: !!(y.delimiter = xe), bestDelimiter: xe };
          })(V, y.newline, y.skipEmptyLines, y.comments, y.delimitersToGuess)).successful ? y.delimiter = C.bestDelimiter : (A = !0, y.delimiter = u.DefaultDelimiter), K.meta.delimiter = y.delimiter), S(y));
          return y.preview && y.header && C.preview++, _ = V, w = new g(C), K = w.parse(_, O, D), se(), T ? { meta: { paused: !0 } } : K || { meta: { paused: !1 } };
        }, this.paused = function() {
          return T;
        }, this.pause = function() {
          T = !0, w.abort(), _ = P(y.chunk) ? "" : _.substring(w.getCharIndex());
        }, this.resume = function() {
          ee.streamer._halted ? (T = !1, ee.streamer.parseChunk(_, !0)) : setTimeout(ee.resume, 3);
        }, this.aborted = function() {
          return F;
        }, this.abort = function() {
          F = !0, w.abort(), K.meta.aborted = !0, P(y.complete) && y.complete(K), _ = "";
        }, this.guessLineEndings = function(z, C) {
          z = z.substring(0, 1048576);
          var C = new RegExp(v(C) + "([^]*?)" + v(C), "gm"), D = (z = z.replace(C, "")).split("\r"), C = z.split(`
`), z = 1 < C.length && C[0].length < D[0].length;
          if (D.length === 1 || z) return `
`;
          for (var H = 0, X = 0; X < D.length; X++) D[X][0] === `
` && H++;
          return H >= D.length / 2 ? `\r
` : "\r";
        };
      }
      function v(y) {
        return y.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function g(y) {
        var _ = (y = y || {}).delimiter, w = y.newline, A = y.comments, k = y.step, N = y.preview, I = y.fastMode, B = null, q = !1, ee = y.quoteChar == null ? '"' : y.quoteChar, re = ee;
        if (y.escapeChar !== void 0 && (re = y.escapeChar), (typeof _ != "string" || -1 < u.BAD_DELIMITERS.indexOf(_)) && (_ = ","), A === _) throw new Error("Comment character same as delimiter");
        A === !0 ? A = "#" : (typeof A != "string" || -1 < u.BAD_DELIMITERS.indexOf(A)) && (A = !1), w !== `
` && w !== "\r" && w !== `\r
` && (w = `
`);
        var Z = 0, T = !1;
        this.parse = function(F, M, K) {
          if (typeof F != "string") throw new Error("Input must be a string");
          var te = F.length, se = _.length, de = w.length, ge = A.length, V = P(k), O = [], D = [], C = [], z = Z = 0;
          if (!F) return Y();
          if (I || I !== !1 && F.indexOf(ee) === -1) {
            for (var H = F.split(w), X = 0; X < H.length; X++) {
              if (C = H[X], Z += C.length, X !== H.length - 1) Z += w.length;
              else if (K) return Y();
              if (!A || C.substring(0, ge) !== A) {
                if (V) {
                  if (O = [], ke(C.split(_)), Q(), T) return Y();
                } else ke(C.split(_));
                if (N && N <= X) return O = O.slice(0, N), Y(!0);
              }
            }
            return Y();
          }
          for (var fe = F.indexOf(_, Z), ce = F.indexOf(w, Z), xe = new RegExp(v(re) + v(ee), "g"), ne = F.indexOf(ee, Z); ; ) if (F[Z] === ee) for (ne = Z, Z++; ; ) {
            if ((ne = F.indexOf(ee, ne + 1)) === -1) return K || D.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: O.length, index: Z }), j();
            if (ne === te - 1) return j(F.substring(Z, ne).replace(xe, ee));
            if (ee === re && F[ne + 1] === re) ne++;
            else if (ee === re || ne === 0 || F[ne - 1] !== re) {
              fe !== -1 && fe < ne + 1 && (fe = F.indexOf(_, ne + 1));
              var we = pe((ce = ce !== -1 && ce < ne + 1 ? F.indexOf(w, ne + 1) : ce) === -1 ? fe : Math.min(fe, ce));
              if (F.substr(ne + 1 + we, se) === _) {
                C.push(F.substring(Z, ne).replace(xe, ee)), F[Z = ne + 1 + we + se] !== ee && (ne = F.indexOf(ee, Z)), fe = F.indexOf(_, Z), ce = F.indexOf(w, Z);
                break;
              }
              if (we = pe(ce), F.substring(ne + 1 + we, ne + 1 + we + de) === w) {
                if (C.push(F.substring(Z, ne).replace(xe, ee)), U(ne + 1 + we + de), fe = F.indexOf(_, Z), ne = F.indexOf(ee, Z), V && (Q(), T)) return Y();
                if (N && O.length >= N) return Y(!0);
                break;
              }
              D.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: O.length, index: Z }), ne++;
            }
          }
          else if (A && C.length === 0 && F.substring(Z, Z + ge) === A) {
            if (ce === -1) return Y();
            Z = ce + de, ce = F.indexOf(w, Z), fe = F.indexOf(_, Z);
          } else if (fe !== -1 && (fe < ce || ce === -1)) C.push(F.substring(Z, fe)), Z = fe + se, fe = F.indexOf(_, Z);
          else {
            if (ce === -1) break;
            if (C.push(F.substring(Z, ce)), U(ce + de), V && (Q(), T)) return Y();
            if (N && O.length >= N) return Y(!0);
          }
          return j();
          function ke(J) {
            O.push(J), z = Z;
          }
          function pe(J) {
            var ae = 0;
            return ae = J !== -1 && (J = F.substring(ne + 1, J)) && J.trim() === "" ? J.length : ae;
          }
          function j(J) {
            return K || (J === void 0 && (J = F.substring(Z)), C.push(J), Z = te, ke(C), V && Q()), Y();
          }
          function U(J) {
            Z = J, ke(C), C = [], ce = F.indexOf(w, Z);
          }
          function Y(J) {
            if (y.header && !M && O.length && !q) {
              var ae = O[0], be = /* @__PURE__ */ Object.create(null), Ae = new Set(ae);
              let qe = !1;
              for (let rt = 0; rt < ae.length; rt++) {
                let mt = ae[rt];
                if (be[mt = P(y.transformHeader) ? y.transformHeader(mt, rt) : mt]) {
                  let _t, ci = be[mt];
                  for (; _t = mt + "_" + ci, ci++, Ae.has(_t); ) ;
                  Ae.add(_t), ae[rt] = _t, be[mt]++, qe = !0, (B = B === null ? {} : B)[_t] = mt;
                } else be[mt] = 1, ae[rt] = mt;
                Ae.add(mt);
              }
              qe && console.warn("Duplicate headers found and renamed."), q = !0;
            }
            return { data: O, errors: D, meta: { delimiter: _, linebreak: w, aborted: T, truncated: !!J, cursor: z + (M || 0), renamedHeaders: B } };
          }
          function Q() {
            k(Y()), O = [], D = [];
          }
        }, this.abort = function() {
          T = !0;
        }, this.getCharIndex = function() {
          return Z;
        };
      }
      function b(y) {
        var _ = y.data, w = s[_.workerId], A = !1;
        if (_.error) w.userError(_.error, _.file);
        else if (_.results && _.results.data) {
          var k = { abort: function() {
            A = !0, E(_.workerId, { data: [], errors: [], meta: { aborted: !0 } });
          }, pause: x, resume: x };
          if (P(w.userStep)) {
            for (var N = 0; N < _.results.data.length && (w.userStep({ data: _.results.data[N], errors: _.results.errors, meta: _.results.meta }, k), !A); N++) ;
            delete _.results;
          } else P(w.userChunk) && (w.userChunk(_.results, k, _.file), delete _.results);
        }
        _.finished && !A && E(_.workerId, _.results);
      }
      function E(y, _) {
        var w = s[y];
        P(w.userComplete) && w.userComplete(_), w.terminate(), delete s[y];
      }
      function x() {
        throw new Error("Not implemented.");
      }
      function S(y) {
        if (typeof y != "object" || y === null) return y;
        var _, w = Array.isArray(y) ? [] : {};
        for (_ in y) w[_] = S(y[_]);
        return w;
      }
      function $(y, _) {
        return function() {
          y.apply(_, arguments);
        };
      }
      function P(y) {
        return typeof y == "function";
      }
      return u.parse = function(y, _) {
        var w = (_ = _ || {}).dynamicTyping || !1;
        if (P(w) && (_.dynamicTypingFunction = w, w = {}), _.dynamicTyping = w, _.transform = !!P(_.transform) && _.transform, !_.worker || !u.WORKERS_SUPPORTED) return w = null, u.NODE_STREAM_INPUT, typeof y == "string" ? (y = ((A) => A.charCodeAt(0) !== 65279 ? A : A.slice(1))(y), w = new (_.download ? f : p)(_)) : y.readable === !0 && P(y.read) && P(y.on) ? w = new h(_) : (r.File && y instanceof File || y instanceof Object) && (w = new d(_)), w.stream(y);
        (w = (() => {
          var A;
          return !!u.WORKERS_SUPPORTED && (A = (() => {
            var k = r.URL || r.webkitURL || null, N = n.toString();
            return u.BLOB_URL || (u.BLOB_URL = k.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", N, ")();"], { type: "text/javascript" })));
          })(), (A = new r.Worker(A)).onmessage = b, A.id = l++, s[A.id] = A);
        })()).userStep = _.step, w.userChunk = _.chunk, w.userComplete = _.complete, w.userError = _.error, _.step = P(_.step), _.chunk = P(_.chunk), _.complete = P(_.complete), _.error = P(_.error), delete _.worker, w.postMessage({ input: y, config: _, workerId: w.id });
      }, u.unparse = function(y, _) {
        var w = !1, A = !0, k = ",", N = `\r
`, I = '"', B = I + I, q = !1, ee = null, re = !1, Z = ((() => {
          if (typeof _ == "object") {
            if (typeof _.delimiter != "string" || u.BAD_DELIMITERS.filter(function(M) {
              return _.delimiter.indexOf(M) !== -1;
            }).length || (k = _.delimiter), typeof _.quotes != "boolean" && typeof _.quotes != "function" && !Array.isArray(_.quotes) || (w = _.quotes), typeof _.skipEmptyLines != "boolean" && typeof _.skipEmptyLines != "string" || (q = _.skipEmptyLines), typeof _.newline == "string" && (N = _.newline), typeof _.quoteChar == "string" && (I = _.quoteChar), typeof _.header == "boolean" && (A = _.header), Array.isArray(_.columns)) {
              if (_.columns.length === 0) throw new Error("Option columns is empty");
              ee = _.columns;
            }
            _.escapeChar !== void 0 && (B = _.escapeChar + I), _.escapeFormulae instanceof RegExp ? re = _.escapeFormulae : typeof _.escapeFormulae == "boolean" && _.escapeFormulae && (re = /^[=+\-@\t\r].*$/);
          }
        })(), new RegExp(v(I), "g"));
        if (typeof y == "string" && (y = JSON.parse(y)), Array.isArray(y)) {
          if (!y.length || Array.isArray(y[0])) return T(null, y, q);
          if (typeof y[0] == "object") return T(ee || Object.keys(y[0]), y, q);
        } else if (typeof y == "object") return typeof y.data == "string" && (y.data = JSON.parse(y.data)), Array.isArray(y.data) && (y.fields || (y.fields = y.meta && y.meta.fields || ee), y.fields || (y.fields = Array.isArray(y.data[0]) ? y.fields : typeof y.data[0] == "object" ? Object.keys(y.data[0]) : []), Array.isArray(y.data[0]) || typeof y.data[0] == "object" || (y.data = [y.data])), T(y.fields || [], y.data || [], q);
        throw new Error("Unable to serialize unrecognized input");
        function T(M, K, te) {
          var se = "", de = (typeof M == "string" && (M = JSON.parse(M)), typeof K == "string" && (K = JSON.parse(K)), Array.isArray(M) && 0 < M.length), ge = !Array.isArray(K[0]);
          if (de && A) {
            for (var V = 0; V < M.length; V++) 0 < V && (se += k), se += F(M[V], V);
            0 < K.length && (se += N);
          }
          for (var O = 0; O < K.length; O++) {
            var D = (de ? M : K[O]).length, C = !1, z = de ? Object.keys(K[O]).length === 0 : K[O].length === 0;
            if (te && !de && (C = te === "greedy" ? K[O].join("").trim() === "" : K[O].length === 1 && K[O][0].length === 0), te === "greedy" && de) {
              for (var H = [], X = 0; X < D; X++) {
                var fe = ge ? M[X] : X;
                H.push(K[O][fe]);
              }
              C = H.join("").trim() === "";
            }
            if (!C) {
              for (var ce = 0; ce < D; ce++) {
                0 < ce && !z && (se += k);
                var xe = de && ge ? M[ce] : ce;
                se += F(K[O][xe], ce);
              }
              O < K.length - 1 && (!te || 0 < D && !z) && (se += N);
            }
          }
          return se;
        }
        function F(M, K) {
          var te, se;
          return M == null ? "" : M.constructor === Date ? JSON.stringify(M).slice(1, 25) : (se = !1, re && typeof M == "string" && re.test(M) && (M = "'" + M, se = !0), te = M.toString().replace(Z, B), (se = se || w === !0 || typeof w == "function" && w(M, K) || Array.isArray(w) && w[K] || ((de, ge) => {
            for (var V = 0; V < ge.length; V++) if (-1 < de.indexOf(ge[V])) return !0;
            return !1;
          })(te, u.BAD_DELIMITERS) || -1 < te.indexOf(k) || te.charAt(0) === " " || te.charAt(te.length - 1) === " ") ? I + te + I : te);
        }
      }, u.RECORD_SEP = "", u.UNIT_SEP = "", u.BYTE_ORDER_MARK = "\uFEFF", u.BAD_DELIMITERS = ["\r", `
`, '"', u.BYTE_ORDER_MARK], u.WORKERS_SUPPORTED = !o && !!r.Worker, u.NODE_STREAM_INPUT = 1, u.LocalChunkSize = 10485760, u.RemoteChunkSize = 5242880, u.DefaultDelimiter = ",", u.Parser = g, u.ParserHandle = m, u.NetworkStreamer = f, u.FileStreamer = d, u.StringStreamer = p, u.ReadableStreamStreamer = h, r.jQuery && ((i = r.jQuery).fn.parse = function(y) {
        var _ = y.config || {}, w = [];
        return this.each(function(N) {
          if (!(i(this).prop("tagName").toUpperCase() === "INPUT" && i(this).attr("type").toLowerCase() === "file" && r.FileReader) || !this.files || this.files.length === 0) return !0;
          for (var I = 0; I < this.files.length; I++) w.push({ file: this.files[I], inputElem: this, instanceConfig: i.extend({}, _) });
        }), A(), this;
        function A() {
          if (w.length === 0) P(y.complete) && y.complete();
          else {
            var N, I, B, q, ee = w[0];
            if (P(y.before)) {
              var re = y.before(ee.file, ee.inputElem);
              if (typeof re == "object") {
                if (re.action === "abort") return N = "AbortError", I = ee.file, B = ee.inputElem, q = re.reason, void (P(y.error) && y.error({ name: N }, I, B, q));
                if (re.action === "skip") return void k();
                typeof re.config == "object" && (ee.instanceConfig = i.extend(ee.instanceConfig, re.config));
              } else if (re === "skip") return void k();
            }
            var Z = ee.instanceConfig.complete;
            ee.instanceConfig.complete = function(T) {
              P(Z) && Z(T, ee.file, ee.inputElem), k();
            }, u.parse(ee.file, ee.instanceConfig);
          }
        }
        function k() {
          w.splice(0, 1), A();
        }
      }), a && (r.onmessage = function(y) {
        y = y.data, u.WORKER_ID === void 0 && y && (u.WORKER_ID = y.workerId), typeof y.input == "string" ? r.postMessage({ workerId: u.WORKER_ID, results: u.parse(y.input, y.config), finished: !0 }) : (r.File && y.input instanceof File || y.input instanceof Object) && (y = u.parse(y.input, y.config)) && r.postMessage({ workerId: u.WORKER_ID, results: y, finished: !0 });
      }), (f.prototype = Object.create(c.prototype)).constructor = f, (d.prototype = Object.create(c.prototype)).constructor = d, (p.prototype = Object.create(p.prototype)).constructor = p, (h.prototype = Object.create(c.prototype)).constructor = h, u;
    });
  })(Bf)), Bf.exports;
}
var nue = tue();
const rue = (e) => /* @__PURE__ */ R.jsx(
  "table",
  {
    className: "bg-neutral-200 mb-4 border-collapse rounded border-none",
    ...e
  }
), iue = ({ data: e }) => {
  const [t, n] = je(null), r = async () => {
    const i = await e.text();
    nue.parse(i, {
      complete: (o) => n(o.data)
    });
  };
  return De(() => {
    r();
  }, [e]), t ? /* @__PURE__ */ R.jsx("div", { className: "p-4 rounded-md bg-neutral-200", children: /* @__PURE__ */ R.jsx(rue, { children: /* @__PURE__ */ R.jsx("tbody", { children: t.map((i, o) => /* @__PURE__ */ R.jsx("tr", { children: Object.keys(i).map((a, s) => /* @__PURE__ */ R.jsx("td", { children: i[a] }, `cell-${o * s}`)) }, `row-${o}`)) }) }) }) : /* @__PURE__ */ R.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ R.jsx("p", { children: "Loading..." }) });
}, v$ = 5e3, ece = ({ bucket: e, fileKey: t }) => {
  if (!e || !t)
    return /* @__PURE__ */ R.jsx("div", { children: "Invalid URL" });
  const n = t, r = n.endsWith(".pdf"), i = n.split(".").pop(), o = Ble({
    variables: { bucket: e, key: n, limit: r ? void 0 : v$ }
  }), [a] = Kle(), [s, l] = je(null), u = n.split("/").pop() || n, c = Ne(
    async (d) => {
      const h = await (await fetch(d, {
        headers: { Range: `bytes=0-${v$}` }
      })).blob();
      l(h);
    },
    [l]
  );
  if (De(() => {
    o.data?.presignedDownloadUrl && c(o.data.presignedDownloadUrl);
  }, [o.data?.presignedDownloadUrl, c]), !s)
    return /* @__PURE__ */ R.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ R.jsx(Yle, {}) });
  let f;
  switch (i) {
    case "svg":
      f = /* @__PURE__ */ R.jsx(Xle, { data: s });
      break;
    case "csv":
    case "bed":
    case "fastq":
    case "tsv":
      f = /* @__PURE__ */ R.jsx(iue, { data: s });
      break;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
    case "webp":
    case "tiff":
    case "tif":
    case "ico":
    case "jfif":
      f = /* @__PURE__ */ R.jsx(Gle, { data: s });
      break;
    case "pdf":
      f = /* @__PURE__ */ R.jsx(Jle, { url: o.data?.presignedDownloadUrl || "" });
      break;
    default:
      f = /* @__PURE__ */ R.jsx("div", { children: "Preview not available for this file type" });
      break;
  }
  return /* @__PURE__ */ R.jsxs("div", { className: "flex flex-col w-full h-full overflow-scroll", children: [
    /* @__PURE__ */ R.jsx(j3, { title: u, children: /* @__PURE__ */ R.jsx(
      $y,
      {
        onClick: async () => {
          const p = (await a({ variables: { bucket: e, key: n } })).data?.presignedDownloadUrl;
          p && window.open(p);
        },
        variant: "gray",
        children: "Download"
      }
    ) }),
    /* @__PURE__ */ R.jsx("div", { className: "flex justify-around w-full", children: f })
  ] });
}, oue = ({
  validate: e,
  children: t,
  onFailure: n
}) => {
  const [r, i] = je(!0), o = Ne(async () => {
    await e() ? i(!1) : n();
  }, []);
  return De(() => {
    o();
  }, []), r ? null : /* @__PURE__ */ R.jsx(R.Fragment, { children: t });
};
function aue(e, t) {
  return t.some(
    (n) => e.some((r) => r.role === n)
  );
}
const tce = ({
  roles: e,
  children: t,
  loginUrl: n
}) => {
  const [r] = Vle({ fetchPolicy: "cache-first" });
  return /* @__PURE__ */ R.jsx(
    oue,
    {
      onFailure: () => {
        window.location.href = `${n}?redirect=${encodeURIComponent(
          window.location.href
        )}`;
      },
      validate: async () => {
        const i = await r();
        return !(!i.data?.me || !aue(i.data.me.roles || [], e));
      },
      children: t
    }
  );
}, nce = ({
  path: e,
  className: t,
  children: n,
  endpoint: r
}) => {
  const i = `${r}/download?bucket=${e}&key=${e}&isFolder=${e.isFolder ? 1 : 0}`;
  return /* @__PURE__ */ R.jsx("a", { className: t, href: i, download: "asfdkl", children: n });
};
function ff(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Gm = { exports: {} }, g$;
function sue() {
  return g$ || (g$ = 1, (function(e, t) {
    (function(n) {
      e.exports = n();
    })(function() {
      return (function n(r, i, o) {
        function a(u, c) {
          if (!i[u]) {
            if (!r[u]) {
              var f = typeof ff == "function" && ff;
              if (!c && f) return f(u, !0);
              if (s) return s(u, !0);
              throw new Error("Cannot find module '" + u + "'");
            }
            c = i[u] = { exports: {} }, r[u][0].call(c.exports, function(d) {
              var p = r[u][1][d];
              return a(p || d);
            }, c, c.exports, n, r, i, o);
          }
          return i[u].exports;
        }
        for (var s = typeof ff == "function" && ff, l = 0; l < o.length; l++) a(o[l]);
        return a;
      })({ 1: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("crypto");
          function m($, P) {
            P = b($, P);
            var y;
            return (y = P.algorithm !== "passthrough" ? h.createHash(P.algorithm) : new S()).write === void 0 && (y.write = y.update, y.end = y.update), x(P, y).dispatch($), y.update || y.end(""), y.digest ? y.digest(P.encoding === "buffer" ? void 0 : P.encoding) : ($ = y.read(), P.encoding !== "buffer" ? $.toString(P.encoding) : $);
          }
          (i = r.exports = m).sha1 = function($) {
            return m($);
          }, i.keys = function($) {
            return m($, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
          }, i.MD5 = function($) {
            return m($, { algorithm: "md5", encoding: "hex" });
          }, i.keysMD5 = function($) {
            return m($, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
          };
          var v = h.getHashes ? h.getHashes().slice() : ["sha1", "md5"], g = (v.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
          function b($, P) {
            var y = {};
            if (y.algorithm = (P = P || {}).algorithm || "sha1", y.encoding = P.encoding || "hex", y.excludeValues = !!P.excludeValues, y.algorithm = y.algorithm.toLowerCase(), y.encoding = y.encoding.toLowerCase(), y.ignoreUnknown = P.ignoreUnknown === !0, y.respectType = P.respectType !== !1, y.respectFunctionNames = P.respectFunctionNames !== !1, y.respectFunctionProperties = P.respectFunctionProperties !== !1, y.unorderedArrays = P.unorderedArrays === !0, y.unorderedSets = P.unorderedSets !== !1, y.unorderedObjects = P.unorderedObjects !== !1, y.replacer = P.replacer || void 0, y.excludeKeys = P.excludeKeys || void 0, $ === void 0) throw new Error("Object argument required.");
            for (var _ = 0; _ < v.length; ++_) v[_].toLowerCase() === y.algorithm.toLowerCase() && (y.algorithm = v[_]);
            if (v.indexOf(y.algorithm) === -1) throw new Error('Algorithm "' + y.algorithm + '"  not supported. supported values: ' + v.join(", "));
            if (g.indexOf(y.encoding) === -1 && y.algorithm !== "passthrough") throw new Error('Encoding "' + y.encoding + '"  not supported. supported values: ' + g.join(", "));
            return y;
          }
          function E($) {
            if (typeof $ == "function") return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call($)) != null;
          }
          function x($, P, y) {
            y = y || [];
            function _(w) {
              return P.update ? P.update(w, "utf8") : P.write(w, "utf8");
            }
            return { dispatch: function(w) {
              return this["_" + ((w = $.replacer ? $.replacer(w) : w) === null ? "null" : typeof w)](w);
            }, _object: function(w) {
              var A, k = Object.prototype.toString.call(w), N = /\[object (.*)\]/i.exec(k);
              if (N = (N = N ? N[1] : "unknown:[" + k + "]").toLowerCase(), 0 <= (k = y.indexOf(w))) return this.dispatch("[CIRCULAR:" + k + "]");
              if (y.push(w), s !== void 0 && s.isBuffer && s.isBuffer(w)) return _("buffer:"), _(w);
              if (N === "object" || N === "function" || N === "asyncfunction") return k = Object.keys(w), $.unorderedObjects && (k = k.sort()), $.respectType === !1 || E(w) || k.splice(0, 0, "prototype", "__proto__", "constructor"), $.excludeKeys && (k = k.filter(function(I) {
                return !$.excludeKeys(I);
              })), _("object:" + k.length + ":"), A = this, k.forEach(function(I) {
                A.dispatch(I), _(":"), $.excludeValues || A.dispatch(w[I]), _(",");
              });
              if (!this["_" + N]) {
                if ($.ignoreUnknown) return _("[" + N + "]");
                throw new Error('Unknown object type "' + N + '"');
              }
              this["_" + N](w);
            }, _array: function(w, I) {
              I = I !== void 0 ? I : $.unorderedArrays !== !1;
              var k = this;
              if (_("array:" + w.length + ":"), !I || w.length <= 1) return w.forEach(function(B) {
                return k.dispatch(B);
              });
              var N = [], I = w.map(function(B) {
                var q = new S(), ee = y.slice();
                return x($, q, ee).dispatch(B), N = N.concat(ee.slice(y.length)), q.read().toString();
              });
              return y = y.concat(N), I.sort(), this._array(I, !1);
            }, _date: function(w) {
              return _("date:" + w.toJSON());
            }, _symbol: function(w) {
              return _("symbol:" + w.toString());
            }, _error: function(w) {
              return _("error:" + w.toString());
            }, _boolean: function(w) {
              return _("bool:" + w.toString());
            }, _string: function(w) {
              _("string:" + w.length + ":"), _(w.toString());
            }, _function: function(w) {
              _("fn:"), E(w) ? this.dispatch("[native]") : this.dispatch(w.toString()), $.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(w.name)), $.respectFunctionProperties && this._object(w);
            }, _number: function(w) {
              return _("number:" + w.toString());
            }, _xml: function(w) {
              return _("xml:" + w.toString());
            }, _null: function() {
              return _("Null");
            }, _undefined: function() {
              return _("Undefined");
            }, _regexp: function(w) {
              return _("regex:" + w.toString());
            }, _uint8array: function(w) {
              return _("uint8array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _uint8clampedarray: function(w) {
              return _("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(w));
            }, _int8array: function(w) {
              return _("int8array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _uint16array: function(w) {
              return _("uint16array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _int16array: function(w) {
              return _("int16array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _uint32array: function(w) {
              return _("uint32array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _int32array: function(w) {
              return _("int32array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _float32array: function(w) {
              return _("float32array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _float64array: function(w) {
              return _("float64array:"), this.dispatch(Array.prototype.slice.call(w));
            }, _arraybuffer: function(w) {
              return _("arraybuffer:"), this.dispatch(new Uint8Array(w));
            }, _url: function(w) {
              return _("url:" + w.toString());
            }, _map: function(w) {
              return _("map:"), w = Array.from(w), this._array(w, $.unorderedSets !== !1);
            }, _set: function(w) {
              return _("set:"), w = Array.from(w), this._array(w, $.unorderedSets !== !1);
            }, _file: function(w) {
              return _("file:"), this.dispatch([w.name, w.size, w.type, w.lastModfied]);
            }, _blob: function() {
              if ($.ignoreUnknown) return _("[blob]");
              throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
            }, _domwindow: function() {
              return _("domwindow");
            }, _bigint: function(w) {
              return _("bigint:" + w.toString());
            }, _process: function() {
              return _("process");
            }, _timer: function() {
              return _("timer");
            }, _pipe: function() {
              return _("pipe");
            }, _tcp: function() {
              return _("tcp");
            }, _udp: function() {
              return _("udp");
            }, _tty: function() {
              return _("tty");
            }, _statwatcher: function() {
              return _("statwatcher");
            }, _securecontext: function() {
              return _("securecontext");
            }, _connection: function() {
              return _("connection");
            }, _zlib: function() {
              return _("zlib");
            }, _context: function() {
              return _("context");
            }, _nodescript: function() {
              return _("nodescript");
            }, _httpparser: function() {
              return _("httpparser");
            }, _dataview: function() {
              return _("dataview");
            }, _signal: function() {
              return _("signal");
            }, _fsevent: function() {
              return _("fsevent");
            }, _tlswrap: function() {
              return _("tlswrap");
            } };
          }
          function S() {
            return { buf: "", write: function($) {
              this.buf += $;
            }, end: function($) {
              this.buf += $;
            }, read: function() {
              return this.buf;
            } };
          }
          i.writeToStream = function($, P, y) {
            return y === void 0 && (y = P, P = {}), x(P = b($, P), y).dispatch($);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
      }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          (function(h) {
            var m = typeof Uint8Array < "u" ? Uint8Array : Array, v = 43, g = 47, b = 48, E = 97, x = 65, S = 45, $ = 95;
            function P(y) {
              return y = y.charCodeAt(0), y === v || y === S ? 62 : y === g || y === $ ? 63 : y < b ? -1 : y < b + 10 ? y - b + 26 + 26 : y < x + 26 ? y - x : y < E + 26 ? y - E + 26 : void 0;
            }
            h.toByteArray = function(y) {
              var _, w;
              if (0 < y.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
              var A = y.length, A = y.charAt(A - 2) === "=" ? 2 : y.charAt(A - 1) === "=" ? 1 : 0, k = new m(3 * y.length / 4 - A), N = 0 < A ? y.length - 4 : y.length, I = 0;
              function B(q) {
                k[I++] = q;
              }
              for (_ = 0; _ < N; _ += 4, 0) B((16711680 & (w = P(y.charAt(_)) << 18 | P(y.charAt(_ + 1)) << 12 | P(y.charAt(_ + 2)) << 6 | P(y.charAt(_ + 3)))) >> 16), B((65280 & w) >> 8), B(255 & w);
              return A == 2 ? B(255 & (w = P(y.charAt(_)) << 2 | P(y.charAt(_ + 1)) >> 4)) : A == 1 && (B((w = P(y.charAt(_)) << 10 | P(y.charAt(_ + 1)) << 4 | P(y.charAt(_ + 2)) >> 2) >> 8 & 255), B(255 & w)), k;
            }, h.fromByteArray = function(y) {
              var _, w, A, k, N = y.length % 3, I = "";
              function B(q) {
                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(q);
              }
              for (_ = 0, A = y.length - N; _ < A; _ += 3) w = (y[_] << 16) + (y[_ + 1] << 8) + y[_ + 2], I += B((k = w) >> 18 & 63) + B(k >> 12 & 63) + B(k >> 6 & 63) + B(63 & k);
              switch (N) {
                case 1:
                  I = (I += B((w = y[y.length - 1]) >> 2)) + B(w << 4 & 63) + "==";
                  break;
                case 2:
                  I = (I = (I += B((w = (y[y.length - 2] << 8) + y[y.length - 1]) >> 10)) + B(w >> 4 & 63)) + B(w << 2 & 63) + "=";
              }
              return I;
            };
          })(i === void 0 ? this.base64js = {} : i);
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
      }, { buffer: 3, lYpoI2: 11 }], 3: [function(n, r, i) {
        (function(o, a, v, l, u, c, f, d, p) {
          var h = n("base64-js"), m = n("ieee754");
          function v(O, D, C) {
            if (!(this instanceof v)) return new v(O, D, C);
            var z, H, X, fe, ce = typeof O;
            if (D === "base64" && ce == "string") for (O = (fe = O).trim ? fe.trim() : fe.replace(/^\s+|\s+$/g, ""); O.length % 4 != 0; ) O += "=";
            if (ce == "number") z = re(O);
            else if (ce == "string") z = v.byteLength(O, D);
            else {
              if (ce != "object") throw new Error("First argument needs to be a number, array or string.");
              z = re(O.length);
            }
            if (v._useTypedArrays ? H = v._augment(new Uint8Array(z)) : ((H = this).length = z, H._isBuffer = !0), v._useTypedArrays && typeof O.byteLength == "number") H._set(O);
            else if (Z(fe = O) || v.isBuffer(fe) || fe && typeof fe == "object" && typeof fe.length == "number") for (X = 0; X < z; X++) v.isBuffer(O) ? H[X] = O.readUInt8(X) : H[X] = O[X];
            else if (ce == "string") H.write(O, 0, D);
            else if (ce == "number" && !v._useTypedArrays && !C) for (X = 0; X < z; X++) H[X] = 0;
            return H;
          }
          function g(O, D, C, z) {
            return v._charsWritten = K((function(H) {
              for (var X = [], fe = 0; fe < H.length; fe++) X.push(255 & H.charCodeAt(fe));
              return X;
            })(D), O, C, z);
          }
          function b(O, D, C, z) {
            return v._charsWritten = K((function(H) {
              for (var X, fe, ce = [], xe = 0; xe < H.length; xe++) fe = H.charCodeAt(xe), X = fe >> 8, fe = fe % 256, ce.push(fe), ce.push(X);
              return ce;
            })(D), O, C, z);
          }
          function E(O, D, C) {
            var z = "";
            C = Math.min(O.length, C);
            for (var H = D; H < C; H++) z += String.fromCharCode(O[H]);
            return z;
          }
          function x(O, D, C, X) {
            X || (V(typeof C == "boolean", "missing or invalid endian"), V(D != null, "missing offset"), V(D + 1 < O.length, "Trying to read beyond buffer length"));
            var H, X = O.length;
            if (!(X <= D)) return C ? (H = O[D], D + 1 < X && (H |= O[D + 1] << 8)) : (H = O[D] << 8, D + 1 < X && (H |= O[D + 1])), H;
          }
          function S(O, D, C, X) {
            X || (V(typeof C == "boolean", "missing or invalid endian"), V(D != null, "missing offset"), V(D + 3 < O.length, "Trying to read beyond buffer length"));
            var H, X = O.length;
            if (!(X <= D)) return C ? (D + 2 < X && (H = O[D + 2] << 16), D + 1 < X && (H |= O[D + 1] << 8), H |= O[D], D + 3 < X && (H += O[D + 3] << 24 >>> 0)) : (D + 1 < X && (H = O[D + 1] << 16), D + 2 < X && (H |= O[D + 2] << 8), D + 3 < X && (H |= O[D + 3]), H += O[D] << 24 >>> 0), H;
          }
          function $(O, D, C, z) {
            if (z || (V(typeof C == "boolean", "missing or invalid endian"), V(D != null, "missing offset"), V(D + 1 < O.length, "Trying to read beyond buffer length")), !(O.length <= D)) return z = x(O, D, C, !0), 32768 & z ? -1 * (65535 - z + 1) : z;
          }
          function P(O, D, C, z) {
            if (z || (V(typeof C == "boolean", "missing or invalid endian"), V(D != null, "missing offset"), V(D + 3 < O.length, "Trying to read beyond buffer length")), !(O.length <= D)) return z = S(O, D, C, !0), 2147483648 & z ? -1 * (4294967295 - z + 1) : z;
          }
          function y(O, D, C, z) {
            return z || (V(typeof C == "boolean", "missing or invalid endian"), V(D + 3 < O.length, "Trying to read beyond buffer length")), m.read(O, D, C, 23, 4);
          }
          function _(O, D, C, z) {
            return z || (V(typeof C == "boolean", "missing or invalid endian"), V(D + 7 < O.length, "Trying to read beyond buffer length")), m.read(O, D, C, 52, 8);
          }
          function w(O, D, C, z, H) {
            if (H || (V(D != null, "missing value"), V(typeof z == "boolean", "missing or invalid endian"), V(C != null, "missing offset"), V(C + 1 < O.length, "trying to write beyond buffer length"), se(D, 65535)), H = O.length, !(H <= C)) for (var X = 0, fe = Math.min(H - C, 2); X < fe; X++) O[C + X] = (D & 255 << 8 * (z ? X : 1 - X)) >>> 8 * (z ? X : 1 - X);
          }
          function A(O, D, C, z, H) {
            if (H || (V(D != null, "missing value"), V(typeof z == "boolean", "missing or invalid endian"), V(C != null, "missing offset"), V(C + 3 < O.length, "trying to write beyond buffer length"), se(D, 4294967295)), H = O.length, !(H <= C)) for (var X = 0, fe = Math.min(H - C, 4); X < fe; X++) O[C + X] = D >>> 8 * (z ? X : 3 - X) & 255;
          }
          function k(O, D, C, z, H) {
            H || (V(D != null, "missing value"), V(typeof z == "boolean", "missing or invalid endian"), V(C != null, "missing offset"), V(C + 1 < O.length, "Trying to write beyond buffer length"), de(D, 32767, -32768)), O.length <= C || w(O, 0 <= D ? D : 65535 + D + 1, C, z, H);
          }
          function N(O, D, C, z, H) {
            H || (V(D != null, "missing value"), V(typeof z == "boolean", "missing or invalid endian"), V(C != null, "missing offset"), V(C + 3 < O.length, "Trying to write beyond buffer length"), de(D, 2147483647, -2147483648)), O.length <= C || A(O, 0 <= D ? D : 4294967295 + D + 1, C, z, H);
          }
          function I(O, D, C, z, H) {
            H || (V(D != null, "missing value"), V(typeof z == "boolean", "missing or invalid endian"), V(C != null, "missing offset"), V(C + 3 < O.length, "Trying to write beyond buffer length"), ge(D, 34028234663852886e22, -34028234663852886e22)), O.length <= C || m.write(O, D, C, z, 23, 4);
          }
          function B(O, D, C, z, H) {
            H || (V(D != null, "missing value"), V(typeof z == "boolean", "missing or invalid endian"), V(C != null, "missing offset"), V(C + 7 < O.length, "Trying to write beyond buffer length"), ge(D, 17976931348623157e292, -17976931348623157e292)), O.length <= C || m.write(O, D, C, z, 52, 8);
          }
          i.Buffer = v, i.SlowBuffer = v, i.INSPECT_MAX_BYTES = 50, v.poolSize = 8192, v._useTypedArrays = (function() {
            try {
              var O = new ArrayBuffer(0), D = new Uint8Array(O);
              return D.foo = function() {
                return 42;
              }, D.foo() === 42 && typeof D.subarray == "function";
            } catch {
              return !1;
            }
          })(), v.isEncoding = function(O) {
            switch (String(O).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "raw":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, v.isBuffer = function(O) {
            return !(O == null || !O._isBuffer);
          }, v.byteLength = function(O, D) {
            var C;
            switch (O += "", D || "utf8") {
              case "hex":
                C = O.length / 2;
                break;
              case "utf8":
              case "utf-8":
                C = F(O).length;
                break;
              case "ascii":
              case "binary":
              case "raw":
                C = O.length;
                break;
              case "base64":
                C = M(O).length;
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                C = 2 * O.length;
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return C;
          }, v.concat = function(O, D) {
            if (V(Z(O), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), O.length === 0) return new v(0);
            if (O.length === 1) return O[0];
            if (typeof D != "number") for (H = D = 0; H < O.length; H++) D += O[H].length;
            for (var C = new v(D), z = 0, H = 0; H < O.length; H++) {
              var X = O[H];
              X.copy(C, z), z += X.length;
            }
            return C;
          }, v.prototype.write = function(O, D, C, z) {
            isFinite(D) ? isFinite(C) || (z = C, C = void 0) : (xe = z, z = D, D = C, C = xe), D = Number(D) || 0;
            var H, X, fe, ce, xe = this.length - D;
            switch ((!C || xe < (C = Number(C))) && (C = xe), z = String(z || "utf8").toLowerCase()) {
              case "hex":
                H = (function(ne, we, ke, pe) {
                  ke = Number(ke) || 0;
                  var j = ne.length - ke;
                  (!pe || j < (pe = Number(pe))) && (pe = j), V((j = we.length) % 2 == 0, "Invalid hex string"), j / 2 < pe && (pe = j / 2);
                  for (var U = 0; U < pe; U++) {
                    var Y = parseInt(we.substr(2 * U, 2), 16);
                    V(!isNaN(Y), "Invalid hex string"), ne[ke + U] = Y;
                  }
                  return v._charsWritten = 2 * U, U;
                })(this, O, D, C);
                break;
              case "utf8":
              case "utf-8":
                X = this, fe = D, ce = C, H = v._charsWritten = K(F(O), X, fe, ce);
                break;
              case "ascii":
              case "binary":
                H = g(this, O, D, C);
                break;
              case "base64":
                X = this, fe = D, ce = C, H = v._charsWritten = K(M(O), X, fe, ce);
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                H = b(this, O, D, C);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return H;
          }, v.prototype.toString = function(O, D, C) {
            var z, H, X, fe, ce = this;
            if (O = String(O || "utf8").toLowerCase(), D = Number(D) || 0, (C = C !== void 0 ? Number(C) : ce.length) === D) return "";
            switch (O) {
              case "hex":
                z = (function(xe, ne, we) {
                  var ke = xe.length;
                  (!ne || ne < 0) && (ne = 0), (!we || we < 0 || ke < we) && (we = ke);
                  for (var pe = "", j = ne; j < we; j++) pe += T(xe[j]);
                  return pe;
                })(ce, D, C);
                break;
              case "utf8":
              case "utf-8":
                z = (function(xe, ne, we) {
                  var ke = "", pe = "";
                  we = Math.min(xe.length, we);
                  for (var j = ne; j < we; j++) xe[j] <= 127 ? (ke += te(pe) + String.fromCharCode(xe[j]), pe = "") : pe += "%" + xe[j].toString(16);
                  return ke + te(pe);
                })(ce, D, C);
                break;
              case "ascii":
              case "binary":
                z = E(ce, D, C);
                break;
              case "base64":
                H = ce, fe = C, z = (X = D) === 0 && fe === H.length ? h.fromByteArray(H) : h.fromByteArray(H.slice(X, fe));
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                z = (function(xe, ne, we) {
                  for (var ke = xe.slice(ne, we), pe = "", j = 0; j < ke.length; j += 2) pe += String.fromCharCode(ke[j] + 256 * ke[j + 1]);
                  return pe;
                })(ce, D, C);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return z;
          }, v.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          }, v.prototype.copy = function(O, D, C, z) {
            if (D = D || 0, (z = z || z === 0 ? z : this.length) !== (C = C || 0) && O.length !== 0 && this.length !== 0) {
              V(C <= z, "sourceEnd < sourceStart"), V(0 <= D && D < O.length, "targetStart out of bounds"), V(0 <= C && C < this.length, "sourceStart out of bounds"), V(0 <= z && z <= this.length, "sourceEnd out of bounds"), z > this.length && (z = this.length);
              var H = (z = O.length - D < z - C ? O.length - D + C : z) - C;
              if (H < 100 || !v._useTypedArrays) for (var X = 0; X < H; X++) O[X + D] = this[X + C];
              else O._set(this.subarray(C, C + H), D);
            }
          }, v.prototype.slice = function(O, D) {
            var C = this.length;
            if (O = ee(O, C, 0), D = ee(D, C, C), v._useTypedArrays) return v._augment(this.subarray(O, D));
            for (var z = D - O, H = new v(z, void 0, !0), X = 0; X < z; X++) H[X] = this[X + O];
            return H;
          }, v.prototype.get = function(O) {
            return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(O);
          }, v.prototype.set = function(O, D) {
            return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(O, D);
          }, v.prototype.readUInt8 = function(O, D) {
            if (D || (V(O != null, "missing offset"), V(O < this.length, "Trying to read beyond buffer length")), !(O >= this.length)) return this[O];
          }, v.prototype.readUInt16LE = function(O, D) {
            return x(this, O, !0, D);
          }, v.prototype.readUInt16BE = function(O, D) {
            return x(this, O, !1, D);
          }, v.prototype.readUInt32LE = function(O, D) {
            return S(this, O, !0, D);
          }, v.prototype.readUInt32BE = function(O, D) {
            return S(this, O, !1, D);
          }, v.prototype.readInt8 = function(O, D) {
            if (D || (V(O != null, "missing offset"), V(O < this.length, "Trying to read beyond buffer length")), !(O >= this.length)) return 128 & this[O] ? -1 * (255 - this[O] + 1) : this[O];
          }, v.prototype.readInt16LE = function(O, D) {
            return $(this, O, !0, D);
          }, v.prototype.readInt16BE = function(O, D) {
            return $(this, O, !1, D);
          }, v.prototype.readInt32LE = function(O, D) {
            return P(this, O, !0, D);
          }, v.prototype.readInt32BE = function(O, D) {
            return P(this, O, !1, D);
          }, v.prototype.readFloatLE = function(O, D) {
            return y(this, O, !0, D);
          }, v.prototype.readFloatBE = function(O, D) {
            return y(this, O, !1, D);
          }, v.prototype.readDoubleLE = function(O, D) {
            return _(this, O, !0, D);
          }, v.prototype.readDoubleBE = function(O, D) {
            return _(this, O, !1, D);
          }, v.prototype.writeUInt8 = function(O, D, C) {
            C || (V(O != null, "missing value"), V(D != null, "missing offset"), V(D < this.length, "trying to write beyond buffer length"), se(O, 255)), D >= this.length || (this[D] = O);
          }, v.prototype.writeUInt16LE = function(O, D, C) {
            w(this, O, D, !0, C);
          }, v.prototype.writeUInt16BE = function(O, D, C) {
            w(this, O, D, !1, C);
          }, v.prototype.writeUInt32LE = function(O, D, C) {
            A(this, O, D, !0, C);
          }, v.prototype.writeUInt32BE = function(O, D, C) {
            A(this, O, D, !1, C);
          }, v.prototype.writeInt8 = function(O, D, C) {
            C || (V(O != null, "missing value"), V(D != null, "missing offset"), V(D < this.length, "Trying to write beyond buffer length"), de(O, 127, -128)), D >= this.length || (0 <= O ? this.writeUInt8(O, D, C) : this.writeUInt8(255 + O + 1, D, C));
          }, v.prototype.writeInt16LE = function(O, D, C) {
            k(this, O, D, !0, C);
          }, v.prototype.writeInt16BE = function(O, D, C) {
            k(this, O, D, !1, C);
          }, v.prototype.writeInt32LE = function(O, D, C) {
            N(this, O, D, !0, C);
          }, v.prototype.writeInt32BE = function(O, D, C) {
            N(this, O, D, !1, C);
          }, v.prototype.writeFloatLE = function(O, D, C) {
            I(this, O, D, !0, C);
          }, v.prototype.writeFloatBE = function(O, D, C) {
            I(this, O, D, !1, C);
          }, v.prototype.writeDoubleLE = function(O, D, C) {
            B(this, O, D, !0, C);
          }, v.prototype.writeDoubleBE = function(O, D, C) {
            B(this, O, D, !1, C);
          }, v.prototype.fill = function(O, D, C) {
            if (D = D || 0, C = C || this.length, V(typeof (O = typeof (O = O || 0) == "string" ? O.charCodeAt(0) : O) == "number" && !isNaN(O), "value is not a number"), V(D <= C, "end < start"), C !== D && this.length !== 0) {
              V(0 <= D && D < this.length, "start out of bounds"), V(0 <= C && C <= this.length, "end out of bounds");
              for (var z = D; z < C; z++) this[z] = O;
            }
          }, v.prototype.inspect = function() {
            for (var O = [], D = this.length, C = 0; C < D; C++) if (O[C] = T(this[C]), C === i.INSPECT_MAX_BYTES) {
              O[C + 1] = "...";
              break;
            }
            return "<Buffer " + O.join(" ") + ">";
          }, v.prototype.toArrayBuffer = function() {
            if (typeof Uint8Array > "u") throw new Error("Buffer.toArrayBuffer not supported in this browser");
            if (v._useTypedArrays) return new v(this).buffer;
            for (var O = new Uint8Array(this.length), D = 0, C = O.length; D < C; D += 1) O[D] = this[D];
            return O.buffer;
          };
          var q = v.prototype;
          function ee(O, D, C) {
            return typeof O != "number" ? C : D <= (O = ~~O) ? D : 0 <= O || 0 <= (O += D) ? O : 0;
          }
          function re(O) {
            return (O = ~~Math.ceil(+O)) < 0 ? 0 : O;
          }
          function Z(O) {
            return (Array.isArray || function(D) {
              return Object.prototype.toString.call(D) === "[object Array]";
            })(O);
          }
          function T(O) {
            return O < 16 ? "0" + O.toString(16) : O.toString(16);
          }
          function F(O) {
            for (var D = [], C = 0; C < O.length; C++) {
              var z = O.charCodeAt(C);
              if (z <= 127) D.push(O.charCodeAt(C));
              else for (var H = C, X = (55296 <= z && z <= 57343 && C++, encodeURIComponent(O.slice(H, C + 1)).substr(1).split("%")), fe = 0; fe < X.length; fe++) D.push(parseInt(X[fe], 16));
            }
            return D;
          }
          function M(O) {
            return h.toByteArray(O);
          }
          function K(O, D, C, z) {
            for (var H = 0; H < z && !(H + C >= D.length || H >= O.length); H++) D[H + C] = O[H];
            return H;
          }
          function te(O) {
            try {
              return decodeURIComponent(O);
            } catch {
              return "�";
            }
          }
          function se(O, D) {
            V(typeof O == "number", "cannot write a non-number as a number"), V(0 <= O, "specified a negative value for writing an unsigned value"), V(O <= D, "value is larger than maximum value for type"), V(Math.floor(O) === O, "value has a fractional component");
          }
          function de(O, D, C) {
            V(typeof O == "number", "cannot write a non-number as a number"), V(O <= D, "value larger than maximum allowed value"), V(C <= O, "value smaller than minimum allowed value"), V(Math.floor(O) === O, "value has a fractional component");
          }
          function ge(O, D, C) {
            V(typeof O == "number", "cannot write a non-number as a number"), V(O <= D, "value larger than maximum allowed value"), V(C <= O, "value smaller than minimum allowed value");
          }
          function V(O, D) {
            if (!O) throw new Error(D || "Failed assertion");
          }
          v._augment = function(O) {
            return O._isBuffer = !0, O._get = O.get, O._set = O.set, O.get = q.get, O.set = q.set, O.write = q.write, O.toString = q.toString, O.toLocaleString = q.toString, O.toJSON = q.toJSON, O.copy = q.copy, O.slice = q.slice, O.readUInt8 = q.readUInt8, O.readUInt16LE = q.readUInt16LE, O.readUInt16BE = q.readUInt16BE, O.readUInt32LE = q.readUInt32LE, O.readUInt32BE = q.readUInt32BE, O.readInt8 = q.readInt8, O.readInt16LE = q.readInt16LE, O.readInt16BE = q.readInt16BE, O.readInt32LE = q.readInt32LE, O.readInt32BE = q.readInt32BE, O.readFloatLE = q.readFloatLE, O.readFloatBE = q.readFloatBE, O.readDoubleLE = q.readDoubleLE, O.readDoubleBE = q.readDoubleBE, O.writeUInt8 = q.writeUInt8, O.writeUInt16LE = q.writeUInt16LE, O.writeUInt16BE = q.writeUInt16BE, O.writeUInt32LE = q.writeUInt32LE, O.writeUInt32BE = q.writeUInt32BE, O.writeInt8 = q.writeInt8, O.writeInt16LE = q.writeInt16LE, O.writeInt16BE = q.writeInt16BE, O.writeInt32LE = q.writeInt32LE, O.writeInt32BE = q.writeInt32BE, O.writeFloatLE = q.writeFloatLE, O.writeFloatBE = q.writeFloatBE, O.writeDoubleLE = q.writeDoubleLE, O.writeDoubleBE = q.writeDoubleBE, O.fill = q.fill, O.inspect = q.inspect, O.toArrayBuffer = q.toArrayBuffer, O;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
      }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(n, r, i) {
        (function(o, a, h, l, u, c, f, d, p) {
          var h = n("buffer").Buffer, m = 4, v = new h(m);
          v.fill(0), r.exports = { hash: function(g, b, E, x) {
            for (var S = b((function(w, A) {
              w.length % m != 0 && (k = w.length + (m - w.length % m), w = h.concat([w, v], k));
              for (var k, N = [], I = A ? w.readInt32BE : w.readInt32LE, B = 0; B < w.length; B += m) N.push(I.call(w, B));
              return N;
            })(g = h.isBuffer(g) ? g : new h(g), x), 8 * g.length), b = x, $ = new h(E), P = b ? $.writeInt32BE : $.writeInt32LE, y = 0; y < S.length; y++) P.call($, S[y], 4 * y, !0);
            return $;
          } };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 5: [function(n, r, i) {
        (function(o, a, h, l, u, c, f, d, p) {
          var h = n("buffer").Buffer, m = n("./sha"), v = n("./sha256"), g = n("./rng"), b = { sha1: m, sha256: v, md5: n("./md5") }, E = 64, x = new h(E);
          function S(w, A) {
            var k = b[w = w || "sha1"], N = [];
            return k || $("algorithm:", w, "is not yet supported"), { update: function(I) {
              return h.isBuffer(I) || (I = new h(I)), N.push(I), I.length, this;
            }, digest: function(I) {
              var B = h.concat(N), B = A ? (function(q, ee, re) {
                h.isBuffer(ee) || (ee = new h(ee)), h.isBuffer(re) || (re = new h(re)), ee.length > E ? ee = q(ee) : ee.length < E && (ee = h.concat([ee, x], E));
                for (var Z = new h(E), T = new h(E), F = 0; F < E; F++) Z[F] = 54 ^ ee[F], T[F] = 92 ^ ee[F];
                return re = q(h.concat([Z, re])), q(h.concat([T, re]));
              })(k, A, B) : k(B);
              return N = null, I ? B.toString(I) : B;
            } };
          }
          function $() {
            var w = [].slice.call(arguments).join(" ");
            throw new Error([w, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
          }
          x.fill(0), i.createHash = function(w) {
            return S(w);
          }, i.createHmac = S, i.randomBytes = function(w, A) {
            if (!A || !A.call) return new h(g(w));
            try {
              A.call(this, void 0, new h(g(w)));
            } catch (k) {
              A(k);
            }
          };
          var P, y = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], _ = function(w) {
            i[w] = function() {
              $("sorry,", w, "is not implemented yet");
            };
          };
          for (P in y) _(y[P]);
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("./helpers");
          function m($, P) {
            $[P >> 5] |= 128 << P % 32, $[14 + (P + 64 >>> 9 << 4)] = P;
            for (var y = 1732584193, _ = -271733879, w = -1732584194, A = 271733878, k = 0; k < $.length; k += 16) {
              var N = y, I = _, B = w, q = A, y = g(y, _, w, A, $[k + 0], 7, -680876936), A = g(A, y, _, w, $[k + 1], 12, -389564586), w = g(w, A, y, _, $[k + 2], 17, 606105819), _ = g(_, w, A, y, $[k + 3], 22, -1044525330);
              y = g(y, _, w, A, $[k + 4], 7, -176418897), A = g(A, y, _, w, $[k + 5], 12, 1200080426), w = g(w, A, y, _, $[k + 6], 17, -1473231341), _ = g(_, w, A, y, $[k + 7], 22, -45705983), y = g(y, _, w, A, $[k + 8], 7, 1770035416), A = g(A, y, _, w, $[k + 9], 12, -1958414417), w = g(w, A, y, _, $[k + 10], 17, -42063), _ = g(_, w, A, y, $[k + 11], 22, -1990404162), y = g(y, _, w, A, $[k + 12], 7, 1804603682), A = g(A, y, _, w, $[k + 13], 12, -40341101), w = g(w, A, y, _, $[k + 14], 17, -1502002290), y = b(y, _ = g(_, w, A, y, $[k + 15], 22, 1236535329), w, A, $[k + 1], 5, -165796510), A = b(A, y, _, w, $[k + 6], 9, -1069501632), w = b(w, A, y, _, $[k + 11], 14, 643717713), _ = b(_, w, A, y, $[k + 0], 20, -373897302), y = b(y, _, w, A, $[k + 5], 5, -701558691), A = b(A, y, _, w, $[k + 10], 9, 38016083), w = b(w, A, y, _, $[k + 15], 14, -660478335), _ = b(_, w, A, y, $[k + 4], 20, -405537848), y = b(y, _, w, A, $[k + 9], 5, 568446438), A = b(A, y, _, w, $[k + 14], 9, -1019803690), w = b(w, A, y, _, $[k + 3], 14, -187363961), _ = b(_, w, A, y, $[k + 8], 20, 1163531501), y = b(y, _, w, A, $[k + 13], 5, -1444681467), A = b(A, y, _, w, $[k + 2], 9, -51403784), w = b(w, A, y, _, $[k + 7], 14, 1735328473), y = E(y, _ = b(_, w, A, y, $[k + 12], 20, -1926607734), w, A, $[k + 5], 4, -378558), A = E(A, y, _, w, $[k + 8], 11, -2022574463), w = E(w, A, y, _, $[k + 11], 16, 1839030562), _ = E(_, w, A, y, $[k + 14], 23, -35309556), y = E(y, _, w, A, $[k + 1], 4, -1530992060), A = E(A, y, _, w, $[k + 4], 11, 1272893353), w = E(w, A, y, _, $[k + 7], 16, -155497632), _ = E(_, w, A, y, $[k + 10], 23, -1094730640), y = E(y, _, w, A, $[k + 13], 4, 681279174), A = E(A, y, _, w, $[k + 0], 11, -358537222), w = E(w, A, y, _, $[k + 3], 16, -722521979), _ = E(_, w, A, y, $[k + 6], 23, 76029189), y = E(y, _, w, A, $[k + 9], 4, -640364487), A = E(A, y, _, w, $[k + 12], 11, -421815835), w = E(w, A, y, _, $[k + 15], 16, 530742520), y = x(y, _ = E(_, w, A, y, $[k + 2], 23, -995338651), w, A, $[k + 0], 6, -198630844), A = x(A, y, _, w, $[k + 7], 10, 1126891415), w = x(w, A, y, _, $[k + 14], 15, -1416354905), _ = x(_, w, A, y, $[k + 5], 21, -57434055), y = x(y, _, w, A, $[k + 12], 6, 1700485571), A = x(A, y, _, w, $[k + 3], 10, -1894986606), w = x(w, A, y, _, $[k + 10], 15, -1051523), _ = x(_, w, A, y, $[k + 1], 21, -2054922799), y = x(y, _, w, A, $[k + 8], 6, 1873313359), A = x(A, y, _, w, $[k + 15], 10, -30611744), w = x(w, A, y, _, $[k + 6], 15, -1560198380), _ = x(_, w, A, y, $[k + 13], 21, 1309151649), y = x(y, _, w, A, $[k + 4], 6, -145523070), A = x(A, y, _, w, $[k + 11], 10, -1120210379), w = x(w, A, y, _, $[k + 2], 15, 718787259), _ = x(_, w, A, y, $[k + 9], 21, -343485551), y = S(y, N), _ = S(_, I), w = S(w, B), A = S(A, q);
            }
            return Array(y, _, w, A);
          }
          function v($, P, y, _, w, A) {
            return S((P = S(S(P, $), S(_, A))) << w | P >>> 32 - w, y);
          }
          function g($, P, y, _, w, A, k) {
            return v(P & y | ~P & _, $, P, w, A, k);
          }
          function b($, P, y, _, w, A, k) {
            return v(P & _ | y & ~_, $, P, w, A, k);
          }
          function E($, P, y, _, w, A, k) {
            return v(P ^ y ^ _, $, P, w, A, k);
          }
          function x($, P, y, _, w, A, k) {
            return v(y ^ (P | ~_), $, P, w, A, k);
          }
          function S($, P) {
            var y = (65535 & $) + (65535 & P);
            return ($ >> 16) + (P >> 16) + (y >> 16) << 16 | 65535 & y;
          }
          r.exports = function($) {
            return h.hash($, m, 16);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          r.exports = function(h) {
            for (var m, v = new Array(h), g = 0; g < h; g++) (3 & g) == 0 && (m = 4294967296 * Math.random()), v[g] = m >>> ((3 & g) << 3) & 255;
            return v;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 8: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("./helpers");
          function m(b, E) {
            b[E >> 5] |= 128 << 24 - E % 32, b[15 + (E + 64 >> 9 << 4)] = E;
            for (var x, S, $, P = Array(80), y = 1732584193, _ = -271733879, w = -1732584194, A = 271733878, k = -1009589776, N = 0; N < b.length; N += 16) {
              for (var I = y, B = _, q = w, ee = A, re = k, Z = 0; Z < 80; Z++) {
                P[Z] = Z < 16 ? b[N + Z] : g(P[Z - 3] ^ P[Z - 8] ^ P[Z - 14] ^ P[Z - 16], 1);
                var T = v(v(g(y, 5), (T = _, S = w, $ = A, (x = Z) < 20 ? T & S | ~T & $ : !(x < 40) && x < 60 ? T & S | T & $ | S & $ : T ^ S ^ $)), v(v(k, P[Z]), (x = Z) < 20 ? 1518500249 : x < 40 ? 1859775393 : x < 60 ? -1894007588 : -899497514)), k = A, A = w, w = g(_, 30), _ = y, y = T;
              }
              y = v(y, I), _ = v(_, B), w = v(w, q), A = v(A, ee), k = v(k, re);
            }
            return Array(y, _, w, A, k);
          }
          function v(b, E) {
            var x = (65535 & b) + (65535 & E);
            return (b >> 16) + (E >> 16) + (x >> 16) << 16 | 65535 & x;
          }
          function g(b, E) {
            return b << E | b >>> 32 - E;
          }
          r.exports = function(b) {
            return h.hash(b, m, 20, !0);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          function h(E, x) {
            var S = (65535 & E) + (65535 & x);
            return (E >> 16) + (x >> 16) + (S >> 16) << 16 | 65535 & S;
          }
          function m(E, x) {
            var S, $ = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), P = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), y = new Array(64);
            E[x >> 5] |= 128 << 24 - x % 32, E[15 + (x + 64 >> 9 << 4)] = x;
            for (var _, w, A = 0; A < E.length; A += 16) {
              for (var k = P[0], N = P[1], I = P[2], B = P[3], q = P[4], ee = P[5], re = P[6], Z = P[7], T = 0; T < 64; T++) y[T] = T < 16 ? E[T + A] : h(h(h((w = y[T - 2], g(w, 17) ^ g(w, 19) ^ b(w, 10)), y[T - 7]), (w = y[T - 15], g(w, 7) ^ g(w, 18) ^ b(w, 3))), y[T - 16]), S = h(h(h(h(Z, g(w = q, 6) ^ g(w, 11) ^ g(w, 25)), q & ee ^ ~q & re), $[T]), y[T]), _ = h(g(_ = k, 2) ^ g(_, 13) ^ g(_, 22), k & N ^ k & I ^ N & I), Z = re, re = ee, ee = q, q = h(B, S), B = I, I = N, N = k, k = h(S, _);
              P[0] = h(k, P[0]), P[1] = h(N, P[1]), P[2] = h(I, P[2]), P[3] = h(B, P[3]), P[4] = h(q, P[4]), P[5] = h(ee, P[5]), P[6] = h(re, P[6]), P[7] = h(Z, P[7]);
            }
            return P;
          }
          var v = n("./helpers"), g = function(E, x) {
            return E >>> x | E << 32 - x;
          }, b = function(E, x) {
            return E >>> x;
          };
          r.exports = function(E) {
            return v.hash(E, m, 32, !0);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          i.read = function(h, m, v, g, A) {
            var E, x, S = 8 * A - g - 1, $ = (1 << S) - 1, P = $ >> 1, y = -7, _ = v ? A - 1 : 0, w = v ? -1 : 1, A = h[m + _];
            for (_ += w, E = A & (1 << -y) - 1, A >>= -y, y += S; 0 < y; E = 256 * E + h[m + _], _ += w, y -= 8) ;
            for (x = E & (1 << -y) - 1, E >>= -y, y += g; 0 < y; x = 256 * x + h[m + _], _ += w, y -= 8) ;
            if (E === 0) E = 1 - P;
            else {
              if (E === $) return x ? NaN : 1 / 0 * (A ? -1 : 1);
              x += Math.pow(2, g), E -= P;
            }
            return (A ? -1 : 1) * x * Math.pow(2, E - g);
          }, i.write = function(h, m, v, g, b, k) {
            var x, S, $ = 8 * k - b - 1, P = (1 << $) - 1, y = P >> 1, _ = b === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, w = g ? 0 : k - 1, A = g ? 1 : -1, k = m < 0 || m === 0 && 1 / m < 0 ? 1 : 0;
            for (m = Math.abs(m), isNaN(m) || m === 1 / 0 ? (S = isNaN(m) ? 1 : 0, x = P) : (x = Math.floor(Math.log(m) / Math.LN2), m * (g = Math.pow(2, -x)) < 1 && (x--, g *= 2), 2 <= (m += 1 <= x + y ? _ / g : _ * Math.pow(2, 1 - y)) * g && (x++, g /= 2), P <= x + y ? (S = 0, x = P) : 1 <= x + y ? (S = (m * g - 1) * Math.pow(2, b), x += y) : (S = m * Math.pow(2, y - 1) * Math.pow(2, b), x = 0)); 8 <= b; h[v + w] = 255 & S, w += A, S /= 256, b -= 8) ;
            for (x = x << b | S, $ += b; 0 < $; h[v + w] = 255 & x, w += A, x /= 256, $ -= 8) ;
            h[v + w - A] |= 128 * k;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
      }, { buffer: 3, lYpoI2: 11 }], 11: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h, m, v;
          function g() {
          }
          (o = r.exports = {}).nextTick = (m = typeof window < "u" && window.setImmediate, v = typeof window < "u" && window.postMessage && window.addEventListener, m ? function(b) {
            return window.setImmediate(b);
          } : v ? (h = [], window.addEventListener("message", function(b) {
            var E = b.source;
            E !== window && E !== null || b.data !== "process-tick" || (b.stopPropagation(), 0 < h.length && h.shift()());
          }, !0), function(b) {
            h.push(b), window.postMessage("process-tick", "*");
          }) : function(b) {
            setTimeout(b, 0);
          }), o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.on = g, o.addListener = g, o.once = g, o.off = g, o.removeListener = g, o.removeAllListeners = g, o.emit = g, o.binding = function(b) {
            throw new Error("process.binding is not supported");
          }, o.cwd = function() {
            return "/";
          }, o.chdir = function(b) {
            throw new Error("process.chdir is not supported");
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
      }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
    });
  })(Gm)), Gm.exports;
}
var lue = sue();
const ea = /* @__PURE__ */ Yd(lue), uue = ({
  children: e,
  showMenu: t
}) => /* @__PURE__ */ R.jsx(
  "div",
  {
    className: `absolute left-0 right-0 z-50 overflow-scroll rounded max-h-40 ${t ? "block" : "hidden"}`,
    children: e
  }
);
function rce({
  options: e,
  onSelect: t,
  displayKey: n
}) {
  const [r, i] = je(!1), o = ve(null), a = () => i(!0), [s, l] = je(""), u = Ee(() => {
    if (!s) return e;
    const c = new RegExp(s, "i");
    return e.filter((f) => n ? f[n].match(c) : f.match(c));
  }, [s, e]);
  return KJ(o, () => i(!1)), RC(
    {
      Escape: () => i(!1)
    },
    [i]
  ), /* @__PURE__ */ R.jsxs("div", { className: "relative", onFocus: a, children: [
    /* @__PURE__ */ R.jsx(
      md,
      {
        autoComplete: "off",
        ref: o,
        type: "text",
        onChange: (c) => l(c.target.value),
        value: s
      }
    ),
    /* @__PURE__ */ R.jsx(uue, { showMenu: r, children: /* @__PURE__ */ R.jsxs(
      Nn.ul,
      {
        className: "flex flex-col w-full h-full p-2 rounded shadow-lg bg-neutral-200",
        layout: !0,
        children: [
          u.length > 0 && u.map((c) => /* @__PURE__ */ R.jsx("li", { className: "hover:text-blue-500", children: /* @__PURE__ */ R.jsx(
            "button",
            {
              onClick: () => {
                t(c), l(
                  n ? c[n] : c
                );
              },
              children: n ? c[n] : c
            }
          ) }, ea(c))),
          r && u.length === 0 && /* @__PURE__ */ R.jsx("p", { className: "italic", children: "No Results" })
        ]
      }
    ) })
  ] });
}
function ice({
  row: e,
  data: t,
  extras: n = [],
  hide: r,
  transform: i,
  editable: o = !1,
  onEdit: a,
  defaultSortKey: s,
  className: l = "",
  render: u,
  renderHeading: c,
  cell: f
}) {
  const [d, p] = je(s ?? ""), [h, m] = je(
    "desc"
    /* Descending */
  ), [v, g] = je({
    key: "",
    newValue: "",
    value: "",
    hashedRow: ""
  }), b = Ee(() => [...t], [t]), E = ve(null), x = Ee(() => d ? b.sort((A, k) => {
    const N = A[d] ?? "", I = k[d] ?? "";
    return N < I ? h === "asc" ? -1 : 1 : N > I ? h === "asc" ? 1 : -1 : 0;
  }) : b, [d, b, h]), S = Ee(() => b.length === 0 ? [] : Object.getOwnPropertyNames(b[0]).reduce((k, N) => {
    if (r?.[N])
      return k;
    if (i && i[N]) {
      const I = i[N](N);
      return [
        ...k,
        {
          key: N,
          transformed: I
        }
      ];
    } else
      return console.log(
        `No transform for column ${N}, using key as transformed value`
      ), [...k, { key: N, transformed: N }];
  }, []), [b]), $ = Ne(
    (A, k) => u?.[A] ? u[A](k) : A === v.key && ea(k) === v.hashedRow && o ? /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ R.jsx(
        "form",
        {
          className: "absolute left-0 right-0 top-0 bottom-0",
          onSubmit: (N) => {
            N.preventDefault(), a && a({
              column: v.key,
              newValue: v.newValue,
              oldValue: v.value,
              rowData: k
            }), g({
              key: "",
              value: "",
              newValue: "",
              hashedRow: ""
            }), E.current?.blur();
          },
          children: /* @__PURE__ */ R.jsx(
            "textarea",
            {
              className: "w-full h-full",
              onBlur: () => {
                a?.({
                  column: v.key,
                  newValue: v.newValue,
                  oldValue: v.value,
                  rowData: k
                }), g({
                  key: "",
                  value: "",
                  newValue: "",
                  hashedRow: ""
                });
              },
              ref: E,
              autoFocus: !0,
              value: v.newValue,
              onChange: (N) => g({
                key: A,
                value: k[A],
                newValue: N.target.value,
                hashedRow: ea(k)
              })
            },
            `${ea(k)}}-${A}-${k[A]}-input`
          )
        }
      ),
      /* @__PURE__ */ R.jsx("p", { className: "invisible", children: k[A] })
    ] }) : /* @__PURE__ */ R.jsx("div", { children: k[A] }),
    [v, u]
  ), P = e ?? ((A) => /* @__PURE__ */ R.jsx("tr", { ...A })), y = (A) => c ? /* @__PURE__ */ R.jsx(R.Fragment, { children: c(A.children) }) : /* @__PURE__ */ R.jsx("tr", { ...A });
  let _ = !0;
  cue(c) && (c ? _ = !0 : _ = !1);
  const w = f ?? "td";
  return /* @__PURE__ */ R.jsxs("table", { className: l, children: [
    _ && /* @__PURE__ */ R.jsx("thead", { children: /* @__PURE__ */ R.jsxs(y, { children: [
      S.map(
        ({ key: A, transformed: k }) => !r?.[A] && /* @__PURE__ */ R.jsx(
          "th",
          {
            onClick: () => {
              d == A ? m(
                () => h === "asc" ? "desc" : "asc"
                /* Ascending */
              ) : (p(A), m(
                "asc"
                /* Ascending */
              ));
            },
            children: /* @__PURE__ */ R.jsxs("div", { className: "flex justify-start items-center", children: [
              k,
              A === d && h === "asc" && /* @__PURE__ */ R.jsx(
                cr,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: B6
                }
              ),
              A === d && h === "desc" && /* @__PURE__ */ R.jsx(
                cr,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: P$
                }
              )
            ] })
          },
          A
        )
      ),
      (n || []).map(({ key: A }, k) => /* @__PURE__ */ R.jsx("th", { children: A }, `extras-${A}-${k}`))
    ] }) }),
    /* @__PURE__ */ R.jsx("tbody", { children: x.map(
      (A) => P(
        {
          key: ea(A),
          children: Object.entries(A).map(([k, N]) => r?.[k] ? null : !r?.[k] && /* @__PURE__ */ R.jsx(
            w,
            {
              title: N,
              onClick: () => {
                o && !u?.[k] && g({
                  key: k,
                  value: N,
                  newValue: N,
                  hashedRow: ea(A)
                });
              },
              children: $(k, A)
            },
            `${ea(A)}}-${k}-${N}`
          ))
        },
        A
      )
    ) })
  ] });
}
function cue(e) {
  return typeof e == "boolean";
}
const z3 = Le(
  {}
);
function fue(e) {
  return /* @__PURE__ */ R.jsx(z3.Provider, { value: e.value, children: e.children });
}
const E1 = () => Ce(z3);
function due({ items: e }) {
  const { activeTab: t, setActiveTab: n } = E1();
  return /* @__PURE__ */ R.jsx(
    "div",
    {
      className: "flex w-full bg-black overflow-x-scroll self-baseline tabs-list overflow-y-hidden",
      children: e.map((r) => /* @__PURE__ */ R.jsx(
        hue,
        {
          label: r.label,
          active: t === r.value,
          value: r.value,
          onClick: (i) => {
            n(i);
          }
        },
        `tab-${r.value}`
      ))
    }
  );
}
const pue = Mr(
  [
    "last:border-none",
    "border-r",
    "flex-shrink-0",
    "px-4",
    "pb-4",
    "hover:bg-gray-200",
    "whitespace-nowrap",
    "overflow-hidden",
    "text-ellipsis",
    "self-baseline"
  ],
  {
    variants: {
      active: {
        false: "bg-black text-white",
        true: "bg-white text-black"
      }
    }
  }
);
function hue(e) {
  return /* @__PURE__ */ R.jsx(
    "button",
    {
      onClick: () => e.onClick(e.value),
      className: pue({ active: e.active }),
      children: e.label
    }
  );
}
function mue({
  children: e,
  className: t,
  value: n
}) {
  const { activeTab: r, contentRef: i } = E1();
  return r !== n || !i ? null : ga(
    /* @__PURE__ */ R.jsx("div", { className: `flex flex-col flex-grow h-full w-full ${t || ""} overflow-hidden`, children: e }),
    i
  );
}
const vue = (({
  children: e,
  items: t,
  onChange: n,
  activeTab: r
}) => {
  const [i, o] = je(null);
  return /* @__PURE__ */ R.jsx(
    fue,
    {
      value: {
        activeTab: r,
        setActiveTab: (a) => {
          n?.(a);
        },
        contentRef: i
      },
      children: /* @__PURE__ */ R.jsxs("div", { className: "flex flex-col tabs h-full overflow-hidden", children: [
        /* @__PURE__ */ R.jsx(due, { items: t }),
        /* @__PURE__ */ R.jsx(
          "div",
          {
            className: "flex flex-col flex-grow-[2] h-full w-full overflow-hidden",
            ref: o,
            children: e
          }
        )
      ] })
    }
  );
});
vue.Tab = mue;
const gue = Mr([
  "rounded",
  "px-4",
  "py-2",
  "bg-neutral-50",
  "mr-1",
  "hover:bg-neutral-100",
  "hover:text-black",
  "text-neutral-800"
], {
  variants: {
    active: {
      true: ["bg-black", "hover:bg-black", "text-white"],
      false: []
    }
  }
}), oce = ({ value: e, children: t }) => {
  const { activeTab: n, setActiveTab: r } = E1();
  return /* @__PURE__ */ R.jsx(
    "button",
    {
      className: gue({ active: n === e }),
      onClick: () => r(e),
      children: t
    }
  );
}, ace = ({
  jobId: e,
  className: t = ""
}) => {
  const { data: n } = qle({ variables: { jobId: e } }), [r, i] = je([]);
  return De(() => {
    n?.taskQueueLogs && i((o) => [...o, n.taskQueueLogs]);
  }, [n]), /* @__PURE__ */ R.jsx(
    "div",
    {
      className: `${t} relative h-full p-4 overflow-y-scroll rounded bg-neutral-200 text-neutral-800`,
      children: r.map((o, a) => /* @__PURE__ */ R.jsx("pre", { children: o.message }, `task-queue-${e}-${o.timestamp}-${a}`))
    }
  );
}, L3 = Le({}), sce = () => Ce(L3), yue = (e = !1) => {
  const [t, n] = je(e);
  return De(() => {
    const r = localStorage.getItem("darkMode");
    try {
      const i = JSON.parse(r || "");
      n(i.darkMode);
    } catch {
      localStorage.setItem(
        "darkMode",
        JSON.stringify({ darkMode: e })
      );
    }
  }, [n]), De(() => {
    localStorage.setItem("darkMode", JSON.stringify({ darkMode: t }));
  }, [t]), {
    darkMode: !1,
    // disable dark mode for now
    setDarkMode: (r) => {
      localStorage.setItem("darkMode", JSON.stringify({ darkMode: !r })), n(r);
    }
  };
}, lce = ({ children: e }) => {
  const { darkMode: t, setDarkMode: n } = yue();
  return De(() => {
    const r = document.querySelector("body");
    r && r.classList.remove("dark");
  }, [t]), /* @__PURE__ */ R.jsx(L3.Provider, { value: { darkMode: t, setDarkMode: n }, children: /* @__PURE__ */ R.jsx("div", { className: "", children: e }) });
}, uce = ({
  order: e,
  children: t,
  className: n = ""
}) => {
  function r(i, o) {
    switch (i) {
      case 1:
        return /* @__PURE__ */ R.jsx("h1", { className: `${n} text-2xl text-brand-500`, children: o });
      case 2:
        return /* @__PURE__ */ R.jsx("h2", { className: `${n} text-xl text-brand-600`, children: o });
      case 3:
        return /* @__PURE__ */ R.jsx("h3", { className: `${n} text-brand-800`, children: o });
      case 4:
        return /* @__PURE__ */ R.jsx("h4", { children: o });
      case 5:
        return /* @__PURE__ */ R.jsx("h5", { children: o });
      default:
      case 6:
        return /* @__PURE__ */ R.jsx("h6", { children: o });
    }
  }
  return r(e, t);
};
function cce({ on: e, onChange: t, className: n = "" }) {
  return /* @__PURE__ */ R.jsx(
    Nn.button,
    {
      layout: !0,
      onClick: () => t(!e),
      className: `
                w-12 h-4 p-1 items-center ${n} flex rounded transition-colors 
                ${e ? "justify-end bg-black" : "justify-start bg-neutral-100"}
            `,
      children: /* @__PURE__ */ R.jsx(
        Nn.div,
        {
          layout: !0,
          className: `w-4 h-2 rounded-sm transition-colors ${e ? "bg-neutral-100" : "bg-neutral-800"}`
        }
      )
    }
  );
}
const fce = Jt(
  ({ className: e, ...t }, n) => /* @__PURE__ */ R.jsx("textarea", { ref: n, ...t, className: Wn(
    "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
    e
  ) })
);
export {
  uh as AppLayout,
  $y as Button,
  Xue as CircleSpinner,
  Aue as CopyButton,
  Iue as Delete,
  Mue as Divider,
  Rue as Drawer,
  Uv as DrawerButton,
  Nue as Dropdown,
  jue as DynamicFormInput,
  Fue as Ellipses,
  CV as Error,
  zue as ErrorBoundary,
  md as Field,
  cee as FileBrowser,
  Zue as FileInput,
  Due as FlexBox,
  Gue as FormikField,
  Yue as GridArea,
  Gle as ImagePreview,
  BJ as Input,
  C3 as Logo,
  G0 as Menu,
  fa as MenuItem,
  BC as MenuItemStyle,
  tee as MenuStyle,
  LX as Modal,
  Uue as ModalContainer,
  Jue as NotFound,
  Pue as Note,
  Wle as Page,
  j3 as PageHeader,
  Zle as PageHeaderTitle,
  ece as Preview,
  oue as Protected,
  Que as ReaderLayout,
  tce as RequireRoles,
  nce as S3DownloadLink,
  Wue as S3FileBrowser,
  Xle as SVGPreview,
  DV as Select,
  rce as SelectionSearch,
  Fd as Spacer,
  Yle as Spinner,
  oce as Tab,
  mue as TabContent,
  ice as Table,
  iue as TablePreview,
  vue as Tabs,
  due as TabsList,
  ace as TaskQueueLogs,
  fce as Textarea,
  L3 as ThemeContext,
  lce as ThemeProvider,
  uce as Title,
  cce as Toggle,
  ree as UploadToast,
  wle as _S3FileBrowser,
  Ple as fileListToArray,
  Hle as pageVariants,
  VX as useModalContext,
  I3 as useTailwindBreakpoint,
  sce as useTheme
};
//# sourceMappingURL=components.js.map
